
(function (global) {
  var babelHelpers = global.babelHelpers = {};

  babelHelpers.inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  babelHelpers.defaults = function (obj, defaults) {
    var keys = Object.getOwnPropertyNames(defaults);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var value = Object.getOwnPropertyDescriptor(defaults, key);

      if (value && value.configurable && obj[key] === undefined) {
        Object.defineProperty(obj, key, value);
      }
    }

    return obj;
  };

  babelHelpers.createClass = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();

  babelHelpers.createDecoratedClass = (function () {
    function defineProperties(target, descriptors, initializers) {
      for (var i = 0; i < descriptors.length; i++) {
        var descriptor = descriptors[i];
        var decorators = descriptor.decorators;
        var key = descriptor.key;
        delete descriptor.key;
        delete descriptor.decorators;
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor || descriptor.initializer) descriptor.writable = true;

        if (decorators) {
          for (var f = 0; f < decorators.length; f++) {
            var decorator = decorators[f];

            if (typeof decorator === "function") {
              descriptor = decorator(target, key, descriptor) || descriptor;
            } else {
              throw new TypeError("The decorator for method " + descriptor.key + " is of the invalid type " + typeof decorator);
            }
          }

          if (descriptor.initializer !== undefined) {
            initializers[key] = descriptor;
            continue;
          }
        }

        Object.defineProperty(target, key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers);
      if (staticProps) defineProperties(Constructor, staticProps, staticInitializers);
      return Constructor;
    };
  })();

  babelHelpers.createDecoratedObject = function (descriptors) {
    var target = {};

    for (var i = 0; i < descriptors.length; i++) {
      var descriptor = descriptors[i];
      var decorators = descriptor.decorators;
      var key = descriptor.key;
      delete descriptor.key;
      delete descriptor.decorators;
      descriptor.enumerable = true;
      descriptor.configurable = true;
      if ("value" in descriptor || descriptor.initializer) descriptor.writable = true;

      if (decorators) {
        for (var f = 0; f < decorators.length; f++) {
          var decorator = decorators[f];

          if (typeof decorator === "function") {
            descriptor = decorator(target, key, descriptor) || descriptor;
          } else {
            throw new TypeError("The decorator for method " + descriptor.key + " is of the invalid type " + typeof decorator);
          }
        }
      }

      if (descriptor.initializer) {
        descriptor.value = descriptor.initializer.call(target);
      }

      Object.defineProperty(target, key, descriptor);
    }

    return target;
  };

  babelHelpers.defineDecoratedPropertyDescriptor = function (target, key, descriptors) {
    var _descriptor = descriptors[key];
    if (!_descriptor) return;
    var descriptor = {};

    for (var _key in _descriptor) descriptor[_key] = _descriptor[_key];

    descriptor.value = descriptor.initializer ? descriptor.initializer.call(target) : undefined;
    Object.defineProperty(target, key, descriptor);
  };

  babelHelpers.taggedTemplateLiteral = function (strings, raw) {
    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  };

  babelHelpers.taggedTemplateLiteralLoose = function (strings, raw) {
    strings.raw = raw;
    return strings;
  };

  babelHelpers.toArray = function (arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
  };

  babelHelpers.toConsumableArray = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    } else {
      return Array.from(arr);
    }
  };

  babelHelpers.slicedToArray = (function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  })();

  babelHelpers.slicedToArrayLoose = function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      var _arr = [];

      for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
        _arr.push(_step.value);

        if (i && _arr.length === i) break;
      }

      return _arr;
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };

  babelHelpers.objectWithoutProperties = function (obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };

  babelHelpers.hasOwn = Object.prototype.hasOwnProperty;
  babelHelpers.slice = Array.prototype.slice;
  babelHelpers.bind = Function.prototype.bind;

  babelHelpers.defineProperty = function (obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };

  babelHelpers.asyncToGenerator = function (fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        var callNext = step.bind(null, "next");
        var callThrow = step.bind(null, "throw");

        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(callNext, callThrow);
          }
        }

        callNext();
      });
    };
  };

  babelHelpers.interopExportWildcard = function (obj, defaults) {
    var newObj = defaults({}, obj);
    delete newObj["default"];
    return newObj;
  };

  babelHelpers.interopRequireWildcard = function (obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  };

  babelHelpers.interopRequireDefault = function (obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  };

  babelHelpers._typeof = function (obj) {
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
  };

  babelHelpers._extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  babelHelpers.get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  babelHelpers.set = function set(object, property, value, receiver) {
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent !== null) {
        set(parent, property, value, receiver);
      }
    } else if ("value" in desc && desc.writable) {
      desc.value = value;
    } else {
      var setter = desc.set;

      if (setter !== undefined) {
        setter.call(receiver, value);
      }
    }

    return value;
  };

  babelHelpers.newArrowCheck = function (innerThis, boundThis) {
    if (innerThis !== boundThis) {
      throw new TypeError("Cannot instantiate an arrow function");
    }
  };

  babelHelpers.classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  babelHelpers.objectDestructuringEmpty = function (obj) {
    if (obj == null) throw new TypeError("Cannot destructure undefined");
  };

  babelHelpers.temporalUndefined = {};

  babelHelpers.temporalAssertDefined = function (val, name, undef) {
    if (val === undef) {
      throw new ReferenceError(name + " is not defined - temporal dead zone");
    }

    return true;
  };

  babelHelpers.selfGlobal = typeof global === "undefined" ? self : global;
  babelHelpers.typeofReactElement = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 60103;

  babelHelpers.defaultProps = function (defaultProps, props) {
    if (defaultProps) {
      for (var propName in defaultProps) {
        if (typeof props[propName] === "undefined") {
          props[propName] = defaultProps[propName];
        }
      }
    }

    return props;
  };

  babelHelpers._instanceof = function (left, right) {
    if (right != null && right[Symbol.hasInstance]) {
      return right[Symbol.hasInstance](left);
    } else {
      return left instanceof right;
    }
  };

  babelHelpers.interopRequire = function (obj) {
    return obj && obj.__esModule ? obj["default"] : obj;
  };
})(typeof global === "undefined" ? self : global);

define("external-helpers", function(){});

/*! jQuery v2.1.4 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l=a.document,m="2.1.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return n.each(this,a,b)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){return!n.isArray(a)&&a-parseFloat(a)+1>=0},isPlainObject:function(a){return"object"!==n.type(a)||a.nodeType||n.isWindow(a)?!1:a.constructor&&!j.call(a.constructor.prototype,"isPrototypeOf")?!1:!0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?h[i.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=l.createElement("script"),b.text=a,l.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=s(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:g.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=s(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(e=d.call(arguments,2),f=function(){return a.apply(b||this,e.concat(d.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:k}),n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){h["[object "+b+"]"]=b.toLowerCase()});function s(a){var b="length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N=M.replace("w","w#"),O="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+N+"))|)"+L+"*\\]",P=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+O+")*)|.*)\\)|)",Q=new RegExp(L+"+","g"),R=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),S=new RegExp("^"+L+"*,"+L+"*"),T=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),U=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),V=new RegExp(P),W=new RegExp("^"+N+"$"),X={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M.replace("w","w*")+")"),ATTR:new RegExp("^"+O),PSEUDO:new RegExp("^"+P),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\d$/i,$=/^[^{]+\{\s*\[native \w/,_=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,aa=/[+~]/,ba=/'|\\/g,ca=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),da=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ea=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(fa){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],k=b.nodeType,"string"!=typeof a||!a||1!==k&&9!==k&&11!==k)return d;if(!e&&p){if(11!==k&&(f=_.exec(a)))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return H.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName)return H.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=1!==k&&a,1===k&&"object"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute("id"))?s=r.replace(ba,"\\$&"):b.setAttribute("id",s),s="[id='"+s+"'] ",l=o.length;while(l--)o[l]=s+ra(o[l]);w=aa.test(a)&&pa(b.parentNode)||b,x=o.join(",")}if(x)try{return H.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute("id")}}}return i(a.replace(R,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=g.documentElement,e=g.defaultView,e&&e!==e.top&&(e.addEventListener?e.addEventListener("unload",ea,!1):e.attachEvent&&e.attachEvent("onunload",ea)),p=!f(g),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(g.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=$.test(g.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!g.getElementsByName||!g.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(g.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\f]' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){var b=g.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",P)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===g||a.ownerDocument===v&&t(v,a)?-1:b===g||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,h=[a],i=[b];if(!e||!f)return a===g?-1:b===g?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?la(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},g):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,"='$1']"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:X,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ca,da),a[3]=(a[3]||a[4]||a[5]||"").replace(ca,da),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ca,da).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(Q," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(R,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(ca,da),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return W.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(ca,da).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[0>c?c+b:c]}),even:oa(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R," ")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;e>d;d++)ga(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(R,"$1"),c,e>i&&xa(a.slice(i,e)),f>e&&xa(a=a.slice(e)),f>e&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q="0",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG("*",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=F.call(i));s=va(s)}H.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&ga.uniqueSort(i)}return k&&(w=v,j=t),r};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=ga.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ca,da),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ca,da),aa.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,aa.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=n.expr.match.needsContext,v=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,w=/^.[^:#\[\.,]*$/;function x(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(w.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return g.call(b,a)>=0!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(x(this,a||[],!1))},not:function(a){return this.pushStack(x(this,a||[],!0))},is:function(a){return!!x(this,"string"==typeof a&&u.test(a)?n(a):a||[],!1).length}});var y,z=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,A=n.fn.init=function(a,b){var c,d;if(!a)return this;if("string"==typeof a){if(c="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||y).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:l,!0)),v.test(c[1])&&n.isPlainObject(b))for(c in b)n.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}return d=l.getElementById(c[2]),d&&d.parentNode&&(this.length=1,this[0]=d),this.context=l,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?"undefined"!=typeof y.ready?y.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};A.prototype=n.fn,y=n(l);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};n.extend({dir:function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=u.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.unique(f):f)},index:function(a){return a?"string"==typeof a?g.call(n(a),this[0]):g.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.unique(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return n.dir(a,"parentNode")},parentsUntil:function(a,b,c){return n.dir(a,"parentNode",c)},next:function(a){return D(a,"nextSibling")},prev:function(a){return D(a,"previousSibling")},nextAll:function(a){return n.dir(a,"nextSibling")},prevAll:function(a){return n.dir(a,"previousSibling")},nextUntil:function(a,b,c){return n.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return n.dir(a,"previousSibling",c)},siblings:function(a){return n.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return n.sibling(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(C[a]||n.unique(e),B.test(a)&&e.reverse()),this.pushStack(e)}});var E=/\S+/g,F={};function G(a){var b=F[a]={};return n.each(a.match(E)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?F[a]||G(a):n.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(b=a.memory&&l,c=!0,g=e||0,e=0,f=h.length,d=!0;h&&f>g;g++)if(h[g].apply(l[0],l[1])===!1&&a.stopOnFalse){b=!1;break}d=!1,h&&(i?i.length&&j(i.shift()):b?h=[]:k.disable())},k={add:function(){if(h){var c=h.length;!function g(b){n.each(b,function(b,c){var d=n.type(c);"function"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&"string"!==d&&g(c)})}(arguments),d?f=h.length:b&&(e=c,j(b))}return this},remove:function(){return h&&n.each(arguments,function(a,b){var c;while((c=n.inArray(b,h,c))>-1)h.splice(c,1),d&&(f>=c&&f--,g>=c&&g--)}),this},has:function(a){return a?n.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],f=0,this},disable:function(){return h=i=b=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,b||k.disable(),this},locked:function(){return!i},fireWith:function(a,b){return!h||c&&!i||(b=b||[],b=[a,b.slice?b.slice():b],d?i.push(b):j(b)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!c}};return k},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&n.isFunction(a.promise)?e:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(H.resolveWith(l,[n]),n.fn.triggerHandler&&(n(l).triggerHandler("ready"),n(l).off("ready"))))}});function I(){l.removeEventListener("DOMContentLoaded",I,!1),a.removeEventListener("load",I,!1),n.ready()}n.ready.promise=function(b){return H||(H=n.Deferred(),"complete"===l.readyState?setTimeout(n.ready):(l.addEventListener("DOMContentLoaded",I,!1),a.addEventListener("load",I,!1))),H.promise(b)},n.ready.promise();var J=n.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)n.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f};n.acceptData=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function K(){Object.defineProperty(this.cache={},0,{get:function(){return{}}}),this.expando=n.expando+K.uid++}K.uid=1,K.accepts=n.acceptData,K.prototype={key:function(a){if(!K.accepts(a))return 0;var b={},c=a[this.expando];if(!c){c=K.uid++;try{b[this.expando]={value:c},Object.defineProperties(a,b)}catch(d){b[this.expando]=c,n.extend(a,b)}}return this.cache[c]||(this.cache[c]={}),c},set:function(a,b,c){var d,e=this.key(a),f=this.cache[e];if("string"==typeof b)f[b]=c;else if(n.isEmptyObject(f))n.extend(this.cache[e],b);else for(d in b)f[d]=b[d];return f},get:function(a,b){var c=this.cache[this.key(a)];return void 0===b?c:c[b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=this.key(a),g=this.cache[f];if(void 0===b)this.cache[f]={};else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in g?d=[b,e]:(d=e,d=d in g?[d]:d.match(E)||[])),c=d.length;while(c--)delete g[d[c]]}},hasData:function(a){return!n.isEmptyObject(this.cache[a[this.expando]]||{})},discard:function(a){a[this.expando]&&delete this.cache[a[this.expando]]}};var L=new K,M=new K,N=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,O=/([A-Z])/g;function P(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(O,"-$1").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}M.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return M.hasData(a)||L.hasData(a)},data:function(a,b,c){
return M.access(a,b,c)},removeData:function(a,b){M.remove(a,b)},_data:function(a,b,c){return L.access(a,b,c)},_removeData:function(a,b){L.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=M.get(f),1===f.nodeType&&!L.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d])));L.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){M.set(this,a)}):J(this,function(b){var c,d=n.camelCase(a);if(f&&void 0===b){if(c=M.get(f,a),void 0!==c)return c;if(c=M.get(f,d),void 0!==c)return c;if(c=P(f,d,void 0),void 0!==c)return c}else this.each(function(){var c=M.get(this,d);M.set(this,d,b),-1!==a.indexOf("-")&&void 0!==c&&M.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){M.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=L.get(a,b),c&&(!d||n.isArray(c)?d=L.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return L.get(a,c)||L.access(a,c,{empty:n.Callbacks("once memory").add(function(){L.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=L.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var Q=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,R=["Top","Right","Bottom","Left"],S=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)},T=/^(?:checkbox|radio)$/i;!function(){var a=l.createDocumentFragment(),b=a.appendChild(l.createElement("div")),c=l.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var U="undefined";k.focusinBubbles="onfocusin"in a;var V=/^key/,W=/^(?:mouse|pointer|contextmenu)|click/,X=/^(?:focusinfocus|focusoutblur)$/,Y=/^([^.]*)(?:\.(.+)|)$/;function Z(){return!0}function $(){return!1}function _(){try{return l.activeElement}catch(a){}}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return typeof n!==U&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(E)||[""],j=b.length;while(j--)h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g,!1)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.hasData(a)&&L.get(a);if(r&&(i=r.events)){b=(b||"").match(E)||[""],j=b.length;while(j--)if(h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&(delete r.handle,L.remove(a,"events"))}},trigger:function(b,c,d,e){var f,g,h,i,k,m,o,p=[d||l],q=j.call(b,"type")?b.type:b,r=j.call(b,"namespace")?b.namespace.split("."):[];if(g=h=d=d||l,3!==d.nodeType&&8!==d.nodeType&&!X.test(q+n.event.triggered)&&(q.indexOf(".")>=0&&(r=q.split("."),q=r.shift(),r.sort()),k=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=r.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},e||!o.trigger||o.trigger.apply(d,c)!==!1)){if(!e&&!o.noBubble&&!n.isWindow(d)){for(i=o.delegateType||q,X.test(i+q)||(g=g.parentNode);g;g=g.parentNode)p.push(g),h=g;h===(d.ownerDocument||l)&&p.push(h.defaultView||h.parentWindow||a)}f=0;while((g=p[f++])&&!b.isPropagationStopped())b.type=f>1?i:o.bindType||q,m=(L.get(g,"events")||{})[b.type]&&L.get(g,"handle"),m&&m.apply(g,c),m=k&&g[k],m&&m.apply&&n.acceptData(g)&&(b.result=m.apply(g,c),b.result===!1&&b.preventDefault());return b.type=q,e||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!n.acceptData(d)||k&&n.isFunction(d[q])&&!n.isWindow(d)&&(h=d[k],h&&(d[k]=null),n.event.triggered=q,d[q](),n.event.triggered=void 0,h&&(d[k]=h)),b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(L.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(g.namespace))&&(a.handleObj=g,a.data=g.data,e=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(a.result=e)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||"click"!==a.type))for(;i!==this;i=i.parentNode||this)if(i.disabled!==!0||"click"!==a.type){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>=0:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,d,e,f=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||l,d=c.documentElement,e=c.body,a.pageX=b.clientX+(d&&d.scrollLeft||e&&e.scrollLeft||0)-(d&&d.clientLeft||e&&e.clientLeft||0),a.pageY=b.clientY+(d&&d.scrollTop||e&&e.scrollTop||0)-(d&&d.clientTop||e&&e.clientTop||0)),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=W.test(e)?this.mouseHooks:V.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new n.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=l),3===a.target.nodeType&&(a.target=a.target.parentNode),g.filter?g.filter(a,f):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==_()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===_()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=n.extend(new n.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?n.event.trigger(e,null,b):n.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?Z:$):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={isDefaultPrevented:$,isPropagationStopped:$,isImmediatePropagationStopped:$,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=Z,a&&a.preventDefault&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=Z,a&&a.stopPropagation&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=Z,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.focusinBubbles||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a),!0)};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=L.access(d,b);e||d.addEventListener(a,c,!0),L.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=L.access(d,b)-1;e?L.access(d,b,e):(d.removeEventListener(a,c,!0),L.remove(d,b))}}}),n.fn.extend({on:function(a,b,c,d,e){var f,g;if("object"==typeof a){"string"!=typeof b&&(c=c||b,b=void 0);for(g in a)this.on(g,b,c,a[g],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&("string"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=$;else if(!d)return this;return 1===e&&(f=d,d=function(a){return n().off(a),f.apply(this,arguments)},d.guid=f.guid||(f.guid=n.guid++)),this.each(function(){n.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=$),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});var aa=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,ba=/<([\w:]+)/,ca=/<|&#?\w+;/,da=/<(?:script|style|link)/i,ea=/checked\s*(?:[^=]|=\s*.checked.)/i,fa=/^$|\/(?:java|ecma)script/i,ga=/^true\/(.*)/,ha=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,ia={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ia.optgroup=ia.option,ia.tbody=ia.tfoot=ia.colgroup=ia.caption=ia.thead,ia.th=ia.td;function ja(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function ka(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function la(a){var b=ga.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function ma(a,b){for(var c=0,d=a.length;d>c;c++)L.set(a[c],"globalEval",!b||L.get(b[c],"globalEval"))}function na(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(L.hasData(a)&&(f=L.access(a),g=L.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}M.hasData(a)&&(h=M.access(a),i=n.extend({},h),M.set(b,i))}}function oa(a,b){var c=a.getElementsByTagName?a.getElementsByTagName(b||"*"):a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function pa(a,b){var c=b.nodeName.toLowerCase();"input"===c&&T.test(a.type)?b.checked=a.checked:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}n.extend({clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=oa(h),f=oa(a),d=0,e=f.length;e>d;d++)pa(f[d],g[d]);if(b)if(c)for(f=f||oa(a),g=g||oa(h),d=0,e=f.length;e>d;d++)na(f[d],g[d]);else na(a,h);return g=oa(h,"script"),g.length>0&&ma(g,!i&&oa(a,"script")),h},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,k=b.createDocumentFragment(),l=[],m=0,o=a.length;o>m;m++)if(e=a[m],e||0===e)if("object"===n.type(e))n.merge(l,e.nodeType?[e]:e);else if(ca.test(e)){f=f||k.appendChild(b.createElement("div")),g=(ba.exec(e)||["",""])[1].toLowerCase(),h=ia[g]||ia._default,f.innerHTML=h[1]+e.replace(aa,"<$1></$2>")+h[2],j=h[0];while(j--)f=f.lastChild;n.merge(l,f.childNodes),f=k.firstChild,f.textContent=""}else l.push(b.createTextNode(e));k.textContent="",m=0;while(e=l[m++])if((!d||-1===n.inArray(e,d))&&(i=n.contains(e.ownerDocument,e),f=oa(k.appendChild(e),"script"),i&&ma(f),c)){j=0;while(e=f[j++])fa.test(e.type||"")&&c.push(e)}return k},cleanData:function(a){for(var b,c,d,e,f=n.event.special,g=0;void 0!==(c=a[g]);g++){if(n.acceptData(c)&&(e=c[L.expando],e&&(b=L.cache[e]))){if(b.events)for(d in b.events)f[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);L.cache[e]&&delete L.cache[e]}delete M.cache[c[M.expando]]}}}),n.fn.extend({text:function(a){return J(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=a)})},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=ja(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=ja(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?n.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||n.cleanData(oa(c)),c.parentNode&&(b&&n.contains(c.ownerDocument,c)&&ma(oa(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(oa(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return J(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!da.test(a)&&!ia[(ba.exec(a)||["",""])[1].toLowerCase()]){a=a.replace(aa,"<$1></$2>");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(oa(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,n.cleanData(oa(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,m=this,o=l-1,p=a[0],q=n.isFunction(p);if(q||l>1&&"string"==typeof p&&!k.checkClone&&ea.test(p))return this.each(function(c){var d=m.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(c=n.buildFragment(a,this[0].ownerDocument,!1,this),d=c.firstChild,1===c.childNodes.length&&(c=d),d)){for(f=n.map(oa(c,"script"),ka),g=f.length;l>j;j++)h=c,j!==o&&(h=n.clone(h,!0,!0),g&&n.merge(f,oa(h,"script"))),b.call(this[j],h,j);if(g)for(i=f[f.length-1].ownerDocument,n.map(f,la),j=0;g>j;j++)h=f[j],fa.test(h.type||"")&&!L.access(h,"globalEval")&&n.contains(i,h)&&(h.src?n._evalUrl&&n._evalUrl(h.src):n.globalEval(h.textContent.replace(ha,"")))}return this}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),g=e.length-1,h=0;g>=h;h++)c=h===g?this:this.clone(!0),n(e[h])[b](c),f.apply(d,c.get());return this.pushStack(d)}});var qa,ra={};function sa(b,c){var d,e=n(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:n.css(e[0],"display");return e.detach(),f}function ta(a){var b=l,c=ra[a];return c||(c=sa(a,b),"none"!==c&&c||(qa=(qa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=qa[0].contentDocument,b.write(),b.close(),c=sa(a,b),qa.detach()),ra[a]=c),c}var ua=/^margin/,va=new RegExp("^("+Q+")(?!px)[a-z%]+$","i"),wa=function(b){return b.ownerDocument.defaultView.opener?b.ownerDocument.defaultView.getComputedStyle(b,null):a.getComputedStyle(b,null)};function xa(a,b,c){var d,e,f,g,h=a.style;return c=c||wa(a),c&&(g=c.getPropertyValue(b)||c[b]),c&&(""!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),va.test(g)&&ua.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function ya(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d=l.documentElement,e=l.createElement("div"),f=l.createElement("div");if(f.style){f.style.backgroundClip="content-box",f.cloneNode(!0).style.backgroundClip="",k.clearCloneStyle="content-box"===f.style.backgroundClip,e.style.cssText="border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute",e.appendChild(f);function g(){f.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute",f.innerHTML="",d.appendChild(e);var g=a.getComputedStyle(f,null);b="1%"!==g.top,c="4px"===g.width,d.removeChild(e)}a.getComputedStyle&&n.extend(k,{pixelPosition:function(){return g(),b},boxSizingReliable:function(){return null==c&&g(),c},reliableMarginRight:function(){var b,c=f.appendChild(l.createElement("div"));return c.style.cssText=f.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",f.style.width="1px",d.appendChild(e),b=!parseFloat(a.getComputedStyle(c,null).marginRight),d.removeChild(e),f.removeChild(c),b}})}}(),n.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var za=/^(none|table(?!-c[ea]).+)/,Aa=new RegExp("^("+Q+")(.*)$","i"),Ba=new RegExp("^([+-])=("+Q+")","i"),Ca={position:"absolute",visibility:"hidden",display:"block"},Da={letterSpacing:"0",fontWeight:"400"},Ea=["Webkit","O","Moz","ms"];function Fa(a,b){if(b in a)return b;var c=b[0].toUpperCase()+b.slice(1),d=b,e=Ea.length;while(e--)if(b=Ea[e]+c,b in a)return b;return d}function Ga(a,b,c){var d=Aa.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function Ha(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+R[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+R[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+R[f]+"Width",!0,e))):(g+=n.css(a,"padding"+R[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+R[f]+"Width",!0,e)));return g}function Ia(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=wa(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=xa(a,b,f),(0>e||null==e)&&(e=a.style[b]),va.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Ha(a,b,c||(g?"border":"content"),d,f)+"px"}function Ja(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=L.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&S(d)&&(f[g]=L.access(d,"olddisplay",ta(d.nodeName)))):(e=S(d),"none"===c&&e||L.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=xa(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Fa(i,h)),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=Ba.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(n.css(a,b)),f="number"),null!=c&&c===c&&("number"!==f||n.cssNumber[h]||(c+="px"),k.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Fa(a.style,h)),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=xa(a,b,d)),"normal"===e&&b in Da&&(e=Da[b]),""===c||c?(f=parseFloat(e),c===!0||n.isNumeric(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?za.test(n.css(a,"display"))&&0===a.offsetWidth?n.swap(a,Ca,function(){return Ia(a,b,d)}):Ia(a,b,d):void 0},set:function(a,c,d){var e=d&&wa(a);return Ga(a,c,d?Ha(a,b,d,"border-box"===n.css(a,"boxSizing",!1,e),e):0)}}}),n.cssHooks.marginRight=ya(k.reliableMarginRight,function(a,b){return b?n.swap(a,{display:"inline-block"},xa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+R[d]+b]=f[d]||f[d-2]||f[0];return e}},ua.test(a)||(n.cssHooks[a+b].set=Ga)}),n.fn.extend({css:function(a,b){return J(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=wa(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Ja(this,!0)},hide:function(){return Ja(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){S(this)?n(this).show():n(this).hide()})}});function Ka(a,b,c,d,e){return new Ka.prototype.init(a,b,c,d,e)}n.Tween=Ka,Ka.prototype={constructor:Ka,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ka.propHooks[this.prop];return a&&a.get?a.get(this):Ka.propHooks._default.get(this)},run:function(a){var b,c=Ka.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ka.propHooks._default.set(this),this}},Ka.prototype.init.prototype=Ka.prototype,Ka.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[n.cssProps[a.prop]]||n.cssHooks[a.prop])?n.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Ka.propHooks.scrollTop=Ka.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},n.fx=Ka.prototype.init,n.fx.step={};var La,Ma,Na=/^(?:toggle|show|hide)$/,Oa=new RegExp("^(?:([+-])=|)("+Q+")([a-z%]*)$","i"),Pa=/queueHooks$/,Qa=[Va],Ra={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=Oa.exec(b),f=e&&e[3]||(n.cssNumber[a]?"":"px"),g=(n.cssNumber[a]||"px"!==f&&+d)&&Oa.exec(n.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,n.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function Sa(){return setTimeout(function(){La=void 0}),La=n.now()}function Ta(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=R[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ua(a,b,c){for(var d,e=(Ra[b]||[]).concat(Ra["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Va(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&S(a),q=L.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?L.get(a,"olddisplay")||ta(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Na.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?ta(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=L.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;L.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ua(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function Wa(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function Xa(a,b,c){var d,e,f=0,g=Qa.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=La||Sa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:La||Sa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(Wa(k,j.opts.specialEasing);g>f;f++)if(d=Qa[f].call(j,a,k,j.opts))return d;return n.map(k,Ua,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(Xa,{tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],Ra[c]=Ra[c]||[],Ra[c].unshift(b)},prefilter:function(a,b){b?Qa.unshift(a):Qa.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(S).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=Xa(this,n.extend({},a),f);(e||L.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=L.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Pa.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=L.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Ta(b,!0),a,d,e)}}),n.each({slideDown:Ta("show"),slideUp:Ta("hide"),slideToggle:Ta("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(La=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),La=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ma||(Ma=setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){clearInterval(Ma),Ma=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(a,b){return a=n.fx?n.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a=l.createElement("input"),b=l.createElement("select"),c=b.appendChild(l.createElement("option"));a.type="checkbox",k.checkOn=""!==a.value,k.optSelected=c.selected,b.disabled=!0,k.optDisabled=!c.disabled,a=l.createElement("input"),a.value="t",a.type="radio",k.radioValue="t"===a.value}();var Ya,Za,$a=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return J(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===U?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),d=n.attrHooks[b]||(n.expr.match.bool.test(b)?Za:Ya)),
void 0===c?d&&"get"in d&&null!==(e=d.get(a,b))?e:(e=n.find.attr(a,b),null==e?void 0:e):null!==c?d&&"set"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+""),c):void n.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}}}),Za={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=$a[b]||n.find.attr;$a[b]=function(a,b,d){var e,f;return d||(f=$a[b],$a[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,$a[b]=f),e}});var _a=/^(?:input|select|textarea|button)$/i;n.fn.extend({prop:function(a,b){return J(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!n.isXMLDoc(a),f&&(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){return a.hasAttribute("tabindex")||_a.test(a.nodeName)||a.href?a.tabIndex:-1}}}}),k.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var ab=/[\t\r\n\f]/g;n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h="string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ab," "):" ")){f=0;while(e=b[f++])d.indexOf(" "+e+" ")<0&&(d+=e+" ");g=n.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0===arguments.length||"string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ab," "):"")){f=0;while(e=b[f++])while(d.indexOf(" "+e+" ")>=0)d=d.replace(" "+e+" "," ");g=a?n.trim(d):"",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(n.isFunction(a)?function(c){n(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c){var b,d=0,e=n(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===U||"boolean"===c)&&(this.className&&L.set(this,"__className__",this.className),this.className=this.className||a===!1?"":L.get(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(ab," ").indexOf(b)>=0)return!0;return!1}});var bb=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(bb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(d.value,f)>=0)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>=0:void 0}},k.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var cb=n.now(),db=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(a){var b,c;if(!a||"string"!=typeof a)return null;try{c=new DOMParser,b=c.parseFromString(a,"text/xml")}catch(d){b=void 0}return(!b||b.getElementsByTagName("parsererror").length)&&n.error("Invalid XML: "+a),b};var eb=/#.*$/,fb=/([?&])_=[^&]*/,gb=/^(.*?):[ \t]*([^\r\n]*)$/gm,hb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,ib=/^(?:GET|HEAD)$/,jb=/^\/\//,kb=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,lb={},mb={},nb="*/".concat("*"),ob=a.location.href,pb=kb.exec(ob.toLowerCase())||[];function qb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(E)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function rb(a,b,c,d){var e={},f=a===mb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function sb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function tb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function ub(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:ob,type:"GET",isLocal:hb.test(pb[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":nb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?sb(sb(a,n.ajaxSettings),b):sb(n.ajaxSettings,a)},ajaxPrefilter:qb(lb),ajaxTransport:qb(mb),ajax:function(a,b){"object"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=n.ajaxSetup({},b),l=k.context||k,m=k.context&&(l.nodeType||l.jquery)?n(l):n.event,o=n.Deferred(),p=n.Callbacks("once memory"),q=k.statusCode||{},r={},s={},t=0,u="canceled",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!f){f={};while(b=gb.exec(e))f[b[1].toLowerCase()]=b[2]}b=f[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?e:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return c&&c.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||ob)+"").replace(eb,"").replace(jb,pb[1]+"//"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=n.trim(k.dataType||"*").toLowerCase().match(E)||[""],null==k.crossDomain&&(h=kb.exec(k.url.toLowerCase()),k.crossDomain=!(!h||h[1]===pb[1]&&h[2]===pb[2]&&(h[3]||("http:"===h[1]?"80":"443"))===(pb[3]||("http:"===pb[1]?"80":"443")))),k.data&&k.processData&&"string"!=typeof k.data&&(k.data=n.param(k.data,k.traditional)),rb(lb,k,b,v),2===t)return v;i=n.event&&k.global,i&&0===n.active++&&n.event.trigger("ajaxStart"),k.type=k.type.toUpperCase(),k.hasContent=!ib.test(k.type),d=k.url,k.hasContent||(k.data&&(d=k.url+=(db.test(d)?"&":"?")+k.data,delete k.data),k.cache===!1&&(k.url=fb.test(d)?d.replace(fb,"$1_="+cb++):d+(db.test(d)?"&":"?")+"_="+cb++)),k.ifModified&&(n.lastModified[d]&&v.setRequestHeader("If-Modified-Since",n.lastModified[d]),n.etag[d]&&v.setRequestHeader("If-None-Match",n.etag[d])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader("Content-Type",k.contentType),v.setRequestHeader("Accept",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+("*"!==k.dataTypes[0]?", "+nb+"; q=0.01":""):k.accepts["*"]);for(j in k.headers)v.setRequestHeader(j,k.headers[j]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u="abort";for(j in{success:1,error:1,complete:1})v[j](k[j]);if(c=rb(mb,k,b,v)){v.readyState=1,i&&m.trigger("ajaxSend",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort("timeout")},k.timeout));try{t=1,c.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,"No Transport");function x(a,b,f,h){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),c=void 0,e=h||"",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,f&&(u=tb(k,v,f)),u=ub(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader("Last-Modified"),w&&(n.lastModified[d]=w),w=v.getResponseHeader("etag"),w&&(n.etag[d]=w)),204===a||"HEAD"===k.type?x="nocontent":304===a?x="notmodified":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+"",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,i&&m.trigger(j?"ajaxSuccess":"ajaxError",[v,k,j?r:s]),p.fireWith(l,[v,x]),i&&(m.trigger("ajaxComplete",[v,k]),--n.active||n.event.trigger("ajaxStop")))}return v},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return this.each(n.isFunction(a)?function(b){n(this).wrapInner(a.call(this,b))}:function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var vb=/%20/g,wb=/\[\]$/,xb=/\r?\n/g,yb=/^(?:submit|button|image|reset|file)$/i,zb=/^(?:input|select|textarea|keygen)/i;function Ab(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||wb.test(a)?d(a,e):Ab(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Ab(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Ab(c,a[c],b,e);return d.join("&").replace(vb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&zb.test(this.nodeName)&&!yb.test(a)&&(this.checked||!T.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(xb,"\r\n")}}):{name:b.name,value:c.replace(xb,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new XMLHttpRequest}catch(a){}};var Bb=0,Cb={},Db={0:200,1223:204},Eb=n.ajaxSettings.xhr();a.attachEvent&&a.attachEvent("onunload",function(){for(var a in Cb)Cb[a]()}),k.cors=!!Eb&&"withCredentials"in Eb,k.ajax=Eb=!!Eb,n.ajaxTransport(function(a){var b;return k.cors||Eb&&!a.crossDomain?{send:function(c,d){var e,f=a.xhr(),g=++Bb;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c["X-Requested-With"]||(c["X-Requested-With"]="XMLHttpRequest");for(e in c)f.setRequestHeader(e,c[e]);b=function(a){return function(){b&&(delete Cb[g],b=f.onload=f.onerror=null,"abort"===a?f.abort():"error"===a?d(f.status,f.statusText):d(Db[f.status]||f.status,f.statusText,"string"==typeof f.responseText?{text:f.responseText}:void 0,f.getAllResponseHeaders()))}},f.onload=b(),f.onerror=b("error"),b=Cb[g]=b("abort");try{f.send(a.hasContent&&a.data||null)}catch(h){if(b)throw h}},abort:function(){b&&b()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(d,e){b=n("<script>").prop({async:!0,charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&e("error"===a.type?404:200,a.type)}),l.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Fb=[],Gb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Fb.pop()||n.expando+"_"+cb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Gb.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Gb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Gb,"$1"+e):b.jsonp!==!1&&(b.url+=(db.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Fb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||l;var d=v.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=n.buildFragment([a],b,e),e&&e.length&&n(e).remove(),n.merge([],d.childNodes))};var Hb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Hb)return Hb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>=0&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e,dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,f||[a.responseText,b,a])}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};var Ib=a.document.documentElement;function Jb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(typeof d.getBoundingClientRect!==U&&(e=d.getBoundingClientRect()),c=Jb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||Ib;while(a&&!n.nodeName(a,"html")&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ib})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(b,c){var d="pageYOffset"===c;n.fn[b]=function(e){return J(this,function(b,e,f){var g=Jb(b);return void 0===f?g?g[c]:b[e]:void(g?g.scrollTo(d?a.pageXOffset:f,d?f:a.pageYOffset):b[e]=f)},b,e,arguments.length,null)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=ya(k.pixelPosition,function(a,c){return c?(c=xa(a,b),va.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return J(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Kb=a.jQuery,Lb=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Lb),b&&a.jQuery===n&&(a.jQuery=Kb),n},typeof b===U&&(a.jQuery=a.$=n),n});

// moment.js
// version : 2.1.0
// author : Tim Wood
// license : MIT
// momentjs.com
!function(t){function e(t,e){return function(n){return u(t.call(this,n),e)}}function n(t,e){return function(n){return this.lang().ordinal(t.call(this,n),e)}}function s(){}function i(t){a(this,t)}function r(t){var e=t.years||t.year||t.y||0,n=t.months||t.month||t.M||0,s=t.weeks||t.week||t.w||0,i=t.days||t.day||t.d||0,r=t.hours||t.hour||t.h||0,a=t.minutes||t.minute||t.m||0,o=t.seconds||t.second||t.s||0,u=t.milliseconds||t.millisecond||t.ms||0;this._input=t,this._milliseconds=u+1e3*o+6e4*a+36e5*r,this._days=i+7*s,this._months=n+12*e,this._data={},this._bubble()}function a(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);return t}function o(t){return 0>t?Math.ceil(t):Math.floor(t)}function u(t,e){for(var n=t+"";n.length<e;)n="0"+n;return n}function h(t,e,n,s){var i,r,a=e._milliseconds,o=e._days,u=e._months;a&&t._d.setTime(+t._d+a*n),(o||u)&&(i=t.minute(),r=t.hour()),o&&t.date(t.date()+o*n),u&&t.month(t.month()+u*n),a&&!s&&H.updateOffset(t),(o||u)&&(t.minute(i),t.hour(r))}function d(t){return"[object Array]"===Object.prototype.toString.call(t)}function c(t,e){var n,s=Math.min(t.length,e.length),i=Math.abs(t.length-e.length),r=0;for(n=0;s>n;n++)~~t[n]!==~~e[n]&&r++;return r+i}function f(t){return t?ie[t]||t.toLowerCase().replace(/(.)s$/,"$1"):t}function l(t,e){return e.abbr=t,x[t]||(x[t]=new s),x[t].set(e),x[t]}function _(t){if(!t)return H.fn._lang;if(!x[t]&&A)try{require("./lang/"+t)}catch(e){return H.fn._lang}return x[t]}function m(t){return t.match(/\[.*\]/)?t.replace(/^\[|\]$/g,""):t.replace(/\\/g,"")}function y(t){var e,n,s=t.match(E);for(e=0,n=s.length;n>e;e++)s[e]=ue[s[e]]?ue[s[e]]:m(s[e]);return function(i){var r="";for(e=0;n>e;e++)r+=s[e]instanceof Function?s[e].call(i,t):s[e];return r}}function M(t,e){function n(e){return t.lang().longDateFormat(e)||e}for(var s=5;s--&&N.test(e);)e=e.replace(N,n);return re[e]||(re[e]=y(e)),re[e](t)}function g(t,e){switch(t){case"DDDD":return V;case"YYYY":return X;case"YYYYY":return $;case"S":case"SS":case"SSS":case"DDD":return I;case"MMM":case"MMMM":case"dd":case"ddd":case"dddd":return R;case"a":case"A":return _(e._l)._meridiemParse;case"X":return B;case"Z":case"ZZ":return j;case"T":return q;case"MM":case"DD":case"YY":case"HH":case"hh":case"mm":case"ss":case"M":case"D":case"d":case"H":case"h":case"m":case"s":return J;default:return new RegExp(t.replace("\\",""))}}function p(t){var e=(j.exec(t)||[])[0],n=(e+"").match(ee)||["-",0,0],s=+(60*n[1])+~~n[2];return"+"===n[0]?-s:s}function D(t,e,n){var s,i=n._a;switch(t){case"M":case"MM":i[1]=null==e?0:~~e-1;break;case"MMM":case"MMMM":s=_(n._l).monthsParse(e),null!=s?i[1]=s:n._isValid=!1;break;case"D":case"DD":case"DDD":case"DDDD":null!=e&&(i[2]=~~e);break;case"YY":i[0]=~~e+(~~e>68?1900:2e3);break;case"YYYY":case"YYYYY":i[0]=~~e;break;case"a":case"A":n._isPm=_(n._l).isPM(e);break;case"H":case"HH":case"h":case"hh":i[3]=~~e;break;case"m":case"mm":i[4]=~~e;break;case"s":case"ss":i[5]=~~e;break;case"S":case"SS":case"SSS":i[6]=~~(1e3*("0."+e));break;case"X":n._d=new Date(1e3*parseFloat(e));break;case"Z":case"ZZ":n._useUTC=!0,n._tzm=p(e)}null==e&&(n._isValid=!1)}function Y(t){var e,n,s=[];if(!t._d){for(e=0;7>e;e++)t._a[e]=s[e]=null==t._a[e]?2===e?1:0:t._a[e];s[3]+=~~((t._tzm||0)/60),s[4]+=~~((t._tzm||0)%60),n=new Date(0),t._useUTC?(n.setUTCFullYear(s[0],s[1],s[2]),n.setUTCHours(s[3],s[4],s[5],s[6])):(n.setFullYear(s[0],s[1],s[2]),n.setHours(s[3],s[4],s[5],s[6])),t._d=n}}function w(t){var e,n,s=t._f.match(E),i=t._i;for(t._a=[],e=0;e<s.length;e++)n=(g(s[e],t).exec(i)||[])[0],n&&(i=i.slice(i.indexOf(n)+n.length)),ue[s[e]]&&D(s[e],n,t);i&&(t._il=i),t._isPm&&t._a[3]<12&&(t._a[3]+=12),t._isPm===!1&&12===t._a[3]&&(t._a[3]=0),Y(t)}function k(t){var e,n,s,r,o,u=99;for(r=0;r<t._f.length;r++)e=a({},t),e._f=t._f[r],w(e),n=new i(e),o=c(e._a,n.toArray()),n._il&&(o+=n._il.length),u>o&&(u=o,s=n);a(t,s)}function v(t){var e,n=t._i,s=K.exec(n);if(s){for(t._f="YYYY-MM-DD"+(s[2]||" "),e=0;4>e;e++)if(te[e][1].exec(n)){t._f+=te[e][0];break}j.exec(n)&&(t._f+=" Z"),w(t)}else t._d=new Date(n)}function T(e){var n=e._i,s=G.exec(n);n===t?e._d=new Date:s?e._d=new Date(+s[1]):"string"==typeof n?v(e):d(n)?(e._a=n.slice(0),Y(e)):e._d=n instanceof Date?new Date(+n):new Date(n)}function b(t,e,n,s,i){return i.relativeTime(e||1,!!n,t,s)}function S(t,e,n){var s=W(Math.abs(t)/1e3),i=W(s/60),r=W(i/60),a=W(r/24),o=W(a/365),u=45>s&&["s",s]||1===i&&["m"]||45>i&&["mm",i]||1===r&&["h"]||22>r&&["hh",r]||1===a&&["d"]||25>=a&&["dd",a]||45>=a&&["M"]||345>a&&["MM",W(a/30)]||1===o&&["y"]||["yy",o];return u[2]=e,u[3]=t>0,u[4]=n,b.apply({},u)}function F(t,e,n){var s,i=n-e,r=n-t.day();return r>i&&(r-=7),i-7>r&&(r+=7),s=H(t).add("d",r),{week:Math.ceil(s.dayOfYear()/7),year:s.year()}}function O(t){var e=t._i,n=t._f;return null===e||""===e?null:("string"==typeof e&&(t._i=e=_().preparse(e)),H.isMoment(e)?(t=a({},e),t._d=new Date(+e._d)):n?d(n)?k(t):w(t):T(t),new i(t))}function z(t,e){H.fn[t]=H.fn[t+"s"]=function(t){var n=this._isUTC?"UTC":"";return null!=t?(this._d["set"+n+e](t),H.updateOffset(this),this):this._d["get"+n+e]()}}function C(t){H.duration.fn[t]=function(){return this._data[t]}}function L(t,e){H.duration.fn["as"+t]=function(){return+this/e}}for(var H,P,U="2.1.0",W=Math.round,x={},A="undefined"!=typeof module&&module.exports,G=/^\/?Date\((\-?\d+)/i,Z=/(\-)?(\d*)?\.?(\d+)\:(\d+)\:(\d+)\.?(\d{3})?/,E=/(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|SS?S?|X|zz?|ZZ?|.)/g,N=/(\[[^\[]*\])|(\\)?(LT|LL?L?L?|l{1,4})/g,J=/\d\d?/,I=/\d{1,3}/,V=/\d{3}/,X=/\d{1,4}/,$=/[+\-]?\d{1,6}/,R=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,j=/Z|[\+\-]\d\d:?\d\d/i,q=/T/i,B=/[\+\-]?\d+(\.\d{1,3})?/,K=/^\s*\d{4}-\d\d-\d\d((T| )(\d\d(:\d\d(:\d\d(\.\d\d?\d?)?)?)?)?([\+\-]\d\d:?\d\d)?)?/,Q="YYYY-MM-DDTHH:mm:ssZ",te=[["HH:mm:ss.S",/(T| )\d\d:\d\d:\d\d\.\d{1,3}/],["HH:mm:ss",/(T| )\d\d:\d\d:\d\d/],["HH:mm",/(T| )\d\d:\d\d/],["HH",/(T| )\d\d/]],ee=/([\+\-]|\d\d)/gi,ne="Date|Hours|Minutes|Seconds|Milliseconds".split("|"),se={Milliseconds:1,Seconds:1e3,Minutes:6e4,Hours:36e5,Days:864e5,Months:2592e6,Years:31536e6},ie={ms:"millisecond",s:"second",m:"minute",h:"hour",d:"day",w:"week",M:"month",y:"year"},re={},ae="DDD w W M D d".split(" "),oe="M D H h m s w W".split(" "),ue={M:function(){return this.month()+1},MMM:function(t){return this.lang().monthsShort(this,t)},MMMM:function(t){return this.lang().months(this,t)},D:function(){return this.date()},DDD:function(){return this.dayOfYear()},d:function(){return this.day()},dd:function(t){return this.lang().weekdaysMin(this,t)},ddd:function(t){return this.lang().weekdaysShort(this,t)},dddd:function(t){return this.lang().weekdays(this,t)},w:function(){return this.week()},W:function(){return this.isoWeek()},YY:function(){return u(this.year()%100,2)},YYYY:function(){return u(this.year(),4)},YYYYY:function(){return u(this.year(),5)},gg:function(){return u(this.weekYear()%100,2)},gggg:function(){return this.weekYear()},ggggg:function(){return u(this.weekYear(),5)},GG:function(){return u(this.isoWeekYear()%100,2)},GGGG:function(){return this.isoWeekYear()},GGGGG:function(){return u(this.isoWeekYear(),5)},e:function(){return this.weekday()},E:function(){return this.isoWeekday()},a:function(){return this.lang().meridiem(this.hours(),this.minutes(),!0)},A:function(){return this.lang().meridiem(this.hours(),this.minutes(),!1)},H:function(){return this.hours()},h:function(){return this.hours()%12||12},m:function(){return this.minutes()},s:function(){return this.seconds()},S:function(){return~~(this.milliseconds()/100)},SS:function(){return u(~~(this.milliseconds()/10),2)},SSS:function(){return u(this.milliseconds(),3)},Z:function(){var t=-this.zone(),e="+";return 0>t&&(t=-t,e="-"),e+u(~~(t/60),2)+":"+u(~~t%60,2)},ZZ:function(){var t=-this.zone(),e="+";return 0>t&&(t=-t,e="-"),e+u(~~(10*t/6),4)},z:function(){return this.zoneAbbr()},zz:function(){return this.zoneName()},X:function(){return this.unix()}};ae.length;)P=ae.pop(),ue[P+"o"]=n(ue[P],P);for(;oe.length;)P=oe.pop(),ue[P+P]=e(ue[P],2);for(ue.DDDD=e(ue.DDD,3),s.prototype={set:function(t){var e,n;for(n in t)e=t[n],"function"==typeof e?this[n]=e:this["_"+n]=e},_months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),months:function(t){return this._months[t.month()]},_monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),monthsShort:function(t){return this._monthsShort[t.month()]},monthsParse:function(t){var e,n,s;for(this._monthsParse||(this._monthsParse=[]),e=0;12>e;e++)if(this._monthsParse[e]||(n=H([2e3,e]),s="^"+this.months(n,"")+"|^"+this.monthsShort(n,""),this._monthsParse[e]=new RegExp(s.replace(".",""),"i")),this._monthsParse[e].test(t))return e},_weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdays:function(t){return this._weekdays[t.day()]},_weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysShort:function(t){return this._weekdaysShort[t.day()]},_weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),weekdaysMin:function(t){return this._weekdaysMin[t.day()]},weekdaysParse:function(t){var e,n,s;for(this._weekdaysParse||(this._weekdaysParse=[]),e=0;7>e;e++)if(this._weekdaysParse[e]||(n=H([2e3,1]).day(e),s="^"+this.weekdays(n,"")+"|^"+this.weekdaysShort(n,"")+"|^"+this.weekdaysMin(n,""),this._weekdaysParse[e]=new RegExp(s.replace(".",""),"i")),this._weekdaysParse[e].test(t))return e},_longDateFormat:{LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D YYYY",LLL:"MMMM D YYYY LT",LLLL:"dddd, MMMM D YYYY LT"},longDateFormat:function(t){var e=this._longDateFormat[t];return!e&&this._longDateFormat[t.toUpperCase()]&&(e=this._longDateFormat[t.toUpperCase()].replace(/MMMM|MM|DD|dddd/g,function(t){return t.slice(1)}),this._longDateFormat[t]=e),e},isPM:function(t){return"p"===(t+"").toLowerCase()[0]},_meridiemParse:/[ap]\.?m?\.?/i,meridiem:function(t,e,n){return t>11?n?"pm":"PM":n?"am":"AM"},_calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},calendar:function(t,e){var n=this._calendar[t];return"function"==typeof n?n.apply(e):n},_relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},relativeTime:function(t,e,n,s){var i=this._relativeTime[n];return"function"==typeof i?i(t,e,n,s):i.replace(/%d/i,t)},pastFuture:function(t,e){var n=this._relativeTime[t>0?"future":"past"];return"function"==typeof n?n(e):n.replace(/%s/i,e)},ordinal:function(t){return this._ordinal.replace("%d",t)},_ordinal:"%d",preparse:function(t){return t},postformat:function(t){return t},week:function(t){return F(t,this._week.dow,this._week.doy).week},_week:{dow:0,doy:6}},H=function(t,e,n){return O({_i:t,_f:e,_l:n,_isUTC:!1})},H.utc=function(t,e,n){return O({_useUTC:!0,_isUTC:!0,_l:n,_i:t,_f:e})},H.unix=function(t){return H(1e3*t)},H.duration=function(t,e){var n,s,i=H.isDuration(t),a="number"==typeof t,o=i?t._input:a?{}:t,u=Z.exec(t);return a?e?o[e]=t:o.milliseconds=t:u&&(n="-"===u[1]?-1:1,o={y:0,d:~~u[2]*n,h:~~u[3]*n,m:~~u[4]*n,s:~~u[5]*n,ms:~~u[6]*n}),s=new r(o),i&&t.hasOwnProperty("_lang")&&(s._lang=t._lang),s},H.version=U,H.defaultFormat=Q,H.updateOffset=function(){},H.lang=function(t,e){return t?(e?l(t,e):x[t]||_(t),H.duration.fn._lang=H.fn._lang=_(t),void 0):H.fn._lang._abbr},H.langData=function(t){return t&&t._lang&&t._lang._abbr&&(t=t._lang._abbr),_(t)},H.isMoment=function(t){return t instanceof i},H.isDuration=function(t){return t instanceof r},H.fn=i.prototype={clone:function(){return H(this)},valueOf:function(){return+this._d+6e4*(this._offset||0)},unix:function(){return Math.floor(+this/1e3)},toString:function(){return this.format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},toDate:function(){return this._offset?new Date(+this):this._d},toISOString:function(){return M(H(this).utc(),"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")},toArray:function(){var t=this;return[t.year(),t.month(),t.date(),t.hours(),t.minutes(),t.seconds(),t.milliseconds()]},isValid:function(){return null==this._isValid&&(this._isValid=this._a?!c(this._a,(this._isUTC?H.utc(this._a):H(this._a)).toArray()):!isNaN(this._d.getTime())),!!this._isValid},utc:function(){return this.zone(0)},local:function(){return this.zone(0),this._isUTC=!1,this},format:function(t){var e=M(this,t||H.defaultFormat);return this.lang().postformat(e)},add:function(t,e){var n;return n="string"==typeof t?H.duration(+e,t):H.duration(t,e),h(this,n,1),this},subtract:function(t,e){var n;return n="string"==typeof t?H.duration(+e,t):H.duration(t,e),h(this,n,-1),this},diff:function(t,e,n){var s,i,r=this._isUTC?H(t).zone(this._offset||0):H(t).local(),a=6e4*(this.zone()-r.zone());return e=f(e),"year"===e||"month"===e?(s=432e5*(this.daysInMonth()+r.daysInMonth()),i=12*(this.year()-r.year())+(this.month()-r.month()),i+=(this-H(this).startOf("month")-(r-H(r).startOf("month")))/s,i-=6e4*(this.zone()-H(this).startOf("month").zone()-(r.zone()-H(r).startOf("month").zone()))/s,"year"===e&&(i/=12)):(s=this-r,i="second"===e?s/1e3:"minute"===e?s/6e4:"hour"===e?s/36e5:"day"===e?(s-a)/864e5:"week"===e?(s-a)/6048e5:s),n?i:o(i)},from:function(t,e){return H.duration(this.diff(t)).lang(this.lang()._abbr).humanize(!e)},fromNow:function(t){return this.from(H(),t)},calendar:function(){var t=this.diff(H().startOf("day"),"days",!0),e=-6>t?"sameElse":-1>t?"lastWeek":0>t?"lastDay":1>t?"sameDay":2>t?"nextDay":7>t?"nextWeek":"sameElse";return this.format(this.lang().calendar(e,this))},isLeapYear:function(){var t=this.year();return 0===t%4&&0!==t%100||0===t%400},isDST:function(){return this.zone()<this.clone().month(0).zone()||this.zone()<this.clone().month(5).zone()},day:function(t){var e=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=t?"string"==typeof t&&(t=this.lang().weekdaysParse(t),"number"!=typeof t)?this:this.add({d:t-e}):e},month:function(t){var e,n=this._isUTC?"UTC":"";return null!=t?"string"==typeof t&&(t=this.lang().monthsParse(t),"number"!=typeof t)?this:(e=this.date(),this.date(1),this._d["set"+n+"Month"](t),this.date(Math.min(e,this.daysInMonth())),H.updateOffset(this),this):this._d["get"+n+"Month"]()},startOf:function(t){switch(t=f(t)){case"year":this.month(0);case"month":this.date(1);case"week":case"day":this.hours(0);case"hour":this.minutes(0);case"minute":this.seconds(0);case"second":this.milliseconds(0)}return"week"===t&&this.weekday(0),this},endOf:function(t){return this.startOf(t).add(t,1).subtract("ms",1)},isAfter:function(t,e){return e="undefined"!=typeof e?e:"millisecond",+this.clone().startOf(e)>+H(t).startOf(e)},isBefore:function(t,e){return e="undefined"!=typeof e?e:"millisecond",+this.clone().startOf(e)<+H(t).startOf(e)},isSame:function(t,e){return e="undefined"!=typeof e?e:"millisecond",+this.clone().startOf(e)===+H(t).startOf(e)},min:function(t){return t=H.apply(null,arguments),this>t?this:t},max:function(t){return t=H.apply(null,arguments),t>this?this:t},zone:function(t){var e=this._offset||0;return null==t?this._isUTC?e:this._d.getTimezoneOffset():("string"==typeof t&&(t=p(t)),Math.abs(t)<16&&(t=60*t),this._offset=t,this._isUTC=!0,e!==t&&h(this,H.duration(e-t,"m"),1,!0),this)},zoneAbbr:function(){return this._isUTC?"UTC":""},zoneName:function(){return this._isUTC?"Coordinated Universal Time":""},daysInMonth:function(){return H.utc([this.year(),this.month()+1,0]).date()},dayOfYear:function(t){var e=W((H(this).startOf("day")-H(this).startOf("year"))/864e5)+1;return null==t?e:this.add("d",t-e)},weekYear:function(t){var e=F(this,this.lang()._week.dow,this.lang()._week.doy).year;return null==t?e:this.add("y",t-e)},isoWeekYear:function(t){var e=F(this,1,4).year;return null==t?e:this.add("y",t-e)},week:function(t){var e=this.lang().week(this);return null==t?e:this.add("d",7*(t-e))},isoWeek:function(t){var e=F(this,1,4).week;return null==t?e:this.add("d",7*(t-e))},weekday:function(t){var e=(this._d.getDay()+7-this.lang()._week.dow)%7;return null==t?e:this.add("d",t-e)},isoWeekday:function(t){return null==t?this.day()||7:this.day(this.day()%7?t:t-7)},lang:function(e){return e===t?this._lang:(this._lang=_(e),this)}},P=0;P<ne.length;P++)z(ne[P].toLowerCase().replace(/s$/,""),ne[P]);z("year","FullYear"),H.fn.days=H.fn.day,H.fn.months=H.fn.month,H.fn.weeks=H.fn.week,H.fn.isoWeeks=H.fn.isoWeek,H.fn.toJSON=H.fn.toISOString,H.duration.fn=r.prototype={_bubble:function(){var t,e,n,s,i=this._milliseconds,r=this._days,a=this._months,u=this._data;u.milliseconds=i%1e3,t=o(i/1e3),u.seconds=t%60,e=o(t/60),u.minutes=e%60,n=o(e/60),u.hours=n%24,r+=o(n/24),u.days=r%30,a+=o(r/30),u.months=a%12,s=o(a/12),u.years=s},weeks:function(){return o(this.days()/7)},valueOf:function(){return this._milliseconds+864e5*this._days+2592e6*(this._months%12)+31536e6*~~(this._months/12)},humanize:function(t){var e=+this,n=S(e,!t,this.lang());return t&&(n=this.lang().pastFuture(e,n)),this.lang().postformat(n)},add:function(t,e){var n=H.duration(t,e);return this._milliseconds+=n._milliseconds,this._days+=n._days,this._months+=n._months,this._bubble(),this},subtract:function(t,e){var n=H.duration(t,e);return this._milliseconds-=n._milliseconds,this._days-=n._days,this._months-=n._months,this._bubble(),this},get:function(t){return t=f(t),this[t.toLowerCase()+"s"]()},as:function(t){return t=f(t),this["as"+t.charAt(0).toUpperCase()+t.slice(1)+"s"]()},lang:H.fn.lang};for(P in se)se.hasOwnProperty(P)&&(L(P,se[P]),C(P.toLowerCase()));L("Weeks",6048e5),H.duration.fn.asMonths=function(){return(+this-31536e6*this.years())/2592e6+12*this.years()},H.lang("en",{ordinal:function(t){var e=t%10,n=1===~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th";return t+n}}),A&&(module.exports=H),"undefined"==typeof ender&&(this.moment=H),"function"==typeof define&&define.amd&&define("moment",[],function(){return H})}.call(this);
/**
 * @author kevinm
 * @file ErrorTrapper module Definition
 */
define('lib/ErrorTrapper',['require','jquery','moment'],function (require) {
    

    var $ = require('jquery');
    var moment = require('moment');

    /**
     * Listens for browser errors, persists a collection of errors, and provides utility functions for providing errors
     * in a readable/loggable format.
     *
     * @class ErrorTrapper
     * @constructor
     * @param {string} userId Id of the signed-in user.
     * @param {string} userName Name of the signed-in user.
     */
    var ErrorTrapper = function (userId, userName) {
        /**
         * Id of the signed-in user.
         *
         * @default null
         * @property userId
         * @type {string} userId
         */
        this.userId = userId == null ? null : userId;

        /**
         * Name of the signed-in user.
         *
         * @default null
         * @property userName
         * @type {string} userName
         */
        this.userName = userName == null ? null : userName;

        /**
         * An array of errors that have been captured so far.
         *
         * @default null
         * @property errorCollection
         * @type {array}
         */
        this.errorCollection = null;

        /**
         * Tracks whether component is enabled.
         *
         * @default false
         * @property isEnabled
         * @type {boolean} isEnabled
         */
        this.isEnabled = false;

        this.init()
            .setupHandlers()
            .enable();
    };

    /**
     * Initialize the ErrorTrapper class.
     *
     * @chainable
     * @method init
     */
    ErrorTrapper.prototype.init = function () {
        this.errorCollection = [];
        return this;
    };

    /**
     * Bind event handlers.
     *
     * @chainable
     * @method setupHandlers
     */
    ErrorTrapper.prototype.setupHandlers = function () {
        // Bind event handlers scope here
        this.onErrorHandler = this.onError.bind(this);

        return this;
    };

    /**
     * Binds events to catch all uncaught browser errors.
     *
     * @chainable
     * @method enable
     */
    ErrorTrapper.prototype.enable = function () {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        // Intentionally not using addEventListener here,
        // as correct arguments would not be supplied to the event handler
        window.onerror = this.onErrorHandler;

        return this;
    };

    /**
     * Unbinds events to catch all uncaught browser errors.
     *
     * @chainable
     * @method disable
     */
    ErrorTrapper.prototype.disable = function () {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;

        window.onerror = function () {};

        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Handle caught browser errors.
     *
     * Gathers additional information about the error, and saves information about each error in an internal array.
     * Note: Different browsers return different arguments for the onerror, so we need to normalize the input here.
     *
     * @event errortrap
     * @method onError
     * @param {object} e Error event object (webkit only).
     */
    ErrorTrapper.prototype.onError = function (e) {
        var message = null;
        var fileName = null;
        var lineNumber = null;

        // Some browsers provide three separate arguments
        if (arguments.length > 1) {
            message = arguments[0];
            fileName = arguments[1];
            lineNumber = arguments[2];
        }
        // Webkit returns a single error object as the 1st argument
        else {
            message = e.message;
            fileName = e.lineno;
            lineNumber = e.filename;
        }

        var error = new Error(this.userId, this.userName, message, fileName, lineNumber);
        this.errorCollection.push(error);

        // Broadcasts a notification of the error to any listening components
        $(window).trigger('errortrap', error);
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Helpers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Sets callback function to call upon error.
     *
     * @method setErrorCallback
     * @param {function} onErrorCallback Callback function to call upon error.
     */
    ErrorTrapper.prototype.setErrorCallback = function (onErrorCallback) {
        this.onErrorCallback = onErrorCallback;
    };

    /**
     * Returns a reference to the error collection.
     *
     * @method getErrorCollection
     * @return {array} Array of Error objects.
     */
    ErrorTrapper.prototype.getErrorCollection = function () {
        if (this.errorCollection.length === 0) {
            // Special case for no errors
            // Create an empty error object which will still report some information about the current state
            var error = new Error(this.userId, this.userName, '(no errors)', '', '');
            return [error];
        }
        else {
            return this.errorCollection;
        }
    };

    /**
     * Returns the number of errors in the error collection.
     *
     * @method getErrorCount
     * @return {integer} The number of errors in the error collection.
     */
    ErrorTrapper.prototype.getErrorCount = function () {
        return this.errorCollection.length;
    };

    /**
     * Returns a String representation of the error collection.
     *
     * @method toString
     * @return {string} String representation of the error collection.
     */
    ErrorTrapper.prototype.toString = function () {
        var sep = '\n\n';
        var arr = [];

        var errorCollection = this.getErrorCollection();

        for (var i = 0; i < errorCollection.length; i++) {
            arr.push(errorCollection[i].toString());
        }

        return arr.join(sep);
    };

    /**
     * Causes the error to be output by the user agent.
     *
     * @method alertError
     */
    ErrorTrapper.prototype.alertError = function () {
        window.logger.log(this.toString());
        window.alert(this.toString());
    };

    /**
     * Abstraction around native js error object.
     *
     * Adds additional time stamp and supplementary information to track the application state at the time of error.
     *
     * @class Error
     * @constructor
     * @param {string} userId Id of the signed-in user.
     * @param {string} userName Name of the signed-in user.
     * @param {string} message Error message.
     * @param {string} fileName Js file in which error occurred.
     * @param {integer} lineNumber Line number of error.
     */
    var Error = function (userId, userName, message, fileName, lineNumber) {
        this.sep = '\n';

        this.userId = userId;
        this.userName = userName;
        this.message = message;
        this.fileName = fileName;
        this.lineNumber = lineNumber;

        // Time logged here depends on client's clock settings, so not to be considered 100% accurate
        this.time = moment.utc().format();

        this.collectSupplementaryInfo();
    };

    /* jshint ignore:start */
    /**
    * Here we can collect additional info to place into error object, such as application state at the time of the error.
    *
    * @method collectSupplementaryInfo
    */
    /* jshint ignore:end */
    Error.prototype.collectSupplementaryInfo = function () {
        this.url = window.location.href;
        this.userAgent = navigator.userAgent;
    };

    /**
     * Returns a String representation of the error.
     *
     * @method toString
     * @return {string} Representation of the error.
     */
    Error.prototype.toString = function () {
        var sep = this.sep;

        var str =
            '====== ERROR ======' + sep +
            'message: ' + this.message + sep +
            'fileName: ' + this.fileName + sep +
            'lineNumber: ' + this.lineNumber + sep +
            'time: ' + this.time + sep +
            'url: ' + this.url + sep +
            'userId: ' + this.userId + sep +
            'userName: ' + this.userName + sep +
            'userAgent: ' + this.userAgent;

        return str;
    };

    return ErrorTrapper;
});

// Knockout JavaScript library v2.2.1
// (c) Steven Sanderson - http://knockoutjs.com/
// License: MIT (http://www.opensource.org/licenses/mit-license.php)

(function () {
    function j(w) {
        throw w;
    }

    var m = !0, p = null, r = !1;

    function u(w) {
        return function () {
            return w
        }
    };
    var x = window, y = document, ga = navigator, F = window.jQuery, I = void 0;

    function L(w) {
        function ha(a, d, c, e, f) {
            var g = [];
            a = b.j(function () {
                var a = d(c, f) || [];
                0 < g.length && (b.a.Ya(M(g), a), e && b.r.K(e, p, [c, a, f]));
                g.splice(0, g.length);
                b.a.P(g, a)
            }, p, {W: a, Ka: function () {
                return 0 == g.length || !b.a.X(g[0])
            }});
            return{M: g, j: a.pa() ? a : I}
        }

        function M(a) {
            for (; a.length && !b.a.X(a[0]);)a.splice(0, 1);
            if (1 < a.length) {
                for (var d = a[0], c = a[a.length - 1], e = [d]; d !== c;) {
                    d = d.nextSibling;
                    if (!d)return;
                    e.push(d)
                }
                Array.prototype.splice.apply(a, [0, a.length].concat(e))
            }
            return a
        }

        function S(a, b, c, e, f) {
            var g = Math.min,
                h = Math.max, k = [], l, n = a.length, q, s = b.length, v = s - n || 1, G = n + s + 1, J, A, z;
            for (l = 0; l <= n; l++) {
                A = J;
                k.push(J = []);
                z = g(s, l + v);
                for (q = h(0, l - 1); q <= z; q++)J[q] = q ? l ? a[l - 1] === b[q - 1] ? A[q - 1] : g(A[q] || G, J[q - 1] || G) + 1 : q + 1 : l + 1
            }
            g = [];
            h = [];
            v = [];
            l = n;
            for (q = s; l || q;)s = k[l][q] - 1, q && s === k[l][q - 1] ? h.push(g[g.length] = {status: c, value: b[--q], index: q}) : l && s === k[l - 1][q] ? v.push(g[g.length] = {status: e, value: a[--l], index: l}) : (g.push({status: "retained", value: b[--q]}), --l);
            if (h.length && v.length) {
                a = 10 * n;
                var t;
                for (b = c = 0; (f || b < a) && (t = h[c]); c++) {
                    for (e =
                             0; k = v[e]; e++)if (t.value === k.value) {
                        t.moved = k.index;
                        k.moved = t.index;
                        v.splice(e, 1);
                        b = e = 0;
                        break
                    }
                    b += e
                }
            }
            return g.reverse()
        }

        function T(a, d, c, e, f) {
            f = f || {};
            var g = a && N(a), g = g && g.ownerDocument, h = f.templateEngine || O;
            b.za.vb(c, h, g);
            c = h.renderTemplate(c, e, f, g);
            ("number" != typeof c.length || 0 < c.length && "number" != typeof c[0].nodeType) && j(Error("Template engine must return an array of DOM nodes"));
            g = r;
            switch (d) {
                case "replaceChildren":
                    b.e.N(a, c);
                    g = m;
                    break;
                case "replaceNode":
                    b.a.Ya(a, c);
                    g = m;
                    break;
                case "ignoreTargetNode":
                    break;
                default:
                    j(Error("Unknown renderMode: " + d))
            }
            g && (U(c, e), f.afterRender && b.r.K(f.afterRender, p, [c, e.$data]));
            return c
        }

        function N(a) {
            return a.nodeType ? a : 0 < a.length ? a[0] : p
        }

        function U(a, d) {
            if (a.length) {
                var c = a[0], e = a[a.length - 1];
                V(c, e, function (a) {
                    b.Da(d, a)
                });
                V(c, e, function (a) {
                    b.s.ib(a, [d])
                })
            }
        }

        function V(a, d, c) {
            var e;
            for (d = b.e.nextSibling(d); a && (e = a) !== d;)a = b.e.nextSibling(e), (1 === e.nodeType || 8 === e.nodeType) && c(e)
        }

        function W(a, d, c) {
            a = b.g.aa(a);
            for (var e = b.g.Q, f = 0; f < a.length; f++) {
                var g = a[f].key;
                if (e.hasOwnProperty(g)) {
                    var h =
                        e[g];
                    "function" === typeof h ? (g = h(a[f].value)) && j(Error(g)) : h || j(Error("This template engine does not support the '" + g + "' binding within its templates"))
                }
            }
            a = "ko.__tr_ambtns(function($context,$element){return(function(){return{ " + b.g.ba(a) + " } })()})";
            return c.createJavaScriptEvaluatorBlock(a) + d
        }

        function X(a, d, c, e) {
            function f(a) {
                return function () {
                    return k[a]
                }
            }

            function g() {
                return k
            }

            var h = 0, k, l;
            b.j(function () {
                var n = c && c instanceof b.z ? c : new b.z(b.a.d(c)), q = n.$data;
                e && b.eb(a, n);
                if (k = ("function" == typeof d ?
                    d(n, a) : d) || b.J.instance.getBindings(a, n)) {
                    if (0 === h) {
                        h = 1;
                        for (var s in k) {
                            var v = b.c[s];
                            v && 8 === a.nodeType && !b.e.I[s] && j(Error("The binding '" + s + "' cannot be used with virtual elements"));
                            if (v && "function" == typeof v.init && (v = (0, v.init)(a, f(s), g, q, n)) && v.controlsDescendantBindings)l !== I && j(Error("Multiple bindings (" + l + " and " + s + ") are trying to control descendant bindings of the same element. You cannot use these bindings together on the same element.")), l = s
                        }
                        h = 2
                    }
                    if (2 === h)for (s in k)(v = b.c[s]) && "function" == typeof v.update && (0, v.update)(a, f(s), g, q, n)
                }
            }, p, {W: a});
            return{Nb: l === I}
        }

        function Y(a, d, c) {
            var e = m, f = 1 === d.nodeType;
            f && b.e.Ta(d);
            if (f && c || b.J.instance.nodeHasBindings(d))e = X(d, p, a, c).Nb;
            e && Z(a, d, !f)
        }

        function Z(a, d, c) {
            for (var e = b.e.firstChild(d); d = e;)e = b.e.nextSibling(d), Y(a, d, c)
        }

        function $(a, b) {
            var c = aa(a, b);
            return c ? 0 < c.length ? c[c.length - 1].nextSibling : a.nextSibling : p
        }

        function aa(a, b) {
            for (var c = a, e = 1, f = []; c = c.nextSibling;) {
                if (H(c) && (e--, 0 === e))return f;
                f.push(c);
                B(c) && e++
            }
            b || j(Error("Cannot find closing comment tag to match: " +
                a.nodeValue));
            return p
        }

        function H(a) {
            return 8 == a.nodeType && (K ? a.text : a.nodeValue).match(ia)
        }

        function B(a) {
            return 8 == a.nodeType && (K ? a.text : a.nodeValue).match(ja)
        }

        function P(a, b) {
            for (var c = p; a != c;)c = a, a = a.replace(ka, function (a, c) {
                return b[c]
            });
            return a
        }

        function la() {
            var a = [], d = [];
            this.save = function (c, e) {
                var f = b.a.i(a, c);
                0 <= f ? d[f] = e : (a.push(c), d.push(e))
            };
            this.get = function (c) {
                c = b.a.i(a, c);
                return 0 <= c ? d[c] : I
            }
        }

        function ba(a, b, c) {
            function e(e) {
                var g = b(a[e]);
                switch (typeof g) {
                    case "boolean":
                    case "number":
                    case "string":
                    case "function":
                        f[e] =
                            g;
                        break;
                    case "object":
                    case "undefined":
                        var h = c.get(g);
                        f[e] = h !== I ? h : ba(g, b, c)
                }
            }

            c = c || new la;
            a = b(a);
            if (!("object" == typeof a && a !== p && a !== I && !(a instanceof Date)))return a;
            var f = a instanceof Array ? [] : {};
            c.save(a, f);
            var g = a;
            if (g instanceof Array) {
                for (var h = 0; h < g.length; h++)e(h);
                "function" == typeof g.toJSON && e("toJSON")
            } else for (h in g)e(h);
            return f
        }

        function ca(a, d) {
            if (a)if (8 == a.nodeType) {
                var c = b.s.Ua(a.nodeValue);
                c != p && d.push({sb: a, Fb: c})
            } else if (1 == a.nodeType)for (var c = 0, e = a.childNodes, f = e.length; c < f; c++)ca(e[c],
                d)
        }

        function Q(a, d, c, e) {
            b.c[a] = {init: function (a) {
                b.a.f.set(a, da, {});
                return{controlsDescendantBindings: m}
            }, update: function (a, g, h, k, l) {
                h = b.a.f.get(a, da);
                g = b.a.d(g());
                k = !c !== !g;
                var n = !h.Za;
                if (n || d || k !== h.qb)n && (h.Za = b.a.Ia(b.e.childNodes(a), m)), k ? (n || b.e.N(a, b.a.Ia(h.Za)), b.Ea(e ? e(l, g) : l, a)) : b.e.Y(a), h.qb = k
            }};
            b.g.Q[a] = r;
            b.e.I[a] = m
        }

        function ea(a, d, c) {
            c && d !== b.k.q(a) && b.k.T(a, d);
            d !== b.k.q(a) && b.r.K(b.a.Ba, p, [a, "change"])
        }

        var b = "undefined" !== typeof w ? w : {};
        b.b = function (a, d) {
            for (var c = a.split("."), e = b, f = 0; f <
                c.length - 1; f++)e = e[c[f]];
            e[c[c.length - 1]] = d
        };
        b.p = function (a, b, c) {
            a[b] = c
        };
        b.version = "2.2.1";
        b.b("version", b.version);
        b.a = new function () {
            function a(a, d) {
                if ("input" !== b.a.u(a) || !a.type || "click" != d.toLowerCase())return r;
                var c = a.type;
                return"checkbox" == c || "radio" == c
            }

            var d = /^(\s|\u00A0)+|(\s|\u00A0)+$/g, c = {}, e = {};
            c[/Firefox\/2/i.test(ga.userAgent) ? "KeyboardEvent" : "UIEvents"] = ["keyup", "keydown", "keypress"];
            c.MouseEvents = "click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave".split(" ");
            for (var f in c) {
                var g = c[f];
                if (g.length)for (var h = 0, k = g.length; h < k; h++)e[g[h]] = f
            }
            var l = {propertychange: m}, n, c = 3;
            f = y.createElement("div");
            for (g = f.getElementsByTagName("i"); f.innerHTML = "\x3c!--[if gt IE " + ++c + "]><i></i><![endif]--\x3e", g[0];);
            n = 4 < c ? c : I;
            return{Na: ["authenticity_token", /^__RequestVerificationToken(_.*)?$/], o: function (a, b) {
                for (var d = 0, c = a.length; d < c; d++)b(a[d])
            }, i: function (a, b) {
                if ("function" == typeof Array.prototype.indexOf)return Array.prototype.indexOf.call(a, b);
                for (var d = 0, c = a.length; d <
                    c; d++)if (a[d] === b)return d;
                return-1
            }, lb: function (a, b, d) {
                for (var c = 0, e = a.length; c < e; c++)if (b.call(d, a[c]))return a[c];
                return p
            }, ga: function (a, d) {
                var c = b.a.i(a, d);
                0 <= c && a.splice(c, 1)
            }, Ga: function (a) {
                a = a || [];
                for (var d = [], c = 0, e = a.length; c < e; c++)0 > b.a.i(d, a[c]) && d.push(a[c]);
                return d
            }, V: function (a, b) {
                a = a || [];
                for (var d = [], c = 0, e = a.length; c < e; c++)d.push(b(a[c]));
                return d
            }, fa: function (a, b) {
                a = a || [];
                for (var d = [], c = 0, e = a.length; c < e; c++)b(a[c]) && d.push(a[c]);
                return d
            }, P: function (a, b) {
                if (b instanceof Array)a.push.apply(a,
                    b); else for (var d = 0, c = b.length; d < c; d++)a.push(b[d]);
                return a
            }, extend: function (a, b) {
                if (b)for (var d in b)b.hasOwnProperty(d) && (a[d] = b[d]);
                return a
            }, ka: function (a) {
                for (; a.firstChild;)b.removeNode(a.firstChild)
            }, Hb: function (a) {
                a = b.a.L(a);
                for (var d = y.createElement("div"), c = 0, e = a.length; c < e; c++)d.appendChild(b.A(a[c]));
                return d
            }, Ia: function (a, d) {
                for (var c = 0, e = a.length, g = []; c < e; c++) {
                    var f = a[c].cloneNode(m);
                    g.push(d ? b.A(f) : f)
                }
                return g
            }, N: function (a, d) {
                b.a.ka(a);
                if (d)for (var c = 0, e = d.length; c < e; c++)a.appendChild(d[c])
            },
                Ya: function (a, d) {
                    var c = a.nodeType ? [a] : a;
                    if (0 < c.length) {
                        for (var e = c[0], g = e.parentNode, f = 0, h = d.length; f < h; f++)g.insertBefore(d[f], e);
                        f = 0;
                        for (h = c.length; f < h; f++)b.removeNode(c[f])
                    }
                }, bb: function (a, b) {
                    7 > n ? a.setAttribute("selected", b) : a.selected = b
                }, D: function (a) {
                    return(a || "").replace(d, "")
                }, Rb: function (a, d) {
                    for (var c = [], e = (a || "").split(d), f = 0, g = e.length; f < g; f++) {
                        var h = b.a.D(e[f]);
                        "" !== h && c.push(h)
                    }
                    return c
                }, Ob: function (a, b) {
                    a = a || "";
                    return b.length > a.length ? r : a.substring(0, b.length) === b
                }, tb: function (a, b) {
                    if (b.compareDocumentPosition)return 16 ==
                        (b.compareDocumentPosition(a) & 16);
                    for (; a != p;) {
                        if (a == b)return m;
                        a = a.parentNode
                    }
                    return r
                }, X: function (a) {
                    return b.a.tb(a, a.ownerDocument)
                }, u: function (a) {
                    return a && a.tagName && a.tagName.toLowerCase()
                }, n: function (b, d, c) {
                    var e = n && l[d];
                    if (!e && "undefined" != typeof F) {
                        if (a(b, d)) {
                            var f = c;
                            c = function (a, b) {
                                var d = this.checked;
                                b && (this.checked = b.nb !== m);
                                f.call(this, a);
                                this.checked = d
                            }
                        }
                        F(b).bind(d, c)
                    } else!e && "function" == typeof b.addEventListener ? b.addEventListener(d, c, r) : "undefined" != typeof b.attachEvent ? b.attachEvent("on" +
                        d, function (a) {
                        c.call(b, a)
                    }) : j(Error("Browser doesn't support addEventListener or attachEvent"))
                }, Ba: function (b, d) {
                    (!b || !b.nodeType) && j(Error("element must be a DOM node when calling triggerEvent"));
                    if ("undefined" != typeof F) {
                        var c = [];
                        a(b, d) && c.push({nb: b.checked});
                        F(b).trigger(d, c)
                    } else"function" == typeof y.createEvent ? "function" == typeof b.dispatchEvent ? (c = y.createEvent(e[d] || "HTMLEvents"), c.initEvent(d, m, m, x, 0, 0, 0, 0, 0, r, r, r, r, 0, b), b.dispatchEvent(c)) : j(Error("The supplied element doesn't support dispatchEvent")) :
                            "undefined" != typeof b.fireEvent ? (a(b, d) && (b.checked = b.checked !== m), b.fireEvent("on" + d)) : j(Error("Browser doesn't support triggering events"))
                }, d: function (a) {
                    return b.$(a) ? a() : a
                }, ua: function (a) {
                    return b.$(a) ? a.t() : a
                }, da: function (a, d, c) {
                    if (d) {
                        var e = /[\w-]+/g, f = a.className.match(e) || [];
                        b.a.o(d.match(e), function (a) {
                            var d = b.a.i(f, a);
                            0 <= d ? c || f.splice(d, 1) : c && f.push(a)
                        });
                        a.className = f.join(" ")
                    }
                }, cb: function (a, d) {
                    var c = b.a.d(d);
                    if (c === p || c === I)c = "";
                    if (3 === a.nodeType)a.data = c; else {
                        var e = b.e.firstChild(a);
                        !e || 3 != e.nodeType || b.e.nextSibling(e) ? b.e.N(a, [y.createTextNode(c)]) : e.data = c;
                        b.a.wb(a)
                    }
                }, ab: function (a, b) {
                    a.name = b;
                    if (7 >= n)try {
                        a.mergeAttributes(y.createElement("<input name='" + a.name + "'/>"), r)
                    } catch (d) {
                    }
                }, wb: function (a) {
                    9 <= n && (a = 1 == a.nodeType ? a : a.parentNode, a.style && (a.style.zoom = a.style.zoom))
                }, ub: function (a) {
                    if (9 <= n) {
                        var b = a.style.width;
                        a.style.width = 0;
                        a.style.width = b
                    }
                }, Lb: function (a, d) {
                    a = b.a.d(a);
                    d = b.a.d(d);
                    for (var c = [], e = a; e <= d; e++)c.push(e);
                    return c
                }, L: function (a) {
                    for (var b = [], d = 0, c = a.length; d <
                        c; d++)b.push(a[d]);
                    return b
                }, Pb: 6 === n, Qb: 7 === n, Z: n, Oa: function (a, d) {
                    for (var c = b.a.L(a.getElementsByTagName("input")).concat(b.a.L(a.getElementsByTagName("textarea"))), e = "string" == typeof d ? function (a) {
                        return a.name === d
                    } : function (a) {
                        return d.test(a.name)
                    }, f = [], g = c.length - 1; 0 <= g; g--)e(c[g]) && f.push(c[g]);
                    return f
                }, Ib: function (a) {
                    return"string" == typeof a && (a = b.a.D(a)) ? x.JSON && x.JSON.parse ? x.JSON.parse(a) : (new Function("return " + a))() : p
                }, xa: function (a, d, c) {
                    ("undefined" == typeof JSON || "undefined" == typeof JSON.stringify) &&
                    j(Error("Cannot find JSON.stringify(). Some browsers (e.g., IE < 8) don't support it natively, but you can overcome this by adding a script reference to json2.js, downloadable from http://www.json.org/json2.js"));
                    return JSON.stringify(b.a.d(a), d, c)
                }, Jb: function (a, d, c) {
                    c = c || {};
                    var e = c.params || {}, f = c.includeFields || this.Na, g = a;
                    if ("object" == typeof a && "form" === b.a.u(a))for (var g = a.action, h = f.length - 1; 0 <= h; h--)for (var k = b.a.Oa(a, f[h]), l = k.length - 1; 0 <= l; l--)e[k[l].name] = k[l].value;
                    d = b.a.d(d);
                    var n = y.createElement("form");
                    n.style.display = "none";
                    n.action = g;
                    n.method = "post";
                    for (var w in d)a = y.createElement("input"), a.name = w, a.value = b.a.xa(b.a.d(d[w])), n.appendChild(a);
                    for (w in e)a = y.createElement("input"), a.name = w, a.value = e[w], n.appendChild(a);
                    y.body.appendChild(n);
                    c.submitter ? c.submitter(n) : n.submit();
                    setTimeout(function () {
                        n.parentNode.removeChild(n)
                    }, 0)
                }}
        };
        b.b("utils", b.a);
        b.b("utils.arrayForEach", b.a.o);
        b.b("utils.arrayFirst", b.a.lb);
        b.b("utils.arrayFilter", b.a.fa);
        b.b("utils.arrayGetDistinctValues", b.a.Ga);
        b.b("utils.arrayIndexOf",
            b.a.i);
        b.b("utils.arrayMap", b.a.V);
        b.b("utils.arrayPushAll", b.a.P);
        b.b("utils.arrayRemoveItem", b.a.ga);
        b.b("utils.extend", b.a.extend);
        b.b("utils.fieldsIncludedWithJsonPost", b.a.Na);
        b.b("utils.getFormFields", b.a.Oa);
        b.b("utils.peekObservable", b.a.ua);
        b.b("utils.postJson", b.a.Jb);
        b.b("utils.parseJson", b.a.Ib);
        b.b("utils.registerEventHandler", b.a.n);
        b.b("utils.stringifyJson", b.a.xa);
        b.b("utils.range", b.a.Lb);
        b.b("utils.toggleDomNodeCssClass", b.a.da);
        b.b("utils.triggerEvent", b.a.Ba);
        b.b("utils.unwrapObservable",
            b.a.d);
        Function.prototype.bind || (Function.prototype.bind = function (a) {
            var b = this, c = Array.prototype.slice.call(arguments);
            a = c.shift();
            return function () {
                return b.apply(a, c.concat(Array.prototype.slice.call(arguments)))
            }
        });
        b.a.f = new function () {
            var a = 0, d = "__ko__" + (new Date).getTime(), c = {};
            return{get: function (a, d) {
                var c = b.a.f.la(a, r);
                return c === I ? I : c[d]
            }, set: function (a, d, c) {
                c === I && b.a.f.la(a, r) === I || (b.a.f.la(a, m)[d] = c)
            }, la: function (b, f) {
                var g = b[d];
                if (!g || !("null" !== g && c[g])) {
                    if (!f)return I;
                    g = b[d] = "ko" +
                        a++;
                    c[g] = {}
                }
                return c[g]
            }, clear: function (a) {
                var b = a[d];
                return b ? (delete c[b], a[d] = p, m) : r
            }}
        };
        b.b("utils.domData", b.a.f);
        b.b("utils.domData.clear", b.a.f.clear);
        b.a.F = new function () {
            function a(a, d) {
                var e = b.a.f.get(a, c);
                e === I && d && (e = [], b.a.f.set(a, c, e));
                return e
            }

            function d(c) {
                var e = a(c, r);
                if (e)for (var e = e.slice(0), k = 0; k < e.length; k++)e[k](c);
                b.a.f.clear(c);
                "function" == typeof F && "function" == typeof F.cleanData && F.cleanData([c]);
                if (f[c.nodeType])for (e = c.firstChild; c = e;)e = c.nextSibling, 8 === c.nodeType && d(c)
            }

            var c = "__ko_domNodeDisposal__" + (new Date).getTime(), e = {1: m, 8: m, 9: m}, f = {1: m, 9: m};
            return{Ca: function (b, d) {
                "function" != typeof d && j(Error("Callback must be a function"));
                a(b, m).push(d)
            }, Xa: function (d, e) {
                var f = a(d, r);
                f && (b.a.ga(f, e), 0 == f.length && b.a.f.set(d, c, I))
            }, A: function (a) {
                if (e[a.nodeType] && (d(a), f[a.nodeType])) {
                    var c = [];
                    b.a.P(c, a.getElementsByTagName("*"));
                    for (var k = 0, l = c.length; k < l; k++)d(c[k])
                }
                return a
            }, removeNode: function (a) {
                b.A(a);
                a.parentNode && a.parentNode.removeChild(a)
            }}
        };
        b.A = b.a.F.A;
        b.removeNode =
            b.a.F.removeNode;
        b.b("cleanNode", b.A);
        b.b("removeNode", b.removeNode);
        b.b("utils.domNodeDisposal", b.a.F);
        b.b("utils.domNodeDisposal.addDisposeCallback", b.a.F.Ca);
        b.b("utils.domNodeDisposal.removeDisposeCallback", b.a.F.Xa);
        b.a.ta = function (a) {
            var d;
            if ("undefined" != typeof F)if (F.parseHTML)d = F.parseHTML(a); else {
                if ((d = F.clean([a])) && d[0]) {
                    for (a = d[0]; a.parentNode && 11 !== a.parentNode.nodeType;)a = a.parentNode;
                    a.parentNode && a.parentNode.removeChild(a)
                }
            } else {
                var c = b.a.D(a).toLowerCase();
                d = y.createElement("div");
                c = c.match(/^<(thead|tbody|tfoot)/) && [1, "<table>", "</table>"] || !c.indexOf("<tr") && [2, "<table><tbody>", "</tbody></table>"] || (!c.indexOf("<td") || !c.indexOf("<th")) && [3, "<table><tbody><tr>", "</tr></tbody></table>"] || [0, "", ""];
                a = "ignored<div>" + c[1] + a + c[2] + "</div>";
                for ("function" == typeof x.innerShiv ? d.appendChild(x.innerShiv(a)) : d.innerHTML = a; c[0]--;)d = d.lastChild;
                d = b.a.L(d.lastChild.childNodes)
            }
            return d
        };
        b.a.ca = function (a, d) {
            b.a.ka(a);
            d = b.a.d(d);
            if (d !== p && d !== I)if ("string" != typeof d && (d = d.toString()),
                "undefined" != typeof F)F(a).html(d); else for (var c = b.a.ta(d), e = 0; e < c.length; e++)a.appendChild(c[e])
        };
        b.b("utils.parseHtmlFragment", b.a.ta);
        b.b("utils.setHtml", b.a.ca);
        var R = {};
        b.s = {ra: function (a) {
            "function" != typeof a && j(Error("You can only pass a function to ko.memoization.memoize()"));
            var b = (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1) + (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1);
            R[b] = a;
            return"\x3c!--[ko_memo:" + b + "]--\x3e"
        }, hb: function (a, b) {
            var c = R[a];
            c === I && j(Error("Couldn't find any memo with ID " +
                a + ". Perhaps it's already been unmemoized."));
            try {
                return c.apply(p, b || []), m
            } finally {
                delete R[a]
            }
        }, ib: function (a, d) {
            var c = [];
            ca(a, c);
            for (var e = 0, f = c.length; e < f; e++) {
                var g = c[e].sb, h = [g];
                d && b.a.P(h, d);
                b.s.hb(c[e].Fb, h);
                g.nodeValue = "";
                g.parentNode && g.parentNode.removeChild(g)
            }
        }, Ua: function (a) {
            return(a = a.match(/^\[ko_memo\:(.*?)\]$/)) ? a[1] : p
        }};
        b.b("memoization", b.s);
        b.b("memoization.memoize", b.s.ra);
        b.b("memoization.unmemoize", b.s.hb);
        b.b("memoization.parseMemoText", b.s.Ua);
        b.b("memoization.unmemoizeDomNodeAndDescendants",
            b.s.ib);
        b.Ma = {throttle: function (a, d) {
            a.throttleEvaluation = d;
            var c = p;
            return b.j({read: a, write: function (b) {
                clearTimeout(c);
                c = setTimeout(function () {
                    a(b)
                }, d)
            }})
        }, notify: function (a, d) {
            a.equalityComparer = "always" == d ? u(r) : b.m.fn.equalityComparer;
            return a
        }};
        b.b("extenders", b.Ma);
        b.fb = function (a, d, c) {
            this.target = a;
            this.ha = d;
            this.rb = c;
            b.p(this, "dispose", this.B)
        };
        b.fb.prototype.B = function () {
            this.Cb = m;
            this.rb()
        };
        b.S = function () {
            this.w = {};
            b.a.extend(this, b.S.fn);
            b.p(this, "subscribe", this.ya);
            b.p(this, "extend",
                this.extend);
            b.p(this, "getSubscriptionsCount", this.yb)
        };
        b.S.fn = {ya: function (a, d, c) {
            c = c || "change";
            var e = new b.fb(this, d ? a.bind(d) : a, function () {
                b.a.ga(this.w[c], e)
            }.bind(this));
            this.w[c] || (this.w[c] = []);
            this.w[c].push(e);
            return e
        }, notifySubscribers: function (a, d) {
            d = d || "change";
            this.w[d] && b.r.K(function () {
                b.a.o(this.w[d].slice(0), function (b) {
                    b && b.Cb !== m && b.ha(a)
                })
            }, this)
        }, yb: function () {
            var a = 0, b;
            for (b in this.w)this.w.hasOwnProperty(b) && (a += this.w[b].length);
            return a
        }, extend: function (a) {
            var d = this;
            if (a)for (var c in a) {
                var e =
                    b.Ma[c];
                "function" == typeof e && (d = e(d, a[c]))
            }
            return d
        }};
        b.Qa = function (a) {
            return"function" == typeof a.ya && "function" == typeof a.notifySubscribers
        };
        b.b("subscribable", b.S);
        b.b("isSubscribable", b.Qa);
        var C = [];
        b.r = {mb: function (a) {
            C.push({ha: a, La: []})
        }, end: function () {
            C.pop()
        }, Wa: function (a) {
            b.Qa(a) || j(Error("Only subscribable things can act as dependencies"));
            if (0 < C.length) {
                var d = C[C.length - 1];
                d && !(0 <= b.a.i(d.La, a)) && (d.La.push(a), d.ha(a))
            }
        }, K: function (a, b, c) {
            try {
                return C.push(p), a.apply(b, c || [])
            } finally {
                C.pop()
            }
        }};
        var ma = {undefined: m, "boolean": m, number: m, string: m};
        b.m = function (a) {
            function d() {
                if (0 < arguments.length) {
                    if (!d.equalityComparer || !d.equalityComparer(c, arguments[0]))d.H(), c = arguments[0], d.G();
                    return this
                }
                b.r.Wa(d);
                return c
            }

            var c = a;
            b.S.call(d);
            d.t = function () {
                return c
            };
            d.G = function () {
                d.notifySubscribers(c)
            };
            d.H = function () {
                d.notifySubscribers(c, "beforeChange")
            };
            b.a.extend(d, b.m.fn);
            b.p(d, "peek", d.t);
            b.p(d, "valueHasMutated", d.G);
            b.p(d, "valueWillMutate", d.H);
            return d
        };
        b.m.fn = {equalityComparer: function (a, b) {
            return a === p || typeof a in ma ? a === b : r
        }};
        var E = b.m.Kb = "__ko_proto__";
        b.m.fn[E] = b.m;
        b.ma = function (a, d) {
            return a === p || a === I || a[E] === I ? r : a[E] === d ? m : b.ma(a[E], d)
        };
        b.$ = function (a) {
            return b.ma(a, b.m)
        };
        b.Ra = function (a) {
            return"function" == typeof a && a[E] === b.m || "function" == typeof a && a[E] === b.j && a.zb ? m : r
        };
        b.b("observable", b.m);
        b.b("isObservable", b.$);
        b.b("isWriteableObservable", b.Ra);
        b.R = function (a) {
            0 == arguments.length && (a = []);
            a !== p && (a !== I && !("length"in a)) && j(Error("The argument passed when initializing an observable array must be an array, or null, or undefined."));
            var d = b.m(a);
            b.a.extend(d, b.R.fn);
            return d
        };
        b.R.fn = {remove: function (a) {
            for (var b = this.t(), c = [], e = "function" == typeof a ? a : function (b) {
                return b === a
            }, f = 0; f < b.length; f++) {
                var g = b[f];
                e(g) && (0 === c.length && this.H(), c.push(g), b.splice(f, 1), f--)
            }
            c.length && this.G();
            return c
        }, removeAll: function (a) {
            if (a === I) {
                var d = this.t(), c = d.slice(0);
                this.H();
                d.splice(0, d.length);
                this.G();
                return c
            }
            return!a ? [] : this.remove(function (d) {
                return 0 <= b.a.i(a, d)
            })
        }, destroy: function (a) {
            var b = this.t(), c = "function" == typeof a ? a : function (b) {
                return b ===
                    a
            };
            this.H();
            for (var e = b.length - 1; 0 <= e; e--)c(b[e]) && (b[e]._destroy = m);
            this.G()
        }, destroyAll: function (a) {
            return a === I ? this.destroy(u(m)) : !a ? [] : this.destroy(function (d) {
                return 0 <= b.a.i(a, d)
            })
        }, indexOf: function (a) {
            var d = this();
            return b.a.i(d, a)
        }, replace: function (a, b) {
            var c = this.indexOf(a);
            0 <= c && (this.H(), this.t()[c] = b, this.G())
        }};
        b.a.o("pop push reverse shift sort splice unshift".split(" "), function (a) {
            b.R.fn[a] = function () {
                var b = this.t();
                this.H();
                b = b[a].apply(b, arguments);
                this.G();
                return b
            }
        });
        b.a.o(["slice"],
            function (a) {
                b.R.fn[a] = function () {
                    var b = this();
                    return b[a].apply(b, arguments)
                }
            });
        b.b("observableArray", b.R);
        b.j = function (a, d, c) {
            function e() {
                b.a.o(z, function (a) {
                    a.B()
                });
                z = []
            }

            function f() {
                var a = h.throttleEvaluation;
                a && 0 <= a ? (clearTimeout(t), t = setTimeout(g, a)) : g()
            }

            function g() {
                if (!q)if (n && w())A(); else {
                    q = m;
                    try {
                        var a = b.a.V(z, function (a) {
                            return a.target
                        });
                        b.r.mb(function (c) {
                            var d;
                            0 <= (d = b.a.i(a, c)) ? a[d] = I : z.push(c.ya(f))
                        });
                        for (var c = s.call(d), e = a.length - 1; 0 <= e; e--)a[e] && z.splice(e, 1)[0].B();
                        n = m;
                        h.notifySubscribers(l,
                            "beforeChange");
                        l = c
                    } finally {
                        b.r.end()
                    }
                    h.notifySubscribers(l);
                    q = r;
                    z.length || A()
                }
            }

            function h() {
                if (0 < arguments.length)return"function" === typeof v ? v.apply(d, arguments) : j(Error("Cannot write a value to a ko.computed unless you specify a 'write' option. If you wish to read the current value, don't pass any parameters.")), this;
                n || g();
                b.r.Wa(h);
                return l
            }

            function k() {
                return!n || 0 < z.length
            }

            var l, n = r, q = r, s = a;
            s && "object" == typeof s ? (c = s, s = c.read) : (c = c || {}, s || (s = c.read));
            "function" != typeof s && j(Error("Pass a function that returns the value of the ko.computed"));
            var v = c.write, G = c.disposeWhenNodeIsRemoved || c.W || p, w = c.disposeWhen || c.Ka || u(r), A = e, z = [], t = p;
            d || (d = c.owner);
            h.t = function () {
                n || g();
                return l
            };
            h.xb = function () {
                return z.length
            };
            h.zb = "function" === typeof c.write;
            h.B = function () {
                A()
            };
            h.pa = k;
            b.S.call(h);
            b.a.extend(h, b.j.fn);
            b.p(h, "peek", h.t);
            b.p(h, "dispose", h.B);
            b.p(h, "isActive", h.pa);
            b.p(h, "getDependenciesCount", h.xb);
            c.deferEvaluation !== m && g();
            if (G && k()) {
                A = function () {
                    b.a.F.Xa(G, arguments.callee);
                    e()
                };
                b.a.F.Ca(G, A);
                var D = w, w = function () {
                    return!b.a.X(G) || D()
                }
            }
            return h
        };
        b.Bb = function (a) {
            return b.ma(a, b.j)
        };
        w = b.m.Kb;
        b.j[w] = b.m;
        b.j.fn = {};
        b.j.fn[w] = b.j;
        b.b("dependentObservable", b.j);
        b.b("computed", b.j);
        b.b("isComputed", b.Bb);
        b.gb = function (a) {
            0 == arguments.length && j(Error("When calling ko.toJS, pass the object you want to convert."));
            return ba(a, function (a) {
                for (var c = 0; b.$(a) && 10 > c; c++)a = a();
                return a
            })
        };
        b.toJSON = function (a, d, c) {
            a = b.gb(a);
            return b.a.xa(a, d, c)
        };
        b.b("toJS", b.gb);
        b.b("toJSON", b.toJSON);
        b.k = {q: function (a) {
            switch (b.a.u(a)) {
                case "option":
                    return a.__ko__hasDomDataOptionValue__ ===
                        m ? b.a.f.get(a, b.c.options.sa) : 7 >= b.a.Z ? a.getAttributeNode("value").specified ? a.value : a.text : a.value;
                case "select":
                    return 0 <= a.selectedIndex ? b.k.q(a.options[a.selectedIndex]) : I;
                default:
                    return a.value
            }
        }, T: function (a, d) {
            switch (b.a.u(a)) {
                case "option":
                    switch (typeof d) {
                        case "string":
                            b.a.f.set(a, b.c.options.sa, I);
                            "__ko__hasDomDataOptionValue__"in a && delete a.__ko__hasDomDataOptionValue__;
                            a.value = d;
                            break;
                        default:
                            b.a.f.set(a, b.c.options.sa, d), a.__ko__hasDomDataOptionValue__ = m, a.value = "number" === typeof d ?
                                d : ""
                    }
                    break;
                case "select":
                    for (var c = a.options.length - 1; 0 <= c; c--)if (b.k.q(a.options[c]) == d) {
                        a.selectedIndex = c;
                        break
                    }
                    break;
                default:
                    if (d === p || d === I)d = "";
                    a.value = d
            }
        }};
        b.b("selectExtensions", b.k);
        b.b("selectExtensions.readValue", b.k.q);
        b.b("selectExtensions.writeValue", b.k.T);
        var ka = /\@ko_token_(\d+)\@/g, na = ["true", "false"], oa = /^(?:[$_a-z][$\w]*|(.+)(\.\s*[$_a-z][$\w]*|\[.+\]))$/i;
        b.g = {Q: [], aa: function (a) {
            var d = b.a.D(a);
            if (3 > d.length)return[];
            "{" === d.charAt(0) && (d = d.substring(1, d.length - 1));
            a = [];
            for (var c =
                p, e, f = 0; f < d.length; f++) {
                var g = d.charAt(f);
                if (c === p)switch (g) {
                    case '"':
                    case "'":
                    case "/":
                        c = f, e = g
                } else if (g == e && "\\" !== d.charAt(f - 1)) {
                    g = d.substring(c, f + 1);
                    a.push(g);
                    var h = "@ko_token_" + (a.length - 1) + "@", d = d.substring(0, c) + h + d.substring(f + 1), f = f - (g.length - h.length), c = p
                }
            }
            e = c = p;
            for (var k = 0, l = p, f = 0; f < d.length; f++) {
                g = d.charAt(f);
                if (c === p)switch (g) {
                    case "{":
                        c = f;
                        l = g;
                        e = "}";
                        break;
                    case "(":
                        c = f;
                        l = g;
                        e = ")";
                        break;
                    case "[":
                        c = f, l = g, e = "]"
                }
                g === l ? k++ : g === e && (k--, 0 === k && (g = d.substring(c, f + 1), a.push(g), h = "@ko_token_" + (a.length -
                    1) + "@", d = d.substring(0, c) + h + d.substring(f + 1), f -= g.length - h.length, c = p))
            }
            e = [];
            d = d.split(",");
            c = 0;
            for (f = d.length; c < f; c++)k = d[c], l = k.indexOf(":"), 0 < l && l < k.length - 1 ? (g = k.substring(l + 1), e.push({key: P(k.substring(0, l), a), value: P(g, a)})) : e.push({unknown: P(k, a)});
            return e
        }, ba: function (a) {
            var d = "string" === typeof a ? b.g.aa(a) : a, c = [];
            a = [];
            for (var e, f = 0; e = d[f]; f++)if (0 < c.length && c.push(","), e.key) {
                var g;
                a:{
                    g = e.key;
                    var h = b.a.D(g);
                    switch (h.length && h.charAt(0)) {
                        case "'":
                        case '"':
                            break a;
                        default:
                            g = "'" + h + "'"
                    }
                }
                e = e.value;
                c.push(g);
                c.push(":");
                c.push(e);
                e = b.a.D(e);
                0 <= b.a.i(na, b.a.D(e).toLowerCase()) ? e = r : (h = e.match(oa), e = h === p ? r : h[1] ? "Object(" + h[1] + ")" + h[2] : e);
                e && (0 < a.length && a.push(", "), a.push(g + " : function(__ko_value) { " + e + " = __ko_value; }"))
            } else e.unknown && c.push(e.unknown);
            d = c.join("");
            0 < a.length && (d = d + ", '_ko_property_writers' : { " + a.join("") + " } ");
            return d
        }, Eb: function (a, d) {
            for (var c = 0; c < a.length; c++)if (b.a.D(a[c].key) == d)return m;
            return r
        }, ea: function (a, d, c, e, f) {
            if (!a || !b.Ra(a)) {
                if ((a = d()._ko_property_writers) &&
                    a[c])a[c](e)
            } else(!f || a.t() !== e) && a(e)
        }};
        b.b("expressionRewriting", b.g);
        b.b("expressionRewriting.bindingRewriteValidators", b.g.Q);
        b.b("expressionRewriting.parseObjectLiteral", b.g.aa);
        b.b("expressionRewriting.preProcessBindings", b.g.ba);
        b.b("jsonExpressionRewriting", b.g);
        b.b("jsonExpressionRewriting.insertPropertyAccessorsIntoJson", b.g.ba);
        var K = "\x3c!--test--\x3e" === y.createComment("test").text, ja = K ? /^\x3c!--\s*ko(?:\s+(.+\s*\:[\s\S]*))?\s*--\x3e$/ : /^\s*ko(?:\s+(.+\s*\:[\s\S]*))?\s*$/, ia = K ? /^\x3c!--\s*\/ko\s*--\x3e$/ :
            /^\s*\/ko\s*$/, pa = {ul: m, ol: m};
        b.e = {I: {}, childNodes: function (a) {
            return B(a) ? aa(a) : a.childNodes
        }, Y: function (a) {
            if (B(a)) {
                a = b.e.childNodes(a);
                for (var d = 0, c = a.length; d < c; d++)b.removeNode(a[d])
            } else b.a.ka(a)
        }, N: function (a, d) {
            if (B(a)) {
                b.e.Y(a);
                for (var c = a.nextSibling, e = 0, f = d.length; e < f; e++)c.parentNode.insertBefore(d[e], c)
            } else b.a.N(a, d)
        }, Va: function (a, b) {
            B(a) ? a.parentNode.insertBefore(b, a.nextSibling) : a.firstChild ? a.insertBefore(b, a.firstChild) : a.appendChild(b)
        }, Pa: function (a, d, c) {
            c ? B(a) ? a.parentNode.insertBefore(d,
                c.nextSibling) : c.nextSibling ? a.insertBefore(d, c.nextSibling) : a.appendChild(d) : b.e.Va(a, d)
        }, firstChild: function (a) {
            return!B(a) ? a.firstChild : !a.nextSibling || H(a.nextSibling) ? p : a.nextSibling
        }, nextSibling: function (a) {
            B(a) && (a = $(a));
            return a.nextSibling && H(a.nextSibling) ? p : a.nextSibling
        }, jb: function (a) {
            return(a = B(a)) ? a[1] : p
        }, Ta: function (a) {
            if (pa[b.a.u(a)]) {
                var d = a.firstChild;
                if (d) {
                    do if (1 === d.nodeType) {
                        var c;
                        c = d.firstChild;
                        var e = p;
                        if (c) {
                            do if (e)e.push(c); else if (B(c)) {
                                var f = $(c, m);
                                f ? c = f : e = [c]
                            } else H(c) &&
                            (e = [c]); while (c = c.nextSibling)
                        }
                        if (c = e) {
                            e = d.nextSibling;
                            for (f = 0; f < c.length; f++)e ? a.insertBefore(c[f], e) : a.appendChild(c[f])
                        }
                    } while (d = d.nextSibling)
                }
            }
        }};
        b.b("virtualElements", b.e);
        b.b("virtualElements.allowedBindings", b.e.I);
        b.b("virtualElements.emptyNode", b.e.Y);
        b.b("virtualElements.insertAfter", b.e.Pa);
        b.b("virtualElements.prepend", b.e.Va);
        b.b("virtualElements.setDomNodeChildren", b.e.N);
        b.J = function () {
            this.Ha = {}
        };
        b.a.extend(b.J.prototype, {nodeHasBindings: function (a) {
            switch (a.nodeType) {
                case 1:
                    return a.getAttribute("data-bind") !=
                        p;
                case 8:
                    return b.e.jb(a) != p;
                default:
                    return r
            }
        }, getBindings: function (a, b) {
            var c = this.getBindingsString(a, b);
            return c ? this.parseBindingsString(c, b, a) : p
        }, getBindingsString: function (a) {
            switch (a.nodeType) {
                case 1:
                    return a.getAttribute("data-bind");
                case 8:
                    return b.e.jb(a);
                default:
                    return p
            }
        }, parseBindingsString: function (a, d, c) {
            try {
                var e;
                if (!(e = this.Ha[a])) {
                    var f = this.Ha, g, h = "with($context){with($data||{}){return{" + b.g.ba(a) + "}}}";
                    g = new Function("$context", "$element", h);
                    e = f[a] = g
                }
                return e(d, c)
            } catch (k) {
                j(Error("Unable to parse bindings.\nMessage: " +
                    k + ";\nBindings value: " + a))
            }
        }});
        b.J.instance = new b.J;
        b.b("bindingProvider", b.J);
        b.c = {};
        b.z = function (a, d, c) {
            d ? (b.a.extend(this, d), this.$parentContext = d, this.$parent = d.$data, this.$parents = (d.$parents || []).slice(0), this.$parents.unshift(this.$parent)) : (this.$parents = [], this.$root = a, this.ko = b);
            this.$data = a;
            c && (this[c] = a)
        };
        b.z.prototype.createChildContext = function (a, d) {
            return new b.z(a, this, d)
        };
        b.z.prototype.extend = function (a) {
            var d = b.a.extend(new b.z, this);
            return b.a.extend(d, a)
        };
        b.eb = function (a, d) {
            if (2 ==
                arguments.length)b.a.f.set(a, "__ko_bindingContext__", d); else return b.a.f.get(a, "__ko_bindingContext__")
        };
        b.Fa = function (a, d, c) {
            1 === a.nodeType && b.e.Ta(a);
            return X(a, d, c, m)
        };
        b.Ea = function (a, b) {
            (1 === b.nodeType || 8 === b.nodeType) && Z(a, b, m)
        };
        b.Da = function (a, b) {
            b && (1 !== b.nodeType && 8 !== b.nodeType) && j(Error("ko.applyBindings: first parameter should be your view model; second parameter should be a DOM node"));
            b = b || x.document.body;
            Y(a, b, m)
        };
        b.ja = function (a) {
            switch (a.nodeType) {
                case 1:
                case 8:
                    var d = b.eb(a);
                    if (d)return d;
                    if (a.parentNode)return b.ja(a.parentNode)
            }
            return I
        };
        b.pb = function (a) {
            return(a = b.ja(a)) ? a.$data : I
        };
        b.b("bindingHandlers", b.c);
        b.b("applyBindings", b.Da);
        b.b("applyBindingsToDescendants", b.Ea);
        b.b("applyBindingsToNode", b.Fa);
        b.b("contextFor", b.ja);
        b.b("dataFor", b.pb);
        var fa = {"class": "className", "for": "htmlFor"};
        b.c.attr = {update: function (a, d) {
            var c = b.a.d(d()) || {}, e;
            for (e in c)if ("string" == typeof e) {
                var f = b.a.d(c[e]), g = f === r || f === p || f === I;
                g && a.removeAttribute(e);
                8 >= b.a.Z && e in fa ? (e = fa[e], g ? a.removeAttribute(e) :
                    a[e] = f) : g || a.setAttribute(e, f.toString());
                "name" === e && b.a.ab(a, g ? "" : f.toString())
            }
        }};
        b.c.checked = {init: function (a, d, c) {
            b.a.n(a, "click", function () {
                var e;
                if ("checkbox" == a.type)e = a.checked; else if ("radio" == a.type && a.checked)e = a.value; else return;
                var f = d(), g = b.a.d(f);
                "checkbox" == a.type && g instanceof Array ? (e = b.a.i(g, a.value), a.checked && 0 > e ? f.push(a.value) : !a.checked && 0 <= e && f.splice(e, 1)) : b.g.ea(f, c, "checked", e, m)
            });
            "radio" == a.type && !a.name && b.c.uniqueName.init(a, u(m))
        }, update: function (a, d) {
            var c = b.a.d(d());
            "checkbox" == a.type ? a.checked = c instanceof Array ? 0 <= b.a.i(c, a.value) : c : "radio" == a.type && (a.checked = a.value == c)
        }};
        b.c.css = {update: function (a, d) {
            var c = b.a.d(d());
            if ("object" == typeof c)for (var e in c) {
                var f = b.a.d(c[e]);
                b.a.da(a, e, f)
            } else c = String(c || ""), b.a.da(a, a.__ko__cssValue, r), a.__ko__cssValue = c, b.a.da(a, c, m)
        }};
        b.c.enable = {update: function (a, d) {
            var c = b.a.d(d());
            c && a.disabled ? a.removeAttribute("disabled") : !c && !a.disabled && (a.disabled = m)
        }};
        b.c.disable = {update: function (a, d) {
            b.c.enable.update(a, function () {
                return!b.a.d(d())
            })
        }};
        b.c.event = {init: function (a, d, c, e) {
            var f = d() || {}, g;
            for (g in f)(function () {
                var f = g;
                "string" == typeof f && b.a.n(a, f, function (a) {
                    var g, n = d()[f];
                    if (n) {
                        var q = c();
                        try {
                            var s = b.a.L(arguments);
                            s.unshift(e);
                            g = n.apply(e, s)
                        } finally {
                            g !== m && (a.preventDefault ? a.preventDefault() : a.returnValue = r)
                        }
                        q[f + "Bubble"] === r && (a.cancelBubble = m, a.stopPropagation && a.stopPropagation())
                    }
                })
            })()
        }};
        b.c.foreach = {Sa: function (a) {
            return function () {
                var d = a(), c = b.a.ua(d);
                if (!c || "number" == typeof c.length)return{foreach: d, templateEngine: b.C.oa};
                b.a.d(d);
                return{foreach: c.data, as: c.as, includeDestroyed: c.includeDestroyed, afterAdd: c.afterAdd, beforeRemove: c.beforeRemove, afterRender: c.afterRender, beforeMove: c.beforeMove, afterMove: c.afterMove, templateEngine: b.C.oa}
            }
        }, init: function (a, d) {
            return b.c.template.init(a, b.c.foreach.Sa(d))
        }, update: function (a, d, c, e, f) {
            return b.c.template.update(a, b.c.foreach.Sa(d), c, e, f)
        }};
        b.g.Q.foreach = r;
        b.e.I.foreach = m;
        b.c.hasfocus = {init: function (a, d, c) {
            function e(e) {
                a.__ko_hasfocusUpdating = m;
                var f = a.ownerDocument;
                "activeElement"in
                f && (e = f.activeElement === a);
                f = d();
                b.g.ea(f, c, "hasfocus", e, m);
                a.__ko_hasfocusUpdating = r
            }

            var f = e.bind(p, m), g = e.bind(p, r);
            b.a.n(a, "focus", f);
            b.a.n(a, "focusin", f);
            b.a.n(a, "blur", g);
            b.a.n(a, "focusout", g)
        }, update: function (a, d) {
            var c = b.a.d(d());
            a.__ko_hasfocusUpdating || (c ? a.focus() : a.blur(), b.r.K(b.a.Ba, p, [a, c ? "focusin" : "focusout"]))
        }};
        b.c.html = {init: function () {
            return{controlsDescendantBindings: m}
        }, update: function (a, d) {
            b.a.ca(a, d())
        }};
        var da = "__ko_withIfBindingData";
        Q("if");
        Q("ifnot", r, m);
        Q("with", m, r, function (a, b) {
            return a.createChildContext(b)
        });
        b.c.options = {update: function (a, d, c) {
            "select" !== b.a.u(a) && j(Error("options binding applies only to SELECT elements"));
            for (var e = 0 == a.length, f = b.a.V(b.a.fa(a.childNodes, function (a) {
                return a.tagName && "option" === b.a.u(a) && a.selected
            }), function (a) {
                return b.k.q(a) || a.innerText || a.textContent
            }), g = a.scrollTop, h = b.a.d(d()); 0 < a.length;)b.A(a.options[0]), a.remove(0);
            if (h) {
                c = c();
                var k = c.optionsIncludeDestroyed;
                "number" != typeof h.length && (h = [h]);
                if (c.optionsCaption) {
                    var l = y.createElement("option");
                    b.a.ca(l, c.optionsCaption);
                    b.k.T(l, I);
                    a.appendChild(l)
                }
                d = 0;
                for (var n = h.length; d < n; d++) {
                    var q = h[d];
                    if (!q || !q._destroy || k) {
                        var l = y.createElement("option"), s = function (a, b, c) {
                            var d = typeof b;
                            return"function" == d ? b(a) : "string" == d ? a[b] : c
                        }, v = s(q, c.optionsValue, q);
                        b.k.T(l, b.a.d(v));
                        q = s(q, c.optionsText, v);
                        b.a.cb(l, q);
                        a.appendChild(l)
                    }
                }
                h = a.getElementsByTagName("option");
                d = k = 0;
                for (n = h.length; d < n; d++)0 <= b.a.i(f, b.k.q(h[d])) && (b.a.bb(h[d], m), k++);
                a.scrollTop = g;
                e && "value"in c && ea(a, b.a.ua(c.value), m);
                b.a.ub(a)
            }
        }};
        b.c.options.sa = "__ko.optionValueDomData__";
        b.c.selectedOptions = {init: function (a, d, c) {
            b.a.n(a, "change", function () {
                var e = d(), f = [];
                b.a.o(a.getElementsByTagName("option"), function (a) {
                    a.selected && f.push(b.k.q(a))
                });
                b.g.ea(e, c, "value", f)
            })
        }, update: function (a, d) {
            "select" != b.a.u(a) && j(Error("values binding applies only to SELECT elements"));
            var c = b.a.d(d());
            c && "number" == typeof c.length && b.a.o(a.getElementsByTagName("option"), function (a) {
                var d = 0 <= b.a.i(c, b.k.q(a));
                b.a.bb(a, d)
            })
        }};
        b.c.style = {update: function (a, d) {
            var c = b.a.d(d() || {}), e;
            for (e in c)if ("string" == typeof e) {
                var f = b.a.d(c[e]);
                a.style[e] = f || ""
            }
        }};
        b.c.submit = {init: function (a, d, c, e) {
            "function" != typeof d() && j(Error("The value for a submit binding must be a function"));
            b.a.n(a, "submit", function (b) {
                var c, h = d();
                try {
                    c = h.call(e, a)
                } finally {
                    c !== m && (b.preventDefault ? b.preventDefault() : b.returnValue = r)
                }
            })
        }};
        b.c.text = {update: function (a, d) {
            b.a.cb(a, d())
        }};
        b.e.I.text = m;
        b.c.uniqueName = {init: function (a, d) {
            if (d()) {
                var c = "ko_unique_" + ++b.c.uniqueName.ob;
                b.a.ab(a,
                    c)
            }
        }};
        b.c.uniqueName.ob = 0;
        b.c.value = {init: function (a, d, c) {
            function e() {
                h = r;
                var e = d(), f = b.k.q(a);
                b.g.ea(e, c, "value", f)
            }

            var f = ["change"], g = c().valueUpdate, h = r;
            g && ("string" == typeof g && (g = [g]), b.a.P(f, g), f = b.a.Ga(f));
            if (b.a.Z && ("input" == a.tagName.toLowerCase() && "text" == a.type && "off" != a.autocomplete && (!a.form || "off" != a.form.autocomplete)) && -1 == b.a.i(f, "propertychange"))b.a.n(a, "propertychange", function () {
                h = m
            }), b.a.n(a, "blur", function () {
                h && e()
            });
            b.a.o(f, function (c) {
                var d = e;
                b.a.Ob(c, "after") && (d = function () {
                    setTimeout(e,
                        0)
                }, c = c.substring(5));
                b.a.n(a, c, d)
            })
        }, update: function (a, d) {
            var c = "select" === b.a.u(a), e = b.a.d(d()), f = b.k.q(a), g = e != f;
            0 === e && (0 !== f && "0" !== f) && (g = m);
            g && (f = function () {
                b.k.T(a, e)
            }, f(), c && setTimeout(f, 0));
            c && 0 < a.length && ea(a, e, r)
        }};
        b.c.visible = {update: function (a, d) {
            var c = b.a.d(d()), e = "none" != a.style.display;
            c && !e ? a.style.display = "" : !c && e && (a.style.display = "none")
        }};
        b.c.click = {init: function (a, d, c, e) {
            return b.c.event.init.call(this, a, function () {
                var a = {};
                a.click = d();
                return a
            }, c, e)
        }};
        b.v = function () {
        };
        b.v.prototype.renderTemplateSource =
            function () {
                j(Error("Override renderTemplateSource"))
            };
        b.v.prototype.createJavaScriptEvaluatorBlock = function () {
            j(Error("Override createJavaScriptEvaluatorBlock"))
        };
        b.v.prototype.makeTemplateSource = function (a, d) {
            if ("string" == typeof a) {
                d = d || y;
                var c = d.getElementById(a);
                c || j(Error("Cannot find template with ID " + a));
                return new b.l.h(c)
            }
            if (1 == a.nodeType || 8 == a.nodeType)return new b.l.O(a);
            j(Error("Unknown template type: " + a))
        };
        b.v.prototype.renderTemplate = function (a, b, c, e) {
            a = this.makeTemplateSource(a, e);
            return this.renderTemplateSource(a, b, c)
        };
        b.v.prototype.isTemplateRewritten = function (a, b) {
            return this.allowTemplateRewriting === r ? m : this.makeTemplateSource(a, b).data("isRewritten")
        };
        b.v.prototype.rewriteTemplate = function (a, b, c) {
            a = this.makeTemplateSource(a, c);
            b = b(a.text());
            a.text(b);
            a.data("isRewritten", m)
        };
        b.b("templateEngine", b.v);
        var qa = /(<[a-z]+\d*(\s+(?!data-bind=)[a-z0-9\-]+(=(\"[^\"]*\"|\'[^\']*\'))?)*\s+)data-bind=(["'])([\s\S]*?)\5/gi, ra = /\x3c!--\s*ko\b\s*([\s\S]*?)\s*--\x3e/g;
        b.za = {vb: function (a, d, c) {
            d.isTemplateRewritten(a, c) || d.rewriteTemplate(a, function (a) {
                return b.za.Gb(a, d)
            }, c)
        }, Gb: function (a, b) {
            return a.replace(qa, function (a, e, f, g, h, k, l) {
                return W(l, e, b)
            }).replace(ra, function (a, e) {
                return W(e, "\x3c!-- ko --\x3e", b)
            })
        }, kb: function (a) {
            return b.s.ra(function (d, c) {
                d.nextSibling && b.Fa(d.nextSibling, a, c)
            })
        }};
        b.b("__tr_ambtns", b.za.kb);
        b.l = {};
        b.l.h = function (a) {
            this.h = a
        };
        b.l.h.prototype.text = function () {
            var a = b.a.u(this.h), a = "script" === a ? "text" : "textarea" === a ? "value" : "innerHTML";
            if (0 == arguments.length)return this.h[a];
            var d = arguments[0];
            "innerHTML" === a ? b.a.ca(this.h, d) : this.h[a] = d
        };
        b.l.h.prototype.data = function (a) {
            if (1 === arguments.length)return b.a.f.get(this.h, "templateSourceData_" + a);
            b.a.f.set(this.h, "templateSourceData_" + a, arguments[1])
        };
        b.l.O = function (a) {
            this.h = a
        };
        b.l.O.prototype = new b.l.h;
        b.l.O.prototype.text = function () {
            if (0 == arguments.length) {
                var a = b.a.f.get(this.h, "__ko_anon_template__") || {};
                a.Aa === I && a.ia && (a.Aa = a.ia.innerHTML);
                return a.Aa
            }
            b.a.f.set(this.h, "__ko_anon_template__", {Aa: arguments[0]})
        };
        b.l.h.prototype.nodes =
            function () {
                if (0 == arguments.length)return(b.a.f.get(this.h, "__ko_anon_template__") || {}).ia;
                b.a.f.set(this.h, "__ko_anon_template__", {ia: arguments[0]})
            };
        b.b("templateSources", b.l);
        b.b("templateSources.domElement", b.l.h);
        b.b("templateSources.anonymousTemplate", b.l.O);
        var O;
        b.wa = function (a) {
            a != I && !(a instanceof b.v) && j(Error("templateEngine must inherit from ko.templateEngine"));
            O = a
        };
        b.va = function (a, d, c, e, f) {
            c = c || {};
            (c.templateEngine || O) == I && j(Error("Set a template engine before calling renderTemplate"));
            f = f || "replaceChildren";
            if (e) {
                var g = N(e);
                return b.j(function () {
                    var h = d && d instanceof b.z ? d : new b.z(b.a.d(d)), k = "function" == typeof a ? a(h.$data, h) : a, h = T(e, f, k, h, c);
                    "replaceNode" == f && (e = h, g = N(e))
                }, p, {Ka: function () {
                    return!g || !b.a.X(g)
                }, W: g && "replaceNode" == f ? g.parentNode : g})
            }
            return b.s.ra(function (e) {
                b.va(a, d, c, e, "replaceNode")
            })
        };
        b.Mb = function (a, d, c, e, f) {
            function g(a, b) {
                U(b, k);
                c.afterRender && c.afterRender(b, a)
            }

            function h(d, e) {
                k = f.createChildContext(b.a.d(d), c.as);
                k.$index = e;
                var g = "function" == typeof a ?
                    a(d, k) : a;
                return T(p, "ignoreTargetNode", g, k, c)
            }

            var k;
            return b.j(function () {
                var a = b.a.d(d) || [];
                "undefined" == typeof a.length && (a = [a]);
                a = b.a.fa(a, function (a) {
                    return c.includeDestroyed || a === I || a === p || !b.a.d(a._destroy)
                });
                b.r.K(b.a.$a, p, [e, a, h, c, g])
            }, p, {W: e})
        };
        b.c.template = {init: function (a, d) {
            var c = b.a.d(d());
            if ("string" != typeof c && !c.name && (1 == a.nodeType || 8 == a.nodeType))c = 1 == a.nodeType ? a.childNodes : b.e.childNodes(a), c = b.a.Hb(c), (new b.l.O(a)).nodes(c);
            return{controlsDescendantBindings: m}
        }, update: function (a, d, c, e, f) {
            d = b.a.d(d());
            c = {};
            e = m;
            var g, h = p;
            "string" != typeof d && (c = d, d = c.name, "if"in c && (e = b.a.d(c["if"])), e && "ifnot"in c && (e = !b.a.d(c.ifnot)), g = b.a.d(c.data));
            "foreach"in c ? h = b.Mb(d || a, e && c.foreach || [], c, a, f) : e ? (f = "data"in c ? f.createChildContext(g, c.as) : f, h = b.va(d || a, f, c, a)) : b.e.Y(a);
            f = h;
            (g = b.a.f.get(a, "__ko__templateComputedDomDataKey__")) && "function" == typeof g.B && g.B();
            b.a.f.set(a, "__ko__templateComputedDomDataKey__", f && f.pa() ? f : I)
        }};
        b.g.Q.template = function (a) {
            a = b.g.aa(a);
            return 1 == a.length && a[0].unknown ||
                b.g.Eb(a, "name") ? p : "This template engine does not support anonymous templates nested within its templates"
        };
        b.e.I.template = m;
        b.b("setTemplateEngine", b.wa);
        b.b("renderTemplate", b.va);
        b.a.Ja = function (a, b, c) {
            a = a || [];
            b = b || [];
            return a.length <= b.length ? S(a, b, "added", "deleted", c) : S(b, a, "deleted", "added", c)
        };
        b.b("utils.compareArrays", b.a.Ja);
        b.a.$a = function (a, d, c, e, f) {
            function g(a, b) {
                t = l[b];
                w !== b && (z[a] = t);
                t.na(w++);
                M(t.M);
                s.push(t);
                A.push(t)
            }

            function h(a, c) {
                if (a)for (var d = 0, e = c.length; d < e; d++)c[d] && b.a.o(c[d].M,
                    function (b) {
                        a(b, d, c[d].U)
                    })
            }

            d = d || [];
            e = e || {};
            var k = b.a.f.get(a, "setDomNodeChildrenFromArrayMapping_lastMappingResult") === I, l = b.a.f.get(a, "setDomNodeChildrenFromArrayMapping_lastMappingResult") || [], n = b.a.V(l, function (a) {
                return a.U
            }), q = b.a.Ja(n, d), s = [], v = 0, w = 0, B = [], A = [];
            d = [];
            for (var z = [], n = [], t, D = 0, C, E; C = q[D]; D++)switch (E = C.moved, C.status) {
                case "deleted":
                    E === I && (t = l[v], t.j && t.j.B(), B.push.apply(B, M(t.M)), e.beforeRemove && (d[D] = t, A.push(t)));
                    v++;
                    break;
                case "retained":
                    g(D, v++);
                    break;
                case "added":
                    E !== I ?
                        g(D, E) : (t = {U: C.value, na: b.m(w++)}, s.push(t), A.push(t), k || (n[D] = t))
            }
            h(e.beforeMove, z);
            b.a.o(B, e.beforeRemove ? b.A : b.removeNode);
            for (var D = 0, k = b.e.firstChild(a), H; t = A[D]; D++) {
                t.M || b.a.extend(t, ha(a, c, t.U, f, t.na));
                for (v = 0; q = t.M[v]; k = q.nextSibling, H = q, v++)q !== k && b.e.Pa(a, q, H);
                !t.Ab && f && (f(t.U, t.M, t.na), t.Ab = m)
            }
            h(e.beforeRemove, d);
            h(e.afterMove, z);
            h(e.afterAdd, n);
            b.a.f.set(a, "setDomNodeChildrenFromArrayMapping_lastMappingResult", s)
        };
        b.b("utils.setDomNodeChildrenFromArrayMapping", b.a.$a);
        b.C = function () {
            this.allowTemplateRewriting =
                r
        };
        b.C.prototype = new b.v;
        b.C.prototype.renderTemplateSource = function (a) {
            var d = !(9 > b.a.Z) && a.nodes ? a.nodes() : p;
            if (d)return b.a.L(d.cloneNode(m).childNodes);
            a = a.text();
            return b.a.ta(a)
        };
        b.C.oa = new b.C;
        b.wa(b.C.oa);
        b.b("nativeTemplateEngine", b.C);
        b.qa = function () {
            var a = this.Db = function () {
                if ("undefined" == typeof F || !F.tmpl)return 0;
                try {
                    if (0 <= F.tmpl.tag.tmpl.open.toString().indexOf("__"))return 2
                } catch (a) {
                }
                return 1
            }();
            this.renderTemplateSource = function (b, c, e) {
                e = e || {};
                2 > a && j(Error("Your version of jQuery.tmpl is too old. Please upgrade to jQuery.tmpl 1.0.0pre or later."));
                var f = b.data("precompiled");
                f || (f = b.text() || "", f = F.template(p, "{{ko_with $item.koBindingContext}}" + f + "{{/ko_with}}"), b.data("precompiled", f));
                b = [c.$data];
                c = F.extend({koBindingContext: c}, e.templateOptions);
                c = F.tmpl(f, b, c);
                c.appendTo(y.createElement("div"));
                F.fragments = {};
                return c
            };
            this.createJavaScriptEvaluatorBlock = function (a) {
                return"{{ko_code ((function() { return " + a + " })()) }}"
            };
            this.addTemplate = function (a, b) {
                y.write("<script type='text/html' id='" + a + "'>" + b + "\x3c/script>")
            };
            0 < a && (F.tmpl.tag.ko_code =
            {open: "__.push($1 || '');"}, F.tmpl.tag.ko_with = {open: "with($1) {", close: "} "})
        };
        b.qa.prototype = new b.v;
        w = new b.qa;
        0 < w.Db && b.wa(w);
        b.b("jqueryTmplTemplateEngine", b.qa)
    }

    "function" === typeof require && "object" === typeof exports && "object" === typeof module ? L(module.exports || exports) : "function" === typeof define && define.amd ? define('knockout',["exports"], L) : L(x.ko = {});
    m;
})();

/*!
 * jQuery Cookie Plugin v1.3.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as anonymous module.
		define('lib-thirdparty/jquery.cookie',['jquery'], factory);
	} else {
		// Browser globals.
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function raw(s) {
		return s;
	}

	function decoded(s) {
		return decodeURIComponent(s.replace(pluses, ' '));
	}

	function converted(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}
		try {
			return config.json ? JSON.parse(s) : s;
		} catch(er) {}
	}

	var config = $.cookie = function (key, value, options) {

		// write
		if (value !== undefined) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setDate(t.getDate() + days);
			}

			value = config.json ? JSON.stringify(value) : String(value);

			return (document.cookie = [
				config.raw ? key : encodeURIComponent(key),
				'=',
				config.raw ? value : encodeURIComponent(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// read
		var decode = config.raw ? raw : decoded;
		var cookies = document.cookie.split('; ');
		var result = key ? undefined : {};
		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = decode(parts.join('='));

			if (key && key === name) {
				result = converted(cookie);
				break;
			}

			if (!key) {
				result[name] = converted(cookie);
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) !== undefined) {
			// Must not alter options, thus extending a fresh object...
			$.cookie(key, '', $.extend({}, options, { expires: -1 }));
			return true;
		}
		return false;
	};

}));

/**
 * @author kevinm
 * @file Util module definition
 */
define('lib/Util',['require','jquery','knockout','../lib-thirdparty/jquery.cookie'],function (require) {
    

    var $ = require('jquery');
    var ko = require('knockout');
    require('../lib-thirdparty/jquery.cookie');

    var disabledClass = 'isDisabled';

    /**
     * Static utility class containing common functions.
     *
     * @class Util
     * @constructor
     */
    var Util = {};

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // AJAX functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Fetches JSON data from a given URL.
     *
     * @method getJSON
     * @param {string} url URL of the JSON to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.getJSON = function (url, params) {
        return this._ajax('json', url, params, false);
    };

    /**
     * Fetches HTML data from a given URL.
     *
     * @method getHTML
     * @param {string} url URL of the HTML to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.getHTML = function (url, params) {
        if (typeof url === 'undefined' || url === null || url === '') {
            console.warn("provided url is blank, this will cause entire page to be retrieved!");
        }
        return this._ajax('html', url, params, false);
    };

    /**
     * Fetches HTML data from a given URL.
     *
     * @method postHTML
     * @param {string} url URL of the HTML to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.postHTML = function (url, params) {
        return this._ajax('html', url, params, true);
    };

    /**
     * Fetches XML data from a given URL.
     *
     * @method getXML
     * @param {string} url URL of the XML to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.getXML = function (url, params) {
        return this._ajax('xml', url, params, false);
    };

    /**
     * Fetches data from a given URL (data type detected via intelligent guess).
     *
     * @method get
     * @param {string} url URL of the data to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.get = function (url, params) {
        return this._ajax(null, url, params, false);
    };

    /**
     * Fetches data from a given URL (data type detected via intelligent guess).
     *
     * @method post
     * @param {string} url URL of the data to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.post = function (url, params) {
        return this._ajax(null, url, params, true);
    };

    /**
     * Fetch data from a given URL.
     *
     * @method _ajax
     * @param {string} dataType
     * @param {string} url
     * @param {object} params
     * @param {string} post
     * @private
     * @return {jqXHR}
     */
    Util._ajax = function (dataType, url, params, post) {
        if (params == null) {
            params = {};
        }

        var type = 'GET';
        if (post === true) {
            type = 'POST';
        }

        // Append versioning, cache buster, etc. to query string
        $.extend(params, Util.getVersionParams(true));

        var result = $.ajax({
            url: url,
            data: params,
            dataType: dataType,
            type: type
        });

        result
            .done(this._onAjaxDone.bind(this))
            .fail(this._onAjaxFail.bind(this));

        return result;
    };

    /**
     * On AJAX done handler.
     *
     * @method _onAjaxDone
     * @param {string} reponse
     * @private
     */
    Util._onAjaxDone = function (response, status, jqHXR) {
        // Detect session expiration

        // Scan whether user has been redirected to login page.
        // This is indicated by the presense of the class `js-loginBox`
        var isLoginPage = false;
        var isExceededPage = false;

        // Just checking the raw string here rather than a jQuery selector for better performance
        if (response != null && typeof response === 'string' && response.length > 0) {
            isLoginPage = response.indexOf('js-loginBox') >= 0;
            isExceededPage = response.indexOf('js-sessionTerminated') > 0;
        }

        if (isLoginPage) {
            this.displayTimeoutModal('timeout');
        } else if (isExceededPage) {
            this.displayTimeoutModal('exceeded');
        }
    };

    /**
     * On AJAX fail handler.
     *
     * @method _onAjaxFail
     * @param {jqXHR} jqXHR
     * @param {string} textStatus
     * @param {string} errorThrown
     * @private
     */
    Util._onAjaxFail = function (jqXHR, textStatus, errorThrown) {
        // Detect session expiration

        // If response is 403/Forbidden
        var isForbidden = (errorThrown === 'Forbidden');

        if (isForbidden) {
            this.displayTimeoutModal('timeout');
        }
    };

    /**
     * Timeout modal displayed.
     *
     * @default false
     * @property timeoutModalDisplayed
     * @type {boolean}
     */
    Util.timeoutModalDisplayed = false;

    /**
     * Display timeout modal.
     *
     * @event open
     * @method displayTimeoutModal
     */
    Util.displayTimeoutModal = function (type) {
        if (type == null) {
            type = 'timeout';
        }

        // Open session timeout modal
        // Only displays this one time, not if it's already been opened before
        if (!this.timeoutModalDisplayed) {
            this.timeoutModalDisplayed = true;

            var modalSelector = '#modal-' + type; // eg, #modal-timeout or modal-exceeded

            $(document.body).trigger('open', [modalSelector]);
        }
    };

    /**
     * Returns an object containing URL query parameters for asset versioning purposes.
     *
     * Return object is in the form { v: 1.0, cb: 0.142414 }, which is
     * suitable for translation into a set of query params in the form ?v=1.0&cb=0.142414.
     *
     * @method getVersionParams
     * @param {boolean} bustCache True to append cache-buster parameter, false to omit.
     * @return {object} Object in the form { v: 1.0, cb: 0.142414 }.
     */
    Util.getVersionParams = function (bustCache) {
        var params = {};

        params.v = window.dtnGlobals.assetVersionNumber;

        if (bustCache) {
            params.cb = Math.random(); // generate a different cache buster for each request
        }

        return params;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // DOM & CSS functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Get the name of the portlet a given element resides in
     */
    Util.getPortletName = function ($element) {
        var $elementToParse = null;

        if ($element.hasClass('portlet-boundary')) {
            $elementToParse = $element;
        } else {
            $elementToParse = $element.parents('.portlet-boundary');
        }

        return $elementToParse.attr('id').split('_')[3];
    };

    /**
     * Prevents browser's default behaviors for a given event.
     *
     * @method preventDefault
     * @param {Event} e js event object
     * @return {boolean}
     */
    Util.preventDefault = function (e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        return false;
    };

    /**
     * Searches for a DOM element positioned at the given (x, y) screen coordinate.
     *
     * @method elementFromCoordinate
     * @param {float} x X-coordinate relative to the screen.
     * @param {float} y Y-coordinate relative to the screen.
     * @param {string} testSelector jQuery selector which will test positively against the element searching for.
     * @return {jQuery} The element matching the given (x, y) coordinate. Returns empty jQuery object if no match found.
     */
    Util.elementFromCoordinate = function (x, y, testSelector) {
        // Adjust coordinates appropriately according to scrollbar position
        var documentX = x - window.scrollX;
        var documentY = y - window.scrollY;

        var $element = $(document.elementFromPoint(documentX, documentY));

        var $matchingElement = null;
        if ($element.is(testSelector)) {
            $matchingElement = $element;
        } else {
            $matchingElement = $element.closest(testSelector);
        }

        return $matchingElement;
    };

    /**
     * Disable or enable the given select element(s).
     *
     * @method setSelectDisabled
     * @param {boolean} categorySelectDisabled True to disable, false to enable.
     * @param {jQuery} $select A jQuery object containing the select(s) to disable or enable.
     */
    Util.setSelectDisabled = function (categorySelectDisabled, $select) {
        $select.prop('disabled', categorySelectDisabled);
        if (categorySelectDisabled) {
            $select.addClass(disabledClass);
        } else {
            $select.removeClass(disabledClass);
        }
    };

    /**
     * Disable or enable the given checkbox(es) and label(s).
     *
     * @method setCheckboxDisabled
     * @param {boolean} dayPitDisabled True to disable, false to enable.
     * @param {boolean} uncheckIfDisabled If this value and dayPitDisabled are both false, uncheck the checkbox(es).
     * @param {jQuery} $checkbox A jQuery object containing the checkbox(es) to disable or enable.
     * @param {jQuery} $label A jQuery object containing the label(s) to disable or enable.
     */
    Util.setCheckboxDisabled = function (dayPitDisabled, uncheckIfDisabled, $checkbox, $label) {
        $checkbox.prop('disabled', dayPitDisabled);
        if (dayPitDisabled) {
            if (uncheckIfDisabled) {
                $checkbox.prop('checked', false);
            }
            if ($label !== null) {
                $label.addClass(disabledClass);
            }
        } else {
            if ($label !== null) {
                $label.removeClass(disabledClass);
            }
        }
    };

    /**
     * Escapes html in the given string
     *
     * @method escapeHtml
     * @param {string} string String to escape
     */
    Util.escapeHtml = function (string) {
        var entityMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
        };

        return String(string).replace(/[&<>"'\/]/g, function (s) {
            return entityMap[s];
        });
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Bootstrap functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Determines whether a DOM element has been initialized with a particular component.
     *
     * @method isInitialized
     * @param {jQuery} $element DOM element to mark as initialized.
     * @param {string} id Unique identifier of the component.
     * @return {boolean} true If component is initialized.
     */
    Util.isInitialized = function ($element, id) {
        return $element.attr('data-' + id + '-initialized') === 'true';
    };

    /**
     * Marks a DOM element as being initialized with a particular component.
     *
     * @method setInitialized
     * @param {jQuery} $element DOM element to mark as initialized.
     * @param {string} id Unique identifier of the component.
     * @param {boolean} isInitialized True to set component as initialized, false to set component as uninitialized.
     */
    Util.setInitialized = function ($element, id, isInitialized) {
        $element.attr('data-' + id + '-initialized', isInitialized);
    };

    /**
     * Get the current breakpoint.
     *
     * @method getCurrentBreakpoint
     */
    Util.getCurrentBreakpoint = function () {
        return STATE.CURRENT_BREAKPOINT;
    };

    /**
     * Get the current orientation.
     *
     * @method getCurrentOrientation
     */
    Util.getCurrentOrientation = function () {
        return STATE.CURRENT_ORIENTATION;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Scroll functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Scrolls the vertical browser scrollbar such that the given element appears at the top of the page.
     *
     * @param {jQuery} $element Element to scroll to.
     * @param {integer} duration Duration of page scroll animation. Set to 0 for no animation.
     * @param {jQuery} $scrollContainer The container object with the scrollbar
     *     (optional, will use document scrollbar by default).
     * @return {$.Promise}
     */
    Util.scrollYToElement = function ($element, duration, $scrollContainer) {
        duration = duration == null ? 0 : duration;
        $scrollContainer = $scrollContainer == null ? $('body,html') : $scrollContainer;

        var y = null;
        if ($element != null && $element.length > 0 && $scrollContainer != null && $scrollContainer.length > 0) {
            y = Util.getY($element, false);
        }

        return Util.scrollToCoordinate(null, y, duration, $scrollContainer);
    };

    /**
     * Scrolls the horizontal browser scrollbar such that the given element appears at the left of the page.
     *
     * @method scrollXToElement
     * @param {jQuery} $element Element to scroll to.
     * @param {integer} duration Duration of page scroll animation. Set to 0 for no animation.
     * @param {jQuery} $scrollContainer The container object with the scrollbar
     *     (optional, will use document scrollbar by default).
     * @return {$.Promise}
     */
    Util.scrollXToElement = function ($element, duration, $scrollContainer) {
        duration = duration == null ? 0 : duration;
        $scrollContainer = $scrollContainer == null ? $('body,html') : $scrollContainer;

        var x = null;
        if ($element != null && $element.length > 0 && $scrollContainer != null && $scrollContainer.length > 0) {
            x = Util.getX($element, true);
        }

        return Util.scrollToCoordinate(x, null, duration, $scrollContainer);
    };

    /**
     * Scrolls the browser scrollbar to a given position.
     *
     * @method scrollToCoordinate
     * @param {int} x Absolute x-position of the page to set the vertical scrollbar, in pixels.
     * @param {int} y Absolute y-position of the page to set the horizontal scrollbar, in pixels.
     * @param {int} duration Duration of page scroll animation. Set to 0 for no animation.
     * @param {jQuery} $scrollContainer The container object with the scrollbar
     *     (optional, will use document scrollbar by default).
     * @return {$.Promise} deferred promise object
     */
    Util.scrollToCoordinate = function (x, y, duration, $scrollContainer) {
        var deferred = $.Deferred();

        duration = duration == null ? 0 : duration;
        $scrollContainer = $scrollContainer == null ? $('body,html') : $scrollContainer;
        if (x == null && y == null) {
            deferred.resolve();
        }

        if (duration === 0) {
            if (x != null) {
                $scrollContainer.scrollLeft(x);
            }
            if (y != null) {
                $scrollContainer.scrollTop(y);
            }

            deferred.resolve();
        } else {
            var propsToAnimate = {};
            if (x != null) {
                propsToAnimate.scrollLeft = x;
            }
            if (y != null) {
                propsToAnimate.scrollTop = y;
            }

            $scrollContainer
                .stop(true, true)
                .animate(
                propsToAnimate,
                {
                    queue: false,
                    duration: duration,
                    complete: function () {
                        deferred.resolve();
                    }
                }
            );
        }

        return deferred.promise();
    };


    /**
     * Gets the x-coordinate of the given DOM element either absolutely or relative to its parent.
     *
     * @method getX
     * @param {jQuery} $element Element to find position of.
     * @param {bool} isRelative True to calculate relative position, false for absolute position.
     * @return {float} X-coordinate of element, in pixels.
     */
    Util.getX = function ($element, isRelative) {
        if (isRelative) {
            return $element.position().left;
        } else {
            return $element.offset().left;
        }
    };

    /**
     * Gets the y-coordinate of the given DOM element either absolutely or relative to its parent.
     *
     * @method getY
     * @param {jQuery} $element Element to find position of.
     * @param {bool} isRelative True to calculate relative position, false for absolute position.
     * @return {float} Y-coordinate of element, in pixels.
     */
    Util.getY = function ($element, isRelative) {
        if (isRelative) {
            return $element.position().top;
        } else {
            return $element.offset().top;
        }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Query string functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Converts a query string to an object containing name/value pairs.
     *
     * @method convertToNameValuePairs
     * @param {string}
     *            url The full url to extract query parameters from, in the form
     *            ?name1=value1&name2=value2.
     * @return {object} Object in the form { name1:value1, name2:value2 }.
     */
    Util.convertToNameValuePairs = function (url) {
        var nameValuePairs = {};
        if (typeof url === 'string') {
            url = url.split('#')[0]; // first remove hash if present
            var index = url.indexOf('?');
            if (index >= 0) {
                var queryString = url.slice(index + 1);
                nameValuePairs = Util.parseQueryString(queryString);
            }
        }
        return nameValuePairs;
    };

    Util.parseQueryString = function (queryString) {
        var nameValuePairs = {};
        if (queryString != null) {
            var queryStringParts = queryString.split('&');

            for (var i = 0; i < queryStringParts.length; i++) {
                var nameValue = queryStringParts[i].split('=');
                if (nameValue.length <= 1) {
                    continue;
                }

                var name = nameValue[0];
                if (name === '') {
                    continue;
                }

                var value = nameValue[1];
                nameValuePairs[name] = value;
            }
        }

        return nameValuePairs;
    };

    /**
     * Converts an object containing name/value pairs to a query string.
     *
     * @method convertToQueryString
     * @param {object} nameValuePairs Object in the form { name1:value1, name2:value2 }.
     * @return {string} The full url to extract query parameters from, in the form ?name1=value1&name2=value2.
     */
    Util.convertToQueryString = function (nameValuePairs) {
        var queryString = [];

        for (var name in nameValuePairs) {
            if (nameValuePairs.hasOwnProperty(name)) {
                var value = nameValuePairs[name];
                queryString.push(name + '=' + value);
            }
        }
        return queryString.join('&');
    };

    /**
     * Returns the value of a named query parameter.
     *
     * @method getQueryValue
     * @param {string} name Key of the query param to get.
     * @param {string} url The full url to search for query parameters, in the form ?name1=value1&name2=value2.
     * @return {string} Value of the query param for the given key. Returns null if no match was found.
     */
    Util.getQueryValue = function (name, url) {
        if (url == null) {
            url = window.location.href;
        }
        // eliminate hash to prevent query value corruption
        url = url.split('#')[0];

        var nameValuePairs = Util.convertToNameValuePairs(url);
        var value = nameValuePairs[name]; // Assumes all names have already been converted lower case
        if (value != null) {
            value = decodeURIComponent(value);
        }
        return value;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Client storage functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Retrieves a value that had been stored on the client.
     *
     * @method getStoredValue
     * @param {string} key Key of the value to retrieve.
     * @return {string} Value of the supplied key. Returns `null` if key is not found.
     */
    Util.getStoredValue = function (key) {
        return $.cookie(key);
    };

    /**
     * Sets a value for storage on the client.
     *
     * @method setStoredValue
     * @param {string} key Key of the value to set.
     * @param {string} value Value to set.
     * @param {int} expireDays (optional) Number of days after which the stored value will expire.
     */
    Util.setStoredValue = function (key, value, expireDays) {
        if (expireDays != null) {
            // path: '/' needed so that cookie will apply to entire site
            $.cookie(key, value, { expires: expireDays, path: '/' });
        } else {
            $.cookie(key, value, { path: '/' });
        }
    };

    /**
     * Builds a paging url.
     *
     * @method buildURL
     * @param {string} url The base url of the requests.
     * @param {Object} data The object containing the parameters of the request.
     * @return {string}
     */
    Util.buildUrl = function (url, data) {
        var params = [];
        for (var d in data) {
            if (data.hasOwnProperty(d)) {
                params.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            }
        }
        return url + params.join('&');
    };

    /**
     * Creates an array from the given delimited string. ',' delimiter assumed unless otherwise specified.
     *
     * @method arrayFromDelimitedString
     * @param {string} string The string to tranform into Array.
     * @param {string} delimiter Optional deliminter to use, will use ',' if not supplied
     * @return {array}
     */
    Util.arrayFromDelimitedString = function (string, delimiter) {
        if (delimiter == null) {
            delimiter = ',';
        }
        var array = [];
        if (string != null && string.length > 0) {
            array = string.split(delimiter);
        }
        return array;
    };

    /**
     * Creates a hash map from the given array. Keys are elements in the array, values are always `true`
     *
     * @method hashFromArray
     * @param {array} array Array to transform into hash
     * @return {object}
     */
    Util.hashFromArray = function (array) {
        var hash = {};
        for (var i = 0; i < array.length; i++) {
            var value = array[i];
            hash[value] = true;
        }
        return hash;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Pub/sub methods
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Subscribes to the given channel
     * Encapsulated here so that we could swap out pub/sub implementation if need be
     *
     * @method subscribe
     * @param {string} channelName Name of channel to subscribe to
     * @param {function} handlerFn Function to trigger upon receipt of broadcast
     * @param {Object} $eventElement Reference to object to apply event to
     * @param {boolean} oneExecution Execute each event only once
     */
    Util.subscribe = function (channelName, handlerFn, $eventElement, oneExecution) {
        if ($eventElement) {
            if (oneExecution) {
                $eventElement.one(channelName, handlerFn);
            } else {
                $eventElement.on(channelName, handlerFn);
            }
        } else {
            if (oneExecution) {
                $(window).one(channelName, handlerFn);
            } else {
                $(window).on(channelName, handlerFn);
            }
        }
    };

    /**
     * Unsubscribes to the given channel
     * Encapsulated here so that we could swap out pub/sub implementation if need be
     *
     * @method unsubscribe
     * @param {string} channelName Name of channel to unsubscribe from
     * @return {function} handlerFn Function to trigger upon receipt of broadcast
     * @param {Object} $eventElement Reference to object to remove the event from
     */
    Util.unsubscribe = function (channelName, handlerFn, $eventElement) {
        if ($eventElement) {
            $eventElement.off(channelName, handlerFn);
        } else {
            $(window).off(channelName, handlerFn);
        }
    };

    /**
     * Broadcasts to the given channel
     * Encapsulated here so that we could swap out pub/sub implementation if need be
     *
     * @method broadcast
     * @param {string} channelName Name of channel to broadcast to
     * @param {array} argumentArray An optional array of arguments to include with broadcast
     * @param {Object} $eventElement Reference to object to trigger event from
     */
    Util.broadcast = function (channelName, argumentArray, $eventElement) {
        if ($eventElement) {
            // triggerHandler used here to avoid event bubbling
            $eventElement.triggerHandler(channelName, argumentArray);
        } else {
            $(window).triggerHandler(channelName, argumentArray);
        }
    };

    /**
     * Triggers an event from a given object
     * Placeholder until components are converted to use esnext base component
     *
     * @method sendAction
     * @param {string} channelName Name of channel to broadcast to
     * @param {Object} $eventElement Reference to object to trigger event from
     */
    Util.sendAction = function (channelName, $eventElement) {
        $eventElement.trigger(channelName);
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Knockout Binding
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Applies data bindings to a DOM element.
     * This will save the current DOM structure as a template before binding.
     *
     * @param {string} id A unique string to identify the element. Used in creating a template.
     * @param {object} model The model to use for the bindings
     * @param {jQuery} $element JQuery element to apply bindings on
     * @method applyBindings
     */
    Util.applyBindings = function (id, model, $element) {
        // Check the knockout cage for an existing template. If one doesn't exist, clone the current element
        // and use as a template.
        var $koCage = $('.js-knockout-cage');
        if ($koCage.find('[data-template-for=' + id + ']').length === 0) {
            var $template = $element.clone();
            $template.attr('data-template-for', id);
            $koCage.append($template);
        }

        // Apply bindings with knockout. Knockout requires unboxing the JQuery element.
        ko.applyBindings(model, $element[0]);
    };

    /**
     * Will remove any data binding from a DOM element.
     * The DOM element must be the same element that was passed in to 'applyBindings'. It will be
     * replaced with the initial template.
     *
     * @param {string} id A unique string to identify the element. Used in identifying the template.
     * @param {jQuery} $element The JQuery element to remove bindings from. Will be replaced with a template.
     * @method removeBindings
     */
    Util.removeBindings = function (id, $element) {
        // Ask knockout to clean the element. This will leave behind any DOM modifications made by knockout.
        ko.cleanNode($element[0]);

        // Restore the element to the templated state, so that knockout can be applied again, if needed.
        var $template = $('.js-knockout-cage').find('[data-template-for=' + id + ']');
        if ($template.length > 0) {
            $element.replaceWith($template);
        } else {
            // Something went wrong and either the template was never saved, or it was lost somehow
            console.warn('Knockout template not found for: ' + id);
        }
    };

    return Util;
});

/**
 * @author Kevin Moot
 * @file BreakpointListener module definition
 */
define('lib/BreakpointListener',['require','jquery','./Util'],function (require) {
    

    var $ = require('jquery');
    var Util = require('./Util');

    /**
     * Listens for window resize and broadcasts appropriate events to all site components.
     *
     * @class BreakpointListener
     * @constructor
     * @param {BrowserDetect} browserDetect
     */
    var BreakpointListener = function (browserDetect) {
        /**
         * Browser detect feature object.
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        /**
         * Force a particular breakpoint to always appear. Null will auto-detect breakpoint.
         *
         * @property forceBreakpoint
         * @type {window.dtnGlobals.breakpointType}
         */
        this.forceBreakpoint = null;

        /**
         * Tracks the current breakpoint state.
         *
         * @property currentBreakpoint
         * @type {window.dtnGlobals.breakpointType}
         */
        this.currentBreakpoint = null;

        /**
         * Tracks the current orientation state.
         *
         * @property currentOrientation
         * @type {window.dtnGlobals.orientationType}
         */
        this.currentOrientation = null;

        /**
         * Tracks whether component is enabled.
         *
         * @property isEnabled
         * @type {boolean}
         */
        this.isEnabled = false;

        /**
         * Viewport string.
         *
         * @property viewportString
         * @type {string}
         */
        this.viewportString = '';

        this.init();
    };

    /**
     * Initializes the component.
     *
     * @chainable
     * @method init
     */
    BreakpointListener.prototype.init = function () {
        if (this.browserDetect.os.iPad) {
            this.forceBreakpoint = window.dtnGlobals.breakpointType.DESKTOP;
        } else if (this.browserDetect.os.iPhone) {
            this.forceBreakpoint = window.dtnGlobals.breakpointType.MOBILE;
        }

        return this.setupHandlers()
                   .enable();
    };

    /**
     * Binds the scope of any handler functions.
     *
     * Should only be run on initialization of the view.
     *
     * @chainable
     * @method setupHandlers
     */
    BreakpointListener.prototype.setupHandlers = function () {
        // Bind event handlers scope here
        this.onResizeHandler = this.onResize.bind(this);
        this.onOrientationChangeHandler = this.onOrientationChange.bind(this);

        return this;
    };

    /**
     * Enables the component.
     *
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @chainable
     * @method enable
     */
    BreakpointListener.prototype.enable = function () {
        if (this.isEnabled) {
            return this;
        }

        this.isEnabled = true;

        // Setup any event handlers
        $(window).on('resize.BreakpointListener', this.onResizeHandler);
        $(window).on('orientationchange.BreakpointListener', this.onOrientationChangeHandler);

        this.onResize(); // Immediately fire the onResize() event
        this.onOrientationChange(); // Immediately fire the onOrientationChange() event

        return this;
    };

    /**
     * Disables the component.
     *
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @chainable
     * @method disable
     */
    BreakpointListener.prototype.disable = function () {
        if (!this.isEnabled) {
            return this;
        }

        this.isEnabled = false;

        // Tear down any event handlers
        $(window).off('resize.BreakpointListener', this.onResizeHandler);
        $(window).off('orientationchange.BreakpointListener', this.onOrientationChangeHandler);

        return this;
    };

    /**
     * Destroys the component.
     *
     * Tears down any events, handlers, elements.
     * Should be called when the object should be left unused.
     *
     * @chainable
     * @method destroy
     */
    BreakpointListener.prototype.destroy = function () {
        this.disable();

        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * On resize handler.
     *
     * Detects appropriate desktop/mobile breakpoint upon browser window resize.
     *
     * @method onResize
     * @param {Event} e JS Event object.
     */
    BreakpointListener.prototype.onResize = function (e) {
        var breakpoint = this.getBreakpoint();

        if (breakpoint !== this.currentBreakpoint) {
            // Exit previous layout
            if (this.currentBreakpoint === window.dtnGlobals.breakpointType.MOBILE) {
                Util.broadcast('breakpointChange', 'mobileExit');
            } else if (this.currentBreakpoint === window.dtnGlobals.breakpointType.DESKTOP) {
                Util.broadcast('breakpointChange', 'desktopExit');
            }

            // Enter new layout
            if (breakpoint === window.dtnGlobals.breakpointType.MOBILE) {
                Util.broadcast('breakpointChange', 'mobileEnter');
            } else if (breakpoint === window.dtnGlobals.breakpointType.DESKTOP) {
                Util.broadcast('breakpointChange', 'desktopEnter');
            }
        }

        this.currentBreakpoint = breakpoint;
        STATE.CURRENT_BREAKPOINT = this.currentBreakpoint; // Set global variable
    };

    /**
     * On orientation change handler.
     *
     * Handles change of orientation on mobile devices.
     *
     * @method onOrientationChange
     * @param {Event} e JS Event object.
     */
    BreakpointListener.prototype.onOrientationChange = function (e) {
        var orientation = this.getOrientation();

        if (orientation !== this.currentOrientation) {
            // Exit previous orientation
            if (this.currentOrientation === window.dtnGlobals.orientationType.PORTRAIT) {
                Util.broadcast('breakpointChange', 'portraitExit');
            } else if (this.currentOrientation === window.dtnGlobals.orientationType.LANDSCAPE) {
                Util.broadcast('breakpointChange', 'landscapeExit');
            }

            // Enter new orientation
            if (orientation === window.dtnGlobals.orientationType.PORTRAIT) {
                Util.broadcast('breakpointChange', 'portraitEnter');
            } else if (orientation === window.dtnGlobals.orientationType.LANDSCAPE) {
                Util.broadcast('breakpointChange', 'landscapeEnter');
            }
        }

        this.currentOrientation = orientation;
        STATE.CURRENT_ORIENTATION = this.currentOrientation; // Set global variable

        this.updateWrapperClass();
        this.onResize();

        window.setTimeout(this.setViewport.bind(this), 10);
    };

    /**
     * Add appropriate classes to wrapper depending on browser feature support.
     *
     * @method updateWrapperClass
     */
    BreakpointListener.prototype.updateWrapperClass = function (e) {
        var $body = $(document.body);

        if (this.currentOrientation === window.dtnGlobals.orientationType.PORTRAIT) {
            $body.removeClass('orientationLandscape');
            $body.addClass('orientationPortrait');
        } else {
            $body.removeClass('orientationPortrait');
            $body.addClass('orientationLandscape');
        }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Viewport Helpers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Set the viewport.
     *
     * @method setViewport
     * @param {Event} e
     */
    BreakpointListener.prototype.setViewport = function (e) {
        if (STATE.CURRENT_BREAKPOINT === window.dtnGlobals.breakpointType.DESKTOP) {
            this.setViewportDesktop();
        } else {
            this.setViewportMobile();
        }
        Util.broadcast('breakpointChange', 'viewportChange');

        $(window).trigger('resize');
    };

    /**
     * Set the desktop viewport.
     *
     * @method setViewportDesktop
     */
    BreakpointListener.prototype.setViewportDesktop = function () {
        var width = window.dtnGlobals.maxDesktopWidth;
        var viewportString = 'width=' + width;

        this.appendViewportTag(viewportString);
    };

    /**
     * Set the mobile viewport.
     *
     * @method setViewportMobile
     */
    BreakpointListener.prototype.setViewportMobile = function () {
        var width = 'device-width';

        var viewportString = '' +
            'width=' + width +
            ', user-scalable=yes';

        this.appendViewportTag(viewportString);
    };

    /**
     * Append the viewport tag.
     *
     * @method appendViewportTag
     * @param {string} viewportString
     */
    BreakpointListener.prototype.appendViewportTag = function (viewportString) {
        // Only update this if something has changed!
        if (viewportString !== this.viewportString) {
            var viewportTagString = '<meta name="viewport" content="' + viewportString + '">';
            var $oldViewport = $('meta[name=viewport]');
            $oldViewport.replaceWith(viewportTagString);
        }

        this.viewportString = viewportString;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Breakpoint Helpers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Returns the current appropriate orientation type based on orientation.
     *
     * @method getOrientation
     * @return {window.dtnGlobals.orientationType} Detected orientation type.
     */
    BreakpointListener.prototype.getOrientation = function () {
        var orientation;

        if (window.orientation === 90 || window.orientation === -90) {
            orientation = window.dtnGlobals.orientationType.LANDSCAPE;
        } else if (window.orientation == null) { // This catches desktop with no orientation defined
            orientation = window.dtnGlobals.orientationType.NONE;
        } else { // this catches orientation === 0 || orientation === 180
            orientation = window.dtnGlobals.orientationType.PORTRAIT;
        }
        return orientation;
    };

    /**
     * Returns the current appropriate breakpoint based on window dimensions.
     *
     * @method getBreakpoint
     * @return {window.dtnGlobals.breakpointType} Detected breakpoint type.
     */
    BreakpointListener.prototype.getBreakpoint = function () {
        var breakpoint;

        if (this.forceBreakpoint != null) {
            breakpoint = this.forceBreakpoint;
        } else {
            // Determine whether the new width has resulted in a different layout from previous layout
            var windowWidth = this.getWindowWidth();
            breakpoint = (windowWidth <= window.dtnGlobals.maxMobileWidth ?
                window.dtnGlobals.breakpointType.MOBILE : window.dtnGlobals.breakpointType.DESKTOP);
        }
        return breakpoint;
    };

    /**
     * Returns the current width of the browser window.
     *
     * Note: manually computing this due to jQuery's broken $(window).width().
     *
     * @method getWindowWidth
     * @return {integer} Width of browser window, in pixels.
     */
    BreakpointListener.prototype.getWindowWidth = function () {
        var width = null;

        var isFirefox = this.browserDetect.browser.firefox;
        var isNewIE = this.browserDetect.browser.ie && this.browserDetect.browser.ieVersion >= 9;

        var useInnerWidth = (isFirefox || isNewIE) ? true : false;

        if (useInnerWidth) {
            // innerWidth delivers the most accurate measurement in Firefox, IE9+
            width = window.innerWidth ||
                document.body.clientWidth ||
                document.documentElement.clientWidth ||
                document.body.offsetWidth;
        } else {
            // clientWidth delivers the most accurate measurement in Chrome, Safari, IE8-
            width = document.body.clientWidth ||
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.offsetWidth;
        }

        return width;
    };

    return BreakpointListener;
});

define('shared-scripts/lib-thirdparty/mout/array/indexOf',[],function () {

    /**
     * Array.indexOf
     */
    function indexOf(arr, item, fromIndex) {
        fromIndex = fromIndex || 0;
        if (arr == null) {
            return -1;
        }

        var len = arr.length,
            i = fromIndex < 0 ? len + fromIndex : fromIndex;
        while (i < len) {
            // we iterate over sparse items since there is no way to make it
            // work properly on IE 7-8. see #64
            if (arr[i] === item) {
                return i;
            }

            i++;
        }

        return -1;
    }

    return indexOf;
});

define('shared-scripts/lib-thirdparty/mout/array/contains',['./indexOf'], function (indexOf) {

    /**
     * If array contains values.
     */
    function contains(arr, val) {
        return indexOf(arr, val) !== -1;
    }
    return contains;
});

define('shared-scripts/lib-thirdparty/mout/string/typecast',[],function () {

    var UNDEF;

    /**
     * Parses string and convert it into a native value.
     */
    function typecast(val) {
        var r;
        if ( val === null || val === 'null' ) {
            r = null;
        } else if ( val === 'true' ) {
            r = true;
        } else if ( val === 'false' ) {
            r = false;
        } else if ( val === UNDEF || val === 'undefined' ) {
            r = UNDEF;
        } else if ( val === '' || isNaN(val) ) {
            //isNaN('') returns false
            r = val;
        } else {
            //parseFloat(null || '') returns NaN
            r = parseFloat(val);
        }
        return r;
    }

    return typecast;
});

define('shared-scripts/lib-thirdparty/mout/queryString/getQuery',[],function () {

    /**
     * Gets full query as string with all special chars decoded.
     */
    function getQuery(url) {
        url = url.replace(/#.*/, ''); //removes hash (to avoid getting hash query)
        var queryString = /\?[a-zA-Z0-9\=\&\%\$\-\_\.\+\!\*\'\(\)\,]+/.exec(url); //valid chars according to: http://www.ietf.org/rfc/rfc1738.txt
        return (queryString)? decodeURIComponent(queryString[0]) : '';
    }

    return getQuery;
});

define('shared-scripts/lib-thirdparty/mout/queryString/getParam',['../string/typecast', './getQuery'], function (typecast, getQuery) {

    /**
     * Get query parameter value.
     */
    function getParam(url, param, shouldTypecast){
        var regexp = new RegExp('(\\?|&)'+ param + '=([^&]*)'), //matches `?param=value` or `&param=value`, value = $2
            result = regexp.exec( getQuery(url) ),
            val = (result && result[2])? result[2] : null;
        return shouldTypecast === false? val : typecast(val);
    }

    return getParam;
});

define('shared-scripts/lib-thirdparty/mout/lang/toString',[],function () {

    /**
     * Typecast a value to a String, using an empty string value for null or
     * undefined.
     */
    function toString(val){
        return val == null ? '' : val.toString();
    }

    return toString;

});

define('shared-scripts/lib-thirdparty/mout/string/replaceAccents',['../lang/toString'], function(toString){
    /**
    * Replaces all accented chars with regular ones
    */
    function replaceAccents(str){
        str = toString(str);

        // verifies if the String has accents and replace them
        if (str.search(/[\xC0-\xFF]/g) > -1) {
            str = str
                    .replace(/[\xC0-\xC5]/g, "A")
                    .replace(/[\xC6]/g, "AE")
                    .replace(/[\xC7]/g, "C")
                    .replace(/[\xC8-\xCB]/g, "E")
                    .replace(/[\xCC-\xCF]/g, "I")
                    .replace(/[\xD0]/g, "D")
                    .replace(/[\xD1]/g, "N")
                    .replace(/[\xD2-\xD6\xD8]/g, "O")
                    .replace(/[\xD9-\xDC]/g, "U")
                    .replace(/[\xDD]/g, "Y")
                    .replace(/[\xDE]/g, "P")
                    .replace(/[\xE0-\xE5]/g, "a")
                    .replace(/[\xE6]/g, "ae")
                    .replace(/[\xE7]/g, "c")
                    .replace(/[\xE8-\xEB]/g, "e")
                    .replace(/[\xEC-\xEF]/g, "i")
                    .replace(/[\xF1]/g, "n")
                    .replace(/[\xF2-\xF6\xF8]/g, "o")
                    .replace(/[\xF9-\xFC]/g, "u")
                    .replace(/[\xFE]/g, "p")
                    .replace(/[\xFD\xFF]/g, "y");
        }
        return str;
    }
    return replaceAccents;
});

define('shared-scripts/lib-thirdparty/mout/string/removeNonWord',['../lang/toString'], function(toString){
    /**
     * Remove non-word chars.
     */
    function removeNonWord(str){
        str = toString(str);
        return str.replace(/[^0-9a-zA-Z\xC0-\xFF \-_]/g, '');
    }

    return removeNonWord;
});

define('shared-scripts/lib-thirdparty/mout/string/WHITE_SPACES',[],function() {
    /**
     * Contains all Unicode white-spaces. Taken from
     * http://en.wikipedia.org/wiki/Whitespace_character.
     */
    return [
        ' ', '\n', '\r', '\t', '\f', '\v', '\u00A0', '\u1680', '\u180E',
        '\u2000', '\u2001', '\u2002', '\u2003', '\u2004', '\u2005', '\u2006',
        '\u2007', '\u2008', '\u2009', '\u200A', '\u2028', '\u2029', '\u202F',
        '\u205F', '\u3000'
    ];
});

define('shared-scripts/lib-thirdparty/mout/string/ltrim',['../lang/toString', './WHITE_SPACES'], function(toString, WHITE_SPACES){
    /**
     * Remove chars from beginning of string.
     */
    function ltrim(str, chars) {
        str = toString(str);
        chars = chars || WHITE_SPACES;

        var start = 0,
            len = str.length,
            charLen = chars.length,
            found = true,
            i, c;

        while (found && start < len) {
            found = false;
            i = -1;
            c = str.charAt(start);

            while (++i < charLen) {
                if (c === chars[i]) {
                    found = true;
                    start++;
                    break;
                }
            }
        }

        return (start >= len) ? '' : str.substr(start, len);
    }

    return ltrim;
});

define('shared-scripts/lib-thirdparty/mout/string/rtrim',['../lang/toString', './WHITE_SPACES'], function(toString, WHITE_SPACES){
    /**
     * Remove chars from end of string.
     */
    function rtrim(str, chars) {
        str = toString(str);
        chars = chars || WHITE_SPACES;

        var end = str.length - 1,
            charLen = chars.length,
            found = true,
            i, c;

        while (found && end >= 0) {
            found = false;
            i = -1;
            c = str.charAt(end);

            while (++i < charLen) {
                if (c === chars[i]) {
                    found = true;
                    end--;
                    break;
                }
            }
        }

        return (end >= 0) ? str.substring(0, end + 1) : '';
    }

    return rtrim;
});

define('shared-scripts/lib-thirdparty/mout/string/trim',['../lang/toString', './WHITE_SPACES', './ltrim', './rtrim'], function(toString, WHITE_SPACES, ltrim, rtrim){
    /**
     * Remove white-spaces from beginning and end of string.
     */
    function trim(str, chars) {
        str = toString(str);
        chars = chars || WHITE_SPACES;
        return ltrim(rtrim(str, chars), chars);
    }

    return trim;
});

define('shared-scripts/lib-thirdparty/mout/string/slugify',['../lang/toString', './replaceAccents', './removeNonWord', './trim'], function(toString, replaceAccents, removeNonWord, trim){
    /**
     * Convert to lower case, remove accents, remove non-word chars and
     * replace spaces with the specified delimeter.
     * Does not split camelCase text.
     */
    function slugify(str, delimeter){
        str = toString(str);

        if (delimeter == null) {
            delimeter = "-";
        }
        str = replaceAccents(str);
        str = removeNonWord(str);
        str = trim(str) //should come after removeNonWord
                .replace(/ +/g, delimeter) //replace spaces with delimeter
                .toLowerCase();
        return str;
    }
    return slugify;
});

define('shared-scripts/lib-thirdparty/mout/string/unCamelCase',['../lang/toString'], function(toString){

    var CAMEL_CASE_BORDER = /([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g;

    /**
     * Add space between camelCase text.
     */
    function unCamelCase(str, delimiter){
        if (delimiter == null) {
            delimiter = ' ';
        }

        function join(str, c1, c2) {
            return c1 + delimiter + c2;
        }

        str = toString(str);
        str = str.replace(CAMEL_CASE_BORDER, join);
        str = str.toLowerCase(); //add space between camelCase text
        return str;
    }
    return unCamelCase;
});

define('shared-scripts/lib-thirdparty/mout/string/hyphenate',['../lang/toString', './slugify', './unCamelCase'], function(toString, slugify, unCamelCase){
    /**
     * Replaces spaces with hyphens, split camelCase text, remove non-word chars, remove accents and convert to lower case.
     */
    function hyphenate(str){
        str = toString(str);
        str = unCamelCase(str);
        return slugify(str, "-");
    }

    return hyphenate;
});

define('shared-scripts/lib-thirdparty/mout/object/hasOwn',[],function () {

    /**
     * Safer Object.hasOwnProperty
     */
     function hasOwn(obj, prop){
         return Object.prototype.hasOwnProperty.call(obj, prop);
     }

     return hasOwn;

});

define('shared-scripts/lib-thirdparty/mout/lang/kindOf',[],function () {

    var _rKind = /^\[object (.*)\]$/,
        _toString = Object.prototype.toString,
        UNDEF;

    /**
     * Gets the "kind" of value. (e.g. "String", "Number", etc)
     */
    function kindOf(val) {
        if (val === null) {
            return 'Null';
        } else if (val === UNDEF) {
            return 'Undefined';
        } else {
            return _rKind.exec( _toString.call(val) )[1];
        }
    }
    return kindOf;
});

define('shared-scripts/lib-thirdparty/mout/lang/isPlainObject',[],function () {

    /**
     * Checks if the value is created by the `Object` constructor.
     */
    function isPlainObject(value) {
        return (!!value
            && typeof value === 'object'
            && value.constructor === Object);
    }

    return isPlainObject;

});

define('shared-scripts/lib-thirdparty/mout/object/forIn',[],function () {

    var _hasDontEnumBug,
        _dontEnums;

    function checkDontEnum(){
        _dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ];

        _hasDontEnumBug = true;

        for (var key in {'toString': null}) {
            _hasDontEnumBug = false;
        }
    }

    /**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */
    function forIn(obj, fn, thisObj){
        var key, i = 0;
        // no need to check if argument is a real object that way we can use
        // it for arrays, functions, date, etc.

        //post-pone check till needed
        if (_hasDontEnumBug == null) checkDontEnum();

        for (key in obj) {
            if (exec(fn, obj, key, thisObj) === false) {
                break;
            }
        }

        if (_hasDontEnumBug) {
            while (key = _dontEnums[i++]) {
                // since we aren't using hasOwn check we need to make sure the
                // property was overwritten
                if (obj[key] !== Object.prototype[key]) {
                    if (exec(fn, obj, key, thisObj) === false) {
                        break;
                    }
                }
            }
        }
    }

    function exec(fn, obj, key, thisObj){
        return fn.call(thisObj, obj[key], key, obj);
    }

    return forIn;

});

define('shared-scripts/lib-thirdparty/mout/object/forOwn',['./hasOwn', './forIn'], function (hasOwn, forIn) {

    /**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */
    function forOwn(obj, fn, thisObj){
        forIn(obj, function(val, key){
            if (hasOwn(obj, key)) {
                return fn.call(thisObj, obj[key], key, obj);
            }
        });
    }

    return forOwn;

});

define('shared-scripts/lib-thirdparty/mout/object/mixIn',['./forOwn'], function(forOwn){

    /**
    * Combine properties from all the objects into first one.
    * - This method affects target object in place, if you want to create a new Object pass an empty object as first param.
    * @param {object} target    Target Object
    * @param {...object} objects    Objects to be combined (0...n objects).
    * @return {object} Target Object.
    */
    function mixIn(target, objects){
        var i = 0,
            n = arguments.length,
            obj;
        while(++i < n){
            obj = arguments[i];
            if (obj != null) {
                forOwn(obj, copyProp, target);
            }
        }
        return target;
    }

    function copyProp(val, key){
        this[key] = val;
    }

    return mixIn;
});

define('shared-scripts/lib-thirdparty/mout/lang/clone',['./kindOf', './isPlainObject', '../object/mixIn'], function (kindOf, isPlainObject, mixIn) {

    /**
     * Clone native types.
     */
    function clone(val){
        switch (kindOf(val)) {
            case 'Object':
                return cloneObject(val);
            case 'Array':
                return cloneArray(val);
            case 'RegExp':
                return cloneRegExp(val);
            case 'Date':
                return cloneDate(val);
            default:
                return val;
        }
    }

    function cloneObject(source) {
        if (isPlainObject(source)) {
            return mixIn({}, source);
        } else {
            return source;
        }
    }

    function cloneRegExp(r) {
        var flags = '';
        flags += r.multiline ? 'm' : '';
        flags += r.global ? 'g' : '';
        flags += r.ignorecase ? 'i' : '';
        return new RegExp(r.source, flags);
    }

    function cloneDate(date) {
        return new Date(+date);
    }

    function cloneArray(arr) {
        return arr.slice();
    }

    return clone;

});

define('shared-scripts/lib-thirdparty/mout/lang/deepClone',['./clone', '../object/forOwn', './kindOf', './isPlainObject'], function (clone, forOwn, kindOf, isPlainObject) {

    /**
     * Recursively clone native types.
     */
    function deepClone(val, instanceClone) {
        switch ( kindOf(val) ) {
            case 'Object':
                return cloneObject(val, instanceClone);
            case 'Array':
                return cloneArray(val, instanceClone);
            default:
                return clone(val);
        }
    }

    function cloneObject(source, instanceClone) {
        if (isPlainObject(source)) {
            var out = {};
            forOwn(source, function(val, key) {
                this[key] = deepClone(val, instanceClone);
            }, out);
            return out;
        } else if (instanceClone) {
            return instanceClone(source);
        } else {
            return source;
        }
    }

    function cloneArray(arr, instanceClone) {
        var out = [],
            i = -1,
            n = arr.length,
            val;
        while (++i < n) {
            out[i] = deepClone(arr[i], instanceClone);
        }
        return out;
    }

    return deepClone;

});


define('shared-scripts/lib-thirdparty/mout/lang/isKind',['./kindOf'], function (kindOf) {
    /**
     * Check if value is from a specific "kind".
     */
    function isKind(val, kind){
        return kindOf(val) === kind;
    }
    return isKind;
});

define('shared-scripts/lib-thirdparty/mout/lang/isObject',['./isKind'], function (isKind) {
    /**
     */
    function isObject(val) {
        return isKind(val, 'Object');
    }
    return isObject;
});

define('shared-scripts/lib-thirdparty/mout/object/merge',['./hasOwn', '../lang/deepClone', '../lang/isObject'], function (hasOwn, deepClone, isObject) {

    /**
     * Deep merge objects.
     */
    function merge() {
        var i = 1,
            key, val, obj, target;

        // make sure we don't modify source element and it's properties
        // objects are passed by reference
        target = deepClone( arguments[0] );

        while (obj = arguments[i++]) {
            for (key in obj) {
                if ( ! hasOwn(obj, key) ) {
                    continue;
                }

                val = obj[key];

                if ( isObject(val) && isObject(target[key]) ){
                    // inception, deep merge objects
                    target[key] = merge(target[key], val);
                } else {
                    // make sure arrays, regexp, date, objects are cloned
                    target[key] = deepClone(val);
                }

            }
        }

        return target;
    }

    return merge;

});

define('shared-scripts/lib-thirdparty/mout/string/startsWith',['../lang/toString'], function (toString) {
    /**
     * Checks if string starts with specified prefix.
     */
    function startsWith(str, prefix) {
        str = toString(str);
        prefix = toString(prefix);

        return str.indexOf(prefix) === 0;
    }

    return startsWith;
});

/*!
 * jQuery Cookie Plugin v1.3.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as anonymous module.
		define('shared-scripts/lib-thirdparty/jquery.cookie',['jquery'], factory);
	} else {
		// Browser globals.
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function raw(s) {
		return s;
	}

	function decoded(s) {
		return decodeURIComponent(s.replace(pluses, ' '));
	}

	function converted(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}
		try {
			return config.json ? JSON.parse(s) : s;
		} catch(er) {}
	}

	var config = $.cookie = function (key, value, options) {

		// write
		if (value !== undefined) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setDate(t.getDate() + days);
			}

			value = config.json ? JSON.stringify(value) : String(value);

			return (document.cookie = [
				config.raw ? key : encodeURIComponent(key),
				'=',
				config.raw ? value : encodeURIComponent(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// read
		var decode = config.raw ? raw : decoded;
		var cookies = document.cookie.split('; ');
		var result = key ? undefined : {};
		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = decode(parts.join('='));

			if (key && key === name) {
				result = converted(cookie);
				break;
			}

			if (!key) {
				result[name] = converted(cookie);
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) !== undefined) {
			// Must not alter options, thus extending a fresh object...
			$.cookie(key, '', $.extend({}, options, { expires: -1 }));
			return true;
		}
		return false;
	};

}));

/**
 * @author kevinm
 * @file Util module definition
 */
define('shared-scripts/lib/Util',['require','jquery','knockout','../lib-thirdparty/jquery.cookie'],function (require) {
    

    var $ = require('jquery');
    var ko = require('knockout');
    require('../lib-thirdparty/jquery.cookie');

    var disabledClass = 'isDisabled';

    /**
     * Static utility class containing common functions.
     *
     * @class Util
     * @constructor
     */
    var Util = {};

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // AJAX functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Fetches JSON data from a given URL.
     *
     * @method getJSON
     * @param {string} url URL of the JSON to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.getJSON = function (url, params) {
        return this._ajax('json', url, params, false);
    };

    /**
     * Fetches HTML data from a given URL.
     *
     * @method getHTML
     * @param {string} url URL of the HTML to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.getHTML = function (url, params) {
        if (typeof url === 'undefined' || url === null || url === '') {
            console.warn("provided url is blank, this will cause entire page to be retrieved!");
        }
        return this._ajax('html', url, params, false);
    };

    /**
     * Fetches HTML data from a given URL.
     *
     * @method postHTML
     * @param {string} url URL of the HTML to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.postHTML = function (url, params) {
        return this._ajax('html', url, params, true);
    };

    /**
     * Fetches XML data from a given URL.
     *
     * @method getXML
     * @param {string} url URL of the XML to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.getXML = function (url, params) {
        return this._ajax('xml', url, params, false);
    };

    /**
     * Fetches data from a given URL (data type detected via intelligent guess).
     *
     * @method get
     * @param {string} url URL of the data to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.get = function (url, params) {
        return this._ajax(null, url, params, false);
    };

    /**
     * Fetches data from a given URL (data type detected via intelligent guess).
     *
     * @method post
     * @param {string} url URL of the data to fetch.
     * @param {object} params Name/value pairs of data to attach to query string in the form {name: value}.
     * @return {jqXHR}
     */
    Util.post = function (url, params) {
        return this._ajax(null, url, params, true);
    };

    /**
     * Fetch data from a given URL.
     *
     * @method _ajax
     * @param {string} dataType
     * @param {string} url
     * @param {object} params
     * @param {string} post
     * @private
     * @return {jqXHR}
     */
    Util._ajax = function (dataType, url, params, post) {
        if (params == null) {
            params = {};
        }

        var type = 'GET';
        if (post === true) {
            type = 'POST';
        }

        // Append versioning, cache buster, etc. to query string
        $.extend(params, Util.getVersionParams(true));

        var result = $.ajax({
            url: url,
            data: params,
            dataType: dataType,
            type: type
        });

        result
            .done(this._onAjaxDone.bind(this))
            .fail(this._onAjaxFail.bind(this));

        return result;
    };

    /**
     * On AJAX done handler.
     *
     * @method _onAjaxDone
     * @param {string} reponse
     * @private
     */
    Util._onAjaxDone = function (response, status, jqHXR) {
        // Detect session expiration

        // Scan whether user has been redirected to login page.
        // This is indicated by the presense of the class `js-loginBox`
        var isLoginPage = false;
        var isExceededPage = false;

        // Just checking the raw string here rather than a jQuery selector for better performance
        if (response != null && typeof response === 'string' && response.length > 0) {
            isLoginPage = response.indexOf('js-loginBox') >= 0;
            isExceededPage = response.indexOf('js-sessionTerminated') > 0;
        }

        if (isLoginPage) {
            this.displayTimeoutModal('timeout');
        } else if (isExceededPage) {
            this.displayTimeoutModal('exceeded');
        }
    };

    /**
     * On AJAX fail handler.
     *
     * @method _onAjaxFail
     * @param {jqXHR} jqXHR
     * @param {string} textStatus
     * @param {string} errorThrown
     * @private
     */
    Util._onAjaxFail = function (jqXHR, textStatus, errorThrown) {
        // Detect session expiration

        // If response is 403/Forbidden
        var isForbidden = (errorThrown === 'Forbidden');

        if (isForbidden) {
            this.displayTimeoutModal('timeout');
        }
    };

    /**
     * Timeout modal displayed.
     *
     * @default false
     * @property timeoutModalDisplayed
     * @type {boolean}
     */
    Util.timeoutModalDisplayed = false;

    /**
     * Display timeout modal.
     *
     * @event open
     * @method displayTimeoutModal
     */
    Util.displayTimeoutModal = function (type) {
        if (type == null) {
            type = 'timeout';
        }

        // Open session timeout modal
        // Only displays this one time, not if it's already been opened before
        if (!this.timeoutModalDisplayed) {
            this.timeoutModalDisplayed = true;

            var modalSelector = '#modal-' + type; // eg, #modal-timeout or modal-exceeded

            $(document.body).trigger('open', [modalSelector]);
        }
    };

    /**
     * Returns an object containing URL query parameters for asset versioning purposes.
     *
     * Return object is in the form { v: 1.0, cb: 0.142414 }, which is
     * suitable for translation into a set of query params in the form ?v=1.0&cb=0.142414.
     *
     * @method getVersionParams
     * @param {boolean} bustCache True to append cache-buster parameter, false to omit.
     * @return {object} Object in the form { v: 1.0, cb: 0.142414 }.
     */
    Util.getVersionParams = function (bustCache) {
        var params = {};

        params.v = window.dtnGlobals.assetVersionNumber;

        if (bustCache) {
            params.cb = Math.random(); // generate a different cache buster for each request
        }

        return params;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // DOM & CSS functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Get the name of the portlet a given element resides in
     */
    Util.getPortletName = function ($element) {
        var $elementToParse = null;

        if ($element.hasClass('portlet-boundary')) {
            $elementToParse = $element;
        } else {
            $elementToParse = $element.parents('.portlet-boundary');
        }

        return $elementToParse.attr('id').split('_')[3];
    };

    /**
     * Prevents browser's default behaviors for a given event.
     *
     * @method preventDefault
     * @param {Event} e js event object
     * @return {boolean}
     */
    Util.preventDefault = function (e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
        return false;
    };

    /**
     * Searches for a DOM element positioned at the given (x, y) screen coordinate.
     *
     * @method elementFromCoordinate
     * @param {float} x X-coordinate relative to the screen.
     * @param {float} y Y-coordinate relative to the screen.
     * @param {string} testSelector jQuery selector which will test positively against the element searching for.
     * @return {jQuery} The element matching the given (x, y) coordinate. Returns empty jQuery object if no match found.
     */
    Util.elementFromCoordinate = function (x, y, testSelector) {
        // Adjust coordinates appropriately according to scrollbar position
        var documentX = x - window.scrollX;
        var documentY = y - window.scrollY;

        var $element = $(document.elementFromPoint(documentX, documentY));

        var $matchingElement = null;
        if ($element.is(testSelector)) {
            $matchingElement = $element;
        } else {
            $matchingElement = $element.closest(testSelector);
        }

        return $matchingElement;
    };

    /**
     * Disable or enable the given select element(s).
     *
     * @method setSelectDisabled
     * @param {boolean} categorySelectDisabled True to disable, false to enable.
     * @param {jQuery} $select A jQuery object containing the select(s) to disable or enable.
     */
    Util.setSelectDisabled = function (categorySelectDisabled, $select) {
        $select.prop('disabled', categorySelectDisabled);
        if (categorySelectDisabled) {
            $select.addClass(disabledClass);
        } else {
            $select.removeClass(disabledClass);
        }
    };

    /**
     * Disable or enable the given checkbox(es) and label(s).
     *
     * @method setCheckboxDisabled
     * @param {boolean} dayPitDisabled True to disable, false to enable.
     * @param {boolean} uncheckIfDisabled If this value and dayPitDisabled are both false, uncheck the checkbox(es).
     * @param {jQuery} $checkbox A jQuery object containing the checkbox(es) to disable or enable.
     * @param {jQuery} $label A jQuery object containing the label(s) to disable or enable.
     */
    Util.setCheckboxDisabled = function (dayPitDisabled, uncheckIfDisabled, $checkbox, $label) {
        $checkbox.prop('disabled', dayPitDisabled);
        if (dayPitDisabled) {
            if (uncheckIfDisabled) {
                $checkbox.prop('checked', false);
            }
            if ($label !== null) {
                $label.addClass(disabledClass);
            }
        } else {
            if ($label !== null) {
                $label.removeClass(disabledClass);
            }
        }
    };

    /**
     * Escapes html in the given string
     *
     * @method escapeHtml
     * @param {string} string String to escape
     */
    Util.escapeHtml = function (string) {
        var entityMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
        };

        return String(string).replace(/[&<>"'\/]/g, function (s) {
            return entityMap[s];
        });
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Bootstrap functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Determines whether a DOM element has been initialized with a particular component.
     *
     * @method isInitialized
     * @param {jQuery} $element DOM element to mark as initialized.
     * @param {string} id Unique identifier of the component.
     * @return {boolean} true If component is initialized.
     */
    Util.isInitialized = function ($element, id) {
        return $element.attr('data-' + id + '-initialized') === 'true';
    };

    /**
     * Marks a DOM element as being initialized with a particular component.
     *
     * @method setInitialized
     * @param {jQuery} $element DOM element to mark as initialized.
     * @param {string} id Unique identifier of the component.
     * @param {boolean} isInitialized True to set component as initialized, false to set component as uninitialized.
     */
    Util.setInitialized = function ($element, id, isInitialized) {
        $element.attr('data-' + id + '-initialized', isInitialized);
    };

    /**
     * Get the current breakpoint.
     *
     * @method getCurrentBreakpoint
     */
    Util.getCurrentBreakpoint = function () {
        return STATE.CURRENT_BREAKPOINT;
    };

    /**
     * Get the current orientation.
     *
     * @method getCurrentOrientation
     */
    Util.getCurrentOrientation = function () {
        return STATE.CURRENT_ORIENTATION;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Scroll functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Scrolls the vertical browser scrollbar such that the given element appears at the top of the page.
     *
     * @param {jQuery} $element Element to scroll to.
     * @param {integer} duration Duration of page scroll animation. Set to 0 for no animation.
     * @param {jQuery} $scrollContainer The container object with the scrollbar
     *     (optional, will use document scrollbar by default).
     * @return {$.Promise}
     */
    Util.scrollYToElement = function ($element, duration, $scrollContainer) {
        duration = duration == null ? 0 : duration;
        $scrollContainer = $scrollContainer == null ? $('body,html') : $scrollContainer;

        var y = null;
        if ($element != null && $element.length > 0 && $scrollContainer != null && $scrollContainer.length > 0) {
            y = Util.getY($element, false);
        }

        return Util.scrollToCoordinate(null, y, duration, $scrollContainer);
    };

    /**
     * Scrolls the horizontal browser scrollbar such that the given element appears at the left of the page.
     *
     * @method scrollXToElement
     * @param {jQuery} $element Element to scroll to.
     * @param {integer} duration Duration of page scroll animation. Set to 0 for no animation.
     * @param {jQuery} $scrollContainer The container object with the scrollbar
     *     (optional, will use document scrollbar by default).
     * @return {$.Promise}
     */
    Util.scrollXToElement = function ($element, duration, $scrollContainer) {
        duration = duration == null ? 0 : duration;
        $scrollContainer = $scrollContainer == null ? $('body,html') : $scrollContainer;

        var x = null;
        if ($element != null && $element.length > 0 && $scrollContainer != null && $scrollContainer.length > 0) {
            x = Util.getX($element, true);
        }

        return Util.scrollToCoordinate(x, null, duration, $scrollContainer);
    };

    /**
     * Scrolls the browser scrollbar to a given position.
     *
     * @method scrollToCoordinate
     * @param {int} x Absolute x-position of the page to set the vertical scrollbar, in pixels.
     * @param {int} y Absolute y-position of the page to set the horizontal scrollbar, in pixels.
     * @param {int} duration Duration of page scroll animation. Set to 0 for no animation.
     * @param {jQuery} $scrollContainer The container object with the scrollbar
     *     (optional, will use document scrollbar by default).
     * @return {$.Promise} deferred promise object
     */
    Util.scrollToCoordinate = function (x, y, duration, $scrollContainer) {
        var deferred = $.Deferred();

        duration = duration == null ? 0 : duration;
        $scrollContainer = $scrollContainer == null ? $('body,html') : $scrollContainer;
        if (x == null && y == null) {
            deferred.resolve();
        }

        if (duration === 0) {
            if (x != null) {
                $scrollContainer.scrollLeft(x);
            }
            if (y != null) {
                $scrollContainer.scrollTop(y);
            }

            deferred.resolve();
        } else {
            var propsToAnimate = {};
            if (x != null) {
                propsToAnimate.scrollLeft = x;
            }
            if (y != null) {
                propsToAnimate.scrollTop = y;
            }

            $scrollContainer
                .stop(true, true)
                .animate(
                propsToAnimate,
                {
                    queue: false,
                    duration: duration,
                    complete: function () {
                        deferred.resolve();
                    }
                }
            );
        }

        return deferred.promise();
    };


    /**
     * Gets the x-coordinate of the given DOM element either absolutely or relative to its parent.
     *
     * @method getX
     * @param {jQuery} $element Element to find position of.
     * @param {bool} isRelative True to calculate relative position, false for absolute position.
     * @return {float} X-coordinate of element, in pixels.
     */
    Util.getX = function ($element, isRelative) {
        if (isRelative) {
            return $element.position().left;
        } else {
            return $element.offset().left;
        }
    };

    /**
     * Gets the y-coordinate of the given DOM element either absolutely or relative to its parent.
     *
     * @method getY
     * @param {jQuery} $element Element to find position of.
     * @param {bool} isRelative True to calculate relative position, false for absolute position.
     * @return {float} Y-coordinate of element, in pixels.
     */
    Util.getY = function ($element, isRelative) {
        if (isRelative) {
            return $element.position().top;
        } else {
            return $element.offset().top;
        }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Query string functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Converts a query string to an object containing name/value pairs.
     *
     * @method convertToNameValuePairs
     * @param {string}
     *            url The full url to extract query parameters from, in the form
     *            ?name1=value1&name2=value2.
     * @return {object} Object in the form { name1:value1, name2:value2 }.
     */
    Util.convertToNameValuePairs = function (url) {
        var nameValuePairs = {};
        if (typeof url === 'string') {
            url = url.split('#')[0]; // first remove hash if present
            var index = url.indexOf('?');
            if (index >= 0) {
                var queryString = url.slice(index + 1);
                nameValuePairs = Util.parseQueryString(queryString);
            }
        }
        return nameValuePairs;
    };

    Util.parseQueryString = function (queryString) {
        var nameValuePairs = {};
        if (queryString != null) {
            var queryStringParts = queryString.split('&');

            for (var i = 0; i < queryStringParts.length; i++) {
                var nameValue = queryStringParts[i].split('=');
                if (nameValue.length <= 1) {
                    continue;
                }

                var name = nameValue[0];
                if (name === '') {
                    continue;
                }

                var value = nameValue[1];
                nameValuePairs[name] = value;
            }
        }

        return nameValuePairs;
    };

    /**
     * Converts an object containing name/value pairs to a query string.
     *
     * @method convertToQueryString
     * @param {object} nameValuePairs Object in the form { name1:value1, name2:value2 }.
     * @return {string} The full url to extract query parameters from, in the form ?name1=value1&name2=value2.
     */
    Util.convertToQueryString = function (nameValuePairs) {
        var queryString = [];

        for (var name in nameValuePairs) {
            if (nameValuePairs.hasOwnProperty(name)) {
                var value = nameValuePairs[name];
                queryString.push(name + '=' + value);
            }
        }
        return queryString.join('&');
    };

    /**
     * Returns the value of a named query parameter.
     *
     * @method getQueryValue
     * @param {string} name Key of the query param to get.
     * @param {string} url The full url to search for query parameters, in the form ?name1=value1&name2=value2.
     * @return {string} Value of the query param for the given key. Returns null if no match was found.
     */
    Util.getQueryValue = function (name, url) {
        if (url == null) {
            url = window.location.href;
        }
        // eliminate hash to prevent query value corruption
        url = url.split('#')[0];

        var nameValuePairs = Util.convertToNameValuePairs(url);
        var value = nameValuePairs[name]; // Assumes all names have already been converted lower case
        if (value != null) {
            value = decodeURIComponent(value);
        }
        return value;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Client storage functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Retrieves a value that had been stored on the client.
     *
     * @method getStoredValue
     * @param {string} key Key of the value to retrieve.
     * @return {string} Value of the supplied key. Returns `null` if key is not found.
     */
    Util.getStoredValue = function (key) {
        return $.cookie(key);
    };

    /**
     * Sets a value for storage on the client.
     *
     * @method setStoredValue
     * @param {string} key Key of the value to set.
     * @param {string} value Value to set.
     * @param {int} expireDays (optional) Number of days after which the stored value will expire.
     */
    Util.setStoredValue = function (key, value, expireDays) {
        if (expireDays != null) {
            // path: '/' needed so that cookie will apply to entire site
            $.cookie(key, value, { expires: expireDays, path: '/' });
        } else {
            $.cookie(key, value, { path: '/' });
        }
    };

    /**
     * Builds a paging url.
     *
     * @method buildURL
     * @param {string} url The base url of the requests.
     * @param {Object} data The object containing the parameters of the request.
     * @return {string}
     */
    Util.buildUrl = function (url, data) {
        var params = [];
        for (var d in data) {
            if (data.hasOwnProperty(d)) {
                params.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            }
        }
        return url + params.join('&');
    };

    /**
     * Creates an array from the given delimited string. ',' delimiter assumed unless otherwise specified.
     *
     * @method arrayFromDelimitedString
     * @param {string} string The string to tranform into Array.
     * @param {string} delimiter Optional deliminter to use, will use ',' if not supplied
     * @return {array}
     */
    Util.arrayFromDelimitedString = function (string, delimiter) {
        if (delimiter == null) {
            delimiter = ',';
        }
        var array = [];
        if (string != null && string.length > 0) {
            array = string.split(delimiter);
        }
        return array;
    };

    /**
     * Creates a hash map from the given array. Keys are elements in the array, values are always `true`
     *
     * @method hashFromArray
     * @param {array} array Array to transform into hash
     * @return {object}
     */
    Util.hashFromArray = function (array) {
        var hash = {};
        for (var i = 0; i < array.length; i++) {
            var value = array[i];
            hash[value] = true;
        }
        return hash;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Pub/sub methods
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Subscribes to the given channel
     * Encapsulated here so that we could swap out pub/sub implementation if need be
     *
     * @method subscribe
     * @param {string} channelName Name of channel to subscribe to
     * @param {function} handlerFn Function to trigger upon receipt of broadcast
     * @param {Object} $eventElement Reference to object to apply event to
     * @param {boolean} oneExecution Execute each event only once
     */
    Util.subscribe = function (channelName, handlerFn, $eventElement, oneExecution) {
        if ($eventElement) {
            if (oneExecution) {
                $eventElement.one(channelName, handlerFn);
            } else {
                $eventElement.on(channelName, handlerFn);
            }
        } else {
            if (oneExecution) {
                $(window).one(channelName, handlerFn);
            } else {
                $(window).on(channelName, handlerFn);
            }
        }
    };

    /**
     * Unsubscribes to the given channel
     * Encapsulated here so that we could swap out pub/sub implementation if need be
     *
     * @method unsubscribe
     * @param {string} channelName Name of channel to unsubscribe from
     * @return {function} handlerFn Function to trigger upon receipt of broadcast
     * @param {Object} $eventElement Reference to object to remove the event from
     */
    Util.unsubscribe = function (channelName, handlerFn, $eventElement) {
        if ($eventElement) {
            $eventElement.off(channelName, handlerFn);
        } else {
            $(window).off(channelName, handlerFn);
        }
    };

    /**
     * Broadcasts to the given channel
     * Encapsulated here so that we could swap out pub/sub implementation if need be
     *
     * @method broadcast
     * @param {string} channelName Name of channel to broadcast to
     * @param {array} argumentArray An optional array of arguments to include with broadcast
     * @param {Object} $eventElement Reference to object to trigger event from
     */
    Util.broadcast = function (channelName, argumentArray, $eventElement) {
        if ($eventElement) {
            // triggerHandler used here to avoid event bubbling
            $eventElement.triggerHandler(channelName, argumentArray);
        } else {
            $(window).triggerHandler(channelName, argumentArray);
        }
    };

    /**
     * Triggers an event from a given object
     * Placeholder until components are converted to use esnext base component
     *
     * @method sendAction
     * @param {string} channelName Name of channel to broadcast to
     * @param {Object} $eventElement Reference to object to trigger event from
     */
    Util.sendAction = function (channelName, $eventElement) {
        $eventElement.trigger(channelName);
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Knockout Binding
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Applies data bindings to a DOM element.
     * This will save the current DOM structure as a template before binding.
     *
     * @param {string} id A unique string to identify the element. Used in creating a template.
     * @param {object} model The model to use for the bindings
     * @param {jQuery} $element JQuery element to apply bindings on
     * @method applyBindings
     */
    Util.applyBindings = function (id, model, $element) {
        // Check the knockout cage for an existing template. If one doesn't exist, clone the current element
        // and use as a template.
        var $koCage = $('.js-knockout-cage');
        if ($koCage.find('[data-template-for=' + id + ']').length === 0) {
            var $template = $element.clone();
            $template.attr('data-template-for', id);
            $koCage.append($template);
        }

        // Apply bindings with knockout. Knockout requires unboxing the JQuery element.
        ko.applyBindings(model, $element[0]);
    };

    /**
     * Will remove any data binding from a DOM element.
     * The DOM element must be the same element that was passed in to 'applyBindings'. It will be
     * replaced with the initial template.
     *
     * @param {string} id A unique string to identify the element. Used in identifying the template.
     * @param {jQuery} $element The JQuery element to remove bindings from. Will be replaced with a template.
     * @method removeBindings
     */
    Util.removeBindings = function (id, $element) {
        // Ask knockout to clean the element. This will leave behind any DOM modifications made by knockout.
        ko.cleanNode($element[0]);

        // Restore the element to the templated state, so that knockout can be applied again, if needed.
        var $template = $('.js-knockout-cage').find('[data-template-for=' + id + ']');
        if ($template.length > 0) {
            $element.replaceWith($template);
        } else {
            // Something went wrong and either the template was never saved, or it was lost somehow
            console.warn('Knockout template not found for: ' + id);
        }
    };

    return Util;
});

define('store-actions',['exports', 'module'], function (exports, module) {
    

    var breakpointListenerStore = ['didEnterMobile', 'didExitMobile', 'didEnterDesktop', 'didExitDesktop'];

    var sneezeGuardStore = ['didCloseSneezeGuard'];

    var mobileMenuStore = ['didCloseMobileMenu', 'didOpenMobileMenu'];

    var modalStore = ['openModal', 'closeModal', 'didCloseModal', 'didOpenModal'];

    var tabStore = ['openTab', 'didOpenTab'];

    var toggleStore = ['didOpenToggle', 'didCloseToggle'];

    var spinnerStore = ['didStartLoading', 'didStopLoading'];

    var postalCodeStore = ['notifyPostalChange', 'notifyRegistationPostalChange', 'notifyRegistationPostalInit'];

    var saveLocationFlyerStore = ['hideAllSaveLocationFlyers'];

    module.exports = [].concat(breakpointListenerStore, sneezeGuardStore, mobileMenuStore, modalStore, tabStore, toggleStore, spinnerStore, postalCodeStore, saveLocationFlyerStore);
});
define('components/Component',["exports", "module", "jquery", "shared-scripts/lib-thirdparty/mout/array/contains", "shared-scripts/lib-thirdparty/mout/queryString/getParam", "shared-scripts/lib-thirdparty/mout/string/hyphenate", "shared-scripts/lib-thirdparty/mout/object/merge", "shared-scripts/lib-thirdparty/mout/string/startsWith", "shared-scripts/lib/Util", "store-actions"], function (exports, module, _jquery, _sharedScriptsLibThirdpartyMoutArrayContains, _sharedScriptsLibThirdpartyMoutQueryStringGetParam, _sharedScriptsLibThirdpartyMoutStringHyphenate, _sharedScriptsLibThirdpartyMoutObjectMerge, _sharedScriptsLibThirdpartyMoutStringStartsWith, _sharedScriptsLibUtil, _storeActions) {
  /* eslint quotes: [2, "double"], semi: 0, indent: [2, 2], no-console: [0], no-multiple-empty-lines: [2, {max: 1}], lines-around-comment: [2] */

  

  var _$ = babelHelpers.interopRequireDefault(_jquery);

  var _contains = babelHelpers.interopRequireDefault(_sharedScriptsLibThirdpartyMoutArrayContains);

  var _getQueryStringParam = babelHelpers.interopRequireDefault(_sharedScriptsLibThirdpartyMoutQueryStringGetParam);

  var _hyphenate = babelHelpers.interopRequireDefault(_sharedScriptsLibThirdpartyMoutStringHyphenate);

  var _merge = babelHelpers.interopRequireDefault(_sharedScriptsLibThirdpartyMoutObjectMerge);

  var _startsWith = babelHelpers.interopRequireDefault(_sharedScriptsLibThirdpartyMoutStringStartsWith);

  var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

  var _storeActions2 = babelHelpers.interopRequireDefault(_storeActions);

  var actionRegistry = [];

  /**
   * @class Component
   *
   * @todo - `event` in the actions hook should be renamed to `action`
   */

  var Component = (function () {
    babelHelpers.createClass(Component, [{
      key: "isDebug",

      /**
       * Flag to determine if the component is in debug mode.
       *
       * Turning this on by either overriding this method in a
       * child class or adding `?debugMode=true` will enable helpfule
       * debuger logging information.
       *
       * @returns {boolean} If the component is in debug mode or not.
       */
      get: function get() {
        return (0, _getQueryStringParam["default"])(window.location.href, "debugMode");
      }

      /**
       * Specify configuration defaults.
       *
       * This object will be merged with [data-config-*] attributes from the
       * components $element. The $elements property takes precedence, allowing
       * these defaults to be overriden on an instance-by-instance basis. They are
       * accessible via the `config` property. DO NOT access from `defaults` directly.
       *
       * @example
       *   {
       *     animationSpeed: 200,
       *     easing: 'linear',
       *   }
       * @returns {object} Component's defaults
       */
    }, {
      key: "defaults",
      get: function get() {
        return {};
      }

      /**
       * Specify constants
       *
       * @example
       *   {
       *     FETCH_URL: 'https://........',
       *   }
       * @returns {object} Components constants
       */
    }, {
      key: "consts",
      get: function get() {
        return {};
      }

      /**
       *   event Optional
       *     - Event to listen for.
       *   delegate Optional
       *     - Selector to delegate event execution to.
       *   func Optional
       *     - Override default func name.
       *   prop Optional (required if selector is provided)
       *     - If the event is not associated with this.$element, provide a property name
       *       to assign the element to.
       *   selector Optional (required if prop is provided)
       *     - If prop is specified, a a selector must be provded to search this.$element for.
       *
       * @returns {array<object>}
       */
    }, {
      key: "elements",
      get: function get() {
        return [];
      }

      /**
       *   type Required "bubble" or "store"
       *   event Required
       *   func Optional
       *
       * @returns {array<object>}
       */
    }, {
      key: "actions",
      get: function get() {
        return [];
      }

      // Lifecycle methods ------------------------------------------------------

      /**
       * @constructor
       */
    }]);

    function Component($element, browserDetect, classId) {
      babelHelpers.classCallCheck(this, Component);

      if (this.id == null) {
        this.id = classId;
      }

      if (this.isInitialized || _Util["default"].isInitialized($element, this.id)) {
        return this;
      }

      _Util["default"].setInitialized($element, this.id, true);
      this.isInitialized = true;
      this.isEnabled = false; // has Component#enable been called already?
      this.isReady = false; // has Component#ready been called already?
      this.deferReady = true; // Defer calling Component#ready until all components have init'd

      this.$element = $element;

      this._managedDomCollection = [].concat(babelHelpers.toConsumableArray(this.elements), babelHelpers.toConsumableArray(this._pluckByTypeFromActions("bubble")));
      this._managedStoreCollection = this._cleanCollectionOfIgnored(this._pluckByTypeFromActions("store"));

      var config = this._mergeDefaultsWithDataConfig();
      this.config = Object.seal(config); // Prevent config from being added/ removed at runtime.

      this._setup();
    }

    /**
     * Determines if the passed argument is a valid jQuery wrapped DOM Element or not
     *
     * @param  {jQuery}  $suspect Value to test
     * @return {Boolean}          True if suspect is $(HTMLElement) false if not
     */
    babelHelpers.createClass(Component, [{
      key: "initProps",
      value: function initProps() {}

      /**
       * Augment managedDomCollection with $el keys.
       * Add corresponding property reference to component if applicable.
       *
       * Lifecycle hook to add properties to DOM dependencies to the component
       * which do not fit within the managed categories.
       */
    }, {
      key: "queryDom",
      value: function queryDom() {
        var _this = this;

        if (this.isDebug) {
          console.info(this.id + "#queryDom");
        }

        var $element = this.$element;

        var domRefsAdded = this._managedDomCollection.map(function (needsDomRef) {
          var prop = needsDomRef.prop;
          var selector = needsDomRef.selector;

          // If a selector is provided, need to query the dom to find the reference.
          if (selector) {
            if (!prop) {
              throw new Error("The selector " + selector + " failed to provide a corresponding property value.");
            }
            needsDomRef.$el = _this._safeDomQuery($element, selector);
            _this._assignProp(prop, needsDomRef.$el);

            if (_this.isDebug) {
              console.info("\"" + [prop] + "\" property added to " + _this.id);
            }
          } else {
            // Otherwise the collection is being normalized to use the component's own element.
            needsDomRef.$el = $element;
          }

          return needsDomRef;
        });

        this._managedDomCollection = domRefsAdded;
      }

      /**
       * Perform any DOM layout operations.
       */
    }, {
      key: "layout",
      value: function layout() {
        if (this.isDebug) {
          console.info(this.id + "#layout");
        }
      }

      /**
       * Augments managedDomCollection to include `namespacedEvent` and
       * `funcNameHandler` keys.
       *
       * Provides lifecycle hook to bind any event handlers that aren not
       * supported automatically.
       */
    }, {
      key: "bindEventHandlers",
      value: function bindEventHandlers() {
        var _this2 = this;

        if (this.isDebug) {
          console.info(this.id + "#bindEventHandlers");
        }

        var eventHandlersBound = this._managedDomCollection.map(function (needsHandler) {
          var event = needsHandler.event;
          var prop = needsHandler.prop;
          var func = needsHandler.func;

          if (!event) {
            if (func) {
              throw new Error("The custom handler \"" + func + "\" was provided, but no accompanying event was defined.");
            }

            // Ignore anything non-event based. Don't use .filter, because these
            // entries still need to be preserved in the managedDomCollection.
            return needsHandler;
          }

          var funcName = func ? func : Component.buildEventFuncName(event, prop); // If handler func already provided, use that
          var funcNameHandler = funcName + "Handler"; // onButtonClick -> onButtonClickHandler
          var namespacedEvent = event + "." + _this2.id; // click.FooComponent, pointermove.BarComponent

          if (_this2[funcName]) {
            _this2[funcNameHandler] = _this2[funcName].bind(_this2); // Bind event handler to the function
          } else {
              throw new Error(_this2.id + " - The method '" + funcName + "' could not be found");
            }

          if (_this2.isDebug) {
            console.info(funcName + " is bound to " + _this2.id);
          }

          needsHandler.namespacedEvent = namespacedEvent;
          needsHandler.funcNameHandler = funcNameHandler;

          return needsHandler;
        });

        var actionHandlersBound = this._managedStoreCollection.map(function (needsHandler) {
          var action = needsHandler.action;
          var func = needsHandler.func;

          var funcName = func ? func : Component.buildActionFuncName(action);
          var funcNameHandler = funcName + "Handler"; // onButtonClick -> onButtonClickHandler

          _this2[funcNameHandler] = _this2[funcName].bind(_this2); // Bind action handler to the function

          needsHandler.funcNameHandler = funcNameHandler;

          return needsHandler;
        });

        this._managedDomCollection = eventHandlersBound;
        this._managedStoreCollection = actionHandlersBound;
      }

      /**
       * Activate event listeners and pass control to corresponding handlers.
       *
       * Provides lifecycle hook to activate any event lsiteners that are not
       * supported automatically.
       */
    }, {
      key: "enable",
      value: function enable() {
        var _this3 = this;

        if (this.isDebug) {
          console.info(this.id + "#enable");
        }

        if (this.isEnabled) {
          return;
        }

        this._willEnable();

        this._managedDomCollection.filter(function (suspect) {
          return Boolean(suspect.event);
        }).forEach(function (needsEnable) {
          var $el = needsEnable.$el;
          var namespacedEvent = needsEnable.namespacedEvent;
          var funcNameHandler = needsEnable.funcNameHandler;
          var delegate = needsEnable.delegate;

          if (delegate) {
            $el.on(namespacedEvent, delegate, _this3[funcNameHandler]);
            if (_this3.isDebug) {
              console.info(namespacedEvent + " is enabled on " + $el[0].nodeName + "." + $el[0].classList + " and delegated to " + delegate);
            }
          } else {
            $el.on(namespacedEvent, _this3[funcNameHandler]);
            if (_this3.isDebug) {
              console.info(namespacedEvent + " is enabled on " + $el[0].nodeName + "." + $el[0].classList);
            }
          }
        });

        this._managedStoreCollection.forEach(function (needsEnable) {
          var action = needsEnable.action;
          var funcNameHandler = needsEnable.funcNameHandler;

          _Util["default"].subscribe(action, _this3[funcNameHandler]);
        });

        this.isEnabled = true;
      }
    }, {
      key: "ready",
      value: function ready() {
        if (this.isDebug) {
          console.info(this.id + "#ready");
        }

        if (this.isReady) {
          return;
        }
        this.isReady = true;
      }

      /**
       * Deactivate event listeners.
       *
       * Provides lifecycle hook to deactivate any event lsiteners that are not
       * supported automatically.
       */
    }, {
      key: "disable",
      value: function disable() {
        var _this4 = this;

        if (this.isDebug) {
          console.info(this.id + "#disable");
        }

        if (!this.isEnabled) {
          return;
        }

        this._willDisable();

        this._managedDomCollection.filter(function (suspect) {
          return Boolean(suspect.event);
        }).forEach(function (needsDisable) {
          var $el = needsDisable.$el;
          var namespacedEvent = needsDisable.namespacedEvent;
          var delegate = needsDisable.delegate;
          var funcNameHandler = needsDisable.funcNameHandler;

          if (delegate) {
            $el.off(namespacedEvent, delegate, _this4[funcNameHandler]);
          } else {
            $el.off(namespacedEvent, _this4[funcNameHandler]);
          }
        });

        this._managedStoreCollection.forEach(function (needsDisable) {
          var action = needsDisable.action;
          var funcNameHandler = needsDisable.funcNameHandler;

          _Util["default"].unsubscribe(action, _this4[funcNameHandler]);
        });

        this.isEnabled = false;
      }

      /**
       * Big question about what to do with this.
       */
    }, {
      key: "destroy",
      value: function destroy() {
        var _this5 = this;

        if (this.isDebug) {
          console.info(this.id + "#destroy");
        }

        this._willDisable();
        this.disable();

        _Util["default"].setInitialized(this.$element, this.id, false);

        Object.keys(this).forEach(function (key) {
          return _this5[key] = null;
        });
      }

      // Public API ---------------------------------------------------------------

      /**
       * Bubble a custom event up the DOM. Data is passed as an array of values.
       *
       * Do not send native DOM events (click, mouseover, etc) through this.
       */
    }, {
      key: "sendAction",
      value: function sendAction(actionName) {
        var data = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

        if (data.constructor !== Array) {
          throw new Error("Data sent through Component#sendAction needs to be an array of values");
        }

        if (!(0, _contains["default"])(actionRegistry, actionName) && !(0, _contains["default"])(_storeActions2["default"], actionName)) {
          actionRegistry.push(actionName);
          (0, _$["default"])(document.body).on(actionName, this._handleUnhandledAction.bind(this));
        }

        this.$element.parent().trigger(actionName, data);
      }

      // Static methods -----------------------------------------------------------

      /**
      * @param {string} event  Name of event.
      * @param {string} prop The property that event interaction is associated with.
      *                      If not passed, it's impled the action is bound to the
      *                      component's own $element (onClick vs onButtonClick).
      */
    }, {
      key: "_setup",
      // onMobileEnter

      // Private API --------------------------------------------------------------

      /**
       * Call lifecycle methods.
       */
      value: function _setup() {
        if (this.isDebug) {
          console.info(this.id + "#_setup");
        }

        this.initProps();
        this.queryDom();
        this.layout();
        this.bindEventHandlers();
        this.enable();
      }
    }, {
      key: "_willEnable",
      value: function _willEnable() {
        this.$element.on("destroy." + this.id, this.destroy.bind(this));
        this.$element.on("domTeardown." + this.id, _$["default"].noop); // jquery special event fired upon element destroy
      }
    }, {
      key: "_willDisable",
      value: function _willDisable() {
        this.$element.off("destroy." + this.id, this.destroy.bind(this));
        this.$element.off("domTeardown." + this.id, _$["default"].noop); // jquery special event fired upon element destroy
      }

      /**
       * Assign a property to class instances
       *
       * @param {String} key
       * @param {Any} prop
       */
    }, {
      key: "_assignProp",
      value: function _assignProp(key, prop) {
        if (typeof this[key] !== "undefined" && this.isDebug) {
          console.warn("A property with the key " + key + " already exists.");
        }
        this[key] = prop;
      }
    }, {
      key: "_safeDomQuery",
      value: function _safeDomQuery(root, selector) {
        var $found = root.find(selector);

        if (!isValidJqueryElement($found)) {
          throw new Error("Failed to find " + selector + " as a child of $element");
        }

        return $found;
      }
    }, {
      key: "_pluckByTypeFromActions",
      value: function _pluckByTypeFromActions(type) {
        return this.actions.filter(function (action) {
          return action.type === type;
        });
      }

      /**
       * Merge Compoent.defaults with data-config attributes on $element.
       *
       * @return {Object} The merged object
       */
    }, {
      key: "_mergeDefaultsWithDataConfig",
      value: function _mergeDefaultsWithDataConfig() {
        var config = (0, _merge["default"])(this.defaults, this._elementConfig);

        Object.keys(config).every(function (suspect) {
          if (config[suspect].required === true) {
            throw new Error("The config '" + suspect + "' is required to be defined by the element but was not found. " + ("Expected 'data-config-" + (0, _hyphenate["default"])(suspect) + "' to be present on this.$element."));
          }
        });

        return config;
      }

      /**
       * Takes a mangedCollection and returns only the events that are not present
       * in this._elementIgnoreActions
       *
       * @param  {Array} collection origin collection
       * @return {Array}            collection without ignored actions
       */
    }, {
      key: "_cleanCollectionOfIgnored",
      value: function _cleanCollectionOfIgnored(collection) {
        var ignoredActions = this._elementIgnoreActions;
        return collection.filter(function (suspect) {
          return !(0, _contains["default"])(ignoredActions, Component.deNamespaceEvent(suspect.action));
        });
      }
    }, {
      key: "_handleUnhandledAction",
      value: function _handleUnhandledAction(event) {
        var action = event.type; // event.type === action name
        console.warn("The action '" + action + "' was not properly handled by any component and bubbled to document.body.");
      }

      // Private properties -------------------------------------------------------

    }, {
      key: "_elementConfig",
      get: function get() {
        var dataAttr = this.$element.data();
        var elementsConfig = {};

        Object.keys(dataAttr).filter(function (suspect) {
          return (0, _startsWith["default"])(suspect, "config");
        }).forEach(function (dataConfig) {
          var normalized = dataConfig.replace("config", "");
          normalized = downcaseFirstLetter(normalized);
          elementsConfig[normalized] = dataAttr[dataConfig];
        });

        return elementsConfig;
      }
    }, {
      key: "_elementIgnoreActions",
      get: function get() {
        var dataAttr = this.$element.data();
        var elementsIgnoreActions = {};

        Object.keys(dataAttr).filter(function (suspect) {
          return (0, _startsWith["default"])(suspect, "ignore");
        }).forEach(function (dataConfig) {
          var normalized = dataConfig.replace("config", "");
          normalized = downcaseFirstLetter(normalized);
          elementsIgnoreActions[normalized] = dataAttr[dataConfig];
        });

        return elementsIgnoreActions.ignoreActions ? elementsIgnoreActions.ignoreActions.split(" ") : [];
      }
    }], [{
      key: "buildEventFuncName",
      value: function buildEventFuncName(event) {
        var prop = arguments.length <= 1 || arguments[1] === undefined ? "" : arguments[1];

        var cleanedProp = upcaseFirstLetter(prop.replace("$", "")); // $button -> Button
        var cleanedEvt = upcaseFirstLetter(event); // pointerdown -> Pointerdown
        return "on" + cleanedProp + cleanedEvt; // onButtonPointerdown
      }
    }, {
      key: "deNamespaceEvent",
      value: function deNamespaceEvent(namespacedEvent) {
        return namespacedEvent.split(".")[0]; // mobileEnter.BreakpointListenerComponent -> mobileEnter
      }

      /**
      * @param {action} event  Name of action with a namespace.
      */
    }, {
      key: "buildActionFuncName",
      value: function buildActionFuncName(action) {
        var namespaceless = Component.deNamespaceEvent(action);
        var cleanedAction = upcaseFirstLetter(namespaceless); // mobileEnter -> MobileEnter
        return "on" + cleanedAction;
      }
    }]);
    return Component;
  })();

  module.exports = Component;
  function isValidJqueryElement(suspect) {
    return suspect.length > 0 && suspect instanceof _$["default"] && suspect[0] instanceof HTMLElement;
  }

  /**
   * Utility function to take a string and return a copy of the string
   * with the first character upper-cased
   *
   * http://stackoverflow.com/a/1026087
   *
   * @param  {String} string
   * @return {String} string
   */
  function upcaseFirstLetter() {
    var string = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];

    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Utility function to take a string and return a copy of the string
   * with the first character down-cased
   *
   * @param  {String} string
   * @return {String} string
   */
  function downcaseFirstLetter() {
    var string = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];

    return string.charAt(0).toLowerCase() + string.slice(1);
  }
});
define('components/AccordionComponent',['exports', 'module', 'jquery', 'components/Component'], function (exports, module, _jquery, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var AccordionComponent = (function (_Component) {
        babelHelpers.inherits(AccordionComponent, _Component);

        function AccordionComponent() {
            babelHelpers.classCallCheck(this, AccordionComponent);
            babelHelpers.get(Object.getPrototypeOf(AccordionComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(AccordionComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(AccordionComponent.prototype), 'initProps', this).apply(this, arguments);
                this.contentCollection = this._buildContentCollection();
            }
        }, {
            key: 'onTriggerClick',
            value: function onTriggerClick(event) {
                var accordionId = (0, _$['default'])(event.currentTarget).attr(this.consts.DATA_ACCORDION_CONTENT);
                this.toggleAccordion(accordionId);
                return false;
            }
        }, {
            key: 'toggleAccordion',
            value: function toggleAccordion(accordionId) {
                if (this.contentCollection[accordionId]) {
                    var $accordionContainer = (0, _$['default'])(this.contentCollection[accordionId].element).parents('.js-accordion-item');
                    if (!$accordionContainer.hasClass(this.consts.IS_ACTIVE_CLASS)) {
                        $accordionContainer.addClass(this.consts.IS_ACTIVE_CLASS);
                    } else {
                        $accordionContainer.removeClass(this.consts.IS_ACTIVE_CLASS);
                    }
                }
            }
        }, {
            key: '_buildContentCollection',
            value: function _buildContentCollection() {
                var _this = this;

                var collection = {};
                _$['default'].makeArray(this.$content).forEach(function (element) {
                    var accordionId = (0, _$['default'])(element).attr(_this.consts.DATA_ACCORDION_CONTENT);
                    collection[accordionId] = { element: element };
                });
                return collection;
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    IS_ACTIVE_CLASS: 'isActive',
                    IS_HIDDEN_CLASS: 'isHidden',
                    DATA_ACCORDION_CONTENT: 'data-accordion-group',
                    ANIMATION_SPEED: 500
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$content', selector: '.js-accordion-item-content' }, { prop: '$trigger', selector: '.js-accordion-item-trigger', event: 'click' }];
            }
        }]);
        return AccordionComponent;
    })(_Component2['default']);

    module.exports = AccordionComponent;
});
define('compiledTemplates/templates',['require'],function (require) { this["templates"] = this["templates"] || {};
this["templates"]["feature"] = function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<div class=\"excerptLink-hd\">\n    <div class=\"ad_recommended_new feature-hbs box_grounded\">\n        <div class=\"media_wrap\">\n            <div class=\"ad_rec_top\">\n\n                <div class=\"text_size14 text_bold ad_rec_blue\">\n                    <div>Sponsored Content</div>\n                </div>\n                <div class=\"ad_rec_title\">\n                    <h4 class=\"ad_black_title hdg_bold hdg_link\">\n                        <a href=\"";
  if (stack1 = helpers.link) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.link); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\" class=\"excerptLink excerptLink-summary_truncate\">";
  if (stack1 = helpers.title) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.title); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "</a>\n                    </h4>\n                </div>\n                <div class=\"ad_rec_bottom\" style=\"display: flex;justify-content: space-evenly;\">\n                    <div>\n                        <a href=\"";
  if (stack1 = helpers.link) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.link); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\">\n                            <img src=\"";
  options = {hash:{
    'width': (120)
  },data:data};
  buffer += escapeExpression(((stack1 = helpers.getThumbHref || (depth0 && depth0.getThumbHref)),stack1 ? stack1.call(depth0, options) : helperMissing.call(depth0, "getThumbHref", options)))
    + "\" style=\"max-width: 120px;\">\n                        </a>\n                    </div>\n                    <div class=\"text_size13 ad_push_left_ten_px\">\n                        <div><a class=\"ad_gray\" href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.link)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"> From: "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a></div>\n                        <div><a href=\"";
  if (stack2 = helpers.link) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.link); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "\" class=\"ad_link_no_decoration excerptLink excerptLink-summary_truncate \">";
  if (stack2 = helpers.summary) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.summary); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</a></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div> <!-- ./excerptLink-bd -->\n\n\n\n\n\n\n";
  return buffer;
  };
this["templates"]["news-lg"] = function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div class=\"section section_accent section_shadow\">\n    <div class=\"section-hd\">\n        <div class=\"split split_stackSmall\">\n            <div class=\"split-chunk\">\n                <h2 class=\"hdg hdg_2 ad_rec_blue\">Sponsored Content</h2>\n            </div>\n        </div>\n    </div>\n    <div class=\"section-bd\">\n        <article>\n            <div class=\"media media_wrap\">\n                <div class=\"media-img\">\n                    <img src=\"";
  options = {hash:{
    'width': (120)
  },data:data};
  buffer += escapeExpression(((stack1 = helpers.getThumbHref || (depth0 && depth0.getThumbHref)),stack1 ? stack1.call(depth0, options) : helperMissing.call(depth0, "getThumbHref", options)))
    + "\"></div>\n                <div class=\"media-bd\">\n                    <div class=\"box box_veryTight\">\n                        <header class=\"media-bd-hdg\" role=\"heading\">\n                            <h3 class=\"hdg hdg_bold hdg_3 hdg_link ad_hovered\">\n                                <a href=\"";
  if (stack2 = helpers.link) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.link); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "\">";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.title); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</a>\n                            </h3>\n                            <span class=\"hdg mix-hdg_light ad_gray\">\n                             <a class=\"ad_gray\" href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.link)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n                            From: "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n                        </a> </span>\n                        </header>\n                    </div>\n                    <p>\n                        <span class=\"news_summary_content\"> ";
  if (stack2 = helpers.summary) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.summary); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</span>\n                    </p>\n                    <div class=\"text_right\">\n                        <a class=\"btn btn_primary\" href=\"";
  if (stack2 = helpers.link) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.link); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "\"><span class=\"text_size14\">Read more</span></a>\n                    </div>\n                </div>\n            </div>\n        </article>\n    </div>\n</div>\n";
  return buffer;
  };
this["templates"]["news"] = function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<li class=\"ad ad_native news-hbs\">\n    <article>\n    <div class=\"media media_wrap\">\n\n        <div class=\"media-img\">\n            <img class=\"ad_rec_sub_left ad_rec_news_image\" src=\"";
  options = {hash:{
    'width': (120)
  },data:data};
  buffer += escapeExpression(((stack1 = helpers.getThumbHref || (depth0 && depth0.getThumbHref)),stack1 ? stack1.call(depth0, options) : helperMissing.call(depth0, "getThumbHref", options)))
    + "\"/>\n        </div>\n        \n        <div class=\"media-bd\">\n            <header class=\"media-bd-hdg\" role=\"heading\">\n                <div class=\"box box_grounded\">\n                    <div class=\"split split_columnThenRow\">\n                        <div class=\"split-chunk split-chunk_left\">\n                            <div class=\"ad_hovered ad_rec_sponsored hdg hdg_bold hdg_4 ad_rec_blue\">Sponsored\n                                Content\n                            </div>                        </div>\n                        <div class=\"split-chunk split-chunk_leftThenRight\">\n                            <a class=\"ad_gray\" href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.link)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">From: "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"box box_grounded\">\n                    <h4 class=\"hdg hdg_bold hdg_3 hdg_link\">\n                        <a href=\"";
  if (stack2 = helpers.link) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.link); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "\" class=\"hdg_bold\" rel=\"nofollow\">";
  if (stack2 = helpers.title) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.title); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</a>\n                    </h4>\n                </div>\n            </header>\n            <p>";
  if (stack2 = helpers.summary) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.summary); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "</p>\n        </div>\n    </div>\n</article>\n</li>\n";
  return buffer;
  };
this["templates"]["standalone-lg"] = function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<div class=\"ad ad_native standalone-lg-hbs\">\n    <div class=\"box\">\n        <div class=\"section section_accent section_shadow\">\n            <div class=\"section-hd\">\n                <div class=\"ad_native-sponsored ad_native-sponsored_offsetLg\">Sponsored Content\n                </div>\n            </div>\n            <div class=\"section-bd\">\n                <div class=\"media\">\n                    <div class=\"media-bd\">\n                        <div class=\"box box_superTight\">\n                            <h4 class=\"hdg hdg_bold hdg_3 hdg_link\">\n                                <a href=\"";
  if (stack1 = helpers.link) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.link); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\" class=\"mix-hdg_green\">";
  if (stack1 = helpers.title) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.title); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "</a>\n                            </h4>\n                        </div>\n                        <p class=\"ad_black_title\">\n                            ";
  if (stack1 = helpers.summary) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.summary); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\n                        </p>\n                    </div>\n                    <div class=\"media-img\">\n                        <img src=\"";
  options = {hash:{
    'width': (120)
  },data:data};
  buffer += escapeExpression(((stack1 = helpers.getThumbHref || (depth0 && depth0.getThumbHref)),stack1 ? stack1.call(depth0, options) : helperMissing.call(depth0, "getThumbHref", options)))
    + "\"/>\n                    </div>\n                </div>\n            </div>\n            <div class=\"section-ft\">\n                <div class=\"text_right ad_native-ft ad_hovered\">\n                    <div class=\"split\">\n                        <div class=\"split-chunk split-chunk_end split-chunk_full\">\n                            <div class=\"ad_native-sponsorLogo\">\n                                <a href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.link)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">From: "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
  return buffer;
  };
this["templates"]["standalone"] = function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<div class=\"ad ad_native standalone-hbs\">\n    <div class=\"box\">\n        <div class=\"section section_accent section_shadow\">\n            <div class=\"section-hd\">\n                <div class=\"box box_veryTight\">\n                    <div class=\"hdg hdg_2 ad_rec_blue\">Sponsored Content\n                    </div>\n                </div>\n                <h4 class=\"hdg hdg_bold hdg_3 hdg_link\">\n                    <a href=\"";
  if (stack1 = helpers.link) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.link); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\" class=\"mix-hdg_green\">";
  if (stack1 = helpers.title) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.title); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "</a>\n                </h4>\n            </div>\n            <div class=\"section-bd\">\n                <div class=\"media media_small\">\n                    <div class=\"media-img\">\n                        <div class=\"box_veryTight\">\n                            <img src=\"";
  options = {hash:{
    'width': (120)
  },data:data};
  buffer += escapeExpression(((stack1 = helpers.getThumbHref || (depth0 && depth0.getThumbHref)),stack1 ? stack1.call(depth0, options) : helperMissing.call(depth0, "getThumbHref", options)))
    + "\">\n                        </div>\n\n                        <div class=\"ad_native-ft\">\n                            <div class=\"box_grounded ad_hovered\">\n                                <a href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.link)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">From: "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.sponsor)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"media-bd ad_black_title\">\n                        <p>\n                            ";
  if (stack2 = helpers.summary) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.summary); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "\n                        </p>\n                        <div class=\"text_right\">\n                            <a class=\"btn btn_small btn_primary\" href=\"";
  if (stack2 = helpers.link) { stack2 = stack2.call(depth0, {hash:{},data:data}); }
  else { stack2 = (depth0 && depth0.link); stack2 = typeof stack2 === functionType ? stack2.call(depth0, {hash:{},data:data}) : stack2; }
  buffer += escapeExpression(stack2)
    + "\"><span class=\"text_size12\">Read more</span></a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
  return buffer;
  }; return this["templates"]; });
define('services/dfpAdService',['exports', 'module', 'shared-scripts/lib/Util', 'jquery'], function (exports, module, _sharedScriptsLibUtil, _jquery) {
    /**
     * DFP Ad service
     * Low-level functionality for communicating with DFP ad service
     *
     * @class dfpdfpAdService
     * @constructor
     */

    

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    // Global Google DFP queue
    // Allows queuing of commands before external Google DFP script tag has loaded
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    var dfpAdService = {};

    // Returns the DFP ad unit in the following form.
    // If no specific ad unit is defined for the portlet, falls back to use the page-level ad unit
    //
    // For example, this data:
    // { account: '/306602/site191.tmus', prefix: 'AgoPaid', adUnit: 'Home1' }
    //
    // Would result in:
    // {account}/{prefix}{adUnit}
    // /306602/site191.tmus/AgoPaidHome1
    dfpAdService.getAdUnit = function (portletAdUnit) {
        var account = window.dtnGlobals.dfpAccount == null ? '' : window.dtnGlobals.dfpAccount;
        var prefix = window.dtnGlobals.dfpPrefix == null ? '' : window.dtnGlobals.dfpPrefix;
        var pageAdUnit = window.dtnGlobals.dfpAdUnit == null ? '' : window.dtnGlobals.dfpAdUnit;
        var portlet = portletAdUnit == null ? '' : portletAdUnit;

        // If defined, portlet-level ad unit overrides page-level ad unit
        var adUnit = portlet === '' ? pageAdUnit : portlet;

        // Undefined ad units are considered to be in an 'Undeclared' bucket
        // For debugging purposes, this would serve dummy placeholder ads on dev
        // environments.
        if (adUnit === '') {
            adUnit = 'Undeclared';
        }

        return account + '/' + prefix + adUnit;
    };

    // Combine all targeting key/value pairs into a single object
    dfpAdService.getTargeting = function (pos, portletTargeting) {
        var user = window.dtnGlobals.dfpUserTargeting;

        var page = {
            'referrer': _Util['default'].getQueryValue('referrer'),
            'search': _Util['default'].getQueryValue('q'),
            'keywords': (0, _$['default'])('meta[name="keywords"]').attr('content').split(',')
        };

        var portlet = {
            pos: pos
        };

        var custom = _Util['default'].parseQueryString(portletTargeting);

        return Object.assign(custom, portlet, user, page);
    };

    dfpAdService.onReady = function (onReadyFn) {
        window.googletag.cmd.push(onReadyFn);
    };

    dfpAdService.getSlot = function (adUnit, id, desktopWidth, desktopHeight, mobileWidth, mobileHeight) {
        // Set Responsive Design sizes
        var sizeMapping = window.googletag.sizeMapping().addSize([0, 0], [mobileWidth, mobileHeight]).addSize([window.dtnGlobals.maxMobileWidth, 0], [desktopWidth, desktopHeight]).build();

        var slot = window.googletag.defineSlot(adUnit, [mobileWidth, mobileHeight], id);

        // Slot will be null if bad params were supplied (such as two ads with the same id)
        if (slot != null) {
            slot.defineSizeMapping(sizeMapping);
            slot.addService(window.googletag.pubads());
        }
        return slot;
    };

    // Used for interstials, etc
    dfpAdService.getOutofPageSlot = function (adUnit, id) {
        var slot = window.googletag.defineOutOfPageSlot(adUnit, id);

        // Slot will be null if bad params were supplied (such as two ads with the same id)
        if (slot != null) {
            slot.addService(window.googletag.pubads());
        }
        return slot;
    };

    dfpAdService.setTargeting = function (slot, targeting) {
        for (var key in targeting) {
            if (targeting.hasOwnProperty(key)) {
                var value = targeting[key];
                if (value != null && value !== '') {
                    slot.setTargeting(key, value);
                }
            }
        }
    };

    dfpAdService.display = function (slot, id, onCompleteFn) {
        // Collapse div if no matching ad returned
        if (!this.isDebug()) {
            window.googletag.pubads().collapseEmptyDivs();
        }

        // Add listener for ad load completion
        if (onCompleteFn != null) {
            window.googletag.pubads().addEventListener('slotRenderEnded', onCompleteFn);
        }

        // Display Ad
        window.googletag.enableServices();
        window.googletag.display(id);
    };

    /**
     * Disables initial load of ads. Refresh() must be called
     * later to force ads to load after the fact.
     */
    dfpAdService.disableInitialLoad = function () {
        window.googletag.pubads().disableInitialLoad();
    };

    /**
     * Refreshes all ads on the page
     * After detaching/moving an ad in the DOM, a funny side effect is that the ad
     * will disappear. Calling refresh() will force all ads to re-appear again.
     */
    dfpAdService.refresh = function (slot) {
        window.googletag.pubads().refresh([slot]);
    };

    // Toggle visibility of visual debugger
    // Shown on test accounts, hidden on production
    dfpAdService.isDebug = function () {
        return window.dtnGlobals.dfpDebug === 'true';
    };

    dfpAdService.addVisualDebugger = function (reason, $element, width, height, portletAdUnit, pos, isOutOfPage) {
        if (!this.isDebug()) {
            return;
        }

        var adUnit = this.getAdUnit(portletAdUnit);
        $element.addClass('ad_error');
        $element.html('DFP AD ' + reason + '<br>' + pos + ' ' + width + ' x ' + height + ' ' + (isOutOfPage ? '(out-of-page)' : '') + '<br>adUnit: ' + adUnit);
        $element.css('width', width);
        $element.css('height', height);
    };

    module.exports = dfpAdService;
});
define('shared-scripts/services/nativeAdService',['exports', 'module', 'jquery', 'moment', 'compiledTemplates/templates', 'services/dfpAdService'], function (exports, module, _jquery, _moment, _compiledTemplatesTemplates, _servicesDfpAdService) {
    /**
     * Native Ad service
     * Low-level functionality for communicating with native ad service
     *
     * @class nativenativeAdService
     * @constructor
     */

    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _moment2 = babelHelpers.interopRequireDefault(_moment);

    var _compiledTemplates = babelHelpers.interopRequireDefault(_compiledTemplatesTemplates);

    var _dfpAdService = babelHelpers.interopRequireDefault(_servicesDfpAdService);

    // Global MediaVoice queue
    // Allows queuing of commands before external mediaVoice script tag has loaded
    window.NATIVEADS = window.NATIVEADS || {};
    window.NATIVEADS_QUEUE = window.NATIVEADS_QUEUE || [];

    var nativeAdService = {};

    nativeAdService.onReady = function (onReadyFn) {
        window.NATIVEADS_QUEUE.push(onReadyFn);
    };

    nativeAdService.getAccount = function () {
        return window.dtnGlobals.mediaVoiceAccount;
    };

    nativeAdService.getTemplate = function (templateName) {
        return _compiledTemplates['default'][templateName];
    };

    nativeAdService.getDfpParams = function (portletAdUnit, pos, portletTargeting, width, height) {
        var adUnit = _dfpAdService['default'].getAdUnit(portletAdUnit);
        var size = width + 'x' + height;
        var targets = _dfpAdService['default'].getTargeting(pos, portletTargeting);

        return {
            'server': 'dfp',
            'id': adUnit,
            size: size,
            targets: targets
        };
    };

    nativeAdService.getSelector = function (container, index) {
        var selector = null;

        if (container != null && container !== '') {
            if (index == null || index === '') {
                selector = container;
            } else {
                selector = container + ' li:eq(' + index + ')';
                // If native ad position does not exit, set position to first item instead
                if ((0, _$['default'])(selector).length === 0) {
                    //                selector = `${container} li:eq(0)`;
                }
            }
        }

        return selector;
    };

    nativeAdService.assignUniqueSelector = function ($element) {
        var attribute = 'data-native-ad-target';
        var value = Math.random();

        var $inner = (0, _$['default'])('<div>');
        $inner.attr(attribute, value);
        $element.append($inner);

        return '[' + attribute + '="' + value + '"]';
    };

    // Sets the URL to navigate the user to once the native ad is clicked.
    // Media voice will append a query param like ?mvi=123245252 to this URL to identify which article to display
    // The url set here MUST match on both the page the native ad is hosted on and the article page itself
    nativeAdService.setArticleUrl = function (url) {
        window.NATIVEADS_QUEUE.push(['setSecondaryPageURL', url]);
    };

    nativeAdService.setAccount = function (account) {
        window.NATIVEADS_QUEUE.push(['setPropertyID', account]);
    };

    nativeAdService.display = function (label, adUnit, selector, compiledTemplate, onFillFn, onRenderFn, onErrorFn) {
        window.NATIVEADS_QUEUE.push(['insertPreview', {
            label: label,
            unit: adUnit,
            location: selector,
            template: compiledTemplate,
            onFill: onFillFn,
            onRender: onRenderFn,
            onError: onErrorFn
        }]);
    };

    // Outputs date in form 2/12/2014 | 8:47 AM
    nativeAdService.dateFormatter = function (date) {
        return (0, _moment2['default'])(date).format('M/D/YYYY | h:mm A z');
    };

    nativeAdService.displayArticle = function (binding, onFillFn, onRenderFn, onErrorFn, onTrackFn) {
        window.NATIVEADS_QUEUE.push(['configureSecondaryPage', {
            dateFormat: this.dateFormatter.bind(this),
            binding: binding,
            onFill: onFillFn,
            onRender: onRenderFn,
            onError: onErrorFn,
            track: onTrackFn
        }]);
    };

    nativeAdService.addVisualDebugger = function (reason, $element, width, height, portletAdUnit) {
        if (!_dfpAdService['default'].isDebug()) {
            return;
        }
        var adUnit = _dfpAdService['default'].getAdUnit(portletAdUnit);

        $element.addClass('ad_error');
        $element.removeClass('isHidden');
        $element.html('(disable your Liferay edit controls or set \'dtnGlobals.dfpDebug\' to false to hide this message)<br><br>NATIVE AD ERROR: "' + reason + '"<br>' + width + ' x ' + height + '<br>adUnit: ' + adUnit);
    };

    module.exports = nativeAdService;
});
define('shared-scripts/components/NativeArticleComponent',['exports', 'module', 'components/Component', 'lib/Util', 'shared-scripts/services/nativeAdService'], function (exports, module, _componentsComponent, _libUtil, _sharedScriptsServicesNativeAdService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _nativeAdService = babelHelpers.interopRequireDefault(_sharedScriptsServicesNativeAdService);

    /**
     * Native Ad Loader Component
     *
     * @class
     */

    var NativeArticleComponent = (function (_Component) {
        babelHelpers.inherits(NativeArticleComponent, _Component);

        function NativeArticleComponent() {
            babelHelpers.classCallCheck(this, NativeArticleComponent);
            babelHelpers.get(Object.getPrototypeOf(NativeArticleComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(NativeArticleComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(NativeArticleComponent.prototype), 'initProps', this).apply(this, arguments);

                this.articleUrl = this.$element.attr('data-article-url');
                this.articleId = _Util['default'].getQueryValue('mvi');
            }
        }, {
            key: 'ready',
            value: function ready() {
                _nativeAdService['default'].onReady(this.onReady.bind(this));
            }
        }, {
            key: 'onReady',
            value: function onReady() {
                if (this.articleId !== '' && this.articleId != null) {
                    this.displayAd();
                } else {
                    this.displayErrorMessage();
                }
            }
        }, {
            key: 'getBinding',
            value: function getBinding() {
                return {
                    sponsor: {
                        name: '[data-bind="sponsor-name"]',
                        link: '[data-bind="sponsor-link"]',
                        logo: '[data-bind="sponsor-logo"]'
                    },
                    title: '[data-bind="title"]',
                    summary: '[data-bind="summary"]',
                    content: '[data-bind="content"]',
                    author: '[data-bind="author"]',
                    pubDate: '[data-bind="pub-date"]',
                    image: {
                        href: '[data-bind="media"]',
                        caption: '[data-bind="media-caption"]',
                        credits: '[data-bind="media-credits"]'
                    }
                };
            }
        }, {
            key: 'onFill',
            value: function onFill(model) {
                //console.log('model', model);
            }
        }, {
            key: 'onRender',
            value: function onRender($element) {
                this.sendAction('didStopLoading');

                var $iframe = this.$element.find('iframe');
                var $iframeParent = $iframe.parent();
                $iframe.addClass('native-ad-article-videoContainer-video');
                $iframeParent.addClass('native-ad-article-videoContainer');
            }
        }, {
            key: 'onTrack',
            value: function onTrack() {
                return 'inbound';
            }
        }, {
            key: 'onError',
            value: function onError(error) {
                console.warn('Error loading native ad:', error, this); // eslint-disable-line no-console
                this.displayErrorMessage();
                this.sendAction('didStopLoading');
                _nativeAdService['default'].addVisualDebugger(error, this.$body);
            }
        }, {
            key: 'displayAd',
            value: function displayAd() {
                this.sendAction('didStartLoading');
                var account = _nativeAdService['default'].getAccount();
                var binding = this.getBinding();

                _nativeAdService['default'].setAccount(account);
                _nativeAdService['default'].setArticleUrl(this.articleUrl);
                _nativeAdService['default'].displayArticle(binding, this.onFill.bind(this), this.onRender.bind(this), this.onError.bind(this), this.onTrack.bind(this));
            }
        }, {
            key: 'displayErrorMessage',
            value: function displayErrorMessage() {
                this.$body.addClass('isHidden');
                this.$error.removeClass('isHidden');
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$body', selector: '.js-nativeArticleComponent-body' }, { prop: '$error', selector: '.js-nativeArticleComponent-error' }];
            }
        }]);
        return NativeArticleComponent;
    })(_Component2['default']);

    module.exports = NativeArticleComponent;
});
define('components/LiferayAdminModuleFixComponent',['exports', 'module', 'jquery', 'components/Component'], function (exports, module, _jquery, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var LiferayAdminModuleFixComponent = (function (_Component) {
        babelHelpers.inherits(LiferayAdminModuleFixComponent, _Component);

        function LiferayAdminModuleFixComponent() {
            babelHelpers.classCallCheck(this, LiferayAdminModuleFixComponent);
            babelHelpers.get(Object.getPrototypeOf(LiferayAdminModuleFixComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(LiferayAdminModuleFixComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(LiferayAdminModuleFixComponent.prototype), 'initProps', this).apply(this, arguments);

                this.preventModify = false;
            }
        }, {
            key: 'onDockbarClick',
            value: function onDockbarClick() {
                window.setTimeout(this.wrapLiferayAdminPanelsInAui.bind(this), 0);
            }
        }, {
            key: 'onDOMSubtreeModified',
            value: function onDOMSubtreeModified() {
                // this event can get fired off a few times at once
                // so this prevents markup from getting added more than once
                if (this.preventModify) {
                    return;
                } else {
                    this.preventModify = true;
                    var $yuiWidgets = this.$element.children('.yui3-widget');
                    $yuiWidgets.wrap(this.consts.AUI_WRAPPER);
                    this.preventModify = false;
                }
            }
        }, {
            key: 'wrapLiferayAdminPanelsInAui',
            value: function wrapLiferayAdminPanelsInAui() {
                var _consts = this.consts;
                var LIFERAY_ADMIN_PANEL_SELECTOR = _consts.LIFERAY_ADMIN_PANEL_SELECTOR;
                var AUI_WRAPPER = _consts.AUI_WRAPPER;

                var adminPanels = document.querySelectorAll(LIFERAY_ADMIN_PANEL_SELECTOR);
                Array.prototype.slice.call(adminPanels).map(function (node) {
                    return (0, _$['default'])(node);
                }).filter(function ($node) {
                    return $node.parents('.aui').length === 0;
                }).forEach(function ($nodesWithoutAuiParent) {
                    return $nodesWithoutAuiParent.wrap(AUI_WRAPPER);
                });
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    LIFERAY_ADMIN_PANEL_SELECTOR: '.lfr-admin-panel',
                    AUI_WRAPPER: '<div class="aui"></div>'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'DOMSubtreeModified' }, { prop: '$addButton', selector: '.site-add-controls > a', event: 'click', func: 'onDockbarClick' }, { prop: '$editLink', selector: '.page-edit-controls > a', event: 'click', func: 'onDockbarClick' }, { prop: '$previewLink', selector: '.page-preview-controls > a', event: 'click', func: 'onDockbarClick' }];
            }
        }]);
        return LiferayAdminModuleFixComponent;
    })(_Component2['default']);

    module.exports = LiferayAdminModuleFixComponent;
});
define('components/Carousel3Component',['exports', 'module', 'jquery', 'components/Component'], function (exports, module, _jquery, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var Nav = (function () {
        function Nav($element) {
            babelHelpers.classCallCheck(this, Nav);

            this.$element = $element;
        }

        babelHelpers.createClass(Nav, [{
            key: 'getIndex',
            value: function getIndex($clickedItem) {

                var url = $clickedItem.find("a").attr("href");
                if (typeof url !== 'undefined') {
                    window.location.href = url;
                }

                return this.$element.children().index($clickedItem);
            }
        }, {
            key: 'update',
            value: function update(index) {
                this.$element.children('li').removeClass('isActive').eq(index).addClass('isActive');
            }
        }]);
        return Nav;
    })();

    var Arrows = (function () {
        function Arrows($arrowLeft, $arrowRight) {
            babelHelpers.classCallCheck(this, Arrows);

            this.$arrowLeft = $arrowLeft;
            this.$arrowRight = $arrowRight;
        }

        babelHelpers.createClass(Arrows, [{
            key: 'update',
            value: function update(index, count) {
                if (index <= 0) {
                    this.$arrowLeft.addClass('isHidden');
                } else {
                    this.$arrowLeft.removeClass('isHidden');
                }
                if (index >= count - 1) {
                    this.$arrowRight.addClass('isHidden');
                } else {
                    this.$arrowRight.removeClass('isHidden');
                }
            }
        }]);
        return Arrows;
    })();

    var Tween = (function () {
        function Tween(start, end, duration) {
            babelHelpers.classCallCheck(this, Tween);

            this.start = start;
            this.end = end;
            this.delta = end - start;
            this.duration = duration;

            this.isComplete = false;
            this.lastTime = null;

            // If nowhere to move, then immediately set to complete
            if (this.delta === 0) {
                this.isComplete = true;
            }
        }

        babelHelpers.createClass(Tween, [{
            key: 'update',
            value: function update(time) {
                if (this.lastTime == null) {
                    this.lastTime = time;
                }

                var timeElapsed = time - this.lastTime;

                var value = null;
                if (timeElapsed >= this.duration) {
                    value = this.end;
                    this.isComplete = true;
                } else {
                    value = this.easeOutSine(timeElapsed, this.start, this.delta, this.duration);
                }

                return value;
            }
        }, {
            key: 'easeOutSine',
            value: function easeOutSine(t, b, c, d) {
                return c * Math.sin(t / d * (Math.PI / 2)) + b;
            }
        }]);
        return Tween;
    })();

    var Stage = (function () {
        babelHelpers.createClass(Stage, [{
            key: 'consts',
            get: function get() {
                return {
                    ANIMATE_DURATION_MS: 250
                };
            }
        }]);

        function Stage($element) {
            babelHelpers.classCallCheck(this, Stage);

            this.$element = $element;
            this.x = 0;
            this.updateHandler = this.update.bind(this);
            this.tween = new Tween(0, 0, 0);
        }

        babelHelpers.createClass(Stage, [{
            key: 'incrementX',
            value: function incrementX(x) {
                this.x += x;
                this.$element.css({ x: -this.x });
            }
        }, {
            key: 'setX',
            value: function setX(x) {
                this.x = x;
                this.$element.css({ x: -this.x });
            }
        }, {
            key: 'start',
            value: function start(targetX, width) {
                this.tween = new Tween(this.x, targetX, this.getDuration(targetX, width));
                window.requestAnimationFrame(this.updateHandler);
            }
        }, {
            key: 'stop',
            value: function stop() {
                this.tween.isComplete = true;
            }
        }, {
            key: 'update',
            value: function update(time) {
                if (!this.tween.isComplete) {
                    var x = this.tween.update(time);
                    this.setX(x);
                    window.requestAnimationFrame(this.updateHandler);
                }
            }

            // Duration is derived from the distance we need to move
        }, {
            key: 'getDuration',
            value: function getDuration(x, width) {
                var distance = this.getDistance(x);
                var percent = this.clamp(distance / width);
                var duration = this.consts.ANIMATE_DURATION_MS * percent;

                return duration < 0.1 ? 0 : duration;
            }
        }, {
            key: 'getDistance',
            value: function getDistance(x) {
                return Math.abs(this.x - x);
            }
        }, {
            key: 'clamp',
            value: function clamp(value) {
                var clamped = value;
                if (clamped > 1) {
                    clamped = 1;
                } else if (clamped < 0) {
                    clamped = 0;
                }
                return clamped;
            }
        }, {
            key: 'isTransitioning',
            get: function get() {
                return !this.tween.isComplete;
            }
        }]);
        return Stage;
    })();

    var Slides = (function () {
        function Slides($element) {
            babelHelpers.classCallCheck(this, Slides);

            this.$element = $element;
            this.count = this.$element.length;
            this.width = 0;
            this.index = 0;
            this.onWidthChange();
        }

        babelHelpers.createClass(Slides, [{
            key: 'getX',
            value: function getX(index) {
                return this.width * index;
            }
        }, {
            key: 'getClosestIndex',
            value: function getClosestIndex(x, direction) {
                var index = Math.floor(x / this.width);
                if (direction === 1) {
                    index++;
                }
                if (index > this.count - 1) {
                    index = this.count - 1;
                } else if (index < 0) {
                    index = 0;
                }
                return index;
            }
        }, {
            key: 'getPreviousIndex',
            value: function getPreviousIndex() {
                return this.index - 1 < 0 ? this.count - 1 : this.index - 1;
            }
        }, {
            key: 'getNextIndex',
            value: function getNextIndex() {
                return this.index + 1 >= this.count ? 0 : this.index + 1;
            }
        }, {
            key: 'onWidthChange',
            value: function onWidthChange() {
                var width = this.$element.first().width();

                // If width is the same as what we already have, do nothing
                if (width !== this.width) {
                    this.width = width;
                    return true;
                }
                return false;
            }
        }]);
        return Slides;
    })();

    var Pointer = (function () {
        babelHelpers.createClass(Pointer, [{
            key: 'consts',
            get: function get() {
                return {
                    SCROLL_THRESHOLD_X: 5,
                    SCROLL_THRESHOLD_Y: 5,
                    SNAPBACK_THRESHOLD_X: 10
                };
            }
        }]);

        function Pointer() {
            babelHelpers.classCallCheck(this, Pointer);

            this.isDragging = false;
            this.start = { x: 0, y: 0 };
            this.previous = { x: 0, y: 0 };
            this.delta = { x: 0, y: 0 };
            this.total = { x: 0, y: 0 };
            this.direction = { isX: false, isY: false };
        }

        babelHelpers.createClass(Pointer, [{
            key: 'startDrag',
            value: function startDrag(x, y) {
                this.isDragging = true;
                this.direction.isX = false;
                this.direction.isY = false;
                this.start.x = x;
                this.start.y = y;
                this.previous.x = this.start.x;
                this.previous.y = this.start.y;
                this.delta.x = 0;
                this.delta.y = 0;
                this.total.x = 0;
                this.total.y = 0;
            }
        }, {
            key: 'moveDrag',
            value: function moveDrag(x, y) {
                this.delta.x = this.previous.x - x;
                this.delta.y = this.previous.y - y;
                this.previous.x = x;
                this.previous.y = y;
                this.total.x += this.delta.x;
                this.total.y += this.delta.y;

                if (this.direction.isX === false && this.direction.isY === false) {
                    if (this.exceededThresholdY) {
                        this.direction.isY = true;
                    } else if (this.exceededThresholdX) {
                        this.direction.isX = true;
                    }
                }
            }
        }, {
            key: 'endDrag',
            value: function endDrag() {
                this.isDragging = false;
            }
        }, {
            key: 'isSnapback',
            get: function get() {
                return Math.abs(this.total.x) <= this.consts.SNAPBACK_THRESHOLD_X;
            }
        }, {
            key: 'dragDirection',
            get: function get() {
                return this.delta.x > 0 ? 1 : -1;
            }
        }, {
            key: 'exceededThresholdX',
            get: function get() {
                return Math.abs(this.total.x) > this.consts.SCROLL_THRESHOLD_X && Math.abs(this.total.y) < this.consts.SCROLL_THRESHOLD_Y;
            }
        }, {
            key: 'exceededThresholdY',
            get: function get() {
                return Math.abs(this.total.x) < this.consts.SCROLL_THRESHOLD_X && Math.abs(this.total.y) > this.consts.SCROLL_THRESHOLD_Y;
            }
        }]);
        return Pointer;
    })();

    var Rotator = (function () {
        babelHelpers.createClass(Rotator, [{
            key: 'consts',
            get: function get() {
                return {
                    AUTO_ROTATE_MS: 5000
                };
            }
        }]);

        function Rotator(onRotateFn) {
            babelHelpers.classCallCheck(this, Rotator);

            this.onRotateFn = onRotateFn;
            this.interval = null;
        }

        babelHelpers.createClass(Rotator, [{
            key: 'start',
            value: function start() {
                this.interval = setInterval(this.onRotateFn, this.consts.AUTO_ROTATE_MS);
            }
        }, {
            key: 'stop',
            value: function stop() {
                clearInterval(this.interval);
            }
        }]);
        return Rotator;
    })();

    var Carousel3Component = (function (_Component) {
        babelHelpers.inherits(Carousel3Component, _Component);

        function Carousel3Component() {
            babelHelpers.classCallCheck(this, Carousel3Component);
            babelHelpers.get(Object.getPrototypeOf(Carousel3Component.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(Carousel3Component, [{
            key: 'bindEventHandlers',
            value: function bindEventHandlers() {
                babelHelpers.get(Object.getPrototypeOf(Carousel3Component.prototype), 'bindEventHandlers', this).apply(this, arguments);
                this.onResizeHandler = this.onResize.bind(this);
                this.onOrientationChangeHandler = this.onOrientationChange.bind(this);
                this.onPointermoveHandler = this.onPointermove.bind(this);
                this.onPointerupHandler = this.onPointerup.bind(this);
                this.onMouseleaveHandler = this.onMouseleave.bind(this);
            }
        }, {
            key: 'queryDom',
            value: function queryDom() {
                var _this = this;

                babelHelpers.get(Object.getPrototypeOf(Carousel3Component.prototype), 'queryDom', this).apply(this, arguments);
                this.$window = (0, _$['default'])(window);
                this.$body = (0, _$['default'])(document.body);

                this.nav = new Nav(this.$nav);
                this.stage = new Stage(this.$stage);
                this.slides = new Slides(this.$slides);
                this.pointer = new Pointer();
                this.rotator = new Rotator(function () {
                    _this.setIndex(_this.slides.getNextIndex());
                });
                this.arrows = new Arrows(this.$arrowLeft, this.$arrowRight);
            }
        }, {
            key: 'enable',
            value: function enable() {
                babelHelpers.get(Object.getPrototypeOf(Carousel3Component.prototype), 'enable', this).apply(this, arguments);

                this.$window.on('resize', this.onResizeHandler);
                this.$window.on('orientationchange', this.onOrientationChangeHandler);
                this.$window.on('pointermove', this.onPointermoveHandler);
                this.$window.on('pointerup', this.onPointerupHandler);
                this.$body.on('mouseleave', this.onMouseleaveHandler);
            }
        }, {
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(Carousel3Component.prototype), 'ready', this).apply(this, arguments);
                this.rotator.start();
                this.slides.onWidthChange();
                this.setIndex(0);
                this.makeUnselectable();
            }
        }, {
            key: 'makeUnselectable',
            value: function makeUnselectable() {
                this.$element.find('.unselectable').attr('unselectable', 'on').prop('draggable', false).on('dragstart', function () {
                    return false;
                });
            }
        }, {
            key: 'onInteraction',
            value: function onInteraction() {
                this.rotator.stop();
            }
        }, {
            key: 'onResize',
            value: function onResize() {
                var wasWidthUpdated = this.slides.onWidthChange();
                if (wasWidthUpdated) {
                    //make sure we stay on current slide if dimensions have changed
                    this.setIndex(this.slides.index);
                }
            }
        }, {
            key: 'onOrientationChange',
            value: function onOrientationChange() {
                this.slides.onWidthChange();
                this.setIndex(this.slides.index);
            }
        }, {
            key: 'onNavClick',
            value: function onNavClick(event) {
                var $clickedItem = (0, _$['default'])(event.currentTarget);
                this.setIndex(this.nav.getIndex($clickedItem));
                this.onInteraction();
                event.preventDefault();
            }
        }, {
            key: 'onArrowLeftClick',
            value: function onArrowLeftClick(event) {
                this.setIndex(this.slides.getPreviousIndex());
                this.onInteraction();
                event.preventDefault();
            }
        }, {
            key: 'onArrowRightClick',
            value: function onArrowRightClick(event) {
                this.setIndex(this.slides.getNextIndex());
                this.onInteraction();
                event.preventDefault();
            }
        }, {
            key: 'onLinkClick',
            value: function onLinkClick(event) {
                if (this.pointer.isDragging || this.stage.isTransitioning) {
                    // Prevent clicking on links when use intends to dragging
                    event.preventDefault();
                }
            }
        }, {
            key: 'onPointerdown',
            value: function onPointerdown(event) {
                // Get around IE  bug
                var button = event.button == null ? event.originalEvent.button : event.button;

                if (!event.isPrimary || button !== 0) {
                    return;
                }

                // Stop any current transitions to allow user to start dragging
                if (this.stage.isTransitioning) {
                    this.stage.stop();
                }

                var x = event.pageX;
                var y = event.pageY;

                this.pointer.startDrag(x, y);
                this.onInteraction();

                // Do not prevent default here, since it will interfere with
                // native page scroll events on mobile
                // event.preventDefault();
            }
        }, {
            key: 'onPointermove',
            value: function onPointermove(event) {
                if (!event.isPrimary || !this.pointer.isDragging) {
                    return;
                }

                var x = event.pageX;
                var y = event.pageY;

                this.pointer.moveDrag(x, y);

                // For touch-based devices only:
                // If a vertical drag was detected, let the native page scroll event handler take care of things from here
                if (event.pointerType !== 'mouse' && this.pointer.direction.isY) {
                    this.setClosestIndex();
                    this.pointer.endDrag();
                } else if (this.pointer.direction.isX) {
                    // Prevent native page scrolling from occurring
                    this.stage.incrementX(this.pointer.delta.x);
                    event.preventDefault();
                }
            }
        }, {
            key: 'onPointerup',
            value: function onPointerup(event) {
                if (!event.isPrimary || !this.pointer.isDragging) {
                    return;
                }

                this.setClosestIndex();
                this.pointer.endDrag();
            }
        }, {
            key: 'onMouseleave',
            value: function onMouseleave() {
                if (!this.pointer.isDragging) {
                    return;
                }

                this.setClosestIndex();
                this.pointer.endDrag();
            }
        }, {
            key: 'setClosestIndex',
            value: function setClosestIndex() {
                var index = -1;
                if (this.pointer.isSnapback) {
                    index = this.slides.index;
                } else {
                    index = this.slides.getClosestIndex(this.stage.x, this.pointer.dragDirection);
                }
                this.setIndex(index);
            }
        }, {
            key: 'setIndex',
            value: function setIndex(index) {
                this.slides.index = index;

                var x = this.slides.getX(this.slides.index);
                this.stage.start(x, this.slides.width);
                this.nav.update(this.slides.index);
                this.arrows.update(this.slides.index, this.slides.count);
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$stage', selector: '.js-carousel3Component-stage' }, { prop: '$stageWrapper', selector: '.js-carousel3Component-stageWrapper', event: 'pointerdown', func: 'onPointerdown' }, { prop: '$slides', selector: '.js-carousel3Component-stage > *' }, { prop: '$nav', selector: '.js-carousel3Component-nav', event: 'click', delegate: 'li' }, { prop: '$arrowLeft', selector: '.js-carousel3Component-arrowLeft', event: 'click' }, { prop: '$arrowRight', selector: '.js-carousel3Component-arrowRight', event: 'click' }, { prop: '$link', selector: 'a', event: 'click' }];
            }
        }]);
        return Carousel3Component;
    })(_Component2['default']);

    module.exports = Carousel3Component;
});
define('shared-scripts/components/BreakpointListenerComponent',['exports', 'module', 'components/Component', 'shared-scripts/lib/Util'], function (exports, module, _componentsComponent, _sharedScriptsLibUtil) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var BreakpointListenerComponent = (function (_Component) {
        babelHelpers.inherits(BreakpointListenerComponent, _Component);

        function BreakpointListenerComponent() {
            babelHelpers.classCallCheck(this, BreakpointListenerComponent);
            babelHelpers.get(Object.getPrototypeOf(BreakpointListenerComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(BreakpointListenerComponent, [{
            key: 'bindEventHandlers',
            value: function bindEventHandlers() {
                babelHelpers.get(Object.getPrototypeOf(BreakpointListenerComponent.prototype), 'bindEventHandlers', this).call(this);

                this.onUtilBreakpointChangeHandler = this.onUtilBreakpointChange.bind(this);
            }
        }, {
            key: 'enable',
            value: function enable() {
                babelHelpers.get(Object.getPrototypeOf(BreakpointListenerComponent.prototype), 'enable', this).call(this);

                _Util['default'].subscribe('breakpointChange', this.onUtilBreakpointChangeHandler);
            }
        }, {
            key: 'disable',
            value: function disable() {
                babelHelpers.get(Object.getPrototypeOf(BreakpointListenerComponent.prototype), 'disable', this).call(this);

                _Util['default'].unsubscribe('breakpointChange', this.onUtilBreakpointChangeHandler);
            }
        }, {
            key: 'onUtilBreakpointChange',
            value: function onUtilBreakpointChange(event, newBreakpoint) {
                var actionName = null;

                if (newBreakpoint === 'mobileEnter') {
                    actionName = 'didEnterMobile';
                } else if (newBreakpoint === 'mobileExit') {
                    actionName = 'didExitMobile';
                } else if (newBreakpoint === 'desktopEnter') {
                    actionName = 'didEnterDesktop';
                } else if (newBreakpoint === 'desktopExit') {
                    actionName = 'didExitDesktop';
                } else if (newBreakpoint === 'viewportChange') {
                    actionName = 'didViewportChange';
                }

                this.sendAction(actionName);
            }
        }]);
        return BreakpointListenerComponent;
    })(_Component2['default']);

    module.exports = BreakpointListenerComponent;
});
define('shared-scripts/components/ButtonComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    /**
     * Button Component
     *
     * @class
     */

    var ButtonComponent = (function (_Component) {
        babelHelpers.inherits(ButtonComponent, _Component);

        function ButtonComponent() {
            babelHelpers.classCallCheck(this, ButtonComponent);
            babelHelpers.get(Object.getPrototypeOf(ButtonComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ButtonComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(ButtonComponent.prototype), 'initProps', this).apply(this, arguments);

                this.config.initialLabel = this.label;
                this.state = this.consts.INITIAL;
            }
        }, {
            key: 'render',
            value: function render() {
                var label = '';
                var disabled = false;

                switch (this.state) {
                    case this.consts.INITIAL:
                        label = this.config.initialLabel;
                        disabled = false;
                        break;
                    case this.consts.PENDING:
                        label = this.config.pendingLabel;
                        disabled = true;
                        break;
                    case this.consts.SUCCESS:
                        label = this.config.successLabel;
                        disabled = false;
                        break;
                    default:
                        label = this.config.initialLabel;
                        disabled = false;
                        break;
                }

                this.label = label;
                this.$element.prop('disabled', disabled);
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    INITIAL: 'INITIAL',
                    PENDING: 'PENDING',
                    SUCCESS: 'SUCCESS'
                };
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    initialLabel: '',
                    pendingLabel: '',
                    successLabel: ''
                };
            }
        }, {
            key: 'state',
            get: function get() {
                return this._state;
            },
            set: function set(state) {
                this._state = state;
                this.render();
            }
        }, {
            key: 'label',
            get: function get() {
                return this.$element.text();
            },
            set: function set(value) {
                this.$element.text(value);
            }
        }]);
        return ButtonComponent;
    })(_Component2['default']);

    module.exports = ButtonComponent;
});
define('shared-scripts/components/FormComponent',['exports', 'module', 'jquery', 'components/Component', 'lib/Util', 'shared-scripts/components/ButtonComponent'], function (exports, module, _jquery, _componentsComponent, _libUtil, _sharedScriptsComponentsButtonComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _ButtonComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsButtonComponent);

    /**
     * Form Component
     *
     * @class
     */

    var FormComponent = (function (_Component) {
        babelHelpers.inherits(FormComponent, _Component);

        function FormComponent() {
            babelHelpers.classCallCheck(this, FormComponent);
            babelHelpers.get(Object.getPrototypeOf(FormComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(FormComponent, [{
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(FormComponent.prototype), 'queryDom', this).call(this);

                // In here because elements are optional
                this.$submitButton = this.$element.find('.js-FormComponent-submitButton');
                this.$resetButton = this.$element.find('.js-FormComponent-resetButton');

                if (this.$submitButton.length === 0) {
                    this.$submitButton = (0, _$['default'])('<div>');
                }
                if (this.$resetButton.length === 0) {
                    this.$resetButton = (0, _$['default'])('<div>');
                }

                this.resetButton = new _ButtonComponent['default'](this.$resetButton);
                this.submitButton = new _ButtonComponent['default'](this.$submitButton);
            }
        }, {
            key: 'enable',
            value: function enable() {
                babelHelpers.get(Object.getPrototypeOf(FormComponent.prototype), 'enable', this).call(this);

                this.$resetButton.on('click', this.onResetButtonClick.bind(this));
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit(event) {
                event.preventDefault(); // `return false` isn't preventing the default event
                this.submit();

                return false;
            }
        }, {
            key: 'onResetButtonClick',
            value: function onResetButtonClick() {
                this.reset();

                return false;
            }
        }, {
            key: 'submit',
            value: function submit() {
                this.submitButton.state = this.submitButton.consts.PENDING;

                this.sendAction('submitForm', [{
                    url: this.config.submitUrl,
                    serializedForm: this.$element.serializeArray(),
                    onSuccess: this.onSuccess.bind(this),
                    onFail: this.onFail.bind(this),
                    onReplace: this.onReplace.bind(this)
                }]);
            }
        }, {
            key: 'reset',
            value: function reset() {
                this.resetButton.state = this.resetButton.consts.PENDING;

                this.sendAction('resetForm', [{
                    url: this.config.resetUrl,
                    onSuccess: this.onSuccess.bind(this),
                    onFail: this.onFail.bind(this),
                    onReplace: this.onReplace.bind(this)
                }]);
            }
        }, {
            key: 'onSuccess',
            value: function onSuccess() {
                this.scrollToTop();
                this.submitButton.state = this.submitButton.consts.SUCCESS;
                this.clearErrors();
            }
        }, {
            key: 'onFail',
            value: function onFail(errorMessageArray) {
                this.scrollToTop();
                this.submitButton.state = this.submitButton.consts.INITIAL;
                this.resetButton.state = this.resetButton.consts.INITIAL;
                this.showErrors(errorMessageArray);
            }
        }, {
            key: 'onReplace',
            value: function onReplace($newForm) {
                this.scrollToTop();
                this.replace($newForm);
            }
        }, {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (this.config.scrollTopAfterSubmit) {
                    // If modal is open, then scroll to the top of the modal
                    var $modal = this.$element.closest('.js-modal');
                    if ($modal.length > 0) {
                        _Util['default'].scrollYToElement($modal, 800);
                    } else {
                        _Util['default'].scrollYToElement(this.$element, 800);
                    }
                }
            }
        }, {
            key: 'replace',
            value: function replace($newForm) {
                this.$element.replaceWith($newForm);
                (0, _$['default'])(document.body).trigger('attachjs');
            }
        }, {
            key: 'showErrors',
            value: function showErrors(errorMessageArray) {
                var $messages = this.$element.find('.js-formComponent-messages');

                $messages.find('.errors-list').empty();
                if (errorMessageArray.length > 0) {
                    var errorHtml = errorMessageArray.map(function (errorMessage) {
                        return '<li>' + errorMessage + '</li>';
                    });
                    $messages.find('.errors-list').append(errorHtml);
                    $messages.removeClass('isHidden');
                }
            }
        }, {
            key: 'clearErrors',
            value: function clearErrors() {
                var $messages = this.$element.find('.js-formComponent-messages');
                $messages.find('.errors-list').empty();
                $messages.addClass('isHidden');
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    submitUrl: { required: true },
                    resetUrl: { required: true },
                    scrollTopAfterSubmit: false
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'submit' }];
            }
        }]);
        return FormComponent;
    })(_Component2['default']);

    module.exports = FormComponent;
});
define('components/JoinCommunityComponent',['exports', 'module', 'components/Component', 'jquery'], function (exports, module, _componentsComponent, _jquery) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var JoinCommunityComponent = (function (_Component) {
        babelHelpers.inherits(JoinCommunityComponent, _Component);

        function JoinCommunityComponent() {
            babelHelpers.classCallCheck(this, JoinCommunityComponent);
            babelHelpers.get(Object.getPrototypeOf(JoinCommunityComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(JoinCommunityComponent, [{
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(JoinCommunityComponent.prototype), 'queryDom', this).apply(this, arguments);
                this.$registrationForm = (0, _$['default'])('#registrationForm');
                this.$sourceInput = this.$registrationForm.find('input[name="utm_source"]');
                this.$campaignInput = this.$registrationForm.find('input[name="utm_campaign"]');
                this.$mediumInput = this.$registrationForm.find('input[name="utm_medium"]');
                this.$contentInput = this.$registrationForm.find('input[name="utm_content"]');
            }
        }, {
            key: 'onClick',
            value: function onClick(event) {
                event.preventDefault();
                this.sendAction('openModal', [this.config.modalTarget, this.config.tabTarget]);
                this.populateHiddenInputs();
            }
        }, {
            key: 'populateHiddenInputs',
            value: function populateHiddenInputs() {
                this.$sourceInput.val(window.location);
                this.$campaignInput.val(this.$element.attr('data-campaign'));
                this.$mediumInput.val(this.$element.attr('data-medium'));
                this.$contentInput.val(this.$element.attr('data-location'));
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    modalTarget: { required: true },
                    tabTarget: null
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return JoinCommunityComponent;
    })(_Component2['default']);

    module.exports = JoinCommunityComponent;
});
define('components/FormComponent',['exports', 'module', 'jquery', 'components/Component', 'lib/Util', 'shared-scripts/components/ButtonComponent'], function (exports, module, _jquery, _componentsComponent, _libUtil, _sharedScriptsComponentsButtonComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _ButtonComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsButtonComponent);

    /**
     * Form Component
     *
     * @class
     */

    var FormComponent = (function (_Component) {
        babelHelpers.inherits(FormComponent, _Component);

        function FormComponent() {
            babelHelpers.classCallCheck(this, FormComponent);
            babelHelpers.get(Object.getPrototypeOf(FormComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(FormComponent, [{
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(FormComponent.prototype), 'queryDom', this).call(this);

                // In here because elements are optional
                this.$submitButton = this.$element.find('.js-FormComponent-submitButton');
                this.$resetButton = this.$element.find('.js-FormComponent-resetButton');

                if (this.$submitButton.length === 0) {
                    this.$submitButton = (0, _$['default'])('<div>');
                }
                if (this.$resetButton.length === 0) {
                    this.$resetButton = (0, _$['default'])('<div>');
                }

                this.resetButton = new _ButtonComponent['default'](this.$resetButton);
                this.submitButton = new _ButtonComponent['default'](this.$submitButton);
            }
        }, {
            key: 'enable',
            value: function enable() {
                babelHelpers.get(Object.getPrototypeOf(FormComponent.prototype), 'enable', this).call(this);

                this.$resetButton.on('click', this.onResetButtonClick.bind(this));
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit(event) {
                event.preventDefault(); // `return false` isn't preventing the default event
                this.submit();

                return false;
            }
        }, {
            key: 'onResetButtonClick',
            value: function onResetButtonClick() {
                this.reset();

                return false;
            }
        }, {
            key: 'submit',
            value: function submit() {
                this.submitButton.state = this.submitButton.consts.PENDING;

                this.sendAction('submitForm', [{
                    url: this.config.submitUrl,
                    serializedForm: this.$element.serializeArray(),
                    onSuccess: this.onSuccess.bind(this),
                    onFail: this.onFail.bind(this),
                    onReplace: this.onReplace.bind(this)
                }]);
            }
        }, {
            key: 'reset',
            value: function reset() {
                this.resetButton.state = this.resetButton.consts.PENDING;

                this.sendAction('resetForm', [{
                    url: this.config.resetUrl,
                    onSuccess: this.onSuccess.bind(this),
                    onFail: this.onFail.bind(this),
                    onReplace: this.onReplace.bind(this)
                }]);
            }
        }, {
            key: 'onSuccess',
            value: function onSuccess() {
                this.scrollToTop();
                this.submitButton.state = this.submitButton.consts.SUCCESS;
                this.clearErrors();
            }
        }, {
            key: 'onFail',
            value: function onFail(errorMessageArray) {
                this.scrollToTop();
                this.submitButton.state = this.submitButton.consts.INITIAL;
                this.resetButton.state = this.resetButton.consts.INITIAL;
                this.showErrors(errorMessageArray);
            }
        }, {
            key: 'onReplace',
            value: function onReplace($newForm) {
                this.scrollToTop();
                this.replace($newForm);
            }
        }, {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (this.config.scrollTopAfterSubmit) {
                    // If modal is open, then scroll to the top of the modal
                    var $modal = this.$element.closest('.js-modal');
                    if ($modal.length > 0) {
                        _Util['default'].scrollYToElement($modal, 800);
                    } else {
                        _Util['default'].scrollYToElement(this.$element, 800);
                    }
                }
            }
        }, {
            key: 'replace',
            value: function replace($newForm) {
                this.$element.replaceWith($newForm);
                (0, _$['default'])(document.body).trigger('attachjs');
            }
        }, {
            key: 'showErrors',
            value: function showErrors(errorMessageArray) {
                var $messages = this.$element.find('.js-formComponent-messages');

                $messages.find('.errors-list').empty();
                if (errorMessageArray.length > 0) {
                    var errorHtml = errorMessageArray.map(function (errorMessage) {
                        return '<li>' + errorMessage + '</li>';
                    });
                    $messages.find('.errors-list').append(errorHtml);
                    $messages.removeClass('isHidden');
                }
            }
        }, {
            key: 'clearErrors',
            value: function clearErrors() {
                var $messages = this.$element.find('.js-formComponent-messages');
                $messages.find('.errors-list').empty();
                $messages.addClass('isHidden');
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    submitUrl: { required: true },
                    resetUrl: { required: true },
                    scrollTopAfterSubmit: false
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'submit' }];
            }
        }]);
        return FormComponent;
    })(_Component2['default']);

    module.exports = FormComponent;
});
define('components/LoginFormComponent',['exports', 'module', 'jquery', 'components/FormComponent'], function (exports, module, _jquery, _componentsFormComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _FormComponent2 = babelHelpers.interopRequireDefault(_componentsFormComponent);

    var LoginFormComponent = (function (_FormComponent) {
        babelHelpers.inherits(LoginFormComponent, _FormComponent);

        function LoginFormComponent() {
            babelHelpers.classCallCheck(this, LoginFormComponent);
            babelHelpers.get(Object.getPrototypeOf(LoginFormComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(LoginFormComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(LoginFormComponent.prototype), 'ready', this).apply(this, arguments);

                // Always check the remember me checkbox by default.
                this.$rememberMeCheckbox.prop('checked', true);
                this.$rememberMeHidden.val(this.$rememberMeCheckbox.is(':checked'));

                // Fill in the userName only if if we have both the rememberMe and userName cookies.
                var rememberMeValue = _$['default'].cookie(this.consts.REMEMBER_ME_COOKIE);
                var userName = _$['default'].cookie(this.consts.LOGIN_USERNAME_COOKIE);
                if (rememberMeValue === 'true' && userName) {
                    this.$loginInput.val(userName);
                }
                // If we don't already have the rememberMe cookie set, set it now.
                else if (rememberMeValue !== 'true') {
                        this.rememberMe();
                    }
            }
        }, {
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(LoginFormComponent.prototype), 'queryDom', this).call(this);

                this.$loginInput = this.$element.find('.js-loginInput');
                this.$rememberMeCheckbox = this.$element.find('.js-rememberMe');
                // Liferay generated hidden field - we need to query based on ID
                this.$rememberMeHidden = this.$element.find('#_58_rememberMe');
            }
        }, {
            key: 'enable',
            value: function enable() {
                babelHelpers.get(Object.getPrototypeOf(LoginFormComponent.prototype), 'enable', this).call(this);

                this.$rememberMeCheckbox.on('change', this.onRememberMeCheckboxChange.bind(this));
            }
        }, {
            key: 'submit',
            value: function submit() {
                // Capture the login name.
                _$['default'].cookie(this.consts.LOGIN_USERNAME_COOKIE, this.$loginInput.val(), {
                    expires: 7,
                    path: '/'
                });

                babelHelpers.get(Object.getPrototypeOf(LoginFormComponent.prototype), 'submit', this).call(this);
            }
        }, {
            key: 'onRememberMeCheckboxChange',
            value: function onRememberMeCheckboxChange() {
                this.rememberMe();
                return false;
            }

            // Set the remember me cookie.
        }, {
            key: 'rememberMe',
            value: function rememberMe() {
                _$['default'].cookie(this.consts.REMEMBER_ME_COOKIE, this.$rememberMeCheckbox.is(':checked'), {
                    expires: 7,
                    path: '/'
                });
                // Set the hidden value which gets submitted to Liferay
                this.$rememberMeHidden.val(this.$rememberMeCheckbox.is(':checked'));
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    REMEMBER_ME_COOKIE: 'AG_REMEMBER_ME',
                    LOGIN_USERNAME_COOKIE: 'AG_LOGIN_USERNAME'
                };
            }
        }]);
        return LoginFormComponent;
    })(_FormComponent2['default']);

    module.exports = LoginFormComponent;
});
define('components/MegaMenuComponent',['exports', 'module', 'jquery', 'components/Component'], function (exports, module, _jquery, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var MegaMenuComponent = (function (_Component) {
        babelHelpers.inherits(MegaMenuComponent, _Component);

        function MegaMenuComponent() {
            babelHelpers.classCallCheck(this, MegaMenuComponent);
            babelHelpers.get(Object.getPrototypeOf(MegaMenuComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(MegaMenuComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(MegaMenuComponent.prototype), 'initProps', this).apply(this, arguments);

                this.contentCollection = null;
                this.supercooltimeout = null;
            }
        }, {
            key: 'layout',
            value: function layout() {
                babelHelpers.get(Object.getPrototypeOf(MegaMenuComponent.prototype), 'layout', this).apply(this, arguments);
                this.setContentHeight();
            }
        }, {
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(MegaMenuComponent.prototype), 'queryDom', this).apply(this, arguments);

                this.contentCollection = this._buildContentCollection();
            }
        }, {
            key: 'setContentHeight',
            value: function setContentHeight() {
                // Find the tallest content height
                var height = 0;
                this.$menuContent.each(function (idx, el) {
                    var elHeight = (0, _$['default'])(el).height();
                    if (elHeight > height) {
                        height = elHeight;
                    }
                });
                // Set height for each content item
                this.$menuContent.height(height).addClass('isHidden');
            }
        }, {
            key: 'onNavItemMouseenter',
            value: function onNavItemMouseenter(event) {
                var $target = (0, _$['default'])(event.currentTarget);
                var contentId = $target.attr('data-menu-content');
                if (!contentId) {
                    this.clearActiveTabs();
                } else {
                    this.setActiveTab($target);
                    this.toggleContent(contentId);
                }
                return false;
            }
        }, {
            key: 'onMouseleave',
            value: function onMouseleave() {
                this.clearActiveTabs();
            }
        }, {
            key: 'onPreventTouchLinks',
            value: function onPreventTouchLinks(event) {
                var browserDetect = window.dtnGlobals.browserDetect;

                if (browserDetect.features.touch) {
                    event.preventDefault();
                }
            }
        }, {
            key: 'setActiveTab',
            value: function setActiveTab($target) {
                this.$element.addClass('isActive');
                $target.addClass('isActive');
                $target.siblings().removeClass('isActive');
            }
        }, {
            key: 'clearActiveTabs',
            value: function clearActiveTabs() {
                this.$navItem.removeClass('isActive');
                this.$element.removeClass('isActive');
                this.$menuContent.addClass('isHidden');
            }

            /**
             * Shows specified content and hides siblings
             *
             * @method toggleContent
             * @param {String} contentId Menu content name
             * @returns {undefined} undefined
             */
        }, {
            key: 'toggleContent',
            value: function toggleContent(contentId) {
                if (this.contentCollection[contentId]) {
                    var $menuContentItem = (0, _$['default'])(this.contentCollection[contentId].element);
                    $menuContentItem.removeClass('isHidden');
                    $menuContentItem.siblings().addClass('isHidden');
                }
            }

            /**
             * Builds content object to store each content name and element
             *
             * @method buildContentCollection
             * @returns {object} content collection object
             */
        }, {
            key: '_buildContentCollection',
            value: function _buildContentCollection() {
                var collection = {};
                _$['default'].makeArray(this.$menuContent).forEach(function (element) {
                    var contentId = (0, _$['default'])(element).attr('data-menu-content');
                    collection[contentId] = { element: element };
                });
                return collection;
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$menuContent', selector: '.js-megaMenu-content' }, { prop: '$navItem', selector: '.js-megaMenu-subMenu > ul > li', event: 'mouseenter' }, { prop: '$navItemLink', selector: '.js-megaMenu-trigger-link', event: 'click', func: 'onPreventTouchLinks' }, { event: 'mouseleave' }];
            }
        }]);
        return MegaMenuComponent;
    })(_Component2['default']);

    module.exports = MegaMenuComponent;
});
define('components/MobileMenuComponent',['exports', 'module', 'jquery', 'components/Component'], function (exports, module, _jquery, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var MobileMenuComponent = (function (_Component) {
        babelHelpers.inherits(MobileMenuComponent, _Component);

        function MobileMenuComponent() {
            babelHelpers.classCallCheck(this, MobileMenuComponent);
            babelHelpers.get(Object.getPrototypeOf(MobileMenuComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(MobileMenuComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(MobileMenuComponent.prototype), 'initProps', this).apply(this, arguments);
                this.isOpen = false;
                this.scrollOffset = 0;
                this.makeStickyBtn();
            }
        }, {
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(MobileMenuComponent.prototype), 'queryDom', this).apply(this, arguments);
                this.$app = (0, _$['default'])('.app');
            }
        }, {
            key: 'layout',
            value: function layout() {
                babelHelpers.get(Object.getPrototypeOf(MobileMenuComponent.prototype), 'layout', this).apply(this, arguments);
                // Wrap .app in a div that can be used for scroll locking
            }
        }, {
            key: 'onTriggerClick',
            value: function onTriggerClick() {
                if (this.isOpen) {
                    this.closeMobileMenu();
                } else {
                    this.openMobileMenu();
                }
            }
        }, {
            key: 'onOpenModal',
            value: function onOpenModal() {
                this.closeMobileMenu();
            }
        }, {
            key: 'onDidCloseSneezeGuard',
            value: function onDidCloseSneezeGuard() {
                this.closeMobileMenu();
            }
        }, {
            key: 'onDidEnterDesktop',
            value: function onDidEnterDesktop() {
                this.closeMobileMenu();
            }
        }, {
            key: 'onTransitionend',
            value: function onTransitionend(event) {
                var target = event.target;
                var $element = this.$element;
                var consts = this.consts;
                var isOpen = this.isOpen;

                // If it was the element that finished transitioning and the menu is not
                // open, remove the transition class to prevent the tear effect seen
                // when resizing browsers
                if ((0, _$['default'])(target).is($element) && !isOpen) {
                    $element.removeClass(consts.TRANSITIONING_CLASS);
                }
            }
        }, {
            key: 'openMobileMenu',
            value: function openMobileMenu() {
                if (this.isOpen) {
                    return;
                }

                this._lockPageScroll();
                this.scrollOffset = window.scrollY;
                this.$element.addClass(this.consts.TRANSITIONING_CLASS).addClass(this.consts.OPEN_CLASS);
                this.$triggerIcon.removeClass(this.consts.MENU_ICON_CLASS).addClass(this.consts.CLOSE_ICON_CLASS);
                this.isOpen = true;
                this.sendAction('didOpenMobileMenu');

                this.makeStickyBtn();
            }
        }, {
            key: 'closeMobileMenu',
            value: function closeMobileMenu() {
                if (!this.isOpen) {
                    return;
                }

                this._unlockPageScroll();
                this.$element.removeClass(this.consts.OPEN_CLASS);
                this.$triggerIcon.addClass(this.consts.MENU_ICON_CLASS).removeClass(this.consts.CLOSE_ICON_CLASS);
                this.isOpen = false;
                this.sendAction('didCloseMobileMenu');
                this.makeStickyBtn();
            }

            //transforms the menu position from absolute to fixed. We need keep the menu when it's closed on the header and make it scrollable when it's opened.
        }, {
            key: 'makeStickyBtn',
            value: function makeStickyBtn() {
                window.scrollTo(0, this.isOpen ? 0 : this.scrollOffset);
                this.$element.css({ 'position': this.isOpen ? 'absolute' : 'fixed' });
            }
        }, {
            key: '_lockPageScroll',
            value: function _lockPageScroll() {
                this.$app.css('position', 'static');
                (0, _$['default'])('.footer').hide(0); // footer does not live inside .app for sticky footer purposes
            }
        }, {
            key: '_unlockPageScroll',
            value: function _unlockPageScroll() {
                this.$app.css('position', 'static');
                (0, _$['default'])('.footer').show(0);
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    OPEN_CLASS: 'isOpen',
                    TRANSITIONING_CLASS: 'isTransitioning',
                    MENU_ICON_CLASS: 'icon_menu',
                    CLOSE_ICON_CLASS: 'icon_close'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'transitionend' }, { prop: '$triggerIcon', selector: '.js-mobileMenuComponent-triggerIcon' }, { prop: '$trigger', selector: '.js-mobileMenuComponent-trigger', event: 'click' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'bubble', event: 'openModal' }, { type: 'store', action: 'didCloseSneezeGuard.SneezeGuardComponent' }, { type: 'store', action: 'didEnterDesktop.BreakpointChangeListenerComponent' }];
            }
        }]);
        return MobileMenuComponent;
    })(_Component2['default']);

    module.exports = MobileMenuComponent;
});
define('components/MobileSubmenuComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var MobileSubmenuComponent = (function (_Component) {
        babelHelpers.inherits(MobileSubmenuComponent, _Component);

        function MobileSubmenuComponent() {
            babelHelpers.classCallCheck(this, MobileSubmenuComponent);
            babelHelpers.get(Object.getPrototypeOf(MobileSubmenuComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(MobileSubmenuComponent, [{
            key: 'ready',
            value: function ready() {
                if (this.$element.hasClass(this.consts.IS_OPEN_CLASS)) {
                    this.open();
                } else {
                    this.close();
                }
            }
        }, {
            key: 'onCategoryClick',
            value: function onCategoryClick() {
                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
                return false;
            }
        }, {
            key: 'open',
            value: function open() {
                this.$submenu.stop(true, true).slideDown();
                this.$element.addClass(this.consts.IS_OPEN_CLASS);
                this.isOpen = true;
            }
        }, {
            key: 'close',
            value: function close() {
                this.$submenu.stop(true, true).slideUp();
                this.$element.removeClass(this.consts.IS_OPEN_CLASS);
                this.isOpen = false;
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    IS_OPEN_CLASS: 'isOpen'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$submenu', selector: '.js-mobileSubmenuComponent-submenu' }, { prop: '$category', selector: '.js-mobileSubmenuComponent-category', event: 'click' }];
            }
        }]);
        return MobileSubmenuComponent;
    })(_Component2['default']);

    module.exports = MobileSubmenuComponent;
});
define('components/MobileSearchComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var MobileSearchComponent = (function (_Component) {
        babelHelpers.inherits(MobileSearchComponent, _Component);

        function MobileSearchComponent() {
            babelHelpers.classCallCheck(this, MobileSearchComponent);
            babelHelpers.get(Object.getPrototypeOf(MobileSearchComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(MobileSearchComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(MobileSearchComponent.prototype), 'initProps', this).apply(this, arguments);

                this.isOpen = false;
            }
        }, {
            key: 'onToggleButtonPointerup',
            value: function onToggleButtonPointerup() {
                if (this.isOpen) {
                    this.hide();
                } else {
                    this.show();
                }

                return false;
            }
        }, {
            key: 'onDidOpenMobileMenu',
            value: function onDidOpenMobileMenu() {
                this.hide();
            }
        }, {
            key: 'show',
            value: function show() {
                var _this = this;

                this.$element.addClass(this.consts.IS_ACTIVE);
                this.$formContainer.slideDown(function () {
                    _this.isOpen = true;
                });
            }
        }, {
            key: 'hide',
            value: function hide() {
                var _this2 = this;

                this.$element.removeClass(this.consts.IS_ACTIVE);
                this.$formContainer.slideUp(function () {
                    _this2.isOpen = false;
                });
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    IS_ACTIVE: 'isOpen'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$formContainer', selector: '.js-mobileSearchComponent-formContainer' }, { prop: '$searchInput', selector: '.js-mobileSearchComponent-searchInput' }, { prop: '$toggleButton', selector: '.js-mobileSearchComponent-toggleButton', event: 'pointerup' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'didOpenMobileMenu.MobileMenuComponent' }];
            }
        }]);
        return MobileSearchComponent;
    })(_Component2['default']);

    module.exports = MobileSearchComponent;
});
define('components/ModalComponent',['exports', 'module', 'jquery', 'components/Component'], function (exports, module, _jquery, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    /**
     * Modal implementation with focus on single entry points for opening and closing modals.
     *
     * @class ModalComponent
     * @author lwloszek
     * @usage
     * <body>
     *
     *   <div class="sneezeGuard js-sneezeGuard"></div>
     *
     *   <div class="js-modal dtnModal">
     *       <div class="js-modal-inner dtnModal-inner">
     *           <button class="js-modal-close dtnModalClose">
     *               <i class="icon icon_close"></i>
     *           </button>
     *           <div class="js-modal-contentHolder dtnModal-contentHolder"></div>
     *       </div>
     *   </div>
     *
     *   <div class="isHidden js-modal-content" data-config-modal-id="testModalContent">
     *       Modal content goes here
     *   </div>
     * </body>
     */

    var ModalComponent = (function (_Component) {
        babelHelpers.inherits(ModalComponent, _Component);

        function ModalComponent() {
            babelHelpers.classCallCheck(this, ModalComponent);
            babelHelpers.get(Object.getPrototypeOf(ModalComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ModalComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(ModalComponent.prototype), 'initProps', this).apply(this, arguments);

                this.isOpen = false;
                this.$content = null;
            }
        }, {
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(ModalComponent.prototype), 'queryDom', this).apply(this, arguments);

                this.$document = (0, _$['default'])(document);
                this.$window = (0, _$['default'])(window);
            }
        }, {
            key: 'bindEventHandlers',
            value: function bindEventHandlers() {
                babelHelpers.get(Object.getPrototypeOf(ModalComponent.prototype), 'bindEventHandlers', this).apply(this, arguments);

                this.onKeyUpHandler = this.onKeyUp.bind(this);
            }
        }, {
            key: 'onOpenModal',
            value: function onOpenModal(event, modalId, tabId) {
                event.preventDefault();

                this.open(modalId, tabId);

                return false;
            }
        }, {
            key: 'onCloseModal',
            value: function onCloseModal() {
                this.close();

                return false;
            }
        }, {
            key: 'onDidCloseSneezeGuard',
            value: function onDidCloseSneezeGuard() {
                this.close();
            }
        }, {
            key: 'onKeyUp',
            value: function onKeyUp(event) {
                var keyCode = event.keyCode;
                var which = event.which;
                var ESCAPE_KEY = this.consts.ESCAPE_KEY;

                if (keyCode === ESCAPE_KEY || which === ESCAPE_KEY) {
                    this.close();
                }
            }
        }, {
            key: 'open',
            value: function open(id, tabId) {
                // if a modal is already being displayed, close it first, then open the new modal
                if (this.isOpen) {
                    this.close();
                }

                this.isOpen = true;

                this.$content = (0, _$['default'])('.js-modal-content[data-config-modal-id=' + id + ']');
                this.$element.addClass('dtnModal_isTransitioning');
                this.$element.removeClass('dtnModal_isHidden');
                this.$modalContentHolder.append(this.$content.contents());

                this.setY();
                // Internally, the following cause the page to scroll because of a focus() on the first imput element in the form
                // For this reason, setY MUST be called before this
                if (tabId != null) {
                    this.sendAction('openTab', [tabId]);
                }
                this.setCentered();
                this.setVerticalOffset();

                // Only bind key handler when modal is open
                this.$document.on('keyup', this.onKeyUpHandler);
                this.sendAction('didOpenModal');
            }
        }, {
            key: 'close',
            value: function close() {
                if (this.isOpen) {
                    this.isOpen = false;

                    this.$element.removeClass('dtnModal_isTransitioning');
                    this.$element.addClass('dtnModal_isHidden');
                    this.$modalContentHolder.contents().appendTo(this.$content);

                    this.$document.off('keyup', this.onKeyUpHandler);
                    this.sendAction('didCloseModal');
                }
            }
        }, {
            key: 'setY',
            value: function setY() {
                // Set absolute position of modal to be at the top of the page
                var y = 0;
                this.$element.css('margin-top', y);
            }
        }, {
            key: 'setCentered',
            value: function setCentered() {
                // Vertically center the modal if data-config-modal-centered="true"
                var isCentered = this.$content.data('configModalCentered');

                this.$element.removeClass('dtnModal_centered');
                if (isCentered) {
                    this.$element.addClass('dtnModal_centered');
                }
            }
        }, {
            key: 'setVerticalOffset',
            value: function setVerticalOffset() {
                // Add vertical offset only if the modal is shorter than the window height
                var isCentered = this.$content.data('configModalCentered');

                this.$element.removeClass('dtnModal_verticalOffset');
                if (!isCentered) {
                    var windowHeight = (0, _$['default'])(window).height();
                    var modalHeight = this.$modalInner.outerHeight() + 100; // 100px is the value of dtnModal_verticalOffset

                    if (modalHeight < windowHeight) {
                        this.$element.addClass('dtnModal_verticalOffset');
                    }
                }
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    ESCAPE_KEY: 27 };
            }
        }, {
            key: 'elements',
            // ESC key
            get: function get() {
                return [{ prop: '$modalInner', selector: '.js-modal-inner' }, { prop: '$modalContentHolder', selector: '.js-modal-contentHolder' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'openModal.ModalOpenComponent' }, { type: 'store', action: 'closeModal.ModalCloseComponent' }, { type: 'store', action: 'didCloseSneezeGuard.SneezeGuardComponent' }];
            }
        }]);
        return ModalComponent;
    })(_Component2['default']);

    module.exports = ModalComponent;
});
define('components/ModalOpenComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var ModalOpenComponent = (function (_Component) {
        babelHelpers.inherits(ModalOpenComponent, _Component);

        function ModalOpenComponent() {
            babelHelpers.classCallCheck(this, ModalOpenComponent);
            babelHelpers.get(Object.getPrototypeOf(ModalOpenComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ModalOpenComponent, [{
            key: 'onClick',
            value: function onClick(event) {
                event.preventDefault();

                this.sendAction('openModal', [this.config.modalTarget, this.config.tabTarget]);

                return false;
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    modalTarget: { required: true },
                    tabTarget: null
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return ModalOpenComponent;
    })(_Component2['default']);

    module.exports = ModalOpenComponent;
});
define('components/ModalCloseComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var ModalCloseComponent = (function (_Component) {
        babelHelpers.inherits(ModalCloseComponent, _Component);

        function ModalCloseComponent() {
            babelHelpers.classCallCheck(this, ModalCloseComponent);
            babelHelpers.get(Object.getPrototypeOf(ModalCloseComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ModalCloseComponent, [{
            key: 'onClick',
            value: function onClick() {
                this.sendAction('closeModal');

                return false;
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return ModalCloseComponent;
    })(_Component2['default']);

    module.exports = ModalCloseComponent;
});
define('components/NavMenuComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var NavMenuComponent = (function (_Component) {
        babelHelpers.inherits(NavMenuComponent, _Component);

        function NavMenuComponent() {
            babelHelpers.classCallCheck(this, NavMenuComponent);
            babelHelpers.get(Object.getPrototypeOf(NavMenuComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(NavMenuComponent, [{
            key: 'onPreventTouchLinks',
            value: function onPreventTouchLinks(event) {
                var browserDetect = window.dtnGlobals.browserDetect;

                if (browserDetect.features.touch) {
                    event.preventDefault();
                }
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$parentLink', selector: '.js-navMenu-parentLink', event: 'click', func: 'onPreventTouchLinks' }];
            }
        }]);
        return NavMenuComponent;
    })(_Component2['default']);

    module.exports = NavMenuComponent;
});
define('components/SneezeGuardComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var SneezeGuardComponent = (function (_Component) {
        babelHelpers.inherits(SneezeGuardComponent, _Component);

        function SneezeGuardComponent() {
            babelHelpers.classCallCheck(this, SneezeGuardComponent);
            babelHelpers.get(Object.getPrototypeOf(SneezeGuardComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(SneezeGuardComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(SneezeGuardComponent.prototype), 'initProps', this).apply(this, arguments);

                this.isOpen = false;
            }
        }, {
            key: 'onShouldOpen',
            value: function onShouldOpen() {
                this.open();
            }
        }, {
            key: 'onShouldClose',
            value: function onShouldClose() {
                this.close();
            }
        }, {
            key: 'open',
            value: function open() {
                if (this.isOpen) {
                    return;
                }

                //scroll the modal to the top in case it's coming from mobile menu.
                window.scrollTo(0, 0);
                this.$element.addClass(this.consts.ACTIVE_CLASS);
                this.isOpen = true;
            }
        }, {
            key: 'close',
            value: function close() {
                if (!this.isOpen) {
                    return;
                }

                this.$element.removeClass(this.consts.ACTIVE_CLASS);
                this.isOpen = false;
                this.sendAction('didCloseSneezeGuard');
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    ACTIVE_CLASS: 'isActive'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$guard', selector: '.js-sneezeGuardComponent-guard', event: 'pointerdown', func: 'onShouldClose' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'bubble', event: 'didOpenToggle', func: 'onShouldOpen' }, { type: 'bubble', event: 'didCloseToggle', func: 'onShouldClose' }, { type: 'bubble', event: 'didOpenModal', func: 'onShouldOpen' }, { type: 'bubble', event: 'didCloseModal', func: 'onShouldClose' }, { type: 'bubble', event: 'didOpenMobileMenu', func: 'onShouldOpen' }, { type: 'bubble', event: 'didCloseMobileMenu', func: 'onShouldClose' }];
            }
        }]);
        return SneezeGuardComponent;
    })(_Component2['default']);

    module.exports = SneezeGuardComponent;
});
define('shared-scripts/services/metricsService',['exports', 'module'], function (exports, module) {
    /**
     * Tag Manager + Google Analytics
     * To add new events, see tagmanager.google.com
     *
     * @class metricsService
     * @constructor
     */
    

    var metricsService = {};

    var PARAM_UTM_SOURCE_NAME = 'utm_source'; // Google Analytics Source
    var PARAM_UTM_SOURCE_VALUE = location.protocol + '//' + location.host + location.pathname; // The page that the user is on, no params
    var PARAM_UTM_CAMPAIGN_NAME = 'utm_campaign'; // Google Analytics Campaign
    var PARAM_UTM_CAMPAIGN_VALUE = 'free_trial';
    var PARAM_UTM_MEDIUM_NAME = 'utm_medium'; // Google Analytics Medium
    var PARAM_UTM_CONTENT_NAME = 'utm_content'; // Google Analytics Content

    metricsService.timings = {};
    metricsService.START = 'start';
    metricsService.END = 'end';

    // Google Analytics queue
    window.dataLayer = window.dataLayer || [];

    // Sets dimensions for GA event calls
    // Ensure this runs before the Tag Manager page view tag fires,
    // or custom dimensions pushed here will not be included
    metricsService.setDimensions = function () {
        var userId = window.dtnGlobals.userId;
        var metricsDimensions = window.dtnGlobals.metricsDimensions;

        if (metricsDimensions != null) {
            window.dataLayer.push({
                userId: userId,
                product: metricsDimensions.product,
                menuName: metricsDimensions.menuName,
                contentType: metricsDimensions.contentType,
                contentName: metricsDimensions.contentName,
                authorName: metricsDimensions.authorName,
                commodityName: metricsDimensions.commodityName
            });
        }
    };

    // Register a Page view
    metricsService.virtualPageView = function () {
        window.dataLayer.push({
            'event': 'virtualPageView'
        });
    };

    /**
     *  Log a page load timing duration.
     *
     * var: pageLoad
     * category: {{ Section Loaded }}
     * value: {{ Duration In Milliseconds}}
     */
    metricsService.pageLoadTime = function (startOrEnd, sectionLoaded, timeInMilliseconds) {
        switch (startOrEnd) {
            case metricsService.START:
                this.timings[sectionLoaded] = { start: timeInMilliseconds };
                break;

            case metricsService.END:
                var timing = this.timings[sectionLoaded];
                if (timing == null) {
                    timing = { start: 0 };
                }
                timing.end = timeInMilliseconds;

                var total = Math.floor(timing.end - timing.start);

                //console.log(sectionLoaded, total);

                // If browser doesn't support performance.now(), we can't
                // reliably measure timing, so skip tracking in that case
                if (!isNaN(total)) {
                    window.dataLayer.push({
                        'event': 'pageLoadTime',
                        sectionLoaded: sectionLoaded,
                        'durationInMilliseconds': total
                    });
                }
                break;

            default:
                break;
        }
    };

    // Returns the number of milliseconds since the user first requested the page
    // Returns NaN if the browser doesn't support performance.now() natively, since there is no alternative way to
    // get an accurate measurement in that case
    metricsService.now = function () {
        return window.performance != null && typeof window.performance.now === 'function' ? window.performance.now() : NaN;
    };

    // Trigger to tell tag manager we viewed an article or blog post page
    metricsService.articleViewed = function () {
        window.dataLayer.push({
            'event': 'articleViewed'
        });
    };

    /**
     * category: Audio
     * action: Play
     * label: {{ File Name }}
     */
    metricsService.audioPlay = function (fileName) {
        window.dataLayer.push({
            'event': 'audioPlay',
            fileName: fileName
        });
    };

    /**
     * category: Video
     * action: Play {{ Video Title }}
     * label: {{ Video Description }}
     */
    metricsService.videoPlay = function (videoTitle, videoDescription) {
        window.dataLayer.push({
            'event': 'videoPlay',
            videoTitle: videoTitle,
            videoDescription: videoDescription
        });
    };

    /**
     * category: Video
     * action: Watched {{ Video Title }}
     * label: {{ Video Description }}
     */
    metricsService.videoWatched = function (videoTitle, videoDescription) {
        window.dataLayer.push({
            'event': 'videoWatched',
            videoTitle: videoTitle,
            videoDescription: videoDescription
        });
    };

    /**
     * category: Comment
     * action: {{ Content Type }}
     * label: {{ Content Name }}
     */
    metricsService.commentEntry = function (contentType, contentName) {
        window.dataLayer.push({
            'event': 'commentEntry',
            contentType: contentType,
            contentName: contentName
        });
    };

    /**
     * category: Commodity
     * action: {{ Portlet }}
     * label: {{ Commodity Name }}
     */
    metricsService.commodityEntry = function (portlet, commodityName) {
        window.dataLayer.push({
            'event': 'commodityEntry',
            portlet: portlet,
            commodityName: commodityName
        });
    };

    /**
     * category: Expand
     * action: {{ Portlet }}
     * label: {{ Content Name }}
     */
    metricsService.expandClick = function (portlet, contentName) {
        window.dataLayer.push({
            'event': 'expandClick',
            portlet: portlet,
            contentName: contentName
        });
    };

    /**
     * category: File Download
     * action: {{ Portlet }}
     * label: {{ File Name }}
     */
    metricsService.fileDownload = function (portlet, fileName) {
        window.dataLayer.push({
            'event': 'fileDownload',
            portlet: portlet,
            fileName: fileName
        });
    };

    /**
     * category: Link
     * action: {{ Link Type }}
     * label: {{ Link Title }}
     */
    metricsService.linkClick = function (linkType, linkTitle) {
        window.dataLayer.push({
            'event': 'linkClick',
            linkType: linkType,
            linkTitle: linkTitle
        });
    };

    /**
     * category: Map
     * action: Layer
     * label: {{ Map Layer Name }}
     */
    metricsService.mapLayerClick = function (mapLayerName) {
        window.dataLayer.push({
            'event': 'mapLayerClick',
            mapLayerName: mapLayerName
        });
    };

    /**
     * category: Location
     * action: {{ Portlet }}
     * label: {{ Location Name }}
     */
    metricsService.locationEntry = function (portlet, locationTerm) {
        window.dataLayer.push({
            'event': 'locationEntry',
            portlet: portlet,
            locationTerm: locationTerm
        });
    };

    /**
     * category: Refresh
     * action: {{ Portlet }}
     */
    metricsService.refreshClick = function (portlet) {
        window.dataLayer.push({
            'event': 'refreshClick',
            portlet: portlet
        });
    };

    /**
     * category: Social
     * label: {{ Social Media Service }}
     */
    metricsService.socialShare = function (service) {
        window.dataLayer.push({
            'event': 'socialShare',
            service: service
        });
    };

    /**
     * category: Search
     * action: {{ Portlet }}
     * label: {{ Search Term }}
     */
    metricsService.searchEntry = function (portlet, searchTerm) {
        window.dataLayer.push({
            'event': 'searchEntry',
            portlet: portlet,
            searchTerm: searchTerm
        });
    };

    /**
     * Tab-Click Event Tracker [Public]
     * category: Tab
     * action: {{ Portlet }}
     * label: {{ Tab Name }}
     */
    metricsService.tabClick = function (portlet, tabName) {
        window.dataLayer.push({
            'event': 'tabClick',
            portlet: portlet,
            tabName: tabName
        });
    };

    /**
     * PREMIUM CODE FOLLOWS - THIS FILE SHOULD PROBABLY BE PULLED OUT OF SHARED AND
     * A PREMIUM VERSION CREATED TO INCLUDE THE CODE BELOW. THERE IS NOTHING IN COMMON
     * BETWEEN PUBLIC/PREMIUM. @RK
     *
     * Google Tag Manager tracking for tab-click events [Premium].
     * @param portlet The portlet title/name
     * @param contentName (aka: tabName/data-tab-id)
     */
    metricsService.tabClick = function (portlet, tabName) {
        this.gaEvent('Tab', portlet, tabName, '');
    };

    metricsService.recommendationsDisplayed = function (recommendationEngine, articleTitle) {
        var category = 'Content';
        var action = recommendationEngine + ' Recommendations Viewed';
        var label = 'On article "' + articleTitle + '"';
        var value = '';
        this.gaEvent(category, action, label, value);
    };

    /**
     * Dynamic Event Tracker [Premium]
     * Google Tag Manager global events tracking.
     * @param category
     * @param action
     * @param label
     * @param value (optional)
     */
    metricsService.gaEvent = function (category, action, label, value) {
        window.dataLayer.push({
            'event': 'gaEvent',
            'category': category,
            'action': action,
            'label': label,
            'value': value
        });
    };

    metricsService.getCampaignParams = function ($element) {
        var campaignParams = {};
        campaignParams[PARAM_UTM_SOURCE_NAME] = encodeURIComponent(PARAM_UTM_SOURCE_VALUE);
        campaignParams[PARAM_UTM_CAMPAIGN_NAME] = PARAM_UTM_CAMPAIGN_VALUE;
        campaignParams[PARAM_UTM_MEDIUM_NAME] = $element.data('configUtmMedium');
        campaignParams[PARAM_UTM_CONTENT_NAME] = $element.data('configUtmContent');
        return campaignParams;
    };

    module.exports = metricsService;
});
define('components/OoyalaVideoPlayerComponent',['exports', 'module', 'jquery', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _jquery, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var OoyalaVideoPlayerComponent = (function (_Component) {
        babelHelpers.inherits(OoyalaVideoPlayerComponent, _Component);

        function OoyalaVideoPlayerComponent() {
            babelHelpers.classCallCheck(this, OoyalaVideoPlayerComponent);
            babelHelpers.get(Object.getPrototypeOf(OoyalaVideoPlayerComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(OoyalaVideoPlayerComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(OoyalaVideoPlayerComponent.prototype), 'ready', this).apply(this, arguments);

                this.sendAction('didStartLoading');
                // Get the ooyala video script, given a configured player id
                this._initVideo();
            }
        }, {
            key: '_initVideo',
            value: function _initVideo() {
                // Set an instance id for the video container
                var videoContainerInstanceId = 'videoContainer' + Math.floor(Math.random() * 1000000);
                this.$videoContainer.attr('id', videoContainerInstanceId);

                window.OO.ready((function () {
                    window.OO.Player.create(videoContainerInstanceId, this.config.embedCode, {
                        view: 'channel',
                        wmode: 'transparent',
                        onCreate: this.onCreate.bind(this)
                    });
                }).bind(this));
            }
        }, {
            key: 'onReload',
            value: function onReload() {
                var incomingEmbedCode = this.$element.attr('data-config-embed-code');
                var currEmbedCode = this.config ? this.config.embedCode : '';
                if (incomingEmbedCode === currEmbedCode) {
                    return;
                }

                // Destroy previous player instance
                if (this.player != null) {
                    this.player.destroy();
                }

                // Reset the config manually, .data() is cached
                this.config = {
                    embedCode: incomingEmbedCode,
                    videoTitle: this.$element.attr('data-config-video-title'),
                    videoDescription: this.$element.attr('data-config-video-description')
                };

                this._initVideo();
            }
        }, {
            key: 'onCreate',
            value: function onCreate(player) {

                var self = this;
                var videoTitle = self.config.videoTitle;
                var videoDescription = self.config.videoDescription;

                // Ooyala documentation doesn't explain what the 2nd paramenter is, so null it is.
                player.subscribe('playbackReady', null, function () {
                    self.enoughSeconds = 0.90 * player.getDuration();
                    self.sendAction('didStopLoading');
                });

                // Collect stats when video is started
                player.subscribe('StartScreenClick', null, function () {
                    _metricsService['default'].videoPlay(videoTitle, videoDescription);
                });

                // Collect stats when more than 90% of the video has been watched
                player.subscribe('playheadTimeChanged', null, function (event, seconds) {
                    if (seconds >= self.enoughSeconds && self.enoughSeconds > 0) {
                        _metricsService['default'].videoWatched(videoTitle, videoDescription);
                        self.enoughSeconds = -1;
                    }
                });

                // Collect stats at the end if not done at the 90% mark
                player.subscribe('played', null, function () {
                    if (self.enoughSeconds > 0) {
                        _metricsService['default'].videoWatched(videoTitle, videoDescription);
                    }
                });

                this.player = player;
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    embedCode: { required: true }
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$videoContainer', selector: '.js-ooyalaVideoContainer' }, { event: 'reload' }];
            }
        }]);
        return OoyalaVideoPlayerComponent;
    })(_Component2['default']);

    module.exports = OoyalaVideoPlayerComponent;
});
define('lib-thirdparty/mout/time/now',[],function () {

    /**
     * Get current time in miliseconds
     */
    var now = (typeof Date.now === 'function')? Date.now : function(){
        return +(new Date());
    };

    return now;

});

define('lib-thirdparty/mout/function/throttle',['../time/now'], function (now) {

    /**
     */
    function throttle(fn, delay){
        var context, timeout, result, args,
            cur, diff, prev = 0;
        function delayed(){
            prev = now();
            timeout = null;
            result = fn.apply(context, args);
        }
        function throttled(){
            context = this;
            args = arguments;
            cur = now();
            diff = delay - (cur - prev);
            if (diff <= 0) {
                clearTimeout(timeout);
                prev = cur;
                result = fn.apply(context, args);
            } else if (! timeout) {
                timeout = setTimeout(delayed, diff);
            }
            return result;
        }
        return throttled;
    }

    return throttle;

});

define('components/SmoothScrollingComponent',['exports', 'module', 'jquery', 'lib-thirdparty/mout/function/throttle', 'components/Component'], function (exports, module, _jquery, _libThirdpartyMoutFunctionThrottle, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _throttle = babelHelpers.interopRequireDefault(_libThirdpartyMoutFunctionThrottle);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var SmoothScrollingComponent = (function (_Component) {
        babelHelpers.inherits(SmoothScrollingComponent, _Component);

        function SmoothScrollingComponent() {
            babelHelpers.classCallCheck(this, SmoothScrollingComponent);
            babelHelpers.get(Object.getPrototypeOf(SmoothScrollingComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(SmoothScrollingComponent, [{
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(SmoothScrollingComponent.prototype), 'queryDom', this).apply(this, arguments);

                this.$window = (0, _$['default'])(window);
                this.$scollableElement = (0, _$['default'])('html, body');
            }
        }, {
            key: 'bindEventHandlers',
            value: function bindEventHandlers() {
                babelHelpers.get(Object.getPrototypeOf(SmoothScrollingComponent.prototype), 'bindEventHandlers', this).apply(this, arguments);

                this.onWindowScrollHandler = this.onWindowScroll.bind(this);
            }
        }, {
            key: 'enable',
            value: function enable() {
                babelHelpers.get(Object.getPrototypeOf(SmoothScrollingComponent.prototype), 'enable', this).apply(this, arguments);

                // Throttle added to stop the scroll event from firing on every single scroll.
                // Edge case: if page is set to a very short height the throttle may cause
                // the toTop button not to show up.
                this.$window.on('scroll.SmoothScrollingComponent', (0, _throttle['default'])(this.onWindowScrollHandler, 50));
            }
        }, {
            key: 'disable',
            value: function disable() {
                babelHelpers.get(Object.getPrototypeOf(SmoothScrollingComponent.prototype), 'disable', this).apply(this, arguments);

                this.$window.off('scroll.SmoothScrollingComponent');
            }
        }, {
            key: 'onClick',
            value: function onClick() {
                this.$scollableElement.animate({
                    scrollTop: 0
                }, this.consts.SCROLL_SPEED);

                return false;
            }
        }, {
            key: 'onWindowScroll',
            value: function onWindowScroll() {
                var currentLocation = this.$window.scrollTop();

                if (currentLocation >= this.consts.OFFSET) {
                    this.$element.addClass(this.consts.IS_VISIBLE_CLASS);
                } else if (currentLocation < this.consts.OFFSET) {
                    this.$element.removeClass(this.consts.IS_VISIBLE_CLASS);
                }
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    SCROLL_SPEED: 500,
                    OFFSET: 230,
                    IS_VISIBLE_CLASS: 'isVisible'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return SmoothScrollingComponent;
    })(_Component2['default']);

    module.exports = SmoothScrollingComponent;
});
define('components/ToggleComponent',['exports', 'module', 'jquery', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _jquery, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    /**
     * Toggle Component
     *
     * Simpler alternative to using ToggleContentComponent
     *
     * @deprecates ToggleContentComponent.js
     * @class ToggleComponent
     */

    var ToggleComponent = (function (_Component) {
        babelHelpers.inherits(ToggleComponent, _Component);

        function ToggleComponent() {
            babelHelpers.classCallCheck(this, ToggleComponent);
            babelHelpers.get(Object.getPrototypeOf(ToggleComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ToggleComponent, [{
            key: 'initProps',
            value: function initProps() {
                this.isExpanded = false;
            }
        }, {
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(ToggleComponent.prototype), 'queryDom', this).apply(this, arguments);

                this.$expanded = (0, _$['default'])('[data-config-toggle-expanded=' + this.config.toggleTarget + ']');
                this.$collapsed = (0, _$['default'])('[data-config-toggle-collapsed=' + this.config.toggleTarget + ']');
                this.urlTriggerHash = this.$element.attr('data-url-hash-trigger');
            }
        }, {
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(ToggleComponent.prototype), 'ready', this).apply(this, arguments);

                // Make sure initial state is collapsed
                this.$element.removeClass(this.consts.activeClass);
                this.hide(this.$expanded);
                this.unhide(this.$collapsed);

                if (this.urlTriggerHash && this.urlTriggerHash === window.location.hash) {
                    this.expand();
                }
            }
        }, {
            key: 'onClick',
            value: function onClick() {
                this.toggle();

                return false;
            }
        }, {
            key: 'toggle',
            value: function toggle() {
                if (this.isExpanded) {
                    this.collapse();
                } else {
                    this.expand();
                }
            }
        }, {
            key: 'expand',
            value: function expand() {
                this.isExpanded = true;

                _metricsService['default'].expandClick(this.config.portletTitle, this.config.action);

                this.$element.addClass(this.consts.activeClass);
                this.unhide(this.$expanded);
                this.hide(this.$collapsed);

                if (this.config.sneezeGuardHide) {
                    this.sendAction('didOpenToggle');
                }
                if (this.config.toggleTriggerHide) {
                    this.$element.addClass(this.consts.hiddenClass);
                }
            }
        }, {
            key: 'collapse',
            value: function collapse() {
                this.isExpanded = false;

                this.$element.removeClass(this.consts.activeClass);
                this.hide(this.$expanded);
                this.unhide(this.$collapsed);

                if (this.config.sneezeGuardHide) {
                    this.sendAction('didCloseToggle');
                }
            }
        }, {
            key: 'onDidCloseSneezeGuard',
            value: function onDidCloseSneezeGuard() {
                this.collapse();
            }
        }, {
            key: 'hide',
            value: function hide($element) {
                $element.addClass(this.consts.hiddenClass);
            }
        }, {
            key: 'unhide',
            value: function unhide($element) {
                $element.removeClass(this.consts.hiddenClass);
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    toggleTarget: { required: true },
                    sneezeGuardHide: false,
                    toggleTriggerHide: false,
                    portletTitle: { required: true },
                    action: { required: true }
                };
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    hiddenClass: 'isHidden',
                    activeClass: 'isActive'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'didCloseSneezeGuard.SneezeGuardComponent' }];
            }
        }]);
        return ToggleComponent;
    })(_Component2['default']);

    module.exports = ToggleComponent;
});
define('components/TermsOfServiceToggleComponent',['exports', 'module', 'jquery', 'lib/Util', 'components/ToggleComponent'], function (exports, module, _jquery, _libUtil, _componentsToggleComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _ToggleComponent2 = babelHelpers.interopRequireDefault(_componentsToggleComponent);

    /**
     * Terms of Service Toggle Component
     *
     * Toggle Component implementation whose sole purpose is to retrieve and populate the terms of service.
     *
     * @deprecates ToggleContentComponent.js
     * @class ToggleComponent
     */

    var TermsOfServiceToggleComponent = (function (_ToggleComponent) {
        babelHelpers.inherits(TermsOfServiceToggleComponent, _ToggleComponent);

        function TermsOfServiceToggleComponent() {
            babelHelpers.classCallCheck(this, TermsOfServiceToggleComponent);
            babelHelpers.get(Object.getPrototypeOf(TermsOfServiceToggleComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(TermsOfServiceToggleComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(TermsOfServiceToggleComponent.prototype), 'ready', this).apply(this, arguments);

                this.tosPopulated = false;
            }
        }, {
            key: 'expand',
            value: function expand() {
                var _this = this;

                babelHelpers.get(Object.getPrototypeOf(TermsOfServiceToggleComponent.prototype), 'expand', this).call(this);

                if (this.tosPopulated) {
                    return;
                }

                this.sendAction('didStartLoading');
                _Util['default'].getHTML(this.config.renderUrl).done(function ($html, status) {
                    var successfulResponse = status === 'success' && $html && $html.indexOf('encountered an error') === -1;
                    if (successfulResponse) {
                        _this.$expanded.html($html);
                        _this.tosPopulated = true;
                    } else {
                        _this.$expanded.html("Error loading terms of service, please try again later.");
                    }
                    _this.sendAction('didStopLoading');
                });
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    toggleTarget: "termsOfService",
                    sneezeGuardHide: false,
                    toggleTriggerHide: false,
                    portletTitle: "Join Our Community",
                    action: "Terms of Service Expanded",
                    renderUrl: { required: true }
                };
            }
        }]);
        return TermsOfServiceToggleComponent;
    })(_ToggleComponent2['default']);

    module.exports = TermsOfServiceToggleComponent;
});
define('components/RecaptchaComponent',['exports', 'module', 'components/Component', 'jquery'], function (exports, module, _componentsComponent, _jquery) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var RecaptchaComponent = (function (_Component) {
        babelHelpers.inherits(RecaptchaComponent, _Component);

        function RecaptchaComponent() {
            babelHelpers.classCallCheck(this, RecaptchaComponent);
            babelHelpers.get(Object.getPrototypeOf(RecaptchaComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(RecaptchaComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(RecaptchaComponent.prototype), 'initProps', this).apply(this, arguments);

                this.widgetId = null;
            }

            // Should be called every time form is re-rendered
            //
            // - Upon first show of modal
            // - After form submittal
        }, {
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(RecaptchaComponent.prototype), 'ready', this).apply(this, arguments);

                if (!this.config.deferInitialize) {
                    this.create();
                }
            }

            // Executes only when registration tab is clicked
        }, {
            key: 'onDidOpenTab',
            value: function onDidOpenTab(event, tabId) {
                // TODO: why in the world does this get called twice if we only triggered the action once?
                // console.log('onDidOpenTab', event, tabId);

                if (tabId === 'signup') {
                    this.create();
                }

                return false;
            }

            // Create recapcha element
        }, {
            key: 'create',
            value: function create() {
                RecaptchaComponent.loadScript().then(this.render.bind(this));
            }

            // Load recaptcha script tag asyncronously
            // All instances of this component will use the same promise
        }, {
            key: 'render',
            value: function render(recaptchaAPI) {
                if (this.widgetId != null) {
                    return;
                }

                this.widgetId = recaptchaAPI.render(this.$element[0], { 'sitekey': this.config.sitekey });

                /*
                    Recaptcha steals focus in IE11
                    Delete this when we get rid of IE11
                */
                var _window$dtnGlobals$browserDetect$browser = window.dtnGlobals.browserDetect.browser;
                var ie = _window$dtnGlobals$browserDetect$browser.ie;
                var ieVersion = _window$dtnGlobals$browserDetect$browser.ieVersion;

                if (ie && Number(ieVersion) === 11) {
                    recaptchaAPI.reset();
                    (0, _$['default'])('#firstName').trigger('focus');
                }
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    sitekey: { required: true },
                    deferInitialize: { required: true }
                };
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'didOpenTab.TabsComponent' }];
            }
        }], [{
            key: 'loadScript',
            value: function loadScript() {
                if (RecaptchaComponent.loadScriptPromise == null) {
                    RecaptchaComponent.loadScriptPromise = new Promise(function (resolve) {
                        // callback that will execute after ReCAPTCHA script loads
                        window.onRecaptchaLoad = function () {
                            resolve(window.grecaptcha);
                        };

                        RecaptchaComponent.fetchScript('onRecaptchaLoad');
                    });
                }

                return RecaptchaComponent.loadScriptPromise;
            }
        }, {
            key: 'fetchScript',
            value: function fetchScript(callbackName) {
                var script = document.createElement('script');
                script.async = true;
                script.src = '//www.google.com/recaptcha/api.js?onload=' + callbackName + '&render=explicit';
                var container = document.getElementsByTagName('script')[0];
                container.parentNode.insertBefore(script, container);
            }
        }]);
        return RecaptchaComponent;
    })(_Component2['default']);

    module.exports = RecaptchaComponent;
});
define('components/ShowHidePasswordComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var ShowHidePasswordComponent = (function (_Component) {
        babelHelpers.inherits(ShowHidePasswordComponent, _Component);

        function ShowHidePasswordComponent() {
            babelHelpers.classCallCheck(this, ShowHidePasswordComponent);
            babelHelpers.get(Object.getPrototypeOf(ShowHidePasswordComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ShowHidePasswordComponent, [{
            key: 'onShowHideTriggerClick',
            value: function onShowHideTriggerClick() {
                if (this.$showHideContent.prop(this.consts.INPUT_TYPE) === this.consts.INPUT_TYPE_PASSWORD) {
                    this.$showHideContent.attr(this.consts.INPUT_TYPE, 'text');
                } else {
                    this.$showHideContent.attr(this.consts.INPUT_TYPE, this.consts.INPUT_TYPE_PASSWORD);
                }
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    INPUT_TYPE: 'type',
                    INPUT_TYPE_PASSWORD: 'password'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$showHideContent', selector: '.js-showHidePasswordComponent-input' }, { prop: '$showHideTrigger', selector: '.js-showHidePasswordComponent-trigger', event: 'click' }];
            }
        }]);
        return ShowHidePasswordComponent;
    })(_Component2['default']);

    module.exports = ShowHidePasswordComponent;
});
define('components/RegularSpinnerComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
  

  var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

  var regularSpinnerSVG = '\n<div class="spinner2-wrapper">\n\n        <svg class="lds-spinner" width="150px"  height="150px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="rotate(0 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(30 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(60 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(90 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(120 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(150 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(180 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(210 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(240 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(270 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(300 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"></animate>\n  </rect>\n</g><g transform="rotate(330 50 50)">\n  <rect x="47" y="12.5" rx="15.51" ry="4.125" width="6" height="25" fill="#6c6c6c">\n    <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animate>\n  </rect>\n</g></svg>\n\n</div>\n';

  /**
   * Loading Spinner Component
   *
   * @class
   */

  var RegularSpinnerComponent = (function (_Component) {
    babelHelpers.inherits(RegularSpinnerComponent, _Component);

    function RegularSpinnerComponent() {
      babelHelpers.classCallCheck(this, RegularSpinnerComponent);
      babelHelpers.get(Object.getPrototypeOf(RegularSpinnerComponent.prototype), 'constructor', this).apply(this, arguments);
    }

    babelHelpers.createClass(RegularSpinnerComponent, [{
      key: 'layout',
      value: function layout() {
        babelHelpers.get(Object.getPrototypeOf(RegularSpinnerComponent.prototype), 'layout', this).apply(this, arguments);
        this.$element.prepend(regularSpinnerSVG);

        if (this.config.startActive) {
          this.startSpinner();
        }
      }
    }, {
      key: 'onDidStartLoading',
      value: function onDidStartLoading(e) {
        e.stopPropagation();
        this.startSpinner();
      }
    }, {
      key: 'onDidStopLoading',
      value: function onDidStopLoading(e) {
        e.stopPropagation();
        this.stopSpinner();
      }
    }, {
      key: 'startSpinner',
      value: function startSpinner() {
        this.$element.addClass(this.consts.ACTIVE_CLASS);
      }
    }, {
      key: 'stopSpinner',
      value: function stopSpinner() {
        this.$element.removeClass(this.consts.ACTIVE_CLASS);
      }
    }, {
      key: 'consts',
      get: function get() {
        return {
          ACTIVE_CLASS: 'isActive'
        };
      }
    }, {
      key: 'defaults',
      get: function get() {
        return {
          startActive: false
        };
      }
    }, {
      key: 'actions',
      get: function get() {
        return [{ type: 'bubble', event: 'didStartLoading' }, { type: 'bubble', event: 'didStopLoading' }];
      }
    }]);
    return RegularSpinnerComponent;
  })(_Component2['default']);

  module.exports = RegularSpinnerComponent;
});
define('components/StopPropagationComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var StopPropagationComponent = (function (_Component) {
        babelHelpers.inherits(StopPropagationComponent, _Component);

        function StopPropagationComponent() {
            babelHelpers.classCallCheck(this, StopPropagationComponent);
            babelHelpers.get(Object.getPrototypeOf(StopPropagationComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(StopPropagationComponent, [{
            key: 'onClick',
            value: function onClick(e) {
                e.stopPropagation();
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return StopPropagationComponent;
    })(_Component2['default']);

    module.exports = StopPropagationComponent;
});
define('components/TabsComponent',['exports', 'module', 'jquery', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _jquery, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var TabsComponent = (function (_Component) {
        babelHelpers.inherits(TabsComponent, _Component);

        function TabsComponent() {
            babelHelpers.classCallCheck(this, TabsComponent);
            babelHelpers.get(Object.getPrototypeOf(TabsComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(TabsComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(TabsComponent.prototype), 'ready', this).apply(this, arguments);

                if (!this.$tabTrigger.hasClass(this.consts.IS_ACTIVE_CLASS)) {
                    this.setActiveTabIndex(0);
                }
            }
        }, {
            key: 'onOpenTab',
            value: function onOpenTab(event, tabId) {
                this.setActiveTabId(tabId);

                return false;
            }
        }, {
            key: 'onTabTriggerClick',
            value: function onTabTriggerClick(event) {
                if (event.currentTarget.className.indexOf("js-tab-skip") > 0) {

                    window.location.href = String(event.currentTarget.attributes.href.value);
                    //window.history.pushState({path: window.location.href},'', window.location.href);

                    return true; // we want to skip the tabs if we have .js-tab-skip
                }

                var $trigger = (0, _$['default'])(event.currentTarget);
                var tabId = $trigger.attr('data-tab-content');
                var portletTitle = $trigger.attr('data-config-portlet-title');
                var tabName = $trigger.attr('data-config-tab-name');

                this.setActiveTabId(tabId);

                if (portletTitle != null && tabName != null) {
                    _metricsService['default'].tabClick(portletTitle, tabName);
                }

                return false;
            }
        }, {
            key: 'setActiveTabIndex',
            value: function setActiveTabIndex(tabIndex) {
                var tabId = this.$tabTrigger.eq(tabIndex).attr('data-tab-content');
                this.setActiveTabId(tabId);
            }
        }, {
            key: 'setActiveTabId',
            value: function setActiveTabId(tabId) {
                var $trigger = this.$tabTrigger.filter('[data-tab-content="' + tabId + '"]');
                var contentId = $trigger.attr(this.consts.DATA_TAB_CONTENT);

                this.$tabTrigger.removeClass(this.consts.IS_ACTIVE_CLASS);
                $trigger.addClass(this.consts.IS_ACTIVE_CLASS);
                this.toggleContent(contentId);

                this.sendAction('didOpenTab', [tabId]);
            }

            /**
             * Shows specified content and hides siblings
             *
             * @method toggleContent
             * @param {String} contentId Menu content name
             * @returns {undefined} undefined
             */
        }, {
            key: 'toggleContent',
            value: function toggleContent(contentId) {
                var $tabContentItem = this._getTabContent(contentId);

                if ($tabContentItem.length > 0) {
                    $tabContentItem.removeClass(this.consts.IS_HIDDEN_CLASS);
                    $tabContentItem.siblings().addClass(this.consts.IS_HIDDEN_CLASS);

                    // Auto-focus the first visible input field found, if any
                    var browserDetect = window.dtnGlobals.browserDetect;

                    if (!browserDetect.features.touch) {
                        $tabContentItem.find('input:visible').first().focus();
                    }
                }
            }
        }, {
            key: '_getTabContent',
            value: function _getTabContent(contentId) {
                var $tabContentItem = this.$tabContent.filter('[' + this.consts.DATA_TAB_CONTENT + '="' + contentId + '"]');

                return $tabContentItem;
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    IS_ACTIVE_CLASS: 'isActive',
                    IS_HIDDEN_CLASS: 'isHidden',
                    DATA_TAB_CONTENT: 'data-tab-content'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$tabContent', selector: '.js-tabs-content' }, { prop: '$tabTrigger', selector: '.js-tabs-trigger', event: 'click' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'openTab.ModalComponent' }];
            }
        }]);
        return TabsComponent;
    })(_Component2['default']);

    module.exports = TabsComponent;
});
define('services/tooltip',['exports', 'module'], function (exports, module) {
    

    module.exports = {
        getTooltipDirection: function getTooltipDirection(tooltip, windowDimensions) {
            var tooltipDirection = '';

            // position tooltip top
            if (tooltip.contentHeight + tooltip.triggerHeight > tooltip.triggerPosTop < window.pageYOffset) {
                tooltipDirection = 't';
            }

            // position tooltip bottom
            if (window.pageYOffset + tooltip.contentHeight + tooltip.triggerHeight > tooltip.triggerPosTop) {
                tooltipDirection = 'b';
            }

            // position tooltip left
            if (windowDimensions.width < tooltip.triggerPosLeft + tooltip.contentWidth / 2 + tooltip.triggerWidth && tooltip.triggerPosLeft > tooltip.contentWidth) {
                tooltipDirection = 'l';
            }

            // position tooltip right
            if (tooltip.triggerPosLeft < tooltip.contentWidth / 2 + tooltip.triggerWidth && tooltip.contentWidth < tooltip.triggerPosLeft) {
                tooltipDirection = 'r';
            }

            // default to top if special positioning is not required
            if (tooltipDirection === '') {
                tooltipDirection = 't';
            }

            return tooltipDirection;
        },

        getTooltipPosition: function getTooltipPosition(tooltip, windowDimensions, tooltipDirection) {
            var verticalMiddle = (-tooltip.contentHeight + tooltip.triggerHeight) / 2;
            var horizontalMiddle = (-tooltip.contentWidth + tooltip.triggerWidth) / 2;
            var tooltipPosition = {
                top: 0,
                left: 0
            };

            switch (tooltipDirection) {
                case 'l':
                    tooltipPosition.top = verticalMiddle;
                    tooltipPosition.left = -tooltip.contentWidth;
                    break;
                case 'r':
                    tooltipPosition.top = verticalMiddle;
                    tooltipPosition.left = tooltip.triggerWidth;
                    break;
                case 'b':
                    tooltipPosition.top = tooltip.triggerHeight;
                    tooltipPosition.left = horizontalMiddle;
                    preventClipping();
                    break;
                default:
                    // defaults to top
                    tooltipPosition.top = -tooltip.contentHeight;
                    tooltipPosition.left = horizontalMiddle;
                    preventClipping();
                    break;
            }

            // in cases where tooltips open on top or bottom and get horizontally clipped (narrow mobile displays), this will
            // adjust the left/right position to fit the tooltip on the screen.
            function preventClipping() {
                if (-tooltip.triggerPosLeft > tooltipPosition.left) {
                    tooltipPosition.left = -tooltip.triggerPosLeft;
                } else if (tooltip.triggerPosLeft + tooltip.contentWidth + tooltipPosition.left > windowDimensions.width) {
                    tooltipPosition.left = -tooltip.triggerPosLeft - tooltip.contentWidth + windowDimensions.width;
                }
            }

            return tooltipPosition;
        }
    };
});
define('components/TooltipComponent',['exports', 'module', 'jquery', 'components/Component', 'services/tooltip'], function (exports, module, _jquery, _componentsComponent, _servicesTooltip) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _tooltipService = babelHelpers.interopRequireDefault(_servicesTooltip);

    var $window = (0, _$['default'])(window);

    var TooltipComponent = (function (_Component) {
        babelHelpers.inherits(TooltipComponent, _Component);

        function TooltipComponent() {
            babelHelpers.classCallCheck(this, TooltipComponent);
            babelHelpers.get(Object.getPrototypeOf(TooltipComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(TooltipComponent, [{
            key: 'bindEventHandlers',
            value: function bindEventHandlers() {
                babelHelpers.get(Object.getPrototypeOf(TooltipComponent.prototype), 'bindEventHandlers', this).apply(this, arguments);

                this.onTriggerClickHandler = this.onTriggerClick.bind(this);
                this.onTriggerMouseenterHandler = this.onTriggerMouseenter.bind(this);
                this.onTriggerMouseoutHandler = this.onTriggerMouseout.bind(this);
            }
        }, {
            key: 'enable',
            value: function enable() {
                babelHelpers.get(Object.getPrototypeOf(TooltipComponent.prototype), 'enable', this).apply(this, arguments);

                if (this.$element.attr('data-tooltip-type') === 'click') {
                    this.$trigger.on('click.TooltipComponent', this.onTriggerClickHandler);
                } else {
                    this.$trigger.on('mouseenter.TooltipComponent', this.onTriggerMouseenterHandler);
                    this.$trigger.on('mouseout.TooltipComponent', this.onTriggerMouseoutHandler);
                }
            }
        }, {
            key: 'disable',
            value: function disable() {
                babelHelpers.get(Object.getPrototypeOf(TooltipComponent.prototype), 'disable', this).apply(this, arguments);

                this.$trigger.off('click.TooltipComponent');
                this.$trigger.off('mouseenter.TooltipComponent');
                this.$element.off('mouseout.TooltipComponent');
            }
        }, {
            key: 'onTriggerMouseenter',
            value: function onTriggerMouseenter(event) {
                event.preventDefault();

                var triggerOffset = (0, _$['default'])(event.currentTarget).offset();

                this.openTooltip(triggerOffset);
            }
        }, {
            key: 'onTriggerMouseout',
            value: function onTriggerMouseout(event) {
                event.preventDefault();

                this.closeTooltip();
            }
        }, {
            key: 'onTriggerClick',
            value: function onTriggerClick(event) {
                var triggerLocation = {
                    left: (0, _$['default'])(event.currentTarget).offset().left,
                    top: (0, _$['default'])(event.currentTarget).offset().top
                };
                if (this.$element.hasClass(this.consts.IS_ACTIVE_CLASS)) {
                    this.closeTooltip();
                } else {
                    this.openTooltip(triggerLocation);
                }

                return false;
            }
        }, {
            key: 'openTooltip',
            value: function openTooltip(triggerLocation) {
                if (this.tooltipProperties) {
                    this.$content.removeClass(this.tooltipProperties.tooltipClass);
                }
                this.tooltipProperties = this.getTooltipProperties(triggerLocation);
                this.$content.addClass(this.tooltipProperties.tooltipClass);
                this.positionTooltip(this.tooltipProperties);
                this.$element.addClass(this.consts.IS_ACTIVE_CLASS);
            }
        }, {
            key: 'closeTooltip',
            value: function closeTooltip() {
                this.$element.removeClass(this.consts.IS_ACTIVE_CLASS);
            }
        }, {
            key: 'positionTooltip',
            value: function positionTooltip(tooltipProperties) {
                this.$content.css({ top: tooltipProperties.position.top, left: tooltipProperties.position.left });
                if (tooltipProperties.tooltipDirection === 't' || tooltipProperties.tooltipDirection === 'b') {
                    this.$pointer.css({ left: -tooltipProperties.position.left - this.$trigger.width() / 2 });
                } else {
                    this.$pointer.css({ left: -tooltipProperties.position.left });
                }
            }
        }, {
            key: 'getTooltipProperties',
            value: function getTooltipProperties(triggerLocation) {
                var tooltip = {
                    contentWidth: this.$content.outerWidth(),
                    contentHeight: this.$content.outerHeight(),
                    triggerWidth: this.$trigger.outerWidth(),
                    triggerHeight: this.$trigger.outerHeight(),
                    triggerPosLeft: triggerLocation.left,
                    triggerPosTop: triggerLocation.top
                };

                var windowDimensions = {
                    height: $window.height(),
                    width: $window.width()
                };

                var tooltipDirection = _tooltipService['default'].getTooltipDirection(tooltip, windowDimensions);
                var tooltipPosition = _tooltipService['default'].getTooltipPosition(tooltip, windowDimensions, tooltipDirection);

                var tooltipProperties = {
                    tooltipClass: this.consts.TOOLTIP_PREFIX_CLASS + tooltipDirection,
                    position: tooltipPosition,
                    tooltipDirection: tooltipDirection
                };

                return tooltipProperties;
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    IS_ACTIVE_CLASS: 'isActive',
                    TOOLTIP_PREFIX_CLASS: 'tooltip-content_'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$trigger', selector: '.js-tooltip-trigger' }, { prop: '$content', selector: '.js-tooltip-content' }, { prop: '$pointer', selector: '.js-tooltip-content-pointer' }];
            }
        }]);
        return TooltipComponent;
    })(_Component2['default']);

    module.exports = TooltipComponent;
});
define('components/ReadMoreComponent',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var ReadMoreComponent = (function (_Component) {
        babelHelpers.inherits(ReadMoreComponent, _Component);

        function ReadMoreComponent() {
            babelHelpers.classCallCheck(this, ReadMoreComponent);
            babelHelpers.get(Object.getPrototypeOf(ReadMoreComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ReadMoreComponent, [{
            key: 'onTriggerClick',
            value: function onTriggerClick() {
                if (!this.$element.hasClass(this.consts.IS_ACTIVE_CLASS)) {
                    this.$element.addClass(this.consts.IS_ACTIVE_CLASS);
                    this.$trigger.text('Read Less');
                    _metricsService['default'].expandClick(this.config.portletTitle, 'Read More Clicked');
                } else {
                    this.$element.removeClass(this.consts.IS_ACTIVE_CLASS);
                    this.$trigger.text('Read More');
                }

                return false;
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    portletTitle: { required: true }
                };
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    IS_ACTIVE_CLASS: 'isActive'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$trigger', selector: '.js-readMoreComponent-trigger', event: 'click' }];
            }
        }]);
        return ReadMoreComponent;
    })(_Component2['default']);

    module.exports = ReadMoreComponent;
});
define('shared-scripts/lib/Logger',['require','jquery','./Util'],function (require) {
    
    var $ = require('jquery');
    var Util = require('./Util');

    /**
     * Check if the client has a console.
     *
     * @return boolean
     */
    function hasConsole () {
        return window.console && typeof window.console !== 'undefined';
    }

    /**
     * Logger component.
     *
     * @class Logger
     * @constructor
     * @param {string} url
     */
    var Logger = function (url) {
        this.url = url;
        this.levels =
        {
            'disable' : -1,
            'error' : 0,
            'warn' : 1,
            'info' : 2,
            'log' : 2,
            'debug' : 3
        };
    };

    /**
     * Configure this logger as the object that handles trapped errors from <code>ErrorTrapper</code>.
     *
     * @method registerForTrappedErrors
     */
    Logger.prototype.registerForTrappedErrors = function () {
    };

    /**
     * Event handler for a 'errortrap' event. Calls <code>error()</code> on this with the given error.
     *
     * @method onError
     * @param {Event} e The triggering 'errortrap' event
     * @param {object} error The error to log.
     */
    Logger.prototype.onError = function (e, error) {
        this.error(error);
    };

    /**
     * Log a message.
     *
     * @method _log
     * @param {*} method
     * @param {string} message
     * @private
     */
    Logger.prototype._log = function (method, message) {
        if (hasConsole()) {
            if (window.console[method]) {
                window.console[method](message);
            } else {
                window.console.log(message);
            }
        }

        // Connect this logger to the first portlet on the page, so that it can perform remote logging.
        if (this.url == null) {
            this.url = $('.js-portletLog').data('logUrl');
        }

        if (this.url && this.levels[method] <= this.levels[window.dtnGlobals.minRemoteLogLevel]) {
            var url = this.url
                .replace('replace-me-message', encodeURIComponent($.trim(message)))
                .replace('replace-me-level', encodeURIComponent(method));

            Util.get(url);
        }
    };

    /**
     * Log a log message.
     *
     * @method log
     * @param {string} message
     */
    Logger.prototype.log = function (message) {
        this._log('log', message);
    };

    /**
     * Log a debug message.
     *
     * @method debug
     * @param {string} message
     */
    Logger.prototype.debug = function (message) {
        this._log('debug', message);
    };

    /**
     * Log an info message.
     *
     * @method info
     * @param {string} message
     */
    Logger.prototype.info = function (message) {
        this._log('info', message);
    };

    /**
     * Log a warning message.
     *
     * @method warn
     * @param {string} message
     */
    Logger.prototype.warn = function (message) {
        this._log('warn', message);
    };

    /**
     * Log an error message.
     *
     * @method error
     * @param {string} message
     */
    Logger.prototype.error = function (message) {
        this._log('error', message);
    };

    /**
     * Assert a condition is met.
     *
     * @method assert
     * @param {boolean} condition
     * @param {string} message
     */
    Logger.prototype.assert = function (condition, message) {
        if (hasConsole()) {
            window.console.assert(condition, message);
        }
    };

    return Logger;
});

/**
 * @fileOverview LoadingSpinnerComponent module definition
 *
 * @author [add author name here]
 */
define('shared-scripts/components/LoadingSpinnerComponent',['require','jquery'],function (require) {
    
    var $ = require('jquery');

    var LoadingSpinnerComponent = function (settings) {
        this.$el = $('<div class="loadingSpinner"></div>');
        this.size = 1;
        var defaultSettings = {
            size: 1
        };
        this.settings = $.extend({}, defaultSettings, settings);

        this.setupSpinner();
    };

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    LoadingSpinnerComponent.isSafeToCallDestroy = false;
    LoadingSpinnerComponent.id = 'LoadingSpinnerComponent';
    LoadingSpinnerComponent.prototype.constructor = LoadingSpinnerComponent;

    LoadingSpinnerComponent.prototype.setupSpinner = function () {

        var size = this.settings.size;
        var borderWidth = size * 0.1;
        var position = size * 0.5 + borderWidth * 0.75;

        this.$el.css({
            'width': size + 'em',
            'height': size + 'em',
            'top': 'calc(50% - ' + position + 'em)',
            'left': 'calc(50% - ' + position + 'em)',
            'border-width': borderWidth + 'em',
            'position': 'absolute',
            'z-index': '2'
        });

        return this;

    };


    return LoadingSpinnerComponent;
});

/**
 * @author Kevin Moot
 * @file BaseComponent module definition
 */
define('shared-scripts/components/BaseComponent',['require','../lib/Util','jquery','../lib/Logger','./LoadingSpinnerComponent'],function (require) {
    

    var Util = require('../lib/Util');
    var $ = require('jquery');
    var Logger = require('../lib/Logger');
    var LoadingSpinnerComponent = require('./LoadingSpinnerComponent');

    /**
     * Base component for other components to extend from.
     *
     * @class BaseComponent
     * @constructor
     */
    var BaseComponent = function (type) {
        /**
         * A reference to the class type.
         *
         * @property type
         * @type {Class}
         */
        this.type = type;

        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = null;

        /**
         * Tracks whether component is enabled.
         *
         * @property isEnabled
         * @type {boolean}
         */
        this.isEnabled = false;

        /**
         * Tracks whether component is initialized.
         *
         * @property isInitialized
         * @type {boolean}
         */
        this.isInitialized = false;

        /**
         * Tracks the current breakpoint state.
         *
         * @property currentBreakpoint
         * @type {window.dtnGlobals.breakpointType}
         */
        this.currentBreakpoint = null;

        /**
         * Tracks the current orientation state.
         *
         * @property currentOrientation
         * @type {window.dtnGlobals.orientationType}
         */
        this.currentOrientation = null;
    };

    /**
     * Initializes the UI Component View.
     *
     * Runs a single setupHandlers call, followed by createChildren and layout
     * Exits early if it is already initialized.
     *
     * @chainable
     * @method init
     */
    BaseComponent.prototype.init = function () {
        if (this.isInitialized || Util.isInitialized(this.$element, this.type.id)) {
            return this;
        }
        var logUrl = this.$element.parents('.js-portletLog').data('logUrl');
        this.logger = new Logger(logUrl);

        this.isInitialized = true;
        Util.setInitialized(this.$element, this.type.id, true);

        this.onInit() // Call implementation of child function
            .setupHandlers()
            .createChildren()
            .layout()
            .enable();

        return this;
    };

    /**
     * Binds the scope of any handler functions.
     *
     * Should only be run on initialization of the view.
     *
     * @chainable
     * @method setupHandlers
     */
    BaseComponent.prototype.setupHandlers = function () {
        // Bind event handlers scope here
        this.breakpointChangeHandler = this.breakpointChange.bind(this);
        this.destroyHandler = this.destroy.bind(this);

        this.onSetupHandlers(); // Call implementation of child function
        return this;
    };

    /**
     * Create any child objects or references to DOM elements.
     *
     * Should only be run on initialization of the view.
     *
     * @chainable
     * @method createChildren
     */
    BaseComponent.prototype.createChildren = function () {
        Util.subscribe('breakpointChange', this.breakpointChangeHandler);
        if (this.$element) {
            this.$element.on('destroy.' + this.type.id, this.destroyHandler);
            this.$element.on('domTeardown.' + this.type.id, $.noop); //jquery special event fired upon element destroy
        }

        this.onCreateChildren(); // Call implementation of child function

        //Enters the corresponding breakpoint for the current screen size.
        //Should only be run on initialization of the view
        var currentBreakpoint = Util.getCurrentBreakpoint(); // Refresh from current global breakpoint state

        if (currentBreakpoint === window.dtnGlobals.breakpointType.DESKTOP) {
            this.onDesktopEnter();
        } else if (currentBreakpoint === window.dtnGlobals.breakpointType.MOBILE) {
            this.onMobileEnter();
        }

        var currentOrientation = Util.getCurrentOrientation(); // Refresh from current global orientation state

        if (currentOrientation === window.dtnGlobals.orientationType.PORTRAIT) {
            this.onPortraitEnter();
        } else if (currentOrientation === window.dtnGlobals.orientationType.LANDSCAPE) {
            this.onLandscapeEnter();
        }

        return this;
    };

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @chainable
     * @method removeChildren
     */
    BaseComponent.prototype.removeChildren = function () {
        this.onRemoveChildren(); // Call implementation of child function
        return this;
    };

    /**
     * Performs measurements and applys any positioning style logic.
     *
     * Should be run anytime the parent layout changes.
     *
     * @chainable
     * @method layout
     */
    BaseComponent.prototype.layout = function () {
        this.onLayout();
        return this;
    };

    /**
     * Enables the component.
     *
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @chainable
     * @method enable
     */
    BaseComponent.prototype.enable = function () {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.onEnable(); // Call implementation of child function
        return this;
    };

    /**
     * Disables the component.
     *
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @chainable
     * @method disable
     */
    BaseComponent.prototype.disable = function () {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;

        this.onDisable(); // Call implementation of child function
        return this;
    };

    /**
     * Destroys the component.
     *
     * Tears down any events, handlers, elements.
     * Should be called when the object should be left unused.
     *
     * @chainable
     * @method destroy
     */
    BaseComponent.prototype.destroy = function () {
        // only destroy the component if on the "white list" to safely do so
        // TODO: after testing onDestroy() method of all components remove this check
        // and destroy all components no matter what
        if (this.type.isSafeToCallDestroy !== false) {
            this.isInitialized = false;

            Util.unsubscribe('breakpointChange', this.breakpointChangeHandler);

            if (this.$element) {
                // Note: if element isn't properly destroyed, this could
                // cause an infinite loop since we are attaching and then getting
                // re-attached again
                Util.setInitialized(this.$element, this.type.id, false);

                this.$element.off('destroy.' + this.type.id, this.destroyHandler);
                this.$element.off('domTeardown.' + this.type.id, $.noop);
            }

            this.disable()
                .removeChildren()
                .onDestroy(); // Call implementation of child function
        }

        return this;
    };

    /*
     * Tells the component to destory itself, and then re-create
     */
    BaseComponent.prototype.reattach = function () {
        // only destroy the component if on the "white list" to safely do so
        // TODO: after testing onDestroy() method of all components remove this check
        // and destroy all components no matter what
        if (this.type.isSafeToCallDestroy !== false) {
            // Trap a reference to $element since it will be lost upon calling destroy()
            var $element = this.$element;

            // Destroy and then re-initialize the component
            this.destroy();
            $element.trigger('attachjs');
        }
    };

    BaseComponent.prototype.onReRender = function (e, $element) {
        this.reRender($element);
    };

    /**
     * Rerender the component.
     *
     * @method reRender
     */
    BaseComponent.prototype.reRender = function ($element, reRenderEndpoint, params) {
        if (!$element || $element === null) {
            $element = this.$element;
        }
        if (params === null || typeof params === 'undefined') {
            params = {};
        }

        // Always send down a "recache" param on rerender so that we can invalidate the cache for this portlet.
        // The assumption is that any time a portlet is re-rendered, we are doing so due to a change affecting
        // portlet state.
        params.recache = true;

        var spinner = new LoadingSpinnerComponent({size: 3});
        var $spinner = spinner.$el;
        var wasOpen = $element.find('.js-visibilityToggle-target').attr('data-was-open');
        if (!reRenderEndpoint || reRenderEndpoint == null) {
            reRenderEndpoint = $element.attr('data-rerender-endpoint');
        }
        var reRenderAt = $element.attr('data-rerender-at-selector');
        var $parent;

        if (reRenderAt) {
            $parent = $element.parents(reRenderAt);
        } else {
            $parent = $element.parent();
        }

        var h = $parent.height();
        $parent.css('height', h).empty().append($spinner);

        Util.getHTML(reRenderEndpoint, params)
            .done(this.onHtmlLoadSuccess.bind(this, reRenderEndpoint, reRenderAt, $parent, $spinner, wasOpen))
            .fail(this.onHtmlLoadFailure.bind(this, reRenderEndpoint, reRenderAt, $parent, $spinner, wasOpen));
    };

    /**
     * Success callback for deferred load of portlet HTML.
     *
     * @method onHtmlLoadSuccess
     * @param {string} reRenderEndpoint
     * @param {string} reRenderAt
     * @param {jQuery} $parent
     * @param {jQuery} $spinner
     * @param {boolean} wasOpen
     * @param {string} htmlResponse
     */
    BaseComponent.prototype.onHtmlLoadSuccess = function (
        reRenderEndpoint,
        reRenderAt,
        $parent,
        $spinner,
        wasOpen,
        htmlResponse
    ) {
        var $html;
        if (reRenderAt) {
            $html = $(htmlResponse).find(reRenderAt);
        } else {
            $html = $(htmlResponse);
        }

        if ($html.length > 0) {
            // if portlet was originally open, we want to preserve that
            if (wasOpen) {
                $html.find('.js-visibilityToggle-target').attr('data-was-open', wasOpen);
            }

            $parent.append($html)
                   .css('height', '')
                   .trigger('attachjs');
        } else {
            var errorMessage = 'Failed to fetch new content: target content not found.';

            $parent.text(errorMessage);
        }

        $spinner.remove();
    };

    /**
     * Failure callback for deferred load of portlet HTML.
     *
     * @method onHtmlLoadFailure
     * @param {string} reRenderEndpoint
     * @param {string} reRenderAt
     * @param {jQuery} $parent
     * @param {jQuery} $spinner
     * @param {boolean} wasOpen
     * @param {jqXHR} jqXHR
     * @param {string} textStatus
     * @param {string} errorThrown
     */
    /*jshint -W072 */
    BaseComponent.prototype.onHtmlLoadFailure = function (
        reRenderEndpoint,
        reRenderAt,
        $parent,
        $spinner,
        wasOpen,
        jqXHR,
        textStatus,
        errorThrown
    ) {
        $parent.text('Failed to fetch new content: ' + jqXHR.status + ' ' + jqXHR.statusText);

        $spinner.remove();
    };

    /**
     * Breakpoint handler
     * Event handler for all breakpoint or orientation changes.
     * Dispatches the appropriate method based on type parameter supplied.
     *
     * @method breakpoint
     * @param {Event} JS event object
     * @param {string} type The event type to dispatch
     * @see BreakpointListener
     */
    BaseComponent.prototype.breakpointChange = function (e, type) {
        switch (type) {
            case 'portraitEnter':
                this.onPortraitEnter();
                break;
            case 'portraitExit':
                this.onPortraitExit();
                break;
            case 'landscapeEnter':
                this.onLandscapeEnter();
                break;
            case 'landscapeExit':
                this.onLandscapeExit();
                break;
            case 'mobileEnter':
                this.onMobileEnter();
                break;
            case 'mobileExit':
                this.onMobileExit();
                break;
            case 'desktopEnter':
                this.onDesktopEnter();
                break;
            case 'desktopExit':
                this.onDesktopExit();
                break;
            case 'viewportChange':
                this.onViewportChange();
                break;
        }
    };

    //////////////////////////////////////////////////////////////////////
    // Abstract functions to be implemented by child classes
    //////////////////////////////////////////////////////////////////////

    /**
     * On init handler.
     *
     * @chainable
     * @method onInit
     */
    BaseComponent.prototype.onInit = function () {
        return this;
    };

    /**
     * On setup handlers.
     *
     * @chainable
     * @method onSetupHandlers
     */
    BaseComponent.prototype.onSetupHandlers = function () {
        return this;
    };

    /**
     * On create children handler.
     *
     * @chainable
     * @method onCreateChildren
     */
    BaseComponent.prototype.onCreateChildren = function () {
        return this;
    };

    /**
     * On remove children handler
     *
     * @chainable
     * @method onRemoveChildren
     */
    BaseComponent.prototype.onRemoveChildren = function () {
        return this;
    };

    /**
     * On layout handler
     *
     * @chainable
     * @method onLayout
     */
    BaseComponent.prototype.onLayout = function () {
        return this;
    };

    /**
     * On enable handler
     *
     * @chainable
     * @method onEnable
     */
    BaseComponent.prototype.onEnable = function () {
        return this;
    };

    /**
     * On disable handler
     *
     * @chainable
     * @method onDisable
     */
    BaseComponent.prototype.onDisable = function () {
        return this;
    };

    /**
     * On destroy handler
     *
     * @chainable
     * @method onDestroy
     */
    BaseComponent.prototype.onDestroy = function () {
        return this;
    };

    /**
     * On desktop enter handler
     *
     * @chainable
     * @method onDesktopEnter
     */
    BaseComponent.prototype.onDesktopEnter = function () {
        return this;
    };

    /**
     * On desktop exit handler
     *
     * @chainable
     * @method onDesktopExit
     */
    BaseComponent.prototype.onDesktopExit = function () {
        return this;
    };

    /**
     * On desktop exit handler
     *
     * @chainable
     * @method onDesktopExit
     */
    BaseComponent.prototype.onViewportChange = function () {
        return this;
    };

    /**
     * On mobile enter handler
     *
     * @chainable
     * @method onMobileEnter
     */
    BaseComponent.prototype.onMobileEnter = function () {
        return this;
    };

    /**
     * On mobile exit handler
     *
     * @chainable
     * @method onMobileExit
     */
    BaseComponent.prototype.onMobileExit = function () {
        return this;
    };

    /**
     * On portrait enter handler
     *
     * @chainable
     * @method onPortraitEnter
     */
    BaseComponent.prototype.onPortraitEnter = function () {
        return this;
    };

    /**
     * On portrait exit handler
     *
     * @chainable
     * @method onPortraitExit
     */
    BaseComponent.prototype.onPortraitExit = function () {
        return this;
    };

    /**
     * On landscape enter handler
     *
     * @chainable
     * @method onLandscapeEnter
     */
    BaseComponent.prototype.onLandscapeEnter = function () {
        return this;
    };

    /**
     * On landscape exit handler
     *
     * @chainable
     * @method onLandscapeExit
     */
    BaseComponent.prototype.onLandscapeExit = function () {
        return this;
    };

    return BaseComponent;
});

define('services/metricsService',['exports', 'module'], function (exports, module) {
    /**
     * Tag Manager + Google Analytics
     * To add new events, see tagmanager.google.com
     *
     * @class metricsService
     * @constructor
     */
    

    var metricsService = {};

    var PARAM_UTM_SOURCE_NAME = 'utm_source'; // Google Analytics Source
    var PARAM_UTM_SOURCE_VALUE = location.protocol + '//' + location.host + location.pathname; // The page that the user is on, no params
    var PARAM_UTM_CAMPAIGN_NAME = 'utm_campaign'; // Google Analytics Campaign
    var PARAM_UTM_CAMPAIGN_VALUE = 'free_trial';
    var PARAM_UTM_MEDIUM_NAME = 'utm_medium'; // Google Analytics Medium
    var PARAM_UTM_CONTENT_NAME = 'utm_content'; // Google Analytics Content

    metricsService.timings = {};
    metricsService.START = 'start';
    metricsService.END = 'end';

    // Google Analytics queue
    window.dataLayer = window.dataLayer || [];

    // Sets dimensions for GA event calls
    // Ensure this runs before the Tag Manager page view tag fires,
    // or custom dimensions pushed here will not be included
    metricsService.setDimensions = function () {
        var userId = window.dtnGlobals.userId;
        var metricsDimensions = window.dtnGlobals.metricsDimensions;

        if (metricsDimensions != null) {
            window.dataLayer.push({
                userId: userId,
                product: metricsDimensions.product,
                menuName: metricsDimensions.menuName,
                contentType: metricsDimensions.contentType,
                contentName: metricsDimensions.contentName,
                authorName: metricsDimensions.authorName,
                commodityName: metricsDimensions.commodityName
            });
        }
    };

    // Register a Page view
    metricsService.virtualPageView = function () {
        window.dataLayer.push({
            'event': 'virtualPageView'
        });
    };

    /**
     *  Log a page load timing duration.
     *
     * var: pageLoad
     * category: {{ Section Loaded }}
     * value: {{ Duration In Milliseconds}}
     */
    metricsService.pageLoadTime = function (startOrEnd, sectionLoaded, timeInMilliseconds) {
        switch (startOrEnd) {
            case metricsService.START:
                this.timings[sectionLoaded] = { start: timeInMilliseconds };
                break;

            case metricsService.END:
                var timing = this.timings[sectionLoaded];
                if (timing == null) {
                    timing = { start: 0 };
                }
                timing.end = timeInMilliseconds;

                var total = Math.floor(timing.end - timing.start);

                //console.log(sectionLoaded, total);

                // If browser doesn't support performance.now(), we can't
                // reliably measure timing, so skip tracking in that case
                if (!isNaN(total)) {
                    window.dataLayer.push({
                        'event': 'pageLoadTime',
                        sectionLoaded: sectionLoaded,
                        'durationInMilliseconds': total
                    });
                }
                break;

            default:
                break;
        }
    };

    // Returns the number of milliseconds since the user first requested the page
    // Returns NaN if the browser doesn't support performance.now() natively, since there is no alternative way to
    // get an accurate measurement in that case
    metricsService.now = function () {
        return window.performance != null && typeof window.performance.now === 'function' ? window.performance.now() : NaN;
    };

    // Trigger to tell tag manager we viewed an article or blog post page
    metricsService.articleViewed = function () {
        window.dataLayer.push({
            'event': 'articleViewed'
        });
    };

    /**
     * category: Audio
     * action: Play
     * label: {{ File Name }}
     */
    metricsService.audioPlay = function (fileName) {
        window.dataLayer.push({
            'event': 'audioPlay',
            fileName: fileName
        });
    };

    /**
     * category: Video
     * action: Play {{ Video Title }}
     * label: {{ Video Description }}
     */
    metricsService.videoPlay = function (videoTitle, videoDescription) {
        window.dataLayer.push({
            'event': 'videoPlay',
            videoTitle: videoTitle,
            videoDescription: videoDescription
        });
    };

    /**
     * category: Video
     * action: Watched {{ Video Title }}
     * label: {{ Video Description }}
     */
    metricsService.videoWatched = function (videoTitle, videoDescription) {
        window.dataLayer.push({
            'event': 'videoWatched',
            videoTitle: videoTitle,
            videoDescription: videoDescription
        });
    };

    /**
     * category: Comment
     * action: {{ Content Type }}
     * label: {{ Content Name }}
     */
    metricsService.commentEntry = function (contentType, contentName) {
        window.dataLayer.push({
            'event': 'commentEntry',
            contentType: contentType,
            contentName: contentName
        });
    };

    /**
     * category: Commodity
     * action: {{ Portlet }}
     * label: {{ Commodity Name }}
     */
    metricsService.commodityEntry = function (portlet, commodityName) {
        window.dataLayer.push({
            'event': 'commodityEntry',
            portlet: portlet,
            commodityName: commodityName
        });
    };

    /**
     * category: Expand
     * action: {{ Portlet }}
     * label: {{ Content Name }}
     */
    metricsService.expandClick = function (portlet, contentName) {
        window.dataLayer.push({
            'event': 'expandClick',
            portlet: portlet,
            contentName: contentName
        });
    };

    /**
     * category: File Download
     * action: {{ Portlet }}
     * label: {{ File Name }}
     */
    metricsService.fileDownload = function (portlet, fileName) {
        window.dataLayer.push({
            'event': 'fileDownload',
            portlet: portlet,
            fileName: fileName
        });
    };

    /**
     * category: Link
     * action: {{ Link Type }}
     * label: {{ Link Title }}
     */
    metricsService.linkClick = function (linkType, linkTitle) {
        window.dataLayer.push({
            'event': 'linkClick',
            linkType: linkType,
            linkTitle: linkTitle
        });
    };

    /**
     * category: Map
     * action: Layer
     * label: {{ Map Layer Name }}
     */
    metricsService.mapLayerClick = function (mapLayerName) {
        window.dataLayer.push({
            'event': 'mapLayerClick',
            mapLayerName: mapLayerName
        });
    };

    /**
     * category: Location
     * action: {{ Portlet }}
     * label: {{ Location Name }}
     */
    metricsService.locationEntry = function (portlet, locationTerm) {
        window.dataLayer.push({
            'event': 'locationEntry',
            portlet: portlet,
            locationTerm: locationTerm
        });
    };

    /**
     * category: Refresh
     * action: {{ Portlet }}
     */
    metricsService.refreshClick = function (portlet) {
        window.dataLayer.push({
            'event': 'refreshClick',
            portlet: portlet
        });
    };

    /**
     * category: Social
     * label: {{ Social Media Service }}
     */
    metricsService.socialShare = function (service) {
        window.dataLayer.push({
            'event': 'socialShare',
            service: service
        });
    };

    /**
     * category: Search
     * action: {{ Portlet }}
     * label: {{ Search Term }}
     */
    metricsService.searchEntry = function (portlet, searchTerm) {
        window.dataLayer.push({
            'event': 'searchEntry',
            portlet: portlet,
            searchTerm: searchTerm
        });
    };

    /**
     * Tab-Click Event Tracker [Public]
     * category: Tab
     * action: {{ Portlet }}
     * label: {{ Tab Name }}
     */
    metricsService.tabClick = function (portlet, tabName) {
        window.dataLayer.push({
            'event': 'tabClick',
            portlet: portlet,
            tabName: tabName
        });
    };

    /**
     * PREMIUM CODE FOLLOWS - THIS FILE SHOULD PROBABLY BE PULLED OUT OF SHARED AND
     * A PREMIUM VERSION CREATED TO INCLUDE THE CODE BELOW. THERE IS NOTHING IN COMMON
     * BETWEEN PUBLIC/PREMIUM. @RK
     *
     * Google Tag Manager tracking for tab-click events [Premium].
     * @param portlet The portlet title/name
     * @param contentName (aka: tabName/data-tab-id)
     */
    metricsService.tabClick = function (portlet, tabName) {
        this.gaEvent('Tab', portlet, tabName, '');
    };

    metricsService.recommendationsDisplayed = function (recommendationEngine, articleTitle) {
        var category = 'Content';
        var action = recommendationEngine + ' Recommendations Viewed';
        var label = 'On article "' + articleTitle + '"';
        var value = '';
        this.gaEvent(category, action, label, value);
    };

    /**
     * Dynamic Event Tracker [Premium]
     * Google Tag Manager global events tracking.
     * @param category
     * @param action
     * @param label
     * @param value (optional)
     */
    metricsService.gaEvent = function (category, action, label, value) {
        window.dataLayer.push({
            'event': 'gaEvent',
            'category': category,
            'action': action,
            'label': label,
            'value': value
        });
    };

    metricsService.getCampaignParams = function ($element) {
        var campaignParams = {};
        campaignParams[PARAM_UTM_SOURCE_NAME] = encodeURIComponent(PARAM_UTM_SOURCE_VALUE);
        campaignParams[PARAM_UTM_CAMPAIGN_NAME] = PARAM_UTM_CAMPAIGN_VALUE;
        campaignParams[PARAM_UTM_MEDIUM_NAME] = $element.data('configUtmMedium');
        campaignParams[PARAM_UTM_CONTENT_NAME] = $element.data('configUtmContent');
        return campaignParams;
    };

    module.exports = metricsService;
});
define('components/AccordionTableComponent',['require','jquery','shared-scripts/components/BaseComponent','services/metricsService'],function (require) {
    

    var $ = require('jquery');
    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var metricsService = require('services/metricsService');

    function AccordionTableComponent ($element, browserDetect) {
        this.$element = $element;
        this.browserDetect = browserDetect;

        this.init();
    }

    AccordionTableComponent.id = 'AccordionTableComponent';
    AccordionTableComponent.prototype = new BaseComponent(AccordionTableComponent);
    AccordionTableComponent.prototype.constructor = AccordionTableComponent;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    AccordionTableComponent.prototype.onSetupHandlers = function () {
        this.onTriggerClickHandler = this.onTriggerClick.bind(this);
        this.onRowClickHandler = this.onRowClick.bind(this);
        this.onLinkClickHandler = this.onLinkClick.bind(this);

        return this;
    };

    AccordionTableComponent.prototype.onCreateChildren = function () {
        this.$toggleRows = this.$element.find('.js-accordionTable-toggleRow');
        this.$baseRows = this.$element.find('.js-accordionTable-baseRow');
        this.$dataChunks = this.$toggleRows.find('.js-accordionTable-dataToggleChunk');
        this.$alertsChunks = this.$toggleRows.find('.js-accordionTable-alertsToggleChunk');
        this.$activeRow = null;
        this.$activeTrigger = null;

        return this;
    };

    AccordionTableComponent.prototype.onRemoveChildren = function () {
        this.$toggleRows = null;
        this.$baseRows = null;
        this.$dataChunks = null;
        this.$alertsChunks = null;
        this.$activeRow = null;
        this.$activeTrigger = null;

        return this;
    };

    AccordionTableComponent.prototype.onEnable = function () {
        this.$element.on('click.AccordionTableComponent', '.js-accordionTable-dataTrigger', this.onTriggerClickHandler);

        // Choose which methods to expose the outside world
        this.$element.data('publicApi', {
            getActiveRow: this.getActiveRow.bind(this),
            setActiveRow: this.setActiveRow.bind(this),
        });

        return this;
    };

    AccordionTableComponent.prototype.onDisable = function () {
        this.$element.off('click.AccordionTableComponent', '.js-accordionTable-dataTrigger',
            this.onTriggerClickHandler);

        this.$element.data('publicApi', null);

        this.$dataChunks.show(0);
        this.$alertsChunks.show(0);

        return this;
    };

    AccordionTableComponent.prototype.onDestroy = function () {
        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    AccordionTableComponent.prototype.onDesktopEnter = function () {
        this.collapse();

        this.$element.off('click.AccordionTableComponent', '.js-accordionTable-baseRow', this.onRowClickHandler);
        this.$element.off('click.AccordionTableComponent', '.js-accordionTable-tr-link', this.onLinkClickHandler);
    };

    AccordionTableComponent.prototype.onMobileEnter = function () {
        this.collapse();

        this.$element.on('click.AccordionTableComponent', '.js-accordionTable-baseRow', this.onRowClickHandler);
        this.$element.on('click.AccordionTableComponent', '.js-accordionTable-tr-link', this.onLinkClickHandler);
    };

    // necessary click event for links within the table row on mobile
    AccordionTableComponent.prototype.onLinkClick = function (e) {
        e.stopPropagation();
        window.location.href = $(e.currentTarget).attr('href');
    };

    AccordionTableComponent.prototype.onRowClick = function (e) {
        var $row = $(e.currentTarget);

        this.expandByRow($row, true);

        // Prevent event bubbling
        return false;
    };

    // Event handler for when a data trigger is clicked
    AccordionTableComponent.prototype.onTriggerClick = function (e) {
        var $trigger = $(e.currentTarget);

        this.expandByTrigger($trigger, true);

        // Prevent event bubbling
        return false;
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Helper Functions
    ///////////////////////////////////////////////////////////////////////////////////////////////

    AccordionTableComponent.prototype.expandByRow = function ($row, isAnimate) {
        var $trigger = $row.find('.js-accordionTable-dataTrigger');

        this.expand($row, $trigger, isAnimate);
    };

    AccordionTableComponent.prototype.expandByTrigger = function ($trigger, isAnimate) {
        var $row = $trigger.parents('tr');

        this.expand($row, $trigger, isAnimate);
    };

    AccordionTableComponent.prototype.expand = function ($row, $trigger, isAnimate) {
        this.collapse();

        if (this.checkActive($row, $trigger)) {
            return;
        }

        this.$activeRow = $row;
        this.$activeTrigger = $trigger;

        this.$activeRow.addClass('isActive');

        var $nextRow = this.$activeRow.next().find(this.$dataChunks);

        $nextRow.removeClass('isVisuallyHidden').stop(true, true);
        if (isAnimate) {
            $nextRow.slideDown();
        } else {
            $nextRow.show();
        }

        var portletTitle = this.$activeTrigger.attr('data-config-portlet-title');
        var contentName = this.$activeTrigger.attr('data-config-content-name');

        if (portletTitle != null && contentName != null) {
            metricsService.expandClick(portletTitle, contentName);
        }
    };

    // Convenience method checking if a given row and trigger
    AccordionTableComponent.prototype.checkActive = function ($row, $trigger) {
        if ($row !== null && $trigger !== null) {
            if ($row.is(this.$activeRow) && $trigger.is(this.$activeTrigger)) {
                this.$activeTrigger = null;
                this.$activeRow = null;
                return true;
            }
        }

        return false;
    };

    // Compare clicked base row to stored activeRow
    AccordionTableComponent.prototype.baseRowCheckActive = function ($row) {
        if ($row !== null && $row.is(this.$activeRow)) {
            this.$activeRow = null;
            return true;
        }

        return false;
    };

    // collapse the table to have all rows not-active and all container chunks closed
    AccordionTableComponent.prototype.collapse = function () {
        if (this.$activeRow !== null) {
            this.clearErrors();
            this.$activeRow.removeClass('isActive');
        }

        this.$dataChunks.stop(true, true).slideUp();
        this.$alertsChunks.stop(true, true).slideUp();
    };

    /**
     * Clean up any errors that may exist
     */
    AccordionTableComponent.prototype.clearErrors = function () {
        // Errors section
        var $errors = this.$activeRow.next().find('.js-alert-errors');

        // Error items section
        var $errorsList = this.$activeRow.next().find('.js-error-items');

        $errors.addClass('isHidden');
        $errorsList.html('');
    };

    // retrieve the active row
    AccordionTableComponent.prototype.getActiveRow = function () {
        var $activeRow = this.$activeRow;
        if ($activeRow == null) {
            $activeRow = $();
        }
        return $activeRow;
    };

    // set the active row
    AccordionTableComponent.prototype.setActiveRow = function (selector) {
        var $row = this.$element.find('.js-accordionTable-baseRow').filter(selector);

        if ($row.length > 0) {
            this.expandByRow($row, false);
        }
    };

    return AccordionTableComponent;
});

define('shared-scripts/components/ShowWhenNotEmptyComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    /**
     * Until browsers natively support the :blank selector, this is necessary to
     * conditionally style elements that have no children
     */

    var ShowWhenNotEmptyComponent = (function (_Component) {
        babelHelpers.inherits(ShowWhenNotEmptyComponent, _Component);

        function ShowWhenNotEmptyComponent() {
            babelHelpers.classCallCheck(this, ShowWhenNotEmptyComponent);
            babelHelpers.get(Object.getPrototypeOf(ShowWhenNotEmptyComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ShowWhenNotEmptyComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(ShowWhenNotEmptyComponent.prototype), 'ready', this).apply(this, arguments);

                if (this.$element.children().length > 0) {
                    this.$element.removeClass('isHidden');
                }
            }
        }]);
        return ShowWhenNotEmptyComponent;
    })(_Component2['default']);

    module.exports = ShowWhenNotEmptyComponent;
});
define('components/ContentReplaceComponent',['exports', 'module', 'jquery', 'components/Component', 'shared-scripts/lib/Util'], function (exports, module, _jquery, _componentsComponent, _sharedScriptsLibUtil) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var ContentReplaceComponent = (function (_Component) {
        babelHelpers.inherits(ContentReplaceComponent, _Component);

        function ContentReplaceComponent() {
            babelHelpers.classCallCheck(this, ContentReplaceComponent);
            babelHelpers.get(Object.getPrototypeOf(ContentReplaceComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ContentReplaceComponent, [{
            key: 'onLinkClick',
            value: function onLinkClick(event) {
                var _this = this;

                event.preventDefault();

                this.fetchPage(this.config.renderUrl).then(function ($newHtml) {
                    _this.$element.replaceWith($newHtml);
                    $newHtml.trigger('attachjs');
                })['catch'](function (e) {
                    /* eslint-disable no-console */
                    console.warn(e);
                    /* eslint-enable no-console */
                });

                return false;
            }
        }, {
            key: 'fetchPage',
            value: function fetchPage(url) {
                return new Promise(function (resolve, reject) {
                    _Util['default'].post(url)
                    // Server error
                    .fail(function (e) {
                        reject(e);
                    })
                    // Successful post
                    .then(function (stringifiedHTML) {
                        resolve((0, _$['default'])(stringifiedHTML));
                    });
                });
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    renderUrl: { required: true }
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$link', selector: '.js-ContentReplaceComponent-link', event: 'click' }];
            }
        }]);
        return ContentReplaceComponent;
    })(_Component2['default']);

    module.exports = ContentReplaceComponent;
});
define('components/ReRenderComponent',['exports', 'module', 'jquery', 'lib/Util', 'components/Component'], function (exports, module, _jquery, _libUtil, _componentsComponent) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var ReRenderComponent = (function (_Component) {
        babelHelpers.inherits(ReRenderComponent, _Component);

        function ReRenderComponent() {
            babelHelpers.classCallCheck(this, ReRenderComponent);
            babelHelpers.get(Object.getPrototypeOf(ReRenderComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ReRenderComponent, [{
            key: 'onReRender',

            /**
             * @param  {jQuery.Event} action The action that triggered this handler
             * @param  {String}       endpoint URL to request new markup from
             * @param  {Object}       postData Data object to send along with the request
             */
            value: function onReRender(action, endpoint, postData) {
                var _this = this;

                action.stopPropagation(); // Stop the action from bubbling further

                this.sendAction('didStartLoading'); // Show the loading spinner

                _Util['default'].post(endpoint, postData).fail(function (jqXHR) {
                    /* eslint-disable no-console */
                    console.error('Non-200 response from server: ' + jqXHR.status + ' ' + jqXHR.statusText);
                    /* eslint-enable no-console */
                }).then(function (portletHtml) {
                    var $html = (0, _$['default'])(portletHtml).find(_this.consts.RE_RENDER_CONTAINER).children(); // Find the re rendered content in the returned markup
                    _this.$content.html($html); // Replace old markup with new markup
                    _this.$content.trigger('attachjs'); // Instantiate components inside

                    _this.sendAction('didStopLoading'); // Hide loading spinner
                });
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    RE_RENDER_CONTAINER: '.js-reRenderComponent-content'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$content', selector: '> ' + this.consts.RE_RENDER_CONTAINER }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'bubble', event: 'reRender' }];
            }
        }]);
        return ReRenderComponent;
    })(_Component2['default']);

    module.exports = ReRenderComponent;
});
define('shared-scripts/services/dataProviderService',['exports', 'module', 'jquery', 'shared-scripts/lib/Util'], function (exports, module, _jquery, _sharedScriptsLibUtil) {
    

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    function submitHtml(url, serializedForm, extractSelector) {
        return new Promise(function (resolve, reject) {
            _Util['default'].post(url, serializedForm)
            // Non-200 server response
            .fail(function (jqXHR) {
                reject('Non-200 response from server: ' + jqXHR.status + ' ' + jqXHR.statusText);
            })
            // 200 server response
            .then(function (portletHtml, status, jqHXR) {
                var $portletHtml = (0, _$['default'])(portletHtml);

                // Check if we found a <form> reponse somewhere in the returned markup
                // TODO Does not handle cases using windowState="exclusive". Needs to check immediate child for extractor as well.
                var $html = $portletHtml.find(extractSelector);
                var redirectUrl = jqHXR.getResponseHeader('REDIRECT');

                if (redirectUrl != null && redirectUrl !== '') {
                    resolve({ redirectUrl: redirectUrl });
                } else if ($html[0] instanceof HTMLElement) {
                    resolve({ $html: $html });
                } else {
                    reject('Expected server HTML to contain selector \'' + extractSelector + '\', instead got \'' + portletHtml + '\'');
                }
            });
        });
    }

    function submitJson(url, serializedForm) {
        return new Promise(function (resolve, reject) {
            _Util['default'].post(url, serializedForm)
            // Non-200 server response
            .fail(function (jqXHR) {
                reject('Non-200 response from server: ' + jqXHR.status + ' ' + jqXHR.statusText);
            })
            // 200 server response
            .then(function (json) {
                var parsed = null;

                try {
                    parsed = JSON.parse(json);
                } catch (e) {}

                if (parsed == null) {
                    reject('Could not parse JSON returned from server: \'' + json + '\'');
                } else {
                    resolve(parsed);
                }
            });
        });
    }

    function resetHtml(url, extractSelector) {
        return new Promise(function (resolve, reject) {
            _Util['default'].getHTML(url)
            // Non-200 server response
            .fail(function (jqXHR) {
                reject('Non-200 response from server: ' + jqXHR.status + ' ' + jqXHR.statusText);
            })
            // 200 server response
            .then(function (portletHtml) {
                var $portletHtml = (0, _$['default'])(portletHtml);
                var $html = $portletHtml.find(extractSelector);

                if ($html[0] instanceof HTMLElement) {
                    resolve({ $html: $html });
                } else {
                    reject('Expected server response to contain selector \'' + extractSelector + '\', instead got \'' + portletHtml + '\'');
                }
            });
        });
    }

    module.exports = { submitHtml: submitHtml, submitJson: submitJson, resetHtml: resetHtml };
});
define('shared-scripts/components/HtmlReRenderComponent',['exports', 'module', 'components/Component', 'shared-scripts/services/dataProviderService'], function (exports, module, _componentsComponent, _sharedScriptsServicesDataProviderService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _dataProviderService = babelHelpers.interopRequireDefault(_sharedScriptsServicesDataProviderService);

    var HtmlReRenderComponent = (function (_Component) {
        babelHelpers.inherits(HtmlReRenderComponent, _Component);

        function HtmlReRenderComponent() {
            babelHelpers.classCallCheck(this, HtmlReRenderComponent);
            babelHelpers.get(Object.getPrototypeOf(HtmlReRenderComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(HtmlReRenderComponent, [{
            key: 'onSubmitForm',
            value: function onSubmitForm(action, request) {
                this.submit(action, request);

                return false;
            }
        }, {
            key: 'onResetForm',
            value: function onResetForm(action, request) {
                this.reset(action, request);

                return false;
            }
        }, {
            key: 'submit',
            value: function submit(action, request) {
                var _this = this;

                this.startSpinner();

                _dataProviderService['default'].submitHtml(request.url, request.serializedForm, this.config.extractSelector).then(function (response) {
                    if (response.redirectUrl != null) {
                        _this.redirect(response.redirectUrl);
                    } else {
                        _this.replace(request, response.$html); // An element matching the extractSelector was found
                    }
                })['catch'](this.exception.bind(this, request));
            }
        }, {
            key: 'reset',
            value: function reset(action, request) {
                var _this2 = this;

                this.startSpinner();

                _dataProviderService['default'].resetHtml(request.url, this.config.extractSelector).then(function (response) {
                    _this2.replace(request, response.$html);
                })['catch'](this.exception.bind(this, request));

                return false;
            }
        }, {
            key: 'replace',
            value: function replace(request, $html) {
                request.onReplace($html);
                this.stopSpinner();
            }
        }, {
            key: 'redirect',
            value: function redirect(redirectUrl) {
                window.location.replace(redirectUrl);
            }
        }, {
            key: 'success',
            value: function success(request) {
                request.onSuccess();
                this.stopSpinner();
            }
        }, {
            key: 'fail',
            value: function fail(request, errorMessageArray) {
                request.onFail(errorMessageArray);
                this.stopSpinner();
            }
        }, {
            key: 'exception',
            value: function exception(request, errorMessage) {
                /*eslint no-console: 0*/
                console.warn(errorMessage);
                request.onFail(['An unexpected error has occurred, please try again later.']);
                this.stopSpinner();
            }
        }, {
            key: 'startSpinner',
            value: function startSpinner() {
                this.sendAction('didStartLoading');
            }
        }, {
            key: 'stopSpinner',
            value: function stopSpinner() {
                this.sendAction('didStopLoading');
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    extractSelector: { required: true }
                };
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ event: 'submitForm', type: 'bubble' }, { event: 'resetForm', type: 'bubble' }];
            }
        }]);
        return HtmlReRenderComponent;
    })(_Component2['default']);

    module.exports = HtmlReRenderComponent;
});
define('shared-scripts/components/DeferredRenderComponent',['exports', 'module', 'lib/Util', 'components/Component'], function (exports, module, _libUtil, _componentsComponent) {
    

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var DeferredRenderComponent = (function (_Component) {
        babelHelpers.inherits(DeferredRenderComponent, _Component);

        function DeferredRenderComponent() {
            babelHelpers.classCallCheck(this, DeferredRenderComponent);
            babelHelpers.get(Object.getPrototypeOf(DeferredRenderComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(DeferredRenderComponent, [{
            key: 'enable',
            value: function enable() {
                if (this.config.renderUrl) {
                    this.startSpinner();
                    _Util['default'].getHTML(this.config.renderUrl).done(this.replace.bind(this));
                }
            }
        }, {
            key: 'replace',
            value: function replace($html) {
                var $container = undefined;

                if (this.config.targetSelector != null && this.config.targetSelector !== '') {
                    // If we have a target in mind, query it
                    $container = $(this.config.targetSelector);

                    // If the specified target was not found, we have no container
                    // to work with so throw an error.
                    if ($container.length === 0) {
                        throw new Error('A target selector "' + this.config.targetSelector + '" was specified, but \n              no elements were found when the DOM was queried.');
                    }
                } else {
                    // Else just use this element
                    $container = this.$element;
                }

                $container.html($html);
                _Util['default'].sendAction('attachjs', $container);
                this.stopSpinner();
            }
        }, {
            key: 'startSpinner',
            value: function startSpinner() {
                if (this.config.enableSpinner) {
                    this.sendAction('didStartLoading');
                }
            }
        }, {
            key: 'stopSpinner',
            value: function stopSpinner() {
                if (this.config.enableSpinner) {
                    this.sendAction('didStopLoading');
                }
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    renderUrl: { required: true },
                    targetSelector: '',
                    enableSpinner: true
                };
            }
        }]);
        return DeferredRenderComponent;
    })(_Component2['default']);

    module.exports = DeferredRenderComponent;
});
define('shared-scripts/components/JsonReRenderComponent',['exports', 'module', 'shared-scripts/components/HtmlReRenderComponent', 'shared-scripts/services/dataProviderService'], function (exports, module, _sharedScriptsComponentsHtmlReRenderComponent, _sharedScriptsServicesDataProviderService) {
    

    var _HtmlReRenderComponent2 = babelHelpers.interopRequireDefault(_sharedScriptsComponentsHtmlReRenderComponent);

    var _dataProviderService = babelHelpers.interopRequireDefault(_sharedScriptsServicesDataProviderService);

    var JsonReRenderComponent = (function (_HtmlReRenderComponent) {
        babelHelpers.inherits(JsonReRenderComponent, _HtmlReRenderComponent);

        function JsonReRenderComponent() {
            babelHelpers.classCallCheck(this, JsonReRenderComponent);
            babelHelpers.get(Object.getPrototypeOf(JsonReRenderComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(JsonReRenderComponent, [{
            key: 'submit',
            value: function submit(action, request) {
                var _this = this;

                this.startSpinner();

                _dataProviderService['default'].submitJson(request.url, request.serializedForm).then(function (json) {
                    if (json.success) {
                        _this.success(request);
                    } else {
                        _this.fail(request, json.errors);
                    }
                })['catch'](this.exception.bind(this, request));

                return false;
            }
        }]);
        return JsonReRenderComponent;
    })(_HtmlReRenderComponent2['default']);

    module.exports = JsonReRenderComponent;
});
define('components/OnReadyRedirectComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    /**
     * On Ready Redirect Component. Will send the user to the redirect portlet when the component has finished loading.
     * @class
     */

    var OnReadyRedirectComponent = (function (_Component) {
        babelHelpers.inherits(OnReadyRedirectComponent, _Component);

        function OnReadyRedirectComponent() {
            babelHelpers.classCallCheck(this, OnReadyRedirectComponent);
            babelHelpers.get(Object.getPrototypeOf(OnReadyRedirectComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(OnReadyRedirectComponent, [{
            key: 'ready',
            // The current URL that the user is on.

            /**
             * When the component is ready call the redirect.
             */
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(OnReadyRedirectComponent.prototype), 'ready', this).apply(this, arguments);

                this.redirect();
            }

            /**
             * On a successful form submission redirect the user to the specified url.
             *
             * @returns {boolean} Kill the event
             */
        }, {
            key: 'redirect',
            value: function redirect() {
                var url = this.config.redirectTo;

                // Encode the current url to preserve any query params
                var encodedUrl = encodeURIComponent(this.config.currentUrl);

                // This assumes that we are always going to the redirect portlet. Otherwise we'll have to rework how the params are passed.
                url = url + '?previousUrl=' + encodedUrl;

                window.location.replace(url);
                return false;
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    redirectTo: { required: true }, // The url to redirect the user to.
                    currentUrl: { required: true } };
            }
        }]);
        return OnReadyRedirectComponent;
    })(_Component2['default']);

    module.exports = OnReadyRedirectComponent;
});
define('components/FreeTrialComponent',['exports', 'module', 'components/Component', 'shared-scripts/lib/Util', 'jquery', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsLibUtil, _jquery, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var FreeTrialComponent = (function (_Component) {
        babelHelpers.inherits(FreeTrialComponent, _Component);

        function FreeTrialComponent() {
            babelHelpers.classCallCheck(this, FreeTrialComponent);
            babelHelpers.get(Object.getPrototypeOf(FreeTrialComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(FreeTrialComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(FreeTrialComponent.prototype), 'ready', this).apply(this, arguments);

                this.$element.attr('href', this._buildUrl());
            }
        }, {
            key: '_buildUrl',
            value: function _buildUrl() {
                var params = {};

                // Referrer
                params[this.consts.PARAM_REFERRER_NAME] = this.consts.PARAM_REFERRER_VALUE;

                // Email Address
                if (window.dtnGlobals.emailToken) {
                    params[this.consts.PARAM_USER_EMAIL_TOKEN] = encodeURIComponent(window.dtnGlobals.emailToken);
                }

                // Reading List Item
                if (this.config.readingListType != null && this.config.readingListEntryId != null && this.config.readingListGroupId != null) {
                    params[this.consts.PARAM_READING_LIST_TYPE_NAME] = this.config.readingListType;
                    params[this.consts.PARAM_READING_LIST_ENTRY_ID_NAME] = this.config.readingListEntryId;
                    params[this.consts.PARAM_READING_LIST_GROUP_ID_NAME] = this.config.readingListGroupId;
                }

                // Google Analytic Params
                var campaignParams = _metricsService['default'].getCampaignParams(this.$element);

                // Combine both the local params and the campaign params, with the campaign params taking precedence
                var combinedParams = _$['default'].extend({}, params, campaignParams);

                // Additional params that are not url encoded.
                // Wave IDs
                if (this.config.waveIds != null && this.config.waveIds !== '') {
                    combinedParams[this.consts.PARAM_WAVE_IDS_NAME] = this.config.waveIds;
                }

                // Create the base URL
                var url = window.dtnGlobals.freeTrialUrl + '/' + this.consts.SIGNUP_URL;

                // Signup link will be changed to Request a Demo link (AGC-573)
                // return url + '?' + Util.convertToQueryString(combinedParams);
                return 'https://dtn.link/tuoz3d';
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    SIGNUP_URL: 'signup', // The URL location of the signup form on premium
                    PARAM_REFERRER_NAME: 'referrer',
                    PARAM_REFERRER_VALUE: 'dtnpf',
                    PARAM_USER_EMAIL_TOKEN: 'et', // The user id
                    PARAM_WAVE_IDS_NAME: 'vars', //Marketing click tracking
                    PARAM_READING_LIST_TYPE_NAME: 'rType', // The type of reading list. Used to add the article to the reading list in premium
                    PARAM_READING_LIST_ENTRY_ID_NAME: 'entryId', // The entry ID of reading list. Used to add the article to the reading list in premium
                    PARAM_READING_LIST_GROUP_ID_NAME: 'groupId', // The group ID of reading list. Used to add the article to the reading list in premium
                    PARAM_TRIAL_NAME: 'trialparams' // The encoded params. This is used as a passthrough on any of the redirects (should the redirect hit a marketing site)
                };
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    utmMedium: { required: true },
                    utmContent: { required: true },
                    emailAddressToken: null,
                    waveIds: null,
                    readingListType: null,
                    readingListEntryId: null,
                    readingListGroupId: null
                };
            }
        }]);
        return FreeTrialComponent;
    })(_Component2['default']);

    module.exports = FreeTrialComponent;
});
define('components/LearnMoreComponent',['exports', 'module', 'components/Component', 'shared-scripts/lib/Util', 'jquery', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsLibUtil, _jquery, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var LearnMoreComponent = (function (_Component) {
        babelHelpers.inherits(LearnMoreComponent, _Component);

        function LearnMoreComponent() {
            babelHelpers.classCallCheck(this, LearnMoreComponent);
            babelHelpers.get(Object.getPrototypeOf(LearnMoreComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(LearnMoreComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(LearnMoreComponent.prototype), 'ready', this).apply(this, arguments);

                this.$element.attr('href', this._buildUrl());
            }
        }, {
            key: '_buildUrl',
            value: function _buildUrl() {
                var params = {};

                // Referrer
                params[this.consts.PARAM_REFERRER_NAME] = this.consts.PARAM_REFERRER_VALUE;

                // Email Address
                if (this.config.emailAddressToken) {
                    params[this.consts.PARAM_USER_ID_NAME] = encodeURIComponent(this.config.emailAddressToken);
                }

                // Reading List Item
                if (this.config.readingListType != null && this.config.readingListEntryId != null && this.config.readingListGroupId != null) {
                    params[this.consts.PARAM_READING_LIST_TYPE_NAME] = this.config.readingListType;
                    params[this.consts.PARAM_READING_LIST_ENTRY_ID_NAME] = this.config.readingListEntryId;
                    params[this.consts.PARAM_READING_LIST_GROUP_ID_NAME] = this.config.readingListGroupId;
                }

                // Google Analytic Params
                var campaignParams = _metricsService['default'].getCampaignParams(this.$element);

                // Combine both the local params and the campaign params, with the campaign params taking precedence
                var combinedParams = _$['default'].extend({}, params, campaignParams);

                // Convert the params to a string to be encoded for use in the trialparams.
                var paramStr = _Util['default'].convertToQueryString(combinedParams);
                var trialParams = {};
                trialParams[this.consts.PARAM_TRIAL_NAME] = encodeURIComponent(paramStr);

                // Create the base URL
                var baseUrl = this.config.url;

                // Find out the separator to be used
                var separator = '?';
                if (baseUrl.indexOf(separator) > 0) {
                    separator = '&';
                }

                return baseUrl + separator + _Util['default'].convertToQueryString(trialParams);
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    PARAM_REFERRER_NAME: 'referrer',
                    PARAM_REFERRER_VALUE: 'dtnpf',
                    PARAM_USER_ID_NAME: 'uid', // The user id
                    PARAM_WAVE_IDS_NAME: 'vars', //Marketing click tracking
                    PARAM_READING_LIST_TYPE_NAME: 'rType', // The type of reading list. Used to add the article to the reading list in premium
                    PARAM_READING_LIST_ENTRY_ID_NAME: 'entryId', // The entry ID of reading list. Used to add the article to the reading list in premium
                    PARAM_READING_LIST_GROUP_ID_NAME: 'groupId', // The group ID of reading list. Used to add the article to the reading list in premium
                    PARAM_TRIAL_NAME: 'trialparams' // The encoded params. This is used as a passthrough on any of the redirects (should the redirect hit a marketing site)
                };
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    utmMedium: { required: true },
                    utmContent: { required: true },
                    url: { required: true },
                    emailAddressToken: null,
                    readingListType: null,
                    readingListEntryId: null,
                    readingListGroupId: null
                };
            }
        }]);
        return LearnMoreComponent;
    })(_Component2['default']);

    module.exports = LearnMoreComponent;
});
define('components/PremiumLoginComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var PremiumLoginComponent = (function (_Component) {
        babelHelpers.inherits(PremiumLoginComponent, _Component);

        function PremiumLoginComponent() {
            babelHelpers.classCallCheck(this, PremiumLoginComponent);
            babelHelpers.get(Object.getPrototypeOf(PremiumLoginComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(PremiumLoginComponent, [{
            key: 'onClick',
            value: function onClick(event) {
                event.preventDefault();

                window.location = this.config.redirectUrl + '&' + this.consts.PARAM_UTM_SOURCE + '&' + this.consts.PARAM_UTM_CAMPAIGN + '&' + this.consts.PARAM_UTM_MEDIUM + '=' + this.config.medium + '&' + this.consts.PARAM_UTM_CONTENT + '=' + this.config.content;

                return false;
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    PARAM_UTM_SOURCE: 'utm_source=public',
                    PARAM_UTM_CAMPAIGN: 'utm_campaign=paid_conversion',
                    PARAM_UTM_MEDIUM: 'utm_medium',
                    PARAM_UTM_CONTENT: 'utm_content'
                };
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    redirectUrl: { required: true },
                    medium: { required: true },
                    content: { required: true }
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return PremiumLoginComponent;
    })(_Component2['default']);

    module.exports = PremiumLoginComponent;
});
define('components/ArticleComponent',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var ArticleComponent = (function (_Component) {
        babelHelpers.inherits(ArticleComponent, _Component);

        function ArticleComponent() {
            babelHelpers.classCallCheck(this, ArticleComponent);
            babelHelpers.get(Object.getPrototypeOf(ArticleComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ArticleComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(ArticleComponent.prototype), 'ready', this).apply(this, arguments);

                _metricsService['default'].articleViewed();
            }
        }]);
        return ArticleComponent;
    })(_Component2['default']);

    module.exports = ArticleComponent;
});
define('components/FileDownloadComponent',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    /* eslint no-unused-vars: 0 */

    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var FileDownloadComponent = (function (_Component) {
        babelHelpers.inherits(FileDownloadComponent, _Component);

        function FileDownloadComponent() {
            babelHelpers.classCallCheck(this, FileDownloadComponent);
            babelHelpers.get(Object.getPrototypeOf(FileDownloadComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(FileDownloadComponent, [{
            key: 'onClick',
            value: function onClick(event) {
                _metricsService['default'].fileDownload(this.config.portletTitle, this.config.fileName);
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    portletTitle: { required: true },
                    fileName: { required: true }
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return FileDownloadComponent;
    })(_Component2['default']);

    module.exports = FileDownloadComponent;
});
define('components/LinkClickComponent',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var LinkClickComponent = (function (_Component) {
        babelHelpers.inherits(LinkClickComponent, _Component);

        function LinkClickComponent() {
            babelHelpers.classCallCheck(this, LinkClickComponent);
            babelHelpers.get(Object.getPrototypeOf(LinkClickComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(LinkClickComponent, [{
            key: 'onClick',
            value: function onClick() {
                _metricsService['default'].linkClick(this.config.linkType, this.config.linkTitle);
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    linkTitle: { required: true },
                    linkType: { required: true }
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return LinkClickComponent;
    })(_Component2['default']);

    module.exports = LinkClickComponent;
});
define('components/ResetToDefaultLocationComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var ResetToDefaultLocationComponent = (function (_Component) {
        babelHelpers.inherits(ResetToDefaultLocationComponent, _Component);

        function ResetToDefaultLocationComponent() {
            babelHelpers.classCallCheck(this, ResetToDefaultLocationComponent);
            babelHelpers.get(Object.getPrototypeOf(ResetToDefaultLocationComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(ResetToDefaultLocationComponent, [{
            key: 'onClick',
            value: function onClick(event) {
                event.preventDefault();

                this.sendAction('resetToDefaultLocation');
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'click' }];
            }
        }]);
        return ResetToDefaultLocationComponent;
    })(_Component2['default']);

    module.exports = ResetToDefaultLocationComponent;
});
define('components/StatusBarComponent',['exports', 'module', 'components/Component', 'jquery'], function (exports, module, _componentsComponent, _jquery) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var StatusBarComponent = (function (_Component) {
        babelHelpers.inherits(StatusBarComponent, _Component);

        function StatusBarComponent() {
            babelHelpers.classCallCheck(this, StatusBarComponent);
            babelHelpers.get(Object.getPrototypeOf(StatusBarComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(StatusBarComponent, [{
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(StatusBarComponent.prototype), 'queryDom', this).apply(this, arguments);
                this.$desktopContainer = (0, _$['default'])('.js-statusBarComponent-desktop');
                this.$mobileContainer = (0, _$['default'])('.js-statusBarComponent-mobile');
            }
        }, {
            key: 'layout',
            value: function layout() {
                babelHelpers.get(Object.getPrototypeOf(StatusBarComponent.prototype), 'layout', this).apply(this, arguments);
                if (this.breakpoint === 'desktop') {
                    this.desktopLayout();
                }
                if (sessionStorage.getItem('closedStatusBar') !== 'true') {
                    this.openStatusBar();
                }
            }
        }, {
            key: 'openStatusBar',
            value: function openStatusBar() {
                this.$statusBar.addClass(this.consts.IS_ACTIVE_CLASS);
            }
        }, {
            key: 'onDidEnterMobile',
            value: function onDidEnterMobile() {
                this.mobileLayout();
            }
        }, {
            key: 'onDidEnterDesktop',
            value: function onDidEnterDesktop() {
                this.desktopLayout();
            }
        }, {
            key: 'mobileLayout',
            value: function mobileLayout() {
                this.$statusBar.detach();
                this.$statusBar.appendTo(this.$mobileContainer);
            }
        }, {
            key: 'desktopLayout',
            value: function desktopLayout() {
                this.$statusBar.detach();
                this.$statusBar.appendTo(this.$desktopContainer);
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    IS_ACTIVE_CLASS: 'isActive'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$statusBar', selector: '.js-statusBarComponent-content' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'didEnterMobile.BreakpointChangeListenerComponent' }, { type: 'store', action: 'didEnterDesktop.BreakpointChangeListenerComponent' }];
            }
        }, {
            key: 'breakpoint',
            get: function get() {
                return window.STATE.CURRENT_BREAKPOINT === window.dtnGlobals.breakpointType.DESKTOP ? 'desktop' : 'mobile';
            }
        }]);
        return StatusBarComponent;
    })(_Component2['default']);

    module.exports = StatusBarComponent;
});
define('components/RegistrationPostalComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var RegistrationPostalComponent = (function (_Component) {
        babelHelpers.inherits(RegistrationPostalComponent, _Component);

        function RegistrationPostalComponent() {
            babelHelpers.classCallCheck(this, RegistrationPostalComponent);
            babelHelpers.get(Object.getPrototypeOf(RegistrationPostalComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(RegistrationPostalComponent, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(RegistrationPostalComponent.prototype), 'ready', this).apply(this, arguments);

                this.notifyInit();
            }
        }, {
            key: 'onChange',
            value: function onChange() {
                this.notifyChange();
            }
        }, {
            key: 'notifyInit',
            value: function notifyInit() {
                if (this.isPopulated) {
                    this.sendAction('notifyRegistationPostalInit', [this.postalCode]);
                }
            }
        }, {
            key: 'notifyChange',
            value: function notifyChange() {
                if (this.isPopulated) {
                    this.sendAction('notifyRegistationPostalChange', [this.postalCode]);
                }
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'change' }];
            }
        }, {
            key: 'isPopulated',
            get: function get() {
                var postalCode = this.postalCode;
                if (postalCode != null && postalCode !== '') {
                    return true;
                } else {
                    return false;
                }
            }
        }, {
            key: 'postalCode',
            get: function get() {
                return this.$element.val();
            }
        }]);
        return RegistrationPostalComponent;
    })(_Component2['default']);

    module.exports = RegistrationPostalComponent;
});
define('components/RegistrationAgreementComponent',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var RegistrationAgreementComponent = (function (_Component) {
        babelHelpers.inherits(RegistrationAgreementComponent, _Component);

        function RegistrationAgreementComponent() {
            babelHelpers.classCallCheck(this, RegistrationAgreementComponent);
            babelHelpers.get(Object.getPrototypeOf(RegistrationAgreementComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(RegistrationAgreementComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(RegistrationAgreementComponent.prototype), 'initProps', this).apply(this, arguments);

                this.hasChanged = false;
            }
        }, {
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(RegistrationAgreementComponent.prototype), 'ready', this).apply(this, arguments);
            }
        }, {
            key: 'onSpamCheckboxClick',
            value: function onSpamCheckboxClick() {
                this.hasChanged = true;
            }
        }, {
            key: 'onNotifyRegistationPostalInit',
            value: function onNotifyRegistationPostalInit(event, postalCode) {
                this.hasChanged = true;
                // Preserve the existing value of the checkbox if it was from a postback
                this.show();
            }
        }, {
            key: 'onNotifyRegistationPostalChange',
            value: function onNotifyRegistationPostalChange(event, postalCode) {
                if (this.hasChanged === false) {
                    this.updatePostal(postalCode);
                }
                this.show();
            }
        }, {
            key: 'updatePostal',
            value: function updatePostal(postalCode) {
                // Uncheck box if the user is in Canada
                if (this.isCanada(postalCode)) {
                    this.setChecked(false);
                }
                // Check box if the user is not in Canada
                else {
                        this.setChecked(true);
                    }
            }
        }, {
            key: 'isCanada',
            value: function isCanada(postalCode) {
                // Match a postal code in the form Y0B 1G0
                var regex = new RegExp(/[ABCEGHJKLMNPRSTVXY]\d[A-Z]\d[A-Z]\d/i);
                var isCanada = regex.test(postalCode.replace(' ', ''));

                return isCanada;
            }
        }, {
            key: 'setChecked',
            value: function setChecked(val) {
                this.$spamCheckbox.prop('checked', val);
            }
        }, {
            key: 'show',
            value: function show() {
                this.$element.removeClass('isHidden');
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$spamCheckbox', selector: '.js-registrationAgreementComponent-spamCheckbox', event: 'click' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'notifyRegistationPostalChange' }, { type: 'store', action: 'notifyRegistationPostalInit' }];
            }
        }]);
        return RegistrationAgreementComponent;
    })(_Component2['default']);

    module.exports = RegistrationAgreementComponent;
});
define('shared-scripts/services/dfpAdService',['exports', 'module', 'shared-scripts/lib/Util', 'jquery'], function (exports, module, _sharedScriptsLibUtil, _jquery) {
    /**
     * DFP Ad service
     * Low-level functionality for communicating with DFP ad service
     *
     * @class dfpdfpAdService
     * @constructor
     */

    

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    // Global Google DFP queue
    // Allows queuing of commands before external Google DFP script tag has loaded
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    var dfpAdService = {};

    // Returns the DFP ad unit in the following form.
    // If no specific ad unit is defined for the portlet, falls back to use the page-level ad unit
    //
    // For example, this data:
    // { account: '/306602/site191.tmus', prefix: 'AgoPaid', adUnit: 'Home1' }
    //
    // Would result in:
    // {account}/{prefix}{adUnit}
    // /306602/site191.tmus/AgoPaidHome1
    dfpAdService.getAdUnit = function (portletAdUnit) {
        var account = window.dtnGlobals.dfpAccount == null ? '' : window.dtnGlobals.dfpAccount;
        var prefix = window.dtnGlobals.dfpPrefix == null ? '' : window.dtnGlobals.dfpPrefix;
        var pageAdUnit = window.dtnGlobals.dfpAdUnit == null ? '' : window.dtnGlobals.dfpAdUnit;
        var portlet = portletAdUnit == null ? '' : portletAdUnit;

        // If defined, portlet-level ad unit overrides page-level ad unit
        var adUnit = portlet === '' ? pageAdUnit : portlet;

        // Undefined ad units are considered to be in an 'Undeclared' bucket
        // For debugging purposes, this would serve dummy placeholder ads on dev
        // environments.
        if (adUnit === '') {
            adUnit = 'Undeclared';
        }

        return account + '/' + prefix + adUnit;
    };

    // Combine all targeting key/value pairs into a single object
    dfpAdService.getTargeting = function (pos, portletTargeting) {
        var user = window.dtnGlobals.dfpUserTargeting;

        var page = {
            'referrer': _Util['default'].getQueryValue('referrer'),
            'search': _Util['default'].getQueryValue('q'),
            'keywords': (0, _$['default'])('meta[name="keywords"]').attr('content').split(',')
        };

        var portlet = {
            pos: pos
        };

        var custom = _Util['default'].parseQueryString(portletTargeting);

        return Object.assign(custom, portlet, user, page);
    };

    dfpAdService.onReady = function (onReadyFn) {
        window.googletag.cmd.push(onReadyFn);
    };

    dfpAdService.getSlot = function (adUnit, id, desktopWidth, desktopHeight, mobileWidth, mobileHeight) {
        // Set Responsive Design sizes
        var sizeMapping = window.googletag.sizeMapping().addSize([0, 0], [mobileWidth, mobileHeight]).addSize([window.dtnGlobals.maxMobileWidth, 0], [desktopWidth, desktopHeight]).build();

        var slot = window.googletag.defineSlot(adUnit, [mobileWidth, mobileHeight], id);

        // Slot will be null if bad params were supplied (such as two ads with the same id)
        if (slot != null) {
            slot.defineSizeMapping(sizeMapping);
            slot.addService(window.googletag.pubads());
        }
        return slot;
    };

    // Used for interstials, etc
    dfpAdService.getOutofPageSlot = function (adUnit, id) {
        var slot = window.googletag.defineOutOfPageSlot(adUnit, id);

        // Slot will be null if bad params were supplied (such as two ads with the same id)
        if (slot != null) {
            slot.addService(window.googletag.pubads());
        }
        return slot;
    };

    dfpAdService.setTargeting = function (slot, targeting) {
        for (var key in targeting) {
            if (targeting.hasOwnProperty(key)) {
                var value = targeting[key];
                if (value != null && value !== '') {
                    slot.setTargeting(key, value);
                }
            }
        }
    };

    dfpAdService.display = function (slot, id, onCompleteFn) {
        // Collapse div if no matching ad returned
        if (!this.isDebug()) {
            window.googletag.pubads().collapseEmptyDivs();
        }

        // Add listener for ad load completion
        if (onCompleteFn != null) {
            window.googletag.pubads().addEventListener('slotRenderEnded', onCompleteFn);
        }

        // Display Ad
        window.googletag.enableServices();
        window.googletag.display(id);
    };

    /**
     * Disables initial load of ads. Refresh() must be called
     * later to force ads to load after the fact.
     */
    dfpAdService.disableInitialLoad = function () {
        window.googletag.pubads().disableInitialLoad();
    };

    /**
     * Refreshes all ads on the page
     * After detaching/moving an ad in the DOM, a funny side effect is that the ad
     * will disappear. Calling refresh() will force all ads to re-appear again.
     */
    dfpAdService.refresh = function (slot) {
        window.googletag.pubads().refresh([slot]);
    };

    // Toggle visibility of visual debugger
    // Shown on test accounts, hidden on production
    dfpAdService.isDebug = function () {
        return window.dtnGlobals.dfpDebug === 'true';
    };

    dfpAdService.addVisualDebugger = function (reason, $element, width, height, portletAdUnit, pos, isOutOfPage) {
        if (!this.isDebug()) {
            return;
        }

        var adUnit = this.getAdUnit(portletAdUnit);
        $element.addClass('ad_error');
        $element.html('DFP AD ' + reason + '<br>' + pos + ' ' + width + ' x ' + height + ' ' + (isOutOfPage ? '(out-of-page)' : '') + '<br>adUnit: ' + adUnit);
        $element.css('width', width);
        $element.css('height', height);
    };

    module.exports = dfpAdService;
});
define('shared-scripts/components/DfpAdComponent',['exports', 'module', 'components/Component', 'shared-scripts/services/dfpAdService'], function (exports, module, _componentsComponent, _sharedScriptsServicesDfpAdService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _dfpAdService = babelHelpers.interopRequireDefault(_sharedScriptsServicesDfpAdService);

    /**
     * Ad Loader Component
     *
     * @class
     */

    var DfpAdComponent = (function (_Component) {
        babelHelpers.inherits(DfpAdComponent, _Component);

        function DfpAdComponent() {
            babelHelpers.classCallCheck(this, DfpAdComponent);
            babelHelpers.get(Object.getPrototypeOf(DfpAdComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(DfpAdComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(DfpAdComponent.prototype), 'initProps', this).apply(this, arguments);

                this.config.mobileWidth = parseInt(this.config.mobileWidth, 10);
                this.config.mobileHeight = parseInt(this.config.mobileHeight, 10);
                this.config.desktopWidth = parseInt(this.config.desktopWidth, 10);
                this.config.desktopHeight = parseInt(this.config.desktopHeight, 10);
                this.config.lazyLoadProximityPercent = parseInt(this.config.lazyLoadProximityPercent, 10);
                this.needsRefresh = false;
                this.disableInitialLoad = window.dtnGlobals.dfpDisableInitialLoad;
            }
        }, {
            key: 'ready',
            value: function ready() {
                if (this.config.pos === "T1") {
                    // In the case of "T1" we will want the parent elm to have
                    // a height set to prepare for when the ad is "stickied".
                    // What we want to prevent is a sudden change of height
                    // of the container which can give the impression of a sudden
                    // lurch of the page.
                    this.$element.parent().css('height', this.adHeight + "px");
                }

                // Set ID
                this.$element.attr('id', 'div-gpt-ad-' + this.config.pos);

                // Hide on mobile if mobileHeight=0 and mobileWidth=0
                if (!this.forMobile) {
                    this.$element.addClass('isHidden_mobile');
                }
                // Height on desktop if desktopHeight=0 and desktopWidth=0
                if (!this.forDesktop) {
                    this.$element.addClass('isHidden_desktop');
                }

                this.hasBeenStickiedOnce = false;
                this.shown = false;
                this.lazyLoadProximityInPixels = window.innerHeight * this.config.lazyLoadProximityPercent * 0.01;

                // Ads will only load if intended for the current breakpoint
                if (this.breakpoint === 'desktop' && this.forDesktop || this.breakpoint === 'mobile' && this.forMobile) {
                    // Do initial 'onViewable' to catch any ads showing before full load
                    this.onViewable();

                    // Add listener for load so that we catch ads after page has fully rendered
                    window.addEventListener('load', (function () {
                        // Do yet another 'onViewable' to catch ads that are now in viewport due to page render
                        this.onViewable();

                        // Finally... add scroll event to catch ads as they scroll by
                        window.addEventListener('scroll', this.onViewable.bind(this));
                    }).bind(this));
                }
            }
        }, {
            key: 'onViewable',
            value: function onViewable() {
                if (this.shown) {
                    if (this.config.pos === "T1") {
                        // If ad is a "T1" then we should evaluate whether or not to "sticky" it
                        this.stickyAdToTop();
                        return;
                    } else {
                        // No need to continue if already shown and not a "T1" ad.
                        return;
                    }
                }

                // This is our lazy load condition, note that we /always/ load "T1" immediately
                // because it stickies to the top
                if (this.config.pos === "T1" || this.isAdWithinViewport()) {
                    if (window.dtnGlobals.dfpDebug) {
                        console.log("lazy loading ad[" + this.config.pos + "]");
                    }

                    this.shown = true;

                    // Runs our onReady() only after the tag manager script kicks off;
                    // this could be some time after this script executes
                    _dfpAdService['default'].onReady(this.onReady.bind(this));
                }
            }
        }, {
            key: 'onDidViewportChange',
            value: function onDidViewportChange() {
                var _this = this;

                var delay = window.dtnGlobals.browserDetect.os.iPad ? 1000 : 0;
                setTimeout(function () {
                    _this.onViewable();
                }, delay);
            }
        }, {
            key: 'onDidEnterDesktop',
            value: function onDidEnterDesktop() {
                this.onViewable();
            }
        }, {
            key: 'onDidEnterMobile',
            value: function onDidEnterMobile() {
                this.onViewable();
            }
        }, {
            key: 'isAdWithinViewport',
            value: function isAdWithinViewport() {
                // Get ad positional attributes

                var _$element$0$getBoundingClientRect = this.$element[0].getBoundingClientRect();

                var top = _$element$0$getBoundingClientRect.top;
                var bottom = _$element$0$getBoundingClientRect.bottom;

                // Gather viewport attributes for evaluating lazy load
                var bottomOfViewPort = window.innerHeight + this.lazyLoadProximityInPixels;
                var topOfViewPort = -this.lazyLoadProximityInPixels;

                // Evaluate whether ad is within the viewport
                return top >= topOfViewPort && top <= bottomOfViewPort || bottom >= topOfViewPort && bottom <= bottomOfViewPort;
            }
        }, {
            key: 'stickyAdToTop',
            value: function stickyAdToTop() {
                if (this.hasBeenStickiedOnce) {
                    return; // If we've already stickied (and unstickied) this once, that's all we want.
                }

                // Calculate position to compare against the top of the viewport
                // to evalute whether or not to 'sticky' the ad.
                var bottomOfAdPlacement = undefined;
                if (this.stickied) {
                    // If already stickied, we need to use the parent element's bottom
                    // because the current element is fixed to the top of the viewport
                    var parentBottom = this.$element.parent()[0].getBoundingClientRect().bottom;
                    bottomOfAdPlacement = parentBottom + this.adHeight;
                } else {
                    // If not stickied, the ad element's bottom should suffice

                    var _$element$0$getBoundingClientRect2 = this.$element[0].getBoundingClientRect();

                    var bottom = _$element$0$getBoundingClientRect2.bottom;

                    bottomOfAdPlacement = bottom;
                }

                if (!this.stickied && bottomOfAdPlacement < 0) {
                    /*
                     If not yet stickied and the position threshold is above top of viewport
                     We will want to 'sticky' the ad
                     */
                    this.stickied = true;

                    // Calculate a left margin that will center the ad horizontally.
                    var marginLeft = this.adWidth / 2;

                    // Apply the 'stickyness'
                    var subNav = document.querySelector(".header-subNav");

                    // Stick ad below Mobile nav bar
                    if (this.breakpoint === "mobile") {
                        this.$element.css({
                            "z-index": 1025,
                            position: "fixed",
                            top: "64px",
                            left: "50%",
                            "margin-left": "-" + marginLeft + "px"
                        });
                    }

                    // Stick ad below Desktop nav bar AND subNav bar
                    // This applies to "Perspectives" and "News" pages
                    else if (subNav) {
                            this.$element.css({
                                "z-index": 9999,
                                position: "fixed",
                                top: "88px",
                                left: "50%",
                                "margin-left": "-" + marginLeft + "px"
                            });
                        }

                        // Default: Stick ad below Desktop nav bar
                        else {
                                this.$element.css({
                                    "z-index": 9999,
                                    position: "fixed",
                                    top: "54px",
                                    left: "50%",
                                    "margin-left": "-" + marginLeft + "px"
                                });
                            }

                    // Set a 5s fade timeout
                    // (enough to capture a viewability metric without negatively impacting UX too much)
                    this.fadeTimeout = setTimeout((function () {
                        this.$element.css('transition', 'opacity 1s');
                        this.$element.css('opacity', 0);
                    }).bind(this), 5000);
                    // Set a 6.1s hide timeout (enough time so that fade occurs before hiding)
                    this.hideTimeout = setTimeout((function () {
                        this.$element.css('display', 'none');
                    }).bind(this), 6100);
                } else if (this.stickied && bottomOfAdPlacement >= this.adHeight) {
                    /*
                     If already stickied and the position threshold is below top of viewport
                     We will want to 'unsticky' the ad
                     */
                    this.stickied = false;
                    this.hasBeenStickiedOnce = true;

                    // Clear the fade/hide timeouts in case they haven't triggered yet
                    if (this.fadeTimeout) {
                        clearTimeout(this.fadeTimeout);
                        this.fadeTimeout = undefined;
                    }
                    if (this.hideTimeout) {
                        clearTimeout(this.hideTimeout);
                        this.hideTimeout = undefined;
                    }

                    // Clear the 'stickyness' css attributes
                    this.$element.css({
                        "transition": "",
                        "opacity": "",
                        "z-index": "",
                        position: "",
                        top: "",
                        left: "",
                        "margin-left": "",
                        "display": ""
                    });
                }
            }

            // Note: this method is executed in a try/catch context by Google DFP,
            // so no JS errors will be output to the console
        }, {
            key: 'onReady',
            value: function onReady() {
                this.displayAd();
                this.removePlaceholder();

                // After displaying ad evaluate sticky condition for ad
                if (this.config.pos === "T1") {
                    this.stickyAdToTop();
                }
            }
        }, {
            key: 'onDidArrangeDashboard',
            value: function onDidArrangeDashboard() {
                this.needsRefresh = true;
                this.refreshIfNeeded();
            }
        }, {
            key: 'displayAd',
            value: function displayAd() {
                if (this.disableInitialLoad) {
                    _dfpAdService['default'].disableInitialLoad();
                }

                var adUnit = _dfpAdService['default'].getAdUnit(this.config.adUnit);
                var targeting = _dfpAdService['default'].getTargeting(this.config.pos, this.config.targeting);

                if (this.config.outOfPage) {
                    this.slot = _dfpAdService['default'].getOutofPageSlot(adUnit, this.adId);
                } else {
                    this.slot = _dfpAdService['default'].getSlot(adUnit, this.adId, this.config.desktopWidth, this.config.desktopHeight, this.config.mobileWidth, this.config.mobileHeight);
                }

                this.sendAction('didStopLoading');

                // Slot will be null if bad params were supplied (such as two ads with the same id)
                if (this.slot == null) {
                    this.addVisualDebugger('BAD PARAMS');
                } else {
                    _dfpAdService['default'].setTargeting(this.slot, targeting);
                    _dfpAdService['default'].display(this.slot, this.adId, this.onDisplayAdComplete.bind(this));
                    this.refreshIfNeeded();
                }
            }
        }, {
            key: 'onDisplayAdComplete',
            value: function onDisplayAdComplete(event) {
                // event handler fires for every ad loaded on the page, not just this one, so bail out if this isn't for us
                if (event && event.slot !== this.slot) {
                    return;
                }

                if (event.isEmpty) {
                    this.addVisualDebugger('NO MATCH');
                }
            }

            // refresh can only be called after display()
        }, {
            key: 'refreshIfNeeded',
            value: function refreshIfNeeded() {
                if (this.needsRefresh && this.slot != null) {
                    _dfpAdService['default'].refresh(this.slot);
                    this.needsRefresh = false;
                }
            }
        }, {
            key: 'addVisualDebugger',
            value: function addVisualDebugger(reason) {
                _dfpAdService['default'].addVisualDebugger(reason, this.$element, this.adWidth, this.adHeight, this.config.adUnit, this.config.pos, this.config.outOfPage);
            }
        }, {
            key: 'removePlaceholder',
            value: function removePlaceholder() {
                this.$placeholder.remove();
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    mobileWidth: 0,
                    mobileHeight: 0,
                    desktopWidth: 0,
                    desktopHeight: 0,
                    lazyLoadProximityPercent: 0,
                    pos: '',
                    targeting: '',
                    outOfPage: false,
                    adUnit: ''
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$placeholder', selector: '.js-dfpAdComponent-placeholder' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'didArrangeDashboard' }, { type: 'store', action: 'didEnterMobile.BreakpointChangeListenerComponent' }, { type: 'store', action: 'didEnterDesktop.BreakpointChangeListenerComponent' }, { type: 'store', action: 'didViewportChange.BreakpointChangeListenerComponent' }];
            }
        }, {
            key: 'adId',
            get: function get() {
                return 'div-gpt-ad-' + this.config.pos;
            }
        }, {
            key: 'forMobile',
            get: function get() {
                return this.config.mobileHeight !== 0;
            }
        }, {
            key: 'forDesktop',
            get: function get() {
                return this.config.desktopHeight !== 0;
            }
        }, {
            key: 'breakpoint',
            get: function get() {
                return window.STATE.CURRENT_BREAKPOINT === window.dtnGlobals.breakpointType.DESKTOP ? 'desktop' : 'mobile';
            }
        }, {
            key: 'adWidth',
            get: function get() {
                if (this.breakpoint === "desktop") {
                    return this.config.desktopWidth;
                } else {
                    return this.config.mobileWidth;
                }
            }
        }, {
            key: 'adHeight',
            get: function get() {
                if (this.breakpoint === "desktop") {
                    return this.config.desktopHeight;
                } else {
                    return this.config.mobileHeight;
                }
            }
        }]);
        return DfpAdComponent;
    })(_Component2['default']);

    module.exports = DfpAdComponent;
});
define('shared-scripts/components/NativeAdComponent',['exports', 'module', 'components/Component', 'shared-scripts/services/nativeAdService', 'jquery'], function (exports, module, _componentsComponent, _sharedScriptsServicesNativeAdService, _jquery) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _nativeAdService = babelHelpers.interopRequireDefault(_sharedScriptsServicesNativeAdService);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    /**
     * Native Ad Loader Component
     *
     * @class
     */

    var NativeAdComponent = (function (_Component) {
        babelHelpers.inherits(NativeAdComponent, _Component);

        function NativeAdComponent() {
            babelHelpers.classCallCheck(this, NativeAdComponent);
            babelHelpers.get(Object.getPrototypeOf(NativeAdComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(NativeAdComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(NativeAdComponent.prototype), 'initProps', this).apply(this, arguments);
                this.config.width = parseInt(this.config.width, 10);
                this.config.height = parseInt(this.config.height, 10);
                this.config.lazyLoadProximityPercent = parseInt(this.config.lazyLoadProximityPercent, 10);

                // For any content we want to display in the event that a standalone ad is not available.
                this.$nativeShowIfAbsent = this.$element.find('.js-nativeShowIfAbsent');

                // If no width/height show the replacement content
                if (this.config.width === 0 || this.config.height === 0) {
                    this.displayIfNativeAdAbsentContent();
                }
            }
        }, {
            key: 'displayIfNativeAdAbsentContent',
            value: function displayIfNativeAdAbsentContent() {
                if (!this.$nativeShowIfAbsent || this.$nativeShowIfAbsent.length === 0 || this.$nativeShowIfAbsent.children().length === 0) {
                    return false;
                }

                this.$nativeShowIfAbsent.children().insertBefore(this.$nativeShowIfAbsent.parent());
                this.$element.addClass('isHidden');
                return true;
            }
        }, {
            key: 'ready',
            value: function ready() {
                this.selector = _nativeAdService['default'].getSelector(this.config.selector, this.config.index);
                if (this.selector == null) {
                    // if no selector provided, will insert inside of this element
                    // MediaVoice needs a jquery selector string
                    this.selector = _nativeAdService['default'].assignUniqueSelector(this.$element);
                }

                this.shown = false;
                this.lazyLoadProximityInPixels = window.innerHeight * this.config.lazyLoadProximityPercent * 0.01;

                // Do initial 'onViewable' to catch any ads showing before full load
                this.onViewable();

                // Add listener for load so that we catch ads after page has fully rendered
                window.addEventListener('load', (function () {
                    // Add timeout to wait for page to render completely
                    setTimeout((function () {
                        // Do yet another 'onViewable' to catch ads that are now in viewport due to page render
                        this.onViewable();
                        // Finally... add scroll event to catch ads as they scroll by
                        window.addEventListener('scroll', this.onViewable.bind(this));
                    }).bind(this), 500);
                }).bind(this));
            }
        }, {
            key: 'onViewable',
            value: function onViewable() {
                if (this.shown) {
                    return;
                }
                if (window.dtnGlobals.dfpDebug) {
                    var label = this.config.label !== '' ? this.config.label : 'NoLabel';
                    var dim = this.config.width + "x" + this.config.height;
                    console.log(" on scroll lazy loading NATIVE-AD[" + label + " (" + dim + ")]");
                }
                this.shown = true;
                _nativeAdService['default'].onReady(this.displayAd.bind(this));
            }
        }, {
            key: 'onDidViewportChange',
            value: function onDidViewportChange() {
                var _this = this;

                var delay = window.dtnGlobals.browserDetect.os.iPad ? 1000 : 0;
                setTimeout(function () {
                    _this.onViewable();
                }, delay);
            }
        }, {
            key: 'onDidEnterDesktop',
            value: function onDidEnterDesktop() {
                this.onViewable();
            }
        }, {
            key: 'onDidEnterMobile',
            value: function onDidEnterMobile() {
                this.onViewable();
            }
        }, {
            key: 'isAdWithinViewport',
            value: function isAdWithinViewport() {
                // Get ad positional attributes
                var rectngl = this.$element[0].getBoundingClientRect();
                var top = rectngl.top;
                var bottom = rectngl.bottom;
                if (top == bottom && top > 2000) {
                    // We have a problem with the in-headline-list Native Ads: they report their position
                    // incorrectly (AG-4109).  To get around this, do the below shifting reported location.
                    // While it is a hack, it seems to get around the problem without seeming to add more
                    // difficulties elsewhere in the product.  Also: we apparently plan on changing
                    // vendors; we can address the 'oddness' of this 'solution' at that time.  CMPiv.
                    top = 400;
                    bottom = 400;
                }

                // Gather viewport attributes for evaluating lazy load
                var bottomOfViewPort = window.innerHeight + this.lazyLoadProximityInPixels;
                var topOfViewPort = -this.lazyLoadProximityInPixels;

                if (window.dtnGlobals.dfpDebug) {}
                //console.log("NativeAdComponent.isAdWithinViewport returning: (" + top + ">=" + topOfViewPort + " " +
                //            top + "<=" + bottomOfViewPort + " " + bottom + ">=" + topOfViewPort + " " +
                //            bottom + "<=" + bottomOfViewPort + " : " +
                //            (top >= topOfViewPort && top <= bottomOfViewPort || bottom >= topOfViewPort && bottom <= bottomOfViewPort));

                // Evaluate whether ad is within the viewport
                return top >= topOfViewPort && top <= bottomOfViewPort || bottom >= topOfViewPort && bottom <= bottomOfViewPort;
            }
        }, {
            key: 'onReady',
            value: function onReady() {
                this.displayAd();
            }
        }, {
            key: 'displayAd',
            value: function displayAd() {
                var account = _nativeAdService['default'].getAccount();
                var dfpParams = _nativeAdService['default'].getDfpParams(this.config.adUnit, this.config.pos, this.config.targeting, this.config.width, this.config.height);
                var compiledTemplate = _nativeAdService['default'].getTemplate(this.config.template);

                _nativeAdService['default'].setAccount(account);
                _nativeAdService['default'].setArticleUrl(this.config.articleUrl);
                _nativeAdService['default'].display(this.config.label, dfpParams, this.selector, compiledTemplate, this.onFill.bind(this), this.onRender.bind(this), this.onError.bind(this));
            }
        }, {
            key: 'onFill',
            value: function onFill(model) {
                // Provide UI with a human-readable data format
                model.pubDate = _nativeAdService['default'].dateFormatter(model.pubDate);
            }
        }, {
            key: 'onRender',
            value: function onRender($element) {
                (0, _$['default'])(this.selector).parent().trigger('attachjs'); // For ads embedded in lists.
                this.$element.trigger('attachjs'); // For standalone ads.
            }
        }, {
            key: 'onError',
            value: function onError(error) {
                console.warn('Error loading native ad:', error, this); // eslint-disable-line no-console

                // On error if there is content to be shown in the ad's absence then show it
                this.displayIfNativeAdAbsentContent();

                // Add the visual debugger to indicate an error as well
                _nativeAdService['default'].addVisualDebugger(error, this.$element, this.config.width, this.config.height, this.config.adUnit);
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    width: 0,
                    height: 0,
                    label: '',
                    template: '',
                    selector: '',
                    index: 0,
                    adUnit: '',
                    pos: '',
                    targeting: '',
                    articleUrl: '',
                    lazyLoadProximityPercent: 0
                };
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'didEnterMobile.BreakpointChangeListenerComponent' }, { type: 'store', action: 'didEnterDesktop.BreakpointChangeListenerComponent' }, { type: 'store', action: 'didViewportChange.BreakpointChangeListenerComponent' }];
            }
        }]);
        return NativeAdComponent;
    })(_Component2['default']);

    module.exports = NativeAdComponent;
});
define('components/QueryParamComponent',['exports', 'module', 'components/Component', 'lib/Util'], function (exports, module, _componentsComponent, _libUtil) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var QueryParamComponent = (function (_Component) {
        babelHelpers.inherits(QueryParamComponent, _Component);

        function QueryParamComponent() {
            babelHelpers.classCallCheck(this, QueryParamComponent);
            babelHelpers.get(Object.getPrototypeOf(QueryParamComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(QueryParamComponent, [{
            key: 'ready',
            value: function ready() {
                // Open signup modal if ?join=1 appears in url
                if (_Util['default'].getQueryValue('join') === '1') {
                    this.sendAction('openModal', ['login', 'signup']);
                }
            }
        }]);
        return QueryParamComponent;
    })(_Component2['default']);

    module.exports = QueryParamComponent;
});
define('components/SocialShareComponent',['exports', 'module', 'components/Component', 'services/metricsService'], function (exports, module, _componentsComponent, _servicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_servicesMetricsService);

    var SocialShareComponent = (function (_Component) {
        babelHelpers.inherits(SocialShareComponent, _Component);

        function SocialShareComponent() {
            babelHelpers.classCallCheck(this, SocialShareComponent);
            babelHelpers.get(Object.getPrototypeOf(SocialShareComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(SocialShareComponent, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(SocialShareComponent.prototype), 'initProps', this).apply(this, arguments);

                this.needsTeardown = false;
            }
        }, {
            key: 'ready',
            value: function ready() {
                var _this = this;

                babelHelpers.get(Object.getPrototypeOf(SocialShareComponent.prototype), 'ready', this).apply(this, arguments);
                var intervalCount = 0;
                var addThisInterval = window.setInterval(function () {
                    if (typeof window.addthis !== 'undefined') {
                        _this.bindAddThisEvents();
                        window.clearInterval(addThisInterval);
                    }

                    intervalCount = intervalCount + 1;
                    if (intervalCount === _this.consts.INTERVAL_TIMEOUT_COUNT) {
                        window.clearInterval(addThisInterval);
                    }
                }, this.consts.INTERVAL);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                babelHelpers.get(Object.getPrototypeOf(SocialShareComponent.prototype), 'destroy', this).apply(this, arguments);

                if (this.needsTeardown && typeof window.addthis !== 'undefined') {
                    this.needsTeardown = false;
                    window.addthis.removeEventListener('addthis.menu.share');
                }
            }
        }, {
            key: 'bindAddThisEvents',
            value: function bindAddThisEvents() {
                this.needsTeardown = true;
                window.addthis.addEventListener('addthis.menu.share', this.onShare.bind(this));
            }
        }, {
            key: 'onShare',
            value: function onShare(event) {
                var service = event.data.service;

                _metricsService['default'].socialShare(service);
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    INTERVAL: 500,
                    INTERVAL_TIMEOUT_COUNT: 1000
                };
            }
        }]);
        return SocialShareComponent;
    })(_Component2['default']);

    module.exports = SocialShareComponent;
});
/* Add to Homescreen v3.1.1 ~ (c) 2014 Matteo Spinelli ~ @license: http://cubiq.org/license */
(function (window, document) {
/*
       _   _ _____     _____
 ___ _| |_| |_   _|___|  |  |___ _____ ___ ___ ___ ___ ___ ___ ___
| .'| . | . | | | | . |     | . |     | -_|_ -|  _|  _| -_| -_|   |
|__,|___|___| |_| |___|__|__|___|_|_|_|___|___|___|_| |___|___|_|_|
                              by Matteo Spinelli ~ http://cubiq.org
*/

// Check for addEventListener browser support (prevent errors in IE<9)
var _eventListener = 'addEventListener' in window;

// Check if document is loaded, needed by autostart
var _DOMReady = false;
if ( document.readyState === 'complete' ) {
	_DOMReady = true;
} else if ( _eventListener ) {
	window.addEventListener('load', loaded, false);
}

function loaded () {
	window.removeEventListener('load', loaded, false);
	_DOMReady = true;
}

// regex used to detect if app has been added to the homescreen
var _reSmartURL = /\/ath(\/)?$/;
var _reQueryString = /([\?&]ath=[^&]*$|&ath=[^&]*(&))/;

// singleton
var _instance;
function ath (options) {
	_instance = _instance || new ath.Class(options);

	return _instance;
}

// message in all supported languages
ath.intl = {
	de_de: {
		ios: 'Um diese Web-App zum Home-Bildschirm hinzuzufügen, tippen Sie auf %icon und dann <strong>Zum Home-Bildschirm</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	en_us: {
		ios: 'To add this web app to the home screen: tap %icon and then <strong>Add to Home Screen</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	es_es: {
		ios: 'Para añadir esta aplicación web a la pantalla de inicio: pulsa %icon y selecciona <strong>Añadir a pantalla de inicio</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	fr_fr: {
		ios: 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez %icon et sélectionnez <strong>Ajouter sur l\'écran d\'accueil</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	he_il: {
		ios: '<span dir="rtl">להוספת האפליקציה למסך הבית: ללחוץ על %icon ואז <strong>הוסף למסך הבית</strong>.</span>',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	it_it: {
		ios: 'Per aggiungere questa web app alla schermata iniziale: premi %icon e poi <strong>Aggiungi a Home</strong>.',
		android: 'Per aggiungere questa web app alla schermata iniziale, apri il menu opzioni del browser e premi su <strong>Aggiungi alla homescreen</strong>. <small>Puoi accedere al menu premendo il pulsante hardware delle opzioni se la tua device ne ha uno, oppure premendo l\'icona <span class="ath-action-icon">icon</span> in alto a destra.</small>',
	},

	nb_no: {
		ios: 'For å installere denne appen på hjem-skjermen: trykk på %icon og deretter <strong>Legg til på Hjem-skjerm</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	pt_br: {
		ios: 'Para adicionar este app à tela de início: clique %icon e então <strong>Tela de início</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	pt_pt: {
		ios: 'Para adicionar esta app ao ecrã principal: clique %icon e depois <strong>Ecrã principal</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	nl_nl: {
		ios: 'Om deze webapp op je telefoon te installeren, klik op %icon en dan <strong>Zet in beginscherm</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	sv_se: {
		ios: 'För att lägga till denna webbapplikation på hemskärmen: tryck på %icon och därefter <strong>Lägg till på hemskärmen</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	zh_cn: {
		ios: '如要把应用程式加至主屏幕,请点击%icon, 然后<strong>加至主屏幕</strong>',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	},

	zh_tw: {
		ios: '如要把應用程式加至主屏幕, 請點擊%icon, 然後<strong>加至主屏幕</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon <span class="ath-action-icon">icon</span>.</small>',
	}
};

// Add 2 characters language support (Android mostly)
for ( var lang in ath.intl ) {
	ath.intl[lang.substr(0, 2)] = ath.intl[lang];
}

// default options
ath.defaults = {
	appID: 'org.cubiq.addtohome',		// local storage name (no need to change)
	fontSize: 15,				// base font size, used to properly resize the popup based on viewport scale factor
	debug: false,				// override browser checks
	modal: false,				// prevent further actions until the message is closed
	mandatory: false,			// you can't proceed if you don't add the app to the homescreen
	autostart: true,			// show the message automatically
	skipFirstVisit: false,		// show only to returning visitors (ie: skip the first time you visit)
	startDelay: 1,				// display the message after that many seconds from page load
	lifespan: 15,				// life of the message in seconds
	displayPace: 1440,			// minutes before the message is shown again (0: display every time, default 24 hours)
	maxDisplayCount: 0,			// absolute maximum number of times the message will be shown to the user (0: no limit)
	icon: true,					// add touch icon to the message
	message: '',				// the message can be customized
	validLocation: [],			// list of pages where the message will be shown (array of regexes)
	onInit: null,				// executed on instance creation
	onShow: null,				// executed when the message is shown
	onRemove: null,				// executed when the message is removed
	onAdd: null,				// when the application is launched the first time from the homescreen (guesstimate)
	onPrivate: null,			// executed if user is in private mode
	privateModeOverride: false,	// show the message even in private mode (very rude)
	detectHomescreen: false		// try to detect if the site has been added to the homescreen (false | true | 'hash' | 'queryString' | 'smartURL')
};

// browser info and capability
var _ua = window.navigator.userAgent;

var _nav = window.navigator;
_extend(ath, {
	hasToken: document.location.hash == '#ath' || _reSmartURL.test(document.location.href) || _reQueryString.test(document.location.search),
	isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
	isIDevice: (/iphone|ipod|ipad/i).test(_ua),
	isMobileChrome: _ua.indexOf('Android') > -1 && (/Chrome\/[.0-9]*/).test(_ua),
	isMobileIE: _ua.indexOf('Windows Phone') > -1,
	language: _nav.language && _nav.language.toLowerCase().replace('-', '_') || ''
});

// falls back to en_us if language is unsupported
ath.language = ath.language && ath.language in ath.intl ? ath.language : 'en_us';

ath.isMobileSafari = ath.isIDevice && _ua.indexOf('Safari') > -1 && _ua.indexOf('CriOS') < 0;
ath.OS = ath.isIDevice ? 'ios' : ath.isMobileChrome ? 'android' : ath.isMobileIE ? 'windows' : 'unsupported';

ath.OSVersion = _ua.match(/(OS|Android) (\d+[_\.]\d+)/);
ath.OSVersion = ath.OSVersion && ath.OSVersion[2] ? +ath.OSVersion[2].replace('_', '.') : 0;

ath.isStandalone = window.navigator.standalone || ( ath.isMobileChrome && ( screen.height - document.documentElement.clientHeight < 40 ) );	// TODO: check the lame polyfill
ath.isTablet = (ath.isMobileSafari && _ua.indexOf('iPad') > -1) || (ath.isMobileChrome && _ua.indexOf('Mobile') < 0);

ath.isCompatible = (ath.isMobileSafari && ath.OSVersion >= 6) || ath.isMobileChrome;	// TODO: add winphone

var _defaultSession = {
	lastDisplayTime: 0,			// last time we displayed the message
	returningVisitor: false,	// is this the first time you visit
	displayCount: 0,			// number of times the message has been shown
	optedout: false,			// has the user opted out
	added: false				// has been actually added to the homescreen
};

ath.removeSession = function (appID) {
	try {
		localStorage.removeItem(appID || ath.defaults.appID);
	} catch (e) {
		// we are most likely in private mode
	}
};

ath.Class = function (options) {
	// merge default options with user config
	this.options = _extend({}, ath.defaults);
	_extend(this.options, options);

	// IE<9 so exit (I hate you, really)
	if ( !_eventListener ) {
		return;
	}

	// normalize some options
	this.options.mandatory = this.options.mandatory && ( 'standalone' in window.navigator || this.options.debug );
	this.options.modal = this.options.modal || this.options.mandatory;
	if ( this.options.mandatory ) {
		this.options.startDelay = -0.5;		// make the popup hasty
	}
	this.options.detectHomescreen = this.options.detectHomescreen === true ? 'hash' : this.options.detectHomescreen;

	// setup the debug environment
	if ( this.options.debug ) {
		ath.isCompatible = true;
		ath.OS = typeof this.options.debug == 'string' ? this.options.debug : ath.OS == 'unsupported' ? 'android' : ath.OS;
		ath.OSVersion = ath.OS == 'ios' ? '8' : '4';
	}

	// the element the message will be appended to
	this.container = document.documentElement;

	// load session
	this.session = localStorage.getItem(this.options.appID);
	this.session = this.session ? JSON.parse(this.session) : undefined;

	// user most likely came from a direct link containing our token, we don't need it and we remove it
	if ( ath.hasToken && ( !ath.isCompatible || !this.session ) ) {
		ath.hasToken = false;
		_removeToken();
	}

	// the device is not supported
	if ( !ath.isCompatible ) {
		return;
	}

	this.session = this.session || _defaultSession;

	// check if we can use the local storage
	try {
		localStorage.setItem(this.options.appID, JSON.stringify(this.session));
		ath.hasLocalStorage = true;
	} catch (e) {
		// we are most likely in private mode
		ath.hasLocalStorage = false;

		if ( this.options.onPrivate ) {
			this.options.onPrivate.call(this);
		}
	}

	// check if this is a valid location
	var isValidLocation = !this.options.validLocation.length;
	for ( var i = this.options.validLocation.length; i--; ) {
		if ( this.options.validLocation[i].test(document.location.href) ) {
			isValidLocation = true;
			break;
		}
	}

	// check compatibility with old versions of add to homescreen. Opt-out if an old session is found
	if ( localStorage.getItem('addToHome') ) {
		this.optOut();
	}

	// critical errors:
	// user opted out, already added to the homescreen, not a valid location
	if ( this.session.optedout || this.session.added || !isValidLocation ) {
		return;
	}

	// check if the app is in stand alone mode
	if ( ath.isStandalone ) {
		// execute the onAdd event if we haven't already
		if ( !this.session.added ) {
			this.session.added = true;
			this.updateSession();

			if ( this.options.onAdd && ath.hasLocalStorage ) {	// double check on localstorage to avoid multiple calls to the custom event
				this.options.onAdd.call(this);
			}
		}

		return;
	}

	// (try to) check if the page has been added to the homescreen
	if ( this.options.detectHomescreen ) {
		// the URL has the token, we are likely coming from the homescreen
		if ( ath.hasToken ) {
			_removeToken();		// we don't actually need the token anymore, we remove it to prevent redistribution

			// this is called the first time the user opens the app from the homescreen
			if ( !this.session.added ) {
				this.session.added = true;
				this.updateSession();

				if ( this.options.onAdd && ath.hasLocalStorage ) {	// double check on localstorage to avoid multiple calls to the custom event
					this.options.onAdd.call(this);
				}
			}

			return;
		}

		// URL doesn't have the token, so add it
		if ( this.options.detectHomescreen == 'hash' ) {
			history.replaceState('', window.document.title, document.location.href + '#ath');
		} else if ( this.options.detectHomescreen == 'smartURL' ) {
			history.replaceState('', window.document.title, document.location.href.replace(/(\/)?$/, '/ath$1'));
		} else {
			history.replaceState('', window.document.title, document.location.href + (document.location.search ? '&' : '?' ) + 'ath=');
		}
	}

	// check if this is a returning visitor
	if ( !this.session.returningVisitor ) {
		this.session.returningVisitor = true;
		this.updateSession();

		// we do not show the message if this is your first visit
		if ( this.options.skipFirstVisit ) {
			return;
		}
	}

	// we do no show the message in private mode
	if ( !this.options.privateModeOverride && !ath.hasLocalStorage ) {
		return;
	}

	// all checks passed, ready to display
	this.ready = true;

	if ( this.options.onInit ) {
		this.options.onInit.call(this);
	}

	if ( this.options.autostart ) {
		this.show();
	}
};

ath.Class.prototype = {
	// event type to method conversion
	events: {
		load: '_delayedShow',
		error: '_delayedShow',
		orientationchange: 'resize',
		resize: 'resize',
		scroll: 'resize',
		click: 'remove',
		touchmove: '_preventDefault',
		transitionend: '_removeElements',
		webkitTransitionEnd: '_removeElements',
		MSTransitionEnd: '_removeElements'
	},

	handleEvent: function (e) {
		var type = this.events[e.type];
		if ( type ) {
			this[type](e);
		}
	},

	show: function (force) {
		// in autostart mode wait for the document to be ready
		if ( this.options.autostart && !_DOMReady ) {
			setTimeout(this.show.bind(this), 50);
			return;
		}

		// message already on screen
		if ( this.shown ) {
			return;
		}

		var now = Date.now();
		var lastDisplayTime = this.session.lastDisplayTime;

		if ( force !== true ) {
			// this is needed if autostart is disabled and you programmatically call the show() method
			if ( !this.ready ) {
				return;
			}

			// we obey the display pace (prevent the message to popup too often)
			if ( now - lastDisplayTime < this.options.displayPace * 60000 ) {
				return;
			}

			// obey the maximum number of display count
			if ( this.options.maxDisplayCount && this.session.displayCount >= this.options.maxDisplayCount ) {
				return;
			}
		}

		this.shown = true;

		// increment the display count
		this.session.lastDisplayTime = now;
		this.session.displayCount++;
		this.updateSession();

		// try to get the highest resolution application icon
		if ( !this.applicationIcon ) {
			if ( ath.OS == 'ios' ) {
				this.applicationIcon = document.querySelector('head link[rel^=apple-touch-icon][sizes="152x152"],head link[rel^=apple-touch-icon][sizes="144x144"],head link[rel^=apple-touch-icon][sizes="120x120"],head link[rel^=apple-touch-icon][sizes="114x114"],head link[rel^=apple-touch-icon]');
			} else {
				this.applicationIcon = document.querySelector('head link[rel^="shortcut icon"][sizes="196x196"],head link[rel^=apple-touch-icon]');
			}
		}

		var message = '';

		if ( this.options.message in ath.intl ) {		// you can force the locale
			message = ath.intl[this.options.message][ath.OS];
		} else if ( this.options.message !== '' ) {		// or use a custom message
			message = this.options.message;
		} else {										// otherwise we use our message
			message = ath.intl[ath.language][ath.OS];
		}

		// add the action icon
		message = '<p>' + message.replace('%icon', '<span class="ath-action-icon">icon</span>') + '</p>';

		// create the message container
		this.viewport = document.createElement('div');
		this.viewport.className = 'ath-viewport';
		if ( this.options.modal ) {
			this.viewport.className += ' ath-modal';
		}
		if ( this.options.mandatory ) {
			this.viewport.className += ' ath-mandatory';
		}
		this.viewport.style.position = 'absolute';

		// create the actual message element
		this.element = document.createElement('div');
		this.element.className = 'ath-container ath-' + ath.OS + ' ath-' + ath.OS + (ath.OSVersion + '').substr(0,1) + ' ath-' + (ath.isTablet ? 'tablet' : 'phone');
		this.element.style.cssText = '-webkit-transition-property:-webkit-transform,opacity;-webkit-transition-duration:0s;-webkit-transition-timing-function:ease-out;transition-property:transform,opacity;transition-duration:0s;transition-timing-function:ease-out;';
		this.element.style.webkitTransform = 'translate3d(0,-' + window.innerHeight + 'px,0)';
		this.element.style.transform = 'translate3d(0,-' + window.innerHeight + 'px,0)';

		// add the application icon
		if ( this.options.icon && this.applicationIcon ) {
			this.element.className += ' ath-icon';
			this.img = document.createElement('img');
			this.img.className = 'ath-application-icon';
			this.img.addEventListener('load', this, false);
			this.img.addEventListener('error', this, false);

			this.img.src = this.applicationIcon.href;
			this.element.appendChild(this.img);
		}

		this.element.innerHTML += message;

		// we are not ready to show, place the message out of sight
		this.viewport.style.left = '-99999em';

		// attach all elements to the DOM
		this.viewport.appendChild(this.element);
		this.container.appendChild(this.viewport);

		// if we don't have to wait for an image to load, show the message right away
		if ( !this.img ) {
			this._delayedShow();
		}
	},

	_delayedShow: function (e) {
		setTimeout(this._show.bind(this), this.options.startDelay * 1000 + 500);
	},

	_show: function () {
		var that = this;

		// update the viewport size and orientation
		this.updateViewport();

		// reposition/resize the message on orientation change
		window.addEventListener('resize', this, false);
		window.addEventListener('scroll', this, false);
		window.addEventListener('orientationchange', this, false);

		if ( this.options.modal ) {
			// lock any other interaction
			document.addEventListener('touchmove', this, true);
		}

		// Enable closing after 1 second
		if ( !this.options.mandatory ) {
			setTimeout(function () {
				that.element.addEventListener('click', that, true);
			}, 1000);
		}

		// kick the animation
		setTimeout(function () {
			that.element.style.webkitTransitionDuration = '1.2s';
			that.element.style.transitionDuration = '1.2s';
			that.element.style.webkitTransform = 'translate3d(0,0,0)';
			that.element.style.transform = 'translate3d(0,0,0)';
		}, 0);

		// set the destroy timer
		if ( this.options.lifespan ) {
			this.removeTimer = setTimeout(this.remove.bind(this), this.options.lifespan * 1000);
		}

		// fire the custom onShow event
		if ( this.options.onShow ) {
			this.options.onShow.call(this);
		}
	},

	remove: function () {
		clearTimeout(this.removeTimer);

		// clear up the event listeners
		if ( this.img ) {
			this.img.removeEventListener('load', this, false);
			this.img.removeEventListener('error', this, false);
		}

		window.removeEventListener('resize', this, false);
		window.removeEventListener('scroll', this, false);
		window.removeEventListener('orientationchange', this, false);
		document.removeEventListener('touchmove', this, true);
		this.element.removeEventListener('click', this, true);

		// remove the message element on transition end
		this.element.addEventListener('transitionend', this, false);
		this.element.addEventListener('webkitTransitionEnd', this, false);
		this.element.addEventListener('MSTransitionEnd', this, false);

		// start the fade out animation
		this.element.style.webkitTransitionDuration = '0.3s';
		this.element.style.opacity = '0';
	},

	_removeElements: function () {
		this.element.removeEventListener('transitionend', this, false);
		this.element.removeEventListener('webkitTransitionEnd', this, false);
		this.element.removeEventListener('MSTransitionEnd', this, false);

		// remove the message from the DOM
		this.container.removeChild(this.viewport);

		this.shown = false;

		// fire the custom onRemove event
		if ( this.options.onRemove ) {
			this.options.onRemove.call(this);
		}
	},

	updateViewport: function () {
		if ( !this.shown ) {
			return;
		}

		this.viewport.style.width = window.innerWidth + 'px';
		this.viewport.style.height = window.innerHeight + 'px';
		this.viewport.style.left = window.scrollX + 'px';
		this.viewport.style.top = window.scrollY + 'px';

		var clientWidth = document.documentElement.clientWidth;

		this.orientation = clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';

		var screenWidth = ath.OS == 'ios' ? this.orientation == 'portrait' ? screen.width : screen.height : screen.width;
		this.scale = screen.width > clientWidth ? 1 : screenWidth / window.innerWidth;

		this.element.style.fontSize = this.options.fontSize / this.scale + 'px';
	},

	resize: function () {
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(this.updateViewport.bind(this), 100);
	},

	updateSession: function () {
		if ( ath.hasLocalStorage === false ) {
			return;
		}

		localStorage.setItem(this.options.appID, JSON.stringify(this.session));
	},

	clearSession: function () {
		this.session = _defaultSession;
		this.updateSession();
	},

	optOut: function () {
		this.session.optedout = true;
		this.updateSession();
	},

	optIn: function () {
		this.session.optedout = false;
		this.updateSession();
	},

	clearDisplayCount: function () {
		this.session.displayCount = 0;
		this.updateSession();
	},

	_preventDefault: function (e) {
		e.preventDefault();
		e.stopPropagation();
	}
};

// utility
function _extend (target, obj) {
	for ( var i in obj ) {
		target[i] = obj[i];
	}

	return target;
}

function _removeToken () {
	if ( document.location.hash == '#ath' ) {
		history.replaceState('', window.document.title, document.location.href.split('#')[0]);
	}

	if ( _reSmartURL.test(document.location.href) ) {
		history.replaceState('', window.document.title, document.location.href.replace(_reSmartURL, '$1'));
	}

	if ( _reQueryString.test(document.location.search) ) {
		history.replaceState('', window.document.title, document.location.href.replace(_reQueryString, '$2'));
	}
}

// expose to the world
window.addToHomescreen = ath;

})(window, document);

define("aths", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.addToHomescreen;
    };
}(this)));

define('views/generic/AddToHomeView',['exports', 'module', 'components/Component', 'aths'], function (exports, module, _componentsComponent, _aths) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _AddToHomeScreen = babelHelpers.interopRequireDefault(_aths);

    var AddToHomeView = (function (_Component) {
        babelHelpers.inherits(AddToHomeView, _Component);

        function AddToHomeView() {
            babelHelpers.classCallCheck(this, AddToHomeView);
            babelHelpers.get(Object.getPrototypeOf(AddToHomeView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(AddToHomeView, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(AddToHomeView.prototype), 'ready', this).apply(this, arguments);

                var browserDetect = window.dtnGlobals.browserDetect;

                var isAndroid = browserDetect.userAgent && browserDetect.userAgent.indexOf('android') !== -1;

                // Only want the widget to show for non-Android devices.
                if (!isAndroid) {
                    this.setupAth();
                }
            }
        }, {
            key: 'setupAth',
            value: function setupAth() {
                var options = {
                    fontSize: 13,
                    displayPace: 4320, // minutes
                    icon: false,
                    maxDisplayCount: 2,
                    message: this.$content.html()
                };

                this.ath = new _AddToHomeScreen['default'](options);
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$content', selector: '.js-addToHomeScreen-content' }];
            }
        }]);
        return AddToHomeView;
    })(_Component2['default']);

    module.exports = AddToHomeView;
});
define('views/news/AudioView',['exports', 'module', 'jquery', 'shared-scripts/components/BaseComponent', 'shared-scripts/lib/Util', 'shared-scripts/services/metricsService'], function (exports, module, _jquery, _sharedScriptsComponentsBaseComponent, _sharedScriptsLibUtil, _sharedScriptsServicesMetricsService) {
    /**
     * @fileOverview AudioView module definition
     * @author mernst, kmoot
     */
    

    module.exports = AudioView;

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _BaseComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsBaseComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    /**
     * Handles interaction of an audioclip. Creates an <audio> element and immediately preloads the audio.
     *
     * Ideally this would just download the metadata in order to duration; however, all desktop
     * browsers currently ignore the preload="metadata" attribute and download the entire audio file,
     * which could be expensive in terms of bandwidth.
     *
     * iOS is the only device that handles this well --it will only download the metadata instead of the entire
     * audio file.
     *
     * Usage:
     *
     * <div class="multimedia js-audio" data-audio-src="audio/audio.mp3">
     *   <div class="multimedia-main">
     *       <div class="multimedia-feature">
     *           <span class="multimedia-feature-status">
     *               <span class="multimedia-feature-status-on">
     *                   <i class="icon icon_middle icon_circle-full-caret-right"></i>
     *               </span>
     *               <span class="multimedia-feature-status-off">
     *                   <i class="icon icon_middle icon_audio"></i>
     *               </span>
     *           </span>
     *       </div>
     *       <div class="multimedia-info">
     *           <span class="multimedia-info-title">My Title</span>
     *           <div class="multimedia-info-meta">
     *               (--:--)
     *           </div>
     *       </div>
     *   </div>
     *
     *   <div class="multimedia-media"></div>
     * </div>
     *
     * @class AudioView
     * @constructor
     * @extends BaseComponent
     */

    function AudioView($element, browserDetect) {
        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = $element;

        /**
         * Feature detection object.
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        /**
         * Audio URL.
         *
         * @property $audioUr
         * @type {string}
         */
        this.$audioUrl = this.$element.attr('data-audio-src');

        /**
         * Feature element.
         *
         * @property $feature
         * @type {jQuery}
         */
        this.$feature = null;

        /**
         * Play toggle element.
         *
         * @property playToggle
         * @type {jQuery}
         */
        this.$playToggle = null;

        /**
         * Media element.
         *
         * @property $media
         * @type {jQuery}
         */
        this.$media = null;

        /**
         * Meta element.
         *
         * @property $meta
         * @type {jQuery}
         */
        this.$meta = null;

        /**
         * Audio element.
         *
         * @property $meta
         * @type {jQuery}
         */
        this.$audio = null;

        this.forceQuitDownload = true;

        this.init();

        // Initial creation and loading of the <audio> element
        // The only purpose is to kick off the `onHasMetadata` event handler
        // and immediately grab the duration of the track
        this.enableHasMetadataListener();
        this.createAudioTag();
        this.load();
    }

    AudioView.id = 'AudioView';
    AudioView.prototype = new _BaseComponent['default'](AudioView);
    AudioView.prototype.constructor = AudioView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    AudioView.prototype.onSetupHandlers = function () {
        this.onCollapseHandler = this.onCollapse.bind(this);
        this.onClickHandler = this.onClick.bind(this);
        this.onHasMetadataHandler = this.onHasMetadata.bind(this);

        return this;
    };

    AudioView.prototype.onCreateChildren = function () {
        this.$feature = this.$element.find('.multimedia-feature');
        this.$playToggle = this.$element.find('.multimedia-feature-status');
        this.$media = this.$element.find('.multimedia-media');
        this.$meta = this.$element.find('.multimedia-info-meta');

        return this;
    };

    AudioView.prototype.onEnable = function () {
        this.$feature.on('click', this.onClickHandler);
        _Util['default'].subscribe('collapseAudioView', this.onCollapseHandler);

        return this;
    };

    AudioView.prototype.onDisable = function () {
        this.$feature.off('click', this.onClickHandler);
        _Util['default'].unsubscribe('collapseAudioView', this.onCollapseHandler);

        return this;
    };

    AudioView.prototype.onDestroy = function () {
        this.$element = null;

        this.disableHasMetadataListener();
        this.unload();
        this.removeAudioTag();

        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * `durationchange` fires as soon as metadata has loaded and the duration value is known
     * Updates the UI with the duration once audio clip metadata has loaded
     *
     * @method onHasMetadata
     * @param {Event} e JS Event object
     */
    AudioView.prototype.onHasMetadata = function () {
        var duration = this.getDuration();
        this.$meta.text(duration);

        // Workaround to artifically force browsers to halt downloading of audio stream.
        // Only really useful for browsers that don't fully respect the preload="metadata" attribute,
        // which would natively prevent the entire file download from continuing
        if (this.forceQuitDownload) {
            this.disableHasMetadataListener();
            this.unload();
            this.removeAudioTag();
        }
    };

    /**
     * Toggles expand/collapse of the audio clip
     *
     * @method onClick
     * @param {Event} e JS Event object
     */
    AudioView.prototype.onClick = function () {
        // Tell all other audio clips on the page to collapse themselves
        // (ensures that only one clip is playing at a time)
        _Util['default'].broadcast('collapseAudioView', [this.$element]);

        // Toggle expand/collapse of this audio clip
        if (!this.$element.hasClass('isActive')) {
            this.expand();

            var fileName = this.$element.attr('data-config-file-name');

            _metricsService['default'].audioPlay(fileName);
        } else {
            this.collapse();
        }
    };

    /**
     * Listener for the collapse broadcast
     * Will not do anything if the originator of the broadcast is the same as this component
     *
     * @method onCollapse
     * @param {Event} e JS Event object
     */
    AudioView.prototype.onCollapse = function (e, $originElement) {
        if ($originElement !== this.$element) {
            this.collapse();
        }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Helpers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Append the <audio> element
     *
     * @method createAudioTag
     */
    AudioView.prototype.enableHasMetadataListener = function () {
        // Must use native eventListener here because audio events don't bubble up in a way that jQuery can catch
        this.$element[0].addEventListener('durationchange', this.onHasMetadataHandler, true);
    };

    /**
     * Append the <audio> element
     *
     * @method createAudioTag
     */
    AudioView.prototype.disableHasMetadataListener = function () {
        // Must use native eventListener here because audio events don't bubble up in a way that jQuery can catch
        this.$element[0].removeEventListener('durationchange', this.onHasMetadataHandler, true);
    };

    /**
     * Append the <audio> element
     *
     * @method createAudioTag
     */
    AudioView.prototype.createAudioTag = function () {
        this.$audio = (0, _$['default'])('<audio>').addClass('audio').attr('preload', 'metadata').attr('controls', 'controls').append((0, _$['default'])('<source type="audio/mpeg"/>'));

        this.$media.append(this.$audio);
    };

    /**
     * Removes the <audio> element
     *
     * @method removeAudioTag
     */
    AudioView.prototype.removeAudioTag = function () {
        this.$audio = null;

        this.$media.empty();
    };

    /**
     * Set the src of the <audio> element
     * Shouldn't have to explicitly call load() here because of preload="metadata" on <audio> element
     *
     * @method load
     */
    AudioView.prototype.load = function () {
        this.$audio.find('source').attr('src', this.$audioUrl);
    };

    /**
     * Unset the src of the <audio> element
     *
     * @method load
     */
    AudioView.prototype.unload = function () {
        this.$audio.find('source').attr('src', '');
        this.$audio.attr('src', '');
        this.$audio[0].load(); // Needed for Firefox to completely unload the file
    };

    /**
     * Return the audio duration as a formatted string
     *
     * @method getDuration
     * @returns {sting} Formatted duration sting in the form (12:52)
     */
    AudioView.prototype.getDuration = function () {
        var duration = Math.floor(this.$audio[0].duration);
        var minutes = parseInt(duration / 60, 10) % 60;
        var seconds = duration % 60;

        if (seconds < 10) {
            seconds = '0' + seconds;
        }

        return '(' + minutes + ':' + seconds + ')';
    };

    /**
     * Expand and play the audio
     *
     * @method play
     */
    AudioView.prototype.expand = function () {
        this.$element.addClass('isActive');
        this.play();
    };

    /**
     * Collapse and pause the audio
     *
     * @method play
     */
    AudioView.prototype.collapse = function () {
        this.$element.removeClass('isActive');
        this.pause();
    };

    /**
     * Play the audio
     *
     * @method play
     */
    AudioView.prototype.play = function () {
        // ensure that the enableHasMetadataListener doesn't remove the audio element
        this.forceQuitDownload = false;

        // If audio element doesn't exist yet, create it!
        if (this.$audio == null) {
            this.createAudioTag();
            this.load();
        }

        this.$audio[0].play();
    };

    /**
     * Pause the audio
     *
     * @method pause
     */
    AudioView.prototype.pause = function () {
        if (this.$audio != null) {
            this.$audio[0].pause();
        }
    };
});
define('lib/Logger',['require','jquery','./Util'],function (require) {
    
    var $ = require('jquery');
    var Util = require('./Util');

    /**
     * Check if the client has a console.
     *
     * @return boolean
     */
    function hasConsole () {
        return window.console && typeof window.console !== 'undefined';
    }

    /**
     * Logger component.
     *
     * @class Logger
     * @constructor
     * @param {string} url
     */
    var Logger = function (url) {
        this.url = url;
        this.levels =
        {
            'disable' : -1,
            'error' : 0,
            'warn' : 1,
            'info' : 2,
            'log' : 2,
            'debug' : 3
        };
    };

    /**
     * Configure this logger as the object that handles trapped errors from <code>ErrorTrapper</code>.
     *
     * @method registerForTrappedErrors
     */
    Logger.prototype.registerForTrappedErrors = function () {
    };

    /**
     * Event handler for a 'errortrap' event. Calls <code>error()</code> on this with the given error.
     *
     * @method onError
     * @param {Event} e The triggering 'errortrap' event
     * @param {object} error The error to log.
     */
    Logger.prototype.onError = function (e, error) {
        this.error(error);
    };

    /**
     * Log a message.
     *
     * @method _log
     * @param {*} method
     * @param {string} message
     * @private
     */
    Logger.prototype._log = function (method, message) {
        if (hasConsole()) {
            if (window.console[method]) {
                window.console[method](message);
            } else {
                window.console.log(message);
            }
        }

        // Connect this logger to the first portlet on the page, so that it can perform remote logging.
        if (this.url == null) {
            this.url = $('.js-portletLog').data('logUrl');
        }

        if (this.url && this.levels[method] <= this.levels[window.dtnGlobals.minRemoteLogLevel]) {
            var url = this.url
                .replace('replace-me-message', encodeURIComponent($.trim(message)))
                .replace('replace-me-level', encodeURIComponent(method));

            Util.get(url);
        }
    };

    /**
     * Log a log message.
     *
     * @method log
     * @param {string} message
     */
    Logger.prototype.log = function (message) {
        this._log('log', message);
    };

    /**
     * Log a debug message.
     *
     * @method debug
     * @param {string} message
     */
    Logger.prototype.debug = function (message) {
        this._log('debug', message);
    };

    /**
     * Log an info message.
     *
     * @method info
     * @param {string} message
     */
    Logger.prototype.info = function (message) {
        this._log('info', message);
    };

    /**
     * Log a warning message.
     *
     * @method warn
     * @param {string} message
     */
    Logger.prototype.warn = function (message) {
        this._log('warn', message);
    };

    /**
     * Log an error message.
     *
     * @method error
     * @param {string} message
     */
    Logger.prototype.error = function (message) {
        this._log('error', message);
    };

    /**
     * Assert a condition is met.
     *
     * @method assert
     * @param {boolean} condition
     * @param {string} message
     */
    Logger.prototype.assert = function (condition, message) {
        if (hasConsole()) {
            window.console.assert(condition, message);
        }
    };

    return Logger;
});

/**
 * @fileOverview LoadingSpinnerComponent module definition
 *
 * @author [add author name here]
 */
define('components/LoadingSpinnerComponent',['require','jquery'],function (require) {
    
    var $ = require('jquery');

    var LoadingSpinnerComponent = function (settings) {
        this.$el = $('<div class="loadingSpinner"></div>');
        this.size = 1;
        var defaultSettings = {
            size: 1
        };
        this.settings = $.extend({}, defaultSettings, settings);

        this.setupSpinner();
    };

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    LoadingSpinnerComponent.isSafeToCallDestroy = false;
    LoadingSpinnerComponent.id = 'LoadingSpinnerComponent';
    LoadingSpinnerComponent.prototype.constructor = LoadingSpinnerComponent;

    LoadingSpinnerComponent.prototype.setupSpinner = function () {

        var size = this.settings.size;
        var borderWidth = size * 0.1;
        var position = size * 0.5 + borderWidth * 0.75;

        this.$el.css({
            'width': size + 'em',
            'height': size + 'em',
            'top': 'calc(50% - ' + position + 'em)',
            'left': 'calc(50% - ' + position + 'em)',
            'border-width': borderWidth + 'em',
            'position': 'absolute',
            'z-index': '2'
        });

        return this;

    };


    return LoadingSpinnerComponent;
});

/**
 * @author Kevin Moot
 * @file BaseComponent module definition
 */
define('components/BaseComponent',['require','../lib/Util','jquery','../lib/Logger','./LoadingSpinnerComponent'],function (require) {
    

    var Util = require('../lib/Util');
    var $ = require('jquery');
    var Logger = require('../lib/Logger');
    var LoadingSpinnerComponent = require('./LoadingSpinnerComponent');

    /**
     * Base component for other components to extend from.
     *
     * @class BaseComponent
     * @constructor
     */
    var BaseComponent = function (type) {
        /**
         * A reference to the class type.
         *
         * @property type
         * @type {Class}
         */
        this.type = type;

        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = null;

        /**
         * Tracks whether component is enabled.
         *
         * @property isEnabled
         * @type {boolean}
         */
        this.isEnabled = false;

        /**
         * Tracks whether component is initialized.
         *
         * @property isInitialized
         * @type {boolean}
         */
        this.isInitialized = false;

        /**
         * Tracks the current breakpoint state.
         *
         * @property currentBreakpoint
         * @type {window.dtnGlobals.breakpointType}
         */
        this.currentBreakpoint = null;

        /**
         * Tracks the current orientation state.
         *
         * @property currentOrientation
         * @type {window.dtnGlobals.orientationType}
         */
        this.currentOrientation = null;
    };

    /**
     * Initializes the UI Component View.
     *
     * Runs a single setupHandlers call, followed by createChildren and layout
     * Exits early if it is already initialized.
     *
     * @chainable
     * @method init
     */
    BaseComponent.prototype.init = function () {
        if (this.isInitialized || Util.isInitialized(this.$element, this.type.id)) {
            return this;
        }
        var logUrl = this.$element.parents('.js-portletLog').data('logUrl');
        this.logger = new Logger(logUrl);

        this.isInitialized = true;
        Util.setInitialized(this.$element, this.type.id, true);

        this.onInit() // Call implementation of child function
            .setupHandlers()
            .createChildren()
            .layout()
            .enable();

        return this;
    };

    /**
     * Binds the scope of any handler functions.
     *
     * Should only be run on initialization of the view.
     *
     * @chainable
     * @method setupHandlers
     */
    BaseComponent.prototype.setupHandlers = function () {
        // Bind event handlers scope here
        this.breakpointChangeHandler = this.breakpointChange.bind(this);
        this.destroyHandler = this.destroy.bind(this);

        this.onSetupHandlers(); // Call implementation of child function
        return this;
    };

    /**
     * Create any child objects or references to DOM elements.
     *
     * Should only be run on initialization of the view.
     *
     * @chainable
     * @method createChildren
     */
    BaseComponent.prototype.createChildren = function () {
        Util.subscribe('breakpointChange', this.breakpointChangeHandler);
        if (this.$element) {
            this.$element.on('destroy.' + this.type.id, this.destroyHandler);
            this.$element.on('domTeardown.' + this.type.id, $.noop); //jquery special event fired upon element destroy
        }

        this.onCreateChildren(); // Call implementation of child function

        //Enters the corresponding breakpoint for the current screen size.
        //Should only be run on initialization of the view
        var currentBreakpoint = Util.getCurrentBreakpoint(); // Refresh from current global breakpoint state

        if (currentBreakpoint === window.dtnGlobals.breakpointType.DESKTOP) {
            this.onDesktopEnter();
        } else if (currentBreakpoint === window.dtnGlobals.breakpointType.MOBILE) {
            this.onMobileEnter();
        }

        var currentOrientation = Util.getCurrentOrientation(); // Refresh from current global orientation state

        if (currentOrientation === window.dtnGlobals.orientationType.PORTRAIT) {
            this.onPortraitEnter();
        } else if (currentOrientation === window.dtnGlobals.orientationType.LANDSCAPE) {
            this.onLandscapeEnter();
        }

        return this;
    };

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @chainable
     * @method removeChildren
     */
    BaseComponent.prototype.removeChildren = function () {
        this.onRemoveChildren(); // Call implementation of child function
        return this;
    };

    /**
     * Performs measurements and applys any positioning style logic.
     *
     * Should be run anytime the parent layout changes.
     *
     * @chainable
     * @method layout
     */
    BaseComponent.prototype.layout = function () {
        this.onLayout();
        return this;
    };

    /**
     * Enables the component.
     *
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @chainable
     * @method enable
     */
    BaseComponent.prototype.enable = function () {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.onEnable(); // Call implementation of child function
        return this;
    };

    /**
     * Disables the component.
     *
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @chainable
     * @method disable
     */
    BaseComponent.prototype.disable = function () {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;

        this.onDisable(); // Call implementation of child function
        return this;
    };

    /**
     * Destroys the component.
     *
     * Tears down any events, handlers, elements.
     * Should be called when the object should be left unused.
     *
     * @chainable
     * @method destroy
     */
    BaseComponent.prototype.destroy = function () {
        // only destroy the component if on the "white list" to safely do so
        // TODO: after testing onDestroy() method of all components remove this check
        // and destroy all components no matter what
        if (this.type.isSafeToCallDestroy !== false) {
            this.isInitialized = false;

            Util.unsubscribe('breakpointChange', this.breakpointChangeHandler);

            if (this.$element) {
                // Note: if element isn't properly destroyed, this could
                // cause an infinite loop since we are attaching and then getting
                // re-attached again
                Util.setInitialized(this.$element, this.type.id, false);

                this.$element.off('destroy.' + this.type.id, this.destroyHandler);
                this.$element.off('domTeardown.' + this.type.id, $.noop);
            }

            this.disable()
                .removeChildren()
                .onDestroy(); // Call implementation of child function
        }

        return this;
    };

    /*
     * Tells the component to destory itself, and then re-create
     */
    BaseComponent.prototype.reattach = function () {
        // only destroy the component if on the "white list" to safely do so
        // TODO: after testing onDestroy() method of all components remove this check
        // and destroy all components no matter what
        if (this.type.isSafeToCallDestroy !== false) {
            // Trap a reference to $element since it will be lost upon calling destroy()
            var $element = this.$element;

            // Destroy and then re-initialize the component
            this.destroy();
            $element.trigger('attachjs');
        }
    };

    BaseComponent.prototype.onReRender = function (e, $element) {
        this.reRender($element);
    };

    /**
     * Rerender the component.
     *
     * @method reRender
     */
    BaseComponent.prototype.reRender = function ($element, reRenderEndpoint, params) {
        if (!$element || $element === null) {
            $element = this.$element;
        }
        if (params === null || typeof params === 'undefined') {
            params = {};
        }

        // Always send down a "recache" param on rerender so that we can invalidate the cache for this portlet.
        // The assumption is that any time a portlet is re-rendered, we are doing so due to a change affecting
        // portlet state.
        params.recache = true;

        var spinner = new LoadingSpinnerComponent({size: 3});
        var $spinner = spinner.$el;
        var wasOpen = $element.find('.js-visibilityToggle-target').attr('data-was-open');
        if (!reRenderEndpoint || reRenderEndpoint == null) {
            reRenderEndpoint = $element.attr('data-rerender-endpoint');
        }
        var reRenderAt = $element.attr('data-rerender-at-selector');
        var $parent;

        if (reRenderAt) {
            $parent = $element.parents(reRenderAt);
        } else {
            $parent = $element.parent();
        }

        var h = $parent.height();
        $parent.css('height', h).empty().append($spinner);

        Util.getHTML(reRenderEndpoint, params)
            .done(this.onHtmlLoadSuccess.bind(this, reRenderEndpoint, reRenderAt, $parent, $spinner, wasOpen))
            .fail(this.onHtmlLoadFailure.bind(this, reRenderEndpoint, reRenderAt, $parent, $spinner, wasOpen));
    };

    /**
     * Success callback for deferred load of portlet HTML.
     *
     * @method onHtmlLoadSuccess
     * @param {string} reRenderEndpoint
     * @param {string} reRenderAt
     * @param {jQuery} $parent
     * @param {jQuery} $spinner
     * @param {boolean} wasOpen
     * @param {string} htmlResponse
     */
    BaseComponent.prototype.onHtmlLoadSuccess = function (
        reRenderEndpoint,
        reRenderAt,
        $parent,
        $spinner,
        wasOpen,
        htmlResponse
    ) {
        var $html;
        if (reRenderAt) {
            $html = $(htmlResponse).find(reRenderAt);
        } else {
            $html = $(htmlResponse);
        }

        if ($html.length > 0) {
            // if portlet was originally open, we want to preserve that
            if (wasOpen) {
                $html.find('.js-visibilityToggle-target').attr('data-was-open', wasOpen);
            }

            $parent.append($html)
                   .css('height', '')
                   .trigger('attachjs');
        } else {
            var errorMessage = 'Failed to fetch new content: target content not found.';

            $parent.text(errorMessage);
        }

        $spinner.remove();
    };

    /**
     * Failure callback for deferred load of portlet HTML.
     *
     * @method onHtmlLoadFailure
     * @param {string} reRenderEndpoint
     * @param {string} reRenderAt
     * @param {jQuery} $parent
     * @param {jQuery} $spinner
     * @param {boolean} wasOpen
     * @param {jqXHR} jqXHR
     * @param {string} textStatus
     * @param {string} errorThrown
     */
    /*jshint -W072 */
    BaseComponent.prototype.onHtmlLoadFailure = function (
        reRenderEndpoint,
        reRenderAt,
        $parent,
        $spinner,
        wasOpen,
        jqXHR,
        textStatus,
        errorThrown
    ) {
        $parent.text('Failed to fetch new content: ' + jqXHR.status + ' ' + jqXHR.statusText);

        $spinner.remove();
    };

    /**
     * Breakpoint handler
     * Event handler for all breakpoint or orientation changes.
     * Dispatches the appropriate method based on type parameter supplied.
     *
     * @method breakpoint
     * @param {Event} JS event object
     * @param {string} type The event type to dispatch
     * @see BreakpointListener
     */
    BaseComponent.prototype.breakpointChange = function (e, type) {
        switch (type) {
            case 'portraitEnter':
                this.onPortraitEnter();
                break;
            case 'portraitExit':
                this.onPortraitExit();
                break;
            case 'landscapeEnter':
                this.onLandscapeEnter();
                break;
            case 'landscapeExit':
                this.onLandscapeExit();
                break;
            case 'mobileEnter':
                this.onMobileEnter();
                break;
            case 'mobileExit':
                this.onMobileExit();
                break;
            case 'desktopEnter':
                this.onDesktopEnter();
                break;
            case 'desktopExit':
                this.onDesktopExit();
                break;
            case 'viewportChange':
                this.onViewportChange();
                break;
        }
    };

    //////////////////////////////////////////////////////////////////////
    // Abstract functions to be implemented by child classes
    //////////////////////////////////////////////////////////////////////

    /**
     * On init handler.
     *
     * @chainable
     * @method onInit
     */
    BaseComponent.prototype.onInit = function () {
        return this;
    };

    /**
     * On setup handlers.
     *
     * @chainable
     * @method onSetupHandlers
     */
    BaseComponent.prototype.onSetupHandlers = function () {
        return this;
    };

    /**
     * On create children handler.
     *
     * @chainable
     * @method onCreateChildren
     */
    BaseComponent.prototype.onCreateChildren = function () {
        return this;
    };

    /**
     * On remove children handler
     *
     * @chainable
     * @method onRemoveChildren
     */
    BaseComponent.prototype.onRemoveChildren = function () {
        return this;
    };

    /**
     * On layout handler
     *
     * @chainable
     * @method onLayout
     */
    BaseComponent.prototype.onLayout = function () {
        return this;
    };

    /**
     * On enable handler
     *
     * @chainable
     * @method onEnable
     */
    BaseComponent.prototype.onEnable = function () {
        return this;
    };

    /**
     * On disable handler
     *
     * @chainable
     * @method onDisable
     */
    BaseComponent.prototype.onDisable = function () {
        return this;
    };

    /**
     * On destroy handler
     *
     * @chainable
     * @method onDestroy
     */
    BaseComponent.prototype.onDestroy = function () {
        return this;
    };

    /**
     * On desktop enter handler
     *
     * @chainable
     * @method onDesktopEnter
     */
    BaseComponent.prototype.onDesktopEnter = function () {
        return this;
    };

    /**
     * On desktop exit handler
     *
     * @chainable
     * @method onDesktopExit
     */
    BaseComponent.prototype.onDesktopExit = function () {
        return this;
    };

    /**
     * On desktop exit handler
     *
     * @chainable
     * @method onDesktopExit
     */
    BaseComponent.prototype.onViewportChange = function () {
        return this;
    };

    /**
     * On mobile enter handler
     *
     * @chainable
     * @method onMobileEnter
     */
    BaseComponent.prototype.onMobileEnter = function () {
        return this;
    };

    /**
     * On mobile exit handler
     *
     * @chainable
     * @method onMobileExit
     */
    BaseComponent.prototype.onMobileExit = function () {
        return this;
    };

    /**
     * On portrait enter handler
     *
     * @chainable
     * @method onPortraitEnter
     */
    BaseComponent.prototype.onPortraitEnter = function () {
        return this;
    };

    /**
     * On portrait exit handler
     *
     * @chainable
     * @method onPortraitExit
     */
    BaseComponent.prototype.onPortraitExit = function () {
        return this;
    };

    /**
     * On landscape enter handler
     *
     * @chainable
     * @method onLandscapeEnter
     */
    BaseComponent.prototype.onLandscapeEnter = function () {
        return this;
    };

    /**
     * On landscape exit handler
     *
     * @chainable
     * @method onLandscapeExit
     */
    BaseComponent.prototype.onLandscapeExit = function () {
        return this;
    };

    return BaseComponent;
});

define('views/SubNavView',['exports', 'module', 'jquery', 'components/BaseComponent'], function (exports, module, _jquery, _componentsBaseComponent) {
    

    module.exports = SubNavView;

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _BaseComponent = babelHelpers.interopRequireDefault(_componentsBaseComponent);

    var EXPAND_DURATION = 300;
    var COLLAPSE_DURATION = 300;
    var EASING = 'swing';
    var IS_ACTIVE_CLASS = 'isActive';

    /**
     * Jump to view.
     *
     * @class SubNavView
     * @constructor
     * @extends BaseComponent
     */

    function SubNavView($element, browserDetect) {
        this.$element = $element;
        this.browserDetect = browserDetect;

        this.init();
    }

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    SubNavView.isSafeToCallDestroy = false;
    SubNavView.id = 'SubNavView';
    SubNavView.prototype = new _BaseComponent['default'](SubNavView);
    SubNavView.prototype.constructor = SubNavView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Binds the scope of any handler functions.
     *
     * Should only be run on initialization of the view.
     *
     * @chainable
     * @method onSetupHandler
     */
    SubNavView.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here
        this.onClickHandler = this.onClick.bind(this);

        return this;
    };

    SubNavView.prototype.onCreateChildren = function () {
        this.$body = (0, _$['default'])(document.body);
        this.$subNavLink = this.$element.find('.subNav-link');
        this.$subNavPanel = this.$element.find('.subNav-panel');

        return this;
    };

    /**
     * Enables the component.
     *
     * Performs any event binding to handlers.
     * Does not execute if component is already enabled.
     *
     * @chainable
     * @method onEnable
     */
    SubNavView.prototype.onEnable = function () {
        // @todo Something is removing the jQuery based event listener on /agriculture/web/ag/alerts-updates
        // after a location has been changed. Using addEventListener fixes the issue until we have
        // time to implement smarter portlet refreshing.
        // this.$subNavLink[0].addEventListener('click', this.onClickHandler);
        this.$subNavLink.on('click.SubNavView', this.onClickHandler);
        return this;
    };

    /**
     * Disables the component.
     *
     * Tears down any event binding to handlers.
     * Does not execute if component is already disabled.
     *
     * @chainable
     * @method onDisable
     */
    SubNavView.prototype.onDisable = function () {
        // Tear down any event handlers
        if (this.$subNavLink) {
            this.$subNavLink.off('click.SubNavView', this.onClickHandler);
        }

        return this;
    };

    /**
     * Destroys the component.
     *
     * Assume that onDisable() and onRemoveChildren() are called prior to this.
     * Should be called when the object should be left unused.
     *
     * @chainable
     * @method onDestroy
     */
    SubNavView.prototype.onDestroy = function () {
        // Clear any timeouts, etc.

        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * On click handler.
     *
     * Perform an action upon click.
     *
     * @method onClick
     * @param {Event} e JS Event object.
     */
    SubNavView.prototype.onClick = function (e) {
        e.preventDefault();
        this.togglePanel();
    };

    /**
     * Toggle the panel.
     *
     * Opens or closes the sideNav panel based on its current status.
     *
     * @method togglePanel
     * @param {Event} e JS Event object.
     */
    SubNavView.prototype.togglePanel = function () {
        if (!this.$subNavPanel.hasClass('isActive')) {
            this.showPanel();
            return;
        }

        this.hidePanel();
    };

    /**
     * Show the panel.
     *
     * Decides how to open the sideNav panel.
     *
     * @method showPanel
     * @param {Event} e JS Event object.
     */
    SubNavView.prototype.showPanel = function () {
        var $subNavPanel = this.$subNavPanel;
        var $subNavLink = this.$subNavLink;

        $subNavPanel.stop(true, true).slideDown({
            queue: false,
            easing: EASING,
            duration: EXPAND_DURATION,
            complete: function complete() {
                $subNavPanel.addClass(IS_ACTIVE_CLASS);
            }
        });
        $subNavLink.addClass(IS_ACTIVE_CLASS);
    };

    /**
     * Hide the panel.
     *
     * Decides how to hide the subNav panel.
     *
     * @method showPanel
     * @param {Event} e JS Event object.
     */
    SubNavView.prototype.hidePanel = function () {
        var $subNavPanel = this.$subNavPanel;
        var $subNavLink = this.$subNavLink;

        $subNavPanel.stop(true, true).slideUp({
            queue: false,
            easing: EASING,
            duration: COLLAPSE_DURATION,
            complete: function complete() {
                $subNavPanel.removeClass(IS_ACTIVE_CLASS).css('display', ''); // Removing 'display: none' to reset to CSS inherited styles
            }
        });
        $subNavLink.removeClass(IS_ACTIVE_CLASS);
    };
});
define('views/generic/SimpleLocationView',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var SimpleLocationView = (function (_Component) {
        babelHelpers.inherits(SimpleLocationView, _Component);

        function SimpleLocationView() {
            babelHelpers.classCallCheck(this, SimpleLocationView);
            babelHelpers.get(Object.getPrototypeOf(SimpleLocationView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(SimpleLocationView, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(SimpleLocationView.prototype), 'ready', this).apply(this, arguments);

                var inputVal = this.$input.val();
                if (inputVal !== '') {
                    this._showSaveLocationFlyer();
                }

                this.$submit.removeAttr('disabled');
            }
        }, {
            key: 'onInputFocus',
            value: function onInputFocus() {
                this._showSaveLocationFlyer();
            }
        }, {
            key: 'onFormSubmit',
            value: function onFormSubmit(event) {
                event.preventDefault();

                _metricsService['default'].locationEntry(this.config.portletTitle, this.$input.val());

                this.sendAction('notifyPostalChange', [this.$form.serializeArray()]);

                return false;
            }
        }, {
            key: 'onNotifyPostalChange',
            value: function onNotifyPostalChange(event, serializedForm) {
                this.sendAction('reRender', [this.$form.attr('action'), serializedForm]);
            }
        }, {
            key: 'onResetToDefaultLocation',
            value: function onResetToDefaultLocation(event) {
                // Clearing out the input and submitting the form caused the users
                // saved default location to be returned
                this.$input.val('');
                this.onFormSubmit(event);
            }
        }, {
            key: '_showSaveLocationFlyer',
            value: function _showSaveLocationFlyer() {
                this.sendAction('showSaveLocationFlyer');
            }
        }, {
            key: '_hideSaveLocationFlyer',
            value: function _hideSaveLocationFlyer() {
                this.sendAction('hideSaveLocationFlyer');
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    portletTitle: ''
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$form', selector: '.js-simpleLocationView-form', event: 'submit' }, { prop: '$input', selector: '.js-simpleLocationView-input', event: 'focus' }, { prop: '$submit', selector: '.js-simpleLocationView-submit' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'bubble', event: 'resetToDefaultLocation' }, { type: 'store', action: 'notifyPostalChange.SimpleLocationView' }];
            }
        }]);
        return SimpleLocationView;
    })(_Component2['default']);

    module.exports = SimpleLocationView;
});
define('views/generic/SaveLocationFlyerView',['exports', 'module', 'components/Component', 'lib/Util'], function (exports, module, _componentsComponent, _libUtil) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var SaveLocationFlyerView = (function (_Component) {
        babelHelpers.inherits(SaveLocationFlyerView, _Component);

        function SaveLocationFlyerView() {
            babelHelpers.classCallCheck(this, SaveLocationFlyerView);
            babelHelpers.get(Object.getPrototypeOf(SaveLocationFlyerView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(SaveLocationFlyerView, [{
            key: 'show',
            value: function show() {
                // Existance of username == user is signed in.
                // This logic shoud probably be moved to the template layer and not render
                // this component at all
                if (window.dtnGlobals.userName != null) {
                    return false;
                }

                // If the "I've already dismissed this" cookie isnt present, show the flyer
                if (!_Util['default'].getStoredValue(this.consts.SAVE_LOCATION_FLYER_COOKIE_KEY)) {
                    this.$flyer.removeClass('isHidden');
                }

                return false;
            }
        }, {
            key: 'hide',
            value: function hide() {
                if (this.$flyer.hasClass('isHidden')) {
                    return false;
                }

                this.$flyer.addClass('isHidden');

                // Set the "I've already dismissed this" cookie to true
                _Util['default'].setStoredValue(this.consts.SAVE_LOCATION_FLYER_COOKIE_KEY, true);

                // Signal to other instances to also hide.
                this.sendAction('hideAllSaveLocationFlyers');

                return false;
            }
        }, {
            key: 'consts',
            get: function get() {
                return {
                    SAVE_LOCATION_FLYER_COOKIE_KEY: 'SAVE_LOCATION_FLYER_COOKIE_DISMISSED'
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$flyer', selector: '.js-saveLocationFlyerView-flyer' }, { prop: '$cancelButton', selector: '.js-saveLocationFlyerView-cancel', event: 'click', func: 'hide' }];
            }
        }, {
            key: 'actions',
            get: function get() {
                return [{ type: 'bubble', event: 'showSaveLocationFlyer', func: 'show' }, { type: 'bubble', event: 'hideSaveLocationFlyer', func: 'hide' }, { type: 'store', action: 'hideAllSaveLocationFlyers', func: 'hide' }];
            }
        }]);
        return SaveLocationFlyerView;
    })(_Component2['default']);

    module.exports = SaveLocationFlyerView;
});
define('views/dashboard/PollView',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var PollView = (function (_Component) {
        babelHelpers.inherits(PollView, _Component);

        function PollView() {
            babelHelpers.classCallCheck(this, PollView);
            babelHelpers.get(Object.getPrototypeOf(PollView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(PollView, [{
            key: 'onSubmit',
            value: function onSubmit(event) {
                event.preventDefault(); // `return false` isn't preventing the default event

                this.sendAction('reRender', [this.$element.attr('action'), this.$element.serializeArray()]);

                return false;
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'submit' }];
            }
        }]);
        return PollView;
    })(_Component2['default']);

    module.exports = PollView;
});
define('views/dashboard/DashboardVideoView',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var DashboardVideoView = (function (_Component) {
        babelHelpers.inherits(DashboardVideoView, _Component);

        function DashboardVideoView() {
            babelHelpers.classCallCheck(this, DashboardVideoView);
            babelHelpers.get(Object.getPrototypeOf(DashboardVideoView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(DashboardVideoView, [{
            key: 'onVideoLinkClick',
            value: function onVideoLinkClick(evt) {
                evt.preventDefault(); // `return false` isn't preventing the default event

                var $nextVideo = $(evt.currentTarget);

                // Set new data configs on video player before resetting it
                this.$videoPlayer.attr('data-config-embed-code', $nextVideo.attr('data-config-embed-code'));
                this.$videoPlayer.attr('data-config-video-title', $nextVideo.attr('data-config-video-title'));
                this.$videoPlayer.attr('data-config-video-description', $nextVideo.attr('data-config-video-description'));

                this.$videoPlayer.trigger('reload');

                return false;
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{
                    prop: '$videoLinks',
                    selector: '.js-dashboardVideoView-videos',
                    event: 'click',
                    delegate: '.video-link',
                    func: 'onVideoLinkClick'
                }, { selector: '.js-ooyalaVideoPlayer', prop: '$videoPlayer' }];
            }
        }]);
        return DashboardVideoView;
    })(_Component2['default']);

    module.exports = DashboardVideoView;
});
define('views/news/CattleAuctionsHeadlinesView',['exports', 'module', 'jquery', 'components/BaseComponent', 'shared-scripts/components/LoadingSpinnerComponent', 'shared-scripts/services/metricsService'], function (exports, module, _jquery, _componentsBaseComponent, _sharedScriptsComponentsLoadingSpinnerComponent, _sharedScriptsServicesMetricsService) {
    

    module.exports = CattleAuctionsHeadlinesView;

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _BaseComponent = babelHelpers.interopRequireDefault(_componentsBaseComponent);

    var _LoadingSpinnerComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsLoadingSpinnerComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    function CattleAuctionsHeadlinesView($element, browserDetect) {
        this.$element = $element;
        this.browserDetect = browserDetect;
        this.init();
    }

    // call parent constructor
    CattleAuctionsHeadlinesView.id = 'CattleAuctionsHeadlinesView';
    CattleAuctionsHeadlinesView.prototype = new _BaseComponent['default'](CattleAuctionsHeadlinesView);
    CattleAuctionsHeadlinesView.prototype.constructor = CattleAuctionsHeadlinesView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    CattleAuctionsHeadlinesView.prototype.onSetupHandlers = function () {
        this.onCategoriesSelectChangeHandler = this.onCategoriesSelectChange.bind(this);
        this.onRefreshButtonClickHandler = this.onRefreshButtonClick.bind(this);

        return this;
    };

    CattleAuctionsHeadlinesView.prototype.onCreateChildren = function () {
        var $element = this.$element;

        // Init children elmts
        this.$headlinesCategories = $element.find('.js-cattleAuctionsHeadlines-categories');
        this.$headlinesRefresh = $element.find('.js-cattleAuctionsHeadlines-refresh');
        this.$spinnerContainer = $element.find('.js-spinnerContainer');

        // Init data
        this.headlinesResourceUrl = $element.data('headlinesResourceUrl');
        this.selectedProductCode = $element.data('selectedProductCode');
        this.referringStoryId = $element.data('referringStoryId');
        this.portletNamespace = $element.data('portletNamespace');
        this.refreshDelay = parseInt($element.data('refreshInterval'), 10);
        this.infoUnavailableMessage = $element.data('infoUnavailableMessage');

        // Init components
        this.spinner = new _LoadingSpinnerComponent['default']({ size: 3 });

        return this;
    };

    CattleAuctionsHeadlinesView.prototype.onRemoveChildren = function () {
        // Tear down children elmts
        this.$headlinesCategories = null;
        this.$headlinesRefresh = null;
        this.$spinnerContainer = null;

        // Tear down data
        this.productCode = null;
        this.refreshDelay = null;

        // Tear down components
        this.spinner = null;

        return this;
    };

    CattleAuctionsHeadlinesView.prototype.onLayout = function () {
        return this;
    };

    CattleAuctionsHeadlinesView.prototype.onEnable = function () {
        // Subscribe event handling
        this.$headlinesCategories.on('change.CattleAuctionsHeadlinesView', this.onCategoriesSelectChangeHandler);
        this.$headlinesRefresh.on('click.CattleAuctionsHeadlinesView', this.onRefreshButtonClickHandler);

        // Append the spinner
        this.$spinnerContainer.append(this.spinner.$el);

        this._setRefreshTimeout();

        return this;
    };

    CattleAuctionsHeadlinesView.prototype.onDisable = function () {
        // Tear down event handling
        this.$headlinesCategories.off('change.CattleAuctionsHeadlinesView', this.onCategoriesSelectChangeHandler);
        this.$headlinesRefresh.off('click.CattleAuctionsHeadlinesView', this.onRefreshButtonClickHandler);

        // Tear down the spinner
        this.$spinnerContainer.empty();

        // Clear refresh timeout
        this._clearRefreshTimeout();

        return this;
    };

    CattleAuctionsHeadlinesView.prototype.onDestroy = function () {
        this.$element = null;
        this.browserDetect = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    CattleAuctionsHeadlinesView.prototype.onRefreshButtonClick = function (e) {
        e.preventDefault();

        var portletTitle = this.$headlinesRefresh.attr('data-config-portlet-title');

        _metricsService['default'].refreshClick(portletTitle);

        this._refreshCattleAuctionsHeadlines();
    };

    CattleAuctionsHeadlinesView.prototype.onCategoriesSelectChange = function () {
        var portletTitle = this.$headlinesCategories.attr('data-config-portlet-title');
        var locationTerm = this.$headlinesCategories.find('option:selected').text();

        _metricsService['default'].locationEntry(portletTitle, locationTerm);

        this._requestCattleAuctionsHeadlines();
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Private methods
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Requests cattle aution headlines for product code
     * @private
     */
    CattleAuctionsHeadlinesView.prototype._requestCattleAuctionsHeadlines = function () {
        var productCode = this.$headlinesCategories.children('option:selected').val();

        // Build up the request url for the cattle auctions headlines
        window.location = window.dtnGlobals.siteContext + '/markets/cattle-auctions?productCode=' + productCode;
    };

    /**
     * Refreshes the page with the latest headlines
     * @private
     */
    CattleAuctionsHeadlinesView.prototype._refreshCattleAuctionsHeadlines = function () {
        window.location.reload();
    };

    /**
     * Clears the refresh timeout
     * @private
     */
    CattleAuctionsHeadlinesView.prototype._clearRefreshTimeout = function () {
        clearTimeout(this.refreshTimeout);
    };

    /**
     * Sets the refresh timeout, according to the configured refresh timeout duration
     * @private
     */
    CattleAuctionsHeadlinesView.prototype._setRefreshTimeout = function () {
        var self = this;
        self.refreshTimeout = setTimeout(function () {
            self._requestCattleAuctionsHeadlines();
        }, 1000 * 60 * self.refreshDelay);
    };
});
/**
 * @author Justin Mullin
 * @fileOverview BlogPostComments module definition.
 */
define('shared-scripts/views/news/BlogPostCommentsView',['require','shared-scripts/components/BaseComponent','shared-scripts/lib/Util','jquery','shared-scripts/services/metricsService'],function (require) {
    

    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var Util = require('shared-scripts/lib/Util');
    var $ = require('jquery');
    var metricsService = require('shared-scripts/services/metricsService');

    /**
     * Component for blog post comments portlet.
     *
     * @class BlogPostCommentsView
     * @constructor
     * @extends BaseComponent
     *
     */
    var BlogPostCommentsView = function ($element, browserDetect) {
        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = $element;

        /**
         * Add Comment element.
         *
         * @property $addComment
         * @type {jQuery}
         */
        this.$addComment = $('.js-blogPostComments-addComment');

        /**
         * Sort type element.
         *
         * @property $sortType
         * @type {jQuery}
         */
        this.$sortType = $('.js-blogPostComments-sortType');

        /**
         * Comment box element.
         *
         * @property $commentBox
         * @type {jQuery}
         */
        this.$commentBox = $('.js-blogPostComments-commentBox');

        /**
         * Comment list element.
         *
         * @property $commentList
         * @type {jQuery}
         */
        this.$commentList = $('.js-blogPostComments-commentList');

        /**
         * Submit comment element.
         *
         * @property $submitComment
         * @type {jQuery}
         */
        this.$submitComment = $('.js-blogPostComments-submitComment');

        /**
         * Submit comment form element.
         *
         * @property $submitCommentForm
         * @type {jQuery}
         */
        this.$submitCommentForm = $('.js-blogPostComments-submitCommentForm');

        /**
         * Browser Detect feature object.
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        // Extract configuration parameters from element attributes (in the form data-my-attribute='true')
        var parameters = $element.data();

        /**
         * Submit comment resource URL.
         *
         * @property
         * @type {string}
         */
        this.submitCommentResourceUrl = parameters.submitCommentResourceUrl;

        /**
         * Comment render URL.
         *
         * @property
         * @type {string}
         */
        this.commentRenderUrl = parameters.commentRenderUrl;

        this.init();
    };

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    BlogPostCommentsView.isSafeToCallDestroy = false;
    BlogPostCommentsView.id = 'BlogPostCommentsView';
    BlogPostCommentsView.prototype = new BaseComponent(BlogPostCommentsView);
    BlogPostCommentsView.prototype.constructor = BlogPostCommentsView;

    // ////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    // ////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Binds the scope of any handler functions Should only be run on
     * initialization of the view.
     *
     * @chainable
     * @method onSetupHandlers
     */
    BlogPostCommentsView.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here

        this.onAddCommentClickHandler = this.onAddCommentClick.bind(this);
        this.onSubmitCommentClickHandler = this.onSubmitCommentClick.bind(this);
        this.onSortChangeHandler = this.onSortChangeHandler.bind(this);

        return this;
    };

    /**
     * Removes any child objects or references to DOM elements.
     *
     * @chainable
     * @method onRemoveChildren
     */
    BlogPostCommentsView.prototype.onRemoveChildren = function () {
        // Remove any other dependencies here
        this.$element.find('div').remove();

        return this;
    };

    /**
     * Enables the component Performs any event binding to handlers.
     *
     * Does not execute if component is already enabled.
     *
     * @chainable
     * @method onEnable
     */
    BlogPostCommentsView.prototype.onEnable = function () {
        this.$addComment.on('click.BlogPostCommentsView', this.onAddCommentClickHandler);
        this.$submitComment.on('click.BlogPostCommentsView', this.onSubmitCommentClickHandler);
        this.$sortType.on('change.BlogPostCommentsView', this.onSortChangeHandler);

        this.onSortChangeHandler(null);

        return this;
    };

    /**
     * Disables the component Tears down any event binding to handlers.
     *
     * Does not execute if component is already disabled.
     *
     * @chainable
     * @method onDisable
     */
    BlogPostCommentsView.prototype.onDisable = function () {
        // Tear down any event handlers

        this.$addComment.off('click.BlogPostCommentsView', this.onAddCommentClickHandler);
        this.$submitComment.off('click.BlogPostCommentsView', this.onSubmitCommentClickHandler);
        this.$sortType.off('change.BlogPostCommentsView', this.onSortChangeHandler);

        return this;
    };

    /**
     * Destroys the component Assume that onDisable() and onRemoveChildren() are
     * called prior to this.
     *
     * Should be called when the object should be left unused.
     *
     * @chainable
     * @method onDestroy
     */
    BlogPostCommentsView.prototype.onDestroy = function () {
        // Clear any timeouts, etc.

        this.$element = null;
        return this;
    };

    // ////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    // ////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * On sort change handler.
     *
     * Handles change of the comment sort type select dropdown.
     *
     * @method onSortChangeHandler
     * @param {Event} e JS Event object.
     */
    BlogPostCommentsView.prototype.onSortChangeHandler = function (e) {
        var $comments = $('.js-blogPostComments-commentList .comment');

        var ascending = this.$sortType.val() === 'newestFirst';
        $comments.sort(this.postDateComparator.bind(this, ascending)).appendTo(this.$commentList);
    };

    /**
     * On add comment click handler.
     *
     * Perform an action upon click on the add comment button.
     *
     * @method onAddCommentClick
     * @param {Event} e JS Event object
     */
    BlogPostCommentsView.prototype.onAddCommentClick = function (e) {
        e.preventDefault();
        this.$commentBox.removeClass('isHidden');
        $('.js-blogPostComments-submitCommentForm textarea').val('');
    };

    /**
     * On submit comment click handler.
     *
     * Handler Perform an action upon click on the comment submit button.
     *
     * @method onSubmitCommentClick
     * @param {Event} e JS Event object.
     */
    BlogPostCommentsView.prototype.onSubmitCommentClick = function (e) {
        e.preventDefault();
        var formData = this.$submitCommentForm.serialize();
        var contentType = this.$submitComment.attr('data-config-content-type');
        var contentName = this.$submitComment.attr('data-config-content-name');

        metricsService.commentEntry(contentType, contentName);

        Util.get(this.submitCommentResourceUrl, formData)
            .done(this.handleSubmitCommentResult.bind(this, formData));
    };

    /**
     * Comparator function for sorting of comments.
     *
     * @method postDateComparator
     * @param ascending If true, sort by newest first; if false, oldest first.
     * @param a The first comment to compare.
     * @param b The second comment to compare.
     * @return {number}
     */
    BlogPostCommentsView.prototype.postDateComparator = function (ascending, a, b) {
        var aVal = a.getAttribute('data-post-time');
        var bVal = b.getAttribute('data-post-time');

        if(aVal > bVal) {
            return ascending ? -1 : 1;
        } else if(bVal > aVal) {
            return ascending ? 1 : -1;
        } else {
            return 0;
        }
    };

    /**
     * Handle an AJAX result returned from the view controller for a comment submission.
     *
     * @method handleSubmitCommentResult
     * @param {string} formData The comment submission form data to render a comment from.
     * @param {string} result The result data returned from the controller.
     */
    BlogPostCommentsView.prototype.handleSubmitCommentResult = function (formData, result) {
        try {
            result = JSON.parse(result);
        } catch (e) {
            // TODO: define error handling
            alert('Failed to post comment.');
        }

        if(result === 'success') {
            this.loadCommentItem(formData);
            this.$commentBox.addClass('isHidden');
        } else {
            // TODO: define error handling
            alert('Failed to post comment.');
        }
    };

    /**
     * Add a comment entry to the page from submitted form data.
     *
     * @method loadCommentItem
     * @param {string} formData Serialized form data for a comment submission.
     */
    BlogPostCommentsView.prototype.loadCommentItem = function (formData) {
        Util.get(this.commentRenderUrl + '&renderType=renderCommentFromForm', formData)
            .done(this.addCommentItem.bind(this));
    };

    /**
     * Appends a comment item to the comments list.
     *
     * @method addCommentItem
     * @param {array} item Comment to append.
     */
    BlogPostCommentsView.prototype.addCommentItem = function (item) {
        if(this.$sortType.val() === 'newestFirst') {
            this.$commentList.prepend(item);
        } else {
            this.$commentList.append(item);
        }
    };

    return BlogPostCommentsView;
});

define('views/news/CommentAdminView',['exports', 'module', 'components/Component'], function (exports, module, _componentsComponent) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var CommentAdminView = (function (_Component) {
        babelHelpers.inherits(CommentAdminView, _Component);

        function CommentAdminView() {
            babelHelpers.classCallCheck(this, CommentAdminView);
            babelHelpers.get(Object.getPrototypeOf(CommentAdminView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(CommentAdminView, [{
            key: 'onSubmit',
            value: function onSubmit(event) {
                event.preventDefault(); // `return false` isn't preventing the default event

                this.sendAction('CommentReRenderView.reRender', [this.$element.attr('action'), this.$element.serializeArray()]);
                this.sendAction('closeModal');

                return false;
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ event: 'submit' }];
            }
        }]);
        return CommentAdminView;
    })(_Component2['default']);

    module.exports = CommentAdminView;
});
define('views/news/CommentReRenderView',['exports', 'module', 'components/ReRenderComponent'], function (exports, module, _componentsReRenderComponent) {
    

    var _ReRenderComponent2 = babelHelpers.interopRequireDefault(_componentsReRenderComponent);

    var CommentReRenderView = (function (_ReRenderComponent) {
        babelHelpers.inherits(CommentReRenderView, _ReRenderComponent);

        function CommentReRenderView() {
            babelHelpers.classCallCheck(this, CommentReRenderView);
            babelHelpers.get(Object.getPrototypeOf(CommentReRenderView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(CommentReRenderView, [{
            key: 'actions',
            get: function get() {
                return [{ type: 'store', action: 'CommentReRenderView.reRender', func: 'onReRender' }];
            }
        }]);
        return CommentReRenderView;
    })(_ReRenderComponent2['default']);

    module.exports = CommentReRenderView;
});
/**
 * @file ContactAuthorFormView module definition
 */
define('views/news/ContactAuthorFormView',['require','jquery','shared-scripts/lib/Util','shared-scripts/components/BaseComponent'],function (require) {
    

    var $ = require('jquery');
    var Util = require('shared-scripts/lib/Util');
    var BaseComponent = require('shared-scripts/components/BaseComponent');

    /**
     * Contact author form view
     *
     * @class ContactAuthorFormView
     * @constructor
     * @extends BaseComponent
     *
     */
    function ContactAuthorFormView ($element, browserDetect) {
        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = $element;

        /**
         * Browser detect feature object.
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        /**
         * Contact author element.
         *
         * @property
         * @type {jQuery}
         */
        this.$contactAuthor = $('.js-contactAuthor').first();

        /**
         * Submit element.
         *
         * @property $submit
         * @type {jQuery}
         */
        this.$submit = this.$contactAuthor.find('.js-submit').first();

        /**
         * Cancel element.
         *
         * @property $cancel
         * @type {jQuery}
         */
        this.$cancel = this.$contactAuthor.find('.js-cancel').first();

        /**
         * Form element.
         *
         * @property $form
         * @type {jQuery}
         */
        this.$form = this.$contactAuthor.find('form');

        /**
         * Success container element.
         *
         * @property $successContainer
         * @type {jQuery}
         */
        this.$successContainer = this.$contactAuthor.find('.js-contact-success').first();

        /**
         * Failure container element.
         *
         * @property $failureContainer
         * @type {jQuery}
         */
        this.$failureContainer = this.$contactAuthor.find('.js-contact-failure').first();


        this.init();
    }

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    ContactAuthorFormView.isSafeToCallDestroy = false;
    ContactAuthorFormView.id = 'ContactAuthorFormView';
    ContactAuthorFormView.prototype = new BaseComponent(ContactAuthorFormView);
    ContactAuthorFormView.prototype.constructor = ContactAuthorFormView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Binds the scope of any handler functions.
     *
     * Should only be run on initialization of the view.
     *
     * @chainable
     * @method onSetupHandlers
     */
    ContactAuthorFormView.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here
        this.onEmailSubmitHandler = this.onEmailSubmit.bind(this);

        this.onFailure.bind(this);
        this.onSuccess.bind(this);


        return this;
    };

    /**
     * Enables the component.
     *
     * Performs any event binding to handlers.
     * Does not execute if component is already enabled.
     *
     * @chainable
     * @method onEnable
     */
    ContactAuthorFormView.prototype.onEnable = function () {
        // Setup any event handlers

        if (this.browserDetect.features.touch) {
            this.$submit.on('touchend', this.onEmailSubmitHandler);
            this.$cancel.on('touchend', this.onCancelSubmitHandler);
        } else {
            this.$submit.on('click', this.onEmailSubmitHandler);
            this.$cancel.on('click', this.onCancelSubmitHandler);
        }

        return this;
    };

    /**
     * Disables the component.
     *
     * Tears down any event binding to handlers.
     * Does not execute if component is already disabled.
     *
     * @chainable
     * @method onDisable
     */
    ContactAuthorFormView.prototype.onDisable = function () {
        // Tear down any event handlers
        if (this.$element != null) {
            this.$element.off('touchend.ContactAuthorFormView', this.onClickHandler);
            this.$element.off('click.ContactAuthorFormView', this.onClickHandler);

            this.$submit.off('touchend', this.onEmailSubmitHandler);
            this.$submit.off('click', this.onEmailSubmitHandler);

            this.$cancel.off('touchend', this.onCancelSubmitHandler);
            this.$cancel.off('click', this.onCancelSubmitHandler);


            this.$successButton.off('touchend', this.onSuccessOk);
            this.$failureButton.off('touchend', this.onFailureOkHandler);

            this.$successButton.off('click', this.onSuccessOk);
            this.$failureButton.off('click', this.onFailureOkHandler);
        }

        return this;
    };

    /**
     * Destroys the component.
     *
     * Assume that onDisable() and onRemoveChildren() are called prior to this.
     * Should be called when the object should be left unused.
     *
     * @chainable
     * @method onDestroy
     */
    ContactAuthorFormView.prototype.onDestroy = function () {
        // Clear any timeouts, etc.

        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * On email submit handler
     *
     * @method onEmailSubmit
     * @param {Event} e
     */
    ContactAuthorFormView.prototype.onEmailSubmit = function (e) {
        var url = this.$form.attr('action');

        e.preventDefault();

        //TODO: Validation
        Util.post(url, this.$form.serialize())
            .done(this.onSuccess.bind(this))
            .fail(this.onFailure.bind(this));
    };

    /**
     * On success handler.
     *
     * @method onSuccess
     */
    ContactAuthorFormView.prototype.onSuccess = function () {
        this.$form.addClass('isHidden');
        this.$successContainer.removeClass('isHidden');
    };

    /**
     * On failure handler.
     *
     * @method onFailure
     */
    ContactAuthorFormView.prototype.onFailure = function () {
        this.$form.addClass('isHidden');
        this.$failureContainer.removeClass('isHidden');
    };

    return ContactAuthorFormView;
});

define('views/news/RecommendedForYouView',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var RecommendedForYouView = (function (_Component) {
        babelHelpers.inherits(RecommendedForYouView, _Component);

        function RecommendedForYouView() {
            babelHelpers.classCallCheck(this, RecommendedForYouView);
            babelHelpers.get(Object.getPrototypeOf(RecommendedForYouView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(RecommendedForYouView, [{
            key: 'ready',
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(RecommendedForYouView.prototype), 'ready', this).apply(this, arguments);

                _metricsService['default'].recommendationsDisplayed(this.config.recommendationEngine, this.config.articleTitle);
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    recommendationEngine: { required: true },
                    articleTitle: { required: true }
                };
            }
        }]);
        return RecommendedForYouView;
    })(_Component2['default']);

    module.exports = RecommendedForYouView;
});
/**
 * @fileOverview AgribusinessSettingsView module definition
 *
 * @author Mike Eastes <meastes@nerdery.com>
 */
define('views/settings/AgribusinessSettingsView',['require','shared-scripts/components/BaseComponent','shared-scripts/lib/Util','jquery'],function (require) {
    

    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var Util = require('shared-scripts/lib/Util');
    var $ = require('jquery');

    /**
     * A view for handling logic with agribusiness settings
     *
     * @class AgribusinessSettingsView
     * @extends BaseComponent
     * @constructor
     */
    function AgribusinessSettingsView ($element, browserDetect) {
        /**
         * The container element for this component
         *
         * @property {jQuery} $element
         */
        this.$element = $element;

        /**
         * Feature-detection object
         *
         * @property {BrowserDetect} browserDetect
         */
        this.browserDetect = browserDetect;

        this.init();

        this.updateDom();
    }

    // call parent constructor
    AgribusinessSettingsView.id = 'AgribusinessSettingsView';
    AgribusinessSettingsView.prototype = new BaseComponent(AgribusinessSettingsView);
    AgribusinessSettingsView.prototype.constructor = AgribusinessSettingsView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Binds the scope of any handler functions
     * Should only be run on initialization of the view
     *
     * @method onSetupHandlers
     * @returns {AgribusinessSettingsView}
     */
    AgribusinessSettingsView.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here
        this.onRemoveClickHandler = this.onRemoveClick.bind(this);
        this.onAddClickHandler = this.onAddClick.bind(this);

        return this;
    };

    /**
     * Create any child objects or references to DOM elements
     * Should only be run on initialization of the view
     *
     * @method onCreateChildren
     * @returns {AgribusinessSettingsView}
     */
    AgribusinessSettingsView.prototype.onCreateChildren = function () {
        this.$removeBtns = this.$element.find('.js-remove');
        this.$addBtn = this.$element.find('.js-add');
        this.$rowContainer = this.$element.find('.js-row-container');
        this.$postalCode = this.$element.find('.js-postal-code');
        this.$errors = this.$element.find('.js-alert-errors');
        this.$errorItems = this.$element.find('.js-error-items');
        this.$table = this.$element.find('.js-agribusiness-table');

        this.maxRows = this.$element.attr('data-max-items');
        this.currentRows = this.$element.find('.js-agribusiness-row').length;

        this.templateUrl = this.$element.attr('data-template-url');
        this.postalValidUrl = this.$element.attr('data-postal-valid-url');

        this.postalErrorMessage = this.$element.attr('data-postal-error');
        this.maxItemsErrorMessage = this.$element.attr('data-max-items-error');
        this.postalHasDataErrorMessage = this.$element.attr('data-postal-data-error');

        return this;
    };

    /**
     * Removes any child objects or references to DOM elements
     *
     * @method onRemoveChildren
     * @returns {AgribusinessSettingsView}
     */
    AgribusinessSettingsView.prototype.onRemoveChildren = function () {
        // Remove any other dependencies here

        this.$removeBtns = null;
        this.$addBtn = null;
        this.$rowContainer = null;
        this.$postalCode = null;
        this.$errors = null;
        this.$errorItems = null;

        this.maxRows = 0;
        this.currentRows = 0;

        this.templateUrl = null;
        this.postalValidUrl = null;

        this.postalErrorMessage = null;
        this.maxItemsErrorMessage = null;
        this.postalHasDataErrorMessage = null;

        return this;
    };

    /**
     * Enables the component
     * Performs any event binding to handlers
     * Does not execute if component is already enabled
     *
     * @method onEnable
     * @returns {AgribusinessSettingsView}
     */
    AgribusinessSettingsView.prototype.onEnable = function () {
        // Setup any event handlers

        this.$removeBtns.on('click.AgribusinessSettingsView', this.onRemoveClickHandler);
        this.$addBtn.on('click.AgribusinessSettingsView', this.onAddClickHandler);

        return this;
    };

    /**
     * Disables the component
     * Tears down any event binding to handlers
     * Does not execute if component is already disabled
     *
     * @method onDisable
     * @returns {AgribusinessSettingsView}
     */
    AgribusinessSettingsView.prototype.onDisable = function () {
        // Tear down any event handlers
        if (this.$element !== null) {
            // Need to refind remove buttons for rows that were dynamically added
            this.$element.find('.js-remove').off('click.AgribusinessSettingsView', this.onRemoveClickHandler);
            this.$addBtn.off('click.AgribusinessSettingsView', this.onAddClickHandler);
        }

        return this;
    };


    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * on Remove Click Handler
     * Removes the current row from the table
     *
     * @method onRemoveClick
     * @param {Event} e JS Event object
     */
    AgribusinessSettingsView.prototype.onRemoveClick = function (e) {
        e.preventDefault();

        var $removeBtn = $(e.currentTarget);
        $removeBtn.off('click.AgribusinessSettingsView', this.onRemoveClickHandler);
        var $currRow = $removeBtn.closest('.js-agribusiness-row');

        $currRow.remove();

        this.currentRows--;

        // Renumber elevators
        this.$element.find('.js-agribusiness-elevator').each(function (index, el) {
            var $input = $(el);
            $input.attr('name', 'agribusinesses[' + index + '].id');
        });

        this.updateDom();
    };

    // TODO add enter event to postal field

    /**
     * on Add Click Handler
     * Attempts to add a new row to the table. Does a request to the server to validate the postal code
     * and then does another request to the server to retrieve the new row markup.
     *
     * @method onAddClick
     * @param {Event} e JS Event object
     */
    AgribusinessSettingsView.prototype.onAddClick = function (e) {
        e.preventDefault();

        if (this.maxRows <= this.currentRows) {
            // TODO spring message?
            this.displayError(this.maxItemsErrorMessage);
            return;
        }
        this.hideErrors();

        this.currentRows++;

        var params = {
            postalCode: this.$postalCode.val(),
        };

        // First need to validate the postal code
        Util.getJSON(this.postalValidUrl, params)
            .done(this.validateAndAddNewRow.bind(this))
            .fail(function () {
                // Need to undo the add if it fails
                this.currentRows--;
            }.bind(this));
    };

    /**
     * Handles the validation from the server and adds a new row if it passed.
     *
     * @method validateAndAddNewRow
     * @param {Boolean} validateJson True if the postal code passed validation
     */
    AgribusinessSettingsView.prototype.validateAndAddNewRow = function (validateJson) {
        if (!validateJson.valid) {
            // If the postal code isn't valid undo the the current row addition and return
            this.displayError(this.postalErrorMessage);
            this.currentRows--;
            return;
        }
        if (!validateJson.hasData) {
            // If the postal code doesn't have data undo the the current row addition and return
            this.displayError(this.postalHasDataErrorMessage);
            this.currentRows--;
            return;
        }
        this.hideErrors();

        // If postal code is valid and has data, get the new row
        var params = {
            postalCode: this.$postalCode.val(),
            rowNumber: this.currentRows - 1,
        };

        Util.get(this.templateUrl, params)
            .done(function (el) {
                // Add markup from the server as a row in the table
                var $newRow = $(el);
                this.$rowContainer.append($newRow);

                // Add the remove click event
                $newRow.find('.js-remove').on('click.AgribusinessSettingsView', this.onRemoveClickHandler);
                this.updateDom();
            }.bind(this))
            .fail(function () {
                // Need to undo the add if it fails
                this.currentRows--;
            }.bind(this));
    };

    /**
     * Shows a single error
     *
     * @method displayError
     * @param {String} message The error message to show
     */
    AgribusinessSettingsView.prototype.displayError = function (message) {
        this.displayErrors([message]);
    };

    /**
     * Shows a list of errors
     *
     * @method displayErrors
     * @param {Array} messages List of error messages
     */
    AgribusinessSettingsView.prototype.displayErrors = function (messages) {
        var $errorItems = this.$errorItems;

        $errorItems.empty();
        $.each(messages, function (idx, item) {
            $errorItems.append($('<li>' + item + '</li>'));
        });
        this.$errors.removeClass('isHidden');
    };

    /**
     * Hides the list of errors
     */
    AgribusinessSettingsView.prototype.hideErrors = function () {
        this.$errors.addClass('isHidden');
    };

    /**
     * Update DOM based on current state
     *
     * @method updateDom
     */
    AgribusinessSettingsView.prototype.updateDom = function () {
        if (this.currentRows <= 0) {
            this.$table.addClass('isHidden');
        } else {
            this.$table.removeClass('isHidden');
        }
    };

    return AgribusinessSettingsView;
});

/*jshint camelcase: false */
/**
 * @fileOverview Repository used as an abstraction layer for address data
 *
 * @author jklun
 * @version 1.0
 */
define('shared-scripts/repositories/AddressRepository',['require','jquery'],function (require) {
    

    var $ = require('jquery');

    var LOOKUP_TIMEOUT = 30000; // 30 seconds

    /**
     * @name AddressRepository
     * @constructor
     * @param textFieldId HTML ID of the text input to bind the type ahead to
     * @param addressUpdateCallback The function to call back when data is received.
     * Parameters will be null if no good data is found.
     * Parameters will be: latitude, longitude, address, addressDetails.
     * @since 1.0
     */
    var AddressRepository = function (textFieldId, addressUpdateCallback, $element) {
        this.$element = $element;
        this.textFieldId = textFieldId;
        this.addressUpdateCallback = addressUpdateCallback;

        this.isAirport = null;
        this.geocoderDeferred = $.Deferred();
        this.$inputField = null;

        /**
         * Reference to Event object for map
         *
         * @property MapEvent
         * @type {Event}
         */
        this.MapEvent = null;

        /**
         * Reference to eventBus object for map
         *
         * @property eventBus
         * @type {EventBus}
         */
        this.eventBus = null;

        this.setupHandlers()
            .createChildren()
            .enable();
    };

    AddressRepository.prototype.setupHandlers = function () {
        this.loadMapApiDoneHandler = this.loadMapApiDone.bind(this);
        this.renderMapDoneHandler = this.renderMapDone.bind(this);
        this.onTransformInputHandler = this.onTransformInput.bind(this);

        return this;
    };

    AddressRepository.prototype.createChildren = function () {
        this.$inputField = $('#' + this.textFieldId);

        this.isAirport = this.$inputField.data('lookupType') === 'airport';

        return this;
    };

    AddressRepository.prototype.enable = function () {
        this.loadMapApi();

        return this;
    };


    /////////////////////////////////////////////////////////////////////////////////////////////////
    // EVENT HANDLERS
    /////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Appends the word 'Airport' after the user-inputted search term
     * so that only airport results are returned
     */
    AddressRepository.prototype.onTransformInput = function (term) {
        if (this.isAirport) {
            term += ' Airport';
        }
        return term;
    };


    //////////////////////////////////////////////////////////////////////////////////////////////////
    // MAP LOADING
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Asyncronously load all dependencies required by the map API
     *
     * @method loadMapApi
     */
    AddressRepository.prototype.loadMapApi = function () {
        window.mapRequire(['./map/ReqjsConfig'], function () {
            window.mapRequire(['./map/MapApi', './map/ui/desktop/GeocoderWidget'],
                this.loadMapApiDoneHandler);
        }.bind(this));
    };

    /**
     * Perform any actions that need to occur after map prerequisities have loaded
     *
     * @method loadMapApiDone
     * @param {MapApi} MapApi Reference to the MapApi class
     * @param {GeocoderWidget} GeocoderWidget Reference to the GeocoderWidget class
     */
    AddressRepository.prototype.loadMapApiDone = function (MapApi, GeocoderWidget) {
        var mapApi = new MapApi(window.dtnGlobals.mapApiConfig);
        this.MapEvent = mapApi.Event;

        mapApi.renderGeocoder({
            userInterface: new GeocoderWidget({
                inputId: this.textFieldId,
                select: this.addressUpdateCallback,
                transformInput: this.onTransformInputHandler
            })
        }).done(this.renderMapDoneHandler);
    };

    /**
     * Perform any actions that need to occur after map has completely rendered
     * Also, this is the first available opportunity to get a reference to the eventBus
     *
     * @method renderMapDone
     * @param {Map} map Reference to the map object
     */
    AddressRepository.prototype.renderMapDone = function (geocoder) {
        this.eventBus = geocoder.getEventBus();

        this.geocoderDeferred.resolve();
    };

    /**
     * Fetch the first location for a search term and send it via the given callback.
     *
     * @param searchTerm The address search term
     * Parameters will be: latitude, longitude, address, addressDetails.
     */
    AddressRepository.prototype.getFirstResult = function (searchTerm) {
        var deferred = $.Deferred();

        if (searchTerm == null || searchTerm.length <= 0) {
            this.onGetFirstResultFail(deferred);
        } else {
            // Timeout to trigger error message if address lookup hangs
            var errorTimeout = setTimeout(this.onGetFirstResultFail.bind(this, deferred), LOOKUP_TIMEOUT);

            this.geocoderDeferred
                .done(function () {

                    // Explicit call to kick off geolocation
                    // (not due to user input)
                    this.eventBus.publish(
                        this.MapEvent.geocode,
                        {
                            searchText: searchTerm,
                            callback: this.onGetFirstResultDone.bind(this, deferred, errorTimeout)
                        }
                    );
                }.bind(this));
        }

        return deferred;
    };

    /**
     * Callback that handles the results of a call to Event.geocode
     * directly, instead of using the GeoCoderWidget. 
     * Takes the first result, if there is one, and returns it to addressUpdateCallback.
     * If there are no results, addressUpdateCallback is called with all null parameters.
     *
     * @param results A list of geocoder location objects.
     */
    AddressRepository.prototype.onGetFirstResultDone = function (deferred, errorTimeout, resultArray) {
        var result = null;

        clearTimeout(errorTimeout);

        if (resultArray != null && resultArray.length > 0 && resultArray[0].addressDetails != null) {
            result = resultArray[0];
            deferred.resolve(result);
        }

        deferred.resolve(result);
    };

    AddressRepository.prototype.onGetFirstResultFail = function (deferred) {
        deferred.resolve(null);
    };

    return AddressRepository;
});

/**
 * View model for binding the address type ahead to html elements via knockout.
 */
define('shared-scripts/models/GeocodedLocationViewModel',['require','knockout'],function (require) {
    
    var ko = require('knockout');

    /**
     * Geocoded location view model.
     *
     * @class GeocodedLocationViewModel
     * @constructor
     * @param {float} latitude
     * @param {float} longitude
     * @param {*} address
     * @param {*} addressDetails
     */
    var GeocodedLocationViewModel = function (latitude, longitude, address, addressDetails) {
        var self = this;

        /**
         * Latitude.
         *
         * @property latitude
         * @type {ko.observable}
         */
        self.latitude = ko.observable(latitude);

        /**
         * Longitude.
         *
         * @property longitude
         * @type {ko.observable}
         */
        self.longitude = ko.observable(longitude);

        /**
         * Full address.
         *
         * @property fullAddress
         * @type {ko.observable}
         */
        self.fullAddress = ko.observable(address);

        /**
         * Address details.
         *
         * @property addressDetails
         * @type {ko.observable}
         */
        self.addressDetails = ko.observable(addressDetails);

        /**
         * Country code.
         *
         * @property countryCode
         * @type {ko.computed}
         */
        self.countryCode = ko.computed(function () {
            return self.addressDetails() == null ? null : self.addressDetails().countryCode;
        });

        /**
         * State code.
         *
         * @property stateCode
         * @type {ko.computed}
         */
        self.stateCode = ko.computed(function () {
            return self.addressDetails() == null ? null : self.addressDetails().stateCode;
        });

        /**
         * City.
         *
         * @property city
         * @type {ko.computed}
         */
        self.city = ko.computed(function () {
            return self.addressDetails() == null ? null : self.addressDetails().city;
        });

        /**
         * Address.
         *
         * @property address1
         * @type {ko.computed}
         */
        self.address1 = ko.computed(function () {
            var val = null;
            if (self.addressDetails() != null) {
                if (self.addressDetails().address1 != null) {
                    val = self.addressDetails().address1;
                } else if (self.addressDetails().streetNumber != null && self.addressDetails().route != null) {
                    val = self.addressDetails().streetNumber + ' ' + self.addressDetails().route;
                }
            }
            return val;
        });

        /**
         * Postal code.
         *
         * @property postalCode
         * @type {ko.computed}
         */
        self.postalCode = ko.computed(function () {
            return self.addressDetails() == null ? null : self.addressDetails().postalCode;
        });

        /**
         * Region code.
         *
         * @property regionCode
         * @type {ko.computed}
         */
        self.regionCode = ko.computed(function () {
            return self.countryCode() === 'CA' ? 'CANADAREGION' : 'USREGION';
        });
    };

    return GeocodedLocationViewModel;
});

define('views/generic/LocationView',['exports', 'module', 'jquery', 'shared-scripts/components/BaseComponent', 'shared-scripts/repositories/AddressRepository', 'shared-scripts/models/GeocodedLocationViewModel', 'knockout'], function (exports, module, _jquery, _sharedScriptsComponentsBaseComponent, _sharedScriptsRepositoriesAddressRepository, _sharedScriptsModelsGeocodedLocationViewModel, _knockout) {
    /**
     * @fileOverview LocationView module definition. Handles interaction and address lookup
     *
     * @author jklun
     */
    

    module.exports = LocationView;

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _BaseComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsBaseComponent);

    var _AddressRepository = babelHelpers.interopRequireDefault(_sharedScriptsRepositoriesAddressRepository);

    var _GeocodedLocationViewModel = babelHelpers.interopRequireDefault(_sharedScriptsModelsGeocodedLocationViewModel);

    var _ko = babelHelpers.interopRequireDefault(_knockout);

    var LOOKUP_CLASS = '.js-address-lookup-field';

    function LocationView($element, browserDetect) {
        this.$element = $element;
        this.browserDetect = browserDetect;
        this.onboardingMode = this.$element.data('onboardingMode');

        this.init();

        if (this.onboardingMode) {
            this.populateModelViaGeocode();
        } else {
            this.populateModelViaForm();
        }

        _ko['default'].applyBindings(this.locationModel, this.$element[0]);
    }

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    LocationView.isSafeToCallDestroy = false;
    LocationView.id = 'LocationView';
    LocationView.prototype = new _BaseComponent['default'](LocationView);
    LocationView.prototype.constructor = LocationView;

    LocationView.prototype.onSetupHandlers = function () {
        this.onAddressChangeHandler = this.onAddressChange.bind(this);
        this.onAddressGeocodeDoneHandler = this.onAddressGeocodeDone.bind(this);
        this.onClickNextHandler = this.onClickNext.bind(this);

        return this;
    };

    LocationView.prototype.onCreateChildren = function () {
        this.$loadingMessage = this.$element.find('.js-loadingLocationMessage');
        this.$addressInput = this.$element.find(LOOKUP_CLASS);
        this.$errorPanel = this.$element.find('.js-errors');
        this.$errorPanelClient = this.$element.find('.js-errors-client');
        this.$agreement = this.$element.find('.js-location-view-agreement');
        this.$wizardNext = this.$element.parent().find('.js-wizard-next');

        // Determine input id
        this.inputId = this.$addressInput.attr('id');
        if (this.inputId.indexOf('-', this.inputId.length - 1) !== -1) {
            var $lookups = (0, _$['default'])(LOOKUP_CLASS);
            this.inputId = this.inputId + $lookups.length;
            this.$addressInput.attr('id', this.inputId);
        }

        // Create address repository
        this.addressRepository = new _AddressRepository['default'](this.inputId, this.onAddressGeocodeDoneHandler, this.$element);

        // Create location model, initially empty
        this.locationModel = new _GeocodedLocationViewModel['default']();

        return this;
    };

    LocationView.prototype.onRemoveChildren = function () {
        this.$wizardNext = null;
        this.$addressInput = null;
        this.$errorPanel = null;
        this.addressRepository = null;
        this.locationModel = null;

        return this;
    };

    LocationView.prototype.onEnable = function () {
        // Using jquery to attach event handler causes some weird duplicate firing of events
        // due to some interaction with kendo autocomplete
        this.$addressInput[0].addEventListener('change', this.onAddressChangeHandler, false);

        // Commandeer control of next button for onboarding mode
        if (this.browserDetect.features.touch) {
            this.$wizardNext.off('touchend.WizardList');
            this.$wizardNext.on('touchend.LocationView', this.onClickNextHandler);
        } else {
            this.$wizardNext.off('click.WizardList');
            this.$wizardNext.on('click.LocationView', this.onClickNextHandler);
        }

        (0, _$['default'])(window).trigger('disableNext.WizardList');

        return this;
    };

    LocationView.prototype.onDisable = function () {
        this.$addressInput.off('change.LocationView', this.onAddressChangeHandler);
        if (this.browserDetect.features.touch) {
            this.$wizardNext.off('touchend.LocationView', this.onClickNextHandler);
        } else {
            this.$wizardNext.off('click.LocationView', this.onClickNextHandler);
        }

        return this;
    };

    LocationView.prototype.onDestroy = function () {
        this.$element = null;
        this.addressRepository = null;
        this.$wizardNext = null;
        this.$addressInput = null;

        return this;
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////
    // EVENT HANDLERS
    /////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Callback when a location is geocoded.
     */
    LocationView.prototype.onAddressGeocodeDone = function (results) {
        var latitude = null;
        var longitude = null;
        var address = null;
        var addressDetails = null;

        if (results != null) {
            latitude = results.location == null ? null : results.location.lat;
            longitude = results.location == null ? null : results.location.lng;
            address = results.formattedAddress;
            addressDetails = results.addressDetails;
        }

        // Although autocomplete will already update the form value automatically,
        // we need to update the form value manually whenever this function is called manually
        if (address != null) {
            this.$addressInput.val(address);
        }

        // Assume if lat/long fields are blank, it is an error
        if (latitude == null || longitude == null) {
            this.setEmptyModel();
        } else {
            this.setModel(latitude, longitude, address, addressDetails);
        }
    };

    /**
     * Called when the user manually updates text in the field.
     */
    LocationView.prototype.onAddressChange = function (e) {
        var address = (0, _$['default'])(e.currentTarget).val();

        // Compares text field value to model value
        // If they are different, it means the user had manually typed something
        // This will invalidate the geocoding results and resets the model to empty
        if (address !== this.locationModel.fullAddress()) {
            this.setEmptyModel();
        }
    };

    // For onboarding only
    LocationView.prototype.onClickNext = function (e) {
        e.preventDefault();

        // Don't continue if the button is disabled
        if ((0, _$['default'])(e.currentTarget).hasClass('isDisabled')) {
            return;
        }

        // Address already supplied, so move on to next step
        if (!this.isModelEmpty()) {
            this.goToNextStep();
        } else {
            // Try to geocode to get the address.
            // If successful, move on to next step
            this.populateModelViaGeocode().done(this.goToNextStep.bind(this));
            //on fail, do nothing
        }
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////
    // HELPERS
    /////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Manually kick off a geocode on the current search term
     */
    LocationView.prototype.populateModelViaGeocode = function () {
        /* eslint-disable new-cap */
        var deferred = _$['default'].Deferred();
        /* eslint-enable new-cap */

        var searchTerm = this.$addressInput.val();

        this.addressRepository.getFirstResult(searchTerm).done((function (results) {
            this.onAddressGeocodeDone(results);

            if (!this.isModelEmpty()) {
                deferred.resolve();
            } else {
                deferred.reject();
            }
        }).bind(this));

        return deferred;
    };

    /**
     * To avoid extraneous hits to the Geocoder API,
     * get pre-existing values from the form that have been filled in
     * by the backend and initially populate the model using these values
     * Important to call before ko is bound
     */
    LocationView.prototype.populateModelViaForm = function () {
        var address = this.$addressInput.val();
        var latitude = this.getFormValue('latitude');
        var longitude = this.getFormValue('longitude');
        var addressDetails = {
            address1: this.getFormValue('address1'),
            city: this.getFormValue('city'),
            stateCode: this.getFormValue('stateCode'),
            countryCode: this.getFormValue('countryCode'),
            postalCode: this.getFormValue('postalCode')
        };

        // Make sure knockout model is in-sync with the form values
        this.setModel(latitude, longitude, address, addressDetails, true);
    };

    /**
     * Used in onboarding mode after lookup times out
     */
    LocationView.prototype.isModelEmpty = function () {
        if (this.locationModel.latitude() != null && this.locationModel.longitude() != null) {
            return false;
        } else {
            return true;
        }
    };

    /**
     * Used in onboarding mode after lookup times out
     */
    LocationView.prototype.setEmptyModel = function () {
        this.setModel(null, null, null, null);
    };

    /**
     * Update the location model that is bound to the UI.
     *
     * streetNumber
     * route
     * city
     * stateCode
     * countryCode
     * postalCode
     *
     * @param {Boolean} ignoreError - Skip displaying the error. Used when first loading the form.
     *
     */
    LocationView.prototype.setModel = function (latitude, longitude, address, addressDetails, ignoreError) {
        this.locationModel.latitude(latitude).longitude(longitude).fullAddress(address).addressDetails(addressDetails);

        if (this.isModelEmpty() && !ignoreError) {
            this.showError();
        } else {
            this.hideError();
        }

        // Show agreement if country is in Canada
        this.$agreement.addClass('isHidden');
        if (this.locationModel.countryCode() === 'CA') {
            this.$agreement.removeClass('isHidden');
        }
    };

    // Disables the next button whenever geocoding results are not valid
    LocationView.prototype.showError = function () {
        this.$errorPanelClient.removeClass('isHidden');
        (0, _$['default'])(window).trigger('disableNext.WizardList');

        this.$loadingMessage.addClass('isHidden');
    };

    LocationView.prototype.hideError = function () {
        this.$errorPanelClient.addClass('isHidden');
        (0, _$['default'])(window).trigger('enableNext.WizardList'); // Enables the next button whenever geocoding results are valid

        this.$loadingMessage.addClass('isHidden');
    };

    LocationView.prototype.getFormValue = function (name) {
        var val = this.$element.find('input[data-bind="value: ' + name + '"]').val();
        if (val === '') {
            val = null;
        }
        return val;
    };

    LocationView.prototype.goToNextStep = function () {
        this.$wizardNext.trigger('next.WizardList');
    };
});
define('mout/array/indexOf',[],function () {

    /**
     * Array.indexOf
     */
    function indexOf(arr, item, fromIndex) {
        fromIndex = fromIndex || 0;
        if (arr == null) {
            return -1;
        }

        var len = arr.length,
            i = fromIndex < 0 ? len + fromIndex : fromIndex;
        while (i < len) {
            // we iterate over sparse items since there is no way to make it
            // work properly on IE 7-8. see #64
            if (arr[i] === item) {
                return i;
            }

            i++;
        }

        return -1;
    }

    return indexOf;
});

define('mout/array/remove',['./indexOf'], function(indexOf){

    /**
     * Remove a single item from the array.
     * (it won't remove duplicates, just a single item)
     */
    function remove(arr, item){
        var idx = indexOf(arr, item);
        if (idx !== -1) arr.splice(idx, 1);
    }

    return remove;
});

define('mout/function/prop',[],function () {

    /**
     * Returns a function that gets a property of the passed object
     */
    function prop(name){
        return function(obj){
            return obj[name];
        };
    }

    return prop;

});

define('mout/object/hasOwn',[],function () {

    /**
     * Safer Object.hasOwnProperty
     */
     function hasOwn(obj, prop){
         return Object.prototype.hasOwnProperty.call(obj, prop);
     }

     return hasOwn;

});

define('mout/object/forIn',[],function () {

    var _hasDontEnumBug,
        _dontEnums;

    function checkDontEnum(){
        _dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ];

        _hasDontEnumBug = true;

        for (var key in {'toString': null}) {
            _hasDontEnumBug = false;
        }
    }

    /**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */
    function forIn(obj, fn, thisObj){
        var key, i = 0;
        // no need to check if argument is a real object that way we can use
        // it for arrays, functions, date, etc.

        //post-pone check till needed
        if (_hasDontEnumBug == null) checkDontEnum();

        for (key in obj) {
            if (exec(fn, obj, key, thisObj) === false) {
                break;
            }
        }

        if (_hasDontEnumBug) {
            while (key = _dontEnums[i++]) {
                // since we aren't using hasOwn check we need to make sure the
                // property was overwritten
                if (obj[key] !== Object.prototype[key]) {
                    if (exec(fn, obj, key, thisObj) === false) {
                        break;
                    }
                }
            }
        }
    }

    function exec(fn, obj, key, thisObj){
        return fn.call(thisObj, obj[key], key, obj);
    }

    return forIn;

});

define('mout/object/forOwn',['./hasOwn', './forIn'], function (hasOwn, forIn) {

    /**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */
    function forOwn(obj, fn, thisObj){
        forIn(obj, function(val, key){
            if (hasOwn(obj, key)) {
                return fn.call(thisObj, obj[key], key, obj);
            }
        });
    }

    return forOwn;

});

define('mout/lang/kindOf',[],function () {

    var _rKind = /^\[object (.*)\]$/,
        _toString = Object.prototype.toString,
        UNDEF;

    /**
     * Gets the "kind" of value. (e.g. "String", "Number", etc)
     */
    function kindOf(val) {
        if (val === null) {
            return 'Null';
        } else if (val === UNDEF) {
            return 'Undefined';
        } else {
            return _rKind.exec( _toString.call(val) )[1];
        }
    }
    return kindOf;
});

define('mout/lang/isKind',['./kindOf'], function (kindOf) {
    /**
     * Check if value is from a specific "kind".
     */
    function isKind(val, kind){
        return kindOf(val) === kind;
    }
    return isKind;
});

define('mout/lang/isArray',['./isKind'], function (isKind) {
    /**
     */
    var isArray = Array.isArray || function (val) {
        return isKind(val, 'Array');
    };
    return isArray;
});

define('mout/object/deepMatches',['./forOwn', '../lang/isArray'], function(forOwn, isArray) {

    function containsMatch(array, pattern) {
        var i = -1, length = array.length;
        while (++i < length) {
            if (deepMatches(array[i], pattern)) {
                return true;
            }
        }

        return false;
    }

    function matchArray(target, pattern) {
        var i = -1, patternLength = pattern.length;
        while (++i < patternLength) {
            if (!containsMatch(target, pattern[i])) {
                return false;
            }
        }

        return true;
    }

    function matchObject(target, pattern) {
        var result = true;
        forOwn(pattern, function(val, key) {
            if (!deepMatches(target[key], val)) {
                // Return false to break out of forOwn early
                return (result = false);
            }
        });

        return result;
    }

    /**
     * Recursively check if the objects match.
     */
    function deepMatches(target, pattern){
        if (target && typeof target === 'object') {
            if (isArray(target) && isArray(pattern)) {
                return matchArray(target, pattern);
            } else {
                return matchObject(target, pattern);
            }
        } else {
            return target === pattern;
        }
    }

    return deepMatches;

});

define('mout/function/makeIterator_',['./prop', '../object/deepMatches'], function(prop, deepMatches) {

    /**
     * Converts argument into a valid iterator.
     * Used internally on most array/object/collection methods that receives a
     * callback/iterator providing a shortcut syntax.
     */
    function makeIterator(src, thisObj){
        switch(typeof src) {
            case 'object':
                // typeof null == "object"
                return (src != null)? function(val, key, target){
                    return deepMatches(val, src);
                } : src;
            case 'string':
            case 'number':
                return prop(src);
            case 'function':
                if (typeof thisObj === 'undefined') {
                    return src;
                } else {
                    return function(val, i, arr){
                        return src.call(thisObj, val, i, arr);
                    };
                }
            default:
                return src;
        }
    }

    return makeIterator;

});

define('mout/array/findIndex',['../function/makeIterator_'], function (makeIterator) {

    /**
     * Returns the index of the first item that matches criteria
     */
    function findIndex(arr, iterator, thisObj){
        iterator = makeIterator(iterator, thisObj);
        if (arr == null) {
            return -1;
        }

        var i = -1, len = arr.length;
        while (++i < len) {
            if (iterator(arr[i], i, arr)) {
                return i;
            }
        }

        return -1;
    }

    return findIndex;
});

define('mout/array/find',['./findIndex'], function (findIndex) {

    /**
     * Returns first item that matches criteria
     */
    function find(arr, iterator, thisObj){
        var idx = findIndex(arr, iterator, thisObj);
        return idx >= 0? arr[idx] : void(0);
    }

    return find;

});

define('shared-scripts/controllers/NavigationManager',['require','jquery','mout/array/remove','mout/array/find','shared-scripts/lib/Util'],function (require) {
    
    var $ = require('jquery');
    var arrayRemove = require('mout/array/remove');
    var arrayFind = require('mout/array/find');
    var Util = require('shared-scripts/lib/Util');

    var ELEMENTS_TO_WATCH_FOR_CHANGES_ON = 'input:not(.allowDirty), select:not(.allowDirty), textarea:not(.allowDirty)';
    const EVENTS_TO_CONFIRM_NAVIGATION = 'click.inputChangeCheck tap.inputChangeCheck';

    /**
     * List of monitored objects.
     *
     * @type {Array}
     * @example
     * {
     *     element: $element,
     *     isDirty: false,
     *     dirtyElements: []
     * }
     */
    var monitoring = [];


    /**
     * True if an input has been changed on the currently active panel.
     *
     * @type {boolean}
     */
    var inputChanged = false;

    $(document).ready(function() {
        // Ensure no other event of this type already exists/on
        $('body').off(EVENTS_TO_CONFIRM_NAVIGATION, 'a');
        // Turn on anchor event binding to intercept for navigation confirmation (form changes)
        $('body').on(EVENTS_TO_CONFIRM_NAVIGATION, 'a', function(e) {
            return true;  // This is the 'hammer' approached suggested by SC
            if (e.target.type === "checkbox") {
                return true;
            }
            // SamC: we should bail if we have a link composed of just #.  2019-04-29
            if ( this.getAttribute( "href") === "#") {
                return true;
            }
	    // SamC: this logic should bail out if we are in a 'aui' or
	    // 'Liferay' container, otherwise we interfere with LR
	    // functionality. 2019-04-26
            var $thisElement = $(this);
	    if (($thisElement.parents('.aui').length !== 0) || ($thisElement.parents('#spray-outlook-widget').length != 0)) {
		return true;
	    }
            // All anchor tags ignoring tabs-nav-list-item-link class as these are tabs within the same page/navigation manager and are already managed
            // Lets limit this to those anchors that _don't_ have 'external' or 'nofollow' rel attribute
            var relAttr =  $thisElement.attr('rel');
            if ( relAttr) {
               if (( relAttr.indexOf( 'nofollow') > -1) || ( relAttr.indexOf( 'external') > -1 )) {
                   return true;
               }
            }
            e.preventDefault();
            e.stopImmediatePropagation();


            var hrefPath = $thisElement.attr('href');
            if (typeof confirmNavigation === 'function' && !$thisElement.hasClass("tabs-nav-list-item-link")
                    && hrefPath && hrefPath.indexOf('#') != 0 && hrefPath.indexOf('javascript:') != 0) {

                confirmNavigation()
                    .then(function() {
                         window.location = hrefPath;
                     });
            } else if (hrefPath){
                window.location = hrefPath;
            }

        });


    });

    /**
     * Add an element to be monitored for changes.
     *
     * @method monitor
     * @param {jQuery} $element
     */
    function monitor ($element) {
        monitoring.push({
            element: $element,
            isDirty: false,
            dirtyElements: []
        });
        $element.on('change', ELEMENTS_TO_WATCH_FOR_CHANGES_ON, onChangeSetDirty);
    }

    /**
     * Stop monitoring an element for changes.
     *
     * @method forget
     * @param {jQuery} $element
     */
    function forget ($element) {
        monitoring.forEach(function (item, index, array) {
            if (item.element.is($element)) {
                arrayRemove(array, item);
                $element.off('change', ELEMENTS_TO_WATCH_FOR_CHANGES_ON, setDirty);
            }
        });
    }

    /**
     * Clear the dirty flags for all monitored items that descend from an element
     *
     * @method reset
     * @param {jQuery} $parent
     */
    function reset ($parent) {
        monitoring.forEach(function (item, index, array) {
            if ($parent.has(item.element)) {
                item.dirtyElements = [];
                item.isDirty = false;
            }
        });
    }

    /**
     * Don't allow navigation if a monitored element has changes associated with it.
     *
     * @method canNavigate
     * @return {boolean}
     */
    function canNavigate () {
        // mout's array find will return the item(s) that matched the condition.
        return arrayFind(monitoring, 'isDirty') === undefined;
    }

    /**
     * Triggers a 'confirm navigation' modal.
     *
     * @method confirmNavigation
     * @return {$.Promise}
     */
    function confirmNavigation () {

        var d = $.Deferred();

        if (canNavigate()) {
            d.resolve(inputChanged);  // Resolve with false if nothing in the monitored element changed.
        } else {
            Util.broadcast('open.ModalComponent', '#navigation-manager-confirmation');

            $('.navigation-manager-yes').one('click.NavigationManger', function () {
                $('.navigation-manager-no').off('click.NavigationManger');
                Util.broadcast('close.ModalComponent');
                d.resolve(true);  // Resolve with true if the monitored element should be refreshed.
            });

            $('.navigation-manager-no').one('click.NavigationManager', function () {
                $('.navigation-manager-yes').off('click.NavigationManger');
                Util.broadcast('close.ModalComponent');
                d.reject();  // Reject the promise if user opts to stay and save changes.
            });
        }

        inputChanged = false;
        return d.promise();
    }

    /**
     * Trigger a css animation on all fields that are 'dirty' (have changes associated with them).
     *
     * @method showDirtyFields
     */
    function showDirtyFields () {
        monitoring.forEach(function (item) {
            item.dirtyElements.forEach(function ($element) {
                $element.parent().css('display', 'block').css('border', 'transparent').addClass('shake');
                window.setTimeout(function () {
                    $element.parent().css('display', '').css('border', '').removeClass('shake');
                }, 1000);
            });
        });
    }

    /**
     * Set an element to dirty state.
     *
     * @method onChangeSetDirty
     * @param {Event} e
     */
    function onChangeSetDirty (e) {
        var $delegateTarget = $(e.delegateTarget);
        var $currentTarget = $(e.currentTarget);

        // This is our opt out at the form level, for portlets/widgets
        // that we don't want dirty checks on wholesale (e.g. Spray Outlook Threshold Settings)
        if ($currentTarget.parents('.js-allowDirty').length !== 0) {
            return;
        }

        inputChanged = true;
        setDirty($delegateTarget, $currentTarget);
    }

    /**
     * Set dirty
     *
     * @method setDirty
     * @param {jQuery} $element
     * @param {jQuery} $dirty
     */
    function setDirty($element, $dirty) {
        monitoring.forEach(function (item, index, array) {
            if (item.element.is($element)) {
                item.isDirty = true;
                if ($dirty) {
                    item.dirtyElements.push($dirty);
                } else {
                    item.dirtyElements.push($element);
                }
            }
        });
    }

    return {
        monitor: monitor,
        forget: forget,
        confirmNavigation: confirmNavigation,
        canNavigate: canNavigate,
        resetDirty: reset,
        setDirty: setDirty,
        showDirtyFields: showDirtyFields
    };
});


define('models/PrioritizeCropModel',['require','knockout'],function (require) {
    

    var ko = require('knockout');

    /**
     * Prioritize crop model.
     *
     * @class PrioritizeCropModel
     * @constructor
     * @param {string} value
     * @param {string} displayName
     * @param {string} symbolicName
     * @param {boolean} checked
     */
    function PrioritizeCropModel (value, displayName, symbolicName, checked) {
        this.value = value;
        this.displayName = displayName;
        this.symbolicName = symbolicName;
        this.checked = ko.observable(checked);
    }

    return PrioritizeCropModel;
});

/**
 * @fileOverview PrioritizeCropsModel module definition
 *
 * @author [add author name here]
 */
define('models/PrioritizeCropViewModel',['require','knockout','models/PrioritizeCropModel'],function (require) {
    

    var ko = require('knockout');
    var PrioritizeCropModel = require('models/PrioritizeCropModel');

    function PrioritizeCropViewModel (initJSON) {
        var self = this;

        // List of all crops, to be bound to checkboxlist
        this.crops = ko.observableArray(ko.utils.arrayMap(initJSON, function (crop) {
            return new PrioritizeCropModel(
                crop.value,
                crop.displayName,
                crop.symbolicName,
                crop.checked
            );
        }));

        // Underlying array for sorted crops
        // To set this up, we take an array like [{sortOrder: 1}, {sortOrder: 2}, {sortOrder:0}]
        // and transform into an array of element indices like [2, 0, 1]
        this.sortedIndices = ko.observableArray(
            this._filterChecked(initJSON).sort(this._sort.bind(this, initJSON))
        );

        // Sorted crops, to be bound to sortable list with up/down controls
        this.sortedCrops = ko.computed(function () {
            return ko.utils.arrayMap(self.sortedIndices(), function (index) {
                return self.crops()[index];
            });
        });
    }

    PrioritizeCropViewModel.prototype._filterChecked = function (initJSON) {
        var indices = [];

        for (var i = 0; i < initJSON.length; i++) {
            if (initJSON[i].checked) {
                indices.push(i);
            }
        }

        return indices;
    };

    PrioritizeCropViewModel.prototype._sort = function (initJSON, index1, index2) {
        var sortOrder1 = initJSON[index1].sortOrder;
        var sortOrder2 = initJSON[index2].sortOrder;

        if (sortOrder1 === sortOrder2) {
            return 0;
        } else if (sortOrder1 < sortOrder2) {
            return -1;
        } else {
            return 1;
        }
    };

    PrioritizeCropViewModel.prototype.onCheck = function (index, crop) {
        var willBeChecked = !crop.checked();

        if (willBeChecked) {
            this.sortedIndices.push(index);
        } else {
            this.sortedIndices.remove(index);
        }

        // Allows antive browser check action to continue
        return true;
    };

    PrioritizeCropViewModel.prototype.onSortUp = function (index) {
        this._swap(this.sortedIndices, index, index - 1);
    };

    PrioritizeCropViewModel.prototype.onSortDown = function (index) {
        this._swap(this.sortedIndices, index, index + 1);
    };

    PrioritizeCropViewModel.prototype._swap = function (observableArray, from, to) {
        if (to >= 0 && to < observableArray().length) {
            observableArray.splice(to, 0, observableArray.splice(from, 1)[0]);
        }
    };

    return PrioritizeCropViewModel;
});

define('views/onboarding/PrioritizeCropsView',['require','shared-scripts/lib/Util','shared-scripts/controllers/NavigationManager','shared-scripts/components/BaseComponent','models/PrioritizeCropViewModel'],function (require) {
    

    var Util = require('shared-scripts/lib/Util');
    var NavigationManager = require('shared-scripts/controllers/NavigationManager');
    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var PrioritizeCropViewModel = require('models/PrioritizeCropViewModel');

    var KO_PRIORITIZE_CROPS_ID = 'ko-PrioritizeCropsView';

    /**
     * THe prioritize crops view component.
     *
     * @param $element
     * @param browserDetect
     * @extends BaseComponent
     * @constructor
     */
    var PrioritizeCropsView = function ($element, browserDetect) {
        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = $element;

        /**
         * Feature detection object.
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        this.init();
    };

    // call parent constructor
    PrioritizeCropsView.id = 'PrioritizeCropsView';
    PrioritizeCropsView.prototype = new BaseComponent(PrioritizeCropsView);
    PrioritizeCropsView.prototype.constructor = PrioritizeCropsView;

    PrioritizeCropsView.prototype.onSetupHandlers = function () {
        this.onCropsListUpdatedHandler = this.onCropsListUpdated.bind(this);
        this.onWillExitSlideHander = this.onWillExitSlide.bind(this);

        return this;
    };

    PrioritizeCropsView.prototype.onCreateChildren = function () {

        /**
         * The div used to apply the knockout bindings to.
         *
         * @property knockoutContent
         * @type {jQuery}
         */
        this.$knockoutContent = this.$element.find('.js-knockout');


        /**
         * The prioritize crops form/
         *
         * @property $form
         * @type {jQuery}
         */
        this.$form = this.$element.closest('#prioritizeCrops');


        /**
         * The items that can be added to the sortable list.
         *
         * @property $checkboxList
         * @type {jQuery}
         */
        this.$checkboxList = this.$element.find('.js-prioritizeCrops-checkboxList');

        /**
         * The checkboxes containing the items that can be added to the sortable list.
         *
         * @property $checkboxes
         * @type {jQuery}
         */
        this.$checkboxes = this.$element.find('.js-prioritizeCrops-checkbox');

        /**
         * The sortable list
         *
         * @property $sortedList
         * @type {jQuery}
         */
        this.$sortedList = this.$element.find('.js-prioritizeCrops-sortedList');

        /**
         * A boolean to track if this is the first time an update has been made.
         * Used to determine if the view should be marked as dirty.
         *
         * @property firstUpdate
         * @type {boolean}
         */
        this.firstUpdate = true;

        /**
         * The view model to be used within the component
         *
         * @property viewModel
         * @type {PrioritizeCropViewModel}
         */
        this.viewModel = new PrioritizeCropViewModel(this.buildCollection());

        return this;
    };

    PrioritizeCropsView.prototype.onRemoveChildren = function () {
        this.$checkboxes = null;
        this.$form = null;
        this.$knockoutContent = null;
        this.firstUpdate = null;
        this.viewModel = null;

        return this;
    };

    PrioritizeCropsView.prototype.onEnable = function () {
        this.$element.on('cropsListUpdated', this.onCropsListUpdatedHandler);
        Util.subscribe('willExitSlide.WizardList', this.onWillExitSlideHander);
        Util.applyBindings(KO_PRIORITIZE_CROPS_ID, this.viewModel, this.$knockoutContent);

        // Interactive content is hidden until completely loaded
        this.$checkboxList.removeClass('isHidden');
        this.$sortedList.removeClass('isHidden');

        return this;
    };

    PrioritizeCropsView.prototype.onDisable = function () {
        this.$element.off('cropsListUpdated', this.onCropsListUpdatedHandler);
        Util.unsubscribe('willExitSlide.WizardList', this.onWillExitSlideHander);
        Util.removeBindings(KO_PRIORITIZE_CROPS_ID, this.$knockoutContent);

        this.$checkboxList.addClass('isHidden');
        this.$sortedList.addClass('isHidden');

        return this;
    };

    PrioritizeCropsView.prototype.onDestroy = function () {
        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Event handler for when the step is exited from the {WizardListView}
     *
     * @private
     * @method onWillExitSlide
     */
    PrioritizeCropsView.prototype.onWillExitSlide = function () {
        this.onDisable();
    };

    /**
     * Event handler for when the view model is initialized.
     *
     * @private
     * @method onCropsListUpdated
     */
    PrioritizeCropsView.prototype.onCropsListUpdated = function () {
        if (!this.firstUpdate) {
            NavigationManager.setDirty(
                this.$element.closest('.tabs2-panels-list-panel'),
                this.$sortableList
            );
        } else {
            this.firstUpdate = false;
        }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Helper methods
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Method to build the data needed for the Knockout Model and apply the bindings.
     *
     * @private
     * @method buildCollection
     * @returns {Array}
     */
    PrioritizeCropsView.prototype.buildCollection = function () {
        var cropModelCollection = [];

        var rankedItems;
        if (window.rankedItems) {
            rankedItems = window.rankedItems.rankedItems;
        }

        this.$checkboxes.each(function (index, node) {
            var value = node.value;
            var displayName = node.getAttribute('data-display-name');
            var symbolicName = node.getAttribute('data-json-key');
            var sortOrder = -1;
            var checked = false;

            if (rankedItems) {
                if (Object.keys(rankedItems).length > 0) {
                    checked = symbolicName in rankedItems;
                }

                if (checked) {
                    sortOrder = rankedItems[symbolicName];
                }

                cropModelCollection.push({
                    value : value,
                    displayName : displayName,
                    symbolicName : symbolicName,
                    sortOrder : sortOrder,
                    checked : checked
                });
            }
        });

        return cropModelCollection;
    };

    return PrioritizeCropsView;
});

define('components/MapLayerPickerComponent',['exports', 'module', 'jquery', 'shared-scripts/components/BaseComponent', 'shared-scripts/services/metricsService', 'lib/Util'], function (exports, module, _jquery, _sharedScriptsComponentsBaseComponent, _sharedScriptsServicesMetricsService, _libUtil) {
    

    module.exports = MapLayerPickerComponent;

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _BaseComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsBaseComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    function MapLayerPickerComponent($element, browserDetect, eventBus, MapEvent) {
        /**
         * The container element for this component
         *
         * @property {jQuery} $element
         */
        this.$element = $element;

        /**
         * Feature-detection object
         *
         * @property {BrowserDetect} browserDetect
         */
        this.browserDetect = browserDetect;

        this.isMobile = false;
        this.eventBus = eventBus;
        this.MapEvent = MapEvent;
        this.numTabsPerPage = 7;
        this.stripPageIndex = 0;

        this.init();
    }

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    MapLayerPickerComponent.isSafeToCallDestroy = false;
    MapLayerPickerComponent.id = 'MapLayerPickerComponent';
    MapLayerPickerComponent.prototype = new _BaseComponent['default'](MapLayerPickerComponent);
    MapLayerPickerComponent.prototype.constructor = MapLayerPickerComponent;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Binds the scope of any handler functions
     * Should only be run on initialization of the view
     *
     * @method onSetupHandlers
     * @returns {MapLayerPickerComponent}
     */
    MapLayerPickerComponent.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here
        this.onNavNextClickHandler = this.onNavNextClick.bind(this);
        this.onNavPrevClickHandler = this.onNavPrevClick.bind(this);
        this.onTabClickHandler = this.onTabClick.bind(this);
        this.onSelectChangeHandler = this.onSelectChange.bind(this);

        return this;
    };

    /**
     * Create any child objects or references to DOM elements
     * Should only be run on initialization of the view
     *
     * @method onCreateChildren
     * @returns {MapLayerPickerComponent}
     */
    MapLayerPickerComponent.prototype.onCreateChildren = function () {
        // Create any other dependencies here
        this.$layerPickerTabsWrapper = this.$element.find('.layerPickerTabsWrapper');
        this.$layerPickerTabs = this.$element.find('.layerPickerTab');
        this.$layerPickerNav = this.$element.find('.layerPickerNav');
        this.$layerPickerNavNext = this.$element.find('.layerPickerNavNext');
        this.$layerPickerNavPrev = this.$element.find('.layerPickerNavPrev');
        this.$layerPickerSelect = this.$element.find('.layerPickerDropdown select');

        this._removeLayerFromMap('*');
        this._addLayerToMap('COMPOSITE_RADAR'); // default layer to show

        return this;
    };

    /**
     * Removes any child objects or references to DOM elements
     *
     * @method onRemoveChildren
     * @returns {MapLayerPickerComponent}
     */
    MapLayerPickerComponent.prototype.onRemoveChildren = function () {
        // Remove any other dependencies here
        this.$layerPickerTabsWrapper = null;
        this.$layerPickerTabs = null;
        this.$layerPickerNav = null;
        this.$layerPickerNavNext = null;
        this.$layerPickerNavPrev = null;
        this.$layerPickerSelect = null;

        return this;
    };

    /**
     * Performs measurements and applies any positioning style logic
     * Trigger manually if the parent layout changes
     * onDesktopEnter/onMobileEnter is normally called before this
     *
     * @method onLayout
     * @returns {MapLayerPickerComponent}
     */
    MapLayerPickerComponent.prototype.onLayout = function () {
        this.isMobile = window.innerWidth < window.dtnGlobals.maxMobileWidth;

        if (this.isMobile) {
            this.$element.show();
            this.$element.animate({
                height: 60
            });
        } else {
            // Ratio of tab width to height is 8:5
            // tabWidth=(8/5)*tabHeight
            // tabHeight=(5/8)*tabWidth
            // (tabWidth+tabLeftMargin)*7tabs+(5/8)*tabWidth+tabLeftMargin=stripWidth
            // The math checks out.. trust me :)
            var stripWidth = this.$element.width();
            var tabLeftMargin = 10;
            var tabWidth = Math.floor((stripWidth - tabLeftMargin * this.numTabsPerPage + 1) * (8 / 61));
            var tabHeight = Math.floor(5 / 8 * tabWidth);

            this.$layerPickerTabs.width(tabWidth).height(tabHeight);
            this.$layerPickerNav.width(tabHeight).height(tabHeight);

            this._showTabsForStripPage();

            this.$element.show();
            this.$element.animate({
                height: tabHeight + 20
            });
        }

        return this;
    };

    /**
     * Enables the component
     * Performs any event binding to handlers
     * Does not execute if component is already enabled
     *
     * @method onEnable
     * @returns {MapLayerPickerComponent}
     */
    MapLayerPickerComponent.prototype.onEnable = function () {
        // Setup any event handlers

        if (this.browserDetect.features.touch) {
            this.$element.on('touchend.MapLayerPickerComponent', this.onClickHandler);
        } else {
            this.$element.on('click.MapLayerPickerComponent', this.onClickHandler);
        }

        this.$layerPickerNavNext.on('click.layerPickerNavNext', this.onNavNextClickHandler);
        this.$layerPickerNavPrev.on('click.layerPickerNavPrev', this.onNavPrevClickHandler);
        this.$layerPickerTabs.on('click.layerPickerTabs', this.onTabClickHandler);
        this.$layerPickerSelect.on('change.layerPickerSelect', this.onSelectChangeHandler);

        return this;
    };

    /**
     * Disables the component
     * Tears down any event binding to handlers
     * Does not execute if component is already disabled
     *
     * @method onDisable
     * @returns {MapLayerPickerComponent}
     */
    MapLayerPickerComponent.prototype.onDisable = function () {
        // Tear down any event handlers
        if (this.$element != null) {
            this.$element.off('touchend.MapLayerPickerComponent', this.onClickHandler);
            this.$element.off('click.MapLayerPickerComponent', this.onClickHandler);
        }

        return this;
    };

    /**
     * Destroys the component
     * Assume that onDisable() and onRemoveChildren() are called prior to this
     * Should be called when the object should be left unused
     *
     * @method onDestroy
     * @returns {MapLayerPickerComponent}
     */
    MapLayerPickerComponent.prototype.onDestroy = function () {
        // Clear any timeouts, etc.

        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * onDesktopExit Handler
     * Re-arrange layout appropriately upon exit from Desktop breakpoint
     *
     * @method onDesktopExit
     */
    MapLayerPickerComponent.prototype.onDesktopExit = function () {
        this.onLayout();
    };

    /**
     * onMobileExit Handler
     * Re-arrange layout appropriately upon exit from Mobile breakpoint
     *
     * @method onMobileExit
     */
    MapLayerPickerComponent.prototype.onMobileExit = function () {
        this.onLayout();
    };

    MapLayerPickerComponent.prototype.onNavNextClick = function () {
        this.stripPageIndex += 1;
        this._showTabsForStripPage(true);
    };

    MapLayerPickerComponent.prototype.onNavPrevClick = function () {
        this.stripPageIndex -= 1;
        this._showTabsForStripPage(true);
    };

    MapLayerPickerComponent.prototype.onTabClick = function (e) {
        var $targetTab = (0, _$['default'])(e.delegateTarget);
        if ($targetTab.hasClass('isActiveLayer')) {
            return; // already being shown!
        }

        var layerSymbolics = $targetTab.attr('data-layer-symbolic').split(',');

        this._removeLayerFromMap('*');
        _$['default'].each(layerSymbolics, (function (i, layerSymbolic) {
            this._addLayerToMap(layerSymbolic);
        }).bind(this));

        this.$layerPickerTabs.filter('.isActiveLayer').removeClass('isActiveLayer');
        $targetTab.addClass('isActiveLayer');

        this.$mapLayerName = $targetTab.attr('data-config-map-layer-name');

        _metricsService['default'].mapLayerClick(this.$mapLayerName);

        // sync the mobile select with the tab that was selected
        this.$layerPickerSelect.children(':selected').prop('selected', '');
        this.$layerPickerSelect.children('[value=' + layerSymbolics[0] + ']').prop('selected', true);
    };

    MapLayerPickerComponent.prototype.onSelectChange = function (e) {
        var $selectedOption = (0, _$['default'])(e.delegateTarget).children(':selected');
        var layerSymbolic = $selectedOption.attr('value');

        // desktop tabs are the authority, click the proper tab to load the layer
        var $targetTab = this.$element.find('[data-layer-symbolic=' + layerSymbolic + ']');
        $targetTab.click();
        // and update the strip page index based on the tab index, for if we go back to desktop view
        this.stripPageIndex = Math.floor($targetTab.index() / this.numTabsPerPage);
        this._showTabsForStripPage(false);
        // for convenience, scroll user back up to the top of the map
        _Util['default'].scrollYToElement(this.$element.parent());
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Private API
    //////////////////////////////////////////////////////////////////////////////////////////////////

    MapLayerPickerComponent.prototype._showTabsForStripPage = function (animate) {
        var targetMarginLeft = 0;
        if (this.stripPageIndex !== 0) {
            var targetNavPrev = this.$layerPickerNavPrev.eq(this.stripPageIndex - 1);
            targetMarginLeft = Math.floor(targetNavPrev.position().left);
        }
        this.$layerPickerTabsWrapper.animate({
            'margin-left': -targetMarginLeft + 'px'
        }, animate ? 400 : 0);
    };

    /**
     * Add layer to map via its event bus
     *
     * @method _addLayerToMap
     * @param {String} layerSymbolic symbolic name of the layer to add
     */
    MapLayerPickerComponent.prototype._addLayerToMap = function (layerSymbolic) {
        this.eventBus.publish(this.MapEvent.addLayer, {
            layerSymbolic: layerSymbolic
        });
    };

    /**
     * Remove layer from map via its event bus
     *
     * @method _removeLayerFromMap
     * @param {String} layerSymbolic symbolic name of the layer to remove
     */
    MapLayerPickerComponent.prototype._removeLayerFromMap = function (layerSymbolic) {
        this.eventBus.publish(this.MapEvent.removeLayer, {
            layerSymbolic: layerSymbolic
        });
    };
});
define('mout/lang/toString',[],function () {

    /**
     * Typecast a value to a String, using an empty string value for null or
     * undefined.
     */
    function toString(val){
        return val == null ? '' : val.toString();
    }

    return toString;

});

define('mout/string/contains',['../lang/toString'], function(toString) {

    /**
     * Searches for a given substring
     */
    function contains(str, substring, fromIndex){
        str = toString(str);
        substring = toString(substring);
        return str.indexOf(substring, fromIndex) !== -1;
    }

    return contains;

});

define('shared-scripts/lib/GeoUtils',['require','jquery','mout/string/contains'],function (require) {
    

    var $ = require('jquery');
    var stringContains = require('mout/string/contains');

    function getPrefix (p) {
        var _pref = '';

        if (p === 'S' || p === 'N') {
            if (p === 'S') {
                _pref = '-';
            }
        } else if (p === 'E' || p === 'W') {
            if (p === 'W') {
                _pref = '-';
            }
        }

        return _pref;
    }

    function hasValidDirectional (p) {
        return p.match(/(N|S|E|W)/);
    }

    function degreeToDMS (degree) {
        var d  = parseInt(degree, 10);
        var md = Math.abs((degree - d) * 60);
        var m  = parseInt(md, 10);
        var sd = Math.round((md - m) * 60);

        return [d + '˚', m + '"', sd + '\''].join(' ');
    }

    function stringToDegree (string) {
        var degrees = null;

        // If the string has a space, it is either GPS or DMS.
        if (stringContains(string, ' ')) {
            // If the string contains a decimal, it's in GPS format
            if (stringContains(string, '.')) {
                degrees = gpsToDegree(string);
            }
            // Otherwise, in DMS format
            else {
                degrees = dmsToDegree(string);
            }
        }

        // No spaces, just try to parse it as a float
        if (degrees == null) {
            degrees = parseFloat(string);
        }

        return degrees;
    }

    function dmsToDegree (dms) {
        dms = dms.split(' ');

        var d = dms[0];
        var p = d.substr(0, 1);

        if (!hasValidDirectional(p)) {
            throw 'Not a valid input';
        }

        d = parseInt(d.substr(1), 10);
        var m = (parseInt(dms[1], 10) / 60);
        var s = (parseInt(dms[2], 10) / 3600);

        return parseFloat(getPrefix(p) + (d + m + s)).toFixed(5);
    }


    function gpsToDegree (gps) {
        gps = gps.split(' ');

        var d = gps[0];
        var p = d.substr(0, 1);

        if (!hasValidDirectional(p)) {
            throw 'Not a valid input';
        }

        d = parseInt(d.substr(1), 10);
        var m = (parseFloat(gps[1]) / 60);

        return parseFloat(getPrefix(p) + (d + m)).toFixed(5);
    }

    /**
     * Get user's current location as provided by their browser.
     *
     * @param timeout Milliseconds to wait before timing out geolocation request. Value must be a number greater than 0.
     * @return {$.Promise}
     */
    function getCurrentLocation (timeout) {
        var d = $.Deferred();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function (geoPosition) {
                    d.resolve([geoPosition.coords.latitude, geoPosition.coords.longitude]);
                },
                function (geoPositionError) {
                    d.reject(geoPositionError);
                }
            );

            /*
             Some browsers (*cough* Firefox, IE) don't handle user geolocation rejection properly.
             To prevent hanging up the deferred, we use a timeout to reject the deferred if
             it hasn't already completed after the specified timeout in ms.
             ----
             For more info checkout this Firefox bug that's been open for (ONLY!) 4 years:
             https://bugzilla.mozilla.org/show_bug.cgi?id=675533
             */
            if (typeof timeout === 'number' && timeout > 0) {
                setTimeout(function () {
                    if (d.state() === 'pending') {
                        d.reject('Timed out after [' + timeout + ' ms] waiting for geolocation to complete.');
                    }
                }, timeout);
            }
        } else {
            d.reject("Browser does not support geolocation.");
        }

        return d.promise();
    }

    return {
        degreeToDMS: degreeToDMS,
        stringToDegree: stringToDegree,
        dmsToDegree: dmsToDegree,
        gpsToDegree: gpsToDegree,
        getCurrentLocation: getCurrentLocation
    };
});

/* eslint object-shorthand: 0 */
/**
 * @fileOverview Module handling interactive map tabbed view interaction and functionality.
 *
 * @author Jeff Lindblom <jeff.lindblom@dtn.com>
 */
define('views/weather/WeatherInteractiveMapPaneView',['require','jquery','shared-scripts/components/BaseComponent','components/MapLayerPickerComponent','shared-scripts/lib/GeoUtils','shared-scripts/lib/Util'],function (require) {
    

    var $ = require('jquery');
    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var MapLayerPickerComponent = require('components/MapLayerPickerComponent');
    var GeoUtils = require('shared-scripts/lib/GeoUtils');
    var Util = require('shared-scripts/lib/Util');

    /**
     * Component providing tabbed view for the Interactive Map
     *
     * @class WeatherInteractiveMapPaneView
     * @extends BaseComponent
     * @constructor
     */
    function WeatherInteractiveMapPaneView ($element, browserDetect) {
        /**
         * The container element for this component
         *
         * @property {jQuery} $element
         */
        this.$element = $element;

        /**
         * Feature-detection object
         *
         * @property {BrowserDetect} browserDetect
         */
        this.browserDetect = browserDetect;

        /**
         * Default width for the animation slider control within the map
         *
         * @property {Number} defaultAnimSliderWidth
         */
        this.defaultAnimSliderWidth = 252;

        /**
         * Wrapper element for the map div
         *
         * @property {jQuery} $interactiveMapWrapper
         */
        this.$interactiveMapWrapper = null;

        /**
         * Primary display element for the map div
         *
         * @type {jQuery} $interactiveMapDiv
         */
        this.$interactiveMapDiv = null;

        /**
         * Integer keeping track of the currently active layer components
         * Useful for dimension modifications
         *
         * @property {Number} activeLayerComponents
         */
        this.activeLayerComponents = 0;

        /**
         * Provided by the map, primary means of communicating events and settings to the map
         *
         * @property {EventBus} eventBus
         */
        this.eventBus = null;

        /**
         * General map event provided to view via the map
         * Used for communicating to the map what events to trigger or subscribe to
         *
         * @property {Event} MapEvent
         */
        this.MapEvent = null;

        /**
         * UI specific event provided to view via the map
         * Used to communicate to the map what UI events to trigger or subscribe to
         *
         * @property {UIEvent} UIEvent
         */
        this.UIEvent = null;

        /**
         * Series of options specific to map initialization and configuration
         *
         * @property {Object} mapOptions
         */
        this.mapOptions = null;

        /**
         * Flag indicating whether or not component is operating in 'mobile
         * mode'
         *
         * @property {Boolean} mobileMode
         */
        this.mobileMode = false;

        /**
         * Flag indicating whether or not component is operating in 'active
         * layer components stack mode', a map setting where the controls for
         * options and legends are stacked on top of eachother.
         *
         * @property {Boolean} activeLayerComponentsStacked
         */
        this.activeLayerComponentsStacked = false;

        /**
         * Component governing map layer selection.
         *
         * @property {MapLayerPickerComponent} mapLayerPickerComponent
         */
        this.mapLayerPickerComponent = null;

        /**
         * Flag indicating whether or not the current layer is disabled
         *
         * @property {Boolean} isLayerDisabled
         */
        this.isLayerDisabled = false;

        // Assumed to be fully defined within the JSP
        if (window.MAP_OPTIONS != null) {
            this.mapOptions = window.MAP_OPTIONS;
        }

        this.init();
    }

    WeatherInteractiveMapPaneView.isSafeToCallDestroy = false;
    WeatherInteractiveMapPaneView.id = 'WeatherInteractiveMapPaneView';
    WeatherInteractiveMapPaneView.prototype = new BaseComponent(WeatherInteractiveMapPaneView);
    WeatherInteractiveMapPaneView.prototype.constructor = WeatherInteractiveMapPaneView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Super methods
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Binds the scope of any handler functions
     * Should only be run on initialization of the view
     *
     * @chainable
     * @method onSetupHandlers
     */
    WeatherInteractiveMapPaneView.prototype.onSetupHandlers = function () {
        this.onMapUILoadedHandler = this.onMapUILoaded.bind(this);
        this.onShowSpinnerHandler = this.onShowSpinner.bind(this);
        this.onHideSpinnerHandler = this.onHideSpinner.bind(this);
        this.onMapLayerLoadingHandler = this.onMapLayerLoading.bind(this);
        this.onMapLayerLoadedHandler = this.onMapLayerLoaded.bind(this);
        this.onMapLayerAddedHandler = this.onMapLayerAdded.bind(this);
        this.onWindowResizeHandler = this.onWindowResize.bind(this);
        this.onMapLayerDisabledHandler = this.onMapLayerDisabled.bind(this);
        this.onMapLayerEnabledHandler = this.onMapLayerEnabled.bind(this);

        return this;
    };

    /**
     * Create any child objects or references to DOM elements
     * Should only be run on initialization of the view
     *
     * @chainable
     * @method onCreateChildren
     */
    WeatherInteractiveMapPaneView.prototype.onCreateChildren = function () {
        this.$interactiveMapWrapper = this.$element.find('.js-interact-map-wrapper');
        this.$interactiveMapDiv = this.$element.find('#map_div');
        this.$mapLayerPickerElmt = this.$element.find('.js-mapLayerPicker');

        return this;
    };

    /**
     * Removes any child objects or references to DOM elements
     *
     * @chainable
     * @method onRemoveChildren
     */
    WeatherInteractiveMapPaneView.prototype.onRemoveChildren = function () {
        this.$interactiveMapWrapper = null;
        this.mobileMode = false;

        return this;
    };

    /**
     * Performs measurements and applies any positioning style logic
     * Trigger manually if the parent layout changes
     * onDesktopEnter/onMobileEnter is normally called before this
     *
     * @chainable
     * @method onLayout
     */
    WeatherInteractiveMapPaneView.prototype.onLayout = function () {
        this.mobileMode = window.innerWidth < window.dtnGlobals.maxMobileWidth;

        this._resizeView();

        return this;
    };

    /**
     * Enables the component
     * Performs any event binding to handlers
     * Does not execute if component is already enabled
     *
     * @chainable
     * @method onEnable
     */
    WeatherInteractiveMapPaneView.prototype.onEnable = function () {
        var self = this;

        Util.sendAction('didStartLoading', this.$element);

        // If user's loginName is blank, assume they are anonymous
        if (this.mapOptions.user.loginName === '') {
            // Default the center lat/long to Omaha
            self.mapOptions.mapPrefs.centerLatitude = 41.264268;
            self.mapOptions.mapPrefs.centerLongitude = -96.053557;

            // If browser is not Chrome, we cannot guarantee that geolocation
            // will handle user events properly, so we need a timeout. :(
            // Note: 0 indicated no timeout.
            var timeout = this.browserDetect.browser.chrome ? 0 : 10000;

            // Get the user's current location
            // If this call doesn't complete in 1 second, timeout
            GeoUtils.getCurrentLocation(timeout)
                .done(function (latLng) {
                    // If we successfully retrieved the user's location, use the given lat/long
                    self.mapOptions.mapPrefs.centerLatitude = latLng[0];
                    self.mapOptions.mapPrefs.centerLongitude = latLng[1];
                })
                .always(this._initMapAPI.bind(this));
        } else {
            this._initMapAPI();
        }

        return this;
    };

    /**
     * Disables the component
     * Tears down any event binding to handlers
     * Does not execute if component is already disabled
     *
     * @chainable
     * @method onDisable
     */
    WeatherInteractiveMapPaneView.prototype.onDisable = function () {
        $(window).off('resize', this.onWindowResizeHandler);

        return this;
    };

    /**
     * Destroys the component
     * Assume that onDisable() and onRemoveChildren() are called prior to this
     * Should be called when the object should be left unused
     *
     * @chainable
     * @method onDestroy
     */
    WeatherInteractiveMapPaneView.prototype.onDestroy = function () {
        this.$element = null;

        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * onMapUILoaded Handler
     * Initialization logic dependent upon the Map and UI being loaded
     *
     * @method onMapUILoaded
     * @param {Event} event JS Event object
     */
    WeatherInteractiveMapPaneView.prototype.onMapUILoaded = function () {
        // register interaction events
        $(window).on('resize', this.onWindowResizeHandler);

        // handle layer loading events
        this.eventBus.subscribe(this.MapEvent.dragStart, this.onHideSpinnerHandler);
        this.eventBus.subscribe(this.MapEvent.dragEnd, this.onShowSpinnerHandler);
        this.eventBus.subscribe(this.MapEvent.setView, this.onShowSpinnerHandler);
        this.eventBus.subscribe(this.MapEvent.layerLoading, this.onMapLayerLoadingHandler);
        this.eventBus.subscribe(this.MapEvent.layerLoaded, this.onMapLayerLoadedHandler);
        this.eventBus.subscribe(this.MapEvent.layerAdded, this.onMapLayerAddedHandler);
        this.eventBus.subscribe(this.MapEvent.layerDisabled, this.onMapLayerDisabledHandler);
        this.eventBus.subscribe(this.MapEvent.layerEnabled, this.onMapLayerEnabledHandler);

        // hide spinner and show interaction elements
        this.onHideSpinnerHandler();
        this.$interactiveMapWrapper.css('visibility', 'visible');

        // Initialize the MapLayerPickerComponent, set as property for debugging purposes
        this.mapLayerPickerComponent = new MapLayerPickerComponent(this.$mapLayerPickerElmt, this.browserDetect, this.eventBus, this.MapEvent);
    };

    /**
     * onShowSpinner Handler
     * Logic to handle updating the view to indicate a layer is loading.
     *
     * @param {Event} event JS Event object
     * @param {Object} eventParms parameters sent with the event
     */
    WeatherInteractiveMapPaneView.prototype.onShowSpinner = function () {
        Util.sendAction('didStartLoading', this.$element);
    };

    /**
     * onShowSpinner Handler
     * Logic to handle updating the view to indicate a layer is loading.
     *
     * @param {Event} event JS Event object
     * @param {Object} eventParms parameters sent with the event
     */
    WeatherInteractiveMapPaneView.prototype.onHideSpinner = function () {
        Util.sendAction('didStopLoading', this.$element);
    };

    /**
     * onMapLayerAdded Handler
     * Logic to handle updating the view after a layer has been added (comes before loaded).
     *
     * @method onMapLayerAdded
     * @param {Event} event JS Event object
     * @param {Object} eventParms parameters sent with the event
     */
    WeatherInteractiveMapPaneView.prototype.onMapLayerAdded = function (event, eventParms) {
        var mapLayerDef = eventParms.mapLayer.definition;
        var layerSymbolicName = mapLayerDef.symbolicName;

        // update single layer legend
        this.eventBus.publish(this.UIEvent.setFocusLayerForSingleLayerLegend, {
            layerSymbolic: layerSymbolicName,
        });

        // update currently known active components
        this.activeLayerComponents = 0;
        if (mapLayerDef.optionsComponent) {
            this.activeLayerComponents++;
        }
        if (mapLayerDef.legendComponent) {
            this.activeLayerComponents++;
        }

        // set layer disabled flag and hide spinner until we know layer is actually loading.
        // The loading event handler will reset this flag back to false and show the spinner.
        this.isLayerDisabled = true;
        this.onHideSpinnerHandler();
    };

    /**
     * onMapLayerDisabled Handler
     * Logic to handle updating the view when a layer is indicated as disabled
     *
     * @method onMapLayerDisabled
     * @param {Event} event JS Event object
     * @param {Object} eventParms parameters sent with the event
     */
    WeatherInteractiveMapPaneView.prototype.onMapLayerDisabled = function () {
        this.isLayerDisabled = true;
        this.onHideSpinnerHandler();
    };

    /**
     * onMapLayerLoading Handler
     * Logic to handle updating the view when a layer is indicated as loading
     *
     * @method onMapLayerLoading
     * @param {Event} event JS Event object
     * @param {Object} eventParms parameters sent with the event
     */
    WeatherInteractiveMapPaneView.prototype.onMapLayerLoading = function () {
        this.isLayerDisabled = false;
        this.onShowSpinnerHandler();

    };

    /**
     * onMapLayerEnabled Handler
     * Logic to handle updating the view when a layer is indicated as enabled
     *
     * @method onMapLayerEnabled
     * @param {Event} event JS Event object
     * @param {Object} eventParms parameters sent with the event
     */
    WeatherInteractiveMapPaneView.prototype.onMapLayerEnabled = function () {
        this.isLayerDisabled = false;
    };

    /**
     * onMapLayerLoaded Handler
     * Logic to handle updating the view after a layer has been loaded.
     *
     * @method onMapLayerLoaded
     * @param {Event} event JS Event object
     * @param {Object} eventParms parameters sent with the event
     */
    WeatherInteractiveMapPaneView.prototype.onMapLayerLoaded = function (event, eventParms) {
        // make layer transparent (if supported)
        this._applyTransparencyToLayer(eventParms.mapLayer);

        // update map and animation slider size
        this.onWindowResizeHandler();

        // tell map to resize to allow slider width change to persist correctly
        this.eventBus.publish(this.MapEvent.resizeMap, {});

        this.onHideSpinnerHandler();
    };

    /**
     * onMobileEnter Handler
     * Re-arrange layout appropriately upon entry into Mobile breakpoint
     *
     * @method onMobileEnter
     * @param {Event} event JS Event object
     */
    WeatherInteractiveMapPaneView.prototype.onMobileEnter = function () {
        this.mobileMode = true;
        this.$element.find('.ZoomControlGUIWidgetTable').parents('.GUIWidget').hide();
        this._toggleSingleLayerLegendMiniMode();
    };

    /**
     * onMobileExit Handler
     * Re-arrange layout appropriately upon exit from Mobile breakpoint
     *
     * @method onMobileExit
     * @param {Event} event JS Event object
     */
    WeatherInteractiveMapPaneView.prototype.onMobileExit = function () {
        this.mobileMode = false;
        this.$element.find('.ZoomControlGUIWidgetTable').parents('.GUIWidget').show();

        // reset animation slider width to default
        this.eventBus.publish(this.UIEvent.setAnimationSliderWidth, {
            width: this.defaultAnimSliderWidth,
        });

        this._toggleSingleLayerLegendMiniMode();
    };

    /**
     * onWindowResize Handler
     * Logic to handle view resize logic for window resizing
     *
     * @method onWindowResize
     * @param {Event} event JS Event object
     */
    WeatherInteractiveMapPaneView.prototype.onWindowResize = function () {
        this._resizeView();

        if (this.eventBus == null || typeof this.eventBus === 'undefined') {
            return; // need eventbus to publish view changes
        }

        // the remaining logic only applies to mobile mode
        if (!this.mobileMode) {
            return;
        }

        // Buffer is determined by number of components (options/legend).
        // We do this instead of measuring directly, because widths can
        // vary during transitions due to the component show/hide animations.
        // TODO: This is prone to break, come up with more versatile way
        // of determining buffer. Perhaps a deferred strategy?
        var firstTierBufferedWidth = Math.min(this.defaultAnimSliderWidth, this.$interactiveMapDiv.innerWidth() - 148);
        var secondTierBufferedWidth = Math.min(this.defaultAnimSliderWidth, this.$interactiveMapDiv.innerWidth() - 256);

        // If the first and second buffered widths are not equal, we know that the secondTierBufferedWidth
        // is less than the defaultAnimSliderWidth. We should then stack the active layer components to
        // allow as much width as possible (i.e. the firstTierBufferedWidth).
        this.activeLayerComponentsStacked = firstTierBufferedWidth !== secondTierBufferedWidth;

        // Retoggle the layer legend mini mode to apply the stacked or non-stacked mode.
        this._toggleSingleLayerLegendMiniMode();

        // New width should allow maximum amount of room for slider.
        var newWidth = Math.max(firstTierBufferedWidth, secondTierBufferedWidth);

        // If the slider width is this small the track doesn't have
        // enough space for reasonable drag, switch to track button mode.
        if (newWidth < 180 && !this.trackButtonMode) {
            this.trackButtonMode = true;
            this.eventBus.publish(this.UIEvent.setAnimationSliderTrackButtonMode, {
                trackButtonMode: true,
            });
            // Else if it is greater we should set track button mode off, so if it's on do so.
        } else if (newWidth >= 180 && this.trackButtonMode) {
            this.trackButtonMode = false;
            this.eventBus.publish(this.UIEvent.setAnimationSliderTrackButtonMode, {
                trackButtonMode: false,
            });
        }

        // Set the new width.
        this.eventBus.publish(this.UIEvent.setAnimationSliderWidth, {
            width: newWidth,
        });
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Private API
    //////////////////////////////////////////////////////////////////////////////////////////////////

    WeatherInteractiveMapPaneView.prototype._initMapAPI = function () {
        // We set this so that the MapAPI doesn't error on calling it
        window.handleSessionTimeout = function () {
            // do nothing, liferay manages this independently
        };

        var self = this;

        window.mapRequire(['./map/ReqjsConfig'], function () {
            window.mapRequire(['./map/MapApi', './map/ui/desktop/DesktopUI'], function (MapApi, DesktopUI) {
                var mapApi = new MapApi(window.dtnGlobals.mapApiConfig);

                var uiOptions = {
                    disableLegend: true,
                    disableSingleLayerLegend: false,
                    disableMainMenu: true,
                    disableFullscreenTools: true,
                    hideOnUserIdle: false,
                };

                mapApi.renderMap({
                    mapDiv: 'map_div',
                    mapDef: self.mapOptions.mapDef,
                    mapConfig: self.mapOptions.mapConfig,
                    user: self.mapOptions.user,
                    mapPrefs: self.mapOptions.mapPrefs,
                    mapFavs: self.mapOptions.mapFavs,
                    usrLocations: self.mapOptions.usrLocations,
                    userInterface: new DesktopUI(uiOptions, mapApi),
                    autoResize: false,
                    scrollwheel: false,
                    eventHandlers: [
                        {
                            event: MapApi.Event.sessionInvalid,
                            callback: function () {
                                window.handleSessionTimeout(window.dtnGlobals.requestPath);
                            },
                        },
                        {
                            event: MapApi.Event.uiLoaded,
                            callback: function () {
                                self._toggleSingleLayerLegendMiniMode();
                                if (self.mobileMode) {
                                    self.$element.find('.ZoomControlGUIWidgetTable').parents('.GUIWidget').hide();
                                }

                                // give browser some time to render after loading map...
                                setTimeout(self.onMapUILoadedHandler, 100);
                            },
                        },
                    ],
                }).done(function (map) {
                    self.eventBus = map.eventBus;
                    self.MapEvent = MapApi.Event;
                    self.UIEvent = DesktopUI.UIEvent;
                    self.map = map.map;
                });
            });
        });
    };


    /**
     * View resize logic motivated by various environmental flags and constraints
     *
     * @method _resizeView
     */
    WeatherInteractiveMapPaneView.prototype._resizeView = function () {
        // determine paneWidth
        var availableWidth = window.innerWidth - this.$interactiveMapDiv.offset().left;
        var paneWidth = this.$element.width();
        if (availableWidth < paneWidth) {
            paneWidth = availableWidth - 10;
        }

        // how much window space do we want around the map?
        var mapPadding = null;
        if (window.innerHeight > window.innerWidth) {
            // if we are vert heavy, more freedom to show UI around map
            mapPadding = this.$element.parents('.portlet-content').outerHeight(true) + 70;
            mapPadding -= this.$interactiveMapDiv.height();
        } else {
            // if we are width heavy, need more space to allow map interaction
            mapPadding = 60;
        }

        // adjust height according to constraints
        var newHeight = (paneWidth * 0.5) + 20; // default
        if (this.mobileMode) {
            // we want to ensure user has enough space to utilize map
            newHeight = window.innerHeight - mapPadding;
        } else if (newHeight > window.innerHeight - mapPadding) {
            // even if not in mobile mode, we want enough space so that the user
            // doesn't have to scale the page down to see the full map
            newHeight = window.innerHeight - mapPadding;
        }

        // resize div to match
        this.$interactiveMapDiv.css({
            width: 'auto',
            height: newHeight,
        });
    };

    /**
     * Toggles map's MapSingleLayerLegendUI to mini mode via the event bus
     * Dependent upon whether mobileMode is true or false
     *
     * @method _toggleSingleLayerLegendMiniMode
     */
    WeatherInteractiveMapPaneView.prototype._toggleSingleLayerLegendMiniMode = function () {
        if (this.eventBus) {
            this.eventBus.publish(this.UIEvent.toggleSingleLayerLegendMiniMode, {
                miniMode: this.mobileMode,
                verticalOrientation: this.activeLayerComponentsStacked,
            });
        }
    };

    WeatherInteractiveMapPaneView.prototype._applyTransparencyToLayer = function (mapLayer) {
        if (mapLayer.isOpacityVariable) {
            this.eventBus.publish(this.MapEvent.setLayerOpacity, {
                layerSymbolic: mapLayer.definition.symbolicName,
                opacity: 80,
            });
        }
    };

    return WeatherInteractiveMapPaneView;
});

define('shared-scripts/models/WeatherForecastModel',['require','jquery','moment','knockout','shared-scripts/services/metricsService'],function (require) {
    

    var $ = require('jquery');
    var moment = require('moment');
    var ko = require('knockout');
    var metricsService = require('shared-scripts/services/metricsService');

    function renderWindSpeedText(target, windSpeedLabel) {
        if (target) {
            var windSpeedText = target.windDirection + ' ' + target.windSpeed;
            // wind speed text is determinate upon presence of a number, if
            // there isn't one do not show label for units
            if (
                typeof target.windSpeed === 'string' &&
                target.windSpeed.match(/.*\d.*/g) != null
            ) {
                windSpeedText += ' ' + windSpeedLabel;
            }

            return windSpeedText;
        }
        return '';
    }

    var WeatherForecastModel = function (data) {
        var self = this;
        self.now = moment();
        self.days = ko.observableArray(data.forecastDays);
        self.hours = data.numberOfHours;
        self.windThresholdSpeed = data.windThresholdSpeed;

        self.selectedDay = ko.observable(self.days()[0]);
        self.selectedHour = ko.observable(null);

        self.showHour = function () {
            return (self.selectedHour() !== null);
        };

        self.currentCondition = data.currentCondition;
        self.currentCondition.windSpeedText = renderWindSpeedText(self
                .selectedDay(), data.windSpeedLabel);

        self.showCurrentCondition = function () {
            return self.selectedDay() === self.days()[0] && !self.showHour();
        };

        self.select = function (day, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            day.windSpeedText = renderWindSpeedText(day, data.windSpeedLabel);
            self.selectedDay(day);
            self.selectedHour(null);

            metricsService.tabClick('Five Day Forecast', self.selectedDay().dayOfWeek);

            return false;
        };
        if (self.selectedDay()) {
            self.selectedDay().windSpeedThreshold = self.windThresholdSpeed < self
                    .selectedDay().windspeed;
        }

        self.selectedDayHours = function () {
            $.each(self.selectedDay().forecastHours, function (i, forecastHour) {
                forecastHour.windSpeedText = renderWindSpeedText(forecastHour,
                        data.windSpeedLabel);
            });
            return self.selectedDay().forecastHours;
        };
        self.seventyTwoHoursData = null;

        self.seventyTwoHours = function () {
            if (self.seventyTwoHoursData === null) {
                // Build the dataset if it doesn't already exist
                self.seventyTwoHoursData = [];

                var count = self.seventyTwoHoursData.length;
                var dayCount = 0;
                var day = self.days()[dayCount];
                var i;
                for (i = 0; count < self.hours; i++) {
                    if (i === day.forecastHours.length) {
                        dayCount = dayCount + 1;
                        day = self.days()[dayCount];
                        i = 0;
                    }
                    var forecastHour = day.forecastHours[i];
                    forecastHour.weekdaySmall = day.weekdaySmall;
                    forecastHour.shortMonth = day.shortMonth;
                    forecastHour.dayOfMonth = day.dayOfMonth;

                    count = self.seventyTwoHoursData.push(day.forecastHours[i]);
                }
            }

            return self.seventyTwoHoursData;
        };

        self.nextDay = function () {
            var nextDayIndex = self.days.indexOf(self.selectedDay()) + 1;
            self.selectedDay(self.days()[nextDayIndex]);
        };

        /**
         * Loop through each of the days and check to see if the temperature or the
         * feels like temperature is over the threshold
         * @returns {boolean}
         */
        self.isTempFeelsLikeValid = function () {
            var invalidDay = ko.utils.arrayFirst(this.days(), function (day) {
                if(!day.tempValid || !day.feelsLikeValid) {
                    return true;
                }
            });
            // If there is no invalid day then the precipAmount is valid
            return invalidDay === null;
        };

        /**
         * Loop through each of the days and check to see if the wind speed or gust speed is over the threshold
         * @returns {boolean}
         */
        self.isWindSpeedGustValid = function () {
            var invalidDay = ko.utils.arrayFirst(this.days(), function (day) {
                if(!day.windSpeedValid || !day.gustSpeedValid) {
                    return true;
                }
            });
            // If there is no invalid day then the precipAmount is valid
            return invalidDay === null;
        };

        /**
         * Loop through each of the days and check to see if the dew point over the threshold
         * @returns {boolean}
         */
        self.isDewPointValid = function () {
            var invalidDay = ko.utils.arrayFirst(this.days(), function (day) {
                if(!day.dewPointValid) {
                    return true;
                }
            });
            // If there is no invalid day then the precipAmount is valid
            return invalidDay === null;
        };

        /**
         * Loop through each of the days and check to see if the humidity is over the threshold
         * @returns {boolean}
         */
        self.isHumidityValid = function () {
            var invalidDay = ko.utils.arrayFirst(this.days(), function (day) {
                if(!day.humidityValid) {
                    return true;
                }
            });
            // If there is no invalid day then the precipAmount is valid
            return invalidDay === null;
        };

        /**
         * Loop through each of the days and check to see if the precip chance is over the threshold
         * @returns {boolean}
         */
        self.isPrecipChanceValid = function () {
            var invalidDay = ko.utils.arrayFirst(this.days(), function (day) {
                if(!day.precipChanceValid) {
                    return true;
                }
            });
            // If there is no invalid day then the precipAmount is valid
            return invalidDay === null;
        };

        /**
         * Loop through each of the days and check to see if the precip amount is over the threshold
         * @returns {boolean}
         */
        self.isPrecipAmountValid = function () {
            var invalidDay = ko.utils.arrayFirst(this.days(), function (day) {
                if(!day.precipAmountValid) {
                    return true;
                }
            });
            // If there is no invalid day then the precipAmount is valid
            return invalidDay === null;
        };

        self.isCurrentHourColumn = function(index, currentHour, maxObservedHours) {
            var currentHourIsLastHour = (index + 1) == maxObservedHours && currentHour >= self.days().length;
            var currentHourIsBeforeNextHour = index < self.days().length && self.weekdaySmall == 'Today' &&
                time <= currentHour && currentHour < self.days()[$index() + 1].time;
            return currentHourIsLastHour || currentHourIsBeforeNextHour;
        }

    };

    return WeatherForecastModel;
});

/**
 * @author mernst <mernst@nerdery.com>
 * @file WeatherForecastTableView module definition
 */
define('views/weather/WeatherForecastTableView',['require','jquery','shared-scripts/components/BaseComponent','shared-scripts/lib/Util'],function (require) {
    
    var $ = require('jquery');

    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var Util = require('shared-scripts/lib/Util');

     /**
     * A view that adjusts the presentation of weather forecast tables
     *
     * Usage:
        <div class="js-forecastTable" data-scroll-hour="5" data-same-layout="true" data-mobile-mode="true">
            <div class="js-forecastTable-nav">
                <div class="js-forecastTable-nav-item">
                    <div class="js-forecastTable-nav-item-trigger">
                        <i class="js-forecastTable-nav-item-icon"></i>
                    </div>
                    <div class="js-forecastTable-nav-item-content">
                    </div>
                </div>
            </div>
        </div>

     *
     */
    function WeatherForecastTableView ($element, browserDetect) {
        this.$element = $element;
        this.browserDetect = browserDetect;
        this.init();
    }

    WeatherForecastTableView.id = 'WeatherForecastTableView';
    WeatherForecastTableView.prototype = new BaseComponent(WeatherForecastTableView);
    WeatherForecastTableView.prototype.constructor = WeatherForecastTableView;

    /**
     * Performs any event binding to handlers
     *
     * @chainable
     * @method onEnable
     */
    WeatherForecastTableView.prototype.onEnable = function () {
        Util.subscribe('WeatherForecastToggle', this.weatherForecastToggleHandler);
        Util.subscribe('tabDidSwitch.tabs', this.tabSwitchHandler);
        return this;
    };

    /**
     * Tears down any event binding to handlers
     *
     * @chainable
     * @method onDisable
     */
    WeatherForecastTableView.prototype.onDisable = function () {
        Util.unsubscribe('WeatherForecastToggle', this.weatherForecastToggleHandler);
        Util.unsubscribe('tabDidSwitch.tabs', this.tabSwitchHandler);
        return this;
    };

    /**
     * Bind scope of handler functions
     *
     * @chainable
     * @method onSetupHandlers
     */
    WeatherForecastTableView.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here
        this.weatherForecastToggleHandler = this.forecastScroll.bind(this);
        this.tabSwitchHandler = this.forecastScroll.bind(this);

        return this;
    };

    /**
     * Destroys the component
     *
     * @chainable
     * @method onDisable
     */
    WeatherForecastTableView.prototype.onDestroy = function () {
        this.$element = null;
        return this;
    };

    /**
     * Create any child objects or references to DOM elements.
     *
     * @chainable
     * @method onCreateChildren
     */
    WeatherForecastTableView.prototype.onCreateChildren = function () {
        this.forceMobile = this.$element.attr('data-mobile-mode');
        this.sameLayout = this.$element.attr('data-same-layout');
        this.scrollToHour = this.$element.attr('data-scroll-hour');

        return this;
    };

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @chainable
     * @method onRemoveChildren
     */
    WeatherForecastTableView.prototype.onRemoveChildren = function () {
        this.forceMobile = null;
        this.sameLayout = null;
        return this;
    };

    /**
     * On mobile enter handler.
     *
     * @method onMobileEnter
     * @param {Event} e JS Event object.
     */
    WeatherForecastTableView.prototype.onMobileEnter = function () {
        this.mobileMode = true;
        this.desktopMode = false;
        this.forecastScroll();
    };

    /**
     * On desktop enter handler.
     *
     * @method onDesktopEnter
     * @param {Event} e JS Event object.
     */
    WeatherForecastTableView.prototype.onDesktopEnter = function () {
        this.mobileMode = false;
        this.desktopMode = true;
        this.forecastScroll();
    };

    /**
     * Auto scroll to certain hour
     *
     * @method forecastScroll
     */
    WeatherForecastTableView.prototype.forecastScroll = function () {
        var $scrollArea = this.$element.find('.js-forecast-scroll');
        if ($scrollArea.length === 0) {
            $scrollArea = this.$element;
        }
        var $column = $scrollArea.find('.js-forecastTable-column');
        $scrollArea.scrollLeft($column.width() * this.scrollToHour);
        this.alignCells();
    };

    /**
     * Aligns cells in row by making them match the height of the tallest cell
     *
     * @method alignCells
     */
    WeatherForecastTableView.prototype.alignCells = function () {
        this.$cell = this.$element.find('.js-forecastTable-cell');
        this.$cell.height('');
        var maxHeight = 0;
        this.$cell.each(function (idx, el) {
            if (maxHeight < $(el).height()) {
                maxHeight = $(el).height();
            }
        });

        this.$cell.height(maxHeight);
    };

    return WeatherForecastTableView;
});

/**
 * @author mernst <mernst@nerdery.com>
 * @file WeatherForecastToggleView module definition
 */
define('shared-scripts/views/weather/WeatherForecastToggleView',['require','jquery','shared-scripts/components/BaseComponent','views/weather/WeatherForecastTableView'],function (require) {
    

    var $ = require('jquery');
    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var WeatherForecastTableView = require('views/weather/WeatherForecastTableView');

    var OPEN_CLASS = 'isOpen';

    /**
     * A view that handles interaction with weather forecast panels
     *
     * Usage:
        <div class="js-weatherForecast">
            <div class="js-weatherForecast-container">
                <div class="js-forecast-trigger" data-forecast-group="hourly">
                    <i class="js-forecast-trigger-icon"></i>
                </div>
                <div class="js-forecast-target" data-forecast-group="hourly">
                    <div class="js-forecastTable" data-mobile-mode="true">
                        <div class="js-forecastTable-nav">
                            <div class="js-forecastTable-nav-item">
                                <div class="js-forecastTable-nav-item-trigger">
                                    <i class="js-forecastTable-nav-item-icon"></i>
                                </div>
                                <div class="js-forecastTable-nav-item-content">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     *
     * @class WeatherForecastView
     * @constructor
     * @extends BaseComponent
     */
    var WeatherForecastToggleView = function ($element, browserDetect) {
        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = $element;

        /**
         * Feature-detection object
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        this.init();
    };

    WeatherForecastToggleView.id = 'WeatherForecastToggleView';
    WeatherForecastToggleView.prototype = new BaseComponent(WeatherForecastToggleView);
    WeatherForecastToggleView.prototype.constructor = WeatherForecastToggleView;

    /**
     * Performs any event binding to handlers
     *
     * @chainable
     * @method onEnable
     */
    WeatherForecastToggleView.prototype.onEnable = function () {
        this.onCreateChildren()
            .setupPanels();

        this.$trigger.on('click.WeatherForecastToggleView', this.onClickHandler);
        this.$forecastNavItem.on('click.WeatherForecastToggleView', this.onTimeClickHandler);

        return this;
    };

    /**
     * Tears down any event binding to handlers
     *
     * @chainable
     * @method onDisable
     */
    WeatherForecastToggleView.prototype.onDisable = function () {
        this.$trigger.off('click.WeatherForecastToggleView', this.onClickHandler);
        this.$forecastNavItem.off('click.WeatherForecastToggleView', this.onTimeClickHandler);

        return this;
    };

    /**
     * Binds the scope of any handler functions.
     *
     * @chainable
     * @method onSetupHandlers
     */
    WeatherForecastToggleView.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here
        this.onClickHandler = this.onClick.bind(this);
        this.onTimeClickHandler = this.onTimeClick.bind(this);

        return this;
    };

    /**
     * Destroys the component.
     *
     * @chainable
     * @method onDestroy
     */
    WeatherForecastToggleView.prototype.onDestroy = function () {
        this.$element = null;

        return this;
    };

    /**
     * Create any child objects or references to DOM elements.
     *
     * @chainable
     * @method onCreateChildren
     */
    WeatherForecastToggleView.prototype.onCreateChildren = function () {
        this.$navItem = null;
        this.$trigger = this.$element.find('.js-forecast-trigger');
        this.$target = this.$element.find('.js-forecast-target');
        this.$triggerIcon = this.$element.find('.js-forecast-trigger-icon');
        this.$forecastNav = this.$element.find('.js-forecastTable-nav');
        this.$forecastNavItem = this.$forecastNav.find('.js-forecastTable-nav-item');
        this.$forecastItemContent = this.$forecastNav.find('.js-forecastTable-nav-item-content');
        this.$forecastItemIcon = this.$forecastNav.find('.js-forecastTable-nav-item-icon');

        return this;
    };

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @chainable
     * @method onRemoveChildren
     */
    WeatherForecastToggleView.prototype.onRemoveChildren = function () {
        this.$trigger = null;
        this.$target = null;
        this.$triggerIcon = null;
        this.$forecastNav = null;
        this.$forecastNavItem = null;
        this.$forecastItemContent = null;
        this.$forecastItemIcon = null;
        this.$forecastTable = null;
        this.$navItem = null;

        return this;
    };

    /**
     * Setup panels for mobile view
     *
     * @method setupPanels
     */
    WeatherForecastToggleView.prototype.setupPanels = function () {
        var self = this;
        if (this.mobileMode === true) {
            this.$target.each(function (){
                var wasopen = $(this).data('was-open');
                var group = $(this).data('forecast-group');
                if (wasopen) {
                    $(this).show();
                    self.showPanel(group, false);
                } else {
                    self.hidePanel(group);
                    $(this).hide();
                }
            });
        }
    };

    /**
     * Initializes new table views and updates objects
     *
     * @method updateContent
     */
    WeatherForecastToggleView.prototype.updateContent = function () {

        this.$navItem = this.$element.find('.js-forecastTable-nav-item');
        this.$contentPanel = this.$navItem.find('.js-forecastTable-nav-item-content');
        this.$contentPanel.slideUp();
        this.$forecastTable = this.$element.find('.js-forecastTable');
        this.$forecastTable.each(function (){
            /*jshint -W031 */
            new WeatherForecastTableView($(this));
        });

        // hide all targets on mobile
        if (this.mobileMode === true) {
            this.$target.hide();
        }

        this.onDisable();
        this.onEnable();

        $(document.body).trigger('WeatherForecastToggle');

        return this;
    };

    /**
     * On click handler.
     *
     * @method onClick
     * @param {Event} e JS Event object.
     */
    WeatherForecastToggleView.prototype.onClick = function (e) {
        this.toggle(e);
    };

    /**
     * Toggles open/close hourly dropdowns.
     *
     * @method onTimeClick
     * @param {Event} e JS Event object.
     */
    WeatherForecastToggleView.prototype.onTimeClick = function (e) {
        var $target = $(e.currentTarget);
        this.$contentPanel.slideUp();
        this.$forecastItemIcon.removeClass(OPEN_CLASS);
        if ($target.hasClass(OPEN_CLASS)){
            $target.removeClass(OPEN_CLASS);
        } else {
            this.$forecastNavItem.removeClass(OPEN_CLASS);
            $target.addClass(OPEN_CLASS);
            $target.find('.js-forecastTable-nav-item-icon').addClass(OPEN_CLASS);
            $target.find('.js-forecastTable-nav-item-content').slideDown();
        }
    };

    /**
     * Toggles show/hide of forecast panels
     *
     * @method toggle
     * @param {Event} e JS Event object.
     */
    WeatherForecastToggleView.prototype.toggle = function (e) {
        var $trigger = $(e.currentTarget);

        var group = $trigger.data('forecast-group');
        if (!$trigger.hasClass(OPEN_CLASS)) {
            this.showPanel(group);
        } else {
            this.hidePanel(group);
        }

        $(document.body).trigger('WeatherForecastToggle');

    };

    /**
     * Opens a forecast panel
     *
     * @method showPanel
     * @param {string} group the ID for the target/panel group.
     */
    WeatherForecastToggleView.prototype.showPanel = function (group) {
        var groupSet = this.getGroupSet(group);

        groupSet.$trigger.addClass(OPEN_CLASS);
        groupSet.$trigger.find('.js-forecast-trigger-icon').addClass(OPEN_CLASS);
        groupSet.$target.slideDown();

    };

    /**
     * Hides a forecast panel.
     *
     * @method hidePanel
     * @param {string} group the ID for the target/panel group.
     */
    WeatherForecastToggleView.prototype.hidePanel = function (group) {
        var groupSet = this.getGroupSet(group);

        groupSet.$trigger.removeClass(OPEN_CLASS);
        groupSet.$trigger.find('.js-forecast-trigger-icon').removeClass(OPEN_CLASS);
        groupSet.$target.slideUp();
    };

    /**
     * Uses group ID string to create a groupSet object containing both trigger and
     * target of the group
     *
     * @method getGroupSet
     * @param {string} group the ID for the target/panel group.
     * @returns {Object}
     */
    WeatherForecastToggleView.prototype.getGroupSet = function (group) {
        var groupSet = {
            $target: this.$element.find('.js-forecast-target[data-forecast-group="' + group + '"]'),
            $trigger: this.$element.find('.js-forecast-trigger[data-forecast-group="' + group + '"]')
        };

        return groupSet;
    };

    /**
     * Mobile specific property & DOM changes
     *
     * @method onMobileEnter
     * @param {Event} e JS Event object.
     */
    WeatherForecastToggleView.prototype.onMobileEnter = function (e) {
        this.mobileMode = true;

        this.onDisable()
            .onEnable();

    };

    /**
     * Desktop specific property & DOM changes
     *
     * @method onDesktopEnter
     * @param {Event} e JS Event object.
     */
    WeatherForecastToggleView.prototype.onDesktopEnter = function (e) {
        this.mobileMode = false;

        if (this.$element.data('mobile-mode') === true) {
            this.onMobileEnter();
        } else {
            if (this.$element.data('defaultToggleOpen') !== true) {
                this.$trigger.removeClass(OPEN_CLASS);
                this.$target.removeClass(OPEN_CLASS).show();
                this.$triggerIcon.removeClass(OPEN_CLASS);
            } else {
                this.$trigger.addClass(OPEN_CLASS);
                this.$target.addClass(OPEN_CLASS);
                this.$triggerIcon.addClass(OPEN_CLASS);
            }
            this.onDisable()
                .onEnable();
        }

    };

    return WeatherForecastToggleView;

});


/**
 * @author mernst <mernst@nerdery.com>
 * @file WeatherForecastView module definition
 */
define('shared-scripts/views/weather/WeatherForecastView',['require','shared-scripts/components/BaseComponent','shared-scripts/models/WeatherForecastModel','shared-scripts/views/weather/WeatherForecastToggleView','shared-scripts/lib/Util'],function (require) {
    

    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var WeatherForecastModel = require('shared-scripts/models/WeatherForecastModel');
    var WeatherForecastToggle = require('shared-scripts/views/weather/WeatherForecastToggleView');
    var Util = require('shared-scripts/lib/Util');

    /**
     * A view that sets up knockout for weather forecast and creates new view instances
     * for weather forecast portlet interaction
     *
     * Usage:
        <div class="js-weatherForecast">
            <div class="js-weatherForecast-container">
                <div class="js-forecast-trigger" data-forecast-group="hourly">
                    <i class="js-forecast-trigger-icon"></i>
                </div>
                <div class="js-forecast-target" data-forecast-group="hourly">
                    <div class="js-forecastTable" data-mobile-mode="true">
                        <div class="js-forecastTable-nav">
                            <div class="js-forecastTable-nav-item">
                                <div class="js-forecastTable-nav-item-trigger">
                                    <i class="js-forecastTable-nav-item-icon"></i>
                                </div>
                                <div class="js-forecastTable-nav-item-content">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     *
     * @class WeatherForecastView
     * @constructor
     * @extends BaseComponent
     */
    function WeatherForecastView ($element, browserDetect) {
        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = $element;

        /**
         * Feature-detection object
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        var weatherData = null;
        var portletType = this.$element.attr('data-portlet-type');
        if (portletType === 'outlook') {
            weatherData = window.FIVE_DAY_FORECAST_DATA;
        } else if (portletType === 'hourly') {
            weatherData = window.HOURLY_FORECAST_DATA;
        }

        // Bail out early if the data needed is not available
        if (weatherData == null) {
            return this;
        }

        this.weatherData = weatherData;

        this.init();
    };

    WeatherForecastView.id = 'WeatherForecastView';
    WeatherForecastView.prototype = new BaseComponent(WeatherForecastView);
    WeatherForecastView.prototype.constructor = WeatherForecastView;

    /**
     * Performs any event binding to handlers
     *
     * @chainable
     * @method onEnable
     */
    WeatherForecastView.prototype.onEnable = function () {
        this.setupDataBindings();
        return this;
    };

    /**
     * Create any child objects or references to DOM elements.
     *
     * @chainable
     * @method onCreateChildren
     */
    WeatherForecastView.prototype.onCreateChildren = function () {
        this.weatherForecastToggleView = new WeatherForecastToggle(this.$element, this.browserDetect);
        this.forecastModel = new WeatherForecastModel(this.weatherData);
        this.$dailyForecast = this.$element.find('.js-weatherForecast-daily');

        return this;
    };

    /**
     * Tears down any event binding to handlers
     *
     * @chainable
     * @method onDisable
     */
    WeatherForecastView.prototype.onDisable = function () {
        this.forecastModel = null;
        this.weatherForecastToggleView = null;

        Util.removeBindings('ko-WeatherForecastView', this.$element);

        return this;
    };


    /**
     * Setup forecastModel knockout bindings
     *
     * @chainable
     * @method setupDataBindings
     */
    WeatherForecastView.prototype.setupDataBindings = function () {
        Util.applyBindings('ko-WeatherForecastView', this.forecastModel, this.$element);
        this.weatherForecastToggleView.updateContent();
        this.$dailyForecast.removeClass('isHidden');
        this.forecastModel.selectedDay.subscribe(function (){
            this.weatherForecastToggleView.updateContent();
        }.bind(this));

        return this;
    };

    return WeatherForecastView;

});

define('views/markets/CurrentChartsView',['exports', 'module', 'jquery', 'shared-scripts/components/BaseComponent', 'shared-scripts/lib/Util', 'shared-scripts/services/metricsService'], function (exports, module, _jquery, _sharedScriptsComponentsBaseComponent, _sharedScriptsLibUtil, _sharedScriptsServicesMetricsService) {
    

    module.exports = CurrentChartsView;

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var _BaseComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsBaseComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var SERVLET_IMAGE_URL = '/mydtn-public-core-portlet/servlet/GetNewsImage?productCode=';

    function CurrentChartsView($element, browserDetect) {
        /**
         * The container element for this component
         *
         * @property {jQuery} $element
         */
        this.$element = $element;

        /**
         * Feature-detection object
         *
         * @property {BrowserDetect} browserDetect
         */
        this.browserDetect = browserDetect;

        this.init();
    }

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    CurrentChartsView.isSafeToCallDestroy = false;
    CurrentChartsView.id = 'CurrentChartsView';
    CurrentChartsView.prototype = new _BaseComponent['default'](CurrentChartsView);
    CurrentChartsView.prototype.constructor = CurrentChartsView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Binds the scope of any handler functions
     * Should only be run on initialization of the view
     *
     * @method onSetupHandlers
     * @returns {CurrentChartsView}
     */
    CurrentChartsView.prototype.onSetupHandlers = function () {
        // Bind event handlers scope here
        this.onSelectChangeHandler = this.onSelectChange.bind(this);
        return this;
    };

    /**
     * Create any child objects or references to DOM elements
     * Should only be run on initialization of the view
     *
     * @method onCreateChildren
     * @returns {CurrentChartsView}
     */
    CurrentChartsView.prototype.onCreateChildren = function () {
        // Create any other dependencies here

        // Form Elements
        this.$select = this.$element.find('.js-currentChartsView-select');
        this.$image = this.$element.find('.js-currentChartsView-image');

        _Util['default'].getJSON(this.$element.data('getChartImageDataUrl')).done((function (jsonMap) {
            this.chartImageDataMap = jsonMap;
        }).bind(this));

        return this;
    };

    /**
     * Removes any child objects or references to DOM elements
     *
     * @method onRemoveChildren
     * @returns {CurrentChartsView}
     */
    CurrentChartsView.prototype.onRemoveChildren = function () {
        // Remove any other dependencies here
        this.$select = null;
        this.$image = null;

        return this;
    };

    /**
     * Enables the component
     * Performs any event binding to handlers
     * Does not execute if component is already enabled
     *
     * @method onEnable
     * @returns {CurrentChartsView}
     */
    CurrentChartsView.prototype.onEnable = function () {
        // Setup any event handlers

        this.$select.on('change.CurrentChartsView', this.onSelectChangeHandler);

        return this;
    };

    /**
     * Disables the component
     * Tears down any event binding to handlers
     * Does not execute if component is already disabled
     *
     * @method onDisable
     * @returns {CurrentChartsView}
     */
    CurrentChartsView.prototype.onDisable = function () {
        // Tear down any event handlers
        if (this.$element != null) {
            this.$select.off('change.CurrentChartsView', this.onSelectChangeHandler);
        }

        return this;
    };

    /**
     * Destroys the component
     * Assume that onDisable() and onRemoveChildren() are called prior to this
     * Should be called when the object should be left unused
     *
     * @method onDestroy
     * @returns {CurrentChartsView}
     */
    CurrentChartsView.prototype.onDestroy = function () {
        // Clear any timeouts, etc.

        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////
    CurrentChartsView.prototype.onSelectChange = function (e) {
        var selectValue = (0, _$['default'])(e.target).val();
        var altValue = this.chartImageDataMap[selectValue].subtitle;
        this.$image.attr({
            src: SERVLET_IMAGE_URL + selectValue,
            alt: altValue
        });

        var portletTitle = this.$select.attr('data-config-portlet-title').toLowerCase();
        var commodityName = this.$select.find('option:selected').attr('data-config-commodity-name').toLowerCase();

        _metricsService['default'].commodityEntry(portletTitle, commodityName);
    };
});
define('views/markets/FuturesView',['exports', 'module', 'shared-scripts/components/BaseComponent', 'shared-scripts/lib/Util', 'shared-scripts/services/metricsService'], function (exports, module, _sharedScriptsComponentsBaseComponent, _sharedScriptsLibUtil, _sharedScriptsServicesMetricsService) {
    

    module.exports = FuturesView;

    var _BaseComponent = babelHelpers.interopRequireDefault(_sharedScriptsComponentsBaseComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var REFRESH_INTERVAL_MS = 10000;

    /**
     * FuturesView
     *
     * @class FuturesView
     * @extends BaseComponent
     * @constructor
     */

    function FuturesView($element, browserDetect) {
        /**
         * The container element for this component
         *
         * @property {jQuery} $element
         */
        this.$element = $element;

        /**
         * Feature-detection object
         *
         * @property {BrowserDetect} browserDetect
         */
        this.browserDetect = browserDetect;

        this.interval = null;

        this.init();

        this._requestData();
    }

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    FuturesView.isSafeToCallDestroy = false;
    FuturesView.id = 'FuturesView';
    FuturesView.prototype = new _BaseComponent['default'](FuturesView);
    FuturesView.prototype.constructor = FuturesView;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    FuturesView.prototype.onSetupHandlers = function () {
        this.onCommodityChangeHandler = this.onCommodityChange.bind(this);
        this.onRefreshIntervalHandler = this.onRefreshInterval.bind(this);
        this.onRefreshClickHandler = this.onRefreshClick.bind(this);

        return this;
    };

    FuturesView.prototype.onCreateChildren = function () {
        this.$commoditySelect = this.$element.find('.js-futures-commodity-select');
        this.$futuresRefreshClick = this.$element.find('.js-futures-refresh');
        this.$futuresContent = this.$element.find('.js-futures-content');
        this.$futuresCommentary = this.$element.find('.js-futures-commentary');

        // Request the futures commentary
        this._requestFuturesCommentary();

        // Disable the auto refresh functionality
        this.disableRefresh = this.$element.data('disableRefresh') === true;

        return this;
    };

    FuturesView.prototype.onRemoveChildren = function () {
        this.$commoditySelect = null;
        this.$futuresRefreshClick = null;
        this.$futuresContent = null;
        this.$futuresCommentary = null;

        return this;
    };

    FuturesView.prototype.onLayout = function () {
        //this.$element.css('width', '400px');

        return this;
    };

    FuturesView.prototype.onEnable = function () {
        this.$commoditySelect.on('change.FuturesView', this.onCommodityChangeHandler);
        this.$futuresRefreshClick.on('click.FuturesView', this.onRefreshClickHandler);

        if (!this.disableRefresh) {
            this._startRefreshInterval();
        }

        return this;
    };

    FuturesView.prototype.onDisable = function () {
        this.$commoditySelect.off('change.FuturesView', this.onCommodityChangeHandler);
        this.$futuresRefreshClick.off('click.FuturesView', this.onRefreshClickHandler);

        this._stopRefreshInterval();

        return this;
    };

    FuturesView.prototype.onDestroy = function () {
        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    FuturesView.prototype.onRefreshClick = function (e) {
        e.preventDefault();

        var portletTitle = this.$futuresRefreshClick.attr('data-config-portlet-title');

        _metricsService['default'].refreshClick(portletTitle);

        this._refresh();

        return false;
    };

    FuturesView.prototype.onCommodityChange = function () {
        this._refresh();

        var portletTitle = this.$commoditySelect.attr('data-config-portlet-title').toLowerCase();
        var commodityName = this.$commoditySelect.find('option:selected').text().toLowerCase();

        _metricsService['default'].commodityEntry(portletTitle, commodityName);
    };

    FuturesView.prototype.onRefreshInterval = function () {

        this._refresh();
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Private API
    //////////////////////////////////////////////////////////////////////////////////////////////////

    // Request the content
    FuturesView.prototype._refresh = function () {
        // Restart the interval timer
        this._startRefreshInterval();
        this._requestData();
    };

    FuturesView.prototype._startRefreshInterval = function () {
        this._stopRefreshInterval(); // stop any existing interval first
        this.interval = setTimeout(this.onRefreshIntervalHandler, REFRESH_INTERVAL_MS);
    };

    FuturesView.prototype._stopRefreshInterval = function () {
        clearTimeout(this.interval);
    };

    FuturesView.prototype._getTableApi = function () {
        var tableApi = this.$element.find('.js-accordionTable').data('publicApi');
        return tableApi;
    };

    FuturesView.prototype._requestData = function () {
        this._requestFuturesContent();
        this._requestFuturesCommentary();
    };

    FuturesView.prototype._requestFuturesContent = function () {
        // Construct the URL
        var quotesUrl = this._constructRenderUrl() + (this.isOverviewSelected() ? '&renderType=quotesGrid' : '&renderType=quotesList');

        // Identify which row is currently expanded
        var symbol = null;
        var tableApi = this._getTableApi();
        if (tableApi != null) {
            symbol = tableApi.getActiveRow().attr('data-config-symbol');
        }

        // Show the spinner
        _Util['default'].sendAction('didStartLoading', this.$futuresContent);

        // Refresh the html
        _Util['default'].getHTML(quotesUrl).done(this.onFetchFuturesHTMLComplete.bind(this, symbol));
    };

    FuturesView.prototype.onFetchFuturesHTMLComplete = function (symbol, htmlResult) {
        // Hide the spinner

        _Util['default'].sendAction('didStopLoading', this.$futuresContent);
        // Refresh with new content
        this.$futuresContent.html(htmlResult);
        _Util['default'].sendAction('attachjs', this.$futuresContent);
        // this.$futuresContent.trigger('attachjs');

        // Re-expand the previously expanded row
        if (symbol != null) {
            var tableApi = this._getTableApi();
            if (tableApi != null) {
                tableApi.setActiveRow('[data-config-symbol="' + symbol + '"]');
            }
        }
    };

    FuturesView.prototype._requestFuturesCommentary = function () {
        // Construct the URL
        var commentaryUrl = this._constructRenderUrl() + '&renderType=futuresCommentary';

        // Show the spinner
        _Util['default'].sendAction('didStartLoading', this.$futuresCommentary);

        // Refresh the html
        _Util['default'].getHTML(commentaryUrl).done(this.onFetchFuturesCommentaryHTMLComplete.bind(this));
    };

    FuturesView.prototype.onFetchFuturesCommentaryHTMLComplete = function (htmlResult) {
        // Hide the spinner
        _Util['default'].sendAction('didStopLoading', this.$futuresCommentary);
        // Refresh with new content
        this.$futuresCommentary.html(htmlResult);
        this.$futuresCommentary.trigger('attachjs');
    };

    FuturesView.prototype._constructRenderUrl = function () {
        return this.$element.data('renderUrl').replace('category-replace-me', this.$commoditySelect.val());
    };

    FuturesView.prototype.isOverviewSelected = function () {
        return this.$commoditySelect.val() === 'overview';
    };
});
define('views/markets/MarketTrackerView',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var MarketTrackerView = (function (_Component) {
        babelHelpers.inherits(MarketTrackerView, _Component);

        function MarketTrackerView() {
            babelHelpers.classCallCheck(this, MarketTrackerView);
            babelHelpers.get(Object.getPrototypeOf(MarketTrackerView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(MarketTrackerView, [{
            key: 'onSelectChange',
            value: function onSelectChange() {
                this.$images.addClass('isHidden');
                this.$images.filter('[data-crop=' + this.$select.val() + ']').removeClass('isHidden');

                var portletTitle = this.$select.attr('data-config-portlet-title').toLowerCase();
                var commodityName = this.$select.find('option:selected').attr('data-config-commodity-name').toLowerCase();

                _metricsService['default'].commodityEntry(portletTitle, commodityName);

                return false;
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$images', selector: '.js-marketTracker-image' }, { prop: '$select', selector: '.js-marketTracker-select', event: 'change' }];
            }
        }]);
        return MarketTrackerView;
    })(_Component2['default']);

    module.exports = MarketTrackerView;
});
/**
 * This is for the month/year drop downs on the Quotes / Charts page.
 */
define('shared-scripts/models/QuoteFutureMonthModel',['require','jquery'],function (require) {
    
    var $ = require('jquery');

    /**
     *
     */
    function QuoteFutureMonthModel (inHistDropDownModel, isSelected) {
        var self = this;
        self.month = inHistDropDownModel.month;
        self.year = inHistDropDownModel.year;
        self.serial = inHistDropDownModel.serial;
        self.hasChart = inHistDropDownModel.chartAvailable;
        self.hasOptions = inHistDropDownModel.optionsAvailable;
        self.selectValue = inHistDropDownModel.selectValue;
        self.selectText = inHistDropDownModel.selectText;
        self.isSelected = isSelected;
        self.serialOptionsSymbol = inHistDropDownModel.serialOptionsSymbol;
        self.description = inHistDropDownModel.description;


        self.populateSelector = function ($monthSelector) {
            var selText = '';
            if (self.isSelected) {
                selText = 'selected';
            }
            $monthSelector.append(
                $('<option value=' + self.selectValue + ' '+selText+'>' + self.selectText + '</option>')
            );
        };
    }


    return QuoteFutureMonthModel;
});

/**
 * This is for the month/year drop downs on the Quotes / Charts page.
 */
define('shared-scripts/models/QuoteChartDropDownModel',['require','jquery'],function (require) {
    
    var $ = require('jquery');

    /**
     *
     */
    function QuoteChartDropDownModel ($selector, $previousLink, $nextLink) {
        var self = this;

        self.selector = $selector;
        self.previousLink = $previousLink;
        self.nextLink = $nextLink;
        self.optModelArray = [];

        /**
         * Append a drop down value, stored in the QuoteFutureMonthModel
         */
        self.appendOption = function (quoteFutureMonthModel) {
            var selText = '';
            if (quoteFutureMonthModel.isSelected) {
                selText = 'selected';
            }
            self.selector.append($('<option value=' + quoteFutureMonthModel.selectValue + ' '+selText+'>' +
                quoteFutureMonthModel.selectText + '</option>'));
            self.optModelArray.push(quoteFutureMonthModel);
        };

        self.clickNext = function () {
            self.selector[0].selectedIndex++;
            self.updateNextPreviousVisibility();
        };

        self.clickPrevious = function () {
            self.selector[0].selectedIndex--;
            self.updateNextPreviousVisibility();
        };

        self.updateNextPreviousVisibility = function () {
            if (self.selector.length > 0 && self.selector[0].selectedIndex > 0) {
                self.previousLink.show();
            } else {
                self.previousLink.hide();
            }
            if (self.selector.length > 0 && self.selector[0].selectedIndex < (self.selector[0].length - 1)) {
                self.nextLink.show();
            } else {
                self.nextLink.hide();
            }
        };

        /**
         * Returns the selected QuoteFutureMonthModel
         */
        self.getSelectedFutureMonthModel = function () {
            var selectedMonthYear = self.getIndexedValue();
            for (var i = 0; i < self.optModelArray.length; i++) {
                if (self.optModelArray[i].selectValue === selectedMonthYear) {
                    return self.optModelArray[i];
                }
            }
        };

        /**
         * Set the month-year value
         */
        self.setValue = function (inVal) {
            self.selector.val(inVal);
            self.updateNextPreviousVisibility();
        };

        self.getValue = function () {
            return self.selector.val();
        };

        self.getIndexedValue = function () {

            var indx = self.selector.length > 0 ? self.selector[0].selectedIndex : 0;

            // This frist time the page loads, the selected index is -1. We want to use the first value (0)
            if (indx < 0) {
                indx = 0;
            }
            return self.selector.length > 0 && self.selector[0].options.length ? self.selector[0].options[indx].value : null;
        };

        /**
         * Return the populate url
         */
        self.getDataUrl = function () {
            return self.selector.attr('data-url');
        };

        self.clearOptions = function () {
            self.selector.find('option').remove();
            self.optModelArray = [];
        };
    }

    return QuoteChartDropDownModel;
});

/**
 * This is for the checkboxes on the QuotesCharts page. Each checkbox is a "study" that can be applied
 * to the chart that gets painted on the screen.
 */
define('shared-scripts/models/QuoteChartStudiesModel',['require'],function (require) {
    

    /**
     *
     */
    function QuoteChartStudiesModel() {
        var self = this;

        self.volOpenChkSel = '.js-quotes-charts-chk-vol-open';
        self.sloStoChkSel = '.js-quotes-charts-chk-slow-sto';
        self.dmiChkSel = '.js-quotes-charts-chk-dmi';
        self.truRangeChkSel = '.js-quotes-charts-chk-avg-tru-range';
        self.mfiChkSel = '.js-quotes-charts-chk-mfi';
        self.fastStoChkSel = '.js-quotes-charts-chk-fast-sto';
        self.macdChkSel = '.js-quotes-charts-chk-macd';
        self.accumDistChkSel = '.js-quotes-charts-chk-accum-dist';
        self.obvSel = '.js-quotes-charts-chk-obv';
        self.rocSel = '.js-quotes-charts-chk-roc';
        self.adxSel = '.js-quotes-charts-chk-adx';
        self.rsiSel = '.js-quotes-charts-chk-rsi';
        self.cciSel = '.js-quotes-charts-chk-cci';
        self.percentRSel = '.js-quotes-charts-chk-percentr';
        self.momentumSel = '.js-quotes-charts-chk-momentum';
        self.bollingerSel = '.js-quotes-charts-chk-boll-bands';
        self.smaSel = '.js-quotes-charts-chk-sma';
        self.emaSel = '.js-quotes-charts-chk-ema';

        /**
         * Get the object values with regards to the study checkboxes
         */
        self.getFormValues = function ($container) {
            var params = {
                atr: $container.find(self.truRangeChkSel).is(':checked'),
                adi: $container.find(self.accumDistChkSel).is(':checked'),
                sma: $container.find(self.smaSel).is(':checked'),
                bollinger: $container.find(self.bollingerSel).is(':checked'),
                volume: $container.find(self.volOpenChkSel).is(':checked'),
                openInterest: $container.find(self.volOpenChkSel).is(':checked'),
                dmi: $container.find(self.dmiChkSel).is(':checked'),
                fastStochastic: $container.find(self.fastStoChkSel).is(':checked'),
                slowStochastic: $container.find(self.sloStoChkSel).is(':checked'),
                macd: $container.find(self.macdChkSel).is(':checked'),
                ema: $container.find(self.emaSel).is(':checked'),
                mfi: $container.find(self.mfiChkSel).is(':checked'),
                obv: $container.find(self.obvSel).is(':checked'),
                roc: $container.find(self.rocSel).is(':checked'),
                adx: $container.find(self.adxSel).is(':checked'),
                rsi: $container.find(self.rsiSel).is(':checked'),
                cci: $container.find(self.cciSel).is(':checked'),
                percentR: $container.find(self.percentRSel).is(':checked'),
                momentum: $container.find(self.momentumSel).is(':checked')
            };
            return params;
        };

        /**
         * This is weak, I know, I should have created a map and iterated through it
         * with all the values. Sue me.
         *
         * The user should be allowed to select and save 2 Stack Studies.
         * The user should be allowed to select and save 2 Overlay Studies.
         * Volume/Open? Interest should be saved if selected but not counted as a Stack or Overlay Study.
         * So there could be up to 5 studies selected and saved, IF Volume/Open? Interest is selected.
         */
        self.getCountOfChecked = function ($container) {

            var overlayCount = 0;
            var stackCount = 0;

            // VOLUME / OPEN INTEREST DOES NOT COUNT
            //            if ($container.find(self.volOpenChkSel).is(':checked')) {
//                // this one doesn't count against our total.
//            }

            ///// OVERLAY STUDIES BELOW /////
            if ($container.find(self.emaSel).is(':checked')) {
                overlayCount++;
            }
            if ($container.find(self.smaSel).is(':checked')) {
                overlayCount++;
            }
            if ($container.find(self.bollingerSel).is(':checked')) {
                overlayCount++;
            }


            // STACK STUDIES BELOW
            if ($container.find(self.truRangeChkSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.accumDistChkSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.dmiChkSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.fastStoChkSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.sloStoChkSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.macdChkSel).is(':checked')) {
                stackCount++;
            }
            if ($container.find(self.mfiChkSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.obvSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.rocSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.adxSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.rsiSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.cciSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.percentRSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            if ($container.find(self.momentumSel).is(':checked')) {
                // STACK STUDY
                stackCount++;
            }
            return  {
                overlayCount: overlayCount,
                stackCount: stackCount
            };
        };

    }

    return QuoteChartStudiesModel;
});

/* jshint indent:false */
define('shared-scripts/models/TooltipModel',['require','jquery'],function (require) {
    
    var $ = require('jquery');

    var TOOLTIP_SPACING = 16;

    var TooltipModel = function (element) {
        this.$element = element;
        this.$pageContent = $('#content');
        this.$content = this.$element.find('.js-tooltip-content');
        this.$tooltipTrigger = this.$element.find('.js-tooltip-trigger');
        this.$portletBoundary = this.$element.parents('.portlet-boundary');
        this.triggerHeight = this.$tooltipTrigger.outerHeight();
        this.triggerWidth = this.$tooltipTrigger.outerWidth();
    };


    TooltipModel.prototype.openTooltip = function (offsetLeft, offsetTop, autoCloseDuration) {

        // Check if z-index on boundary has already been modified by something else
        this.cssLocked = this.$portletBoundary.css('z-index') >= 0;

        var tooltipDirection = this.getTooltipDirection(offsetLeft, offsetTop);

        // add the correct direction class to the tooltip
        this.tooltipClass = 'tooltip-content_' + tooltipDirection;
        this.$content.addClass(this.tooltipClass);

        // get and set position of the tooltip
        var tooltipPosition = this.getTooltipPosition(tooltipDirection);
        this.positionTooltip(tooltipPosition.top, tooltipPosition.left);

        this.$element.addClass('isActive');

        // bring this container above all other portlets on the page
        // to prevent tooltip from being clipped
        if (!this.cssLocked) {
            this.$portletBoundary.css({
                'position': 'relative',
                'z-index': '1'
            });
        }

        // If auto close duration is included, set a timeout to close the tooltip
        clearTimeout(this.autoCloseTimeout);
        if (autoCloseDuration) {
            this.autoCloseTimeout = setTimeout(function (){
                this.closeTooltip();
            }.bind(this), autoCloseDuration);
        }
    };

    TooltipModel.prototype.getTooltipDirection = function (offsetLeft, offsetTop) {
        // tooltip size
        var size = {
            width: this.$content.outerWidth(),
            height: this.$content.outerHeight()
        };

        var tooltipDirection = '';

        // position tooltip top
        if (offsetTop + this.triggerHeight + size.height > this.$pageContent.height) {
            tooltipDirection = 't';
        }

        // position tooltip bottom
        if ((offsetTop - this.$pageContent.offset().top) - this.triggerHeight - TOOLTIP_SPACING < size.height) {
            tooltipDirection = 'b';
        }

        // position tooltip left
        if ($(window).width() < offsetLeft + (size.width / 2) + this.triggerWidth) {
            tooltipDirection += 'l';
        }

        // position tooltip right
        if (offsetLeft < (size.width / 2) + this.triggerWidth) {
            tooltipDirection += 'r';
        }

        // default to top if special positioning is not required
        if (tooltipDirection === '') {
            tooltipDirection = 't';
        }

        return tooltipDirection;

    };

    TooltipModel.prototype.getTooltipPosition = function (position) {
        var verticalTop = (-this.$content.outerHeight() - this.triggerHeight) - TOOLTIP_SPACING;
        var verticalBottom = this.triggerHeight;
        var verticalMiddle = (-this.$content.outerHeight() - this.triggerHeight) / 2;
        var horizontalLeft = -this.$content.width();
        var horizontalRight = 0;
        var horizontalMiddle = -this.$content.outerWidth() / 2;
        var tooltipPosition = {
            top: 0,
            left: 0
        };

        switch (position) {
            case 'tl':
                tooltipPosition.top = verticalTop;
                tooltipPosition.left = horizontalLeft;
                break;
            case 'tr':
                tooltipPosition.top = verticalTop;
                tooltipPosition.left = horizontalRight;
                break;
            case 'bl':
                tooltipPosition.top = verticalBottom;
                tooltipPosition.left = horizontalLeft;
                break;
            case 'br':
                tooltipPosition.top = verticalBottom;
                tooltipPosition.left = horizontalRight;
                break;
            case 'l':
                tooltipPosition.top = verticalMiddle;
                tooltipPosition.left = -this.$content.outerWidth() - TOOLTIP_SPACING;
                break;
            case 'r':
                tooltipPosition.top = verticalMiddle;
                tooltipPosition.left = this.triggerWidth + TOOLTIP_SPACING;
                break;
            case 'b':
                tooltipPosition.top = verticalBottom;
                tooltipPosition.left = horizontalMiddle;
                break;
            default:
                // defaults to top
                tooltipPosition.top = verticalTop;
                tooltipPosition.left = horizontalMiddle;
                break;
        }

        return tooltipPosition;

    };

    TooltipModel.prototype.positionTooltip = function (top, left) {
        this.$content.css({
            'top': top,
            'left': left
        });
    };

    TooltipModel.prototype.replaceContent = function (content) {
        this.$content.html(content);
        if (this.tooltipClass) {
            this.$content.removeClass(this.tooltipClass);
        }
    };

    TooltipModel.prototype.closeTooltip = function () {
        this.$element.removeClass('isActive');
        this.$content.removeClass(this.tooltipClass);

        // brings the portlet back to initial z-index
        if (!this.cssLocked) {
            this.$portletBoundary.css({
                'position': 'static',
                'z-index': 'initial'
            });
        }

        this.$content.attr('style', '');
    };

    return TooltipModel;

});
define('shared-scripts/lib/CsrfUtil',['exports', 'lib/Util'], function (exports, _libUtil) {
  

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _Util = babelHelpers.interopRequireDefault(_libUtil);

  var token = _Util['default'].getStoredValue('tokenUUID');
  exports.token = token;
});
define('shared-scripts/lib-thirdparty/mout/queryString/setParam',[],function () {

    /**
     * Set query string parameter value
     */
    function setParam(url, paramName, value){
        url = url || '';

        var re = new RegExp('(\\?|&)'+ paramName +'=[^&]*' );
        var param = paramName +'='+ encodeURIComponent( value );

        if ( re.test(url) ) {
            return url.replace(re, '$1'+ param);
        } else {
            if (url.indexOf('?') === -1) {
                url += '?';
            }
            if (url.indexOf('=') !== -1) {
                url += '&';
            }
            return url + param;
        }

    }

    return setParam;

});

/**
 * @author Matt Dowell
 * @file QuotesChartView module definition. This component is used in
 *       the Quotes Charts & Options section
 */
define('shared-scripts/views/markets/QuotesChartView',['require','shared-scripts/components/BaseComponent','jquery','shared-scripts/lib/Util','knockout','moment','shared-scripts/models/QuoteFutureMonthModel','shared-scripts/models/QuoteChartDropDownModel','shared-scripts/models/QuoteChartStudiesModel','shared-scripts/models/TooltipModel','shared-scripts/lib/CsrfUtil','shared-scripts/lib-thirdparty/mout/queryString/setParam'],function (require) {
    

    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var $ = require('jquery');
    var Util = require('shared-scripts/lib/Util');
    var ko = require('knockout');
    var moment = require('moment');
    var QuoteFutureMonthModel = require('shared-scripts/models/QuoteFutureMonthModel');
    var QuoteChartDropDownModel = require('shared-scripts/models/QuoteChartDropDownModel');
    var QuoteChartStudiesModel = require('shared-scripts/models/QuoteChartStudiesModel');
    var chartImageMapId = 'quotesChartViewCallbacks-imageMap';
    var TooltipModel = require('shared-scripts/models/TooltipModel');
    var csrfToken = require('shared-scripts/lib/CsrfUtil').token;
    var setQueryParam = require('shared-scripts/lib-thirdparty/mout/queryString/setParam');

    /**
     * QuotesChartView
     *
     * @class QuotesChartView
     * @constructor
     * @extends BaseComponent
     */
    var QuotesChartView = function ($element, browserDetect) {
        /**
         * The container element for this component.
         *
         * @property $element
         * @type {jQuery}
         */
        this.$element = $element;

        /**
         * Feature detection object
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        this.init();
    };

    // call parent constructor
    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    QuotesChartView.isSafeToCallDestroy = false;
    QuotesChartView.id = 'QuotesChartView';
    QuotesChartView.prototype = new BaseComponent(QuotesChartView);
    QuotesChartView.prototype.constructor = QuotesChartView;

    // ////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    // ////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Create any child objects or references to DOM elements Should only be run
     * on initialization of the view.
     *
     * @chainable
     * @method onCreateChildren
     */
    QuotesChartView.prototype.onCreateChildren = function () {
        this.$redrawChartBtn = this.$element.find('.js-quotes-charts-redraw-chart-btn');
        this.$redrawHistBtn = this.$element.find('.js-quotes-charts-redraw-hist-btn');
        this.$histApplyBtn = this.$element.find('.js-quotes-hist-apply-btn');
        this.$applyBtn = this.$element.find('.js-quotes-charts-apply-btn');

        this.$saveDefaultsBtn = this.$element.find('.js-quotes-charts-save-defaults-btn');
        this.$saveDefaultsMsg = this.$element.find('.js-quotes-charts-save-defaults-msg');

        this.$intervalSel = this.$element.find('.js-quotes-charts-select-interval');
        this.$durationSel = this.$element.find('.js-quotes-charts-select-duration');
        this.$chartTypeSel = this.$element.find('.js-quotes-charts-select-type');

        // Strike Range, All or Few
        this.$strikeRange = this.$element.find('.js-quotes-options-strike-range');

        // MONTH Selector OPTIONS
        this.$monthSelOptions = this.$element.find('.js-quotes-options-month-select');
        this.$previousMonthOptBtn = this.$element.find('.js-quotes-options-previous-month');
        this.$nextMonthOptBtn = this.$element.find('.js-quotes-options-next-month');
        this.optionsDropDownModel = new QuoteChartDropDownModel(
            this.$monthSelOptions,
            this.$previousMonthOptBtn,
            this.$nextMonthOptBtn
        );

        // Month selector CHARTS
        this.$chartMonthSel = this.$element.find('.js-quotes-charts-month-select');
        this.$previousMonthChartBtn = this.$element.find('.js-quotes-charts-previous-month');
        this.$nextMonthChartBtn = this.$element.find('.js-quotes-charts-next-month');
        this.chartDropDownModel = new QuoteChartDropDownModel(
            this.$chartMonthSel,
            this.$previousMonthChartBtn,
            this.$nextMonthChartBtn
        );

        // Hist
        this.$previousMonthHistBtn = this.$element.find('.js-quotes-hist-previous-month');
        this.$nextMonthHistBtn = this.$element.find('.js-quotes-hist-next-month');
        this.$histMonthSel = this.$element.find('.js-quotes-hist-month-select');
        this.$histRedrawBtn = this.$element.find('.js-quotes-hist-redraw-hist-btn');

        this.viewSel = '.js-chart-view';
        this.$allViews = this.$element.find(this.viewSel);

        this.$chartImage = this.$element.find('.js-quotes-charts-chart-img');
        this.$historicalChartImage = this.$element.find('.js-quotes-hist-chart-img');
        this.$header = this.$element.find('.js-quotes-charts-symbol-header');

        // Hidden Fields
        this.$symbol = this.$element.find('.js-quotes-charts-symbol-value');
        this.serialOptionsSymbol = this.$element.find('.js-quotes-charts-serial-options-symbol').val();
        this.serialMonth = this.$element.find('.js-quotes-charts-month-value').val();
        this.isSerial = this.$element.find('.js-quotes-charts-serial').val();
        this.$rootSymbol = this.$element.find('.js-quotes-charts-rootsymbol-value');
        this.$month = this.$element.find('.js-quotes-charts-month-value');
        this.$year = this.$element.find('.js-quotes-charts-year-value');
        this.$exchangeDesc = this.$element.find('.js-quotes-charts-exchange-value');
        this.$exchangeId = this.$element.find('.js-quotes-charts-exchange-id-value');
        this.$symbolType = this.$element.find('.js-quotes-charts-symbol-type-value');
        this.$form = this.$element.find('.js-quotes-charts-form');
        this.$selectedMonthYear = this.$element.find('.js-quotes-charts-selected-month-year');
        this.$selectedInterval = this.$element.find('.js-quotes-charts-selected-interval-def');
        this.$selectedDuration = this.$element.find('.js-quotes-charts-selected-duration-def');

        // Symbol or name search
        this.$searchTypeSelect = this.$element.find('.js-change-symbol-search-type');
        this.$noDataMsg = this.$element.find('.js-change-symbol-no-data-msg');

        this.symbolModel = null;
        this.suggestModel = null;
        this.optionsModel = null;
        this.contractModel = null;
        this.intervalDurationModel = null;

        // This var holds on to the previous value in case no data is found for
        // the new one
        this.previousSymbolValue = null;

        // SYMBOL DETAILS
        this.$refreshBtn = this.$element.find('.js-quotes-symbol-details-refresh-btn');

        // Links and Tabs
        this.$spreadTag = this.$element.find('.js-quotes-symbol-details-spread-link');
        this.$futuresTag = this.$element.find('.js-quotes-symbol-details-futures-link');
        this.$optionsTab = this.$element.find('.js-quotes-charts-symbol-options-nav');
        this.$historicalTab = this.$element.find('.js-quotes-charts-symbol-historical-nav');

        // Chart and options containers
        this.$chartImgContainer = this.$element.find('.js-quotes-charts-chart-img-container');
        this.$historicalChartImgContainer = this.$element.find('.js-quotes-charts-historical-chart-img-container');
        this.$optionsTabContainer = this.$element.find('.js-quotes-options-table-container');

        // TAB URL's
        this.$optionsTabURl = this.$element.find('.js-quotes-charts-options-data-url');

        this.$noOptionsDataMsg = this.$element.find('.js-quotes-options-no-data-msg');

        // content for flipping position of content in mobile
        this.$chartOptionsContainer = this.$element.find('.js-charts-options');
        this.$mobileChartOptions = this.$chartOptionsContainer.filter('[data-chart-options-layout=mobile]');
        this.$desktopChartOptions = this.$chartOptionsContainer.filter('[data-chart-options-layout=desktop]');

        this.quoteChartStudiesModel = new QuoteChartStudiesModel();

        this.$expDays = this.$element.find('.js-quotes-exp-days');

        this.monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];

        return this;
    };

    /**
     * Removes any child objects or references to DOM elements.
     *
     * @chainable
     * @method onRemoveChildren
     */
    QuotesChartView.prototype.onRemoveChildren = function () {
        this.$redrawChartBtn = null;
        this.$applyBtn = null;
        this.$saveDefaultsBtn = null;
        this.$previousMonthChartBtn = null;
        this.$nextMonthChartBtn = null;
        this.$previousMonthOptBtn = null;
        this.$nextMonthOptBtn = null;
        this.$chartImage = null;
        this.$historicalChartImage = null;
        this.$symbol = null;
        this.serialOptionsSymbol = null;
        this.isSerial = null;
        this.$rootSymbol = null;
        this.$header = null;
        this.$strikeRange = null;
        this.$searchTypeSelect = null;
        this.$spreadTag = null;
        this.$futuresTag = null;
        this.$chartContainer = null;
        this.previousSymbolValue = null;
        this.$noOptionsDataMsg = null;
        this.$optionsTab = null;
        this.$historicalTab = null;
        this.$allViews = null;
        this.$selectedMonthYear = null;
        this.$selectedInterval = null;
        this.$selectedDuration = null;

        // Models
        this.symbolModel = null;
        this.suggestModel = null;
        this.optionsModel = null;
        this.contractModel = null;

        // Spinners

        this.$chartOptionsContainer = null;

        return this;
    };

    /**
     * Enables the component Performs any event binding to handlers Does not
     * execute if component is already enabled.
     *
     * @chainable
     * @method onEnable
     */
    QuotesChartView.prototype.onEnable = function () {
        this.onMapHandlers();
        this.onInitialLoadOfPage();
    };

    /**
     * On map handlers handler
     *
     * @chainable
     * @method onMapHandlers
     */
    QuotesChartView.prototype.onMapHandlers = function () {
        $(window).on('symbolWasPicked.QuoteSearch', this.onSymbolWasPickedHandler);

        // These two get the details and redraw the chart
        this.$refreshBtn.on('click.QuotesChartView', this.redrawChartHandler);

        // These two redraw the chart only
        this.$redrawChartBtn.on('click.QuotesChartView', this.redrawChartHandler);
        this.$applyBtn.on('click.QuotesChartView', this.redrawChartHandler);
        this.$redrawHistBtn.on('click.QuotesChartView', this.redrawChartHandler);
        this.$histApplyBtn.on('click.QuotesChartView', this.redrawChartHandler);
        this.$histRedrawBtn.on('click.QuotesChartView', this.redrawChartHandler);

        // Persist the defaults to the database
        this.$saveDefaultsBtn.on('click.QuotesChartView', this.onSaveDefaultsHandler);

        // Next and Previous Buttons
        this.$previousMonthChartBtn.on('click.QuotesChartView', this.onPreviousMonthChartHandler);
        this.$nextMonthChartBtn.on('click.QuotesChartView', this.onNextMonthChartHandler);
        this.$chartMonthSel.on('change.QuotesChartView', this.onChangeMonthYearChartHandler);

        this.$previousMonthOptBtn.on('click.QuotesChartView', this.onPreviousMonthOptionsHandler);
        this.$nextMonthOptBtn.on('click.QuotesChartView', this.onNextMonthOptionsHandler);

        // Month selector for options
        this.$monthSelOptions.on('change.QuotesChartView', this.onSelectOptionMonthHandler);

        // Strike Range
        this.$strikeRange.on('change.QuotesChartView', this.onStrikeRangeHandler);

        // Interval - duration select
        if (this.currentBreakpoint === window.dtnGlobals.breakpointType.MOBILE) {
            this.$intervalSel.on('change.QuotesChartView', this.onIntervalSelectHandlerTouch);
        } else {
            this.$intervalSel.on('change.QuotesChartView', this.onIntervalSelectHandler);
        }

        // Duration - duration select
        if (this.currentBreakpoint === window.dtnGlobals.breakpointType.MOBILE) {
            this.$durationSel.on('change.QuotesChartView', this.onDurationSelectHandlerTouch);
        }

        // Type - duration select
        if (this.currentBreakpoint === window.dtnGlobals.breakpointType.MOBILE) {
            this.$chartTypeSel.on('change.QuotesChartView', this.onChartTypeSelectHandlerTouch);
        }

        this.$spreadTag.on('click.QuotesChartView', this.onClickOptionsTab);
        this.$futuresTag.on('click.QuotesChartView', this.onClickOptionsTab);

        return this;
    };

    /**
     * Binds the scope of any handler functions Should only be run on
     * initialization of the view.
     *
     * @chainable
     * @method onSetupHandlers
     */
    QuotesChartView.prototype.onSetupHandlers = function () {

        this.onSymbolWasPickedHandler = this.onSymbolWasPicked.bind(this);
        this.onSaveDefaultsHandler = this.saveDefaults.bind(this);
        this.goButtonHandler = this.userClicksGoButton.bind(this);
        // User wants to redraw the chart
        this.redrawChartHandler = this.userClicksRedrawChartButtons.bind(this);

        // Previous and next CHARTS
        this.onPreviousMonthChartHandler = this.userClicksChartPreviousMonthButton.bind(this);
        this.onNextMonthChartHandler = this.userClicksChartNextMonthButton.bind(this);
        this.onChangeMonthYearChartHandler = this.userChangesChartMonthYearSelect.bind(this);

        // Selections on OPTIONS
        this.onPreviousMonthOptionsHandler = this.userClicksOptPreviousMonthButton.bind(this);
        this.onNextMonthOptionsHandler = this.userClicksOptNextMonthButton.bind(this);
        this.onStrikeRangeHandler = this.updateOptionsDisplay.bind(this);
        this.onSelectOptionMonthHandler = this.onUserSelectsOptionMonth.bind(this);

        // Options tab click handler
        this.onClickOptionsTab = this.userClicksOptionsTab.bind(this);

        // Interval select handler
        this.onIntervalSelectHandler = this.populateDurationsBasedOnInterval.bind(this);
        this.onIntervalSelectHandlerTouch = this.populateDurationsBasedOnIntervalTouch.bind(this);

        // Duration select Handler
        this.onDurationSelectHandlerTouch = this.handleDurationSelectTouch.bind(this);

        // Type select handler
        this.onChartTypeSelectHandlerTouch = this.handleChartTypeSelectTouch.bind(this);

        return this;
    };

    /**
     * Disables the component Tears down any event binding to handlers.
     * Does not execute if component is already disabled.
     *
     * @chainable
     * @method onDisable
     */
    QuotesChartView.prototype.onDisable = function () {
        // Tear down any event handlers
        $(window).off('symbolWasPicked.QuoteSearch', this.onSymbolWasPickedHandler);
        this.$refreshBtn.off('click.QuotesChartView', this.redrawChartHandler);
        this.$redrawChartBtn.off('click.QuotesChartView', this.redrawChartHandler);
        this.$applyBtn.off('click.QuotesChartView', this.redrawChartHandler);
        this.$redrawHistBtn.off('click.QuotesChartView', this.redrawChartHandler);
        this.$histApplyBtn.off('click.QuotesChartView', this.redrawChartHandler);
        this.$histRedrawBtn.off('click.QuotesChartView', this.redrawChartHandler);
        this.$saveDefaultsBtn.off('click.QuotesChartView', this.onSaveDefaultsHandler);
        this.$previousMonthChartBtn.off('click.QuotesChartView', this.onPreviousMonthChartHandler);
        this.$nextMonthChartBtn.off('click.QuotesChartView', this.onNextMonthChartHandler);
        this.$chartMonthSel.off('change.QuotesChartView', this.onChangeMonthYearChartHandler);
        this.$previousMonthOptBtn.off('click.QuotesChartView', this.onPreviousMonthOptionsHandler);
        this.$nextMonthOptBtn.off('click.QuotesChartView', this.onNextMonthOptionsHandler);
        this.$previousMonthHistBtn.off('click.QuotesChartView', this.onPreviousMonthHistHandler);
        this.$nextMonthHistBtn.off('click.QuotesChartView', this.onNextMonthHistHandler);
        this.$histMonthSel.off('change.QuotesChartView', this.onChangeMonthYearHistHandler);
        this.$strikeRange.off('change.QuotesChartView', this.onStrikeRangeHandler);
        this.$intervalSel.off('change.QuotesChartView', this.onIntervalSelectHandler);
        this.$intervalSel.off('change.QuotesChartView', this.onIntervalSelectHandlerTouch);
        this.$intervalSel.off('change.QuotesChartView', this.onDurationSelectHandlerTouch);
        this.$intervalSel.off('change.QuotesChartView', this.onChartTypeSelectHandlerTouch);
        this.$spreadTag.off('click.QuotesChartView', this.onClickOptionsTab);
        this.$futuresTag.off('click.QuotesChartView', this.onClickOptionsTab);
        this.$monthSelOptions.off('change.QuotesChartView', this.onSelectOptionMonthHandler);
        return this;
    };

    /**
     * Destroys the component.
     * Assume that onDisable() and onRemoveChildren() are called prior to this.
     * Should be called when the object should be left unused.
     *
     * @chainable
     * @method onDestroy
     */
    QuotesChartView.prototype.onDestroy = function () {
        // Clear any timeouts, etc.
        this.$element = null;
        return this;
    };

    // ////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    // ////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * On mobile exit handler
     *
     * @method onMobileExit
     */
    QuotesChartView.prototype.onMobileExit = function (e) {
        this.mobileMode = false;
        // Move the DOM elements back to the desktop position
        this.$mobileChartOptions.children().detach().appendTo(this.$desktopChartOptions);

        // Turn off the mobile handlers
        this.$intervalSel.off('change.QuotesChartView', this.onIntervalSelectHandlerTouch);
        this.$durationSel.off('change.QuotesChartView', this.onDurationSelectHandlerTouch);
        this.$chartTypeSel.off('change.QuotesChartView', this.onChartTypeSelectHandlerTouch);

        // Turn on the desktop handlers
        this.$intervalSel.on('change.QuotesChartView', this.onIntervalSelectHandler);
        this.$redrawChartBtn.on('click.QuotesChartView', this.redrawChartHandler);
    };

    /**
     * On mobile enter handler
     *
     * @method onMobileEnter
     */
    QuotesChartView.prototype.onMobileEnter = function (e) {
        this.mobileMode = true;
        this.$desktopChartOptions.children().detach().appendTo(this.$mobileChartOptions);

        // Turn off the desktop handlers
        this.$intervalSel.off('change.QuotesChartView', this.onIntervalSelectHandler);
        this.$redrawChartBtn.off('click.QuotesChartView', this.redrawChartHandler);

        // Turn on the mobile handlers
        this.$intervalSel.on('change.QuotesChartView', this.onIntervalSelectHandlerTouch);
        this.$durationSel.on('change.QuotesChartView', this.onDurationSelectHandlerTouch);
        this.$chartTypeSel.on('change.QuotesChartView', this.onChartTypeSelectHandlerTouch);
    };

    // ///////////////////////////////////////////////////////
    // / HELPERS
    // ///////////////////////////////////////////////////////

    /**
     * A symbol was picked from the QuoteSearch portlet. exchangeId:
     * future.exchangeId, month: future.month, symbol: future.symbol, year:
     * future.year.
     *
     * @method onSymbolWasPicked
     * @param {Event} event
     * @param {object} data
     */
    QuotesChartView.prototype.onSymbolWasPicked = function (event, data) {
        this.startSpinner();
        // Hold on to the old value
        this.previousSymbolValue = this.$symbol.val();

        if (data.exchangeId) {
            this.$exchangeId.val(data.exchangeId);
        }
        if (data.month) {
            this.$month.val(data.month);

        }
        // Appanrently, the user can specify the month as well... i.e.
        // @C@2 (so, if the second to last
        // Set to Jan if no month speficied
        // Except, that is not the month. That is the future chain month,
        // meaning
        // the X'th link down the future chain. So do we set the month here
        // or not?. No apparently. The service handles it.

        if (data.year) {
            this.$year.val(data.year);
        } else {
            // Set to current year if no year specified by user
            this.$year.val(new Date().getFullYear());
        }

        this.$symbol.val(data.symbol);
        this.isSerial = false;

        this.userClicksGoButton(event);

        if (data.type === 'future') {
            $('.js-quotes-charts-symbol-options-nav').click();
        }
    };

    /**
     * Set selected month and years.
     *
     * @method setSelectedMonthYears
     */
    QuotesChartView.prototype.setSelectedMonthYears = function () {
        var moYa = '';

        if (this.isSerial) {
            moYa = this.serialMonth + '_' + this.$year.val();
        } else {
            moYa = this.$month.val() + '_' + this.$year.val();
        }
        this.$selectedMonthYear.val(moYa);

        // Set the value on the drop downs.
        this.optionsDropDownModel.setValue(moYa);

        if (this.isSerial) {
            // There are no serial months on the chart drop down, soo...
            moYa = this.$month.val() + '_' + this.$year.val();
            // set the month year to previous value?
        }
        this.chartDropDownModel.setValue(moYa);
    };

    /**
     * Build month char model.
     *
     * @method buildMonthCharModel
     */
    QuotesChartView.prototype.buildMonthCharModel = function () {
        this.monthFutureCodeModel = {
            '1': 'F', // January
            '2': 'G', // February

            '3': 'H', // Etc..
            '4': 'J',
            '5': 'K',
            '6': 'M',
            '7': 'N',
            '8': 'Q',
            '9': 'U',
            '10': 'V',
            '11': 'X',
            '12': 'Z'
        };
    };

    /**
     * This method makes the call to the server to get the interval duration
     * map.
     */
    QuotesChartView.prototype.getIntervalDurationStruct = function () {
        var url = this.$intervalSel.attr('data-url');

        Util.getJSON(url)
            .done(this.populateIntervalDurationStruct.bind(this))
            .fail(this.handleFailure.bind(this));
    };

    /**
     * This method makes the call to the server to get the month_year
     * combination drop-down
     */
    QuotesChartView.prototype.getMonthYearDropDownValues = function (monthSelectorMod) {
        var d = $.Deferred();
        var url = monthSelectorMod.getDataUrl();

        if (url !== void 0) {
            //TODO: pass these in as second params argument instead to getJSON()
            url = url + '&exchangeId=' + this.$exchangeId.val() + '&rootSymbol=' + this.$rootSymbol.val();

            Util.getJSON(url)
                .done(function (json) {
                    d.resolve(json);
                    // self.populateMonthYearDropDownValues(monthSelectorMod, json);
                });

            // .fail(this.handleFailure.bind(this));
        } else {
            d.resolve('');
        }

        return d.promise();
    };

    QuotesChartView.prototype.populateMonthYearDropDownValues = function (monthSelectorMod, data) {
        // Clear all the existing options
        monthSelectorMod.clearOptions();

        var isSelected = false;
        var selectedDates = this.$selectedMonthYear.val();

        for (var i = 0; i < data.length; i++) {
            if (selectedDates === data[i].selectValue) {
                isSelected = true;
            } else {
                isSelected = false;
            }

            // Append the option to the drop down model
            var mod = new QuoteFutureMonthModel(data[i], isSelected);
            monthSelectorMod.appendOption(mod);
        }

        // Now set the selected value
        var monthYear = this.$month.val() + '_' + this.$year.val();
        monthSelectorMod.setValue(monthYear);
    };

    /**
     * This method populates the "map"-like structure we will need for
     * populating the intervals and durations.
     *
     * @param data
     */
    QuotesChartView.prototype.populateIntervalDurationStruct = function (data) {
        this.intervalDurationModel = data;
        this.populateDurationsBasedOnInterval();

        // Now set the defaults
        this.$intervalSel.val(this.$selectedInterval.val());
        this.$durationSel.val(this.$selectedDuration.val());
    };

    /**
     * This method populates the duration drop-down based upon the user-selected
     * interval
     *
     * @param inInterval
     */
    QuotesChartView.prototype.populateDurationsBasedOnInterval = function (e) {

        var interval = this.$intervalSel.val();

        // Clear all the existing options
        this.$durationSel.find('option').remove();

        // We first have to loop through all the interval/duration values to
        // match the key
        // with the given interval
        var durationArray = this.intervalDurationModel[interval];

        for (var i = 0; i < durationArray.length; i++) {
            this.$durationSel.append($('<option>' + durationArray[i] + '</option>'));
        }
    };

    /**
     * Update the durations and then redraw the chart based on the new values
     *
     * @param e
     */
    QuotesChartView.prototype.populateDurationsBasedOnIntervalTouch = function (e) {
        this.populateDurationsBasedOnInterval(e);
        this.userClicksRedrawChartButtons(e);
    };

    /**
     * Redraw the chart based on the new values after the durations drop down
     * has changed
     *
     * @param e
     */
    QuotesChartView.prototype.handleDurationSelectTouch = function (e) {
        this.userClicksRedrawChartButtons(e);
    };

    /**
     * Redraw the chart based on the new values after the chart type drop down
     * has changed
     *
     * @param e
     */
    QuotesChartView.prototype.handleChartTypeSelectTouch = function (e) {
        this.userClicksRedrawChartButtons(e);
    };

    /**
     * The user has either clicked REDRAW CHART, or APPLY
     */
    QuotesChartView.prototype.userClicksRedrawChartButtons = function (event) {
        event.preventDefault();
        if (this.checkMaxStudies(event)) {
            return;
        }

        this.startSpinner();
        this.refreshChartUrl();
        // this.refreshHistoricalChartUrl();
    };

    /**
     * A user has clicked the options tab. It is either DISABLED because there
     * was an Equity chosen, or it is enabled because there was a future chosen
     * (and only futures have options)
     */
    QuotesChartView.prototype.userClicksOptionsTab = function (e) {

        // MonthShown == future
        if (this.contractModel.monthShown) {
            return true;
        } else {
            // If our current data model has an Equity, return false.
            return false;
        }
    };

    QuotesChartView.prototype.userClicksChartNextMonthButton = function (e) {
        e.preventDefault();
        this.chartDropDownModel.clickNext();
        this.userChangesChartMonthYearSelect(e);
    };
    QuotesChartView.prototype.userClicksChartPreviousMonthButton = function (e) {
        e.preventDefault();
        this.chartDropDownModel.clickPrevious();
        this.userChangesChartMonthYearSelect(e);
    };
    QuotesChartView.prototype.userChangesChartMonthYearSelect = function (e) {
        e.preventDefault();
        // There are no serial options on the chart selector
        this.isSerial = false;
        this.getNewSymbolFromMonthYear(this.chartDropDownModel);
        this.chartDropDownModel.updateNextPreviousVisibility();
        this.userClicksGoButton(e);
    };

    QuotesChartView.prototype.userClicksOptNextMonthButton = function (e) {
        e.preventDefault();
        this.optionsDropDownModel.clickNext();
        this.onUserSelectsOptionMonth(e);
    };
    QuotesChartView.prototype.userClicksOptPreviousMonthButton = function (e) {
        e.preventDefault();
        this.optionsDropDownModel.clickPrevious();
        this.onUserSelectsOptionMonth(e);
    };

    /**
     * USER CLICKS ON MONTH FROM OPTIONS DROP DOWN. We have to always call this
     * method if it is the Options drop down, because "Serial" months play havoc
     * with the chart screen.
     *
     * @param e
     */
    QuotesChartView.prototype.onUserSelectsOptionMonth = function (e) {
        e.preventDefault();
        this.getNewSymbolFromMonthYear(this.optionsDropDownModel);
        this.determineSerialOptionMonth();
        this.optionsDropDownModel.updateNextPreviousVisibility();
        this.userClicksGoButton(e);
    };

    /**
     * This method determines whether the selected (or 0-indexed month on our
     * first visit) month on the options page is a SERIAL month or not.
     */
    QuotesChartView.prototype.determineSerialOptionMonth = function () {
        var mod = this.optionsDropDownModel.getSelectedFutureMonthModel();
        if (mod && mod.serial) {
            // Change the month to the serial month
            this.serialOptionsSymbol = mod.serialOptionsSymbol;
            this.isSerial = true;
            this.serialMonth = mod.month;
        } else {
            this.serialOptionsSymbol = '';
            this.isSerial = false;
            this.serialMonth = '';
        }
    };

    /**
     * This method parses the month[space]year drop-down value and returns a new
     * symbol (the month and year are in the symbol)
     *
     * Month codes
     * http://www.cmegroup.com/product-codes-listing/month-codes.html
     */
    QuotesChartView.prototype.getNewSymbolFromMonthYear = function (monthDropDownModel) {

        this.previousSymbolValue = this.$symbol.val();

        // Gets the selected index, which is more stable since technically one
        // of the drop down values
        // might not be "selected" by the user, depending on certain situations.
        var inMonthYearDigits = monthDropDownModel.getIndexedValue();

        // Set the new value
        this.$selectedMonthYear.val(inMonthYearDigits);

        // Parse out the month (digit) & year
        var monthYearDigitsArray = inMonthYearDigits.split('_');

        // determine the stock-future month symbol
        var month = monthYearDigitsArray[0];
        var monthDigit = this.monthFutureCodeModel[month];

        // parse the last two year digits
        var year = monthYearDigitsArray[1];

        // Set the hidden year value
        this.$year.val(year);
        this.$month.val(month);

        var twoDigitYear = year.substr(2, 3);

        // set the new symbol (the old symbol, remove the last 3 chars, replace
        // with new monthyear)
        var oldSymbol = this.$symbol.val();
        var endIndex = oldSymbol.length;
        var rootSymbol = oldSymbol.substr(0, (endIndex - 3));

        var newSymbol = rootSymbol + monthDigit + twoDigitYear;
        this.$symbol.val(newSymbol);
    };

    /**
     * The symbol should already be in the SYMBOL box, and now the user clicks
     * the GO button
     *
     * @method onClick
     * @param {Event} e JS Event object
     */
    QuotesChartView.prototype.userClicksGoButton = function (e) {
        e.preventDefault();
        this.fetchSymbolDetails(e);
        return false;
    };

    /**
     * Calls the ajax method to save the default search parameters
     */
    QuotesChartView.prototype.saveDefaults = function (event) {
        event.preventDefault();

        if (this.checkMaxStudies(event)) {
            return;
        }

        var url = this.$saveDefaultsBtn.attr('data-url');

        var params = this.buildFormArray($(event.currentTarget).closest(this.viewSel));

        Util.getJSON(url, params).done(this.showSaveDefaultsSuccess()).fail();
    };

    QuotesChartView.prototype.showSaveDefaultsSuccess = function () {
        this.$saveDefaultsMsg.removeClass('isHidden');
    };

    /**
     * This method is called when a user selects a value from the sugestions
     */
    QuotesChartView.prototype.onInitialLoadOfPage = function (e) {

        this.startSpinner();

        // Populate the interval drop down
        this.getIntervalDurationStruct();

        // Build the month=char model
        this.buildMonthCharModel();

        this.fetchSymbolDetails(e);

        return false;
    };

    /**
     * This method takes all the form elements and returns an array. We have to
     * do it this way because the checkboxes do not get sent as FALSE, and they
     * are just not sent at all, so since we extend a DTN file as part of our
     * model, it has some of the fields set to TRUE by default, and they
     * continue to be set as true. So instead of fixing it at the controller, we
     * just handle it here
     */
    QuotesChartView.prototype.buildFormArray = function ($container) {

        var studiesParams = this.quoteChartStudiesModel.getFormValues($container);

        var chartParams = {
            chart: this.$symbol.val(),
            symbol: this.$symbol.val(),
            serialOptionsSymbol: this.serialOptionsSymbol,
            serialMonth: this.serialMonth,
            serial: this.isSerial,
            rootSymbol: this.$rootSymbol.val(),
            chartMonthYear: this.$chartMonthSel.val(),
            histMonthYear: this.$histMonthSel.val(),
            optMonthYear: this.$monthSelOptions.val(),
            exchange: this.$exchangeDesc.val(),
            exchangeId: this.$exchangeId.val(),
            month: this.$month.val(),
            year: this.$year.val(),
            symbolType: this.$symbolType.val(),
            symbolSearchBy: this.$searchTypeSelect.val(),
            optionsDisplayAll: this.$strikeRange.val(),
            staticChart: '',
            duration: this.$durationSel.val(),
            interval: this.$intervalSel.val(),
            chartType: this.$chartTypeSel.val()
        };

        // this copies both objects in to a new object
        var allParams = $.extend({}, studiesParams, chartParams);

        return allParams;
    };

    QuotesChartView.prototype.checkMaxStudies = function () {

        var countData = this.quoteChartStudiesModel.getCountOfChecked(this.$allViews.first());

        /*
         If more than 2 Stack Studies are selected, "Please select a maximum of 2 optional Stack Studies"
         is displayed immediately if a 3rd Stack Study is selected.
         */
        if (countData.stackCount > 2) {
            window.alert('Please select a maximum of 2 optional Stack Studies');
            this.stopSpinner();
            return true;
        }
        /*
         If more than 2 Overlay Studies are selected, "Please select a maximum of 2 optional Overlay Studies"
         is displayed immediately if a 3rd Overlay Study is selected.
         */
        if (countData.overlayCount > 2) {
            window.alert('Please select a maximum of 2 optional Overlay Studies');
            this.stopSpinner();
            return true;
        }

        return false;
    };

    /**
     * Fetches the symbol details, like last open price, volume, etc..
     *
     * @param event
     * @param symbol
     */
    QuotesChartView.prototype.fetchSymbolDetails = function (event) {

        if (this.checkMaxStudies()) {
            return;
        }

        var url = this.$element.attr('data-url');
        var params;

        // This is likely to come from a button being clicked
        if (event !== undefined) {

            // Symbol search from a button click is allowed only on NORMAL type symbols
            this.$symbolType.val('');

            params = this.buildFormArray($(event.currentTarget));
            Util.getJSON(url, params)
                .done(this.handlePageComponents.bind(this))
                .fail(this.handleFailure.bind(this));

        // This is likely to come from a page transition
        } else {
            // When we have more tabs again (histor) we should change back to
            // EACH instead of FIRST
            // this.$allViews.foreach(function () {
            params = this.buildFormArray(this.$allViews.first());

            Util.getJSON(url, params)
                .done(this.handlePageComponents.bind(this))
                .fail(this.handleFailure.bind(this));
        }
    };

    /**
     * This method takes the data from the displayResultsFunction and broadcasts
     * the new symbol.
     *
     * This method affects multiple sections of the page: - Header - Symbol
     * details - Chart
     *
     * @method showResults
     * @param data
     */
    QuotesChartView.prototype.handlePageComponents = function (data) {
        if (data.symbol === '--') {
            this.$noDataMsg.removeClass('isHidden');
            // Clears the options display
            // this.updateOptionsDisplay();
            this.stopSpinner();
            return;
        }

        this.$noDataMsg.addClass('isHidden');

        this.contractModel = data;

        // Set the header information (symnol / Month / Delay)
        this.setHeader(data);

        // set the symbol details
        this.updateSymbolDisplay(data);

        // Set the chart URL
        this.refreshChartUrl();
        // this.refreshHistoricalChartUrl();

        var self = this;

        // We have to do this with a promise, becuase we need to populate the
        // drop down values
        // and determine if the option drop down value is SERIAL before we
        // update the optinos display.
        // NOTE: The drop downs for the charts/optinos are different
        // Populate the month/year drop downs\
        $.when(
            this.getMonthYearDropDownValues(this.optionsDropDownModel),
            this.getMonthYearDropDownValues(this.chartDropDownModel)
        )
            .done(function (optResult, chartResult) {
                // First, populate the drop downs
                self.populateMonthYearDropDownValues(self.optionsDropDownModel, optResult);
                self.populateMonthYearDropDownValues(self.chartDropDownModel, chartResult);

                // Set the selected month/year
                self.setSelectedMonthYears();

                // Determines if it is a serial month (fake month)
                self.determineSerialOptionMonth();

                // Sets the options calls and puts
                self.updateOptionsDisplay();
            });

        this.$expDays.html(moment(data.expirationDate).diff(moment(), 'days') + ' days');

        if (data.future) {
            this.configurePageForFuture();
        } else if (data.futureOption) {
            this.configurePageForFutureOption();
        } else {
            this.configurePageForEquity();
        }
    };

    /**
     * Sets the symbol/range/delay header.
     * The header should contain: Chart and Options showing the commodity name,
     * month in parenthesis, and delay in brackets.
     *
     * @method setHeader
     * @param {object} data
     */
    QuotesChartView.prototype.setHeader = function (data) {
        var sym = '';

        if (this.isSerial === 'true') {
            sym = this.serialOptionsSymbol;
        } else {
            sym = data.symbol;
        }

        var desc = data.description;

        this.$header.text(sym.toUpperCase() + ' ' + desc + ' [' + data.delay + ']');
    };

    /**
     * Updates the Options CALLS and PUTS
     *
     * @method updateOptionsDisplay
     */
    QuotesChartView.prototype.updateOptionsDisplay = function () {
        // Get the URL
        var url = this.$optionsTabURl.attr('data-url');
        var params = this.buildFormArray(this.$allViews.first());
        this.startSpinner();
        // Make the action call to the controller
        Util.getHTML(url, params)
            .done(this.onFetchOptionsHTMLComplete.bind(this))
            .fail(this.onFetchOptionsHTMLFail.bind(this));
    };

    /**
     * Updates the symbol details section, and sets the symbolModel.
     *
     * @method updateSymbolDisplay
     * @param {object} data
     */
    QuotesChartView.prototype.updateSymbolDisplay = function (data) {
        if (data.length === 0) {
            return;
        }

        // Set the new exchange id key. wtf isgoingonhere?
        this.$exchangeDesc.val(data.exchange);
        this.$exchangeId.val(data.exchangeId);
        this.$rootSymbol.val(data.rootSymbol);
        this.$symbol.val(data.symbol);
        this.$month.val(data.month);
        this.$year.val(data.year);

        if (this.symbolModel === null) {

            this.symbolModel = {
                contract: ko.observable(data)
            };

            ko.applyBindings(this.symbolModel, $('.js-quotes-symbol-details')[0]);

        } else {
            this.symbolModel.contract(data);
        }
    };

    /**
     * On fetch options HTML complete
     *
     * @method onFetchOptionsHTMLComplete
     */
    QuotesChartView.prototype.onFetchOptionsHTMLComplete = function (htmlResult) {
        this.$optionsTabContainer.html(htmlResult);
        $(document.body).trigger('attachjs');
        this.setSelectedMonthYears();
        this.stopSpinner();
    };

    /**
     * On fetch options HTML fail
     *
     * @method onFetchOptionsHTMLFail
     */
    QuotesChartView.prototype.onFetchOptionsHTMLFail = function (jqXHR, textStatus) {
        var errorMessage = 'Error fetching Options HTML: ' + textStatus;
        this.logger.warn('XHR status: ' + jqXHR.status + ' - ' + errorMessage);
        this.stopSpinner();
    };

    /**
     * Builds the URL with the serialized form params, and sets the URL of the
     * image tag, which triggers the call to the controller to stream the new
     * chart contents.
     *
     * @method refreshChartUrl
     */
    QuotesChartView.prototype.refreshChartUrl = function () {
        var url = this.$chartImage.attr('data-url');
        var mapUrl = this.$chartImage.attr('data-map-url');

        var jsonArray = this.buildFormArray(this.$allViews.first());

        // Turn the params in to an URL params string
        var params = $.param(jsonArray);

        // Build the full url
        var fullUrl = url + '&' + params + '&timestamp=' + new Date().getTime();
        if (csrfToken != null) {
            fullUrl = setQueryParam(fullUrl, 'tokenUUID', csrfToken);
        }
        var fullMapUrl = mapUrl + '&' + params;

        var deferred = new $.Deferred();

        Util.getHTML(fullMapUrl)
            .done(this.onImageMapLoadComplete.bind(this, deferred))
            .fail(this.onImageMapLoadError.bind(this, deferred));

        $.when(deferred).then(function () {
            // Set the full url on the img element, triggering a get from the browser
            // First clear out the previous src otherwise the get will never occur
            this.$chartImage.attr('src', '');

            this.$chartImage
                .on('error', this.onImageFetchError.bind(this))
                .on('load', this.onImageFetchComplete.bind(this))
                .attr('src', fullUrl);

        }.bind(this));
    };

    /**
     * Callback when image map data is loaded via Ajax.
     *
     * Updates the image map data to be v3 compatible and connects it to
     * v4 callbacks.
     *
     * @method onImageMapLoadComplete
     * @param {$.Deferred} deferred
     * @param {string} htmlResult
     */
    QuotesChartView.prototype.onImageMapLoadComplete = function (deferred, htmlResult) {
        var result = $.parseJSON(htmlResult);

        // update the contract
        this.updateSymbolDisplay(result.quoteModel);

        // update the map data
        // The markup here is being generated for v3, so this search & replace makes it more v4 friendly.
        var fixedHtmlResult = result.mapData
            .replace(/showToolTip/g, 'window.quotesChartViewCallbacks.showToolTip')
            .replace(/clearToolTip/g, 'window.quotesChartViewCallbacks.clearToolTip')
            .replace(/imageMap/g, chartImageMapId);
        this.$chartImgContainer.find('#' + chartImageMapId).remove();
        this.$chartImgContainer.append(fixedHtmlResult);
        var $tooltip = $('.js-charts-tooltip');
        var tooltipModel = new TooltipModel($tooltip);
        var self = this;
        var timeout;
        if (!window.quotesChartViewCallbacks) {
            window.quotesChartViewCallbacks = {
                showToolTip: function (tooltipText, e) {
                    // stop timeout from clear tooltip if another trigger
                    // is triggered before it completes
                    clearTimeout(timeout);

                    // early exit on mobile to prevent tooltips
                    if (self.mobileMode) {
                        return false;
                    }

                    // formatting our string of tooltip data
                    var tooltipContent = tooltipText.split(',');
                    var $newTooltipContent = $('<table class="chartFilter-tooltip">');
                    for (var i = 0; i < tooltipContent.length; i++) {
                        if (tooltipContent[i] !== ' ') {
                            var item = tooltipContent[i].trim();
                            var itemChunk = item.split('=');
                            $newTooltipContent.append(
                                '<tr class="chartFilter-tooltip-item">' +
                                    '<td class="chartFilter-tooltip-item-name">' + itemChunk[0] + '</td>' +
                                    '<td>:&nbsp;' + itemChunk[1] + '</td>' +
                                    '</tr>'
                            );
                        }
                    }
                    // replace tooltip content with new data
                    tooltipModel.replaceContent($newTooltipContent);

                    // manually position tooltip to mouse location because triggers
                    // on chart stretch the full height of the image
                    $tooltip.css({
                        'position': 'absolute',
                        'top': e.layerY,
                        'left': e.layerX
                    });

                    tooltipModel.openTooltip(e.pageX, e.pageY);
                },
                clearToolTip: function () {
                    // early exit on mobile to prevent tooltips
                    if (self.mobileMode) {
                        return false;
                    }
                    // set a small timeout when clearToolTip is fired before closing it
                    // this will prevent flickering when quickly mousing over the chart
                    timeout = setTimeout(function () {
                        tooltipModel.closeTooltip();
                    }, 200);
                }
            };
        }
        deferred.resolve(htmlResult);
    };

    /**
     * Callback when image map data fails to load. Rejects the deferred and hides the image.
     *
     * @method onImageMapLoadError
     */
    QuotesChartView.prototype.onImageMapLoadError = function (deferred, jqXHR, textStatus) {
        this.stopSpinner();
        var errorMessage = 'Error fetching updated HTML: ' + textStatus;
        this.logger.info('XHR status: ' + jqXHR.status + ' - ' + errorMessage);
        this.$chartImage.hide();
        deferred.reject(errorMessage);
    };

    /**
     * Callback for when the chart image successfully loads. Displays the image and connects to the image map.
     *
     * @method onImageFetchComplete
     */
    QuotesChartView.prototype.onImageFetchComplete = function () {
        // After the image loads, the spinner should stop
        this.stopSpinner();
        this.$chartImage.attr('usemap', '#' + chartImageMapId);
        this.$chartImage.show();
    };

    /**
     * Callback when image data fails to load. Hides the image.
     *
     * @method onImageFetchError
     * @param {string} err
     */
    QuotesChartView.prototype.onImageFetchError = function (err) {
        this.logger.log('Failed to load chart image: ' + err);
    };

    /**
     * The historical chart calls a separate service than the regular chart
     * service.
     *
     * @method refreshHistoricalChartUrl
     */
    QuotesChartView.prototype.refreshHistoricalChartUrl = function () {

        var url = this.$historicalChartImage.attr('data-url');

        var jsonArray = this.buildFormArray(this.$allViews.last());

        // Turn the params in to an URL params string
        var params = $.param(jsonArray);

        // Build the full url
        var fullUrl = url + '&' + params;

        // Set the full url on the img element, triggering a get from the
        // browser
        var self = this;

        // After the image loads, the spinner should stop
        this.$historicalChartImage.on('load', function () {
            self.$historicalChartImage.show();
        });

        this.$historicalChartImage.on('error', function () {
            self.$historicalChartImage.hide();
        });

        this.$historicalChartImage.attr('src', fullUrl);
    };

    /**
     * This method configures the page for a Future (no time-wise, but
     * stock-wise) which has a larger number of page features available to the
     * user.
     *
     * ENABLE - Spread Matrix - Future Chain - Month / Year drop down - Options
     * Tab - Historical Tab *
     *
     * @method configurePageForFuture
     */
    QuotesChartView.prototype.configurePageForFuture = function () {
        this.$spreadTag.show();
        this.$futuresTag.show();
        this.$optionsTab.parent().show();
        this.$historicalTab.parent().show();
        // Month selector
        this.$chartMonthSel.show();
        // this.$histMonthSel.show();

        if (this.$chartMonthSel.length > 0 && this.$chartMonthSel[0].selectedIndex > 0) {
            this.$previousMonthChartBtn.show();
        }
        if (this.$chartMonthSel.length > 0 && this.$chartMonthSel[0].selectedIndex > this.$chartMonthSel[0].length - 1) {
            this.$nextMonthChartBtn.show();
        }
    };

    /**
     * This method configures the page for an Equity, which means we have to
     * disable certain buttons and links as they are not applicable to equities.
     *
     * DISABLE - Spread Matrix - Future Chain - Month / Year drop down - Options
     * Tab - Historical Tab
     *
     * @method configurePageForEquity
     */
    QuotesChartView.prototype.configurePageForEquity = function () {
        this.$spreadTag.hide();
        this.$futuresTag.hide();
        $('.js-quotes-charts-symbol-chart-nav').click();
        this.$optionsTab.parent().hide();
        this.$historicalTab.parent().hide();

        // Month selector
        this.$chartMonthSel.hide();
        this.$histMonthSel.hide();

        this.$previousMonthChartBtn.hide();
        this.$nextMonthChartBtn.hide();
    };

    /**
     * This method configures the page for a Future Option for ticket #2394.
     *
     * ENABLE - Futures link.
     *
     * DISABLE - Spread Matrix - Future Chain - Month / Year drop down - Options
     * Tab - Historical Tab.
     *
     * @method configurePageForFutureOption
     */
    QuotesChartView.prototype.configurePageForFutureOption = function () {

        this.$futuresTag.show();
        this.$spreadTag.show();
        $('.js-quotes-charts-symbol-chart-nav').click();
        this.$optionsTab.parent().hide();
        this.$historicalTab.parent().hide();

        // Month selector
        this.$chartMonthSel.hide();
        this.$histMonthSel.hide();
        this.$previousMonthChartBtn.hide();
        this.$nextMonthChartBtn.hide();
    };

    /**
     * This method starts the TWO spinners spinning. One for chart, the other
     * for options.
     *
     * @method startSpinner
     */
    QuotesChartView.prototype.startSpinner = function () {
        Util.sendAction('didStartLoading', this.$element);
        // this.$spinnerContainer.empty();
        // this.$spinnerContainer.append(this.spinner.$el);
        //
        // this.$spinnerContainer.css({
        //     'background-color': 'rgba(255,255,255,0.7)',
        //     //'display': 'block',
        //     'position': 'fixed',
        //     'width': '100%',
        //     'height': '100%',
        //     'z-index': '100',
        //     'top': '0',
        //     'left': '0'
        // });
        //
        // this.$spinnerContainer.show();
    };

    /**
     * This method starts the TWO spinners spinning. One for chart, the other
     * for options.
     *
     * @method stopSpinner
     */
    QuotesChartView.prototype.stopSpinner = function () {
      Util.sendAction('didStopLoading', this.$element);
        // this.$spinnerContainer.empty().hide();
    };

    /**
     * Failed detail fetch.
     *
     * @method handleFailure
     * @param {object} data
     */
    QuotesChartView.prototype.handleFailure = function (data) {
        this.logger.log('Failed to fetch symbol details');
    };

    return QuotesChartView;
});

define('models/EquipmentModel',["exports", "module"], function (exports, module) {
    

    var EquipmentModel = (function () {
        function EquipmentModel(model) {
            babelHelpers.classCallCheck(this, EquipmentModel);

            this.categoryArray = [];
            this.categoryHash = {};

            if (model != null) {
                this.categoryArray = model.categoryArray.slice();
            }
        }

        babelHelpers.createClass(EquipmentModel, [{
            key: "clone",
            value: function clone() {
                return new EquipmentModel(this);
            }
        }, {
            key: "addCategory",
            value: function addCategory(_ref) {
                var name = _ref.name;
                var id = _ref.id;
                var treeDepth = _ref.treeDepth;
                var sortOrder = _ref.sortOrder;

                var category = {
                    name: name,
                    id: id,
                    treeDepth: treeDepth,
                    sortOrder: sortOrder
                };

                this.categoryArray.push(category);
                this.categoryHash[id] = category;

                return this;
            }
        }, {
            key: "filter",
            value: function filter(filterFunction) {
                this.categoryArray = this.categoryArray.filter(filterFunction);

                return this;
            }
        }, {
            key: "sort",
            value: function sort() {
                this.categoryArray = this.categoryArray.sort(function (a, b) {
                    return a.sortOrder - b.sortOrder;
                });

                return this;
            }
        }, {
            key: "find",
            value: function find(id) {
                return this.categoryHash[id];
            }
        }, {
            key: "pluck",
            value: function pluck() {
                return this.categoryArray;
            }
        }]);
        return EquipmentModel;
    })();

    module.exports = EquipmentModel;
});
define('services/equipmentService',['exports', 'module', 'lib/Util', 'models/EquipmentModel'], function (exports, module, _libUtil, _modelsEquipmentModel) {
    

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _EquipmentModel = babelHelpers.interopRequireDefault(_modelsEquipmentModel);

    var consts = {
        TOP_LEVEL_CATEGORY_ID: 464 };

    // The top level 'All' category
    function fetchCategories(url) {
        return new Promise(function (resolve, reject) {
            _Util['default'].getJSON(url).fail(function (jqXHR) {
                reject('Non-200 response from server: ' + jqXHR.status + ' ' + jqXHR.statusText);
            }).then(function (json) {
                var model = jsonToModel(json);
                resolve(model);
            });
        });
    }

    function fetchManufacturers(url, categoryId) {
        return new Promise(function (resolve, reject) {
            _Util['default'].getJSON(url, { categoryId: categoryId }).fail(function (jqXHR) {
                reject('Non-200 response from server: ' + jqXHR.status + ' ' + jqXHR.statusText);
            }).then(function (json) {
                var model = ['All'].concat(babelHelpers.toConsumableArray(json));
                resolve(model);
            });
        });
    }

    // Convert server's JSON to our own model format
    function jsonToModel(json) {
        var model = new _EquipmentModel['default']();

        model.addCategory({
            name: 'All',
            id: consts.TOP_LEVEL_CATEGORY_ID,
            treeDepth: 0,
            sortOrder: 0
        });

        for (var i = 0; i < json.length; i++) {
            var category = json[i];

            model.addCategory({
                name: category.categoryName,
                id: parseInt(category.categoryId, 10),
                treeDepth: parseInt(category.treeDepth, 10),
                sortOrder: parseInt(category.sortOrder, 10)
            });
        }

        return model;
    }

    module.exports = { consts: consts, fetchCategories: fetchCategories, fetchManufacturers: fetchManufacturers };
});
define('views/resources/EquipmentView',['exports', 'module', 'lib/Util', 'components/Component', 'services/equipmentService', 'shared-scripts/services/metricsService'], function (exports, module, _libUtil, _componentsComponent, _servicesEquipmentService, _sharedScriptsServicesMetricsService) {
    

    var _Util = babelHelpers.interopRequireDefault(_libUtil);

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _equipmentService = babelHelpers.interopRequireDefault(_servicesEquipmentService);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var EquipmentView = (function (_Component) {
        babelHelpers.inherits(EquipmentView, _Component);

        function EquipmentView() {
            babelHelpers.classCallCheck(this, EquipmentView);
            babelHelpers.get(Object.getPrototypeOf(EquipmentView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(EquipmentView, [{
            key: 'initProps',
            value: function initProps() {
                babelHelpers.get(Object.getPrototypeOf(EquipmentView.prototype), 'initProps', this).apply(this, arguments);

                this.equipmentModel = [];
            }
        }, {
            key: 'ready',
            value: function ready() {
                _equipmentService['default'].fetchCategories(this.config.categoryUrl).then(this.setModel.bind(this)).then(this.render.bind(this))['catch'](this.exception.bind(this));
            }
        }, {
            key: 'onSubmitClick',
            value: function onSubmitClick() {
                var categoryId = this.$category.val();
                var categoryName = this.equipmentModel.find(categoryId).name;
                var manufacturerName = this.$manufacturer.val() === '' ? 'All' : this.$manufacturer.val();
                var model = this.$model.val();

                _metricsService['default'].searchEntry(this.config.portletTitle, categoryName + '/' + manufacturerName + '/' + model);
            }
        }, {
            key: 'setModel',
            value: function setModel(equipmentModel) {
                this.equipmentModel = equipmentModel;
            }
        }, {
            key: 'render',
            value: function render() {
                this.fetchCategory();
                this.fetchManufacturer();
            }
        }, {
            key: 'exception',
            value: function exception(errorMessage) {
                console.warn(errorMessage); // eslint-disable-line no-console
                this.$category.html('<option>Error!</option>');
                this.$manufacturer.html('<option>Error!</option>');
            }
        }, {
            key: 'onCategoryChange',
            value: function onCategoryChange() {
                this.fetchManufacturer();
            }
        }, {
            key: 'fetchCategory',
            value: function fetchCategory() {
                var categoryArray = this.equipmentModel.clone().sort().pluck();

                this.renderCategory(categoryArray);
            }
        }, {
            key: 'fetchManufacturer',
            value: function fetchManufacturer() {
                var categoryId = this.$category.val();
                var selectedManufacturer = this.$manufacturer.val();

                this.$manufacturer.html('<option>Loading...<option>');

                _equipmentService['default'].fetchManufacturers(this.config.manufacturersUrl, categoryId).then(this.renderManufacturer.bind(this, selectedManufacturer))['catch'](this.exception.bind(this));
            }
        }, {
            key: 'renderCategory',
            value: function renderCategory(categoryArray) {
                var options = [];

                for (var i = 0; i < categoryArray.length; i++) {
                    var category = categoryArray[i];
                    var value = _Util['default'].escapeHtml(category.id);
                    var _name = _Util['default'].escapeHtml(category.name);
                    var indent = this.renderIndent(category.treeDepth);

                    if (category.treeDepth === 1) {
                        options.push('<option value="" disabled>---------------------------------------</option>');
                    }
                    options.push('<option value="' + value + '">' + indent + _name + '</option>');
                }

                this.$category.html(options.join(''));
            }
        }, {
            key: 'renderIndent',
            value: function renderIndent(treeDepth) {
                var indentString = '';
                if (treeDepth > 2) {
                    indentString += Array(treeDepth).join('&nbsp;&nbsp;&nbsp;');
                }
                if (treeDepth > 1) {
                    indentString += '&gt;&nbsp;';
                }
                return indentString;
            }
        }, {
            key: 'renderManufacturer',
            value: function renderManufacturer(selectedManufacturer, manufacturerArray) {
                var options = [];

                for (var i = 0; i < manufacturerArray.length; i++) {
                    var manufacturer = manufacturerArray[i];
                    var _name2 = _Util['default'].escapeHtml(manufacturer);
                    var value = _name2 === 'All' ? '' : _name2;
                    var selected = selectedManufacturer === value ? 'selected' : '';

                    options.push('<option ' + selected + ' value="' + value + '">' + _name2 + '</option>');
                }

                this.$manufacturer.html(options.join(''));
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    portletTitle: { required: true },
                    categoryUrl: { required: true },
                    manufacturersUrl: { required: true }
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$category', selector: '.js-equipmentView-category', event: 'change' }, { prop: '$manufacturer', selector: '.js-equipmentView-manufacturer' }, { prop: '$model', selector: '.js-equipmentView-model' }, { prop: '$submit', selector: '.js-equipmentView-submit', event: 'click' }];
            }
        }]);
        return EquipmentView;
    })(_Component2['default']);

    module.exports = EquipmentView;
});
define('views/resources/JobsView',['exports', 'module', 'components/Component', 'shared-scripts/services/metricsService'], function (exports, module, _componentsComponent, _sharedScriptsServicesMetricsService) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _metricsService = babelHelpers.interopRequireDefault(_sharedScriptsServicesMetricsService);

    var JobsView = (function (_Component) {
        babelHelpers.inherits(JobsView, _Component);

        function JobsView() {
            babelHelpers.classCallCheck(this, JobsView);
            babelHelpers.get(Object.getPrototypeOf(JobsView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(JobsView, [{
            key: 'onSubmitClick',
            value: function onSubmitClick() {
                var keywords = this.$keywords.val();
                var location = this.$location.val();

                _metricsService['default'].searchEntry(this.config.portletTitle, keywords + '/' + location);
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    portletTitle: { required: true }
                };
            }
        }, {
            key: 'elements',
            get: function get() {
                return [{ prop: '$keywords', selector: '.js-jobsView-keywords' }, { prop: '$location', selector: '.js-jobsView-location' }, { prop: '$submit', selector: '.js-jobsView-submit', event: 'click' }];
            }
        }]);
        return JobsView;
    })(_Component2['default']);

    module.exports = JobsView;
});
define('shared-scripts/views/profile/ForgotPasswordView',['require','shared-scripts/components/BaseComponent','shared-scripts/lib/Util'],function (require) {
    

    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var Util = require('shared-scripts/lib/Util');

    var ForgotPasswordComponent = function ($element, browserDetect) {
        this.$element = $element;
        this.browserDetect = browserDetect;

        this.init();
    };

    //TODO: remove the isSafeToCallDestroy line once destroy() method has been tested
    ForgotPasswordComponent.isSafeToCallDestroy = false;
    ForgotPasswordComponent.id = 'ForgotPasswordComponent';
    ForgotPasswordComponent.prototype = new BaseComponent(ForgotPasswordComponent);
    ForgotPasswordComponent.prototype.constructor = ForgotPasswordComponent;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    ForgotPasswordComponent.prototype.onSetupHandlers = function () {
        this.onContinueClickHandler = this.onContinueClick.bind(this);
        this.onEmailKeyPressHandler = this.onEmailKeyPress.bind(this);
        return this;
    };

    ForgotPasswordComponent.prototype.onCreateChildren = function () {
        this.$successMessage = this.$element.find('.js-forgotPassword-success');
        this.$failMessage = this.$element.find('.js-forgotPassword-failure');
        this.$email = this.$element.find('.js-forgotEmail');
        return this;
    };

    ForgotPasswordComponent.prototype.onRemoveChildren = function () {
        this.$successMessage = null;
        this.$failMessage = null;
        this.$email = null;
        return this;
    };

    ForgotPasswordComponent.prototype.onEnable = function () {
        this.$element.on('click.ForgotPasswordComponent', '.js-forgotPassword-continue', this.onContinueClickHandler);
        this.$email.on('keypress.ForgotPasswordComponent', this.onEmailKeyPressHandler);
        return this;
    };

    ForgotPasswordComponent.prototype.onDisable = function () {
        this.$element.off('click.ForgotPasswordComponent', this.onContinueClickHandler);
        this.$email.off('keypress.ForgotPasswordComponent', this.onEmailKeyPressHandler);
        return this;
    };

    ForgotPasswordComponent.prototype.onDestroy = function () {
        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////

    ForgotPasswordComponent.prototype.onEmailKeyPress = function (e) {
        var code = e.which;
        // If the user presses enter, submit the postal code
        if( code === 13 ) {
            e.preventDefault();
            this.$element.find('.js-forgotPassword-continue').click();
        }
    };

    ForgotPasswordComponent.prototype.onContinueClick = function (e) {
        e.preventDefault();
        this.reset();

        var $form = this.$element.find('.js-forgotPassword-form');
        var url = $form.attr('action');
        Util.getJSON(url, $form.serialize())
            .done(this.onContinueComplete.bind(this));
    };

    ForgotPasswordComponent.prototype.onContinueComplete = function (result) {
        if (result.success) {
            this.$successMessage.removeClass('isHidden');
        } else {
            this.$failMessage.removeClass('isHidden');
        }
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Helper Functions
    ///////////////////////////////////////////////////////////////////////////////////////////////

    ForgotPasswordComponent.prototype.reset = function () {
        this.$successMessage.addClass('isHidden');
        this.$failMessage.addClass('isHidden');
    };

    return ForgotPasswordComponent;
});

define('shared-scripts/views/profile/ResetPasswordView',['require','shared-scripts/components/BaseComponent','shared-scripts/lib/Util'],function (require) {
    

    var BaseComponent = require('shared-scripts/components/BaseComponent');
    var Util = require('shared-scripts/lib/Util');

    var ResetPasswordComponent = function ($element, browserDetect) {
        this.$element = $element;
        this.browserDetect = browserDetect;

        this.init();
    };

    ResetPasswordComponent.id = 'ResetPasswordComponent';
    ResetPasswordComponent.prototype = new BaseComponent(ResetPasswordComponent);
    ResetPasswordComponent.prototype.constructor = ResetPasswordComponent;

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Concrete implementation of parent functions
    //////////////////////////////////////////////////////////////////////////////////////////////////

    ResetPasswordComponent.prototype.onSetupHandlers = function () {
        this.onContinueClickHandler = this.onContinueClick.bind(this);
        return this;
    };

    ResetPasswordComponent.prototype.onCreateChildren = function () {
        this.$successMessage = this.$element.find('.js-resetPassword-success');
        this.$failMessage = this.$element.find('.js-resetPassword-failure');
        this.$errorList = this.$element.find('.js-resetPassword-error-list');
        return this;
    };

    ResetPasswordComponent.prototype.onRemoveChildren = function () {
        this.$successMessage = null;
        this.$failMessage = null;
        this.$errorList = null;
        return this;
    };

    ResetPasswordComponent.prototype.onEnable = function () {
        this.$element.on('click.ResetPasswordComponent', '.js-resetPassword-continue', this.onContinueClickHandler);
        return this;
    };

    ResetPasswordComponent.prototype.onDisable = function () {
        this.$element.off('click.ResetPasswordComponent', this.onContinueClickHandler);
        return this;
    };

    ResetPasswordComponent.prototype.onDestroy = function () {
        this.$element = null;
        return this;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    //////////////////////////////////////////////////////////////////////////////////////////////////


    /**
     * Send password change request to server.
     */
    ResetPasswordComponent.prototype.onContinueClick = function (e) {
        e.preventDefault();
        this.reset();

        var $form = this.$element.find('.js-resetPassword-form');
        var url = $form.attr('action');

        Util.getJSON(url, $form.serialize())
            .done(this.onContinueComplete.bind(this));
    };

    /**
     * Verify result from password change request.
     */
    ResetPasswordComponent.prototype.onContinueComplete = function (result) {
        if (result.success) {
            this.$successMessage.removeClass('isHidden');
        } else {
            this.$failMessage.removeClass('isHidden');

            // Include list of problems
            var errorList = '';
            for (var i=0, len=result.errors.length; i<len; i++) {
                errorList += '<li>' + result.errors[i] + '</li>';
            }
            this.$errorList.html(errorList);
        }
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Helper Functions
    ///////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Hide pre-defined status messages.
     */
    ResetPasswordComponent.prototype.reset = function () {
        this.$successMessage.addClass('isHidden');
        this.$failMessage.addClass('isHidden');
    };

    return ResetPasswordComponent;
});

define('views/account_gateway/RedirectView',['exports', 'module', 'components/Component', 'shared-scripts/lib/Util'], function (exports, module, _componentsComponent, _sharedScriptsLibUtil) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _Util = babelHelpers.interopRequireDefault(_sharedScriptsLibUtil);

    /**
     * Redirect View. Retrieves the redirect url from the RedirectViewController and then redirects the user to the returned location.
     * @class
     */

    var RedirectView = (function (_Component) {
        babelHelpers.inherits(RedirectView, _Component);

        function RedirectView() {
            babelHelpers.classCallCheck(this, RedirectView);
            babelHelpers.get(Object.getPrototypeOf(RedirectView.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(RedirectView, [{
            key: 'ready',
            // The previous URL the user was on.
            value: function ready() {
                babelHelpers.get(Object.getPrototypeOf(RedirectView.prototype), 'ready', this).apply(this, arguments);

                this.getRedirectUrl().then(function (json) {
                    window.location.replace(json.redirectUrl);
                })['catch'](function (e) {
                    /* eslint-disable no-alert */
                    alert(e);
                });
            }
        }, {
            key: 'getRedirectUrl',
            value: function getRedirectUrl() {
                var _this = this;

                return new Promise(function (resolve, reject) {
                    var params = { previousUrl: _this.config.previousUrl };
                    _Util['default'].getJSON(_this.config.resourceUrl, params)
                    // Non-200 response
                    .fail(function (jqXHR) {
                        reject('Error fetching server JSON: ' + jqXHR.status + ' ' + jqXHR.statusText);
                    })
                    // 200 server response
                    .then(function (json) {
                        resolve(json);
                    });
                });
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {
                    resourceUrl: { required: true }, // The url to retrieve the URL to redirect the user to.
                    previousUrl: { required: true } };
            }
        }]);
        return RedirectView;
    })(_Component2['default']);

    module.exports = RedirectView;
});
define('components/magazine/PastIssuesListFilterComponent',['exports', 'module', 'components/Component', 'jquery'], function (exports, module, _componentsComponent, _jquery) {
    

    var _Component2 = babelHelpers.interopRequireDefault(_componentsComponent);

    var _$ = babelHelpers.interopRequireDefault(_jquery);

    var PastIssuesListFilterComponent = (function (_Component) {
        babelHelpers.inherits(PastIssuesListFilterComponent, _Component);

        function PastIssuesListFilterComponent() {
            babelHelpers.classCallCheck(this, PastIssuesListFilterComponent);
            babelHelpers.get(Object.getPrototypeOf(PastIssuesListFilterComponent.prototype), 'constructor', this).apply(this, arguments);
        }

        babelHelpers.createClass(PastIssuesListFilterComponent, [{
            key: 'ready',

            //when everything is loaded $(document).ready()
            value: function ready() {

                var selectedYear = this.getAllUrlParams().year;
                var selectedMonth = this.getAllUrlParams().month;

                var options = this.$year.find("option");

                for (var i = 0; i < options.length; i++) {
                    (0, _$['default'])(options[i]).prop('selected', false);
                }

                if (selectedYear) {
                    this.$year.find("option[value=" + selectedYear + "]").prop('selected', true);
                } else {
                    this.$year.find("option[value='0']").prop('selected', true);
                }

                this.onYearChange(null); //trigger onyearchange if user hits directly the link with year only populated.

                var optionsMonth = this.$form.find("select[name='month']>option");

                for (var i = 0; i < optionsMonth.length; i++) {
                    (0, _$['default'])(optionsMonth[i]).prop('selected', false);
                }

                if (selectedMonth) {
                    this.$month.find("option[value=" + selectedMonth + "]").prop('selected', true);
                    this.$month.find("option[value=" + selectedMonth + "]").prop('disabled', false);
                } else {
                    this.$month.find("option[value='0']").prop('selected', true);
                }
            }

            //when the page is loaded init all elements we need later
        }, {
            key: 'queryDom',
            value: function queryDom() {
                babelHelpers.get(Object.getPrototypeOf(PastIssuesListFilterComponent.prototype), 'queryDom', this).apply(this, arguments);

                this.$form = (0, _$['default'])('#pastIssuesFilterForm');
                this.$filterBtn = this.$form.find('input[type="submit"]');
                this.$year = this.$form.find("select[name='year']");
                this.$month = this.$form.find("select[name='month']");
            }

            //handle submit btn and update the url
        }, {
            key: 'onSubmit',
            value: function onSubmit(event) {
                event.preventDefault();
                var baseUrl = this.$form.attr("action").split("?")[0];
                var urlAttributes = this.$form.serialize();
                var url = this.getAllUrlParams(baseUrl + "?" + urlAttributes);

                var finalUrl = {};

                if (url && url.year !== undefined && url.year != "all") {
                    finalUrl.year = url.year;
                }
                if (url && url.month !== undefined && url.month != "0") {
                    finalUrl.month = url.month;
                }

                if (finalUrl.year || finalUrl.month) {
                    baseUrl = baseUrl + "?" + this.objectToUrl(finalUrl);
                }

                window.location.href = baseUrl;
            }
        }, {
            key: 'onYearChange',
            value: function onYearChange(event) {
                var date = new Date();
                var currentYear = date.getYear() + 1900;
                var currentMonth = date.getMonth() + 1; // january = 1, december = 12; all = 0
                var selectedYear = this.$year.find("option:selected").val();
                var months = this.$month.find("option");
                //enable all fields on the first place

                for (var i = 0; i < months.length; i++) {
                    (0, _$['default'])(months[i]).prop('disabled', false); // enable it
                    (0, _$['default'])(months[i]).prop('selected', false); // deselect all options
                }
                (0, _$['default'])(months[0]).prop('selected', true); // make first ("All") to be selected by default

                if (currentYear - selectedYear !== 0) {
                    return true; // no need to do this year is not selected
                }

                //  after that disable all unpublished issue's months ( including the same month DTNPF-184)

                for (var i = currentMonth; i < months.length; i++) {
                    (0, _$['default'])(months[i]).prop('disabled', true);
                }
            }

            //convert all url params to an object
        }, {
            key: 'getAllUrlParams',
            value: function getAllUrlParams(url) {

                var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

                var obj = {};

                if (queryString) {

                    queryString = queryString.split('#')[0];

                    var arr = queryString.split('&');

                    for (var i = 0; i < arr.length; i++) {
                        var a = arr[i].split('=');

                        var paramName = a[0];
                        var paramValue = typeof a[1] === 'undefined' ? true : a[1];

                        paramName = paramName.toLowerCase();
                        if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                        if (paramName.match(/\[(\d+)?\]$/)) {

                            var key = paramName.replace(/\[(\d+)?\]/, '');
                            if (!obj[key]) obj[key] = [];

                            if (paramName.match(/\[\d+\]$/)) {
                                var index = /\[(\d+)\]/.exec(paramName)[1];
                                obj[key][index] = paramValue;
                            } else {
                                obj[key].push(paramValue);
                            }
                        } else {
                            if (!obj[paramName]) {
                                obj[paramName] = paramValue;
                            } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                                obj[paramName] = [obj[paramName]];
                                obj[paramName].push(paramValue);
                            } else {
                                obj[paramName].push(paramValue);
                            }
                        }
                    }
                }

                return obj;
            }
        }, {
            key: 'objectToUrl',
            value: function objectToUrl(obj) {
                var str = "";
                for (var key in obj) {
                    if (str != "") {
                        str += "&";
                    }
                    str += key + "=" + encodeURIComponent(obj[key]);
                }
                return str;
            }
        }, {
            key: 'defaults',
            get: function get() {
                return {};
            }

            //elements and events declaration
        }, {
            key: 'elements',
            get: function get() {
                return [{
                    event: 'submit'
                }, // on submit
                {
                    prop: '$year',
                    selector: '.js-past-issues-category',
                    event: 'change'
                }];
            }
        }]);
        return PastIssuesListFilterComponent;
    })(_Component2['default']);

    module.exports = PastIssuesListFilterComponent;
});
/* eslint object-shorthand: 0 */
define('bootstrap-class-maps',['require','components/AccordionComponent','shared-scripts/components/NativeArticleComponent','components/LiferayAdminModuleFixComponent','components/Carousel3Component','shared-scripts/components/BreakpointListenerComponent','shared-scripts/components/FormComponent','components/JoinCommunityComponent','components/LoginFormComponent','components/MegaMenuComponent','components/MobileMenuComponent','components/MobileSubmenuComponent','components/MobileSearchComponent','components/ModalComponent','components/ModalOpenComponent','components/ModalCloseComponent','components/NavMenuComponent','components/SneezeGuardComponent','components/OoyalaVideoPlayerComponent','components/SmoothScrollingComponent','components/ToggleComponent','components/TermsOfServiceToggleComponent','components/RecaptchaComponent','components/ShowHidePasswordComponent','components/RegularSpinnerComponent','components/StopPropagationComponent','components/TabsComponent','components/TooltipComponent','components/ReadMoreComponent','components/AccordionTableComponent','shared-scripts/components/ShowWhenNotEmptyComponent','components/ContentReplaceComponent','components/ReRenderComponent','shared-scripts/components/HtmlReRenderComponent','shared-scripts/components/DeferredRenderComponent','shared-scripts/components/JsonReRenderComponent','components/OnReadyRedirectComponent','components/FreeTrialComponent','components/LearnMoreComponent','components/PremiumLoginComponent','components/ArticleComponent','components/FileDownloadComponent','components/LinkClickComponent','components/ResetToDefaultLocationComponent','components/StatusBarComponent','components/RegistrationPostalComponent','components/RegistrationAgreementComponent','shared-scripts/components/DfpAdComponent','shared-scripts/components/NativeAdComponent','components/QueryParamComponent','components/SocialShareComponent','views/generic/AddToHomeView','views/news/AudioView','views/SubNavView','views/generic/SimpleLocationView','views/generic/SaveLocationFlyerView','views/dashboard/PollView','views/dashboard/DashboardVideoView','views/news/CattleAuctionsHeadlinesView','shared-scripts/views/news/BlogPostCommentsView','views/news/CommentAdminView','views/news/CommentReRenderView','views/news/ContactAuthorFormView','views/news/RecommendedForYouView','views/settings/AgribusinessSettingsView','views/generic/LocationView','views/onboarding/PrioritizeCropsView','views/weather/WeatherInteractiveMapPaneView','shared-scripts/views/weather/WeatherForecastView','views/markets/CurrentChartsView','views/markets/FuturesView','views/markets/MarketTrackerView','shared-scripts/views/markets/QuotesChartView','views/resources/EquipmentView','views/resources/JobsView','shared-scripts/views/profile/ForgotPasswordView','shared-scripts/views/profile/ResetPasswordView','views/account_gateway/RedirectView','components/magazine/PastIssuesListFilterComponent'],function (require) {
    

    var queryParamMap = [];

    var selectorMap = [
        // Generic Components
        {selector: '.js-accordion', Class: require('components/AccordionComponent')},
        {selector: '.js-nativeArticleComponent', Class: require('shared-scripts/components/NativeArticleComponent')},
        {selector: '.js-admin-control-fix', Class: require('components/LiferayAdminModuleFixComponent')},
        {selector: '.js-carousel3Component', Class: require('components/Carousel3Component')},
        {selector: '.js-breakpointListenerComponent', Class: require('shared-scripts/components/BreakpointListenerComponent')},
        {selector: '.js-formComponent', Class: require('shared-scripts/components/FormComponent')},
        {selector: '.js-joinCommunityComponent', Class: require('components/JoinCommunityComponent')},
        {selector: '.js-loginFormComponent', Class: require('components/LoginFormComponent')},
        {selector: '.js-megaMenu', Class: require('components/MegaMenuComponent')},
        {selector: '.js-mobileMenuComponent', Class: require('components/MobileMenuComponent')},
        {selector: '.js-mobileSubmenuComponent', Class: require('components/MobileSubmenuComponent')},
        {selector: '.js-mobileSearchComponent', Class: require('components/MobileSearchComponent')},
        {selector: '.js-modal', Class: require('components/ModalComponent')},
        {selector: '.js-modal-open', Class: require('components/ModalOpenComponent')},
        {selector: '.js-modal-close', Class: require('components/ModalCloseComponent')},
        {selector: '.js-navMenu', Class: require('components/NavMenuComponent')},
        {selector: '.js-sneezeGuardComponent', Class: require('components/SneezeGuardComponent')},
        {selector: '.js-ooyalaVideoPlayer', Class: require('components/OoyalaVideoPlayerComponent')},
        {selector: '.js-smoothScroll', Class: require('components/SmoothScrollingComponent')},
        {selector: '.js-toggleComponent', Class: require('components/ToggleComponent')},
        {selector: '.js-termsOfServiceToggleComponent', Class: require('components/TermsOfServiceToggleComponent')},
        {selector: '.js-recaptcha', Class: require('components/RecaptchaComponent')},
        {selector: '.js-showHidePasswordComponent', Class: require('components/ShowHidePasswordComponent')},
        {selector: '.js-regularSpinnerComponent', Class: require('components/RegularSpinnerComponent')},
        {selector: '.js-stopPropagationComponent', Class: require('components/StopPropagationComponent')},
        {selector: '.js-tabs', Class: require('components/TabsComponent')},
        {selector: '.js-tooltip', Class: require('components/TooltipComponent')},
        {selector: '.js-readMoreComponent', Class: require('components/ReadMoreComponent')},
        {selector: '.js-accordionTable', Class: require('components/AccordionTableComponent')},
        {selector: '.js-showWhenNotEmptyComponent', Class: require('shared-scripts/components/ShowWhenNotEmptyComponent')},
        {selector: '.js-contentReplaceComponent', Class: require('components/ContentReplaceComponent')},
        {selector: '.js-reRenderComponent', Class: require('components/ReRenderComponent')},
        {selector: '.js-htmlReRenderComponent', Class: require('shared-scripts/components/HtmlReRenderComponent')},
        {selector: '.js-deferredRenderComponent', Class: require('shared-scripts/components/DeferredRenderComponent')},
        {selector: '.js-jsonReRenderComponent', Class: require('shared-scripts/components/JsonReRenderComponent')},
        {selector: '.js-onReadyRedirectComponent', Class: require('components/OnReadyRedirectComponent')},
        {selector: '.js-freeTrialComponent', Class: require('components/FreeTrialComponent')},
        {selector: '.js-learnMoreComponent', Class: require('components/LearnMoreComponent')},
        {selector: '.js-premiumLoginComponent', Class: require('components/PremiumLoginComponent')},
        {selector: '.js-articleComponent', Class: require('components/ArticleComponent')},
        {selector: '.js-fileDownloadComponent', Class: require('components/FileDownloadComponent')},
        {selector: '.js-linkClickComponent', Class: require('components/LinkClickComponent')},
        {selector: '.js-resetToDefaultLocationComponent', Class: require('components/ResetToDefaultLocationComponent')},
        {selector: '.js-statusBarComponent', Class: require('components/StatusBarComponent')},
        {selector: '.js-registrationPostalComponent', Class: require('components/RegistrationPostalComponent')},
        {selector: '.js-registrationAgreementComponent', Class: require('components/RegistrationAgreementComponent')},
        {selector: '.js-dfpAdComponent', Class: require('shared-scripts/components/DfpAdComponent'), priority: 9998},
        {selector: '.js-nativeAdComponent', Class: require('shared-scripts/components/NativeAdComponent'), priority: 9998},
        {selector: '.js-queryParamComponent', Class: require('components/QueryParamComponent'), priority: 9999}, // Run after everything else has loaded
        {selector: '.js-socialShareComponent', Class: require('components/SocialShareComponent'), priority: 9997},

        // Generic Views
        {selector: '.js-addToHomeScreen', Class: require('views/generic/AddToHomeView')},
        {selector: '.js-audio', Class: require('views/news/AudioView')},
        {selector: '.js-subNav', Class: require('views/SubNavView')},
        {selector: '.js-simpleLocationView', Class: require('views/generic/SimpleLocationView')},
        {selector: '.js-saveLocationFlyerView', Class: require('views/generic/SaveLocationFlyerView')},

        // Dashboard Views
        {selector: '.js-pollView', Class: require('views/dashboard/PollView')},
        {selector: '.js-dashboardVideoView', Class: require('views/dashboard/DashboardVideoView')},

        // News Views
        {selector: '.js-cattleAuctionsHeadlines', Class: require('views/news/CattleAuctionsHeadlinesView')},
        {selector: '.js-blogPostComments', Class: require('shared-scripts/views/news/BlogPostCommentsView')},
        {selector: '.js-commentAdminView', Class: require('views/news/CommentAdminView')},
        {selector: '.js-commentReRenderView', Class: require('views/news/CommentReRenderView')},
        {selector: '.js-contactAuthorLink', Class: require('views/news/ContactAuthorFormView')},
        {selector: '.js-recommendedForYou', Class: require('views/news/RecommendedForYouView')},

        // Settings Views
        {selector: '.js-agribusinessSettings', Class: require('views/settings/AgribusinessSettingsView')},
        {selector: '.js-location-view', Class: require('views/generic/LocationView')},
        {selector: '.js-prioritizeCrops', Class: require('views/onboarding/PrioritizeCropsView')},

        // Weather Views
        {selector: '.js-weatherInteractiveMapPane', Class: require('views/weather/WeatherInteractiveMapPaneView'), priority: 100},
        {selector: '.js-weatherForecast', Class: require('shared-scripts/views/weather/WeatherForecastView')},

        // Markets Views
        {selector: '.js-currentChartsView', Class: require('views/markets/CurrentChartsView')},
        {selector: '.js-futuresView', Class: require('views/markets/FuturesView')},
        {selector: '.js-marketTracker', Class: require('views/markets/MarketTrackerView')},
        {selector: '.js-quotes-charts', Class: require('shared-scripts/views/markets/QuotesChartView')},

        // Resources Views
        {selector: '.js-equipmentView', Class: require('views/resources/EquipmentView')},
        {selector: '.js-jobsView', Class: require('views/resources/JobsView')},

        // Account Gateway
        {selector: '.js-forgotPassword', Class: require('shared-scripts/views/profile/ForgotPasswordView')},
        {selector: '.js-resetPassword', Class: require('shared-scripts/views/profile/ResetPasswordView')},
        {selector: '.js-readyRedirectComponent', Class: require('views/account_gateway/RedirectView')},

        //Magazine components
        {selector: '.js-pastIssuesListFilterComponent', Class: require('components/magazine/PastIssuesListFilterComponent')},

    ];

    return {
        queryParamMap: queryParamMap,
        selectorMap: selectorMap,
    };
});

/* eslint object-shorthand: 0 */

define('Bootstrap',['require','jquery','./lib/Util','bootstrap-class-maps'],function (require) {
    

    var $ = require('jquery');
    var Util = require('./lib/Util');

    var bootstrapClassMaps = require('bootstrap-class-maps');

    /**
     * Bootstrap class.
     *
     * @class Bootstrap
     * @constructor
     * @param {BrowserDetect} browserDetect
     */
    function Bootstrap (browserDetect) {
        /**
         * Browser detect.
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = browserDetect;

        /**
         * Maps query parameter to classes.
         * Bootstrap will instantiate the class whenever the URL matches the provided query param.
         *
         * Please note that className should be provided rather than the actual required class,
         * as the JS file will be loaded asyncronously for performance reasons.
         *
         * @property queryParamMapping
         * @type {array<object>} Array of objects in form { queryParam: '', className: '' }
         */
        this.queryParamMapping = bootstrapClassMaps.queryParamMap;

        /**
         * Maps selectors to classes. Bootstrap will instantiate the class for every element on the page matching the provided selector.
         *
         * @property selectorMapping
         * @type {array<object>} Array of objects in form { selector: '', Class: require(''), priority: 0, url: '' }
         */
        this.selectorMapping = bootstrapClassMaps.selectorMap.map(function (item) {
            // Normalize all Classes to have an `id`
            // Components inheriting from BaseComponent require these populated already. Components
            // inheriting from Component need to have that added dynamically.
            if (!item.Class.id) {
                item.Class.id = guid();
            }
            return item;
        });

        this.selectorMappingPrioritized = this.selectorMapping.sort(
            function (a, b) {
                var aPriority = a.priority == null ? 50 : a.priority;
                var bPriority = b.priority == null ? 50 : b.priority;
                return aPriority - bPriority;
            }
        );

        this.init();
    }

    /**
     * Allows triggering of the 'attachjs' event on any html element.
     * Event should be triggered again whenever new elements are added to the page dynamically (via AJAX, etc).
     *
     * ```javascript
     *     $(document.body).trigger('attachjs');  // attaches to all elements in the document
     *     $('.my-container').trigger('attachjs');  // attaches only to all child elements within a specific container
     * ```
     *
     * @method init
     */
    Bootstrap.prototype.init = function () {
        // `*` is used so event can be triggered for any newly added elements to the DOM after-the-fact.
        $(document.body)
            .on('attachjs', this.onAttachJS.bind(this))
            .on('attachjs', '*', this.onAttachJS.bind(this));

        /*
         * In order to call a component's onDestroy() method once removed from the DOM,
         * we leverage the teardown special event in jQuery which is called any time an element is destroyed
         * via $.empty(), $.remove() etc.
         *
         * It is NOT okay to use native DOM methods to remove elements, since $.cleanData will never be called
         *
         * Okay:
         *      .empty(), .remove(), .replaceWith(), .html(), unwrap()
         *
         * Not okay:
         *      .detach(), .removeChild()
         */
        $.event.special.domTeardown = {
            teardown: function () {
                // Just calls the destroy() method defined in BaseComponent
                $(this).triggerHandler('destroy');
            },
        };
    };

    ///////////////////////////////////////////////////////////////////////////
    // Event Handlers
    ///////////////////////////////////////////////////////////////////////////

    /**
     * Handler for the attachjs event.
     *
     * @method onAttachJS
     * @param {Event} e
     */
    Bootstrap.prototype.onAttachJS = function (e) {
        this.instantiateBySelector($(e.currentTarget));

        return false;
    };

    ///////////////////////////////////////////////////////////////////////////
    // Public API
    ///////////////////////////////////////////////////////////////////////////

    /*
     * Instantiates JS classes based on whether the URL matches one of the defined query params.
     *
     * Since this only apply to certain scenarios, the JS file is loaded on-demand only when the condition is satisfied.
     * This will provide better performance since the JS is loaded only as-needed.
     * Use caution with this approach since async loading can cause unpredictable behavior if not designed for it.
     *
     * @method instantiateByQueryParam
     *
     */
    Bootstrap.prototype.instantiateByQueryParam = function () {
        for (var i = 0; i < this.queryParamMapping.length; i++) {
            var mapping = this.queryParamMapping[i];
            var value = Util.getQueryValue(mapping.queryParam);

            // Here we _could_ just check if (value === '1'), but varying the number can be useful
            // toward distinguishing the context of usage for GoogleAnalytics. E.g. value = 2 means
            // the referrer was Help & Support, etc.
            if (typeof value !== 'undefined' && value !== null && value !== '0' && value !== '') {
                this.instantiateAsync(mapping.className);
                break;
            }
        }
    };

    /**
     * Search for component selectors in the $container and initialize if needed.
     *
     * @method instantiateBySelector
     * @param {jQuery} $container Element to start scanning from
     */
    Bootstrap.prototype.instantiateBySelector = function ($container) {
        for (var i = 0; i < this.selectorMappingPrioritized.length; i++) {
            var mapping = this.selectorMappingPrioritized[i];

            // If a `url` property is defined, then only instantiate if the current URL matches the required url
            var shouldApply = false;
            if (mapping.url == null) {
                shouldApply = true;
            } else {
                var urlRegex = '^' + window.dtnGlobals.siteContext + '/' + mapping.url + '$';
                if (window.location.pathname.match(urlRegex)) {
                    shouldApply = true;
                }
            }

            if (shouldApply) {
                var $elements = $container.find(mapping.selector).addBack(mapping.selector);
                // Create an instance for each selector found in this container
                for (var j = 0; j < $elements.length; j++) {
                    var $element = $elements.eq(j);

                    // Only create if not instantiated yet
                    // mapping.Class.name is used by the new Component to identify class names.
                    if (!Util.isInitialized($element, mapping.Class.id)) {
                        this.instantiateSync(mapping.Class, $element);
                    }
                }
            }
        }

        for (var k = 0; k < this._readyQueue.length; k++) {
            this._readyQueue[k].ready();
        }
        this._readyQueue.length = 0;
    };

    /*
     * Instatiates a class syncronously.
     *
     * @method instantiateSync
     * @param {object} Class A direct reference to the Class to instantiate
     * @param {jQuery} $element Container element to provide to constructor
     */
    Bootstrap.prototype.instantiateSync = function (Class, $element) {
        var component = new Class($element, this.browserDetect, Class.id);

        if (component.deferReady) {
            this._readyQueue.push(component);
        }
    };

    /*
     * Instatiates a class asyncronously.
     * Performs an asyncronous require to grab the JS file, and then instantiates the class.
     *
     * @method instantiateAsync
     * @param {string} className Name of hte class to instantiate
     */
    Bootstrap.prototype.instantiateAsync = function (className) {
        /* eslint-disable no-new */
        require([className], function (Class) {
            new Class(this.browserDetect);
        }.bind(this));
        /* eslint-enable no-new */
    };

    /**
     * Collection of components queued up waiting on the first pass of
     * component initialization to complete.
     *
     * When Bootstrap has completed calling Component#init on all components
     * found on the page, this queue will be flushed, and `ready()` will
     * be called on each component in the queue.
     *
     * @type {Array}
     */
    Bootstrap.prototype._readyQueue = [];

    return Bootstrap;
});

function guid () {
    function s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}
;
define('lib/Knockout-extend',['require','jquery','knockout','moment'],function (require) {
    

    var $ = require('jquery');
    var ko = require('knockout');
    var moment = require('moment');

    var KnockoutExtend = function () {

        // Convert time in seconds since epoc to date string
        ko.bindingHandlers.dateString = {
            update : function (element, valueAccessor, allBindingsAccessor, viewModel) {
                var value = valueAccessor(), allBindings = allBindingsAccessor();
                var seconds = ko.utils.unwrapObservable(value);

                // If "local" then apply offset to build local date instead of UTC
                if (allBindings.local) {
                    var timezoneOffset = (new Date(seconds)).getTimezoneOffset() * 60000;
                    seconds += timezoneOffset;
                }

                var valueUnwrapped = moment(seconds);
                var pattern = allBindings.datePattern || 'MM/DD/YYYY';
                if (valueUnwrapped != null) {
                    $(element).text(valueUnwrapped.format(pattern));
                }
            }
        };
        ko.bindingHandlers.millisToMinutes = {
            update : function (element, valueAccessor, allBindingsAccessor, viewModel) {
                var mom = moment(new Date(ko.utils.unwrapObservable(valueAccessor())));
                $(element).text(mom.format('mm:ss'));
            }
        };
        ko.bindingHandlers.rerunBootstrap = {
            init : function (element){
                $(document.body).trigger('attachjs');
            }
        };
        ko.bindingHandlers.sortableList = {
            init: function (element, valueAccessor) {
                var list = valueAccessor();
                $(element).on('reordered.sortableList', function (e, oldIndex, moveUp) {
                    if (moveUp) {
                        list.splice(oldIndex - 1, 2, list()[oldIndex], list()[oldIndex - 1]);
                    } else {
                        list.splice(oldIndex, 2, list()[oldIndex + 1], list()[oldIndex]);
                    }
                });
            }
        };
        ko.bindingHandlers.stopBinding = {
            init: function () {
                return { controlsDescendantBindings: true };
            }
        };
        ko.virtualElements.allowedBindings.stopBinding = true;
    };

    return new KnockoutExtend();
});

/*!
 * jQuery Transit - CSS3 transitions and transformations
 * (c) 2011-2012 Rico Sta. Cruz <rico@ricostacruz.com>
 * MIT Licensed.
 *
 * http://ricostacruz.com/jquery.transit
 * http://github.com/rstacruz/jquery.transit
 */

(function($) {
  $.transit = {
    version: "0.9.9",

    // Map of $.css() keys to values for 'transitionProperty'.
    // See https://developer.mozilla.org/en/CSS/CSS_transitions#Properties_that_can_be_animated
    propertyMap: {
      marginLeft    : 'margin',
      marginRight   : 'margin',
      marginBottom  : 'margin',
      marginTop     : 'margin',
      paddingLeft   : 'padding',
      paddingRight  : 'padding',
      paddingBottom : 'padding',
      paddingTop    : 'padding'
    },

    // Will simply transition "instantly" if false
    enabled: true,

    // Set this to false if you don't want to use the transition end property.
    useTransitionEnd: false
  };

  var div = document.createElement('div');
  var support = {};

  // Helper function to get the proper vendor property name.
  // (`transition` => `WebkitTransition`)
  function getVendorPropertyName(prop) {
    // Handle unprefixed versions (FF16+, for example)
    if (prop in div.style) return prop;

    var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
    var prop_ = prop.charAt(0).toUpperCase() + prop.substr(1);

    if (prop in div.style) { return prop; }

    for (var i=0; i<prefixes.length; ++i) {
      var vendorProp = prefixes[i] + prop_;
      if (vendorProp in div.style) { return vendorProp; }
    }
  }

  // Helper function to check if transform3D is supported.
  // Should return true for Webkits and Firefox 10+.
  function checkTransform3dSupport() {
    div.style[support.transform] = '';
    div.style[support.transform] = 'rotateY(90deg)';
    return div.style[support.transform] !== '';
  }

  var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

  // Check for the browser's transitions support.
  support.transition      = getVendorPropertyName('transition');
  support.transitionDelay = getVendorPropertyName('transitionDelay');
  support.transform       = getVendorPropertyName('transform');
  support.transformOrigin = getVendorPropertyName('transformOrigin');
  support.transform3d     = checkTransform3dSupport();

  var eventNames = {
    'transition':       'transitionEnd',
    'MozTransition':    'transitionend',
    'OTransition':      'oTransitionEnd',
    'WebkitTransition': 'webkitTransitionEnd',
    'msTransition':     'MSTransitionEnd'
  };

  // Detect the 'transitionend' event needed.
  var transitionEnd = support.transitionEnd = eventNames[support.transition] || null;

  // Populate jQuery's `$.support` with the vendor prefixes we know.
  // As per [jQuery's cssHooks documentation](http://api.jquery.com/jQuery.cssHooks/),
  // we set $.support.transition to a string of the actual property name used.
  for (var key in support) {
    if (support.hasOwnProperty(key) && typeof $.support[key] === 'undefined') {
      $.support[key] = support[key];
    }
  }

  // Avoid memory leak in IE.
  div = null;

  // ## $.cssEase
  // List of easing aliases that you can use with `$.fn.transition`.
  $.cssEase = {
    '_default':       'ease',
    'in':             'ease-in',
    'out':            'ease-out',
    'in-out':         'ease-in-out',
    'snap':           'cubic-bezier(0,1,.5,1)',
    // Penner equations
    'easeOutCubic':   'cubic-bezier(.215,.61,.355,1)',
    'easeInOutCubic': 'cubic-bezier(.645,.045,.355,1)',
    'easeInCirc':     'cubic-bezier(.6,.04,.98,.335)',
    'easeOutCirc':    'cubic-bezier(.075,.82,.165,1)',
    'easeInOutCirc':  'cubic-bezier(.785,.135,.15,.86)',
    'easeInExpo':     'cubic-bezier(.95,.05,.795,.035)',
    'easeOutExpo':    'cubic-bezier(.19,1,.22,1)',
    'easeInOutExpo':  'cubic-bezier(1,0,0,1)',
    'easeInQuad':     'cubic-bezier(.55,.085,.68,.53)',
    'easeOutQuad':    'cubic-bezier(.25,.46,.45,.94)',
    'easeInOutQuad':  'cubic-bezier(.455,.03,.515,.955)',
    'easeInQuart':    'cubic-bezier(.895,.03,.685,.22)',
    'easeOutQuart':   'cubic-bezier(.165,.84,.44,1)',
    'easeInOutQuart': 'cubic-bezier(.77,0,.175,1)',
    'easeInQuint':    'cubic-bezier(.755,.05,.855,.06)',
    'easeOutQuint':   'cubic-bezier(.23,1,.32,1)',
    'easeInOutQuint': 'cubic-bezier(.86,0,.07,1)',
    'easeInSine':     'cubic-bezier(.47,0,.745,.715)',
    'easeOutSine':    'cubic-bezier(.39,.575,.565,1)',
    'easeInOutSine':  'cubic-bezier(.445,.05,.55,.95)',
    'easeInBack':     'cubic-bezier(.6,-.28,.735,.045)',
    'easeOutBack':    'cubic-bezier(.175, .885,.32,1.275)',
    'easeInOutBack':  'cubic-bezier(.68,-.55,.265,1.55)'
  };

  // ## 'transform' CSS hook
  // Allows you to use the `transform` property in CSS.
  //
  //     $("#hello").css({ transform: "rotate(90deg)" });
  //
  //     $("#hello").css('transform');
  //     //=> { rotate: '90deg' }
  //
  $.cssHooks['transit:transform'] = {
    // The getter returns a `Transform` object.
    get: function(elem) {
      return $(elem).data('transform') || new Transform();
    },

    // The setter accepts a `Transform` object or a string.
    set: function(elem, v) {
      var value = v;

      if (!(value instanceof Transform)) {
        value = new Transform(value);
      }

      // We've seen the 3D version of Scale() not work in Chrome when the
      // element being scaled extends outside of the viewport.  Thus, we're
      // forcing Chrome to not use the 3d transforms as well.  Not sure if
      // translate is affectede, but not risking it.  Detection code from
      // http://davidwalsh.name/detecting-google-chrome-javascript
      if (support.transform.toLowerCase() === 'webkittransform' || support.transform.toLowerCase() === 'transform') { // && !isChrome) {
        elem.style[support.transform] = value.toString(true);
      } else {
        elem.style[support.transform] = value.toString();
      }

      $(elem).data('transform', value);
    }
  };

  // Add a CSS hook for `.css({ transform: '...' })`.
  // In jQuery 1.8+, this will intentionally override the default `transform`
  // CSS hook so it'll play well with Transit. (see issue #62)
  $.cssHooks.transform = {
    set: $.cssHooks['transit:transform'].set
  };

  // jQuery 1.8+ supports prefix-free transitions, so these polyfills will not
  // be necessary.
  if ($.fn.jquery < "1.8") {
    // ## 'transformOrigin' CSS hook
    // Allows the use for `transformOrigin` to define where scaling and rotation
    // is pivoted.
    //
    //     $("#hello").css({ transformOrigin: '0 0' });
    //
    $.cssHooks.transformOrigin = {
      get: function(elem) {
        return elem.style[support.transformOrigin];
      },
      set: function(elem, value) {
        elem.style[support.transformOrigin] = value;
      }
    };

    // ## 'transition' CSS hook
    // Allows you to use the `transition` property in CSS.
    //
    //     $("#hello").css({ transition: 'all 0 ease 0' });
    //
    $.cssHooks.transition = {
      get: function(elem) {
        return elem.style[support.transition];
      },
      set: function(elem, value) {
        elem.style[support.transition] = value;
      }
    };
  }

  // ## Other CSS hooks
  // Allows you to rotate, scale and translate.
  registerCssHook('scale');
  registerCssHook('translate');
  registerCssHook('rotate');
  registerCssHook('rotateX');
  registerCssHook('rotateY');
  registerCssHook('rotate3d');
  registerCssHook('perspective');
  registerCssHook('skewX');
  registerCssHook('skewY');
  registerCssHook('x', true);
  registerCssHook('y', true);

  // ## Transform class
  // This is the main class of a transformation property that powers
  // `$.fn.css({ transform: '...' })`.
  //
  // This is, in essence, a dictionary object with key/values as `-transform`
  // properties.
  //
  //     var t = new Transform("rotate(90) scale(4)");
  //
  //     t.rotate             //=> "90deg"
  //     t.scale              //=> "4,4"
  //
  // Setters are accounted for.
  //
  //     t.set('rotate', 4)
  //     t.rotate             //=> "4deg"
  //
  // Convert it to a CSS string using the `toString()` and `toString(true)` (for WebKit)
  // functions.
  //
  //     t.toString()         //=> "rotate(90deg) scale(4,4)"
  //     t.toString(true)     //=> "rotate(90deg) scale3d(4,4,0)" (WebKit version)
  //
  function Transform(str) {
    if (typeof str === 'string') { this.parse(str); }
    return this;
  }

  Transform.prototype = {
    // ### setFromString()
    // Sets a property from a string.
    //
    //     t.setFromString('scale', '2,4');
    //     // Same as set('scale', '2', '4');
    //
    setFromString: function(prop, val) {
      var args =
        (typeof val === 'string')  ? val.split(',') :
        (val.constructor === Array) ? val :
        [ val ];

      args.unshift(prop);

      Transform.prototype.set.apply(this, args);
    },

    // ### set()
    // Sets a property.
    //
    //     t.set('scale', 2, 4);
    //
    set: function(prop) {
      var args = Array.prototype.slice.apply(arguments, [1]);
      if (this.setter[prop]) {
        this.setter[prop].apply(this, args);
      } else {
        this[prop] = args.join(',');
      }
    },

    get: function(prop) {
      if (this.getter[prop]) {
        return this.getter[prop].apply(this);
      } else {
        return this[prop] || 0;
      }
    },

    setter: {
      // ### rotate
      //
      //     .css({ rotate: 30 })
      //     .css({ rotate: "30" })
      //     .css({ rotate: "30deg" })
      //     .css({ rotate: "30deg" })
      //
      rotate: function(theta) {
        this.rotate = unit(theta, 'deg');
      },

      rotateX: function(theta) {
        this.rotateX = unit(theta, 'deg');
      },

      rotateY: function(theta) {
        this.rotateY = unit(theta, 'deg');
      },

      // ### scale
      //
      //     .css({ scale: 9 })      //=> "scale(9,9)"
      //     .css({ scale: '3,2' })  //=> "scale(3,2)"
      //
      scale: function(x, y) {
        if (y === undefined) { y = x; }
        this.scale = x + "," + y;
      },

      // ### skewX + skewY
      skewX: function(x) {
        this.skewX = unit(x, 'deg');
      },

      skewY: function(y) {
        this.skewY = unit(y, 'deg');
      },

      // ### perspectvie
      perspective: function(dist) {
        this.perspective = unit(dist, 'px');
      },

      // ### x / y
      // Translations. Notice how this keeps the other value.
      //
      //     .css({ x: 4 })       //=> "translate(4px, 0)"
      //     .css({ y: 10 })      //=> "translate(4px, 10px)"
      //
      x: function(x) {
        this.set('translate', x, null);
      },

      y: function(y) {
        this.set('translate', null, y);
      },

      // ### translate
      // Notice how this keeps the other value.
      //
      //     .css({ translate: '2, 5' })    //=> "translate(2px, 5px)"
      //
      translate: function(x, y) {
        if (this._translateX === undefined) { this._translateX = 0; }
        if (this._translateY === undefined) { this._translateY = 0; }

        if (x !== null && x !== undefined) { this._translateX = unit(x, 'px'); }
        if (y !== null && y !== undefined) { this._translateY = unit(y, 'px'); }

        this.translate = this._translateX + "," + this._translateY;
      }
    },

    getter: {
      x: function() {
        return this._translateX || 0;
      },

      y: function() {
        return this._translateY || 0;
      },

      scale: function() {
        var s = (this.scale || "1,1").split(',');
        if (s[0]) { s[0] = parseFloat(s[0]); }
        if (s[1]) { s[1] = parseFloat(s[1]); }

        // "2.5,2.5" => 2.5
        // "2.5,1" => [2.5,1]
        return (s[0] === s[1]) ? s[0] : s;
      },

      rotate3d: function() {
        var s = (this.rotate3d || "0,0,0,0deg").split(',');
        for (var i=0; i<=3; ++i) {
          if (s[i]) { s[i] = parseFloat(s[i]); }
        }
        if (s[3]) { s[3] = unit(s[3], 'deg'); }

        return s;
      }
    },

    // ### parse()
    // Parses from a string. Called on constructor.
    parse: function(str) {
      var self = this;
      str.replace(/([a-zA-Z0-9]+)\((.*?)\)/g, function(x, prop, val) {
        self.setFromString(prop, val);
      });
    },

    // ### toString()
    // Converts to a `transition` CSS property string. If `use3d` is given,
    // it converts to a `-webkit-transition` CSS property string instead.
    toString: function(use3d) {
      var re = [];

      for (var i in this) {
        if (this.hasOwnProperty(i)) {
          // Don't use 3D transformations if the browser can't support it.
          if ((!support.transform3d) && (
            (i === 'rotateX') ||
            (i === 'rotateY') ||
            (i === 'perspective') ||
            (i === 'transformOrigin'))) { continue; }

          if (i[0] !== '_') {
            if (use3d && (i === 'scale')) {
              re.push(i + "3d(" + this[i] + ",1)");
            } else if (use3d && (i === 'translate')) {
              re.push(i + "3d(" + this[i] + ",0)");
            } else {
              re.push(i + "(" + this[i] + ")");
            }
          }
        }
      }

      return re.join(" ");
    }
  };

  function callOrQueue(self, queue, fn) {
    if (queue === true) {
      self.queue(fn);
    } else if (queue) {
      self.queue(queue, fn);
    } else {
      fn();
    }
  }

  // ### getProperties(dict)
  // Returns properties (for `transition-property`) for dictionary `props`. The
  // value of `props` is what you would expect in `$.css(...)`.
  function getProperties(props) {
    var re = [];

    $.each(props, function(key) {
      key = $.camelCase(key); // Convert "text-align" => "textAlign"
      key = $.transit.propertyMap[key] || $.cssProps[key] || key;
      key = uncamel(key); // Convert back to dasherized

      if ($.inArray(key, re) === -1) { re.push(key); }
    });

    return re;
  }

  // ### getTransition()
  // Returns the transition string to be used for the `transition` CSS property.
  //
  // Example:
  //
  //     getTransition({ opacity: 1, rotate: 30 }, 500, 'ease');
  //     //=> 'opacity 500ms ease, -webkit-transform 500ms ease'
  //
  function getTransition(properties, duration, easing, delay) {
    // Get the CSS properties needed.
    var props = getProperties(properties);

    // Account for aliases (`in` => `ease-in`).
    if ($.cssEase[easing]) { easing = $.cssEase[easing]; }

    // Build the duration/easing/delay attributes for it.
    var attribs = '' + toMS(duration) + ' ' + easing;
    if (parseInt(delay, 10) > 0) { attribs += ' ' + toMS(delay); }

    // For more properties, add them this way:
    // "margin 200ms ease, padding 200ms ease, ..."
    var transitions = [];
    $.each(props, function(i, name) {
      transitions.push(name + ' ' + attribs);
    });

    return transitions.join(', ');
  }

  // ## $.fn.transition
  // Works like $.fn.animate(), but uses CSS transitions.
  //
  //     $("...").transition({ opacity: 0.1, scale: 0.3 });
  //
  //     // Specific duration
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500);
  //
  //     // With duration and easing
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in');
  //
  //     // With callback
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, function() { ... });
  //
  //     // With everything
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in', function() { ... });
  //
  //     // Alternate syntax
  //     $("...").transition({
  //       opacity: 0.1,
  //       duration: 200,
  //       delay: 40,
  //       easing: 'in',
  //       complete: function() { /* ... */ }
  //      });
  //
  $.fn.transition = $.fn.transit = function(properties, duration, easing, callback) {
    var self  = this;
    var delay = 0;
    var queue = true;

    // Account for `.transition(properties, callback)`.
    if (typeof duration === 'function') {
      callback = duration;
      duration = undefined;
    }

    // Account for `.transition(properties, duration, callback)`.
    if (typeof easing === 'function') {
      callback = easing;
      easing = undefined;
    }

    // Alternate syntax.
    if (typeof properties.easing !== 'undefined') {
      easing = properties.easing;
      delete properties.easing;
    }

    if (typeof properties.duration !== 'undefined') {
      duration = properties.duration;
      delete properties.duration;
    }

    if (typeof properties.complete !== 'undefined') {
      callback = properties.complete;
      delete properties.complete;
    }

    if (typeof properties.queue !== 'undefined') {
      queue = properties.queue;
      delete properties.queue;
    }

    if (typeof properties.delay !== 'undefined') {
      delay = properties.delay;
      delete properties.delay;
    }

    // Set defaults. (`400` duration, `ease` easing)
    if (typeof duration === 'undefined') { duration = $.fx.speeds._default; }
    if (typeof easing === 'undefined')   { easing = $.cssEase._default; }

    duration = toMS(duration);

    // Build the `transition` property.
    var transitionValue = getTransition(properties, duration, easing, delay);

    // Compute delay until callback.
    // If this becomes 0, don't bother setting the transition property.
    var work = $.transit.enabled && support.transition;
    var i = work ? (parseInt(duration, 10) + parseInt(delay, 10)) : 0;

    // If there's nothing to do...
    if (i === 0) {
      var fn = function(next) {
        self.css(properties);
        if (callback) { callback.apply(self); }
        if (next) { next(); }
      };

      callOrQueue(self, queue, fn);
      return self;
    }

    // Save the old transitions of each element so we can restore it later.
    var oldTransitions = {};

    var run = function(nextCall) {
      var bound = false;

      // Prepare the callback.
      var cb = function() {
        if (bound) { self.unbind(transitionEnd, cb); }

        if (i > 0) {
          self.each(function() {
            this.style[support.transition] = (oldTransitions[this] || null);
          });
        }

        if (typeof callback === 'function') { callback.apply(self); }
        if (typeof nextCall === 'function') { nextCall(); }
      };

      if ((i > 0) && (transitionEnd) && ($.transit.useTransitionEnd)) {
        // Use the 'transitionend' event if it's available.
        bound = true;
        self.bind(transitionEnd, cb);
      } else {
        // Fallback to timers if the 'transitionend' event isn't supported.
        window.setTimeout(cb, i);
      }

      // Apply transitions.
      self.each(function() {
        if (i > 0) {
          this.style[support.transition] = transitionValue;
        }
        $(this).css(properties);
      });
    };

    // Defer running. This allows the browser to paint any pending CSS it hasn't
    // painted yet before doing the transitions.
    var deferredRun = function(next) {
      var i = 0;

      // Durations that are too slow will get transitions mixed up.
      // (Tested on Mac/FF 7.0.1)
      if ((support.transition === 'MozTransition') && (i < 25)) { i = 25; }

      window.setTimeout(function() { run(next); }, i);
    };

    // Use jQuery's fx queue.
    callOrQueue(self, queue, deferredRun);

    // Chainability.
    return this;
  };

  function registerCssHook(prop, isPixels) {
    // For certain properties, the 'px' should not be implied.
    if (!isPixels) { $.cssNumber[prop] = true; }

    $.transit.propertyMap[prop] = support.transform;

    $.cssHooks[prop] = {
      get: function(elem) {
        var t = $(elem).css('transit:transform');
        return t.get(prop);
      },

      set: function(elem, value) {
        var t = $(elem).css('transit:transform');
        t.setFromString(prop, value);

        $(elem).css({ 'transit:transform': t });
      }
    };

  }

  // ### uncamel(str)
  // Converts a camelcase string to a dasherized string.
  // (`marginLeft` => `margin-left`)
  function uncamel(str) {
    return str.replace(/([A-Z])/g, function(letter) { return '-' + letter.toLowerCase(); });
  }

  // ### unit(number, unit)
  // Ensures that number `number` has a unit. If no unit is found, assume the
  // default is `unit`.
  //
  //     unit(2, 'px')          //=> "2px"
  //     unit("30deg", 'rad')   //=> "30deg"
  //
  function unit(i, units) {
    if ((typeof i === "string") && (!i.match(/^[\-0-9\.]+$/))) {
      return i;
    } else {
      return "" + i + units;
    }
  }

  // ### toMS(duration)
  // Converts given `duration` to a millisecond string.
  //
  //     toMS('fast')   //=> '400ms'
  //     toMS(10)       //=> '10ms'
  //
  function toMS(duration) {
    var i = duration;

    // Allow for string durations like 'fast'.
    if ($.fx.speeds[i]) { i = $.fx.speeds[i]; }

    return unit(i, 'ms');
  }

  // Export some functions for testable-ness.
  $.transit.getTransitionValue = getTransition;
})(jQuery);

define("transit", ["jquery"], function(){});

!function(){function a(){return window.navigator.userAgent.match(/iPhone|iPad|iPod/)?"iOSSafari":void 0}var b={iOSSafari:{touchEvent:"touchstart",styles:{input:{opacity:1},textarea:{opacity:1},select:{color:"black"}}}},c=function(c){var d=a();if(!d)return!1;var e=c||"input-disabled",f="";for(var g in b[d].styles){f+=g+":disabled."+e+"{";for(var h in b[d].styles[g])f+=h+":"+b[d].styles[g][h]+";";f+="}"}$("<style>",{id:"touch-input-nav-styles"}).html(f).appendTo("head");var i="input,select,textarea";$(document).on("focus",i,function(){var a=$(this),c=a.closest("form").find(i),f=$(i).not(c);f.prop("disabled",!0).addClass(e+" "+d),a.one("blur",function(){$(i).off(".input-disabled"),f.prop("disabled",!1).removeClass(e+" "+d)}),$(i).one(b[d].touchEvent+".input-disabled",function(){$(this).prop("disabled",!1)})})};"function"==typeof define&&"object"==typeof define.amd&&define.amd?define('touch-input-nav',["jquery"],function(){return c}):"object"==typeof module&&module.exports?(require("jquery")(window),module.exports=c):window.touchInputNav=c}();
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
 * @version   2.1.1
 */

(function(){function lib$es6$promise$utils$$objectOrFunction(x){return typeof x==="function"||typeof x==="object"&&x!==null}function lib$es6$promise$utils$$isFunction(x){return typeof x==="function"}function lib$es6$promise$utils$$isMaybeThenable(x){return typeof x==="object"&&x!==null}var lib$es6$promise$utils$$_isArray;if(!Array.isArray){lib$es6$promise$utils$$_isArray=function(x){return Object.prototype.toString.call(x)==="[object Array]"}}else{lib$es6$promise$utils$$_isArray=Array.isArray}var lib$es6$promise$utils$$isArray=lib$es6$promise$utils$$_isArray;var lib$es6$promise$asap$$len=0;var lib$es6$promise$asap$$toString={}.toString;var lib$es6$promise$asap$$vertxNext;function lib$es6$promise$asap$$asap(callback,arg){lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len]=callback;lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len+1]=arg;lib$es6$promise$asap$$len+=2;if(lib$es6$promise$asap$$len===2){lib$es6$promise$asap$$scheduleFlush()}}var lib$es6$promise$asap$$default=lib$es6$promise$asap$$asap;var lib$es6$promise$asap$$browserWindow=typeof window!=="undefined"?window:undefined;var lib$es6$promise$asap$$browserGlobal=lib$es6$promise$asap$$browserWindow||{};var lib$es6$promise$asap$$BrowserMutationObserver=lib$es6$promise$asap$$browserGlobal.MutationObserver||lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;var lib$es6$promise$asap$$isNode=typeof process!=="undefined"&&{}.toString.call(process)==="[object process]";var lib$es6$promise$asap$$isWorker=typeof Uint8ClampedArray!=="undefined"&&typeof importScripts!=="undefined"&&typeof MessageChannel!=="undefined";function lib$es6$promise$asap$$useNextTick(){var nextTick=process.nextTick;var version=process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);if(Array.isArray(version)&&version[1]==="0"&&version[2]==="10"){nextTick=setImmediate}return function(){nextTick(lib$es6$promise$asap$$flush)}}function lib$es6$promise$asap$$useVertxTimer(){return function(){lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush)}}function lib$es6$promise$asap$$useMutationObserver(){var iterations=0;var observer=new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);var node=document.createTextNode("");observer.observe(node,{characterData:true});return function(){node.data=iterations=++iterations%2}}function lib$es6$promise$asap$$useMessageChannel(){var channel=new MessageChannel;channel.port1.onmessage=lib$es6$promise$asap$$flush;return function(){channel.port2.postMessage(0)}}function lib$es6$promise$asap$$useSetTimeout(){return function(){setTimeout(lib$es6$promise$asap$$flush,1)}}var lib$es6$promise$asap$$queue=new Array(1e3);function lib$es6$promise$asap$$flush(){for(var i=0;i<lib$es6$promise$asap$$len;i+=2){var callback=lib$es6$promise$asap$$queue[i];var arg=lib$es6$promise$asap$$queue[i+1];callback(arg);lib$es6$promise$asap$$queue[i]=undefined;lib$es6$promise$asap$$queue[i+1]=undefined}lib$es6$promise$asap$$len=0}function lib$es6$promise$asap$$attemptVertex(){try{var r=require;var vertx=r("vertx");lib$es6$promise$asap$$vertxNext=vertx.runOnLoop||vertx.runOnContext;return lib$es6$promise$asap$$useVertxTimer()}catch(e){return lib$es6$promise$asap$$useSetTimeout()}}var lib$es6$promise$asap$$scheduleFlush;if(lib$es6$promise$asap$$isNode){lib$es6$promise$asap$$scheduleFlush=lib$es6$promise$asap$$useNextTick()}else if(lib$es6$promise$asap$$BrowserMutationObserver){lib$es6$promise$asap$$scheduleFlush=lib$es6$promise$asap$$useMutationObserver()}else if(lib$es6$promise$asap$$isWorker){lib$es6$promise$asap$$scheduleFlush=lib$es6$promise$asap$$useMessageChannel()}else if(lib$es6$promise$asap$$browserWindow===undefined&&typeof require==="function"){lib$es6$promise$asap$$scheduleFlush=lib$es6$promise$asap$$attemptVertex()}else{lib$es6$promise$asap$$scheduleFlush=lib$es6$promise$asap$$useSetTimeout()}function lib$es6$promise$$internal$$noop(){}var lib$es6$promise$$internal$$PENDING=void 0;var lib$es6$promise$$internal$$FULFILLED=1;var lib$es6$promise$$internal$$REJECTED=2;var lib$es6$promise$$internal$$GET_THEN_ERROR=new lib$es6$promise$$internal$$ErrorObject;function lib$es6$promise$$internal$$selfFullfillment(){return new TypeError("You cannot resolve a promise with itself")}function lib$es6$promise$$internal$$cannotReturnOwn(){return new TypeError("A promises callback cannot return that same promise.")}function lib$es6$promise$$internal$$getThen(promise){try{return promise.then}catch(error){lib$es6$promise$$internal$$GET_THEN_ERROR.error=error;return lib$es6$promise$$internal$$GET_THEN_ERROR}}function lib$es6$promise$$internal$$tryThen(then,value,fulfillmentHandler,rejectionHandler){try{then.call(value,fulfillmentHandler,rejectionHandler)}catch(e){return e}}function lib$es6$promise$$internal$$handleForeignThenable(promise,thenable,then){lib$es6$promise$asap$$default(function(promise){var sealed=false;var error=lib$es6$promise$$internal$$tryThen(then,thenable,function(value){if(sealed){return}sealed=true;if(thenable!==value){lib$es6$promise$$internal$$resolve(promise,value)}else{lib$es6$promise$$internal$$fulfill(promise,value)}},function(reason){if(sealed){return}sealed=true;lib$es6$promise$$internal$$reject(promise,reason)},"Settle: "+(promise._label||" unknown promise"));if(!sealed&&error){sealed=true;lib$es6$promise$$internal$$reject(promise,error)}},promise)}function lib$es6$promise$$internal$$handleOwnThenable(promise,thenable){if(thenable._state===lib$es6$promise$$internal$$FULFILLED){lib$es6$promise$$internal$$fulfill(promise,thenable._result)}else if(thenable._state===lib$es6$promise$$internal$$REJECTED){lib$es6$promise$$internal$$reject(promise,thenable._result)}else{lib$es6$promise$$internal$$subscribe(thenable,undefined,function(value){lib$es6$promise$$internal$$resolve(promise,value)},function(reason){lib$es6$promise$$internal$$reject(promise,reason)})}}function lib$es6$promise$$internal$$handleMaybeThenable(promise,maybeThenable){if(maybeThenable.constructor===promise.constructor){lib$es6$promise$$internal$$handleOwnThenable(promise,maybeThenable)}else{var then=lib$es6$promise$$internal$$getThen(maybeThenable);if(then===lib$es6$promise$$internal$$GET_THEN_ERROR){lib$es6$promise$$internal$$reject(promise,lib$es6$promise$$internal$$GET_THEN_ERROR.error)}else if(then===undefined){lib$es6$promise$$internal$$fulfill(promise,maybeThenable)}else if(lib$es6$promise$utils$$isFunction(then)){lib$es6$promise$$internal$$handleForeignThenable(promise,maybeThenable,then)}else{lib$es6$promise$$internal$$fulfill(promise,maybeThenable)}}}function lib$es6$promise$$internal$$resolve(promise,value){if(promise===value){lib$es6$promise$$internal$$reject(promise,lib$es6$promise$$internal$$selfFullfillment())}else if(lib$es6$promise$utils$$objectOrFunction(value)){lib$es6$promise$$internal$$handleMaybeThenable(promise,value)}else{lib$es6$promise$$internal$$fulfill(promise,value)}}function lib$es6$promise$$internal$$publishRejection(promise){if(promise._onerror){promise._onerror(promise._result)}lib$es6$promise$$internal$$publish(promise)}function lib$es6$promise$$internal$$fulfill(promise,value){if(promise._state!==lib$es6$promise$$internal$$PENDING){return}promise._result=value;promise._state=lib$es6$promise$$internal$$FULFILLED;if(promise._subscribers.length!==0){lib$es6$promise$asap$$default(lib$es6$promise$$internal$$publish,promise)}}function lib$es6$promise$$internal$$reject(promise,reason){if(promise._state!==lib$es6$promise$$internal$$PENDING){return}promise._state=lib$es6$promise$$internal$$REJECTED;promise._result=reason;lib$es6$promise$asap$$default(lib$es6$promise$$internal$$publishRejection,promise)}function lib$es6$promise$$internal$$subscribe(parent,child,onFulfillment,onRejection){var subscribers=parent._subscribers;var length=subscribers.length;parent._onerror=null;subscribers[length]=child;subscribers[length+lib$es6$promise$$internal$$FULFILLED]=onFulfillment;subscribers[length+lib$es6$promise$$internal$$REJECTED]=onRejection;if(length===0&&parent._state){lib$es6$promise$asap$$default(lib$es6$promise$$internal$$publish,parent)}}function lib$es6$promise$$internal$$publish(promise){var subscribers=promise._subscribers;var settled=promise._state;if(subscribers.length===0){return}var child,callback,detail=promise._result;for(var i=0;i<subscribers.length;i+=3){child=subscribers[i];callback=subscribers[i+settled];if(child){lib$es6$promise$$internal$$invokeCallback(settled,child,callback,detail)}else{callback(detail)}}promise._subscribers.length=0}function lib$es6$promise$$internal$$ErrorObject(){this.error=null}var lib$es6$promise$$internal$$TRY_CATCH_ERROR=new lib$es6$promise$$internal$$ErrorObject;function lib$es6$promise$$internal$$tryCatch(callback,detail){try{return callback(detail)}catch(e){lib$es6$promise$$internal$$TRY_CATCH_ERROR.error=e;return lib$es6$promise$$internal$$TRY_CATCH_ERROR}}function lib$es6$promise$$internal$$invokeCallback(settled,promise,callback,detail){var hasCallback=lib$es6$promise$utils$$isFunction(callback),value,error,succeeded,failed;if(hasCallback){value=lib$es6$promise$$internal$$tryCatch(callback,detail);if(value===lib$es6$promise$$internal$$TRY_CATCH_ERROR){failed=true;error=value.error;value=null}else{succeeded=true}if(promise===value){lib$es6$promise$$internal$$reject(promise,lib$es6$promise$$internal$$cannotReturnOwn());return}}else{value=detail;succeeded=true}if(promise._state!==lib$es6$promise$$internal$$PENDING){}else if(hasCallback&&succeeded){lib$es6$promise$$internal$$resolve(promise,value)}else if(failed){lib$es6$promise$$internal$$reject(promise,error)}else if(settled===lib$es6$promise$$internal$$FULFILLED){lib$es6$promise$$internal$$fulfill(promise,value)}else if(settled===lib$es6$promise$$internal$$REJECTED){lib$es6$promise$$internal$$reject(promise,value)}}function lib$es6$promise$$internal$$initializePromise(promise,resolver){try{resolver(function resolvePromise(value){lib$es6$promise$$internal$$resolve(promise,value)},function rejectPromise(reason){lib$es6$promise$$internal$$reject(promise,reason)})}catch(e){lib$es6$promise$$internal$$reject(promise,e)}}function lib$es6$promise$enumerator$$Enumerator(Constructor,input){var enumerator=this;enumerator._instanceConstructor=Constructor;enumerator.promise=new Constructor(lib$es6$promise$$internal$$noop);if(enumerator._validateInput(input)){enumerator._input=input;enumerator.length=input.length;enumerator._remaining=input.length;enumerator._init();if(enumerator.length===0){lib$es6$promise$$internal$$fulfill(enumerator.promise,enumerator._result)}else{enumerator.length=enumerator.length||0;enumerator._enumerate();if(enumerator._remaining===0){lib$es6$promise$$internal$$fulfill(enumerator.promise,enumerator._result)}}}else{lib$es6$promise$$internal$$reject(enumerator.promise,enumerator._validationError())}}lib$es6$promise$enumerator$$Enumerator.prototype._validateInput=function(input){return lib$es6$promise$utils$$isArray(input)};lib$es6$promise$enumerator$$Enumerator.prototype._validationError=function(){return new Error("Array Methods must be provided an Array")};lib$es6$promise$enumerator$$Enumerator.prototype._init=function(){this._result=new Array(this.length)};var lib$es6$promise$enumerator$$default=lib$es6$promise$enumerator$$Enumerator;lib$es6$promise$enumerator$$Enumerator.prototype._enumerate=function(){var enumerator=this;var length=enumerator.length;var promise=enumerator.promise;var input=enumerator._input;for(var i=0;promise._state===lib$es6$promise$$internal$$PENDING&&i<length;i++){enumerator._eachEntry(input[i],i)}};lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry=function(entry,i){var enumerator=this;var c=enumerator._instanceConstructor;if(lib$es6$promise$utils$$isMaybeThenable(entry)){if(entry.constructor===c&&entry._state!==lib$es6$promise$$internal$$PENDING){entry._onerror=null;enumerator._settledAt(entry._state,i,entry._result)}else{enumerator._willSettleAt(c.resolve(entry),i)}}else{enumerator._remaining--;enumerator._result[i]=entry}};lib$es6$promise$enumerator$$Enumerator.prototype._settledAt=function(state,i,value){var enumerator=this;var promise=enumerator.promise;if(promise._state===lib$es6$promise$$internal$$PENDING){enumerator._remaining--;if(state===lib$es6$promise$$internal$$REJECTED){lib$es6$promise$$internal$$reject(promise,value)}else{enumerator._result[i]=value}}if(enumerator._remaining===0){lib$es6$promise$$internal$$fulfill(promise,enumerator._result)}};lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt=function(promise,i){var enumerator=this;lib$es6$promise$$internal$$subscribe(promise,undefined,function(value){enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED,i,value)},function(reason){enumerator._settledAt(lib$es6$promise$$internal$$REJECTED,i,reason)})};function lib$es6$promise$promise$all$$all(entries){return new lib$es6$promise$enumerator$$default(this,entries).promise}var lib$es6$promise$promise$all$$default=lib$es6$promise$promise$all$$all;function lib$es6$promise$promise$race$$race(entries){var Constructor=this;var promise=new Constructor(lib$es6$promise$$internal$$noop);if(!lib$es6$promise$utils$$isArray(entries)){lib$es6$promise$$internal$$reject(promise,new TypeError("You must pass an array to race."));return promise}var length=entries.length;function onFulfillment(value){lib$es6$promise$$internal$$resolve(promise,value)}function onRejection(reason){lib$es6$promise$$internal$$reject(promise,reason)}for(var i=0;promise._state===lib$es6$promise$$internal$$PENDING&&i<length;i++){lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]),undefined,onFulfillment,onRejection)}return promise}var lib$es6$promise$promise$race$$default=lib$es6$promise$promise$race$$race;function lib$es6$promise$promise$resolve$$resolve(object){var Constructor=this;if(object&&typeof object==="object"&&object.constructor===Constructor){return object}var promise=new Constructor(lib$es6$promise$$internal$$noop);lib$es6$promise$$internal$$resolve(promise,object);return promise}var lib$es6$promise$promise$resolve$$default=lib$es6$promise$promise$resolve$$resolve;function lib$es6$promise$promise$reject$$reject(reason){var Constructor=this;var promise=new Constructor(lib$es6$promise$$internal$$noop);lib$es6$promise$$internal$$reject(promise,reason);return promise}var lib$es6$promise$promise$reject$$default=lib$es6$promise$promise$reject$$reject;var lib$es6$promise$promise$$counter=0;function lib$es6$promise$promise$$needsResolver(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function lib$es6$promise$promise$$needsNew(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}var lib$es6$promise$promise$$default=lib$es6$promise$promise$$Promise;function lib$es6$promise$promise$$Promise(resolver){this._id=lib$es6$promise$promise$$counter++;this._state=undefined;this._result=undefined;this._subscribers=[];if(lib$es6$promise$$internal$$noop!==resolver){if(!lib$es6$promise$utils$$isFunction(resolver)){lib$es6$promise$promise$$needsResolver()}if(!(this instanceof lib$es6$promise$promise$$Promise)){lib$es6$promise$promise$$needsNew()}lib$es6$promise$$internal$$initializePromise(this,resolver)}}lib$es6$promise$promise$$Promise.all=lib$es6$promise$promise$all$$default;lib$es6$promise$promise$$Promise.race=lib$es6$promise$promise$race$$default;lib$es6$promise$promise$$Promise.resolve=lib$es6$promise$promise$resolve$$default;lib$es6$promise$promise$$Promise.reject=lib$es6$promise$promise$reject$$default;lib$es6$promise$promise$$Promise.prototype={constructor:lib$es6$promise$promise$$Promise,then:function(onFulfillment,onRejection){var parent=this;var state=parent._state;if(state===lib$es6$promise$$internal$$FULFILLED&&!onFulfillment||state===lib$es6$promise$$internal$$REJECTED&&!onRejection){return this}var child=new this.constructor(lib$es6$promise$$internal$$noop);var result=parent._result;if(state){var callback=arguments[state-1];lib$es6$promise$asap$$default(function(){lib$es6$promise$$internal$$invokeCallback(state,child,callback,result)})}else{lib$es6$promise$$internal$$subscribe(parent,child,onFulfillment,onRejection)}return child},"catch":function(onRejection){return this.then(null,onRejection)}};function lib$es6$promise$polyfill$$polyfill(){var local;if(typeof global!=="undefined"){local=global}else if(typeof self!=="undefined"){local=self}else{try{local=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}}var P=local.Promise;if(P&&Object.prototype.toString.call(P.resolve())==="[object Promise]"&&!P.cast){return}local.Promise=lib$es6$promise$promise$$default}var lib$es6$promise$polyfill$$default=lib$es6$promise$polyfill$$polyfill;var lib$es6$promise$umd$$ES6Promise={Promise:lib$es6$promise$promise$$default,polyfill:lib$es6$promise$polyfill$$default};if(typeof define==="function"&&define["amd"]){define('es6-promise',[],function(){return lib$es6$promise$umd$$ES6Promise})}else if(typeof module!=="undefined"&&module["exports"]){module["exports"]=lib$es6$promise$umd$$ES6Promise}else if(typeof this!=="undefined"){this["ES6Promise"]=lib$es6$promise$umd$$ES6Promise}lib$es6$promise$polyfill$$default()}).call(this);

// Object.assign polyfill
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

if (!Object.assign) {
  Object.defineProperty(Object, 'assign', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(target) {
      
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert first argument to object');
      }

      var to = Object(target);
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
          continue;
        }
        nextSource = Object(nextSource);

        var keysArray = Object.keys(nextSource);
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
      return to;
    }
  });
}
;
define("es6-polyfills", function(){});

(function() {
    var eventEvents, adapterEvent, eventTracker, Controller, handlersMouse, adapterToucharea, handlersTouch, Pointer, jquerypointerHooks, Bootstrapjquery, _Util_;
    _Util_ = function(require) {
        var _addOrRemoveEvent = function(event, callback, target, add) {
            if (!target) {
                target = document.body;
            }
            var i = 0;
            var events = event instanceof Array ? event : event.split(" ");
            var length = events.length;
            var method = (add ? "add" : "remove") + "EventListener";
            for (;i < length; i++) {
                if (target[method]) {
                    target[method](events[i], callback, false);
                } else {
                    target[(add ? "attach" : "detach") + "Event"]("on" + events[i], callback);
                }
            }
        };
        return {
            on: function(event, callback, target) {
                _addOrRemoveEvent(event, callback, target, true);
                return this;
            },
            off: function(event, callback, target) {
                _addOrRemoveEvent(event, callback, target);
                return this;
            },
            indexOf: function(array, item) {
                var i = 0;
                var length = array.length;
                for (;i < length; i++) {
                    if (array[i] === item) {
                        return i;
                    }
                }
                return -1;
            },
            contains: function(target, child) {
                if (target === child) {
                    return true;
                }
                if (target.contains) {
                    return target.contains(child);
                } else {
                    do {
                        if (child === target) {
                            return true;
                        }
                    } while (child = child.parentNode);
                    return false;
                }
            },
            getTarget: function(event, target) {
                target = target || event.target || event.srcElement || document;
                if (target.nodeType === 3) {
                    target = target.parentNode;
                }
                return target;
            },
            now: Date.now || function() {
                return +new Date();
            },
            getId: function(event) {
                var point = 0;
                if ("identifier" in event) {
                    point = event.identifier + 1;
                }
                return point;
            }
        };
    }({});
    eventEvents = function(require) {
        var _defineEvents = function(namespace, isTouch) {
            return [ namespace + "enter", namespace + "over", namespace + (isTouch ? "start" : "down"), namespace + "move", namespace + (isTouch ? "end" : "up"), namespace + "out", namespace + "leave", namespace + "cancel" ];
        };
        var PointerEvents = _defineEvents("pointer");
        var MouseEvents = _defineEvents("mouse");
        var TouchEvents = _defineEvents("touch", true);
        var MAP = {};
        var i = 0;
        var length = PointerEvents.length;
        for (;i < length; i++) {
            if (TouchEvents[i]) {
                MAP[TouchEvents[i]] = PointerEvents[i];
            }
            if (MouseEvents[i]) {
                MAP[MouseEvents[i]] = PointerEvents[i];
            }
        }
        return {
            POINTER: PointerEvents,
            MOUSE: MouseEvents,
            TOUCH: TouchEvents,
            MAP: MAP
        };
    }({});
    adapterEvent = function(require) {
        var $ = window.jQuery;
        return {
            create: function(type, originalEvent, properties, bubbles) {
                var event = $.Event(originalEvent, properties);
                event.type = type;
                event.bubbles = bubbles !== false;
                return event;
            },
            trigger: function(event, target) {
                if (!target.setPointerCapture) {
                    eventTracker.setCaptureMethods(target);
                }
                $.event.trigger(event, null, target, !event.bubbles);
            }
        };
    }({});
    eventTracker = function(require) {
        var Adapter = adapterEvent;
        var Util = _Util_;
        var MAP = {
            mouseover: "touchover",
            mousedown: "touchstart",
            mousemove: "touchend",
            mouseup: "touchend",
            mouseout: "touchstart"
        };
        var LAST_EVENTS = {
            touchover: {},
            touchstart: {},
            touchend: {},
            touchout: {}
        };
        var TARGET_LOCKS = {};
        var DELTA_TIME = 3e3;
        var CAPTURE_DATA = {
            cancelable: false
        };
        return {
            hasTouched: false,
            isMouseDown: false,
            init: function() {
                var element = window.Element;
                if (element) {
                    this.setCaptureMethods(element.prototype);
                }
            },
            setCaptureMethods: function(target) {
                target.setPointerCapture = this.capturePointer;
                target.releasePointerCapture = this.releasePointer;
            },
            capturePointer: function(pointerId) {
                TARGET_LOCKS[pointerId] = this;
                var event = Adapter.create("gotpointercapture", null, CAPTURE_DATA);
                Adapter.trigger(event, this);
            },
            releasePointer: function(pointerId) {
                var lastTarget = TARGET_LOCKS[pointerId];
                TARGET_LOCKS[pointerId] = null;
                if (lastTarget) {
                    var event = Adapter.create("lostpointercapture", null, CAPTURE_DATA);
                    Adapter.trigger(event, lastTarget);
                }
            },
            register: function(event, overrideEventName, target) {
                var eventName = overrideEventName || event.type;
                if (LAST_EVENTS.hasOwnProperty(eventName)) {
                    LAST_EVENTS[eventName][event.pointerId] = {
                        timeStamp: Util.now(),
                        x: event.clientX,
                        y: event.clientY,
                        target: target || event.target
                    };
                    this.hasTouched = true;
                }
                return this;
            },
            getTarget: function(pointerEvent) {
                return TARGET_LOCKS[pointerEvent.pointerId || pointerEvent];
            },
            isSimulated: function(event) {
                if (!MAP.hasOwnProperty(event.type)) {
                    return false;
                }
                var eventName = MAP[event.type];
                var previousEvent = LAST_EVENTS[eventName];
                if (!previousEvent) {
                    return false;
                }
                var pointerId;
                var pointer;
                var now = Util.now();
                var target = Util.getTarget(event);
                if (event.type === "mouseout") {
                    target = event.relatedTarget;
                }
                for (pointerId in previousEvent) {
                    if (!previousEvent.hasOwnProperty(pointerId) || !previousEvent[pointerId]) {
                        continue;
                    }
                    pointer = previousEvent[pointerId];
                    if (Math.abs(now - pointer.timeStamp) > DELTA_TIME) {
                        LAST_EVENTS[eventName][pointerId] = null;
                        continue;
                    }
                    if (pointer.target === target && pointer.x === event.clientX && pointer.y === event.clientY) {
                        return true;
                    }
                }
                return false;
            }
        };
    }({});
    Controller = function(require) {
        var Events = eventEvents;
        var Adapter = adapterEvent;
        var Tracker = eventTracker;
        var Util = _Util_;
        var PointerEvents = Events.POINTER;
        var PROPS = {
            screenX: 0,
            screenY: 0,
            pageX: 0,
            pageY: 0,
            offsetX: 0,
            offsetY: 0,
            clientX: 0,
            clientY: 0,
            view: null,
            detail: null,
            ctrlKey: false,
            altKey: false,
            shiftKey: false,
            metaKey: false,
            button: 0,
            relatedTarget: null,
            width: 0,
            height: 0,
            tiltX: 0,
            tiltY: 0,
            pressure: .5
        };
        var _getProperties = function(type, originalEvent, touchIndex) {
            var source = originalEvent;
            var pointerId = 0;
            var pointerType = "mouse";
            var properties = {
                timeStamp: originalEvent.timeStamp || Util.now()
            };
            if (originalEvent.type.indexOf("touch") === 0) {
                source = originalEvent.changedTouches[touchIndex || 0];
                pointerId = 1 + (touchIndex || 0);
                pointerType = "touch";
            }
            properties.isPrimary = pointerId <= 1;
            var name;
            for (name in PROPS) {
                if (PROPS.hasOwnProperty(name)) {
                    properties[name] = source[name] || PROPS[name];
                }
            }
            if (!properties.pageX && properties.clientX) {
                properties.pageX = properties.clientX + _getPageOffset(true);
                properties.pageY = properties.clientY + _getPageOffset();
            }
            properties.x = properties.pageX;
            properties.y = properties.pageY;
            if (pointerId == 0) {
                properties.pressure = Tracker.isMouseDown ? .5 : 0;
            }
            properties.pointerId = pointerId;
            properties.pointerType = pointerType;
            return properties;
        };
        var _getPageOffset = function(left) {
            var doc = document;
            var body = doc.body;
            var prop = left ? "Left" : "Top";
            var scroll = "scroll" + prop;
            var client = "client" + prop;
            return (doc[scroll] || body[scroll] || 0) - (doc[client] || body[client] || 0);
        };
        var _detectEnterOrLeave = function(eventName, event, target, relatedTarget, pointerId) {
            var pointerEvent;
            if (!relatedTarget) {
                relatedTarget = event.relatedTarget;
            }
            do {
                if (!relatedTarget || !Util.contains(target, relatedTarget)) {
                    pointerEvent = _create(eventName, event, pointerId);
                    if (pointerEvent) {
                        if (pointerEvent.pointerType === "touch") {
                            Tracker.register(pointerEvent, eventName, target);
                        }
                        Adapter.trigger(pointerEvent, target);
                    }
                } else {
                    break;
                }
            } while (target = target.parentNode);
        };
        var _create = function(type, originalEvent, touchIndex) {
            var properties = _getProperties(type, originalEvent, touchIndex);
            return Adapter.create(type, originalEvent, properties, type !== PointerEvents[0] && type !== PointerEvents[6]);
        };
        var _trigger = function(originalEvent, target, overrideType, touchIndex, relatedTarget) {
            var eventName = overrideType || originalEvent.type;
            if (!originalEvent || !Events.MAP.hasOwnProperty(eventName)) {
                return;
            }
            var type = Events.MAP[eventName];
            var pointerId = touchIndex || 0;
            var event = _create(type, originalEvent, pointerId);
            target = Util.getTarget(originalEvent, target);
            if (event) {
                if (event.pointerType === "touch") {
                    Tracker.register(event, eventName, target);
                }
                if (type === PointerEvents[1]) {
                    _detectEnterOrLeave(PointerEvents[0], originalEvent, target, relatedTarget, pointerId);
                }
                Adapter.trigger(event, target);
                if (event.type === PointerEvents[4] || event.type === PointerEvents[7]) {
                    Tracker.releasePointer(event.pointerId);
                }
                if (type === PointerEvents[5]) {
                    _detectEnterOrLeave(PointerEvents[6], originalEvent, target, relatedTarget, pointerId);
                }
            }
        };
        return {
            create: _create,
            trigger: _trigger
        };
    }({});
    handlersMouse = function(require) {
        var Util = _Util_;
        var Events = eventEvents.MOUSE;
        var Tracker = eventTracker;
        var _on = _Util_.on;
        var trigger = Controller.trigger;
        var EVENT_OVER = Events[1];
        var EVENT_DOWN = Events[2];
        var EVENT_MOVE = Events[3];
        var EVENT_UP = Events[4];
        var EVENT_OUT = Events[5];
        var _onMouseUp = function(event) {
            Tracker.isMouseActive = false;
            if (event.target === document.documentElement) {
                Tracker.releasePointer(Util.getId(event));
            }
        };
        _on("mouseup", _onMouseUp, window);
        _on("contextmenu", _onMouseUp, window);
        return {
            events: [ EVENT_OVER, EVENT_DOWN, EVENT_MOVE, EVENT_UP, EVENT_OUT ],
            onEvent: function(event) {
                if (Tracker.hasTouched && Tracker.isSimulated(event)) {
                    try {
                        event._isSimulated = true;
                    } catch (e) {}
                    return;
                }
                if (event.type === EVENT_DOWN) {
                    Tracker.isMouseDown = true;
                } else if (event.type === EVENT_UP) {
                    Tracker.isMouseDown = false;
                }
                trigger(event, Tracker.getTarget(Util.getId(event)));
            }
        };
    }({});
    adapterToucharea = function(require) {
        var ATTRIBUTE = "touch-action";
        return {
            detect: function(target) {
                while (target.hasAttribute && !target.hasAttribute(ATTRIBUTE)) {
                    target = target.parentNode;
                }
                return target.getAttribute && target.getAttribute(ATTRIBUTE) === "none" || false;
            }
        };
    }({});
    handlersTouch = function(require) {
        var Util = _Util_;
        var Events = eventEvents.TOUCH;
        var TouchAreaAdapter = adapterToucharea;
        var Tracker = eventTracker;
        var trigger = Controller.trigger;
        var EVENT_OVER = Events[1];
        var EVENT_START = Events[2];
        var EVENT_MOVE = Events[3];
        var EVENT_END = Events[4];
        var EVENT_OUT = Events[5];
        var EVENT_CANCEL = Events[7];
        var PREVIOUS_TARGETS = {};
        var PREVIOUS_POSITIONS = {};
        var _onPointCancel = function(point, event, pointIndex) {
            PREVIOUS_TARGETS[point.identifier] = null;
            trigger(event, event.target, EVENT_CANCEL, pointIndex);
            trigger(event, event.target, EVENT_OUT, pointIndex);
        };
        var _onPointMove = function(point, event, pointIndex) {
            var identifier = point.identifier;
            var newTarget = Tracker.getTarget(Util.getId(point)) || document.elementFromPoint(point.clientX, point.clientY);
            var currentTarget = PREVIOUS_TARGETS[identifier];
            PREVIOUS_TARGETS[identifier] = newTarget;
            if (newTarget !== currentTarget) {
                if (currentTarget) {
                    trigger(event, currentTarget, EVENT_OUT, pointIndex, newTarget);
                }
                if (newTarget) {
                    trigger(event, newTarget, EVENT_OVER, pointIndex, currentTarget);
                }
            }
            trigger(event, newTarget, EVENT_MOVE, pointIndex);
            if (newTarget && TouchAreaAdapter.detect(newTarget)) {
                event.preventDefault();
            }
        };
        var _onPointStartEnd = function(point, event, pointIndex) {
            var identifier = point.identifier;
            var target = Tracker.getTarget(Util.getId(point)) || event.target;
            var type = event.type;
            if (type === EVENT_START) {
                PREVIOUS_TARGETS[identifier] = target;
                trigger(event, target, EVENT_OVER, pointIndex);
            }
            var currentTarget = PREVIOUS_TARGETS[identifier] || target;
            trigger(event, currentTarget, type, pointIndex);
            if (type === EVENT_END) {
                PREVIOUS_TARGETS[identifier] = null;
                trigger(event, currentTarget, EVENT_OUT, pointIndex);
            }
        };
        return {
            events: [ EVENT_START, EVENT_MOVE, EVENT_END, EVENT_CANCEL ],
            onEvent: function(event) {
                var i = -1;
                var type = event.type;
                var id;
                var touch;
                var position;
                var method = _onPointCancel;
                if (type === EVENT_START || type === EVENT_END) {
                    method = _onPointStartEnd;
                } else if (type === EVENT_MOVE) {
                    method = _onPointMove;
                }
                while (touch = event.changedTouches[++i]) {
                    id = touch.identifier;
                    if (type === EVENT_MOVE) {
                        position = touch.pageX + "|" + touch.pageY;
                        if (PREVIOUS_POSITIONS[id] === position) {
                            continue;
                        }
                        PREVIOUS_POSITIONS[id] = position;
                    }
                    method(touch, event, i);
                }
            }
        };
    }({});
    Pointer = function(require) {
        var Util = _Util_;
        var MouseHandler = handlersMouse;
        var TouchHandler = handlersTouch;
        var navigator = window.navigator;
        return function() {
            navigator.pointerEnabled = true;
            navigator.maxTouchPoints = 10;
            Util.on(TouchHandler.events, TouchHandler.onEvent).on(MouseHandler.events, MouseHandler.onEvent);
        };
    }({});
    (function($) {
        var events = [ "pointerenter", "pointerover", "pointerdown", "pointermove", "pointerup", "pointerout", "pointerleave", "pointercancel" ];
        var fixHook = {
            props: [ "pageX", "pageY", "clientX", "clientY", "screenX", "screenY", "relatedTarget", "pointerId", "pointerType", "x", "y", "isPrimary", "width", "height", "tiltX", "tiltY", "pressure" ]
        };
        var i = 0;
        var length = events.length;
        for (;i < length; i++) {
            $.event.fixHooks[events[i]] = fixHook;
        }
    })(jQuery);
    jquerypointerHooks = undefined;
    (function(Pointer, EventTracker) {
        if (window.navigator.pointerEnabled === true) {
            return;
        }
        EventTracker.init();
        window.jQuery(document).ready(Pointer);
    })(Pointer, eventTracker);
    Bootstrapjquery = undefined;
})();

define("pointer", ["jquery"], function(){});

/*! eq.js (with polyfills) v1.7.1 (c) 2013-2015 Sam Richard with thanks to the Financial Times, MIT license */
!function(){"getPrototypeOf"in Object||(Object.getPrototypeOf=function(t){if(t!==Object(t))throw new TypeError("Object.getPrototypeOf called on non-object");return t.constructor?t.constructor.prototype:null}),"requestAnimationFrame"in this||!function(t){var e=Date.now();t.requestAnimationFrame=function(t){if("function"!=typeof t)throw new TypeError(t+"is not a function");var n=Date.now(),o=16+e-n;return 0>o&&(o=0),e=n,setTimeout(function(){e=Date.now(),t(performance.now())},o)},t.cancelAnimationFrame=function(t){clearTimeout(t)}}(this),function(t){if(!("Event"in t))return!1;if("function"==typeof t.Event)return!0;try{return new Event("click"),!0}catch(e){return!1}}(this)||(this.Event=function(t,e){if(!t)throw new Error("Not enough arguments");var n=document.createEvent("Event"),o=e&&void 0!==e.bubbles?e.bubbles:!1,r=e&&void 0!==e.cancelable?e.cancelable:!1;return n.initEvent(t,o,r),n}),"CustomEvent"in this&&("function"==typeof this.CustomEvent||this.CustomEvent.toString().indexOf("CustomEventConstructor")>-1)||(this.CustomEvent=function(t,e){if(!t)throw Error('TypeError: Failed to construct "CustomEvent": An event name must be provided.');var n;e=e||{bubbles:!1,cancelable:!1,detail:null};try{n=document.createEvent("CustomEvent"),n.initCustomEvent(t,e.bubbles,e.cancelable,e.detail)}catch(o){n=document.createEvent("Event"),n.initEvent(t,e.bubbles,e.cancelable),n.detail=e.detail}return n},CustomEvent.prototype=Event.prototype),"addEventListener"in this||document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&document.dispatchEvent(new Event("DOMContentLoaded",{bubbles:!0}))}),"getComputedStyle"in this||!function(t){function e(t,n,o){var r,i=t.document&&t.currentStyle[n].match(/([\d\.]+)(%|cm|em|in|mm|pc|pt|)/)||[0,0,""],u=i[1],c=i[2];return o=o?/%|em/.test(c)&&t.parentElement?e(t.parentElement,"fontSize",null):16:o,r="fontSize"==n?o:/width/i.test(n)?t.clientWidth:t.clientHeight,"%"==c?u/100*r:"cm"==c?.3937*u*96:"em"==c?u*o:"in"==c?96*u:"mm"==c?.3937*u*96/10:"pc"==c?12*u*96/72:"pt"==c?96*u/72:u}function n(t,e){var n="border"==e?"Width":"",o=e+"Top"+n,r=e+"Right"+n,i=e+"Bottom"+n,u=e+"Left"+n;t[e]=(t[o]==t[r]&&t[o]==t[i]&&t[o]==t[u]?[t[o]]:t[o]==t[i]&&t[u]==t[r]?[t[o],t[r]]:t[u]==t[r]?[t[o],t[r],t[i]]:[t[o],t[r],t[i],t[u]]).join(" ")}function o(t){var o,r=this,i=t.currentStyle,u=e(t,"fontSize"),c=function(t){return"-"+t.toLowerCase()};for(o in i)if(Array.prototype.push.call(r,"styleFloat"==o?"float":o.replace(/[A-Z]/,c)),"width"==o)r[o]=t.offsetWidth+"px";else if("height"==o)r[o]=t.offsetHeight+"px";else if("styleFloat"==o)r.float=i[o];else if(/margin.|padding.|border.+W/.test(o)&&"auto"!=r[o])r[o]=Math.round(e(t,o,u))+"px";else if(/^outline/.test(o))try{r[o]=i[o]}catch(a){r.outlineColor=i.color,r.outlineStyle=r.outlineStyle||"none",r.outlineWidth=r.outlineWidth||"0px",r.outline=[r.outlineColor,r.outlineWidth,r.outlineStyle].join(" ")}else r[o]=i[o];n(r,"margin"),n(r,"padding"),n(r,"border"),r.fontSize=Math.round(u)+"px"}o.prototype={constructor:o,getPropertyPriority:function(){throw new Error("NotSupportedError: DOM Exception 9")},getPropertyValue:function(t){return this[t.replace(/-\w/g,function(t){return t[1].toUpperCase()})]},item:function(t){return this[t]},removeProperty:function(){throw new Error("NoModificationAllowedError: DOM Exception 7")},setProperty:function(){throw new Error("NoModificationAllowedError: DOM Exception 7")},getPropertyCSSValue:function(){throw new Error("NotSupportedError: DOM Exception 9")}},t.getComputedStyle=function(t){return new o(t)}}(this),"forEach"in Array.prototype||(Array.prototype.forEach=function(t){if(void 0===this||null===this)throw new TypeError(this+"is not an object");if(!(t instanceof Function))throw new TypeError(t+" is not a function");for(var e=Object(this),n=arguments[1],o=e instanceof String?e.split(""):e,r=Math.max(Math.min(o.length,9007199254740991),0)||0,i=-1;++i<r;)i in o&&t.call(n,o[i],i,e)})}(),function(t){function e(){this.nodes=[],this.eqsLength=0,this.widths=[],this.points=[],this.callback=void 0}function n(t,e,n){t.addEventListener?t.addEventListener(e,n,!1):t.attachEvent("on"+e,function(){return n.call(t,window.event)})}function o(t){return window.getComputedStyle(t,":before").getPropertyValue("content").slice(1,-1)}var r=function(t,e){return[].slice.call(t).concat([].slice.call(e))};e.prototype.query=function(e,n){var r,i=Object.getPrototypeOf(t);n&&"function"==typeof n&&(i.callback=n),e&&"number"!=typeof e?r=e.length:(e=i.nodes,r=i.nodesLength);var u,c=[],a=[];for(u=0;r>u;u++){c.push(e[u].offsetWidth);try{a.push(i.sortObj(e[u].getAttribute("data-eq-pts")))}catch(s){try{a.push(i.sortObj(o(e[u])))}catch(l){a.push([{key:"",value:0}])}}}i.widths=c,i.points=a,e&&"number"!=typeof e?i.nodeWrites(e,c,a):n&&"function"!=typeof n?i.nodeWrites():window.requestAnimationFrame(i.nodeWrites)},e.prototype.nodeWrites=function(e){var n,o,r,i,u,c,a,s=Object.getPrototypeOf(t),l=s.widths,f=s.points;for(e&&"number"!=typeof e?i=e.length:(e=s.nodes,i=s.nodesLength),n=0;i>n;n++){var d=l[n],p=e[n],h=f[n],y=[],v=h.length;if(d<h[0].value)a=null;else if(d>=h[v-1].value){for(r=0;v>r;r++)y.push(h[r].key);a=y.join(" ")}else for(o=0;v>o;o++){var m=h[o],b=h[o+1];if(y.push(m.key),0===o&&d<m.value){a=null;break}if(void 0===b.value){y.push(b.key),a=y.join(" ");break}if(d>=m.value&&d<b.value){a=y.join(" ");break}}null===a?p.removeAttribute("data-eq-state"):p.setAttribute("data-eq-state",a),c=new CustomEvent("eqResize",{detail:a,bubbles:!0}),p.dispatchEvent(c)}s.callback&&(u=s.callback,s.callback=void 0,u(e))},e.prototype.refreshNodes=function(){var e=Object.getPrototypeOf(t),n=[];e.nodes=document.querySelectorAll("[data-eq-pts]"),n=o(document.querySelector("html")).split(", "),n.forEach(function(t){""!==t&&(e.nodes=r(e.nodes,document.querySelectorAll(t)))}),e.nodesLength=e.nodes.length},e.prototype.sortObj=function(t){for(var e=[],n=t.split(","),o=0;o<n.length;o++){var r=n[o].split(":");e.push({key:r[0].replace(/^\s+|\s+$/g,""),value:parseFloat(r[1])})}return e.sort(function(t,e){return t.value-e.value})},t=t||new e,n(window,"DOMContentLoaded",function(){t.refreshNodes(),t.query(void 0,!0)}),n(window,"load",function(){t.refreshNodes(),t.query(void 0,!0)}),n(window,"resize",function(){t.refreshNodes(),window.requestAnimationFrame(t.query)}),"undefined"!=typeof module&&module.exports?module.exports=t:"function"==typeof define&&define.amd?define('eq',[],function(){return t}):window.eqjs=t}(window.eqjs);
//# sourceMappingURL=eq.polyfilled.min.js.map
;
/**
 * @author Kevin Moot
 * @file App module definition
 */
define('App',['require','jquery','./lib/ErrorTrapper','./lib/BreakpointListener','./Bootstrap','shared-scripts/services/metricsService','./lib/Knockout-extend','transit','touch-input-nav','es6-promise','es6-polyfills','pointer','eq'],function (require) {
    

    var $ = require('jquery');

    var ErrorTrapper = require('./lib/ErrorTrapper');
    var BreakpointListener = require('./lib/BreakpointListener');
    var Bootstrap = require('./Bootstrap');
    var metricsService = require('shared-scripts/services/metricsService');
    var BrowserDetect = window.BrowserDetect;

    require('./lib/Knockout-extend');
    require('transit');  // jQuery.animate plugin to use css3 transitions when possible.
    require('touch-input-nav')();  // Function to prevent next/previous on MobileSafari from jumping between forms
    require('es6-promise').polyfill();
    require('es6-polyfills');
    require('pointer');
    require('eq');

    /**
     * Initial application setup. Runs once upon every page load.
     *
     * @class App
     * @constructor
     */
    var App = function () {
        /**
         * ErrorTrapper object responsible for capturing and logging JS errors.
         *
         * @property errorTrapper
         * @type {ErrorTrapper}
         */
        this.errorTrapper = null;

        /**
         * BrowserDetect object responsible for detecting browser features.
         *
         * @property browserDetect
         * @type {BrowserDetect}
         */
        this.browserDetect = null;

        /**
         * BreakpointListener object responsible for listening to events related to mobile/desktop breakpoints.
         *
         * @property breakpointListener
         * @type {BreakpointListener}
         */
        this.breakpointListener = null;

        /**
         * Bootstrap object responsible for attaching JS components to appropriate DOM elements.
         *
         * @property bootstrap
         * @type {Bootstrap}
         */
        this.bootstrap = null;

        // Set dimension variables for Google Analytics
        metricsService.setDimensions();

        // Send initial page view
        metricsService.virtualPageView();

        // Measure server processing
        metricsService.pageLoadTime(metricsService.END, 'Server Processing', window.dtnGlobals.serverLoadTime);

        // Measure DOM Ready timing
        metricsService.pageLoadTime(metricsService.START, 'DOM Ready', window.dtnGlobals.serverLoadTime);
        metricsService.pageLoadTime(metricsService.END, 'DOM Ready', metricsService.now());

        // Measure JavaScript Execution timing
        metricsService.pageLoadTime(metricsService.START, 'JavaScript Execution', metricsService.now());
        this.init();
        metricsService.pageLoadTime(metricsService.END, 'JavaScript Execution', metricsService.now());

        // Measure Image Loading timing
        metricsService.pageLoadTime(metricsService.START, 'DOM Loaded', metricsService.now());
        $(window).on('load', function () {
            metricsService.pageLoadTime(metricsService.END, 'DOM Loaded', metricsService.now());
        });
    };

    /**
     * Initializes the application and kicks off loading of prerequisites.
     *
     * @method init
     */
    App.prototype.init = function () {
        // Init ErrorTrapper (This should always be initialized first)
        this.errorTrapper = new ErrorTrapper(window.dtnGlobals.userId, window.dtnGlobals.userName);
        this.browserDetect = new BrowserDetect();
        this.breakpointListener = new BreakpointListener(this.browserDetect);
        this.bootstrap = new Bootstrap(this.browserDetect);

        // Initial kickoff of the attachment of JS components to appropriate DOM
        $(document.body).trigger('attachjs');
        this.bootstrap.instantiateByQueryParam();
    };

    // Sticky navigation components
    const navBar = document.querySelector(".js-sticky");
    const subNav = document.querySelector(".header-subNav");
    const navLogo = document.querySelector("#navLogo-item");

    // Sticky navigation - checks to see if window is scrolled down on scroll
    if ( null != navBar) {
        window.addEventListener('scroll', function() {
        var scrollPos = window.pageYOffset;
           // If window is scrolled down 195px, attach sticky class to navBar
           if (scrollPos >= 195) {
               navBar.classList.add("sticky");
               navLogo.style.display = "block";
               // Sub Nav exists on News and Perspectives pages
               if (subNav) {
                   subNav.classList.add("sticky-sub");
               }
           }
           else {
               navBar.classList.remove("sticky");
               navLogo.style.display = "none";
               if (subNav) {
                   subNav.classList.remove("sticky-sub");
               }
           }
        });
    }

    // Sticky navigation - checks to see if window is scrolled down on initial load
    window.addEventListener('load', function() {
        var initialScrollPos = window.pageYOffset;

        if (initialScrollPos >= 195) {
            navBar.classList.add("sticky");
            navLogo.style.display = "block";
            // Sub Nav exists on News and Perspectives pages
            if (subNav) {
                subNav.classList.add("sticky-sub");
            }
        }
    });

    return App;
});

define('lib-thirdparty/mout/queryString/setParam',[],function () {

    /**
     * Set query string parameter value
     */
    function setParam(url, paramName, value){
        url = url || '';

        var re = new RegExp('(\\?|&)'+ paramName +'=[^&]*' );
        var param = paramName +'='+ encodeURIComponent( value );

        if ( re.test(url) ) {
            return url.replace(re, '$1'+ param);
        } else {
            if (url.indexOf('?') === -1) {
                url += '?';
            }
            if (url.indexOf('=') !== -1) {
                url += '&';
            }
            return url + param;
        }

    }

    return setParam;

});

define('lib/CsrfUtil',['exports', 'lib/Util'], function (exports, _libUtil) {
  

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _Util = babelHelpers.interopRequireDefault(_libUtil);

  var token = _Util['default'].getStoredValue('tokenUUID');
  exports.token = token;
});
/* global require */
/* eslint no-extra-strict: 0 */
require([
    'external-helpers',
    'jquery',
    'App',
    'lib/Logger',
    'lib-thirdparty/mout/queryString/setParam',
    'lib/Util',
    'lib/CsrfUtil',
], function(
    babelHelpers,
    $,
    App,
    Logger,
    setParam,
    Util,
    CsrfUtil
) {
    

    // Apply a UUID unique to the session as a queryparam to all outgoing ajax requests
    // This needs to be run before an app code makes requests
    $(document).ajaxSend(setupAjaxRequestsToIncludeToken);

    // Expose the Logger as a global for importing convenience.
    window.logger = new Logger(null);
    window.logger.registerForTrappedErrors();
    window.app = new App();

    function setupAjaxRequestsToIncludeToken(event, jqXhr, settings) {
        var token = CsrfUtil.token;

        if (token != null) {
            var url = settings.url;
            url = setParam(url, 'tokenUUID', token);
            settings.url = url;
        }
    }

    $(document).ready(function() {
        $("nav#breadcrumbs")
            .find("ul:first-child")
            .prepend("<li" + " class='only'><a href='/'" + ">Home</a" + "><span class='divider'></span></li>");
    });

});

define("start", function(){});
